(function () {
    'use strict';

    angular
        .module('chamadosApp', [
            'LocalStorageModule',
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngCacheBuster',
            'ngFileUpload',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            // jhipster-needle-angularjs-add-module JHipster will add new module here
            'angular-loading-bar',
            'ncy-angular-breadcrumb',
            'yaru22.angular-timeago',
            'oitozero.ngSweetAlert',
            'chart.js',
            'angular-md5',
            'ngImgCrop',
            'ngSanitize',
            'angular-web-notification',
            'angular.filter',
            'dndLists',
            'textAngular',
            'ui.tinymce',
            'color.picker',
            'ng-showdown'
        ])
        .run(run);

    run.$inject = ['$rootScope', 'stateHandler', 'translationHandler', '$state', 'timeAgoSettings'];

    function run($rootScope, stateHandler, translationHandler, $state, timeAgoSettings) {
        stateHandler.initialize();
        translationHandler.initialize();
        $rootScope.$state = $state;
        var oneDay = 60 * 60 * 60 * 60 * 24;
        timeAgoSettings.fullDateAfterSeconds = oneDay;
        timeAgoSettings.overrideLang = 'pt_BR';

    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User($resource) {

        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'getAllInternos': {url: 'api/users-internos', method: 'GET', isArray: true},
            'getAllWithEquipe': {url: 'api/users-com-equipe', method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'},
            'reset': {method: 'GET', url:'api/users/reset-password/:login'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$http'];

    function ProfileService($http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerEnabled = result.data.activeProfiles.indexOf("swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" data-translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', 'WsNotificationService', 'localStorageService'];

    function Principal($q, Account, WsNotificationService, localStorageService) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            hasFila: hasFila,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved
        };

        return service;

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority(authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority(authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function (_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function () {
                return false;
            });
        }

        function hasFila(fila) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function (_id) {
                return _id.filas && _id.filas.indexOf(fila) !== -1;
            }, function () {
                return false;
            });
        }

        function identity(force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get().$promise
                .then(getAccountThen)
                .catch(getAccountCatch);

            return deferred.promise;

            function getAccountThen(account) {
                _identity = account.data;
                _authenticated = true;
                deferred.resolve(_identity);
                WsNotificationService.connect();
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$resource'];

    function PasswordResetInit($resource) {
        var service = $resource('api/account/reset_password/init', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .directive('hasFila', hasFila);

    hasFila.$inject = ['Principal'];

    function hasFila(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var fila = attrs.hasFila.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasFila(fila)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (fila.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                };

            /** @type {string} */
            var currentAttr = '';

            function applyVisibility() {
                element.removeClass('hidden');
                var val = angular.isUndefined(currentAttr) ? '' : currentAttr === null ? '' : String(currentAttr);
                var authoritiesList = val.replace(/\s+/g, '').split(',').filter(function (a) { return a.length > 0; });
                var result;

                if (authoritiesList.length === 0) {
                    setHidden();
                    return;
                }

                result = Principal.hasAnyAuthority(authoritiesList);
                if (result) {
                    setVisible();
                } else {
                    setHidden();
                }
            }

            attrs.$observe('hasAnyAuthority', function (interpolated) {
                currentAttr = interpolated === undefined ? '' : interpolated;
                applyVisibility();
            });

            scope.$watch(function () {
                return Principal.isAuthenticated();
            }, function () {
                applyVisibility();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('AuthServerProvider', AuthServerProvider);

    AuthServerProvider.$inject = ['$http', '$localStorage' ];

    function AuthServerProvider ($http, $localStorage ) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout
        };

        return service;

        function getToken () {
            var token = $localStorage.authenticationToken;
            return token;
        }

        function hasValidToken () {
            var token = this.getToken();
            return !!token;
        }

        function login (credentials) {
            var data = 'j_username=' + encodeURIComponent(credentials.username) +
                '&j_password=' + encodeURIComponent(credentials.password) +
                '&remember-me=' + credentials.rememberMe + '&submit=Login';

            return $http.post('api/authentication', data, {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }).success(function (response) {
                return response;
            });
        }

        function logout () {

            
            // logout from the server
            $http.post('api/logout').success(function (response) {
                delete $localStorage.authenticationToken;
                // to get a new csrf token call the api
                $http.get('api/account');
                return response;
            });
            
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish', 'WsNotificationService'];

    function Auth ($rootScope, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, Register, Activate, Password, PasswordResetInit, PasswordResetFinish, WsNotificationService) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('home');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            $state.go('login');
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    WsNotificationService.sendActivity();
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account!== null) {
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('ApiTokens', ApiTokens);

    ApiTokens.$inject = ['$resource'];

    function ApiTokens ($resource) {
        return $resource('api/account/api-tokens/:id', {}, {
            'getAll': { method: 'GET', isArray: true },
            'create': { method: 'POST' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('Account', Account);

    Account.$inject = ['$resource'];

    function Account($resource) {

        var service = $resource('api/account', {}, {
            'get': {
                method: 'GET', params: {}, isArray: false,
                interceptor: {
                    response: function (response) {
                        // expose response
                        return response;
                    }
                }
            },
            'getImagem': {
                method: 'GET',
                url: 'api/imagem-usuario',
            },
            'getRedmine': {
                method: 'GET',
                url: 'api/account-redmine',
            },
            'getImagemAjustada': {
                method: 'GET',
                url: 'api/imagem-ajustada-usuario',
            },
            'getImagemAjustadaByLogin': {
                method: 'GET',
                url: 'api/imagem-ajustada-usuario/:login',
            },
            'saveImagem': {
                method: 'POST',
                url: 'api/imagem-usuario',
            },
            'saveRedmine': {
                method: 'POST',
                url: 'api/account-redmine',
            },
            'saveGit': {
                method: 'POST',
                url: 'api/account-git',
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('ReleaseDetailController', ReleaseDetailController);

    ReleaseDetailController.$inject = ['$scope', '$rootScope', 'Alerta', 'previousState', 'entity', 'Release', 'Chamado', '$state', '$filter'];

    function ReleaseDetailController($scope, $rootScope, Alerta, previousState, entity, Release, Chamado, $state, $filter) {
        var vm = this;

        vm.release = entity;
        vm.previousState = previousState.name;
        vm.salvar = salvar;
        vm.remover = remover;
        vm.alocar = alocar;
        vm.desalocar = desalocar;
        vm.encerrarRelease = encerrarRelease;
        vm.iniciarRelease = iniciarRelease;
        vm.sincronizartGit = sincronizartGit;
        vm.copyToClipboard = copyToClipboard;
        vm.atualizarNotas = atualizarNotas;

        var unsubscribe = $rootScope.$on('chamadosApp:releaseUpdate', function (event, result) {
            vm.release = result;
        });
        $scope.$on('$destroy', unsubscribe);

        function sincronizartGit() {
            Release.sincronizartGit({id: vm.release.id}, loadChamados);
        }

        function copyToClipboard(copyText) {
            navigator.clipboard.writeText(copyText);
        }

        function loadChamados() {
            vm.chamado = {release: vm.release};
            Chamado.getChamadosByRelease({releaseId: vm.chamado.release.id}, function (data) {
                vm.chamados = data;
                vm.release.detalhesRelease = [];
                vm.release.detalhesRelease.push({
                    quantidade: vm.chamados.length,
                    texto: "Chamados",
                    cor: "navy-bg",
                    icon: 'fa-cloud'
                });

                var chamadoTipo = {};
                vm.projetosGit = {};
                angular.forEach(vm.chamados, function (chamado) {
                    Chamado.getSolicitacoes({id: chamado.id}, function (solicitacoes) {
                        chamado.solicitacoes = solicitacoes;
                        for (var i = 0; i < chamado.solicitacoes.length; i++) {
                            var tarefa = chamado.solicitacoes[i];
                            for (var j = 0; j < tarefa.projetosGit.length; j++) {
                                var projetoGit = tarefa.projetosGit[j];
                                if (!vm.projetosGit[projetoGit.repositorioGit]) {
                                    vm.projetosGit[projetoGit.repositorioGit] = projetoGit;
                                }
                            }

                        }
                    });
                });

                angular.forEach(vm.chamados, function (chamado) {
                    if (!chamadoTipo[chamado.tipoChamado]) {
                        chamadoTipo[chamado.tipoChamado] = [];
                    }
                    chamadoTipo[chamado.tipoChamado].push(chamado);
                });

                angular.forEach(chamadoTipo, function (chamados, tipo) {
                    vm.release.detalhesRelease.push({
                        quantidade: chamados.length,
                        texto: $filter('translate')('chamadosApp.TipoChamado.' + tipo),
                        cor: tipo === 'BUG' ? 'red-bg' : tipo === 'MELHORIA' ? 'yellow-bg' : tipo === 'NOVA_FUNCIONALIDADE' ? 'blue-bg' : 'navy-bg',
                        icon: tipo === 'BUG' ? 'fa-bug' : tipo === 'MELHORIA' ? 'fa-cogs' : tipo === 'NOVA_FUNCIONALIDADE' ? 'fa-cloud-upload' : 'fa-cloud'
                    });
                });


            });
        }

        function atualizarNotas() {
            var modulos = [];
            var chamadoModulo = {};
            for (var i = 0; i < vm.chamados.length; i++) {
                var chamado = vm.chamados[i];

                if (!chamadoModulo[chamado.modulo.id]) {
                    chamadoModulo[chamado.modulo.id] = [];
                    modulos.push(chamado.modulo);
                }
                chamadoModulo[chamado.modulo.id].push(chamado);

            }

            vm.release.notas = "";
            for (var i = 0; i < modulos.length; i++) {
                var modulo = modulos[i];
                vm.release.notas += "&nbsp; " + modulo.descricao + " <br>";
                var sorted = chamadoModulo[modulo.id];
                for (var j = 0; j < sorted.length; j++) {
                    var chamado = sorted[j];
                    vm.release.notas += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; " + chamado.subModulo.descricao + " <small><i>(" + $filter('translate')('chamadosApp.TipoChamado.' + chamado.tipoChamado) + ")</i></small>: "
                        + "#" + chamado.id + "&nbsp;-&nbsp;"
                        + (chamado.releaseNotes ? chamado.releaseNotes : chamado.titulo) + "<br>";

                }
                vm.release.notas += "<br>";
            }
        }


        loadChamados();

        function confirmEncerrar() {
            Release.encerrar(vm.release, function (data) {
                Alerta.success("Operação realizada", "A Release foi encerrada!");
                $state.go('release');
            }, function error(error) {
                Alerta.error("Operação Não realizada", "Tente novamente!");
            });
        }

        function confirmIniciar() {
            Release.iniciar(vm.release, function (data) {
                Alerta.success("Operação realizada", "A Release foi iniciada!");
                $state.reload(true);
            });
        }

        function cancel() {
            //Alerta.success("Operação NÃO Realizada", "")
        }


        function encerrarRelease() {
            Alerta.confirm("Atenção!",
                "Você tem certeza que deseja encerrar a Release " + vm.release.versao + "?",
                "warning",
                confirmEncerrar, cancel);
        }


        function iniciarRelease() {
            Alerta.confirm("Atenção!",
                "Você tem certeza que deseja iniciar a Release " + vm.release.versao + "?",
                "warning",
                confirmIniciar, cancel);
        }

        function salvar() {
            Release.update(vm.release, function (data) {
                Alerta.success("Operação realizada", "A Release foi Salva!");
                $state.go('release');
            }, function error(error) {
                Alerta.error("Operação Não realizada", "Tente novamente!");
            });
        }

        function remover() {
            Release.delete({id: vm.release.id}, function (data) {
                Alerta.success("Operação realizada", "A Release foi removida!");
                $state.go('release');
            }, function error(error) {
                Alerta.error("Operação Não realizada", "Tente novamente!");
            });
        }

        function desalocar(remover) {

            Chamado.get({id: remover.id}, function (chamado) {
                chamado.release = null;
                Chamado.update(chamado, function (removido) {
                    Alerta.success("Operação realizada", "O chamado " + removido.id + " foi removido");
                    $state.reload(true);
                });
            });
        }

        function alocar(id) {
            Chamado.get({id: id}, function (chamado) {
                chamado.release = vm.release;
                Chamado.update(chamado, function (adicionado) {
                    Alerta.success("Operação realizada", "O chamado " + adicionado.id + " foi adicionado");
                    $state.reload(true);
                });
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('release', {
            parent: 'app',
            url: '/release?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
            },
            ncyBreadcrumb: {
                label: 'Release'
            },
            views: {
                'content@': {
                    templateUrl: 'app/release/release.html',
                    controller: 'ReleaseController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('situacaoRelease');
                    $translatePartialLoader.addPart('tipoRelease');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
            .state('release-detail', {
                parent: 'release',
                url: '/release?{sistemaId}&{versao}&{id}',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'chamadosApp.release.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/release/release-detail.html',
                        controller: 'ReleaseDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('chamado');
                        $translatePartialLoader.addPart('situacaoChamado');
                        $translatePartialLoader.addPart('situacaoRelease');
                        $translatePartialLoader.addPart('tipoRelease');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'Release', function ($stateParams, Release) {
                        if ($stateParams.id) {
                            return Release.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                        return Release.getByVersao({
                            versao: $stateParams.versao,
                            sistema: {id: $stateParams.sistemaId}
                        }).$promise;
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'release',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
    }
})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('Release', Release);

    Release.$inject = ['$resource', 'DateUtils'];

    function Release($resource, DateUtils) {
        var resourceUrl = 'api/releases/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'sincronizartGit': {url: '/api/sincronizar-git-releases/:id', method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.solicitacao = DateUtils.convertLocalDateFromServer(data.solicitacao);
                        data.liberacao = DateUtils.convertLocalDateFromServer(data.liberacao);
                    }
                    return data;
                }
            },
            'getByVersao': {
                url: '/api/release-by-version/:versao',
                method: 'POST',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.solicitacao = DateUtils.convertLocalDateFromServer(data.solicitacao);
                        data.liberacao = DateUtils.convertLocalDateFromServer(data.liberacao);
                    }
                    return data;
                }
            },
            'getBySituacao': {
                url: '/api/release-by-situacao',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.solicitacao = DateUtils.convertLocalDateFromServer(data.solicitacao);
                        data.liberacao = DateUtils.convertLocalDateFromServer(data.liberacao);
                    }
                    return data;
                }
            },
            'new': {
                url: '/api/releases/new',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.solicitacao = DateUtils.convertLocalDateFromServer(data.solicitacao);
                        data.liberacao = DateUtils.convertLocalDateFromServer(data.liberacao);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.solicitacao = DateUtils.convertLocalDateToServer(copy.solicitacao);
                    copy.liberacao = DateUtils.convertLocalDateToServer(copy.liberacao);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.solicitacao = DateUtils.convertLocalDateToServer(copy.solicitacao);
                    copy.liberacao = DateUtils.convertLocalDateToServer(copy.liberacao);
                    return angular.toJson(copy);
                }
            },
            'encerrar': {
                method: 'PUT',
                url: '/api/releases/encerramento',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.solicitacao = DateUtils.convertLocalDateToServer(copy.solicitacao);
                    copy.liberacao = DateUtils.convertLocalDateToServer(copy.liberacao);
                    return angular.toJson(copy);
                }
            },

            'iniciar': {
                method: 'PUT',
                url: '/api/releases/iniciar',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.solicitacao = DateUtils.convertLocalDateToServer(copy.solicitacao);
                    copy.liberacao = DateUtils.convertLocalDateToServer(copy.liberacao);
                    return angular.toJson(copy);
                }
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('ReleaseController', ReleaseController);

    ReleaseController.$inject = ['AlertService', 'pagingParams', 'ParseLinks', 'paginationConstants', '$state',
        '$filter', 'Chamado', 'Release', 'SweetAlert', 'Sistema', 'Agrupador'];

    function ReleaseController(AlertService, pagingParams, ParseLinks, paginationConstants, $state,
                               $filter, Chamado, Release, SweetAlert, Sistema, Agrupador) {
        var vm = this;
        vm.predicate = pagingParams.predicate;
        vm.reverse = true;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        vm.alocar = alocar;
        vm.alocarTodos = alocarTodos;

        vm.desalocar = desalocar;
        vm.desalocarTodos = desalocarTodos;
        vm.carregarSistema = carregarSistema;
        vm.selecionarSistema = selecionarSistema;
        vm.solicitar = solicitar;
        vm.release = {};


        function agruparChamados() {
            vm.chamadosPorSistema = {};
            Chamado.queryValidadosSemRelease({}, function (chamados) {
                for (var i = 0; i < vm.sistemas.length; i++) {
                    var sistema = vm.sistemas[i];
                    sistema.bugs = 0;
                    sistema.melhorias = 0;
                    sistema.funcionalidades = 0;
                    sistema.suporte = 0;
                    vm.chamadosPorSistema[sistema.id] = {sistema: sistema, chamados: []};
                    for (var j = 0; j < chamados.length; j++) {
                        var chamado = chamados[j];
                        if (chamado.sistema.id == sistema.id) {
                            if (!vm.chamadosPorSistema[chamado.sistema.id]) {
                                vm.chamadosPorSistema[chamado.sistema.id] = {sistema: chamado.sistema, chamados: []};
                            }
                            switch (chamado.tipoChamado) {
                                case 'BUG':
                                    sistema.bugs++;
                                    break;
                                case 'MELHORIA':
                                    sistema.melhorias++;
                                    break;
                                case 'NOVA_FUNCIONALIDADE':
                                    sistema.funcionalidades++;
                                    break;
                                case 'SUPORTE':
                                    sistema.suporte++;
                                    break;
                            }
                            vm.chamadosPorSistema[chamado.sistema.id].chamados.push(chamado);
                        }
                    }
                }

                selecionarSistema(vm.sistemas[0]);
            });
        }

        function alocarTodos() {
            selecionarSistema(vm.sistema);
        }

        function alocar(chamado) {
            if(chamado.numeroAgrupadores >0){
                    SweetAlert.swal({
                        title: "Chamado agrupado!",
                        text: "todos os chamados do agrupador <b>"+chamado.agrupadores[0].nome+"</b> devem ser validados para adiciona-los em uma release",
                        type: "error",
                        html: true
                    });
            }
            if (chamado.numeroAgrupadores ===0 && vm.release.chamados.indexOf(chamado) < 0) {
                vm.release.chamados.push(chamado);
            }
        }

        function desalocar(remover) {
            var index = -1;
            angular.forEach(vm.release.chamados, function (chamado, ind) {
                if (chamado.id === remover.id) {
                    index = ind;
                }
            });

            if (index >= 0) {
                vm.release.chamados.splice(index, 1);
            }
        }

        function desalocarTodos() {
            vm.release.chamados = [];
        }

        loadAll();

        function selecionarSistema(sistema) {
            vm.sistema = sistema;

            vm.release = {detalhesRelease: [], chamados: [], sistema: sistema};
            vm.release.detalhesRelease.push({
                quantidade: vm.chamadosPorSistema[sistema.id].chamados.length,
                texto: "Chamados"
            });
            var chamadoTipo = {};
            angular.forEach(vm.chamadosPorSistema[sistema.id].chamados, function (chamado) {
                chamado.numeroAgrupadores = 0
                Agrupador.getBychamado({id: chamado.id}, function (agrupadores) {
                    chamado.agrupadores = agrupadores;
                    chamado.numeroAgrupadores = agrupadores.length;
                    if (!chamadoTipo[chamado.tipoChamado]) {
                        chamadoTipo[chamado.tipoChamado] = [];
                    }
                    chamadoTipo[chamado.tipoChamado].push(chamado);
                    if (chamado.agrupadores.length ===0) {
                        vm.release.chamados.push(chamado);
                    }
                });
            });

            angular.forEach(chamadoTipo, function (chamados, tipo) {
                vm.release.detalhesRelease.push({
                    quantidade: chamados.length,
                    texto: $filter('translate')('chamadosApp.TipoChamado.' + tipo)
                });
            });

        }


        function carregarSistema() {
            Sistema.getByUser({}, function (data) {
                vm.sistemas = data;

                agruparChamados();
            })
        }

        function loadAll() {
            carregarSistema();
            carregarReleases();
        }

        function carregarReleases() {
            Release.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + ('desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.releases = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }


        function solicitar() {

            SweetAlert.swal({
                    title: "Atenção",
                    text: "Tem certeza que deseja solicitar uma nova release? Chamados com agrupadores não finalizados serao removidos da release",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        vm.solicitados = [];
                        vm.release.situacao = 'ABERTO';
                        var modulos = [];
                        var chamadoModulo = {};
                        for (var i = 0; i < vm.release.chamados.length; i++) {
                            var chamado = vm.release.chamados[i];
                            if (chamado.agrupadores.length == 0) {
                                if (!chamadoModulo[chamado.modulo.id]) {
                                    chamadoModulo[chamado.modulo.id] = [];
                                    modulos.push(chamado.modulo);
                                }
                                chamadoModulo[chamado.modulo.id].push(chamado);
                            }
                        }

                        vm.release.notas = "";
                        for (var i = 0; i < modulos.length; i++) {
                            var modulo = modulos[i];
                            vm.release.notas += "&nbsp; " + modulo.descricao + " <br>";
                            var sorted = chamadoModulo[modulo.id];
                            for (var j = 0; j < sorted.length; j++) {
                                var chamado = sorted[j];
                                vm.release.notas += "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; " + chamado.subModulo.descricao + " <small><i>(" + $filter('translate')('chamadosApp.TipoChamado.' + chamado.tipoChamado) + ")</i></small>: "
                                    + "#" + chamado.id + "&nbsp;-&nbsp;"
                                    + (chamado.releaseNotes ? chamado.releaseNotes : chamado.titulo) + "<br>";

                            }
                            vm.release.notas += "<br>";
                        }

                        Release.save(vm.release, function (data) {
                            vm.release.totalChamados = 0;
                            for (var i = 0; i < vm.release.chamados.length; i++) {
                                var chamado = vm.release.chamados[i];
                                if (chamado.agrupadores.length == 0) {
                                    vm.release.totalChamados++;
                                    chamado.release = data;
                                    Chamado.update(chamado, function (chamado) {
                                        aposSolicitar(vm.release, chamado);
                                    });
                                }
                            }
                        }, function (error) {
                            setTimeout(function () {
                                SweetAlert.swal({
                                    title: "Atenção",
                                    text: error.data.message,
                                    type: "error",
                                    html: true
                                });
                            }, 1000);
                        });
                    }
                });
        }

        function aposSolicitar(release, chamado) {
            vm.solicitados.push(chamado);
            if (release.totalChamados === vm.solicitados.length) {
                $state.reload(true);
            }
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }

})();



(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('movimentacao-demandas', {
            parent: 'app',
            url: '/movimentacao-demandas',
            data: {
                authorities: ['ROLE_USER'],
            },
            ncyBreadcrumb: {
                label: 'Relatório das movimentações das demandas'
            },
            views: {
                'content@': {
                    templateUrl: 'app/relatorios/movimentacao-demandas/movimentacao-demandas.html',
                    controller: 'MovimentacaoDemandasController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('chamado');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    return $translate.refresh();
                }]
            }
        }).state('acumulo-demandas', {
            parent: 'app',
            url: '/acumulo-demandas',
            data: {
                authorities: ['ROLE_USER'],
            },
            ncyBreadcrumb: {
                label: 'Relatório das movimentações das demandas'
            },
            views: {
                'content@': {
                    templateUrl: 'app/relatorios/movimentacao-demandas/acumulo-demandas.html',
                    controller: 'AcumuloDemandasController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('chamado');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('MovimentacaoDemandas', MovimentacaoDemandas);

    MovimentacaoDemandas.$inject = ['$resource'];

    function MovimentacaoDemandas($resource) {
        var resourceUrl = 'api/movimentacao-demandas';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'POST',
                isArray: true
            },
            'situacaoPorPeriodo': {
                url : 'api/situacao-chamado-por-periodo',
                method: 'GET',
                isArray: true
            }

        });
    }


})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('MovimentacaoDemandasController', MovimentacaoDemandasController);

    MovimentacaoDemandasController.$inject = ['MovimentacaoDemandas', '$filter'];

    function MovimentacaoDemandasController(MovimentacaoDemandas, $filter) {
        var vm = this;
        var curr = new Date;
        vm.fim = new Date(curr);
        vm.inicio = new Date(curr.setDate(curr.getDate() - 7));

        vm.datePickerOpenStatus = {};
        vm.chamados = []
        vm.agruparPorCampo = agruparPorCampo;
        vm.load = load;
        vm.openCalendar = openCalendar;

        vm.orderBy = 'id';

        vm.chamadosPorCliente = {};

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function load() {
            MovimentacaoDemandas.situacaoPorPeriodo({inicio: vm.inicio, fim: vm.fim}, function (data) {
                vm.chamados = data;
                agruparPorCliente();
            });
        }

        function agruparPorCliente() {
            for (var i = 0; i < vm.chamados.length; i++) {
                var chamado = vm.chamados[i];
                if (!vm.chamadosPorCliente[chamado.clienteId]) {
                    vm.chamadosPorCliente[chamado.clienteId] = {
                        cliente: {id: chamado.clienteId, nome: chamado.cliente},
                        chamados: []
                    }
                }
                vm.chamadosPorCliente[chamado.clienteId].chamados.push(chamado);
            }
            if (vm.chamados.length > 0) {
                vm.clienteSelecionado = vm.chamadosPorCliente[vm.chamados[0].clienteId];
            }
            agruparPorModulo();
            angular.forEach(vm.chamadosPorCliente, function (cliente) {
                agruparPorCampo(cliente, 'situacao');
            });
        }

        function agruparPorModulo() {
            angular.forEach(vm.chamadosPorCliente, function (cliente) {
                cliente.modulos = {};
                for (var x = 0; x < cliente.chamados.length; x++) {
                    var chamado = cliente.chamados[x];
                    if (!cliente.modulos[chamado.moduloId]) {
                        cliente.modulos[chamado.moduloId] = {
                            modulo: {id: chamado.moduloId, nome: chamado.modulo},
                            chamados: []
                        }
                    }
                    cliente.modulos[chamado.moduloId].chamados.push(chamado);
                }
                angular.forEach(cliente.modulos, function (modulo) {
                    agruparPorCampo(modulo, 'situacao');
                });
            });
        }

        function agruparPorCampo(modulo, campo) {
            modulo.agrupamento = {};
            for (var x = 0; x < modulo.chamados.length; x++) {
                var chamado = modulo.chamados[x];
                if (!modulo.agrupamento[chamado[campo]]) {
                    modulo.agrupamento[chamado[campo]] = {
                        campo: chamado[campo],
                        chamados: []
                    }
                }
                modulo.agrupamento[chamado[campo]].chamados.push(chamado);
            }
            montarGraficoPizza(modulo);
        }

        function montarGraficoPizza(modulo) {
            if (modulo.chamados) {
                modulo.pie = {labels: [], data: []};
                modulo.pie.options = {responsive: true, legend: {display: true, position: 'bottom'}};

                angular.forEach(modulo.agrupamento, function (campo) {
                    modulo.pie.labels.push(campo.campo);
                    modulo.pie.data.push(campo.chamados.length);
                });
            }
        }

        load();
    }

})();



(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('AcumuloDemandasController', AcumuloDemandasController);

    AcumuloDemandasController.$inject = ['MovimentacaoDemandas', 'DateUtils', 'Modulo', 'SubModulo', 'Sprint', '$filter', 'Cliente'];

    function AcumuloDemandasController(MovimentacaoDemandas, DateUtils, Modulo, SubModulo, Sprint, $filter, Cliente) {
        var vm = this;

        vm.chamado = {id: null, modulo: null, tipoChamado: null, titulo: null};
        vm.modulos = Modulo.query({page: 0, size: 99});
        vm.subModulos = SubModulo.query({page: 0, size: 99});
        vm.sprints = Sprint.query({page: 0, size: 99});
        vm.diasSemMovimentar = 10;
        vm.orderBy = '-diasAtraso';
        vm.colors = ['#46BFBD', '#F7464A', '#FDB45C', '#97BBCD'];

        vm.loadAll = loadAll;


        load();

        function load() {
            Cliente.getByUser({}, function (data) {
                vm.clientes = data;
                vm.chamado.cliente = data[0];
                loadAll();
            });
        }

        function loadAll() {
            vm.hoje = new Date();

            vm.diasAtraso = 0;
            vm.atrasoPorModulo = {};


            MovimentacaoDemandas.query(vm.chamado, function (data) {
                if (vm.diasSemMovimentar) {
                    vm.chamados = [];
                    angular.forEach(data, function (chamado) {
                        if (chamado.diasAtraso > vm.diasSemMovimentar) {
                            vm.chamados.push(chamado);
                        }
                    });
                } else {
                    vm.chamados = data;
                }
                angular.forEach(vm.chamados, function (chamado) {
                    if (!vm.atrasoPorModulo [chamado.modulo]) {
                        vm.atrasoPorModulo [chamado.modulo] = {modulo: chamado.modulo, chamados: []};
                    }
                    vm.atrasoPorModulo [chamado.modulo].chamados.push(chamado);

                    chamado.inicio = DateUtils.convertDateTimeFromServer(chamado.inicio);
                    chamado.fim = DateUtils.convertDateTimeFromServer(chamado.fim);
                    chamado.entrega = DateUtils.convertDateTimeFromServer(chamado.entrega);

                    if (chamado.diasAtraso > 0) {
                        chamado.cor = "success";
                    }
                    if (chamado.diasAtraso > 5) {
                        chamado.cor = "info";
                    }
                    if (chamado.diasAtraso > 10) {
                        chamado.cor = "warning";
                    }
                    if (chamado.diasAtraso > 20) {
                        chamado.cor = "danger";
                    }

                    if (chamado.diasAtraso) {
                        vm.diasAtraso = vm.diasAtraso + chamado.diasAtraso;
                    }
                });
                vm.diasAtraso = vm.diasAtraso / vm.chamados.length;

                vm.modulosAtrasados = [];

                angular.forEach(vm.atrasoPorModulo, function (modulo) {
                    modulo.diasAtraso = 0;
                    angular.forEach(modulo.chamados, function (chamado) {
                        if (chamado.diasAtraso) {
                            modulo.diasAtraso = modulo.diasAtraso + chamado.diasAtraso;
                        }
                    });
                    modulo.diasAtraso = modulo.diasAtraso / modulo.chamados.length;
                    vm.modulosAtrasados.push(modulo);

                    modulo.atrasoPorSituacao = {};
                });

            });
        }
    }

})();



(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('chamados-rejeitados', {
            parent: 'app',
            url: '/chamados-rejeitados',
            data: {
                authorities: ['ROLE_PO'],
            },
            ncyBreadcrumb: {
                label: 'Relatório de chamados rejeitados'
            },
            views: {
                'content@': {
                    templateUrl: 'app/relatorios/chamados-rejeitados/chamados-rejeitados.html',
                    controller: 'ChamadosRejeitadosController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('chamado');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    $translatePartialLoader.addPart('severidade');
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('ChamadosRejeitados', ChamadosRejeitados);

    ChamadosRejeitados.$inject = ['$resource'];

    function ChamadosRejeitados($resource) {
        var resourceUrl = 'api/chamados-rejeitados';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'POST',
                isArray: true
            }

        });
    }


})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('ChamadosRejeitadosController', ChamadosRejeitadosController);

    ChamadosRejeitadosController.$inject = ['$sanitize', 'ChamadosRejeitados', 'DateUtils', '$uibModal', 'Account', 'Modulo', 'SubModulo', 'Sprint', 'Release', '$filter', 'Cliente'];

    function ChamadosRejeitadosController($sanitize, ChamadosRejeitados, DateUtils, $uibModal, Account, Modulo, SubModulo, Sprint, Release, $filter, Cliente) {
        var vm = this;

        vm.chamado = {id: null, modulo: null, tipoChamado: null, titulo: null, criadoEmInicio: null, criadoEmFim: null, sprints:[]};
        vm.modulos = Modulo.query({page: 0, size: 99});
        vm.subModulos = SubModulo.query({page: 0, size: 99});
        vm.sprints = Sprint.query({page: 0, size: 99});
        vm.releases = Release.query({page: 0, size: 99});
        vm.colors = ['#46BFBD', '#F7464A', '#FDB45C', '#97BBCD'];
        vm.visualizar = visualizar;
        vm.imprimir = imprimir;
        vm.loadAll = loadAll;
        vm.limpar = limpar;

        load();

        function load() {
            Cliente.getByUser({}, function (data) {
                vm.clientes = data;
                vm.chamado.cliente = data[0];
            });
        }

        function limpar() {
            vm.chamado = {
                id: null,
                modulo: null,
                tipoChamado: null,
                titulo: null,
                criadoEmInicio: null,
                criadoEmFim: null
            };
            limparVariaveis();
        }

        function limparVariaveis() {
            vm.totalChamados = 0;
            vm.totalRejeicoes = 0;
            vm.totalMelhorias = 0;
            vm.labels = [];
            vm.data = [];
            vm.percentual = [];
            vm.chamados = [];
            vm.modulosAtrasados = [];
        }

        function loadAll() {
            limparVariaveis();
            var rejeicaoPorModulo = {};

            vm.labels.push('Rejeições');
            vm.labels.push('Melhorias');

            ChamadosRejeitados.query(vm.chamado, function (data) {
                vm.totalChamados = data.length;
                angular.forEach(data, function (chamado) {

                    if (chamado.rejeitado) {
                        vm.chamados.push(chamado);
                        vm.totalRejeicoes = vm.totalRejeicoes + chamado.quantidadeRejeicao;
                        vm.totalMelhorias = vm.totalMelhorias + chamado.quantidadeMelhorias;

                        angular.forEach(chamado.comentariosRejeicao, function (comentario) {
                            Account.getImagemAjustadaByLogin({login: comentario.usuario.login}, function (data) {
                                comentario.imagemUsuario = data.imagemAjustada;
                            });
                        });

                        if (!rejeicaoPorModulo[chamado.chamado.modulo.descricao]) {
                            rejeicaoPorModulo[chamado.chamado.modulo.descricao] = [];
                        }
                        rejeicaoPorModulo[chamado.chamado.modulo.descricao].push(chamado);

                        vm.modulosAtrasados = [];

                        angular.forEach(rejeicaoPorModulo, function (value, key) {
                            var modulo = {modulo: key, quantidade: 0};
                            angular.forEach(value, function (chamado) {
                                modulo.quantidade += (chamado.quantidadeRejeicao + chamado.quantidadeMelhorias);
                            });
                            vm.modulosAtrasados.push(modulo);
                        });
                    }
                });

                vm.data.push(vm.totalRejeicoes);
                vm.data.push(vm.totalMelhorias);

                for (var i = 0; i < vm.data.length; i++) {
                    var valor = vm.data[i];
                    vm.percentual[i] = (valor * 100) / (vm.totalRejeicoes + vm.totalMelhorias);
                }
            });
        }


        function visualizar(chamado) {
            var modalInstance = $uibModal.open({
                size: 'lg',
                animation: true,
                templateUrl: 'visualizarRejeicao.html',
                controller: 'VisualizarRejeicaoController',
                controllerAs: 'vm',
                windowClass: 'modal-grande',
                resolve: {
                    chamado: chamado
                }
            });
            modalInstance.result.then(function (chamado) {
                /*ao fecherar o dialog*/
            });
        }

        function imprimir() {

            var docDefinition = {
                pageSize: 'A4',

                // by default we use portrait, you can change it to landscape if you wish
                pageOrientation: 'landscape',

                // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
                pageMargins: [40, 60, 40, 60],

                content: [
                    {text: 'Webpublico - Helpdesk', style: 'header', alignment: 'center'},
                    {text: 'Relatório de Rejeição', style: 'subheader'},
                    table(getChamadosParaImpressao(), ['Chamado', 'Tipo', 'Título', 'Tempo Est.', 'Módulo', 'Situação', 'Rejeição', 'Melhoria']),
                    {text: 'Total de rejeitados:'+ vm.totalRejeicoes, style: 'subheader'},
                    {text: 'Total de melhorias:'+ vm.totalMelhorias, style: 'subheader'},
                    {text: 'Total de chamados:'+ vm.totalChamados, style: 'subheader'},
                ],
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    subheader: {
                        fontSize: 16,
                        bold: true,
                        margin: [0, 10, 0, 5]
                    },
                    tableExample: {
                        margin: [0, 5, 0, 15]
                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 13,
                        color: 'black'
                    }
                }
            };

            // download the PDF
            pdfMake.createPdf(docDefinition).download('Chamados Rejeitados.pdf');
        }

        function buildTableBody(data, columns) {
            var body = [];

            body.push(columns);

            data.forEach(function (row) {
                var dataRow = [];

                columns.forEach(function (column) {
                    if (row[column]) {
                        dataRow.push(row[column].toString());
                    } else {
                        dataRow.push(" ");
                    }
                });

                body.push(dataRow);
            });

            return body;
        }


        function getChamadosParaImpressao() {
            /*table(getChamadosParaImpressao(), ['Chamado', 'Tipo', 'Título', 'Tempo Est.', 'Módulo', 'Situação', 'Rejeição', 'Melhoria'])*/
            var chamados = [];
            angular.forEach(vm.chamados, function (chamado) {
                chamados.push(
                    {
                        'Chamado': chamado.chamado.id,
                        'Tipo': $filter('translate')('chamadosApp.TipoChamado.' + chamado.chamado.tipoChamado),
                        'Título': chamado.chamado.titulo,
                        'Tempo Est.': chamado.chamado.tempoEstimado,
                        'Módulo': chamado.chamado.modulo.descricao,
                        'Situação': $filter('translate')('chamadosApp.SituacaoChamado.' + chamado.chamado.situacao),
                        'Rejeição': chamado.quantidadeRejeicao,
                        'Melhoria': chamado.quantidadeMelhorias
                    }
                )
            });
            return chamados;
        }

        function table(data, columns) {
            return {
                table: {
                    margin: [5, 10, 5, 10],
                    style: 'tableExample',
                    headerRows: 1,
                    body: buildTableBody(data, columns)
                },
                layout: 'lightHorizontalLines'
            };
        }
    }

    angular
        .module('chamadosApp')
        .controller('VisualizarRejeicaoController', VisualizarRejeicaoController);

    VisualizarRejeicaoController.$inject = ['$sanitize', '$uibModalInstance', 'chamado'];

    function VisualizarRejeicaoController($sanitize, $uibModalInstance, chamado) {
        var vm = this;
        vm.trustAsHtml = trustAsHtml;
        vm.chamado = chamado;

        function trustAsHtml(value) {
            return $sanitize(value);
        };

        vm.ok = function () {
            $uibModalInstance.close(vm.chamado);
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    };

})();



(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('chamados-por-volumetria', {
            parent: 'app',
            url: '/chamados-por-volumetria',
            data: {
                authorities: ['ROLE_USER'],
            },
            ncyBreadcrumb: {
                label: 'Relatório de chamados por Volumetria'
            },
            views: {
                'content@': {
                    templateUrl: 'app/relatorios/chamados-por-volumetria/chamados-por-volumetria.html',
                    controller: 'ChamadosPorVolumetriaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('chamado');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    $translatePartialLoader.addPart('severidade');
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('ChamadosPorVolumetria', ChamadosPorVolumetria);

    ChamadosPorVolumetria.$inject = ['$resource'];

    function ChamadosPorVolumetria($resource) {
        var resourceUrl = 'api/chamados-por-volumetria';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'POST',
                isArray: false
            }

        });
    }


})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('ChamadosPorVolumetriaController', ChamadosPorVolumetriaController);

    ChamadosPorVolumetriaController.$inject = ['ChamadosPorVolumetria', 'DateUtils', 'Modulo', 'SubModulo', 'Sprint', 'Release', '$filter', 'Cliente'];

    function ChamadosPorVolumetriaController(ChamadosPorVolumetria, DateUtils, Modulo, SubModulo, Sprint, Release, $filter, Cliente) {
        var vm = this;

        vm.chamado = {id: null, modulo: null, tipoChamado: null, titulo: null, criadoEmInicio: null, criadoEmFim: null, sprints:[]};
        vm.modulos = Modulo.query({page: 0, size: 99});
        vm.subModulos = SubModulo.query({page: 0, size: 99});
        vm.sprints = Sprint.query({page: 0, size: 99});
        vm.releases = Release.query({page: 0, size: 99});
        vm.diasSemMovimentar = 1;


        vm.colors = ['#46BFBD', '#F7464A', '#FDB45C', '#97BBCD'];

        vm.loadAll = loadAll;

        load();

        function load() {
            Cliente.getByUser({}, function (data) {
                vm.clientes = data;
                vm.chamado.cliente = data[0];
            });
        }

        function loadAll() {
            ChamadosPorVolumetria.query(vm.chamado, function (data) {
                vm.total = data.total;
                vm.quantidadeAberto = data.quantidadeAberto;
                vm.quantidadeImpedido = data.quantidadeImpedido;
                vm.quantidadeEncerrado = data.quantidadeEncerrado;
                vm.quantidadeRejeitado = data.quantidadeRejeitado;
                vm.quantidadeAbertoVencidos = data.quantidadeAbertoVencidos;
                vm.quantidadeAguardandoValidacao = data.quantidadeAguardandoValidacao;
                vm.quantidadeAguardandoDesenvolvimento = data.quantidadeAguardandoDesenvolvimento;
                vm.quantidadeAbertoSprint = data.quantidadeAbertoSprint;
                vm.quantidadeTeste = data.quantidadeTeste;
                vm.produtividade = data.produtividade;
                vm.esforcoEmpregado = data.esforcoEmpregado;
                vm.tempoMedio = data.tempoMedio;
                vm.atendimentoSegundoNivel = data.atendimentoSegundoNivel;
                vm.atendimentoDesenvolvimento = data.atendimentoDesenvolvimento;
                vm.severidades = data.severidades;
            });
        }

    }

})();



(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('chamados-por-sprint', {
            parent: 'app',
            url: '/chamados-por-sprint',
            data: {
                authorities: ['ROLE_USER'],
            },
            ncyBreadcrumb: {
                label: 'Relatório das movimentações das demandas'
            },
            views: {
                'content@': {
                    templateUrl: 'app/relatorios/chamados-por-sprint/chamados-por-sprint.html',
                    controller: 'ChamadosPorSprintController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('chamado');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    $translatePartialLoader.addPart('severidade');
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('ChamadosPorSprint', ChamadosPorSprint);

    ChamadosPorSprint.$inject = ['$resource'];

    function ChamadosPorSprint($resource) {
        var resourceUrl = 'api/chamados-por-sprint';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'POST',
                isArray: true
            }

        });
    }


})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('ChamadosPorSprintController', ChamadosPorSprintController);

    ChamadosPorSprintController.$inject = ['ChamadosPorSprint', 'DateUtils', 'Modulo', 'SubModulo', 'Sprint', 'Release', '$filter', 'Cliente'];

    function ChamadosPorSprintController(ChamadosPorSprint, DateUtils, Modulo, SubModulo, Sprint, Release, $filter, Cliente) {
        var vm = this;

        vm.chamado = {id: null, modulo: null, tipoChamado: null, titulo: null};
        vm.modulos = Modulo.query({page: 0, size: 99});
        vm.subModulos = SubModulo.query({page: 0, size: 99});
        vm.sprints = Sprint.query({page: 0, size: 99});
        vm.releases = Release.query({page: 0, size: 99});
        vm.diasSemMovimentar = 1;


        vm.colors = ['#46BFBD', '#F7464A', '#FDB45C', '#97BBCD'];

        vm.loadAll = loadAll;

        vm.imprimir = imprimir;

        load();

        function load() {
            Cliente.getByUser({}, function (data) {
                vm.clientes = data;
                vm.chamado.cliente = data[0];
            });
        }

        function imprimir() {

            var docDefinition = {
                pageSize: 'A4',

                // by default we use portrait, you can change it to landscape if you wish
                pageOrientation: 'landscape',

                // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
                pageMargins: [40, 60, 40, 60],

                content: [
                    {text: 'Webpublico - Helpdesk', style: 'header', alignment: 'center'},
                    {text: 'Relatório de Acompanhamento dos Chamados por Ciclo', style: 'subheader'},
                    {text: vm.chamado.modulo ? 'Módulo: ' + vm.chamado.modulo.descricao : " "},
                    {text: vm.chamado.situacao ? 'Situação: ' + vm.chamado.situacao : " "},
                    {
                        text: vm.chamado.sprint ? 'Período: '
                            + " ( " + $filter('date')(vm.chamado.sprint.inicio, 'mediumDate') + " até " + $filter('date')(vm.chamado.sprint.fim, 'mediumDate') + ")" : " "
                    },
                    sprintsImpressao()
                ],
                footer: function (currentPage, pageCount) {
                    return {
                        margin: 10,
                        columns: [
                            {
                                fontSize: 9,
                                text: [
                                    {
                                        text: '______________________________________________________________' +
                                            '\n',
                                        margin: [0, 20]
                                    },
                                    {
                                        text: '© MGA - Gestão Pública. Página ' + currentPage.toString() + ' de ' + pageCount,
                                    }
                                ],
                                alignment: 'center'
                            }
                        ]
                    };
                },
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    subheader: {
                        fontSize: 16,
                        bold: true,
                        margin: [0, 10, 0, 5]
                    },
                    tableExample: {
                        margin: [0, 5, 0, 15]
                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 13,
                        color: 'black'
                    }
                }
            };

            // download the PDF
            pdfMake.createPdf(docDefinition).download('Chamados.pdf');
        }

        function buildTableBody(data, columns) {
            var body = [];

            body.push(columns);

            data.forEach(function (row) {
                var dataRow = [];

                columns.forEach(function (column) {
                    if (row[column]) {
                        dataRow.push(row[column].toString());
                    } else {
                        dataRow.push(" ");
                    }
                });

                body.push(dataRow);
            });

            return body;
        }

        function sprintsImpressao() {
            var sprintsImprimir = [];

            angular.forEach(vm.sprintsProntas, function (sprint) {
                sprintsImprimir.push(
                    {text: sprint.descricao, style: 'header', alignment: 'center', margin: [5, 10, 5, 10]},
                    {
                        text: $filter('date')(sprint.inicio, 'mediumDate') + " até " + $filter('date')(sprint.fim, 'mediumDate'),
                        style: 'subheader', alignment: 'center'
                    },
                    table(getChamadosParaImpressao(sprint), ['Chamado', 'Tipo', 'Título', 'Tempo Est.', 'Módulo', 'Situação'])
                );

            });

            return sprintsImprimir;

        }

        function table(data, columns) {
            return {
                table: {
                    margin: [5, 10, 5, 10],
                    style: 'tableExample',
                    headerRows: 1,
                    body: buildTableBody(data, columns)
                },
                layout: 'lightHorizontalLines'
            };
        }

        function loadAll() {
            vm.chamadosAgrupados = {};
            vm.sprintsProntas = [];
            ChamadosPorSprint.query(vm.chamado, function (data) {
                vm.chamados = data;
                angular.forEach(vm.chamados, function (chamado) {
                    if (!vm.chamadosAgrupados[chamado.sprint.descricao]) {
                        vm.sprintsProntas.push(chamado.sprint);
                        vm.chamadosAgrupados[chamado.sprint.descricao] = {sprint: chamado.sprint, chamados: []};
                    }
                    vm.chamadosAgrupados[chamado.sprint.descricao].chamados.push(chamado);
                })

            });
        }


        function getChamadosParaImpressao(sprint) {
            var chamados = [];
            angular.forEach(vm.chamadosAgrupados[sprint.descricao].chamados, function (chamado) {
                chamados.push(
                    {
                        'Chamado': chamado.id,
                        'Tipo': $filter('translate')('chamadosApp.TipoChamado.' + chamado.tipoChamado),
                        'Título': chamado.titulo,
                        'Tempo Est.': chamado.tempoEstimado,
                        'Módulo': chamado.modulo.descricao,
                        'Situação': $filter('translate')('chamadosApp.SituacaoChamado.' + chamado.situacao)
                    }
                )
            });
            return chamados;
        }

    }

})();



(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('chamados-por-solicitante', {
            parent: 'app',
            url: '/chamados-por-solicitante',
            data: {
                authorities: ['ROLE_USER'],
            },
            ncyBreadcrumb: {
                label: 'Relatório de chamados por solicitantes'
            },
            views: {
                'content@': {
                    templateUrl: 'app/relatorios/chamados-por-solicitante/chamados-por-solicitante.html',
                    controller: 'ChamadosPorSolicitanteController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('chamado');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    $translatePartialLoader.addPart('severidade');
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('ChamadosPorSolicitante', ChamadosPorSolicitante);

    ChamadosPorSolicitante.$inject = ['$resource'];

    function ChamadosPorSolicitante($resource) {
        var resourceUrl = 'api/chamados-por-solicitante';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'POST',
                isArray: true
            }

        });
    }


})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('ChamadosPorSolicitanteController', ChamadosPorSolicitanteController);

    ChamadosPorSolicitanteController.$inject = ['ChamadosPorSolicitante', 'DateUtils', 'Modulo', 'SubModulo', 'Sprint', 'Release', 'Solicitante', '$filter', 'Cliente'];

    function ChamadosPorSolicitanteController(ChamadosPorSolicitante, DateUtils, Modulo, SubModulo, Sprint, Release, Solicitante, $filter, Cliente) {
        var vm = this;

        vm.chamado = {id: null, modulo: null, tipoChamado: null, titulo: null, criadoEmInicio: new Date(), criadoEmFim: new Date()};
        vm.modulos = Modulo.query({page: 0, size: 99});
        vm.subModulos = SubModulo.query({page: 0, size: 99});
        vm.sprints = Sprint.query({page: 0, size: 99});
        vm.releases = Release.query({page: 0, size: 99});
        vm.solicitantes = Solicitante.query({page: 0, size: 99});

        vm.colors = ['#46BFBD', '#F7464A', '#FDB45C', '#97BBCD'];

        vm.loadAll = loadAll;

        vm.imprimir = imprimir;

        load();

        function load() {
            Cliente.getByUser({}, function (data) {
                vm.clientes = data;
            });
        }

        function imprimir() {

            var docDefinition = {
                pageSize: 'A4',

                // by default we use portrait, you can change it to landscape if you wish
                pageOrientation: 'landscape',

                // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
                pageMargins: [40, 60, 40, 60],

                content: [
                    {text: 'Webpublico - Helpdesk', style: 'header'},
                    {text: 'Relatório de chamados por solicitantes', style: 'subheader'},
                    {text: vm.chamado.modulo ? 'Módulo: ' + vm.chamado.modulo.descricao : " "},
                    {text: vm.chamado.situacao ? 'Situação: ' + vm.chamado.situacao : " "},
                    solicitantesImpressao()
                ],
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    subheader: {
                        fontSize: 16,
                        bold: true,
                        margin: [0, 10, 0, 5]
                    },
                    tableExample: {
                        margin: [0, 5, 0, 15]
                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 13,
                        color: 'black'
                    }
                }
            };

            // download the PDF
            pdfMake.createPdf(docDefinition).download('chamados-por-solicitante.pdf');
        }

        function buildTableBody(data, columns) {
            var body = [];

            body.push(columns);

            data.forEach(function (row) {
                var dataRow = [];

                columns.forEach(function (column) {
                    if (row[column]) {
                        dataRow.push(row[column].toString());
                    } else {
                        dataRow.push(" ");
                    }
                });

                body.push(dataRow);
            });

            return body;
        }

        function table(data, columns) {
            return {
                table: {
                    margin: [5, 10, 5, 10],
                    style: 'tableExample',
                    headerRows: 1,
                    body: buildTableBody(data, columns)
                },
                layout: 'lightHorizontalLines'
            };
        }

        function solicitantesImpressao() {
            var solicitantesImprimir = [];

            angular.forEach(vm.solicitantesProntos, function (solicitante) {
                solicitantesImprimir.push(
                    {text: solicitante.nome, style: 'header', alignment: 'center', margin: [5, 10, 5, 10]},
                    table(getChamadosParaImpressao(solicitante), ['Chamado', 'Tipo', 'Título', 'Tempo Est.', 'Módulo', 'Situação'])
                );

            });

            return solicitantesImprimir;

        }

        function loadAll() {
            vm.chamadosAgrupados = {};
            vm.solicitantesProntos = [];
            ChamadosPorSolicitante.query(vm.chamado, function (data) {
                vm.chamados = data;
                angular.forEach(vm.chamados, function (chamado) {
                    if (!vm.chamadosAgrupados[chamado.entidadeSolicitante.nome]) {
                        vm.solicitantesProntos.push(chamado.entidadeSolicitante);
                        vm.chamadosAgrupados[chamado.entidadeSolicitante.nome] = {solicitante: chamado.entidadeSolicitante, chamados: []};
                    }
                    vm.chamadosAgrupados[chamado.entidadeSolicitante.nome].chamados.push(chamado);
                })

            });
        }


        function getChamadosParaImpressao(solicitante) {
            var chamados = [];
            angular.forEach(vm.chamadosAgrupados[solicitante.nome].chamados, function (chamado) {
                chamados.push(
                    {
                        'Chamado': chamado.id,
                        'Tipo': $filter('translate')('chamadosApp.TipoChamado.' + chamado.tipoChamado),
                        'Título': chamado.titulo,
                        'Tempo Est.': chamado.tempoEstimado,
                        'Módulo': chamado.modulo.descricao,
                        'Situação': $filter('translate')('chamadosApp.SituacaoChamado.' + chamado.situacao)
                    }
                )
            });
            return chamados;
        }
    }

})();



(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('chamados-por-release', {
            parent: 'app',
            url: '/chamados-por-release',
            data: {
                authorities: ['ROLE_USER'],
            },
            ncyBreadcrumb: {
                label: 'Relatório de chamados por releases'
            },
            views: {
                'content@': {
                    templateUrl: 'app/relatorios/chamados-por-release/chamados-por-release.html',
                    controller: 'ChamadosPorReleaseController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('chamado');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    $translatePartialLoader.addPart('severidade');
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('ChamadosPorRelease', ChamadosPorRelease);

    ChamadosPorRelease.$inject = ['$resource'];

    function ChamadosPorRelease($resource) {
        var resourceUrl = 'api/chamados-por-release';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'POST',
                isArray: true
            }

        });
    }


})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('ChamadosPorReleaseController', ChamadosPorReleaseController);

    ChamadosPorReleaseController.$inject = ['ChamadosPorRelease', 'DateUtils', 'Modulo', 'SubModulo', 'Sprint', 'Release', '$filter', 'Cliente'];

    function ChamadosPorReleaseController(ChamadosPorRelease, DateUtils, Modulo, SubModulo, Sprint, Release, $filter, Cliente) {
        var vm = this;

        vm.chamado = {id: null, modulo: null, tipoChamado: null, titulo: null};
        vm.modulos = Modulo.query({page: 0, size: 99});
        vm.subModulos = SubModulo.query({page: 0, size: 99});
        vm.sprints = Sprint.query({page: 0, size: 99});
        vm.releases = Release.query({page: 0, size: 99});
        vm.diasSemMovimentar = 1;


        vm.colors = ['#46BFBD', '#F7464A', '#FDB45C', '#97BBCD'];

        vm.loadAll = loadAll;

        vm.imprimir = imprimir;

        load();

        function load() {
            Cliente.getByUser({}, function (data) {
                vm.clientes = data;
                vm.chamado.cliente = data[0];
            });
        }

        function imprimir() {

            var docDefinition = {
                pageSize: 'A4',

                // by default we use portrait, you can change it to landscape if you wish
                pageOrientation: 'landscape',

                // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
                pageMargins: [40, 60, 40, 60],

                content: [
                    {text: 'Webpublico - Helpdesk', style: 'header'},
                    {text: 'Relatório de chamados por releases', style: 'subheader'},
                    {text: vm.chamado.modulo ? 'Módulo: ' + vm.chamado.modulo.descricao : " "},
                    {text: vm.chamado.situacao ? 'Situação: ' + vm.chamado.situacao : " "},
                    releasesImpressao()
                ],
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    subheader: {
                        fontSize: 16,
                        bold: true,
                        margin: [0, 10, 0, 5]
                    },
                    tableExample: {
                        margin: [0, 5, 0, 15]
                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 13,
                        color: 'black'
                    }
                }
            };

            // download the PDF
            pdfMake.createPdf(docDefinition).download('Chamados.pdf');
        }

        function buildTableBody(data, columns) {
            var body = [];

            body.push(columns);

            data.forEach(function (row) {
                var dataRow = [];

                columns.forEach(function (column) {
                    if (row[column]) {
                        dataRow.push(row[column].toString());
                    } else {
                        dataRow.push(" ");
                    }
                });

                body.push(dataRow);
            });

            return body;
        }

        function table(data, columns) {
            return {
                table: {
                    margin: [5, 10, 5, 10],
                    style: 'tableExample',
                    headerRows: 1,
                    body: buildTableBody(data, columns)
                },
                layout: 'lightHorizontalLines'
            };
        }

        function releasesImpressao() {
            var releasesImprimir = [];

            angular.forEach(vm.realsesProntas, function (release) {
                releasesImprimir.push(
                    {text: release.versao, style: 'header', alignment: 'center', margin: [5, 10, 5, 10]},
                    {
                        text: release.liberacao ?
                            "Solicitado em: " + $filter('date')(release.solicitacao, 'mediumDate') + " Liberado em:" + $filter('date')(release.liberacao, 'mediumDate')
                            : " Aguardando Liberação em Produção ",
                        style: 'subheader', alignment: 'center'
                    },
                    table(getChamadosParaImpressao(release), ['Chamado', 'Tipo', 'Título', 'Tempo Est.', 'Módulo', 'Situação'])
                );

            });

            return releasesImprimir;

        }

        function loadAll() {
            vm.chamadosAgrupados = {};
            vm.realsesProntas = [];
            ChamadosPorRelease.query(vm.chamado, function (data) {
                vm.chamados = data;
                angular.forEach(vm.chamados, function (chamado) {
                    if (!vm.chamadosAgrupados[chamado.release.versao]) {
                        vm.realsesProntas.push(chamado.release);
                        vm.chamadosAgrupados[chamado.release.versao] = {release: chamado.release, chamados: []};
                    }
                    vm.chamadosAgrupados[chamado.release.versao].chamados.push(chamado);
                })

            });
        }


        function getChamadosParaImpressao(release) {
            var chamados = [];
            angular.forEach(vm.chamadosAgrupados[release.versao].chamados, function (chamado) {
                chamados.push(
                    {
                        'Chamado': chamado.id,
                        'Tipo': $filter('translate')('chamadosApp.TipoChamado.' + chamado.tipoChamado),
                        'Título': chamado.titulo,
                        'Tempo Est.': chamado.tempoEstimado,
                        'Módulo': chamado.modulo.descricao,
                        'Situação': $filter('translate')('chamadosApp.SituacaoChamado.' + chamado.situacao)
                    }
                )
            });
            return chamados;
        }
    }

})();



(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('chamados-por-fila', {
            parent: 'app',
            url: '/chamados-por-fila',
            data: {
                authorities: ['ROLE_USER'],
            },
            ncyBreadcrumb: {
                label: 'Relatório das movimentações das demandas'
            },
            views: {
                'content@': {
                    templateUrl: 'app/relatorios/chamados-por-fila/chamados-por-fila.html',
                    controller: 'ChamadosPorFilaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('chamado');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    $translatePartialLoader.addPart('severidade');
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('ChamadosPorFila', ChamadosPorFila);

    ChamadosPorFila.$inject = ['$resource'];

    function ChamadosPorFila($resource) {
        var resourceUrl = 'api/chamados-por-fila';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'POST',
                isArray: true
            }

        });
    }


})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('ChamadosPorFilaController', ChamadosPorFilaController);

    ChamadosPorFilaController.$inject = ['ChamadosPorFila', 'Chamado', 'Modulo', 'SubModulo', 'Sprint', 'Release', '$filter', 'Cliente'];

    function ChamadosPorFilaController(ChamadosPorFila, Chamado, Modulo, SubModulo, Sprint, Release, $filter, Cliente) {
        var vm = this;

        vm.chamado = {id: null, modulo: null, tipoChamado: null, titulo: null};
        vm.modulos = Modulo.query({page: 0, size: 99});
        vm.subModulos = SubModulo.query({page: 0, size: 99});
        vm.sprints = Sprint.query({page: 0, size: 99});
        vm.releases = Release.query({page: 0, size: 99});
        Chamado.getSituacoes({}, function (data) {
            vm.situacoes = data;
            vm.chamado.situacoes = [];

            angular.forEach(vm.situacoes, function (situacao) {
                if (situacao !== 'FECHADO' && situacao !== 'IMPEDIDO' && situacao !== 'MIGRACAO_REDMINE') {
                    vm.chamado.situacoes.push(situacao);
                }
            });
        });
        vm.diasSemMovimentar = 1;
        vm.getIconePorSituacao = getIconePorSituacao;

        Cliente.getByUser({}, function (data) {
            vm.clientes = data;
            vm.chamado.cliente = data[0];
        });

        vm.colors = ['#46BFBD', '#F7464A', '#FDB45C', '#97BBCD'];

        vm.loadAll = loadAll;

        vm.imprimir = imprimir;

        function imprimir() {

            var docDefinition = {
                pageSize: 'A4',

                // by default we use portrait, you can change it to landscape if you wish
                pageOrientation: 'landscape',

                // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
                pageMargins: [40, 60, 40, 60],

                content: [
                    {text: 'Webpublico - Helpdesk', style: 'header', alignment: 'center'},
                    {text: 'Relatório de Acompanhamento dos Chamados por Fila', style: 'subheader'},
                    {text: vm.chamado.modulo ? 'Módulo: ' + vm.chamado.modulo.descricao : " "},
                    {text: vm.chamado.situacao ? 'Situação: ' + vm.chamado.situacao : " "},
                    {
                        text: vm.chamado.sprint ? 'Período: '
                            + " ( " + $filter('date')(vm.chamado.sprint.inicio, 'mediumDate') + " até " + $filter('date')(vm.chamado.sprint.fim, 'mediumDate') + ")" : " "
                    },
                    filasImpressao()
                ],
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    subheader: {
                        fontSize: 16,
                        bold: true,
                        margin: [0, 10, 0, 5]
                    },
                    footer: {
                        fontSize: 14,
                        italic: true,
                        margin: [0, 10, 0, 5]
                    },
                    tableExample: {
                        margin: [0, 5, 0, 15]
                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 13,
                        color: 'black'
                    }
                }
            };

            // download the PDF
            pdfMake.createPdf(docDefinition).download('Chamados.pdf');
        }

        function buildTableBody(data, columns) {
            var body = [];

            body.push(columns);

            data.forEach(function (row) {
                var dataRow = [];

                columns.forEach(function (column) {
                    if (row[column]) {
                        dataRow.push(row[column].toString());
                    } else {
                        dataRow.push(" ");
                    }
                });

                body.push(dataRow);
            });

            return body;
        }

        function filasImpressao() {
            var filasImprimir = [];

            angular.forEach(vm.filasProntas, function (fila) {
                if (vm.chamadosAgrupados[fila]) {
                    filasImprimir.push(
                        {
                            text: $filter('translate')('chamadosApp.SituacaoChamado.' + fila),
                            style: 'header',
                            alignment: 'center',
                            margin: [5, 10, 5, 10]
                        },
                        table(getChamadosParaImpressao(fila), ['Severidade', 'Tipo', 'Chamado', 'Título', 'Módulo', 'Inicio Dev.', 'Fim Dev.', 'Lib. Teste', 'Validado', 'Última Mov.']),
                        {
                            text: " Total de Chamados na fila " + $filter('translate')('chamadosApp.SituacaoChamado.' + fila) + ": " + vm.chamadosAgrupados[fila].chamados.length,
                            style: 'footer', alignment: 'center', margin: [5, 10, 5, 10]
                        }
                    );
                }
            });

            return filasImprimir;

        }

        function table(data, columns) {
            return {
                table: {
                    margin: [5, 10, 5, 10],
                    style: 'tableExample',
                    headerRows: 1,
                    body: buildTableBody(data, columns)
                },
                layout: 'lightHorizontalLines'
            };
        }

        function getChamadosParaImpressao(situacao) {
            var chamados = [];
            if (vm.chamadosAgrupados[situacao]) {
                angular.forEach(vm.chamadosAgrupados[situacao].chamados, function (chamado) {
                    chamados.push(
                        {
                            'Severidade': $filter('translate')('chamadosApp.Severidade.' + chamado.severidade),
                            'Tipo': $filter('translate')('chamadosApp.TipoChamado.' + chamado.tipoChamado),
                            'Chamado': chamado.id,
                            'Título': chamado.titulo,
                            'Módulo': chamado.modulo,
                            'Início Dev.': $filter('date')(chamado.inicioDesenvolvimento, 'shortDate'),
                            'Fim Dev.': $filter('date')(chamado.fimDesenvolvimento, 'shortDate'),
                            'Lib. Teste': $filter('date')(chamado.inicioTeste, 'shortDate'),
                            'Validado': $filter('date')(chamado.fimTeste, 'shortDate'),
                            'Última Mov.': $filter('date')(chamado.ultimaInteracao, 'shortDate')
                        }
                    )
                });
            }

            return chamados;
        }


        function loadAll() {
            vm.chamadosAgrupados = {};
            ChamadosPorFila.query(vm.chamado, function (data) {
                vm.chamados = data;
                vm.filasProntas = vm.chamado.situacoes;

                angular.forEach(vm.chamados, function (chamado) {
                    if (!vm.chamadosAgrupados[chamado.situacao]) {
                        vm.chamadosAgrupados[chamado.situacao] = {situacao: chamado.situacao, chamados: []};
                    }
                    vm.chamadosAgrupados[chamado.situacao].chamados.push(chamado);
                })

            });
        }


        function getIconePorSituacao(situacao) {
            switch (situacao) {
                case 'ABERTO':
                    return 'fa-envelope-o';
                case 'IMPEDIDO':
                    return 'fa-bell';
                case 'EM_SUPORTE':
                    return 'fa-group';
                case 'EM_ANALISE':
                    return 'fa-spinner';
                case 'EM_ANALISE_DESENVOLVIMENTO':
                    return 'fa-code';
                case 'TESTE_SUPORTE':
                    return 'fa-spinner';
                case 'EM_DESENVOLVIMENTO':
                    return 'fa-code-fork';
                case 'AGUARDANDO_TESTE':
                    return 'fa-slideshare';
                case 'AGUARDANDO_VALIDACAO':
                    return 'fa-check';
                case 'FECHADO':
                    return 'fa-chack-circle-o';
                case 'REJEITADO':
                    return 'fa-thumbs-o-down';
                case 'VALIDADO':
                    return 'fa-thumbs-o-up';
                case 'AGUARDANDO_DESENVOLVIMENTO':
                    return 'fa-laptop';
                default:
                    return 'fa-circle-o';
            }
        }

    }

})();



(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('chamados-atrasados', {
            parent: 'app',
            url: '/entrega-dos-chamados',
            data: {
                authorities: ['ROLE_ATENDENTE', 'ROLE_PO', 'ROLE_DESENVOLVEDOR'],
            },
            ncyBreadcrumb: {
                label: 'Relatório de chamados não entregues no prazo estimado'
            },
            views: {
                'content@': {
                    templateUrl: 'app/relatorios/chamados-atrasados/chamados-atrasados.html',
                    controller: 'ChamadosAtrasadosController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('chamado');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('ChamadosAtrasados', ChamadosAtrasados);

    ChamadosAtrasados.$inject = ['$resource'];

    function ChamadosAtrasados($resource) {
        var resourceUrl = 'api/relatorio-chamados-prazo';

        return $resource(resourceUrl, {}, {
            'query': {
                method: 'POST',
                isArray: true
            }

        });
    }


})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('ChamadosAtrasadosController', ChamadosAtrasadosController);

    ChamadosAtrasadosController.$inject = ['ChamadosAtrasados', 'DateUtils', 'Modulo', 'SubModulo', 'Sprint', '$filter', 'Cliente'];

    function ChamadosAtrasadosController(ChamadosAtrasados, DateUtils, Modulo, SubModulo, Sprint, $filter, Cliente) {
        var vm = this;

        vm.chamado = {id: null, modulo: null, tipoChamado: null, titulo: null};
        vm.modulos = Modulo.query({page: 0, size: 99});
        vm.subModulos = SubModulo.query({page: 0, size: 99});
        vm.sprints = Sprint.query({page: 0, size: 99});

        vm.labels = ["No Prazo", "Não entregue e fora do Prazo", "Entregue Fora do Prazo", "Entregue no Prazo"];
        vm.colors = ['#46BFBD', '#F7464A', '#FDB45C', '#97BBCD'];

        vm.loadAll = loadAll;

        vm.imprimir = imprimir;

        load();

        function load() {
            Cliente.getByUser({}, function (data) {
                vm.clientes = data;
                vm.chamado.cliente = data[0];
            });
        }

        function imprimir() {

            var docDefinition = {
                pageSize: 'A4',

                // by default we use portrait, you can change it to landscape if you wish
                pageOrientation: 'landscape',

                // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
                pageMargins: [ 40, 60, 40, 60 ],

                content: [
                    {text: 'Webpublico - Helpdesk', style: 'header'},
                    {text: 'Relatório de acompanhamento dos Chamados', style: 'subheader'},
                    {text: vm.chamado.modulo ? 'Módulo: ' + vm.chamado.modulo.descricao :" "},
                    {text: vm.situacaoEntrega ? 'Situação: ' + vm.situacaoEntrega :" "},
                    table(getChamadosParaImpressao(), ['Chamado', 'Titulo', 'Prazo', 'Entregue Em', 'Situacao']),

                ],
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    subheader: {
                        fontSize: 16,
                        bold: true,
                        margin: [0, 10, 0, 5]
                    },
                    tableExample: {
                        margin: [0, 5, 0, 15]
                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 13,
                        color: 'black'
                    }
                }
            };

            // download the PDF
            pdfMake.createPdf(docDefinition).download('Chamados_Em_Atraso.pdf');
        }

        function buildTableBody(data, columns) {
            var body = [];

            body.push(columns);

            data.forEach(function (row) {
                var dataRow = [];

                columns.forEach(function (column) {
                    if(row[column]){
                        dataRow.push(row[column].toString());
                    }else{
                        dataRow.push(" ");
                    }
                });

                body.push(dataRow);
            });

            return body;
        }

        function table(data, columns) {
            return {
                table: {
                    margin: [ 5, 10, 5, 10 ],
                    style: 'tableExample',
                    headerRows: 1,
                    body: buildTableBody(data, columns)
                },
                layout: 'lightHorizontalLines'
            };
        }

        function loadAll() {
            vm.hoje = new Date();
            vm.data = [0, 0, 0, 0];
            vm.percentual = [0, 0, 0, 0];
            vm.diasAtraso = 0;
            var atrasoPorModulo = {};
            ChamadosAtrasados.query(vm.chamado, function (data) {
                if (vm.situacaoEntrega) {
                    vm.chamados = [];
                    angular.forEach(data, function (chamado) {
                        if (chamado.situacaoEntrega === vm.situacaoEntrega) {
                            vm.chamados.push(chamado);
                        }
                    });
                } else {
                    vm.chamados = data;
                }
                angular.forEach(vm.chamados, function (chamado) {
                    if (!atrasoPorModulo[chamado.modulo]) {
                        atrasoPorModulo[chamado.modulo] = [];
                    }
                    atrasoPorModulo[chamado.modulo].push(chamado);
                    chamado.inicio = DateUtils.convertDateTimeFromServer(chamado.inicio);
                    chamado.fim = DateUtils.convertDateTimeFromServer(chamado.fim);
                    chamado.entrega = DateUtils.convertDateTimeFromServer(chamado.entrega);

                    if (!chamado.entrega && chamado.fim > vm.hoje) {
                        chamado.cor = "info";
                        vm.data[0] = vm.data[0] + 1;
                    }
                    if (!chamado.entrega && chamado.fim < vm.hoje) {
                        chamado.cor = "danger";
                        vm.data[1] = vm.data[1] + 1;
                    }
                    if (chamado.entrega && chamado.entrega > chamado.fim) {
                        chamado.cor = "warning";
                        vm.data[2] = vm.data[2] + 1;
                    }
                    if (chamado.entrega && chamado.entrega <= chamado.fim) {
                        chamado.cor = "success";
                        vm.data[3] = vm.data[3] + 1;
                    }
                    if (chamado.diasAtraso) {
                        vm.diasAtraso = vm.diasAtraso + chamado.diasAtraso;
                    }
                });
                vm.diasAtraso = vm.diasAtraso / vm.chamados.length;
                for (var i = 0; i < vm.data.length; i++) {
                    var valor = vm.data[i];
                    vm.percentual[i] = (valor * 100) / vm.chamados.length;
                }
                vm.modulosAtrasados = [];

                angular.forEach(atrasoPorModulo, function (value, key) {
                    var modulo = {modulo: key, diasAtraso: 0};
                    angular.forEach(value, function (chamado) {
                        if (chamado.diasAtraso) {
                            modulo.diasAtraso = modulo.diasAtraso + chamado.diasAtraso;
                        }
                    });
                    modulo.diasAtraso = modulo.diasAtraso / value.length;
                    vm.modulosAtrasados.push(modulo);
                });
            });
        }


        function getChamadosParaImpressao() {
            var chamados = [];
            angular.forEach(vm.chamados, function (chamado) {
                chamados.push(
                    {
                        'Chamado': chamado.id,
                        'Titulo': chamado.titulo,
                        'Prazo': 'De ' + $filter('date')(chamado.inicio) + ' Até ' + $filter('date')(chamado.fim),
                        'Entregue Em': chamado.diasAtraso ?
                            chamado.diasAtraso + (chamado.diasAtraso > 1 ? ' dias' : ' dia') + ' de atraso' : $filter('date')(chamado.entrega),
                        'Situacao': chamado.situacaoEntrega
                    }
                )
            });
            return chamados;
        }
    }

})();



(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('acompanhamento-sprint', {
            parent: 'app',
            url: '/acompanhamento-sprint',
            data: {
                authorities: ['ROLE_ATENDENTE'],
            },
            ncyBreadcrumb: {
                label: 'Relatório de acompanhamento do Ciclo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/relatorios/acompanhamento-sprint/acompanhamento-sprint.html',
                    controller: 'AcompanhamentoSprintController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('chamado');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('AcompanhamentoSprint', AcompanhamentoSprint);

    AcompanhamentoSprint.$inject = ['$resource', 'DateUtils'];

    function AcompanhamentoSprint($resource, DateUtils) {
        var resourceUrl = 'api/acompanhamento-sprint';

        return $resource(resourceUrl, {}, {
            'getSprintRedmine': {
                url: 'api/sprints-redmine/:id',
                method: 'GET',
                isArray: true
            },
            'getTicketsRedmine': {
                url: 'api/tickets-redmine/:id',
                method: 'GET'
            },
            'getTicketsRedminePorUsuario': {
                url: 'api/tickets-redmine/:idSprint/:idUser',
                method: 'GET'
            },
            'getUsersRedmine': {
                url: 'api/usuarios-redmine/:id',
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('AcompanhamentoSprintController', AcompanhamentoSprintController);

    AcompanhamentoSprintController.$inject = ['AcompanhamentoSprint', '$filter', 'Modulo', 'SubModulo', 'Sprint'];

    function AcompanhamentoSprintController(AcompanhamentoSprint, $filter, Modulo, SubModulo, Sprint) {
        var vm = this;

        vm.sprints = Sprint.query({page: 0, size: 99});

        vm.chartOptions = {responsive: true, legend: {display: true, position: 'bottom', fullWidth: true}};

        vm.loadAll = loadAll;
        vm.loadUsers = loadUsers;
        vm.loadByUser = loadByUser;

        function loadUsers() {
            if (vm.sprint) {
                AcompanhamentoSprint.getUsersRedmine({id: vm.sprint.id}, function (data) {
                    vm.users = data;
                    if (vm.users.length > 0) {
                        vm.user = vm.users[0];
                        AcompanhamentoSprint.getTicketsRedminePorUsuario({
                            idSprint: vm.sprint.id,
                            idUser: vm.user.id
                        }, loadSuccess);
                    }
                })
            }
        }

        function loadByUser(user) {
            if (vm.sprint) {
                vm.user = user;
                AcompanhamentoSprint.getTicketsRedminePorUsuario({
                    idSprint: vm.sprint.id,
                    idUser: vm.user.id
                }, loadSuccess);
            }
        }

        function loadAll() {
            if (vm.sprint) {
                vm.users = null;
                vm.user = null;
                AcompanhamentoSprint.getTicketsRedmine({id: vm.sprint.id}, loadSuccess);
            }
        }

        function loadSuccess(data) {
            vm.labelsGraficoProjetos = [];
            vm.dataGraficoProjetos = [];

            vm.labelsGraficoTipo = [];
            vm.dataGraficoTipo = [];

            vm.relatorio = data;
            angular.forEach(vm.relatorio.projetos, function (projeto) {
                vm.labelsGraficoProjetos.push(projeto.nome);
                vm.dataGraficoProjetos.push(projeto.tempoGasto);
            });

            angular.forEach(vm.relatorio.tiposTarefas, function (tipo) {
                vm.labelsGraficoTipo.push(tipo.nome);
                vm.dataGraficoTipo.push(tipo.tempoGasto);
            });
        }


    }

})();



(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('planejamento', {
            parent: 'app',
            url: '/planejamento',
            data: {
                authorities: ['ROLE_USER'],
            },
            ncyBreadcrumb: {
                label: 'Planejamento de Ciclo'
            },
            views: {
                'content@': {
                    templateUrl: 'app/planejamento/planejamento.html',
                    controller: 'PlanejamentoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    $translatePartialLoader.addPart('severidade');
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('PlanejamentoController', PlanejamentoController);

    PlanejamentoController.$inject = ['$scope', 'Principal', '$state', 'Chamado', 'Sprint', 'Modulo', 'Sistema', 'Cliente', 'SolicitacaoDesenvolvimento'];

    function PlanejamentoController($scope, Principal, $state, Chamado, Sprint, Modulo, Sistema, Cliente, SolicitacaoDesenvolvimento) {
        var vm = this;
        vm.load = load;
        vm.alocar = alocar;
        vm.desalocar = desalocar;
        vm.alocarTarefa = alocarTarefa;
        vm.desalocarTarefa = desalocarTarefa;
        vm.podeAlocarTarefa = podeAlocarTarefa;
        vm.usuarioTemCliente = usuarioTemCliente;
        vm.getTarefasSprintPorModulo = getTarefasSprintPorModulo;
        vm.getHorasPormodulo = getHorasPormodulo;
        vm.getTempoEpico = getTempoEpico;
        vm.getCorPorTipo = getCorPorTipo;
        vm.carregarSistema = carregarSistema;
        vm.atualizarTarefa = atualizarTarefa;
        vm.selecionarSistema = selecionarSistema;
        vm.agruparChamados = agruparChamados;
        vm.chamadosPorModulo = {};
        vm.epicosSemTarefaAbertos = false;
        vm.toggleEpicosSemTarefa = toggleEpicosSemTarefa;
        vm.getTarefasParaAlocar = getTarefasParaAlocar;
        vm.getEpicosSemTarefa = getEpicosSemTarefa;
        vm.getQtdTarefasParaAlocar = getQtdTarefasParaAlocar;

        function carregarModulos() {
            Modulo.getBySistema({id: vm.sistema.id}, function (data) {
                vm.modulos = data;
                vm.modulo = data[0];
                agruparChamados();
            });
        }

        function selecionarSistema(sistema) {
            vm.sistema = sistema;
            carregarClientes();
        }

        function atualizarTarefa(tarefa) {
            SolicitacaoDesenvolvimento.update(tarefa, agruparChamados);
        }

        function load() {
            Principal.identity().then(function (account) {
                vm.account = account;
                carregarSistema();
            });

        }

        function tempoEstimado(tarefa) {
            return Number(tarefa && tarefa.tempoEstimado) || 0;
        }

        function somaTempoTarefas(tarefas) {
            var total = 0;
            angular.forEach(tarefas || [], function (tarefa) {
                total += tempoEstimado(tarefa);
            });
            return total;
        }

        function bucketModuloVazio(modulo) {
            return {
                modulo: modulo,
                epicos: [],
                tarefasParaAlocar: [],
                epicosSemTarefa: [],
                tempoDisponivel: 0
            };
        }

        function derivarListasDoModulo(moduloId) {
            var bucket = vm.chamadosPorModulo[moduloId];
            if (!bucket) {
                return;
            }
            var tarefasParaAlocar = [];
            var epicosSemTarefa = [];
            angular.forEach(bucket.epicos, function (epico) {
                if (!epico.tarefas || epico.tarefas.length === 0) {
                    epicosSemTarefa.push(epico);
                    return;
                }
                angular.forEach(epico.tarefas, function (tarefa) {
                    tarefasParaAlocar.push({
                        tarefa: tarefa,
                        epico: epico
                    });
                });
            });
            bucket.tarefasParaAlocar = tarefasParaAlocar;
            bucket.epicosSemTarefa = epicosSemTarefa;
        }

        function adicionarEpicoPraPlanejar(epico) {
            var chamado = epico.chamado;
            if (!vm.chamadosPorModulo[chamado.modulo.id]) {
                vm.chamadosPorModulo[chamado.modulo.id] = bucketModuloVazio(chamado.modulo);
            }
            vm.chamadosPorModulo[chamado.modulo.id].epicos.push(epico);

            if (!epico.dependentes || epico.dependentes.length === 0) {
                var horasTarefas = somaTempoTarefas(epico.tarefas);
                vm.chamadosPorModulo[chamado.modulo.id].tempoDisponivel =
                    vm.chamadosPorModulo[chamado.modulo.id].tempoDisponivel + horasTarefas;

                if (vm.horasDisponiveisCliente[chamado.cliente.id]) {
                    vm.horasDisponiveisCliente[chamado.cliente.id].horasSemDependencia =
                        vm.horasDisponiveisCliente[chamado.cliente.id].horasSemDependencia + horasTarefas;
                }
            }
            derivarListasDoModulo(chamado.modulo.id);
        }

        function toggleEpicosSemTarefa() {
            vm.epicosSemTarefaAbertos = !vm.epicosSemTarefaAbertos;
        }

        function getTarefasParaAlocar(modulo) {
            if (!modulo || !vm.chamadosPorModulo[modulo.id]) {
                return [];
            }
            return vm.chamadosPorModulo[modulo.id].tarefasParaAlocar || [];
        }

        function getEpicosSemTarefa(modulo) {
            if (!modulo || !vm.chamadosPorModulo[modulo.id]) {
                return [];
            }
            return vm.chamadosPorModulo[modulo.id].epicosSemTarefa || [];
        }

        function getQtdTarefasParaAlocar(modulo) {
            return getTarefasParaAlocar(modulo).length;
        }

        function carregarClientes() {
            Cliente.getBySistema({sistemaId: vm.sistema.id}, function (data) {
                vm.clientes = [];
                for (var j = 0; j < data.length; j++) {
                    var c = data[j];
                    if (c.ativo !== true) {
                        continue;
                    }
                    vm.clientes.push(c);
                }
                vm.horasDisponiveisCliente = {};
                for (var i = 0; i < vm.clientes.length; i++) {
                    vm.clientes[i].selecionado = true;
                    vm.horasDisponiveisCliente[vm.clientes[i].id] = {
                        cliente: vm.clientes[i],
                        horasOcupadas: 0,
                        horasSemDependencia: 0,
                        horasDisponiveis: vm.clientes[i].horasDisponiveis
                    };
                }
                carregarModulos();
            });
        }

        function agruparChamados() {

            Sprint.getBySituacao({situacao: 'ABERTA'}, function (aberta) {
                vm.chamadosPorModulo = {};

                for (var i = 0; i < aberta.clientes.length; i++) {

                    var cliente = aberta.clientes[i];

                    if (vm.horasDisponiveisCliente[cliente.cliente.id]) {
                        vm.horasDisponiveisCliente[cliente.cliente.id].horasDisponiveis = cliente.horasDisponiveis;
                        vm.horasDisponiveisCliente[cliente.cliente.id].horasOcupadas = 0;
                        vm.horasDisponiveisCliente[cliente.cliente.id].horasSemDependencia = 0;
                    }

                    if (vm.horasDisponiveisCliente[cliente.cliente.id] && vm.horasDisponiveisCliente[cliente.cliente.id].cliente.selecionado) {
                        Chamado.getProximasSprints({
                            idSistema: vm.sistema.id,
                            idCLiente: cliente.cliente.id
                        }, function (epicos) {

                            angular.forEach(epicos, function (epico) {
                                if (!epico.tarefas) {
                                    epico.tarefas = [];
                                }
                                if (!vm.chamadosPorModulo[epico.chamado.modulo.id]) {
                                    vm.chamadosPorModulo[epico.chamado.modulo.id] =
                                        bucketModuloVazio(epico.chamado.modulo);
                                }

                                Chamado.getDependentes({id: epico.chamado.id}, function (data) {
                                    epico.dependentes = data;
                                    epico.chamado.dependentes = data;
                                    adicionarEpicoPraPlanejar(epico);
                                }, function () {
                                    epico.dependentes = [];
                                    epico.chamado.dependentes = [];
                                    adicionarEpicoPraPlanejar(epico);
                                });

                            });
                        });
                    }
                }

                SolicitacaoDesenvolvimento.queryBySprintSistema({
                    sprintId: aberta.id,
                    sistemaId: vm.sistema.id
                }, function (tarefas) {
                    aberta.tarefas = tarefas;
                    vm.sprintAberta = aberta;

                    angular.forEach(vm.sprintAberta.tarefas, function (tarefa) {
                        var clienteId = tarefa.cliente && tarefa.cliente.id;
                        if (!clienteId && tarefa.chamado && tarefa.chamado.cliente) {
                            clienteId = tarefa.chamado.cliente.id;
                        }
                        if (clienteId && vm.horasDisponiveisCliente[clienteId]) {
                            vm.horasDisponiveisCliente[clienteId].horasOcupadas =
                                vm.horasDisponiveisCliente[clienteId].horasOcupadas + tempoEstimado(tarefa);
                        }
                    });
                });
            })
        }

        load();

        function carregarSistema() {
            Sistema.getByUser({}, function (data) {
                vm.sistemas = data;
                selecionarSistema(vm.sistemas[0]);
            })
        }

        function alocar(chamado) {
            // legado: alocação passou a ser por tarefa
        }

        function desalocar(chamado) {
            // legado: desalocação passou a ser por tarefa
        }

        function alocarTarefa(tarefa, epico) {
            SolicitacaoDesenvolvimento.alocarPlanejamento(tarefa, agruparChamados);
        }

        function desalocarTarefa(tarefa) {
            SolicitacaoDesenvolvimento.desalocarPlanejamento(tarefa, agruparChamados);
        }

        /**
         * Não hard-bloqueia só por existir dependente na lista.
         * getDependentes já omite bloqueadores FECHADO; a regra completa
         * (tarefas pendentes do bloqueador) é validada no backend.
         */
        function podeAlocarTarefa(epico) {
            return !!vm.sprintAberta;
        }

        function usuarioTemCliente(cliente) {
            for (var i = 0; i < vm.account.clientes.length; i++) {
                var obj = vm.account.clientes[i];
                if (obj.id === cliente.id) {
                    return true;
                }
            }

            return false;
        }

        function getTarefasSprintPorModulo(modulo) {
            if (!vm.sprintAberta || !vm.sprintAberta.tarefas) {
                return [];
            }
            return vm.sprintAberta.tarefas.filter(function (tarefa) {
                return tarefa.modulo && tarefa.modulo.id === modulo.id &&
                    tarefa.sistema && tarefa.sistema.id === vm.sistema.id;
            });
        }

        function getHorasPormodulo(modulo) {
            var tempo = 0;
            if (modulo.id != null) {
                var tarefas = getTarefasSprintPorModulo(modulo);
                for (var i = 0; i < tarefas.length; i++) {
                    tempo += tempoEstimado(tarefas[i]);
                }
            }

            return tempo;
        }

        function getTempoEpico(epico) {
            return somaTempoTarefas(epico && epico.tarefas);
        }

        function getCorPorTipo(tipo) {
            switch (tipo) {
                case 'SUPORTE':
                    return 'warning';
                case 'BUG':
                    return 'danger';
                case 'MELHORIA':
                    return 'info';
                case 'NOVA_FUNCIONALIDADE':
                    return 'success';
                default:
                    return 'info';
            }
        }
    }

})
();

(function () {
    'use strict';
    /* globals SockJS, Stomp */

    angular
        .module('chamadosApp')
        .factory('WsNotificationService', WsNotificationService);

    WsNotificationService.$inject = ['$rootScope', '$window', '$cookies', '$http', '$q', 'AuthServerProvider'];

    function WsNotificationService($rootScope, $window, $cookies, $http, $q, AuthServerProvider) {
        var stompClient = null;
        var subscriber = null;
        var listener = $q.defer();
        var connected = $q.defer();
        var alreadyConnectedOnce = false;

        var service = {
            connect: connect,
            disconnect: disconnect,
            receive: receive,
            sendActivity: sendActivity,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };

        return service;

        function connect() {
            //building absolute path so that websocket doesn't fail when deploying with a context path
            var loc = $window.location;
            var url = '//' + loc.host + loc.pathname + 'websocket';
            console.log("URL WS " + url);
            var authToken = AuthServerProvider.getToken();
            if (authToken) {
                url += '?access_token=' + authToken;
            }
            var socket = new SockJS(url);
            stompClient = Stomp.over(socket);
            var headers = {};
            stompClient.connect(headers, function () {
                connected.resolve('success');
                sendActivity();
                if (!alreadyConnectedOnce) {
                    alreadyConnectedOnce = true;
                }
            });

        }

        function disconnect() {
            if (stompClient !== null) {
                stompClient.disconnect();
                stompClient = null;
            }
        }

        function receive() {
            return listener.promise;
        }

        function sendActivity() {
            if (stompClient !== null && stompClient.connected) {
                stompClient
                    .send('/topic/notification',
                        {},
                        angular.toJson({'page': $rootScope.toState.name}));
            }
        }

        function subscribe() {
            connected.promise.then(function () {
                subscriber = stompClient.subscribe('/user/queue/notification', function (data) {
                    listener.notify(angular.fromJson(data.body));
                });
            }, null, null);
        }

        function unsubscribe() {
            if (subscriber !== null) {
                subscriber.unsubscribe();
            }
            listener = $q.defer();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('BrowserNotificationController', BrowserNotification);

    BrowserNotification.$inject = ['$scope', 'WsNotificationService', 'webNotification'];

    function BrowserNotification($scope, WsNotificationService, webNotification) {
        var vm = this;

        vm.showActivity = showActivity;
        vm.initialize = initialize;

        function initialize() {
            WsNotificationService.subscribe();

            WsNotificationService.receive().then(null, null, function (activity) {
                vm.showActivity(activity);
            });

        };

        vm.initialize();

        function showActivity(activity) {

            webNotification.showNotification(activity.title, {
                body: activity.message,
                onClick: function onNotificationClicked() {
                    console.log('Notification clicked.');
                },
                autoClose: 4000 //auto close the notification after 4 seconds (you can manually close it via hide function)
            });

            console.log("|Atividade: ", activity);
            $scope.$emit('chamadosApp:activityNotification', activity);
            $scope.$emit('chamadosApp:solicitacaoDesenvolvimentoUpdate', activity)
        }

        $scope.$on("$destroy", function () {
            WsNotificationService.unsubscribe();
        });


    }

})();



(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('NavbarController', NavbarController);

    NavbarController.$inject = ['$state', 'Auth', 'Principal', 'ProfileService', '$scope',
        'Chamado', 'Account', 'localStorageService', '$window', 'Notificacao',
        '$rootScope', '$uibModal', 'SolicitacaoDesenvolvimento', 'Acao', 'Ata'];

    function NavbarController($state, Auth, Principal, ProfileService, $scope,
                              Chamado, Account, localStorageService, $window, Notificacao,
                              $rootScope, $uibModal, SolicitacaoDesenvolvimento, Acao, Ata) {
        var vm = this;
        vm.login = login;
        vm.logout = logout;

        vm.toggleNavbar = toggleNavbar;
        vm.collapseNavbar = collapseNavbar;
        vm.buscar = buscar;
        vm.getIconePorSituacao = getIconePorSituacao;
        vm.$state = $state;
        vm.textoBusca = "";
        vm.notificar = notificar;
        vm.isNavbarCollapsed = true;
        vm.isAuthenticated = Principal.isAuthenticated;
        vm.marcarNotificacaoComoLida = marcarNotificacaoComoLida;

        vm.estaNaTelaDeChamadosPorSituacao = estaNaTelaDeChamadosPorSituacao;
        vm.abrirJanela = abrirJanela;
        vm.abrirJanelaAcao = abrirJanelaAcao;
        vm.hasAcaoPendente = false;

        ProfileService.getProfileInfo().then(function (response) {
            vm.inProduction = response.inProduction;
            vm.swaggerEnabled = response.swaggerEnabled;
        });

       function montarMenu(){
           vm.menu = [
               {
                   ordem: 1,
                   fila: 'ABERTO',
                   sref: 'new-chamado',
                   click: vm.collapseNavbar,
                   icon: 'fa fa-plus-circle',
                   label: 'Chamado'
               },
               {
                   ordem: 2,
                   authority: 'ROLE_ATENDENTE, ROLE_PO, ROLE_DESENVOLVEDOR',
                   sref: 'scrumboard',
                   click: vm.collapseNavbar,
                   icon: 'fa fa-code-fork',
                   label: 'Board'
               },
               {
                   ordem: 3,
                   authority: 'ROLE_USER',
                   dropdown: true,
                   click: vm.collapseNavbar,
                   icon: 'fa fa-list-alt',
                   label: 'Atendimento',
                   filhos: [
                       {
                           authority: 'ROLE_ATENDENTE, ROLE_PO, ROLE_DESENVOLVEDOR',
                           sref: 'new-suporte',
                           icon: 'fa fa-plus-circle',
                           label: 'Atividade'
                       },
                       {
                           fila: 'ABERTO',
                           sref: 'new-chamado',
                           icon: 'fa fa-plus-circle',
                           label: 'Chamado'
                       },
                       {
                           authority: 'ROLE_USER',
                           sref: 'chamado({situacao: null})',
                           icon: 'fa fa-tasks',
                           label: 'Todos Chamados'
                       },
                       {
                           authority: 'ROLE_USER',
                           sref: 'solicitante',
                           icon: 'fa fa-user',
                           label: 'Solicitantes'
                       },
                       {
                           authority: 'ROLE_PO',
                           sref: 'aplicacao',
                           icon: 'fa fa-file-text-o',
                           label: 'Aplicações'
                       },
                       {
                           authority: 'ROLE_OCORRENCIA_CHAMADO',
                           sref: 'ocorrencia',
                           icon: 'fa fa-code',
                           label: 'Ocorrências'
                       },
                       {
                           authority: 'ROLE_USER',
                           sref: 'agrupador',
                           icon: 'fa fa-exchange',
                           label: 'Agrupador'
                       },
                       {
                           authority: 'ROLE_PO, ROLE_DESENVOLVEDOR',
                           sref: 'feedback',
                           icon: 'fa fa-feed',
                           label: 'Feedback'
                       },
                   ]
               },
               {
                   ordem: 4,
                   authority: 'ROLE_USER',
                   dropdown: true,
                   click: vm.collapseNavbar,
                   icon: 'fa fa-code-fork',
                   label: 'Desenvolvimento',
                   filhos: [
                       {
                           authority: 'ROLE_ATENDENTE, ROLE_PO, ROLE_DESENVOLVEDOR, ROLE_SCRUM',
                           sref: 'ata',
                           icon: 'fa fa-file',
                           label: 'Atas'
                       },
                       {
                           authority: 'ROLE_DESENVOLVEDOR',
                           sref: 'solicitacaoDesenvolvimento',
                           icon: 'fa fa-ticket',
                           label: 'Tarefas'
                       },
                       {
                           fila: 'AGUARDANDO_DESENVOLVIMENTO',
                           sref: 'planejamento',
                           icon: 'fa fa-clock-o',
                           label: 'Planejamento'
                       },
                       {
                           authority: 'ROLE_ATENDENTE, ROLE_PO, ROLE_DESENVOLVEDOR, ROLE_SCRUM',
                           sref: 'sprint',
                           icon: 'fa fa-code',
                           label: 'Ciclos'
                       },
                       {
                           fila: 'VALIDADO',
                           sref: 'release',
                           icon: 'fa fa-code-fork',
                           label: 'Releases'
                       },
                   ]
               },
               {
                   ordem: 5,
                   authority: 'ROLE_ATENDENTE, ROLE_PO, ROLE_DESENVOLVEDOR, ROLE_CLIENTE',
                   dropdown: true,
                   click: vm.collapseNavbar,
                   icon: 'fa fa-sitemap',
                   label: 'Relatórios',
                   filhos: [
                       {
                           authority: 'ROLE_ATENDENTE, ROLE_PO, ROLE_DESENVOLVEDOR',
                           sref: 'tempo-gasto',
                           icon: 'fa fa-clock-o',
                           label: 'Tempo Gasto'
                       },
                       {
                           authority: 'ROLE_ATENDENTE, ROLE_PO, ROLE_DESENVOLVEDOR',
                           sref: 'chamados-atrasados',
                           icon: 'fa fa-check-square-o',
                           label: 'Entrega de Chamados'
                       },
                       {
                           authority: 'ROLE_ATENDENTE, ROLE_PO, ROLE_DESENVOLVEDOR',
                           sref: 'acompanhamento-sprint',
                           icon: 'fa fa-group',
                           label: 'Acompanhamento dos Ciclos'
                       },
                       {
                           authority: 'ROLE_PO, ROLE_PLANEJAMENTO_SPRINT, ROLE_ATENDENTE',
                           sref: 'movimentacao-demandas',
                           icon: 'fa fa-check-square-o',
                           label: 'Movimentação das Demandas'
                       },
                       {
                           authority: 'ROLE_PO, ROLE_PLANEJAMENTO_SPRINT, ROLE_ATENDENTE',
                           sref: 'chamados-por-release',
                           icon: 'fa fa-check-square-o',
                           label: 'Chamados por Release'
                       },
                       {
                           authority: 'ROLE_PO, ROLE_PLANEJAMENTO_SPRINT, ROLE_ATENDENTE',
                           sref: 'chamados-por-solicitante',
                           icon: 'fa fa-check-square-o',
                           label: 'Chamados por Solicitante'
                       },
                       {
                           authority: 'ROLE_PO, ROLE_PLANEJAMENTO_SPRINT, ROLE_ATENDENTE',
                           sref: 'chamados-por-volumetria',
                           icon: 'fa fa-check-square-o',
                           label: 'Volumetria'
                       }, {
                           authority: 'ROLE_PO, ROLE_PLANEJAMENTO_SPRINT, ROLE_ATENDENTE',
                           sref: 'chamados-por-sprint',
                           icon: 'fa fa-check-square-o',
                           label: 'Chamados por Ciclo'
                       }, {
                           authority: 'ROLE_PO, ROLE_PLANEJAMENTO_SPRINT, ROLE_ATENDENTE',
                           sref: 'chamados-por-fila',
                           icon: 'fa fa-check-square-o',
                           label: 'Chamados por Fila'
                       },
                       {
                           authority: 'ROLE_PO, ROLE_PLANEJAMENTO_SPRINT, ROLE_ATENDENTE',
                           sref: 'chamados-rejeitados',
                           icon: 'fa fa-thumbs-o-down',
                           label: 'Rejeitados'
                       },
                   ]
               },
               {
                   ordem: 7,
                   authority: 'ROLE_USER',
                   dropdown: true,
                   click: vm.collapseNavbar,
                   icon: 'fa fa-user',
                   label: vm.account.firstName,
                   filhos: [
                       {
                           authority: 'ROLE_USER',
                           sref: 'settings',
                           icon: 'fa fa-gears',
                           label: 'Configurações'
                       },
                       {
                           authority: 'ROLE_USER',
                           sref: 'password',
                           icon: 'fa fa-user',
                           label: 'Senha'
                       },
                       {
                           authority: 'ROLE_ATENDENTE, ROLE_PO, ROLE_DESENVOLVEDOR',
                           sref: 'redmine',
                           icon: 'fa fa-git-square',
                           label: 'Git'
                       },
                       {
                           authority: 'ROLE_USER',
                           sref: 'sessions',
                           icon: 'fa fa-cloud',
                           label: 'Sessões'
                       },
                       {
                           authority: 'ROLE_USER',
                           click: vm.logout,
                           sref: 'login',
                           icon: 'fa fa-sign-out',
                           label: 'Sair'
                       },
                   ]
               },
               {
                   ordem: 6,
                   authority: 'ROLE_ATENDENTE, ROLE_PO, ROLE_DESENVOLVEDOR',
                   sref: 'wiki',
                   icon: 'fa fa-list',
                   label: 'Wiki'
               },
           ];
       }

        function abrirJanela() {
            vm.chamado = null;
            vm.solicitacaoDesenvolvimento = null;
            vm.ata = null;

            if ($state.current && $state.current.name === 'edit-chamado' && $state.params.id) {
                Chamado.get({id: $state.params.id}, function (data) {
                    vm.chamado = data;
                    abrirApontamentoHoras();
                });
            } else if ($state.current && $state.current.name === 'solicitacaoDesenvolvimento.detail' && $state.params.id) {
                SolicitacaoDesenvolvimento.get({id: $state.params.id}, function (data) {
                    vm.solicitacaoDesenvolvimento = data;
                    abrirApontamentoHoras();
                });
            } else if ($state.current && $state.current.name === 'detail-ata' && $state.params.id) {
                Ata.get({id: $state.params.id}, function (data) {
                    vm.ata = data;
                    abrirApontamentoHoras();
                });
            } else {
                abrirApontamentoHoras();
            }
        }

        function estaNaTelaDeChamadosPorSituacao(situacao) {
            return ($state.current && $state.current.name === 'chamado' && $state.params.situacao && $state.params.situacao == situacao)
        }

        function abrirApontamentoHoras() {
            $uibModal.open({
                templateUrl: 'app/entities/tempogasto/tempogasto-dialog.html',
                controller: 'TempoGastoDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return {
                            chamado: vm.chamado,
                            solicitacaoDesenvolvimento: vm.solicitacaoDesenvolvimento,
                            ata: vm.ata,
                            criadoEm: new Date(),
                            horas: 0,
                            minutos: 0
                        };
                    }
                }
            })
        }

        function abrirJanelaAcao() {
            $uibModal.open({
                templateUrl: 'app/admin/acao/acao-justificativa-dialog.html',
                controller: 'AcaoJustificativaDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {}
            })
        }

        function marcarNotificacaoComoLida() {
            Notificacao.marcarComoLida({}, function (data) {
                carregarNotificacoes();
            });
        }


        function notificar(id) {
            Notificacao.notificar({}, function (data) {
                carregarNotificacoes();
            });
        }

        function carregarSituacoes() {
            Chamado.contarPorSituacao({}, function (data) {
                vm.situacoes = data;
            });
        }

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                if (account) {
                    Account.getImagemAjustada({}, function (data) {
                        vm.imagemUsuario = data.imagemAjustada;
                    });
                    carregarSituacoes();
                    carregarNotificacoes();
                    montarMenu();
                }
            });
        }

        getAccount();
        // carregarSituacoes();


        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });


        $rootScope.$on('chamadosApp:notificacaoUpdate', function () {
            carregarSituacoes();
            carregarNotificacoes();
        });

        $rootScope.$on('chamadosApp:acaoUpdate', function () {
            hasAcaoPendente();
        });

        $rootScope.$on('chamadosApp:activityNotification', function () {
            carregarSituacoes();
            carregarNotificacoes();
        });


        function login() {
            collapseNavbar();
            $state.go('login');
        }

        function logout() {
            collapseNavbar();
            Auth.logout();
            $state.go('login');
        }

        function toggleNavbar() {
            vm.isNavbarCollapsed = !vm.isNavbarCollapsed;
        }

        function collapseNavbar() {
            vm.isNavbarCollapsed = true;
        }

        function buscar(event) {
            event.preventDefault();
            if (vm.textoBusca) {
                $state.go("pesquisa", {search: vm.textoBusca});
                vm.textoBusca = "";
            }
        }

        function carregarNotificacoes() {
            // vm.notificacoes = Notificacao.queryNaoLidas();
            // vm.comentarios = Chamado.getComentariosMeiaHora();
        }

        function getIconePorSituacao(situacao) {
            var codigoSituacao = situacao.codigo || situacao.situacaoChamado;
            switch (codigoSituacao) {
                case 'ABERTO':
                    return 'fa-envelope-o';
                case 'IMPEDIDO':
                    return 'fa-bell';
                case 'EM_SUPORTE':
                    return 'fa-group';
                case 'EM_ANALISE':
                    return 'fa-spinner';
                case 'EM_ANALISE_DESENVOLVIMENTO':
                    return 'fa-code';
                case 'TESTE_SUPORTE':
                    return 'fa-spinner';
                case 'EM_DESENVOLVIMENTO':
                    return 'fa-code-fork';
                case 'AGUARDANDO_TESTE':
                    return 'fa-slideshare';
                case 'AGUARDANDO_VALIDACAO':
                    return 'fa-check';
                case 'FECHADO':
                    return 'fa-chack-circle-o';
                case 'REJEITADO':
                    return 'fa-thumbs-o-down';
                case 'VALIDADO':
                    return 'fa-thumbs-o-up';
                case 'AGUARDANDO_DESENVOLVIMENTO':
                    return 'fa-laptop';
                default:
                    return 'fa-circle-o';
            }
        }

        vm.hasMiniNavbar = function () {
            return $('body').hasClass('mini-navbar');
        }

        vm.minimalize = function () {
            $("body").toggleClass("mini-navbar");
            if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
                // Hide menu in order to smoothly turn on when maximize menu
                $('#side-menu').hide();
                // For smoothly turn on menu
                setTimeout(
                    function () {
                        $('#side-menu').fadeIn(500);
                    }, 100);
            } else if ($('body').hasClass('fixed-sidebar')) {
                $('#side-menu').hide();
                setTimeout(
                    function () {
                        $('#side-menu').fadeIn(500);
                    }, 300);
            } else {
                // Remove all inline style from jquery fadeIn function to reset menu state
                $('#side-menu').removeAttr('style');
            }
        }

        function hasAcaoPendente() {
            vm.hasAcaoPendente = false;
            Acao.byUserPendente(function (data) {
                if (data != null && data.length > 0) {
                    vm.hasAcaoPendente = true;
                }
            });
        }

        hasAcaoPendente();
    }

})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .directive('activeMenu', activeMenu);

    activeMenu.$inject = ['$translate', '$locale', 'tmhDynamicLocale'];

    function activeMenu($translate, $locale, tmhDynamicLocale) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var language = attrs.activeMenu;

            scope.$watch(function() {
                return $translate.use();
            }, function(selectedLanguage) {
                if (language === selectedLanguage) {
                    tmhDynamicLocale.set(language);
                    element.addClass('active');
                } else {
                    element.removeClass('active');
                }
            });
        }
    }
})();

/*
 * metismenu - v2.0.2
 * A jQuery menu plugin
 * https://github.com/onokumus/metisMenu
 *
 * Made by Osman Nuri Okumus
 * Under MIT License
 */

!function(a){"use strict";function b(){var a=document.createElement("mm"),b={WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd otransitionend",transition:"transitionend"};for(var c in b)if(void 0!==a.style[c])return{end:b[c]};return!1}function c(b){return this.each(function(){var c=a(this),d=c.data("mm"),f=a.extend({},e.DEFAULTS,c.data(),"object"==typeof b&&b);d||c.data("mm",d=new e(this,f)),"string"==typeof b&&d[b]()})}a.fn.emulateTransitionEnd=function(b){var c=!1,e=this;a(this).one("mmTransitionEnd",function(){c=!0});var f=function(){c||a(e).trigger(d.end)};return setTimeout(f,b),this};var d=b();d&&(a.event.special.mmTransitionEnd={bindType:d.end,delegateType:d.end,handle:function(b){return a(b.target).is(this)?b.handleObj.handler.apply(this,arguments):void 0}});var e=function(b,c){this.$element=a(b),this.options=a.extend({},e.DEFAULTS,c),this.transitioning=null,this.init()};e.TRANSITION_DURATION=350,e.DEFAULTS={toggle:!0,doubleTapToGo:!1,activeClass:"active"},e.prototype.init=function(){var b=this,c=this.options.activeClass;this.$element.find("li."+c).has("ul").children("ul").addClass("collapse in"),this.$element.find("li").not("."+c).has("ul").children("ul").addClass("collapse"),this.options.doubleTapToGo&&this.$element.find("li."+c).has("ul").children("a").addClass("doubleTapToGo"),this.$element.find("li").has("ul").children("a").on("click.metisMenu",function(d){var e=a(this),f=e.parent("li"),g=f.children("ul");return d.preventDefault(),f.hasClass(c)?b.hide(g):b.show(g),b.options.doubleTapToGo&&b.doubleTapToGo(e)&&"#"!==e.attr("href")&&""!==e.attr("href")?(d.stopPropagation(),void(document.location=e.attr("href"))):void 0})},e.prototype.doubleTapToGo=function(a){var b=this.$element;return a.hasClass("doubleTapToGo")?(a.removeClass("doubleTapToGo"),!0):a.parent().children("ul").length?(b.find(".doubleTapToGo").removeClass("doubleTapToGo"),a.addClass("doubleTapToGo"),!1):void 0},e.prototype.show=function(b){var c=this.options.activeClass,f=a(b),g=f.parent("li");if(!this.transitioning&&!f.hasClass("in")){g.addClass(c),this.options.toggle&&this.hide(g.siblings().children("ul.in")),f.removeClass("collapse").addClass("collapsing").height(0),this.transitioning=1;var h=function(){f.removeClass("collapsing").addClass("collapse in").height(""),this.transitioning=0};return d?void f.one("mmTransitionEnd",a.proxy(h,this)).emulateTransitionEnd(e.TRANSITION_DURATION).height(f[0].scrollHeight):h.call(this)}},e.prototype.hide=function(b){var c=this.options.activeClass,f=a(b);if(!this.transitioning&&f.hasClass("in")){f.parent("li").removeClass(c),f.height(f.height())[0].offsetHeight,f.addClass("collapsing").removeClass("collapse").removeClass("in"),this.transitioning=1;var g=function(){this.transitioning=0,f.removeClass("collapsing").addClass("collapse")};return d?void f.height(0).one("mmTransitionEnd",a.proxy(g,this)).emulateTransitionEnd(e.TRANSITION_DURATION):g.call(this)}};var f=a.fn.metisMenu;a.fn.metisMenu=c,a.fn.metisMenu.Constructor=e,a.fn.metisMenu.noConflict=function(){return a.fn.metisMenu=f,this}}(jQuery);

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('home', {
            parent: 'app',
            url: '/',
            data: {
                authorities: ['ROLE_USER', 'ROLE_RESPONSAVEL'],
            },
            ncyBreadcrumb: {
                label: 'Home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/home/home.html',
                    controller: 'HomeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    $translatePartialLoader.addPart('situacaoTarefa');
                    $translatePartialLoader.addPart('tipoHora');
                    $translatePartialLoader.addPart('complexidadeChamado');
                    $translatePartialLoader.addPart('situacaoSprint');
                    return $translate.refresh();
                }],
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
            }
        })
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('HomeController', HomeController);

    HomeController.$inject = ['$scope', '$timeout', 'Principal', '$state', 'Chamado', 'Sprint', '$sanitize', 'DateUtils', 'FeedBack', '$uibModal', 'Alerta', '$rootScope', 'SolicitacaoDesenvolvimento', 'Account', '$filter', 'Agrupador', 'Acao', '$sce'];

    function HomeController($scope, $timeout, Principal, $state, Chamado, Sprint, $sanitize, DateUtils, FeedBack, $uibModal, Alerta, $rootScope, SolicitacaoDesenvolvimento, Account, $filter, Agrupador, Acao, $sce) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = login;
        vm.register = register;
        vm.tempoExcedente = tempoExcedente;
        vm.trustAsHtml = trustAsHtml;
        vm.verChamadosProjeto = verChamadosProjeto;
        vm.labelsModulo = [];
        vm.dataModulo = [[], []];
        vm.labelsTipo = [];
        vm.dataTipo = [];
        vm.sprints = [];
        vm.alertas = [];
        vm.sprintSelecionada = null;
        vm.loadAll = loadAll;
        vm.situacoesSprintSelecionadas = [null, 'EM_ANDAMENTO'];
        vm.changeSprint = changeSprint;
        vm.changeSituacoesSprint = changeSituacoesSprint;

        $scope.$on('authenticationSuccess', function () {
            getAccount();
        });

        function login() {
            $state.go('login');
        }

        getAccount();

        function trustAsHtml(value) {
            return $sanitize(value);
        }

        function loadSprint() {
            Sprint.query({page: 0, size: 99}, function (data) {
                for (var i = 0; i < data.length; i++) {
                    var sprint = data[i];
                    if (sprint.situacao !== 'ABERTA') {
                        vm.sprints.push(sprint);
                    }
                }
                if (vm.sprintSelecionada === null) {
                    vm.sprintSelecionada = vm.sprints[0];
                }
                loadAll();
            });
        }

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.filtro = {};
                vm.isAuthenticated = Principal.isAuthenticated;
                vm.filtro.user = vm.account;
                vm.filtro.sprintAtual = true;
                loadSprint();
                buildBashboardUrl();
            });
        }

        function buildBashboardUrl() {
            var dashBoardUrl = "https://dashboard.webpublico.app.br/public/dashboard/ca4ab58c-783e-4de8-9c82-5f3230f35f72?";
            if (vm.account.modulos.length > 0) {
                dashBoardUrl += "modulo=";
                for (var i = 0; i < vm.account.modulos.length; i++) {
                    var modulo = vm.account.modulos[i];
                    dashBoardUrl += modulo.id+ (i < vm.account.modulos.length -1?  ", ": "");
                }
            }
            if (vm.account.equipes.length > 0) {
                dashBoardUrl += "&equipe=";
                for (var x = 0; x < vm.account.equipes.length; x++) {
                    var equipe = vm.account.equipes[x];
                    dashBoardUrl += equipe.id + (x < vm.account.equipes.length -1?  ", ": "");
                }
            }
            vm.dashBoardUrl = $sce.trustAsResourceUrl(dashBoardUrl);
        }

        function register() {
            $state.go('register');
        }

        function loadAgrupadores() {
            Agrupador.getBySituacao({}, function (data) {
                vm.agrupadores = data;
            });
        }

        function addDays(date, days) {
            var result = new Date(date);
            result.setDate(result.getDate() + days);
            return result;
        }

        function contarChamadosPorSituacao(situacao, cor) {
            if (!vm.clientesChamado) {
                vm.clientesChamado = {};
            }
            vm.clientesChamado[situacao] = [];
            if (!vm.tiposChamado) {
                vm.tiposChamado = {};
            }
            vm.tiposChamado[situacao] = {};
            if (!vm.modulosChamado) {
                vm.modulosChamado = {};
            }
            vm.modulosChamado[situacao] = {};
            if (!vm.situacoesDosChamado) {
                vm.situacoesDosChamado = [];
            }
            Chamado.contarByFiltro({situacao: situacao}, function (data) {
                var chamadosContados = data;
                vm.situacoesDosChamado.push({situacao: situacao, quantidade: chamadosContados.length, cor: cor});
                for (var j = 0; j < chamadosContados.length; j++) {
                    if (!vm.tiposChamado[situacao][chamadosContados[j].tipoChamado]) {
                        vm.tiposChamado[situacao][chamadosContados[j].tipoChamado] = {
                            quantidade: 0, nome: chamadosContados[j].tipoChamado
                        };
                    }
                    vm.tiposChamado[situacao][chamadosContados[j].tipoChamado].quantidade += chamadosContados[j].quantidade;

                    if (!vm.modulosChamado[situacao][chamadosContados[j].modulo]) {
                        vm.modulosChamado[situacao][chamadosContados[j].modulo] = {
                            quantidade: 0, nome: chamadosContados[j].modulo, id: chamadosContados[j].moduloId
                        };
                    }
                    vm.modulosChamado[situacao][chamadosContados[j].modulo].quantidade += chamadosContados[j].quantidade;

                    var cliente = {
                        nome: chamadosContados[j].cliente, id: chamadosContados[j].clienteId, totalItems: 0
                    };
                    var achou = false;
                    for (var i = 0; i < vm.clientesChamado[situacao].length; i++) {
                        if (vm.clientesChamado[situacao][i].id === cliente.id) {
                            cliente = vm.clientesChamado[situacao][i];
                            achou = true;
                            break;
                        }
                    }
                    if (!achou) {
                        vm.clientesChamado[situacao].push(cliente);
                    }
                    cliente.totalItems += chamadosContados[j].quantidade;
                }
            });
        }

        function buscarTarrefasDaSprint() {
            var consulta = {
                idUsuario: vm.filtro.user.id,
                situacoesSprint: vm.situacoesSprintSelecionadas
            }
            SolicitacaoDesenvolvimento.getAllEmDesenvolvimento(consulta,
                function (data) {
                vm.tarefasDaSprint = data;
                vm.tarefasRejeitadas = [];
                vm.tarefasFazendo = [];
                vm.tarefasImpedidas = [];
                vm.tarefasAtrasadas = [];
                for (var i = 0; i < data.length; i++) {
                    var tarefa = data[i];
                    if (tarefa.situacao === 'FAZENDO') {
                        vm.tarefasFazendo.push(tarefa);
                    }
                    if (tarefa.situacao === 'REJEITADO') {
                        vm.tarefasRejeitadas.push(tarefa);
                    }
                    if (tarefa.situacao === 'IMPEDIDO') {
                        vm.tarefasImpedidas.push(tarefa);
                    }
                    if (tarefa.sprintOriginal !== vm.sprintSelecionada.descricao && tarefa.sprintChamado) {
                        vm.tarefasAtrasadas.push(tarefa);
                    }
                }
                if (vm.tarefasFazendo.length > 1) {
                    vm.alertas.push({
                        tipo: 'warning',
                        title: vm.tarefasFazendo.length + ' Tarefas em situação de FAZENDO ao mesmo tempo'
                    });
                }
                if (vm.tarefasRejeitadas.length > 0) {
                    vm.alertas.push({
                        tipo: 'danger',
                        titulo: vm.tarefasRejeitadas.length + ' Tarefa(s) Rejeitada(s)',
                        link: 'scrum-board'
                    });
                }
                if (vm.tarefasAtrasadas.length > 0) {
                    vm.alertas.push({
                        tipo: 'danger',
                        titulo: vm.tarefasAtrasadas.length + ' Tarefa(s) Atrasadas(s)',
                        link: 'scrum-board'
                    });
                }
                if (vm.tarefasImpedidas.length > 0) {
                    vm.alertas.push({
                        tipo: 'warning',
                        titulo: vm.tarefasImpedidas.length + ' Tarefa(s) Impedidas(s)',
                        link: 'scrum-board'
                    });
                }
            });
        }

        function loadAcaoPendente() {
            Acao.byUserPendente(function (data) {
                vm.acoes = data;
                if (data != null && data.length > 0) {
                    vm.alertas.push({
                        tipo: 'danger', titulo: vm.acoes.length + ' Ações não Justificadas', link: 'scrum-board'
                    });
                }
            });
        }

        function recuperarTickets() {
            vm.tarefas = {};
            vm.todasTarefas = [];

            vm.chamados = [];
            vm.horasPorModulo = [];
            vm.horasPonto = [];
            vm.atividades = [];
            if (!vm.filtro.user.imagem) {
                Account.getImagemAjustadaByLogin({login: vm.filtro.user.login}, function (data) {
                    vm.filtro.user.imagem = data.imagemAjustada;
                });
            }

        }


        function recuperarHorasApontada() {
            vm.horaApontadaPorDia = [];
            var loop = new Date(vm.sprintSelecionada.inicio);
            while (loop < new Date(vm.sprintSelecionada.fim)) {
                var newDate = loop.setDate(loop.getDate() + 1);
                loop = new Date(newDate);
                if (loop.getDay() === 6 || loop.getDay() === 0) {
                    continue;
                }
                var criadoEm = $filter('date')(newDate, 'yyyy-MM-dd');

                vm.horaApontadaPorDia.push({dia: criadoEm, tempoGasto: 0, horaPonto: 0, percentual: 0});
            }

            Chamado.queryTempoGasto({
                inicio: vm.sprintSelecionada.inicio,
                fim: vm.sprintSelecionada.fim,
                user: vm.filtro.user
            }, function (data) {
                vm.atividades = data;
                vm.totalTarefasTrabalhadas = 0;
                vm.totalTarefasAjudadas = 0;

                vm.totalHoraTrabalhadas = 0;

                angular.forEach(vm.atividades, function (atividade) {
                    var criadoEm = $filter('date')(atividade.criadoEm, 'yyyy-MM-dd');

                    for (var i = 0; i < vm.horaApontadaPorDia.length; i++) {
                        if (vm.horaApontadaPorDia[i].dia === criadoEm) {
                            vm.horaApontadaPorDia[i].tempoGasto = vm.horaApontadaPorDia[i].tempoGasto + atividade.tempo;
                        }
                    }
                    vm.totalHoraTrabalhadas = vm.totalHoraTrabalhadas + atividade.tempo;
                    adicionarTarefa(atividade);
                });

                recuperarHorasPonto();

                SolicitacaoDesenvolvimento.getAllConcluidasSprint(vm.filtro, function (data) {
                    vm.concluidas = data;
                });

                SolicitacaoDesenvolvimento.getAllRejeitadasSprint(vm.filtro, function (data) {
                    vm.rejeitadas = data;
                });
                montarGraficoModulos();
            });
        }

        function recuperarHorasPonto() {
            vm.filtro.inicio = vm.sprintSelecionada.inicio;
            vm.filtro.fim = vm.sprintSelecionada.fim;
            Chamado.queryTempoGastoPonto(vm.filtro, function (data) {
                vm.horasPonto = data;
                angular.forEach(vm.horasPonto, function (ponto) {
                    if (ponto.horasTrabalhadas) {
                        var criadoEm = $filter('date')(ponto.data, 'yyyy-MM-dd');
                        for (var i = 0; i < vm.horaApontadaPorDia.length; i++) {
                            if (vm.horaApontadaPorDia[i].dia === criadoEm) {
                                vm.horaApontadaPorDia[i].horaPonto += timeToDecimal(ponto.horasTrabalhadasString);
                            }
                        }
                    }
                });
                calculaPercentual();
            }, function (error) {
                calculaPercentual();
            });
        }

        function calculaPercentual() {
            angular.forEach(vm.horaApontadaPorDia, function (dia) {
                var horaPonto = dia.horaPonto;
                if (horaPonto <= 0) {
                    horaPonto = 8.48;
                }
                dia.percentual = ((dia.tempoGasto * 100) / horaPonto);
            });
        }


        function timeToDecimal(t) {
            var arr = t.split(':');
            var dec = parseInt((arr[1] / 6) * 10, 10);

            return parseFloat(parseInt(arr[0], 10) + '.' + (dec < 10 ? '0' : '') + dec);
        }

        function changeSprint() {
            loadAll();
        }

        function changeSituacoesSprint() {
            loadAll();
        }

        function loadAll() {
            vm.alertas = [];
            vm.labelsModulo = [];
            vm.dataModulo = [[], []];
            vm.labelsTipo = [];
            vm.dataTipo = [];

            Chamado.getChamadosSprintAtual({sprintId: vm.sprintSelecionada.id}, function (chamados) {
                vm.sprintEmAndamento = {};
                vm.sprintEmAndamento.chamados = chamados;
                vm.sprintEmAndamento.tempoPlanejado = 0;
                if (chamados && chamados.length > 0) {
                    vm.sprintEmAndamento.horasDisponiveisSprint = chamados[0].horasDisponiveisSprint;
                    vm.sprintEmAndamento.inicioSprint = DateUtils.convertLocalDateFromServer(chamados[0].inicioSprint);
                    vm.sprintEmAndamento.fimSprint = DateUtils.convertLocalDateFromServer(chamados[0].fimSprint);
                    vm.sprintEmAndamento.sprint = chamados[0].sprint;

                    angular.forEach(vm.sprints, function (sprint) {
                        if (chamados[0].sprint === sprint.descricao) {
                            vm.sprintSelecionada = sprint;
                        }
                    });
                }

                vm.chamadosPorCliente = {};
                vm.chamadosPorSistema = {};
                vm.chamadosPorModulo = {};
                vm.chamadosPorTipo = {};

                angular.forEach(vm.sprintEmAndamento.chamados, function (chamado) {
                    if (!vm.chamadosPorCliente[chamado.clienteId]) {
                        vm.chamadosPorCliente[chamado.clienteId] = {
                            cliente: chamado.cliente,
                            clienteId: chamado.clienteId,
                            disponivel: chamado.horasDisponiveisSprint,
                            alocado: 0,
                            suporte: 0,
                            chamados: []
                        };
                    }
                    if (!vm.chamadosPorModulo[chamado.modulo]) {
                        vm.chamadosPorModulo[chamado.modulo] = {
                            modulo: chamado.modulo,
                            alocado: 0,
                            suporte: 0,
                            chamados: []
                        };
                    }
                    if (!vm.chamadosPorTipo[chamado.tipoChamado]) {
                        vm.chamadosPorTipo[chamado.tipoChamado] = {
                            tipo: chamado.tipoChamado,
                            alocado: 0,
                            suporte: 0,
                            chamados: []
                        };
                    }
                    if (!vm.chamadosPorSistema[chamado.sistema]) {
                        vm.chamadosPorSistema[chamado.sistema] = {
                            sistema: chamado.sistema, alocado: 0, suporte: 0, chamados: []
                        };
                    }
                    vm.chamadosPorCliente[chamado.clienteId].chamados.push(chamado);
                    vm.chamadosPorSistema[chamado.sistema].chamados.push(chamado);
                    vm.chamadosPorModulo[chamado.modulo].chamados.push(chamado);
                    vm.chamadosPorTipo[chamado.tipoChamado].chamados.push(chamado);

                    if (chamado.tipoChamado !== 'SUPORTE') {
                        vm.sprintEmAndamento.tempoPlanejado = vm.sprintEmAndamento.tempoPlanejado + chamado.tempoEstimado;
                        vm.chamadosPorCliente[chamado.clienteId].alocado += chamado.tempoEstimado;
                        vm.chamadosPorSistema[chamado.sistema].alocado += chamado.tempoEstimado;
                        vm.chamadosPorModulo[chamado.modulo].alocado += chamado.tempoEstimado;
                    } else {
                        vm.chamadosPorCliente[chamado.clienteId].suporte += chamado.tempoEstimado;
                        vm.chamadosPorSistema[chamado.sistema].suporte += chamado.tempoEstimado;
                        vm.chamadosPorModulo[chamado.modulo].suporte += chamado.tempoEstimado;
                    }
                    vm.chamadosPorTipo[chamado.tipoChamado].alocado += chamado.tempoEstimado;
                    if (vm.labelsModulo.indexOf(chamado.modulo) < 0) {
                        vm.labelsModulo.push(chamado.modulo);
                    }
                    if (vm.labelsTipo.indexOf(chamado.tipoChamado) < 0) {
                        vm.labelsTipo.push(chamado.tipoChamado);
                    }
                });

                angular.forEach(vm.labelsModulo, function (modulo) {
                    vm.dataModulo[0].push(0);
                    vm.dataModulo[1].push(0);
                    angular.forEach(vm.sprintEmAndamento.chamados, function (chamado) {
                        if (chamado.modulo === modulo) {
                            vm.dataModulo[0][vm.labelsModulo.indexOf(modulo)] = vm.dataModulo[0][vm.labelsModulo.indexOf(modulo)] + chamado.tempoEstimado;
                        }
                    });
                });

                angular.forEach(vm.labelsTipo, function (tipo) {
                    vm.dataTipo.push(0);
                    angular.forEach(vm.sprintEmAndamento.chamados, function (chamado) {
                        if (chamado.tipoChamado === tipo) {
                            vm.dataTipo[vm.labelsTipo.indexOf(tipo)] = vm.dataTipo[vm.labelsTipo.indexOf(tipo)] + chamado.tempoEstimado;
                        }
                    });
                });
                vm.labelsModulo.push('Total');
                vm.dataModulo[0].push(vm.sprintEmAndamento.tempoPlanejado);

                var inicio = vm.sprintEmAndamento.inicioSprint;
                inicio.setHours(0, 0, 0, 0);
                var hoje = new Date();
                hoje.setHours(0, 0, 0, 0);
                vm.totalDias = 0;
                vm.diasPercorridos = 0;
                while (inicio < vm.sprintEmAndamento.fimSprint) {
                    vm.totalDias++;
                    if ((inicio.getDate() === hoje.getDate())) {
                        vm.diasPercorridos = vm.totalDias;
                    }
                    inicio = addDays(inicio, 1);
                }
                if (vm.diasPercorridos === 0) {
                    vm.diasPercorridos = vm.totalDias;
                }

                recuperarHorasApontada();

                if (Principal.hasAnyAuthority(['ROLE_DESENVOLVEDOR', 'ROLE_PO', 'ROLE_ATENDENTE'])) {
                    buscarTarrefasDaSprint();
                    vm.mostraColunaDetalhesUsuario = true;
                }
                if (Principal.hasAnyAuthority(['ROLE_PO'])) {
                    contarChamadosPorSituacao('EM_DESENVOLVIMENTO', 'success');
                }
                if (Principal.hasAnyAuthority(['ROLE_PO', 'ROLE_ATENDENTE'])) {
                    loadAgrupadores();
                    contarChamadosPorSituacao('TESTE_SUPORTE', 'warning');
                }
                if (Principal.hasAnyAuthority(['ROLE_CLIENTE'])) {
                    loadAgrupadores();
                    contarChamadosPorSituacao('AGUARDANDO_TESTE', 'danger');
                    contarChamadosPorSituacao('AGUARDANDO_VALIDACAO', 'warning');
                }
                if (Principal.hasAnyAuthority(['ROLE_DESENVOLVEDOR', 'ROLE_PO', 'ROLE_ATENDENTE'])) {
                    loadAcaoPendente();
                    recuperarTickets();
                }
            });
        }

        function tempoExcedente(cliente) {
            var tempo = cliente.alocado - cliente.disponivel;
            return tempo;
        }

        function adicionarTarefa(atividade) {
            if (atividade.solicitacaoDesenvolvimento) {
                if (atividade.tipo === 'CODE_REVIEW') {
                    return;
                }
                var tem = false;
                for (var i = 0; i < vm.tarefasDaSprint.length; i++) {
                    var tarefaDaSprint = vm.tarefasDaSprint[i];
                    if (tarefaDaSprint.id === atividade.solicitacaoDesenvolvimento.id) {
                        tem = true;
                        if (!tarefaDaSprint.tempoGasto) {
                            tarefaDaSprint.tempoGasto = 0;
                        }
                        tarefaDaSprint.tempoGasto += atividade.tempo;
                        break;
                    }
                }
                var tipo = atividade.tipo ? $filter('translate')('chamadosApp.TipoHora.' + atividade.tipo) : atividade.conteudo;
                if (!vm.tarefas[tipo]) {
                    vm.tarefas[tipo] = [];
                }
                var tarefa = atividade.solicitacaoDesenvolvimento;
                var indice = vm.tarefas[tipo].map(function (value) {
                    return value.numero;
                }).indexOf(tarefa.numero);


                if (indice > -1) {
                    vm.tarefas[tipo][indice].tempoGasto += atividade.tempo;
                } else {
                    tarefa.tempoGasto = atividade.tempo;
                    vm.tarefas[tipo].push(tarefa);
                    if (atividade.solicitacaoDesenvolvimento.responsavel && atividade.solicitacaoDesenvolvimento.responsavel.login === vm.filtro.user.login) {
                        vm.totalTarefasTrabalhadas = vm.totalTarefasTrabalhadas + 1;
                    } else {
                        vm.totalTarefasAjudadas = vm.totalTarefasAjudadas + 1;
                    }
                }
            } else {
            }
        }


        function verChamadosProjeto(cliente) {
            var modalInstance = $uibModal.open({
                size: 'lg',
                animation: true,
                templateUrl: 'chamadosCliente.html',
                controller: 'DialogChamadosProjeto',
                controllerAs: 'vm',
                backdrop: 'static',
                resolve: {
                    cliente: vm.chamadosPorCliente[cliente.clienteId], feedBack: {}
                }
            });
            modalInstance.result.then(function (feedBack) {
                FeedBack.save(feedBack, function (data) {
                    vm.feedBack = data;
                    Alerta.info("Obrigado!", "");
                });
            });
        }

        function montarGraficoModulos() {
            vm.labelsModulo = [];
            vm.dataModulo = [];
            vm.totalModulo = 0;
            angular.forEach(vm.atividades, function (atividade) {
                if (!atividade.chamado) {
                    return;
                }
                if (vm.labelsModulo.indexOf(atividade.chamado.modulo.descricao) < 0) {
                    vm.labelsModulo.push(atividade.chamado.modulo.descricao);
                }
            });
            angular.forEach(vm.labelsModulo, function (modulo) {
                angular.forEach(vm.atividades, function (atividade) {
                    if (!atividade.chamado) {
                        return;
                    }
                    if (atividade.chamado.modulo.descricao === modulo) {
                        if (!vm.dataModulo[vm.labelsModulo.indexOf(modulo)]) {
                            vm.dataModulo[vm.labelsModulo.indexOf(modulo)] = 0;
                        }
                        vm.dataModulo[vm.labelsModulo.indexOf(modulo)] =
                            vm.dataModulo[vm.labelsModulo.indexOf(modulo)] + atividade.tempo;
                        vm.totalModulo += atividade.tempo;
                    }
                });
            });
            montarGraficoTipos();
        }

        function montarGraficoTipos() {
            vm.labelsTipo = [];
            vm.dataTipo = [];
            vm.totalTipo = 0;
            angular.forEach(vm.atividades, function (atividade) {
                if (!atividade.chamado) {
                    return;
                }
                var tipo = atividade.tipo ? $filter('translate')('chamadosApp.TipoHora.' + atividade.tipo) : atividade.conteudo;
                if (vm.labelsTipo.indexOf(tipo) < 0) {
                    vm.labelsTipo.push(tipo);
                }
            });
            angular.forEach(vm.labelsTipo, function (tipo) {
                angular.forEach(vm.atividades, function (atividade) {
                    if (!atividade.chamado) {
                        return;
                    }
                    var tipoAtividade = atividade.tipo ? $filter('translate')('chamadosApp.TipoHora.' + atividade.tipo) : atividade.conteudo;

                    if (tipoAtividade === tipo) {
                        if (!vm.dataTipo[vm.labelsTipo.indexOf(tipo)]) {
                            vm.dataTipo[vm.labelsTipo.indexOf(tipo)] = 0;
                        }
                        vm.dataTipo[vm.labelsTipo.indexOf(tipo)] =
                            vm.dataTipo[vm.labelsTipo.indexOf(tipo)] + atividade.tempo;
                        vm.totalTipo += atividade.tempo;
                    }
                });
            });
            montarGraficoComplexidade();
        }

        function montarGraficoComplexidade() {
            vm.labelsComplexidade = [];
            vm.dataComplexidade = [];
            vm.totalComplexidade = 0;
            angular.forEach(vm.atividades, function (atividade) {
                if (!atividade.chamado) {
                    return;
                }
                var complexidade = atividade.chamado.complexidade ? $filter('translate')('chamadosApp.ComplexidadeChamado.' + atividade.chamado.complexidade) : "Sem Comple.";
                if (vm.labelsComplexidade.indexOf(complexidade) < 0) {
                    vm.labelsComplexidade.push(complexidade);
                }
            });
            angular.forEach(vm.labelsComplexidade, function (complexidade) {
                angular.forEach(vm.atividades, function (atividade) {
                    if (!atividade.chamado) {
                        return;
                    }
                    var complexidadeAtividade = $filter('translate')('chamadosApp.ComplexidadeChamado.' + atividade.chamado.complexidade);

                    if (complexidadeAtividade === complexidade) {
                        if (!vm.dataComplexidade[vm.labelsComplexidade.indexOf(complexidade)]) {
                            vm.dataComplexidade[vm.labelsComplexidade.indexOf(complexidade)] = 0;
                        }
                        vm.dataComplexidade[vm.labelsComplexidade.indexOf(complexidade)] =
                            vm.dataComplexidade[vm.labelsComplexidade.indexOf(complexidade)] + atividade.tempo;
                        vm.totalComplexidade += atividade.tempo;
                    }
                });
            });
            montarGraficoProjeto();
        }


        function montarGraficoProjeto() {
            vm.labelsProjeto = [];
            vm.dataProjeto = [];
            vm.totalProjeto = 0;
            angular.forEach(vm.atividades, function (atividade) {
                if (!atividade.chamado) {
                    return;
                }
                var projeto = atividade.chamado.cliente.nome;
                if (vm.labelsProjeto.indexOf(projeto) < 0) {
                    vm.labelsProjeto.push(projeto);
                }
            });
            angular.forEach(vm.labelsProjeto, function (projeto) {
                angular.forEach(vm.atividades, function (atividade) {
                    if (!atividade.chamado) {
                        return;
                    }
                    var projetoAtividade = atividade.chamado.cliente.nome;

                    if (projetoAtividade === projeto) {
                        if (!vm.dataProjeto[vm.labelsProjeto.indexOf(projeto)]) {
                            vm.dataProjeto[vm.labelsProjeto.indexOf(projeto)] = 0;
                        }
                        vm.dataProjeto[vm.labelsProjeto.indexOf(projeto)] =
                            vm.dataProjeto[vm.labelsProjeto.indexOf(projeto)] + atividade.tempo;
                        vm.totalProjeto += atividade.tempo;
                    }
                });
            });
        }

    }

    angular
        .module('chamadosApp')
        .controller('DialogChamadosProjeto', DialogChamadosProjeto);

    DialogChamadosProjeto.$inject = ['$uibModalInstance', 'cliente'];


    function DialogChamadosProjeto($uibModalInstance, cliente) {
        var vm = this;
        vm.feedBack = cliente;
        vm.cliente = cliente;
        vm.ok = function () {
            $uibModalInstance.close();
        };

    };

})();



(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .directive('wikiTinymce', wikiTinymce);

    function wikiTinymce() {
        return {
            restrict: 'E',
            require: 'ngModel',
            scope: {
                ngModel: '='
            },
            template: '<textarea rows="50" ui-tinymce="tinymceOptions" ng-model="ngModel"></textarea>',
            link: function (scope) {
                scope.tinymceOptions = {
                    height: 500,
                    menubar: false,
                    plugins: 'link image table lists code paste autoresize',
                    toolbar: 'undo redo | formatselect | bold italic underline | bullist numlist | link image table | code',
                    content_css: 'content/css/wiki-content.css',
                    paste_data_images: false,
                    file_picker_types: 'image',
                    file_picker_callback: function (callback, value, meta) {
                        if (meta.filetype !== 'image') {
                            return;
                        }
                        var input = document.createElement('input');
                        input.setAttribute('type', 'file');
                        input.setAttribute('accept', 'image/jpeg,image/png,image/gif,image/webp');
                        input.onchange = function () {
                            var file = this.files[0];
                            if (!file) {
                                return;
                            }
                            var formData = new FormData();
                            formData.append('file', file);
                            var xhr = new XMLHttpRequest();
                            xhr.open('POST', 'api/wiki/images');
                            xhr.onload = function () {
                                if (xhr.status === 200) {
                                    var json = JSON.parse(xhr.responseText);
                                    callback(json.url, {alt: file.name});
                                }
                            };
                            xhr.onerror = function () {
                                window.alert('Falha no upload da imagem');
                            };
                            xhr.send(formData);
                        };
                        input.click();
                    }
                };
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('WikiSpaceDialogController', WikiSpaceDialogController);

    WikiSpaceDialogController.$inject = ['$scope', 'entity', '$uibModalInstance', 'WikiSpace'];

    function WikiSpaceDialogController($scope, entity, $uibModalInstance, WikiSpace) {
        var vm = this;
        vm.space = entity;
        vm.clear = clear;
        vm.save = save;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.space.id !== null) {
                WikiSpace.update(vm.space, onSaveSuccess, onSaveError);
            } else {
                WikiSpace.save(vm.space, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('chamadosApp:wikiSpaceUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('WikiSpace', WikiSpace);

    WikiSpace.$inject = ['$resource'];

    function WikiSpace($resource) {
        return $resource('api/wiki-spaces/:id', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {method: 'GET'},
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('WikiSpaceController', WikiSpaceController);

    WikiSpaceController.$inject = ['$uibModal', 'WikiSpace', 'Wiki', 'AlertService'];

    function WikiSpaceController($uibModal, WikiSpace, Wiki, AlertService) {
        var vm = this;
        vm.spaces = [];
        vm.edit = edit;
        vm.remove = remove;
        vm.openCreate = openCreate;

        load();

        function load() {
            WikiSpace.query({}, function (data) {
                vm.spaces = data;
                vm.spaces.forEach(function (space) {
                    Wiki.query({spaceId: space.id}, function (pages) {
                        space.pageCount = pages.length;
                    });
                });
            });
        }

        function edit(space) {
            $uibModal.open({
                templateUrl: 'app/entities/wiki/wiki-space-dialog.html',
                controller: 'WikiSpaceDialogController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function () {
                        return angular.copy(space);
                    }
                }
            }).result.then(function () {
                load();
            }, angular.noop);
        }

        function openCreate() {
            $uibModal.open({
                templateUrl: 'app/entities/wiki/wiki-space-dialog.html',
                controller: 'WikiSpaceDialogController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function () {
                        return {id: null, nome: null, descricao: null, ordem: 100};
                    }
                }
            }).result.then(function () {
                load();
            }, angular.noop);
        }

        function remove(space) {
            WikiSpace.delete({id: space.id}, function () {
                load();
            }, function (error) {
                if (error && error.data && error.data.message) {
                    AlertService.error(error.data.message);
                }
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('WikiRedirectController', WikiRedirectController);

    WikiRedirectController.$inject = ['$state', 'WikiSpace', '$window'];

    function WikiRedirectController($state, WikiSpace, $window) {
        WikiSpace.query({}, function (spaces) {
            var lastId = $window.localStorage.getItem('wiki.lastSpaceId');
            var target = null;

            if (lastId) {
                target = spaces.filter(function (s) {
                    return s.id === parseInt(lastId, 10);
                })[0];
            }
            if (!target) {
                target = spaces.filter(function (s) {
                    return s.nome === 'Geral';
                })[0];
            }
            if (!target && spaces.length > 0) {
                target = spaces[0];
            }
            if (target) {
                $state.go('wiki-space', {spaceId: target.id}, {location: 'replace'});
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .directive('wikiPageTree', wikiPageTree);

    function wikiPageTree() {
        return {
            restrict: 'E',
            templateUrl: 'app/entities/wiki/wiki-page-tree.html',
            controller: 'WikiPageTreeController',
            controllerAs: 'vm',
            bindToController: true,
            scope: {
                pages: '=',
                spaceId: '=',
                currentPageId: '=',
                onTreeChange: '&'
            }
        };
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('WikiPageTreeController', WikiPageTreeController);

    WikiPageTreeController.$inject = ['$scope', '$state', 'Wiki', 'Alerta', 'AlertService'];

    function WikiPageTreeController($scope, $state, Wiki, Alerta, AlertService) {
        var vm = this;
        vm.expanded = {};
        vm.toggleExpand = toggleExpand;
        vm.isExpanded = isExpanded;
        vm.hasChildren = hasChildren;
        vm.isActive = isActive;
        vm.openPage = openPage;
        vm.addSubpage = addSubpage;
        vm.editPage = editPage;
        vm.deletePage = deletePage;

        $scope.$watch(function () {
            return vm.pages;
        }, function (newPages) {
            if (newPages) {
                initExpanded(newPages);
            }
        }, true);

        if (vm.pages) {
            initExpanded(vm.pages);
        }

        function initExpanded(pages) {
            angular.forEach(pages, function (page) {
                vm.expanded[page.id] = true;
                if (page.filhos && page.filhos.length) {
                    initExpanded(page.filhos);
                }
            });
        }

        function hasChildren(page) {
            return page.filhos && page.filhos.length > 0;
        }

        function isExpanded(pageId) {
            return vm.expanded[pageId] !== false;
        }

        function toggleExpand(pageId, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            vm.expanded[pageId] = !isExpanded(pageId);
        }

        function isActive(pageId) {
            return vm.currentPageId && vm.currentPageId === pageId;
        }

        function openPage(pageId) {
            $state.go('detail-wiki', {spaceId: vm.spaceId, id: pageId});
        }

        function addSubpage(pageId, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            $state.go('new-wiki', {spaceId: vm.spaceId, superior: pageId});
        }

        function editPage(pageId, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            $state.go('edit-wiki', {spaceId: vm.spaceId, id: pageId});
        }

        function deletePage(page, $event) {
            if ($event) {
                $event.stopPropagation();
            }
            Alerta.confirm('Atenção', 'Tem certeza que deseja excluir a página "' + page.titulo + '"?', 'warning', function () {
                Wiki.delete({id: page.id}, function () {
                    Alerta.success('Operação realizada', 'Página excluída.');
                    if (vm.currentPageId === page.id) {
                        $state.go('wiki-space', {spaceId: vm.spaceId});
                    }
                    if (vm.onTreeChange) {
                        vm.onTreeChange();
                    }
                }, function (error) {
                    var message = error && error.data && error.data.message
                        ? error.data.message
                        : 'Não foi possível excluir a página.';
                    AlertService.error(message);
                });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('WikiNavbarController', WikiNavbarController);

    WikiNavbarController.$inject = ['$scope', '$state', '$stateParams', '$window', '$uibModal', 'WikiSpace', 'Principal', 'Auth'];

    function WikiNavbarController($scope, $state, $stateParams, $window, $uibModal, WikiSpace, Principal, Auth) {
        var vm = this;

        vm.spaces = [];
        vm.currentSpaceId = null;
        vm.account = null;
        vm.switchSpace = switchSpace;
        vm.openNewSpaceDialog = openNewSpaceDialog;
        vm.logout = logout;

        resolveCurrentSpaceId();
        loadSpaces();
        loadAccount();

        $scope.$on('$stateChangeSuccess', function () {
            resolveCurrentSpaceId();
        });

        function loadAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
            });
        }

        function resolveCurrentSpaceId() {
            if ($stateParams.spaceId) {
                vm.currentSpaceId = parseInt($stateParams.spaceId, 10);
                return;
            }
            var lastId = $window.localStorage.getItem('wiki.lastSpaceId');
            if (lastId) {
                vm.currentSpaceId = parseInt(lastId, 10);
            }
        }

        function loadSpaces() {
            WikiSpace.query({}, function (data) {
                vm.spaces = data;
                if (!vm.currentSpaceId && data.length > 0) {
                    var geral = data.filter(function (s) {
                        return s.nome === 'Geral';
                    })[0];
                    vm.currentSpaceId = geral ? geral.id : data[0].id;
                }
            });
        }

        function switchSpace(spaceId) {
            if (!spaceId) {
                return;
            }
            $window.localStorage.setItem('wiki.lastSpaceId', spaceId);
            vm.currentSpaceId = spaceId;
            $state.go('wiki-space', {spaceId: spaceId});
        }

        function openNewSpaceDialog() {
            $uibModal.open({
                templateUrl: 'app/entities/wiki/wiki-space-dialog.html',
                controller: 'WikiSpaceDialogController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: function () {
                        return {id: null, nome: null, descricao: null, ordem: 100};
                    }
                }
            }).result.then(function (result) {
                WikiSpace.query({}, function (data) {
                    vm.spaces = data;
                });
                switchSpace(result.id);
            }, angular.noop);
        }

        function logout() {
            Auth.logout();
            $state.go('login');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('WikiEditController', WikiEditController);

    WikiEditController.$inject = ['$scope', '$state', '$stateParams', 'entity', 'Wiki'];

    function WikiEditController($scope, $state, $stateParams, entity, Wiki) {
        var vm = this;
        vm.wiki = entity;
        vm.spaceId = parseInt($stateParams.spaceId, 10);
        vm.wikis = [];
        vm.cancel = cancel;
        vm.goBack = goBack;
        vm.save = save;

        if (!vm.wiki.space) {
            vm.wiki.space = {id: vm.spaceId};
        }

        Wiki.query({spaceId: vm.spaceId}, function (data) {
            vm.wikis = data;
        });

        if (vm.wiki.superior && vm.wiki.superior.id) {
            Wiki.get({id: vm.wiki.superior.id}, function (data) {
                vm.wiki.superior = data;
            });
        }

        function goBack() {
            if (vm.wiki.id) {
                $state.go('detail-wiki', {spaceId: vm.spaceId, id: vm.wiki.id});
            } else {
                $state.go('wiki-space', {spaceId: vm.spaceId});
            }
        }

        function cancel() {
            goBack();
        }

        function save() {
            vm.isSaving = true;
            if (vm.wiki.id !== null) {
                Wiki.update(vm.wiki, onSaveSuccess, onSaveError);
            } else {
                Wiki.save(vm.wiki, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('chamadosApp:wikiUpdate', result);
            $state.go('detail-wiki', {spaceId: vm.spaceId, id: result.id});
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('WikiDetailController', WikiDetailController);

    WikiDetailController.$inject = ['$scope', '$stateParams', '$window', 'entity', 'space', 'Wiki', 'AlertService'];

    function WikiDetailController($scope, $stateParams, $window, entity, space, Wiki, AlertService) {
        var vm = this;
        vm.wiki = entity && entity.id ? entity : null;
        vm.space = space;
        vm.wikis = [];
        vm.reloadTree = reloadTree;
        vm.scrollToHeading = scrollToHeading;

        if (vm.space && vm.space.id) {
            $window.localStorage.setItem('wiki.lastSpaceId', vm.space.id);
        }

        reloadTree();

        $scope.$on('chamadosApp:wikiUpdate', function () {
            reloadTree();
        });

        function reloadTree() {
            Wiki.query({spaceId: vm.space.id}, function (data) {
                vm.wikis = data;
                refreshPageData();
            }, onError);
        }

        function findPagePath(pages, targetId, path) {
            path = path || [];
            for (var i = 0; i < pages.length; i++) {
                var page = pages[i];
                var currentPath = path.concat([{id: page.id, titulo: page.titulo}]);
                if (page.id === targetId) {
                    return currentPath;
                }
                if (page.filhos && page.filhos.length) {
                    var found = findPagePath(page.filhos, targetId, currentPath);
                    if (found) {
                        return found;
                    }
                }
            }
            return null;
        }

        function findPageNode(pages, targetId) {
            for (var i = 0; i < pages.length; i++) {
                if (pages[i].id === targetId) {
                    return pages[i];
                }
                if (pages[i].filhos) {
                    var found = findPageNode(pages[i].filhos, targetId);
                    if (found) {
                        return found;
                    }
                }
            }
            return null;
        }

        function slugify(text, index) {
            return 'wiki-h-' + index + '-' + (text || '').toLowerCase()
                .replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
        }

        function buildTocAndContent(html) {
            var toc = [];
            var index = 0;
            var rendered = (html || '').replace(/<(h[1-3])([^>]*)>(.*?)<\/\1>/gi, function (match, tag, attrs, text) {
                index++;
                var id = slugify(text.replace(/<[^>]+>/g, ''), index);
                var level = parseInt(tag.charAt(1), 10);
                toc.push({id: id, text: text.replace(/<[^>]+>/g, ''), level: level});
                return '<' + tag + ' id="' + id + '"' + attrs + '>' + text + '</' + tag + '>';
            });
            return {toc: toc, rendered: rendered};
        }

        function refreshPageData() {
            if (!vm.wiki || !vm.wiki.id || !vm.wikis.length) {
                vm.breadcrumbs = [];
                vm.toc = [];
                vm.renderedContent = vm.wiki ? vm.wiki.conteudo : '';
                vm.childPages = [];
                return;
            }
            var path = findPagePath(vm.wikis, vm.wiki.id) || [];
            vm.breadcrumbs = [{titulo: vm.space.nome}].concat(path);
            var node = findPageNode(vm.wikis, vm.wiki.id);
            vm.childPages = (node && node.filhos) ? node.filhos : [];
            var parsed = buildTocAndContent(vm.wiki.conteudo);
            vm.toc = parsed.toc;
            vm.renderedContent = parsed.rendered;
        }

        function scrollToHeading(id) {
            var el = document.getElementById(id);
            if (el) {
                el.scrollIntoView({behavior: 'smooth', block: 'start'});
            }
        }

        function onError(error) {
            if (error && error.data && error.data.message) {
                AlertService.error(error.data.message);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('wiki-root', {
                parent: 'entity',
                abstract: true,
                url: '/wiki',
                views: {
                    'filas@': {
                        template: ''
                    },
                    'navbar@': {
                        templateUrl: 'app/entities/wiki/wiki-navbar.html',
                        controller: 'WikiNavbarController',
                        controllerAs: 'vm'
                    }
                },
                data: {
                    specialClass: "white-bg"
                },
            })
            .state('wiki', {
                parent: 'wiki-root',
                url: '',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_CLIENTE', 'ROLE_RESPONSAVEL', 'ROLE_DESENVOLVEDOR', 'ROLE_PO'],
                    pageTitle: 'Visualização de Wiki'
                },
                views: {
                    'content@': {
                        controller: 'WikiRedirectController',
                        template: '<div class="text-center p-lg"><i class="fa fa-spinner fa-spin"></i></div>'
                    }
                }
            })
            .state('wiki-space', {
                parent: 'wiki-root',
                url: '/space/{spaceId}',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_CLIENTE', 'ROLE_RESPONSAVEL', 'ROLE_DESENVOLVEDOR', 'ROLE_PO'],
                    pageTitle: 'Visualização de Wiki'
                },
                ncyBreadcrumb: {
                    label: 'Visualização de Wiki'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/wiki/wiki-detail.html',
                        controller: 'WikiDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    space: ['$stateParams', 'WikiSpace', function ($stateParams, WikiSpace) {
                        return WikiSpace.get({id: $stateParams.spaceId}).$promise;
                    }],
                    entity: ['$stateParams', 'Wiki', function ($stateParams, Wiki) {
                        return Wiki.first({spaceId: $stateParams.spaceId}).$promise.then(function (data) {
                            return data && data.id ? data : null;
                        });
                    }],
                    previousState: ['$state', function ($state) {
                        return {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('new-wiki', {
                parent: 'wiki-root',
                url: '/space/{spaceId}/new?superior',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_DESENVOLVEDOR', 'ROLE_PO'],
                    pageTitle: 'Inclusão de Wiki'
                },
                ncyBreadcrumb: {
                    label: 'Inclusão de Wiki'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/wiki/wiki-edit.html',
                        controller: 'WikiEditController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    superior: null
                },
                resolve: {
                    entity: ['$stateParams', function ($stateParams) {
                        var wiki = {
                            titulo: null,
                            conteudo: null,
                            id: null,
                            space: {id: parseInt($stateParams.spaceId, 10)}
                        };
                        if ($stateParams.superior) {
                            wiki.superior = {id: $stateParams.superior};
                        }
                        return wiki;
                    }],
                    previousState: ['$state', function ($state) {
                        return {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('edit-wiki', {
                parent: 'wiki-root',
                url: '/space/{spaceId}/edit/{id}',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_CLIENTE', 'ROLE_RESPONSAVEL', 'ROLE_DESENVOLVEDOR', 'ROLE_PO'],
                    pageTitle: 'Edição de Wiki'
                },
                ncyBreadcrumb: {
                    label: 'Edição de Wiki'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/wiki/wiki-edit.html',
                        controller: 'WikiEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'Wiki', function ($stateParams, Wiki) {
                        return Wiki.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ['$state', function ($state) {
                        return {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('detail-wiki', {
                parent: 'wiki-root',
                url: '/space/{spaceId}/page/{id}',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_CLIENTE', 'ROLE_RESPONSAVEL', 'ROLE_DESENVOLVEDOR', 'ROLE_PO'],
                    pageTitle: 'Visualização de Wiki'
                },
                ncyBreadcrumb: {
                    label: 'Visualização de Wiki'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/wiki/wiki-detail.html',
                        controller: 'WikiDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    space: ['$stateParams', 'WikiSpace', function ($stateParams, WikiSpace) {
                        return WikiSpace.get({id: $stateParams.spaceId}).$promise;
                    }],
                    entity: ['$stateParams', 'Wiki', function ($stateParams, Wiki) {
                        return Wiki.get({id: $stateParams.id}).$promise;
                    }],
                    previousState: ['$state', function ($state) {
                        return {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                    }]
                }
            })
            .state('wiki-spaces', {
                parent: 'wiki-root',
                url: '/spaces',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_DESENVOLVEDOR', 'ROLE_PO'],
                    pageTitle: 'Gerenciar Espaços Wiki'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/wiki/wiki-space.html',
                        controller: 'WikiSpaceController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('Wiki', Wiki);

    Wiki.$inject = ['$resource'];

    function Wiki($resource) {
        var resourceUrl = 'api/wiki/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true, params: {spaceId: '@spaceId'}},
            'get': {method: 'GET'},
            'first': {url: 'api/wiki/first', method: 'GET', params: {spaceId: '@spaceId'}},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('WikiController', WikiController);

    WikiController.$inject = ['$scope', '$state', 'Wiki', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Alerta'];

    function WikiController($scope, $state, Wiki, ParseLinks, AlertService, paginationConstants, pagingParams, Alerta) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.loadWiki = loadWiki;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.remover = remover;
        vm.itemsPerPage = 999;
        vm.wikis;
        vm.filtro = " ";

        function loadAll() {
            Wiki.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                filtro: vm.filtro
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(dwiki) {
                vm.wikis = dwiki;
                if(vm.wikis && vm.wikis.length){
                    loadWiki(vm.wikis[0].id);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        vm.loadAll();

        function loadWiki(id) {
            Wiki.get({id: id}, function (data) {
                vm.wiki = data;
            })
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function remover(id) {
            Alerta.confirm("Atenção", "Tem certeza que deseja remover essa Wiki?", "warning", function () {
                Wiki.delete({id: id},
                    function () {
                        Alerta.success("Operação realizada", "O Wiki foi removida!");
                        vm.loadAll();
                        $scope.$emit('chamadosApp:wikiUpdate');

                    });
            });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('Uf', Uf);

    Uf.$inject = ['$resource'];

    function Uf($resource) {
        return $resource('api/ufs/:id', {}, {
            'findAll': {
                url: 'api/ufs',
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('TempoGastoDialogController', TempoGastoDialogController);

    TempoGastoDialogController.$inject = ['Principal', '$uibModalInstance',
        'Chamado', 'AlertService', 'Ata', 'User', 'Alerta', '$timeout', 'SolicitacaoDesenvolvimento', 'entity'];

    function TempoGastoDialogController(Principal, $uibModalInstance,
                                        Chamado, AlertService, Ata,
                                        User, Alerta, $timeout, SolicitacaoDesenvolvimento, entity
    ) {
        var vm = this;

        vm.buscar = buscar;
        vm.definirTempoGasto = definirTempoGasto;
        vm.buscar = buscar;
        vm.clear = clear;
        vm.tempoGasto = entity;
        vm.branches = [];

        function load() {
            if (vm.tempoGasto.tempo) {
                var totalMinutos = vm.tempoGasto.tempo *60;
                var horas = Math.floor(totalMinutos / 60);
                var minutos = totalMinutos % 60;
                vm.tempoGasto.horas = horas;
                vm.tempoGasto.minutos = Math.floor(minutos);
            }
        }

        load();

        function buscar() {

            vm.branches = [];
            SolicitacaoDesenvolvimento.getByNumero({numero: vm.numeroBusca},
                function (ticket) {
                    vm.tempoGasto.solicitacaoDesenvolvimento = ticket;
                    vm.tempoGasto.chamado = ticket.chamado;
                    vm.branches = SolicitacaoDesenvolvimento.getBranches({id: ticket.id});
                }, function (error) {
                    Chamado.get({id: vm.numeroBusca}, function (chamado) {
                        vm.tempoGasto.chamado = chamado;
                        vm.tempoGasto.solicitacaoDesenvolvimento = null;
                    }, function (error) {
                        Ata.getByNumero({numero: vm.numeroBusca}, function (ata) {
                            vm.tempoGasto.ata = ata;
                            vm.tempoGasto.solicitacaoDesenvolvimento = null;
                            vm.tempoGasto.chamado = null;
                            vm.tempoGasto.tipo = 'CERIMONIA_SCRUM';
                        }, function (error) {
                            Alerta.error("Ops!", "Não foi possível encontrar chamado, tarefa ou ata com o número" + vm.numeroBusca + "!");
                        });
                    });
                });


        }

        function definirTempoGasto() {
            vm.isSaving = true;
            vm.tempoGasto.tempo = vm.tempoGasto.horas + (vm.tempoGasto.minutos / 60)
            Chamado.defirnirTempo(vm.tempoGasto, function (data) {
                vm.openChat = false;
                Alerta.success("Operação realizada!", "Tempo apontado com sucesso!");
                $uibModalInstance.close(data);
            });
        }


        function carregarAtividades() {
            vm.numeroBusca = '';
            if (vm.tempoGasto.chamado) {
                vm.numeroBusca = vm.tempoGasto.chamado.id
            } else if (vm.tempoGasto.solicitacaoDesenvolvimento) {
                vm.numeroBusca = vm.tempoGasto.solicitacaoDesenvolvimento.numero;
                vm.tempoGasto.chamado = vm.tempoGasto.solicitacaoDesenvolvimento.chamado;
            } else if (vm.tempoGasto.ata) {
                vm.numeroBusca = vm.tempoGasto.ata.numero;
                vm.tempoGasto.tipo = 'CERIMONIA_SCRUM';
            }

        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        carregarAtividades();

    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tempo-gasto', {
                parent: 'entity',
                url: '/tempo-gasto?page&sort&search&situacao&dia',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_DESENVOLVEDOR', 'ROLE_PO'],
                    pageTitle: 'Tempo Gasto'
                },
                ncyBreadcrumb: {
                    label: 'Tempo Gasto'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/tempogasto/tempogasto.html',
                        controller: 'TempoGastoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    dia: null,
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            dia: $stateParams.dia
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('situacaoChamado');
                        $translatePartialLoader.addPart('tipoHora');

                        return $translate.refresh();
                    }]
                }
            })
            .state('tempo-gasto.new', {
                parent: 'entity',
                url: 'tempo-gasto/new',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_DESENVOLVEDOR', 'ROLE_PO'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tempogasto/tempogasto-dialog.html',
                        controller: 'TempoGastoDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {chamado: null, criadoEm: new Date(), horas: 0, minutos: 0};
                            }
                        }
                    }).result.then(function (result) {
                        $state.go('^');
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
        ;
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('TempoGastoController', TempoGastoController);

    TempoGastoController.$inject = ['Principal',
        'Chamado', 'Sistema', 'AlertService', 'User', 'Alerta', 'DateUtils', '$sanitize', 'Cliente', 'pagingParams', '$uibModal'];

    function TempoGastoController(Principal,
                                  Chamado, Sistema, AlertService,
                                  User, Alerta, DateUtils, $sanitize, Cliente, pagingParams, $uibModal) {
        var vm = this;

        if (pagingParams.dia) {
            var parts =pagingParams.dia.split('-');
            var firstday = new Date(parts[0], parts[1] - 1, parts[2]);
            vm.filtro = {inicio: firstday, fim: firstday};
            vm.detalhado = true;
            vm.resumido = false;
        } else {
            var curr = new Date;
            var firstday = new Date(curr.setDate(curr.getDate() - curr.getDay()));
            var lastday = new Date(curr.setDate(curr.getDate() - curr.getDay() + 6));
            vm.filtro = {inicio: firstday, fim: lastday};
            vm.detalhado = false;
            vm.resumido = true;
        }


        vm.account = null;
        vm.isAuthenticated = null;
        vm.datePickerOpenStatus = {};
        vm.geral = false;


        vm.excluir = excluir;
        vm.getTempoPorDia = getTempoPorDia;
        vm.getTempoTotalPorUsuario = getTempoTotalPorUsuario;
        vm.carregarTemposPorCliente = carregarTemposPorCliente;
        vm.carregarTemposPorSistemaCliente = carregarTemposPorSistemaCliente;
        vm.trustAsHtml = trustAsHtml;
        vm.loadAll = loadAll;
        vm.getUserByLogin = getUserByLogin;

        vm.openCalendar = openCalendar;
        vm.editarApontamento = editarApontamento;


        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                User.getAllInternos({}, function (data) {
                    vm.users = data;
                    angular.forEach(vm.users, function (user) {
                        if (vm.account.login === user.login)
                            vm.filtro.user = user;
                    });
                    loadAll();
                });
            });

            Cliente.getByUser({}, function (data) {
                vm.clientes = data;
                for (var i = 0; i < vm.clientes.length; i++) {
                    var cliente = vm.clientes[i];
                    cliente.sistemas = Sistema.getByCliente({clienteId: cliente.id});
                }
            });


        }

        getAccount();

        function carregarTemposPorCliente(cliente) {
            var total = 0;
            angular.forEach(vm.atividades, function (atividade) {
                if (atividade.solicitacaoDesenvolvimento) {
                    if (atividade.solicitacaoDesenvolvimento.cliente.id === cliente.id) {
                        total = total + atividade.tempo;
                    }
                } else if (atividade.chamado) {
                    if (atividade.chamado.cliente.id === cliente.id) {
                        total = total + atividade.tempo;
                    }
                }
            });
            return total;
        }


        function carregarTemposPorSistemaCliente(cliente, sistema) {
            var total = 0;
            angular.forEach(vm.atividades, function (atividade) {
                if (atividade.solicitacaoDesenvolvimento) {
                    if (atividade.solicitacaoDesenvolvimento.sistema.id === sistema.id
                        && atividade.solicitacaoDesenvolvimento.cliente.id === cliente.id) {
                        total = total + atividade.tempo;
                    }
                } else if (atividade.chamado) {
                    if (atividade.chamado.sistema.id === sistema.id
                        && atividade.chamado.cliente.id === cliente.id) {
                        total = total + atividade.tempo;
                    }
                }
            });
            return total;
        }

        function getTempoTotalPorUsuario(login, cliente, sistema) {
            var total = 0;
            angular.forEach(vm.atividades, function (atividade) {
                if (atividade.solicitacaoDesenvolvimento) {
                    if (atividade.user.login === login
                        && atividade.solicitacaoDesenvolvimento.sistema.id === sistema.id
                        && atividade.solicitacaoDesenvolvimento.cliente.id === cliente.id) {
                        total = total + atividade.tempo;
                    }
                } else if (atividade.chamado) {
                    if (atividade.user.login === login
                        && atividade.chamado.sistema.id === sistema.id
                        && atividade.chamado.cliente.id === cliente.id) {
                        total = total + atividade.tempo;
                    }
                }
            });
            return total;
        }

        function getTempoPorDia(dia, login) {
            var total = 0;
            angular.forEach(vm.atividades, function (atividade) {
                if (atividade.criadoEm.getTime() === dia.getTime() && atividade.user.login === login) {
                    total = total + atividade.tempo;
                }
            });

            return total;
        }

        function trustAsHtml(value) {
            return $sanitize(value);
        };

        function getUserByLogin(value) {
            for (var i = 0; i < vm.users.length; i++) {
                var user = vm.users[i];
                if (user.login === value) {
                    return user;
                }
            }
        };

        function loadAll() {
            vm.dateArray = [];
            vm.usuariosListados = [];
            Chamado.queryTempoGasto(vm.filtro, onSuccess, onError);
        }

        function onSuccess(data) {
            vm.atividades = data;

            angular.forEach(vm.atividades, function (atividade) {
                atividade.criadoEm = DateUtils.convertLocalDateFromServer(atividade.criadoEm);
                if (vm.usuariosListados.indexOf(atividade.user.login) < 0) {
                    vm.usuariosListados.push(atividade.user.login);
                }
            });

            var currentDate = new Date(vm.filtro.inicio);
            while (currentDate <= vm.filtro.fim) {
                var date = new Date(currentDate);
                date.setHours(0, 0, 0, 0);
                vm.dateArray.push(date);
                currentDate.setDate(currentDate.getDate() + 1);
            }
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }


        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function excluir(id) {
            vm.isSaving = true;
            vm.id = id;
            Alerta.confirm("Confirme a operação",
                "Você tem certeza que excluir esse Apontamento de Horas?",
                "error",
                confirmExcluir,
                onSaveError);
        }

        function confirmExcluir() {
            Chamado.excluirTempo({id: vm.id}, function () {
                loadAll();
                vm.isSaving = false;
                vm.id = null;
                Alerta.success("Operação realizada!", "O apontamento de horas foi removido da base de dados e do redmine!");
            });
        }

        function onSaveError() {
            vm.isSaving = false;
            Alerta.error("Operação NÃO realizada!", "não foi possível remover o registro!");

        }

        function editarApontamento(entity) {
            $uibModal.open({
                templateUrl: 'app/entities/tempogasto/tempogasto-dialog.html',
                controller: 'TempoGastoDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                resolve: {
                    entity: function () {
                        return entity;
                    }
                }
            })
        }


    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('teamboard', {
            parent: 'app',
            url: '/team-board',
            data: {
                authorities: ['ROLE_USER'],
            },
            ncyBreadcrumb: {
                label: 'TeamBoard'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/teamboard/teamboard.html',
                    controller: 'TeamBoardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('situacaoTarefa');
                    $translatePartialLoader.addPart('tipoChamado');
                    $translatePartialLoader.addPart('situacaoTarefa');
                    $translatePartialLoader.addPart('tipoHora');
                    $translatePartialLoader.addPart('complexidadeChamado');
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('TeamBoardController', TeamBoardController);

    TeamBoardController.$inject = ['$scope', '$rootScope', '$filter', 'Principal', '$state', 'Chamado', 'Sprint', 'SolicitacaoDesenvolvimento', 'Account', 'Modulo', 'User'];

    function TeamBoardController($scope, $rootScope, $filter, Principal, $state, Chamado, Sprint, SolicitacaoDesenvolvimento, Account, Modulo, User) {
        var vm = this;
        vm.modulos = Modulo.queryByUser();
        vm.recuperarTickets = recuperarTickets;
        vm.getQuantidadeTickets = getQuantidadeTickets;
        vm.sprints = Sprint.query();
        vm.totalHoraTrabalhadas = 0;
        vm.totalTarefas = 0;
        vm.users = User.getAllWithEquipe();

        function getQuantidadeTickets(situacao) {
            var quantidade = 0;
            angular.forEach(vm.tarefas, function (tipo) {
                angular.forEach(vm.tarefas[tipo], function (ticket) {
                    if (ticket.situacao == situacao) {
                        quantidade = quantidade + 1;
                    }
                });

            });
            return quantidade;
        }

        function load() {
            Principal.identity().then(function (account) {
                vm.account = account;
                Sprint.getBySituacao({situacao: 'EM_ANDAMENTO'}, function (aberta) {
                    vm.sprint = aberta;
                    vm.filtro = {};
                    vm.filtro.inicio = vm.sprint.inicio;
                    vm.filtro.fim = vm.sprint.fim;
                    vm.filtro.user = vm.account;
                    recuperarTickets();
                });
            });
        }

        function recuperarTickets() {
            vm.tarefas = {};
            vm.chamados = [];
            vm.horasPorModulo = [];
            vm.horasPonto = [];
            vm.atividades = [];

            Sprint.get({id: vm.sprint.id}, function (aberta) {
                vm.sprint = aberta;
                vm.filtro.inicio = vm.sprint.inicio;
                vm.filtro.fim = vm.sprint.fim;
                recuperarHorasApontada();

            });
            if (!vm.filtro.user.imagem) {
                Account.getImagemAjustadaByLogin({login: vm.filtro.user.login}, function (data) {
                    vm.filtro.user.imagem = data.imagemAjustada;
                });
            }

        }

        function adicionarTarefa(atividade) {
            if (atividade.solicitacaoDesenvolvimento) {
                if (atividade.tipo === 'CODE_REVIEW') {
                    return;
                }
                var tipo = atividade.tipo ? $filter('translate')('chamadosApp.TipoHora.' + atividade.tipo) : atividade.conteudo;
                if (!vm.tarefas[tipo]) {
                    vm.tarefas[tipo] = [];
                }
                var tarefa = atividade.solicitacaoDesenvolvimento;
                var indice = vm.tarefas[tipo].map(function (value) {
                    return value.numero
                }).indexOf(tarefa.numero);
                if (indice > -1) {
                    vm.tarefas[tipo][indice].tempoGasto += atividade.tempo;
                    vm.totalTarefas ++;
                } else {
                    tarefa.tempoGasto = atividade.tempo;
                    vm.tarefas[tipo].push(tarefa);
                }
            }
        }

        function adicionarChamado(atividade) {
            if (atividade.chamado) {
                if (atividade.tipo === 'CODE_REVIEW') {
                    return;
                }
                var chamado = atividade.chamado;
                var indice = vm.chamados.map(function (value) {
                    return value.id
                }).indexOf(chamado.id);
                if (indice > -1) {
                    vm.chamados[indice].tempoGasto += atividade.tempo;
                } else {
                    chamado.tempoGasto = atividade.tempo;
                    vm.chamados.push(chamado);
                }
            }
        }

        function recuperarHorasApontada() {
            Chamado.queryTempoGasto(vm.filtro, function (data) {
                vm.atividades = data;
                vm.horaApontadaPorDia = {};
                vm.totalHoraTrabalhadas = 0;
                for (var d = new Date(vm.sprint.inicio); d <= vm.sprint.fim - 1; d.setDate(d.getDate() + 1)) {
                    if (d.getDay() === 6 || d.getDay() === 0) {
                        continue;
                    }
                    var criadoEm = $filter('date')(new Date(d), 'yyyy-MM-dd');
                    vm.horaApontadaPorDia[criadoEm] = {dia: criadoEm, tempoGasto: 0, horaPonto: 0, percentual: 0};
                }

                angular.forEach(vm.atividades, function (atividade) {
                    var criadoEm = $filter('date')(atividade.criadoEm, 'yyyy-MM-dd');
                    if (!vm.horaApontadaPorDia[criadoEm]) {
                        vm.horaApontadaPorDia[criadoEm] = {dia: criadoEm, tempoGasto: 0, horaPonto: 0, percentual: 0};
                    }
                    vm.horaApontadaPorDia[criadoEm].tempoGasto = vm.horaApontadaPorDia[criadoEm].tempoGasto + atividade.tempo;
                    vm.totalHoraTrabalhadas = vm.totalHoraTrabalhadas + atividade.tempo;

                    adicionarTarefa(atividade);
                    adicionarChamado(atividade);
                });

                recuperarHorasPonto();
            });
        }

        function recuperarHorasPonto() {
            Chamado.queryTempoGastoPonto(vm.filtro, function (data) {
                vm.horasPonto = data;
                angular.forEach(vm.horasPonto, function (ponto) {
                    if (ponto.horasTrabalhadas) {
                        var criadoEm = $filter('date')(ponto.data, 'yyyy-MM-dd');
                        if (!vm.horaApontadaPorDia[criadoEm]) {
                            vm.horaApontadaPorDia[criadoEm] = {
                                dia: criadoEm,
                                tempoGasto: 0,
                                horaPonto: 0,
                                percentual: 0
                            };
                        }
                        vm.horaApontadaPorDia[criadoEm].horaPonto += timeToDecimal(ponto.horasTrabalhadasString);
                    }
                });
                calculaPercentual();
            }, function (error) {
                calculaPercentual();
            });
        }

        function calculaPercentual() {
            angular.forEach(vm.horaApontadaPorDia, function (dia) {
                var horaPonto = dia.horaPonto;
                if (horaPonto <= 0) {
                    horaPonto = 8.48;
                }
                dia.percentual = ((dia.tempoGasto * 100) / horaPonto);
            });
            montarGraficoHoras();
        }

        function montarGraficoHoras() {
            vm.labelsHoras = [];
            vm.dataHoras = [[], [], []];
            vm.serieHoras = ["Trabalhado", "Esperado", "Apontado"];
            angular.forEach(vm.horaApontadaPorDia, function (dia) {
                vm.labelsHoras.push($filter('date')(dia.dia, 'dd/MM/yyyy'));
                vm.dataHoras[0].push(dia.horaPonto);
                vm.dataHoras[1].push(8.48);
                vm.dataHoras[2].push(dia.tempoGasto);
            });
            montarGraficoModulos();
        }

        function montarGraficoModulos() {
            vm.labelsModulo = [];
            vm.dataModulo = [];
            vm.totalModulo = 0;
            angular.forEach(vm.atividades, function (atividade) {
                if (!atividade.chamado) {
                    return;
                }
                if (vm.labelsModulo.indexOf(atividade.chamado.modulo.descricao) < 0) {
                    vm.labelsModulo.push(atividade.chamado.modulo.descricao);
                }
            });
            angular.forEach(vm.labelsModulo, function (modulo) {
                angular.forEach(vm.atividades, function (atividade) {
                    if (!atividade.chamado) {
                        return;
                    }
                    if (atividade.chamado.modulo.descricao === modulo) {
                        if (!vm.dataModulo[vm.labelsModulo.indexOf(modulo)]) {
                            vm.dataModulo[vm.labelsModulo.indexOf(modulo)] = 0;
                        }
                        vm.dataModulo[vm.labelsModulo.indexOf(modulo)] =
                            vm.dataModulo[vm.labelsModulo.indexOf(modulo)] + atividade.tempo;
                        vm.totalModulo += atividade.tempo;
                    }
                });
            });
            montarGraficoTipos()
        }

        function montarGraficoTipos() {
            vm.labelsTipo = [];
            vm.dataTipo = [];
            vm.totalTipo = 0;
            angular.forEach(vm.atividades, function (atividade) {
                if (!atividade.chamado) {
                    return;
                }
                var tipo = atividade.tipo ? $filter('translate')('chamadosApp.TipoHora.' + atividade.tipo) : atividade.conteudo;
                if (vm.labelsTipo.indexOf(tipo) < 0) {
                    vm.labelsTipo.push(tipo);
                }
            });
            angular.forEach(vm.labelsTipo, function (tipo) {
                angular.forEach(vm.atividades, function (atividade) {
                    if (!atividade.chamado) {
                        return;
                    }
                    var tipoAtividade = atividade.tipo ? $filter('translate')('chamadosApp.TipoHora.' + atividade.tipo) : atividade.conteudo;

                    if (tipoAtividade === tipo) {
                        if (!vm.dataTipo[vm.labelsTipo.indexOf(tipo)]) {
                            vm.dataTipo[vm.labelsTipo.indexOf(tipo)] = 0;
                        }
                        vm.dataTipo[vm.labelsTipo.indexOf(tipo)] =
                            vm.dataTipo[vm.labelsTipo.indexOf(tipo)] + atividade.tempo;
                        vm.totalTipo += atividade.tempo;
                    }
                });
            });
            montarGraficoComplexidade()
        }

        function montarGraficoComplexidade() {
            vm.labelsComplexidade = [];
            vm.dataComplexidade = [];
            vm.totalComplexidade = 0;
            angular.forEach(vm.atividades, function (atividade) {
                if (!atividade.chamado) {
                    return;
                }
                var complexidade = atividade.chamado.complexidade ? $filter('translate')('chamadosApp.ComplexidadeChamado.' + atividade.chamado.complexidade) : "Sem Comple.";
                if (vm.labelsComplexidade.indexOf(complexidade) < 0) {
                    vm.labelsComplexidade.push(complexidade);
                }
            });
            angular.forEach(vm.labelsComplexidade, function (complexidade) {
                angular.forEach(vm.atividades, function (atividade) {
                    if (!atividade.chamado) {
                        return;
                    }
                    var complexidadeAtividade = $filter('translate')('chamadosApp.ComplexidadeChamado.' + atividade.chamado.complexidade);

                    if (complexidadeAtividade === complexidade) {
                        if (!vm.dataComplexidade[vm.labelsComplexidade.indexOf(complexidade)]) {
                            vm.dataComplexidade[vm.labelsComplexidade.indexOf(complexidade)] = 0;
                        }
                        vm.dataComplexidade[vm.labelsComplexidade.indexOf(complexidade)] =
                            vm.dataComplexidade[vm.labelsComplexidade.indexOf(complexidade)] + atividade.tempo;
                        vm.totalComplexidade += atividade.tempo;
                    }
                });
            });
        }

        function timeToDecimal(t) {
            var arr = t.split(':');
            var dec = parseInt((arr[1] / 6) * 10, 10);

            return parseFloat(parseInt(arr[0], 10) + '.' + (dec < 10 ? '0' : '') + dec);
        }

        load();

    }

})();



(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('SubModuloDialogController', SubModuloDialogController);

    SubModuloDialogController.$inject = ['$timeout', '$scope', 'Modulo', '$uibModalInstance', 'entity', 'SubModulo', 'User', 'Cliente'];

    function SubModuloDialogController($timeout, $scope, Modulo, $uibModalInstance, entity, SubModulo, User, Cliente) {
        var vm = this;

        vm.subModulo = entity;
        vm.clear = clear;
        vm.save = save;
        vm.modulos = Modulo.query();
        vm.users = User.query({
            page: 0,
            size: 100
        });
        vm.clientes = Cliente.query({
            page: 0,
            size: 100
        });

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.subModulo.id !== null) {
                SubModulo.update(vm.subModulo, onSaveSuccess, onSaveError);
            } else {
                SubModulo.save(vm.subModulo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('chamadosApp:subModuloUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('subModulo', {
            parent: 'entity',
            url: '/sub-modulo?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'chamadosApp.subModulo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/submodulo/submodulo.html',
                    controller: 'SubModuloController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('subModulo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('subModulo.new', {
            parent: 'subModulo',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/submodulo/submodulo-dialog.html',
                    controller: 'SubModuloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                descricao: null,
                                projetoRedMine: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('subModulo', null, { reload: 'subModulo' });
                }, function() {
                    $state.go('subModulo');
                });
            }]
        })
        .state('subModulo.edit', {
            parent: 'subModulo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/submodulo/submodulo-dialog.html',
                    controller: 'SubModuloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['SubModulo', function(SubModulo) {
                            return SubModulo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('subModulo', null, { reload: 'subModulo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('SubModulo', SubModulo);

    SubModulo.$inject = ['$resource'];

    function SubModulo ($resource) {
        var resourceUrl =  'api/sub-modulos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByModulo': {
                url : 'api/sub-modulos-by-modulo-user/:id',
                method: 'GET',
                isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('SubModuloController', SubModuloController);

    SubModuloController.$inject = ['$scope', '$state', 'SubModulo', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Alerta'];

    function SubModuloController ($scope, $state, SubModulo, ParseLinks, AlertService, paginationConstants, pagingParams, Alerta) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.remover = remover;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            SubModulo.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.subModulos = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function remover(id) {
            Alerta.confirm("Atenção", "Tem certeza que deseja remover esse SubModulo?", "warning", function () {
                SubModulo.delete({id: id},
                    function () {
                        Alerta.success("Operação realizada", "O SubModulo foi removido!");
                        loadAll();
                    });
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('SprintDialogController', SprintDialogController);

    SprintDialogController.$inject = ['$timeout', '$scope', 'Cliente', '$uibModalInstance', 'entity', 'Sprint', 'Chamado'];

    function SprintDialogController($timeout, $scope, Cliente, $uibModalInstance, entity, Sprint, Chamado) {
        var vm = this;

        vm.sprint = entity;
        vm.clear = clear;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.save = save;
        vm.chamados = Chamado.query();

        carregarClientes();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.sprint.id !== null) {
                Sprint.update(vm.sprint, onSaveSuccess, onSaveError);
            } else {
                Sprint.save(vm.sprint, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('chamadosApp:sprintUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        vm.datePickerOpenStatus.inicio = false;
        vm.datePickerOpenStatus.fim = false;

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function indexCliente(cliente) {
            var j = -1;
            for (var i = 0; i < vm.sprint.clientes.length; i++) {
                var obj = vm.sprint.clientes[i];
                if (obj.cliente.id === cliente.id) {
                    j = i;
                }
            }
            return j;
        }

        function carregarClientes() {
            if (!vm.sprint.clientes) {
                vm.sprint.clientes = [];
            }
            Cliente.query({page: 0, size: 99}, function (clientes) {
                for (var i = 0; i < clientes.length; i++) {
                    var cliente = clientes[i];
                    if (indexCliente(cliente) < 0) {
                        vm.sprint.clientes.push({cliente: cliente, horasDisponiveis: cliente.horasDisponiveis})
                    }
                }
            })
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('SprintDetailController', SprintDetailController);

    SprintDetailController.$inject = ['$scope', '$rootScope', '$uibModal', 'Alerta', 'previousState', 'entity', 'Sprint', 'Chamado', '$state', 'SolicitacaoDesenvolvimento', 'Ata', 'Sistema', '$sce'];

    function SprintDetailController($scope, $rootScope, $uibModal, Alerta, previousState, entity, Sprint, Chamado, $state, SolicitacaoDesenvolvimento, Ata, Sistema, $sce) {
        var vm = this;

        vm.sprint = entity;
        vm.previousState = previousState.name;
        vm.horasPlanejadas = 0;
        vm.horasPlanejadasSprintAberta = 0;
        vm.tempos = {};
        vm.tempoTotalGasto = 0;
        vm.modulosSprintAndamento = [];
        vm.modulosSprintAberta = [];
        vm.encerrarSprint = encerrarSprint;
        vm.criarPlanejamento = criarPlanejamento;
        vm.criarEncerramento = criarEncerramento;
        vm.criarReuniaoDiaria = criarReuniaoDiaria;

        var unsubscribe = $rootScope.$on('chamadosApp:sprintUpdate', function (event, result) {
            vm.sprint = result;
        });
        $scope.$on('$destroy', unsubscribe);


        function buildBashboardUrl() {
            var dashBoardUrl = "https://dashboard.webpublico.app.br/public/dashboard/6284eb5c-8fe2-419c-bb48-f2fc985570e9?sprint="+vm.sprint.id;
            vm.dashBoardUrl = $sce.trustAsResourceUrl(dashBoardUrl);
        }

        function findModuloIndex(modulos, moduloId) {
            var index = -1;
            angular.forEach(modulos, function (modulo, ind) {
                if (modulo.modulo.id === moduloId) {
                    index = ind;
                }
            });
            return index;
        }

        function ensureModulo(modulos, modulo, comExtrasAberta) {
            var index = findModuloIndex(modulos, modulo.id);
            if (index < 0) {
                var novoModulo = {
                    modulo: modulo,
                    chamadosAFazer: 0,
                    chamadosFazendo: 0,
                    chamadosEntregues: 0
                };
                if (comExtrasAberta) {
                    novoModulo.tempoEstimado = 0;
                    novoModulo.chamadosSemTarefas = [];
                }
                modulos.push(novoModulo);
                index = modulos.indexOf(novoModulo);
            }
            return index;
        }

        function processarChamadosAndamento(chamados) {
            vm.sprint.chamados = chamados;
            vm.sprint.horasDisponiveis = 0;

            angular.forEach(vm.sprint.clientes, function (cliente) {
                vm.sprint.horasDisponiveis = vm.sprint.horasDisponiveis + cliente.horasDisponiveis;
            });

            angular.forEach(chamados, function (chamado) {
                var index = ensureModulo(vm.modulosSprintAndamento, chamado.modulo, false);

                if (chamado.situacao === 'EM_DESENVOLVIMENTO') {
                    vm.modulosSprintAndamento[index].chamadosFazendo = vm.modulosSprintAndamento[index].chamadosFazendo + 1;
                }

                if (chamado.situacao !== 'EM_DESENVOLVIMENTO') {
                    vm.modulosSprintAndamento[index].chamadosEntregues = vm.modulosSprintAndamento[index].chamadosEntregues + 1;
                }

                Chamado.getSolicitacoes({id: chamado.id}, function (solicitacoes) {
                    chamado.solicitacoes = solicitacoes;

                    angular.forEach(solicitacoes, function (sol) {
                        if (sol.situacao === 'A_FAZER' && chamado.situacao === 'EM_DESENVOLVIMENTO') {
                            vm.modulosSprintAndamento[index].chamadosAFazer = vm.modulosSprintAndamento[index].chamadosAFazer + 1;
                        }

                        SolicitacaoDesenvolvimento.getTempoGastoByTicket({id: sol.id}, function (data) {
                            adicionarTempo(data);
                        });
                    });
                });

                vm.horasPlanejadas = vm.horasPlanejadas + (chamado.tempoEstimado || 0);
            });
        }

        function processarTarefasAndamento(tarefas) {
            vm.sprint.tarefas = tarefas;
            vm.sprint.horasDisponiveis = 0;

            angular.forEach(vm.sprint.clientes, function (cliente) {
                vm.sprint.horasDisponiveis = vm.sprint.horasDisponiveis + cliente.horasDisponiveis;
            });

            angular.forEach(tarefas, function (tarefa) {
                var chamado = tarefa.chamado || {};
                var modulo = tarefa.modulo || chamado.modulo;
                if (!modulo) {
                    return;
                }
                var index = ensureModulo(vm.modulosSprintAndamento, modulo, false);
                var situacao = chamado.situacao;

                if (situacao === 'EM_DESENVOLVIMENTO') {
                    vm.modulosSprintAndamento[index].chamadosFazendo = vm.modulosSprintAndamento[index].chamadosFazendo + 1;
                } else if (situacao) {
                    vm.modulosSprintAndamento[index].chamadosEntregues = vm.modulosSprintAndamento[index].chamadosEntregues + 1;
                }

                if (tarefa.situacao === 'A_FAZER' && situacao === 'EM_DESENVOLVIMENTO') {
                    vm.modulosSprintAndamento[index].chamadosAFazer = vm.modulosSprintAndamento[index].chamadosAFazer + 1;
                }

                SolicitacaoDesenvolvimento.getTempoGastoByTicket({id: tarefa.id}, function (data) {
                    adicionarTempo(data);
                });

                vm.horasPlanejadas = vm.horasPlanejadas + (Number(tarefa.tempoEstimado) || 0);
            });
        }

        function processarTarefasAberta(aberta, tarefas) {
            aberta.tarefas = tarefas;
            vm.sprintAberta = aberta;
            vm.sprintAberta.horasDisponiveis = 0;

            angular.forEach(vm.sprintAberta.clientes, function (cliente) {
                vm.sprintAberta.horasDisponiveis = vm.sprintAberta.horasDisponiveis + cliente.horasDisponiveis;
            });

            angular.forEach(tarefas, function (tarefa) {
                var chamado = tarefa.chamado || {};
                var modulo = tarefa.modulo || chamado.modulo;
                if (!modulo) {
                    return;
                }
                var index = ensureModulo(vm.modulosSprintAberta, modulo, true);
                var situacao = chamado.situacao;

                vm.modulosSprintAberta[index].tempoEstimado =
                    vm.modulosSprintAberta[index].tempoEstimado + (Number(tarefa.tempoEstimado) || 0);

                if (situacao === 'AGUARDANDO_DESENVOLVIMENTO' || situacao === 'EM_ANALISE' || situacao === 'EM_ANALISE_DESENVOLVIMENTO') {
                    vm.modulosSprintAberta[index].chamadosAFazer = vm.modulosSprintAberta[index].chamadosAFazer + 1;
                } else if (situacao) {
                    vm.modulosSprintAberta[index].chamadosEntregues = vm.modulosSprintAberta[index].chamadosEntregues + 1;
                }
                if (situacao === 'EM_DESENVOLVIMENTO') {
                    vm.modulosSprintAberta[index].chamadosFazendo = vm.modulosSprintAberta[index].chamadosFazendo + 1;
                }

                vm.horasPlanejadasSprintAberta = vm.horasPlanejadasSprintAberta + (Number(tarefa.tempoEstimado) || 0);
            });
        }

        function loadChamados() {

            vm.chamado = {sprint: vm.sprint};
            Chamado.queryByFiltro(vm.chamado, function (data) {
                vm.chamados = data;
            });


            Sistema.getByUser({}, function (data) {
                vm.sistemas = data;

                angular.forEach(vm.sistemas, function (sistema) {
                    // FECHADA: histórico ainda em chamado.sprint; ABERTA/EM_ANDAMENTO: sprint na tarefa
                    if (vm.sprint.situacao === 'FECHADA') {
                        Chamado.queryBySprint({sprintId: vm.sprint.id, sistemaId: sistema.id}, function (chamados) {
                            processarChamadosAndamento(chamados);
                        });
                    } else {
                        SolicitacaoDesenvolvimento.queryBySprintSistema({
                            sprintId: vm.sprint.id,
                            sistemaId: sistema.id
                        }, function (tarefas) {
                            processarTarefasAndamento(tarefas);
                        });
                    }
                });

                angular.forEach(vm.sistemas, function (sistema) {
                    Sprint.getBySituacao({situacao: 'ABERTA'}, function (aberta) {
                        SolicitacaoDesenvolvimento.queryBySprintSistema({
                            sprintId: aberta.id,
                            sistemaId: sistema.id
                        }, function (tarefas) {
                            processarTarefasAberta(aberta, tarefas);
                        });
                    });
                });

            });

        }

        loadChamados();
        buildBashboardUrl();

        function confirmEncerrar() {
            Sprint.encerrar(vm.sprint, function (data) {
                Alerta.success("Operação realizada", "A Sprint foi encerrada!")
                $state.go('sprint')
            }, function error(error) {
                Alerta.error("Operação Não realizada", "Tente novamente!")
            });
        }

        function cancel() {
            //Alerta.success("Operação NÃO Realizada", "")
        }


        function encerrarSprint() {
            Alerta.confirm("Atenção!",
                "Você tem certeza que deseja encerrar a Srpint " + vm.sprint.descricao + "?",
                "warning",
                confirmEncerrar, cancel);
        }

        function criarPlanejamento(sprint) {
            Ata.criarPlanejamento(sprint, function (data) {
                $state.reload(true);
            });
        }

        function criarEncerramento(sprint) {
            Ata.criarEncerramento(sprint, function (data) {
                $state.reload(true);
            });
        }

        function criarReuniaoDiaria(sprint) {
            Ata.criarReuniaoDiaria(sprint, function (data) {
                $state.reload(true);
            });
        }

        function adicionarTempo(data) {
            angular.forEach(data, function (tempo) {
                vm.tempoTotalGasto = vm.tempoTotalGasto + tempo.tempo;
                if (!vm.tempos[tempo.tipo]) {
                    vm.tempos[tempo.tipo] = {
                        tipo: tempo.tipo,
                        tempo: tempo.tempo
                    };
                } else {
                    vm.tempos[tempo.tipo].tempo = vm.tempos[tempo.tipo].tempo + tempo.tempo;
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('SprintDeleteController',SprintDeleteController);

    SprintDeleteController.$inject = ['$uibModalInstance', 'entity', 'Sprint'];

    function SprintDeleteController($uibModalInstance, entity, Sprint) {
        var vm = this;

        vm.sprint = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Sprint.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('sprint', {
            parent: 'entity',
            url: '/ciclo?page&sort&search',
            data: {
                authorities: ['ROLE_DESENVOLVEDOR', 'ROLE_PO', 'ROLE_SCRUM', 'ROLE_ATENDENTE'],
                pageTitle: 'chamadosApp.sprint.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sprint/sprints.html',
                    controller: 'SprintController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sprint');
                    $translatePartialLoader.addPart('situacaoSprint');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('sprint-detail', {
            parent: 'sprint',
            url: '/ciclo/{id}',
            data: {
                authorities: ['ROLE_DESENVOLVEDOR', 'ROLE_PO', 'ROLE_SCRUM', 'ROLE_ATENDENTE'],
                pageTitle: 'chamadosApp.sprint.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/sprint/sprint-detail.html',
                    controller: 'SprintDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sprint');
                    $translatePartialLoader.addPart('chamado');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('situacaoSprint');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'Sprint', function($stateParams, Sprint) {
                    return Sprint.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'sprint',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('sprint-detail.edit', {
            parent: 'sprint-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_DESENVOLVEDOR', 'ROLE_PO', 'ROLE_SCRUM', 'ROLE_ATENDENTE']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sprint/sprint-dialog.html',
                    controller: 'SprintDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Sprint', function(Sprint) {
                            return Sprint.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sprint.new', {
            parent: 'sprint',
            url: '/new',
            data: {
                authorities: ['ROLE_SCRUM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sprint/sprint-dialog.html',
                    controller: 'SprintDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                inicio: null,
                                fim: null,
                                descricao: null,
                                situacao: null,
                                horasDisponiveis: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('sprint', null, { reload: 'sprint' });
                }, function() {
                    $state.go('sprint');
                });
            }]
        })
        .state('sprint.edit', {
            parent: 'sprint',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_SCRUM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sprint/sprint-dialog.html',
                    controller: 'SprintDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Sprint', function(Sprint) {
                            return Sprint.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sprint', null, { reload: 'sprint' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('sprint.delete', {
            parent: 'sprint',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_SCRUM']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/sprint/sprint-delete-dialog.html',
                    controller: 'SprintDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['Sprint', function(Sprint) {
                            return Sprint.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('sprint', null, { reload: 'sprint' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('Sprint', Sprint);

    Sprint.$inject = ['$resource', 'DateUtils'];

    function Sprint($resource, DateUtils) {
        var resourceUrl = 'api/sprints/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.inicio = DateUtils.convertLocalDateFromServer(data.inicio);
                        data.fim = DateUtils.convertLocalDateFromServer(data.fim);
                    }
                    return data;
                }
            },
            'getBySituacao': {
                url: '/api/sprint-by-situacao/:situacao',
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.inicio = DateUtils.convertLocalDateFromServer(data.inicio);
                        data.fim = DateUtils.convertLocalDateFromServer(data.fim);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.inicio = DateUtils.convertLocalDateToServer(copy.inicio);
                    copy.fim = DateUtils.convertLocalDateToServer(copy.fim);
                    return angular.toJson(copy);
                }
            },
            'encerrar': {
                method: 'PUT',
                url: '/api/sprints-encerramento',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.inicio = DateUtils.convertLocalDateToServer(copy.inicio);
                    copy.fim = DateUtils.convertLocalDateToServer(copy.fim);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.inicio = DateUtils.convertLocalDateToServer(copy.inicio);
                    copy.fim = DateUtils.convertLocalDateToServer(copy.fim);
                    return angular.toJson(copy);
                }
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('SprintController', SprintController);

    SprintController.$inject = ['$scope', '$state', 'Sprint', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function SprintController ($scope, $state, Sprint, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Sprint.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sprints = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('SolicitanteDialogController', SolicitanteDialogController);

    SolicitanteDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Cliente', 'Solicitante', 'User', 'Principal'];

    function SolicitanteDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Cliente, Solicitante, User, Principal) {
        var vm = this;

        vm.solicitante = entity;
        vm.clear = clear;
        vm.save = save;

        getAccount();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;

                Cliente.getByUser({}, function (data) {
                    vm.clientes = data;
                })

            });
        }

        function save() {
            vm.isSaving = true;
            if (vm.solicitante.id !== null) {
                Solicitante.update(vm.solicitante, onSaveSuccess, onSaveError);
            } else {
                Solicitante.save(vm.solicitante, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('chamadosApp:solicitanteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('solicitante', {
            parent: 'entity',
            url: '/solicitante?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'chamadosApp.solicitante.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/solicitante/solicitantes.html',
                    controller: 'SolicitanteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('solicitante');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('solicitante.new', {
            parent: 'solicitante',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/solicitante/solicitante-dialog.html',
                    controller: 'SolicitanteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                projetoRedMine: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('solicitante', null, { reload: 'solicitante' });
                }, function() {
                    $state.go('solicitante');
                });
            }]
        })
        .state('solicitante.edit', {
            parent: 'solicitante',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/solicitante/solicitante-dialog.html',
                    controller: 'SolicitanteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Solicitante', function(Solicitante) {
                            return Solicitante.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('solicitante', null, { reload: 'solicitante' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }

})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('Solicitante', Solicitante);

    Solicitante.$inject = ['$resource'];

    function Solicitante($resource) {
        var resourceUrl = 'api/solicitantes/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'getByCliente': {url: "api/solicitantes-by-cliente/:clienteId", method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('SolicitanteController', SolicitanteController);

    SolicitanteController.$inject = ['$scope', '$state', 'Solicitante', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Alerta'];

    function SolicitanteController ($scope, $state, Solicitante, ParseLinks, AlertService, paginationConstants, pagingParams, Alerta) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.remover = remover;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Solicitante.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.solicitantes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function remover(id) {
            Alerta.confirm("Atenção", "Tem certeza que deseja remover esse solicitante?", "warning", function () {
                Solicitante.delete({id: id},
                    function () {
                        Alerta.success("Operação realizada", "O solicitante foi removido!");
                        loadAll();
                    });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('SolicitacaoDesenvolvimentoImportarController', SolicitacaoDesenvolvimentoImportarController);

    SolicitacaoDesenvolvimentoImportarController.$inject = ['$timeout', '$scope', '$stateParams', '$state', '$uibModalInstance',
        'entity', 'SolicitacaoDesenvolvimento', 'User', 'Sistema', 'Principal', 'Cliente', 'Modulo', 'SubModulo'];

    function SolicitacaoDesenvolvimentoImportarController($timeout, $scope, $stateParams, $state, $uibModalInstance,
                                                      entity, SolicitacaoDesenvolvimento, User, Sistema,
                                                      Principal, Cliente, Modulo, SubModulo) {
        var vm = this;

        vm.solicitacaoDesenvolvimento = entity;
        vm.clear = clear;
        vm.save = save;
        vm.carregarSistemas = carregarSistemas;
        vm.carregarSubModulo = carregarSubModulo;
        vm.modulos = Modulo.queryByUser();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;

            SolicitacaoDesenvolvimento.importarRedmine(vm.solicitacaoDesenvolvimento, onSaveSuccess, onSaveError);

        }

        function onSaveSuccess(result) {
            $scope.$emit('chamadosApp:solicitacaoDesenvolvimentoUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                vm.solicitacaoDesenvolvimento.solicitante = vm.account;
                Cliente.getByUser({}, function (data) {
                    vm.clientes = data;
                    vm.solicitacaoDesenvolvimento.cliente = data[0];
                    carregarSistemas();

                })

            });
        }

        function carregarSistemas() {
            if (vm.solicitacaoDesenvolvimento.cliente) {
                Sistema.getByCliente({clienteId: vm.solicitacaoDesenvolvimento.cliente.id}, function (data) {
                    vm.sistemas = data;
                    vm.solicitacaoDesenvolvimento.sistema = data[0];

                })
            } else {
                vm.sistemas = [];
            }
        }

        function carregarSubModulo() {
            if (vm.solicitacaoDesenvolvimento.modulo) {
                vm.submodulos = SubModulo.queryByModulo({id: vm.solicitacaoDesenvolvimento.modulo.id});
            }
        }

        getAccount();

    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('SolicitacaoDesenvolvimentoEditController', SolicitacaoDesenvolvimentoEditController);

    SolicitacaoDesenvolvimentoEditController.$inject = ['$timeout', '$scope', '$stateParams', '$state', 'entity',
        'SolicitacaoDesenvolvimento', 'User', 'Sistema', 'Principal', 'Cliente', 'Modulo', 'SubModulo', 'Sprint'];

    function SolicitacaoDesenvolvimentoEditController($timeout, $scope, $stateParams, $state, entity,
                                                      SolicitacaoDesenvolvimento, User, Sistema, Principal,
                                                      Cliente, Modulo, SubModulo, Sprint) {
        var vm = this;

        vm.solicitacaoDesenvolvimento = entity;
        vm.save = save;
        vm.carregarSistemas = carregarSistemas;
        vm.carregarSubModulo = carregarSubModulo;
        vm.encerraChamado = encerraChamado;
        vm.modulos = Modulo.queryByUser();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function encerraChamado(encerra) {
            vm.solicitacaoDesenvolvimento.chamado.situacao = encerra? 'FECHADO': 'EM_DESENVOLVIMENTO';
        }

        function save() {
            vm.isSaving = true;
            if (vm.solicitacaoDesenvolvimento.id !== null) {
                SolicitacaoDesenvolvimento.update(vm.solicitacaoDesenvolvimento, onSaveSuccess, onSaveError);
            } else {
                SolicitacaoDesenvolvimento.save(vm.solicitacaoDesenvolvimento, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(data) {
            if (data && data.id) {
                vm.isSaving = false;
                $state.go("solicitacaoDesenvolvimento.detail", {id: data.id});
            } else {
                vm.isSaving = false;
                $state.go("scrumboard");
            }

        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                vm.solicitacaoDesenvolvimento.solicitante = vm.account;
                Cliente.getByUser({}, function (data) {
                    vm.clientes = data;
                    if (vm.solicitacaoDesenvolvimento.sistema) {
                        for (var i = 0; i < data.length; i++) {
                            if (vm.solicitacaoDesenvolvimento.cliente.id === data[i].id) {
                                vm.solicitacaoDesenvolvimento.cliente = data[i];
                            }
                        }
                    } else {
                        vm.solicitacaoDesenvolvimento.cliente = data[0];
                    }
                    carregarSistemas();

                })

            });
        }

        function carregarSistemas() {
            if (vm.solicitacaoDesenvolvimento.cliente) {
                Sistema.getByCliente({clienteId: vm.solicitacaoDesenvolvimento.cliente.id}, function (data) {
                    vm.sistemas = data;
                    if (vm.solicitacaoDesenvolvimento.sistema) {
                        for (var i = 0; i < data.length; i++) {
                            if (vm.solicitacaoDesenvolvimento.sistema.id === data[i].id) {
                                vm.solicitacaoDesenvolvimento.sistema = data[i];
                            }
                        }
                    } else {
                        vm.solicitacaoDesenvolvimento.sistema = data[0];
                    }
                })
            } else {
                vm.sistemas = [];
            }
        }

        function carregarSubModulo() {
            if (vm.solicitacaoDesenvolvimento.modulo) {
                vm.submodulos = SubModulo.queryByModulo({id: vm.solicitacaoDesenvolvimento.modulo.id});
            }
        }

        function carregarSprint() {
            Sprint.query({}, function (data) {
                vm.sprints = data;
                if (!vm.solicitacaoDesenvolvimento.sprint) {
                    for (var i = 0; i < vm.sprints.length; i++) {
                        if (vm.sprints[i].situacao === 'EM_ANDAMENTO')
                            vm.solicitacaoDesenvolvimento.sprint = vm.sprints[i];
                    }
                }

            });

        }

        getAccount();
        carregarSubModulo();
        carregarSprint();
    }
})();

(function () {
        'use strict';

        angular
            .module('chamadosApp')
            .controller('SolicitacaoDesenvolvimentoDetailController', SolicitacaoDesenvolvimentoDetailController);

        SolicitacaoDesenvolvimentoDetailController.$inject = ['$timeout', '$scope', '$stateParams', 'entity',
            'SolicitacaoDesenvolvimento', '$state', 'Sprint', 'Principal', 'Account',
            '$sanitize', 'AnexoChamado', '$http', 'Upload', 'Chamado', '$uibModal', '$filter', 'FeedBack', 'Alerta'];

        function SolicitacaoDesenvolvimentoDetailController($timeout, $scope, $stateParams, entity,
                                                            SolicitacaoDesenvolvimento, $state, Sprint, Principal, Account,
                                                            $sanitize, AnexoChamado, $http, Upload, Chamado, $uibModal, $filter, FeedBack, Alerta) {
            var vm = this;
            vm.solicitacaoDesenvolvimento = entity;
            vm.atribuirTarefa = atribuirTarefa;
            vm.desatribuirTarefa = desatribuirTarefa;
            vm.alterarResponsavel = alterarResponsavel;
            vm.alterarSituacao = alterarSituacao;
            vm.avancarTarefa = avancarTarefa;
            vm.alocarTarefa = alocarTarefa;
            vm.desalocarTarefa = desalocarTarefa;
            vm.save = save;
            vm.adicionarRepositorio = adicionarRepositorio;
            vm.criarFeedback = criarFeedback;
            vm.carregarRepositorio = carregarRepositorio;
            vm.carregarComentarios = carregarComentarios;
            vm.comentar = comentar;
            vm.trustAsHtml = trustAsHtml;
            vm.upload = upload;
            vm.downloadAnexo = downloadAnexo;
            vm.reload = reload;
            vm.calcularPercentualTempo = calcularPercentualTempo;
            vm.diffHour = diffHour;
            vm.sincronizarGit = sincronizarGit;

            vm.comentario = {};
            vm.comentarios = [];
            vm.isSaving = false;
            vm.agrupadorSituacao = {};
            vm.labelsSituacao = []
            vm.dataSituacao = [];

            $timeout(function () {
                angular.element('.form-group:eq(1)>input').focus();
            });

            Sprint.getBySituacao({situacao: 'EM_ANDAMENTO'}, function (aberta) {
                vm.sprint = aberta;
            });

            Principal.identity().then(function (account) {
                vm.account = account;
            });


            function downloadAnexo(index) {
                var anexo = vm.anexos[index];
                AnexoChamado.downloadAnexo(anexo);
            }

            function atribuirTarefa() {
                vm.isSaving = true;
                SolicitacaoDesenvolvimento.atribuir(vm.solicitacaoDesenvolvimento, onSaveSuccess, onSaveError);
            }

            function desatribuirTarefa() {
                vm.isSaving = true;
                SolicitacaoDesenvolvimento.dasatribuir(vm.solicitacaoDesenvolvimento, onSaveSuccess, onSaveError);
            }

            function alterarResponsavel() {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/entities/solicitacaodesenvolvimento/alterar-responsavel.html',
                    controller: 'AlterarResponsavelTarefaController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'md',
                    resolve: {
                        solicitacaoDesenvolvimento: function () {
                            return SolicitacaoDesenvolvimento.get({id: vm.solicitacaoDesenvolvimento.id}).$promise;
                        }
                    }
                });

                modalInstance.result.then(function (result) {
                    $scope.$emit('chamadosApp:solicitacaoDesenvolvimentoUpdate', result);
                    $state.reload();
                });
            }

            function alocarTarefa() {
                vm.isSaving = true;
                SolicitacaoDesenvolvimento.alocar(vm.solicitacaoDesenvolvimento, onSaveSuccess, onSaveError);
            }

            function desalocarTarefa() {
                vm.isSaving = true;
                vm.solicitacaoDesenvolvimento.sprint = null;
                SolicitacaoDesenvolvimento.update(vm.solicitacaoDesenvolvimento, onSaveSuccess, onSaveError);
            }

            function save() {
                vm.isSaving = true;
                SolicitacaoDesenvolvimento.update(vm.solicitacaoDesenvolvimento, onSaveSuccess, onSaveError);
            }

            function avancarTarefa() {
                vm.isSaving = true;
                vm.editTarefa = false;
                SolicitacaoDesenvolvimento.avancar(vm.solicitacaoDesenvolvimento, onSaveSuccess, onSaveError);
            }

            function reload() {
                $state.reload();
            }

            function onSaveSuccess(result) {
                vm.solicitacaoDesenvolvimento = result;
                vm.isSaving = false;
                vm.editTarefa = false;
                $scope.$emit('chamadosApp:solicitacaoDesenvolvimentoUpdate', result);
                $state.reload();
            }

            function onSaveError() {
                vm.isSaving = false;
            }

            function carregarComentarios() {
                if (vm.solicitacaoDesenvolvimento.id) {
                    SolicitacaoDesenvolvimento.getComentarios({id: vm.solicitacaoDesenvolvimento.id}, function (data) {
                        vm.comentarios = data;
                        angular.forEach(vm.comentarios, function (comentario) {
                            Account.getImagemAjustadaByLogin({login: comentario.usuario.login}, function (data) {
                                comentario.imagemUsuario = data.imagemAjustada;
                            });
                        })
                    });
                }
            }

            function carregarHistorico() {
                if (vm.solicitacaoDesenvolvimento.id) {
                    SolicitacaoDesenvolvimento.getStatusBySolicitacao({id: vm.solicitacaoDesenvolvimento.id}, function (data) {
                        vm.historicos = data;
                        vm.agrupadorSituacao = {};
                        vm.labelsSituacao = []
                        vm.dataSituacao = [];
                        for (var i = 0; i < vm.historicos.length; i++) {
                            var historico = vm.historicos[i];
                            if (!vm.agrupadorSituacao[historico.situacao]) {
                                vm.agrupadorSituacao[historico.situacao] = {situacao: historico.situacao, dados: []};
                                vm.labelsSituacao.push(historico.situacao);
                                vm.dataSituacao.push(0);
                            }
                            historico.horas = Math.abs(historico.inicio - (historico.fim ? historico.fim : new Date())) / 36e5;
                            vm.agrupadorSituacao[historico.situacao].dados.push(historico);
                        }
                        for (var x = 0; x < vm.labelsSituacao.length; x++) {
                            var situacao = vm.labelsSituacao[x];
                            for (var j = 0; j < vm.agrupadorSituacao[situacao].dados.length; j++) {
                                vm.dataSituacao[j] =
                                    vm.dataSituacao[j] + vm.agrupadorSituacao[situacao].dados[j].horas;
                            }
                        }
                        console.log(vm.labelsSituacao);
                        console.log(vm.dataSituacao);

                    });
                }
            }

            function diffHour(historico) {
                var date1 = historico.inicio;
                var date2 = historico.fim;
                if (!date1) {
                    date1 = new Date();
                }
                if (!date2) {
                    date2 = new Date();
                }
                var diffMs = (date2 - date1); // milliseconds between now & Christmas
                var diffDays = Math.floor(diffMs / 86400000); // days
                var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
                var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
                if (diffDays) {
                    return diffDays + " dia(s), " + diffHrs + " hora(s) e " + diffMins + " minuto(s).";
                }
                if (diffHrs) {
                    return diffHrs + " hora(s) e " + diffMins + " minuto(s).";
                }
                if (diffMins) {
                    return diffMins + " minuto(s).";
                }
                return diffHrs;
            }


            function comentar() {
                vm.isSaving = true;
                vm.comentario.solicitacaoDesenvolvimento = vm.solicitacaoDesenvolvimento;
                vm.comentario.usuario = vm.account;
                SolicitacaoDesenvolvimento.comentarSolicitacao(vm.comentario, function () {
                    vm.comentario = {solicitacaoDesenvolvimento: vm.solicitacaoDesenvolvimento, usuario: vm.account};
                    carregarComentarios();
                    vm.isSaving = false;
                }, onSaveError);
            }

            function trustAsHtml(value) {
                return $sanitize(value);
            }

            function carregarAnexos() {
                vm.anexos = vm.solicitacaoDesenvolvimento.chamado ? AnexoChamado.query({id: vm.solicitacaoDesenvolvimento.chamado.id}) : [];
            }

            function carregarSituacoes() {
                vm.situacoes = SolicitacaoDesenvolvimento.getSituacoePossiveis({situacao: vm.solicitacaoDesenvolvimento.situacao})
            }

            function upload($file) {
                if ($file) {
                    if (!vm.anexos) {
                        vm.anexos = [];
                    }
                    Upload.dataUrl($file, true).then(
                        function (conteudo) {
                            var anexo = {};
                            anexo.descricao = $file.name;
                            anexo.conteudo = conteudo;
                            anexo.mimeType = $file.type;
                            if (vm.solicitacaoDesenvolvimento.chamado.id) {
                                anexo.chamado = vm.solicitacaoDesenvolvimento.chamado;
                                anexo.tipo = 'INTERNO';
                                AnexoChamado.save(anexo, function (data) {
                                    vm.anexos.push(data);
                                });
                            }
                        }
                    );
                } else {
                    Alerta.warn("Atenção!", "Você deve selecionar um arquivo de até 100Mb");
                }
            }

            function contarTempoGasto() {
                SolicitacaoDesenvolvimento.getTempoGastoByTicket({id: vm.solicitacaoDesenvolvimento.id}, function (data) {
                    adicionarTempo(data);
                });
            }

            function adicionarTempo(data) {
                vm.tempos = {};
                vm.horasApontadas = data;
                vm.tempoTotalGasto = 0;
                angular.forEach(data, function (tempo) {
                    vm.tempoTotalGasto = vm.tempoTotalGasto + tempo.tempo;
                    if (!vm.tempos[tempo.tipo]) {
                        vm.tempos[tempo.tipo] = {
                            tipo: tempo.tipo ? $filter('translate')('chamadosApp.TipoHora.' + tempo.tipo) : tempo.conteudo,
                            tempo: tempo.tempo
                        };
                    } else {
                        vm.tempos[tempo.tipo].tempo = vm.tempos[tempo.tipo].tempo + tempo.tempo;
                    }
                });
            }

            function calcularPercentualTempo() {
                if (vm.tempoTotalGasto && vm.solicitacaoDesenvolvimento.tempoEstimado) {
                    var number = (vm.tempoTotalGasto * 100) / vm.solicitacaoDesenvolvimento.tempoEstimado;
                    return number > 100 ? 100 : number;
                }
                return 0;
            }

            function sincronizarGit() {
                SolicitacaoDesenvolvimento.sincronizarGit({id: vm.solicitacaoDesenvolvimento.id}, carregarBranches);
            }


            function alterarSituacao() {
                var modalInstance = $uibModal.open({
                    templateUrl: 'app/entities/solicitacaodesenvolvimento/alterar-situacao.html',
                    controller: 'AlterarSituacaoTarefaController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        solicitacaoDesenvolvimento: function () {
                            return SolicitacaoDesenvolvimento.get({id: vm.solicitacaoDesenvolvimento.id}).$promise;
                        },
                        tempoGasto: function () {
                            var tempoGasto = {criadoEm: new Date(), tipo: 'DESENVOLVIMENTO', horas: 0, minutos: 0};
                            if (vm.solicitacaoDesenvolvimento.tipo === 'BUG') {
                                tempoGasto.tipo = "CORRECAO";
                            }
                            return tempoGasto;
                        }
                    }
                });

                modalInstance.result.then(function (result) {
                    $scope.$emit('chamadosApp:solicitacaoDesenvolvimentoUpdate', result);
                    $state.reload();
                });
            }

            function carregarBranches() {
                vm.branches = SolicitacaoDesenvolvimento.getBranches({id: vm.solicitacaoDesenvolvimento.id});
            }

            function carregarRepositorio() {
                vm.projetos = SolicitacaoDesenvolvimento.getGitRepositories();
                vm.vaiAddRepositorio = true;
                carregarBranches();
            }

            function adicionarRepositorio() {
                if (!vm.solicitacaoDesenvolvimento.projetosGit) {
                    vm.solicitacaoDesenvolvimento.projetosGit = [];
                }
                vm.solicitacaoDesenvolvimento.projetosGit
                    .push({
                        projetoGit: vm.projetoGit.key,
                        repositorioGit: vm.repositorioGit.name
                    })
                vm.projetoGit = {};
                vm.vaiAddRepositorio = false;
                save();
            }

            function carregarFotoSolicitante() {
                if (vm.solicitacaoDesenvolvimento.responsavel) {
                    Account.getImagemAjustadaByLogin({login: vm.solicitacaoDesenvolvimento.responsavel.login}, function (data) {
                        vm.fotoSolicitante = data.imagemAjustada;
                    });
                }
            }

            carregarComentarios();
            carregarAnexos();
            carregarSituacoes();
            carregarBranches();
            contarTempoGasto();
            carregarHistorico();
            carregarFotoSolicitante();


            function criarFeedback() {
                var modalInstance = $uibModal.open({
                    size: 'lg',
                    animation: true,
                    templateUrl: 'feedbackContent.html',
                    controller: 'FeedBackChamadoController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    resolve: {
                        feedBack: {chamado: vm.solicitacaoDesenvolvimento.chamado}
                    }
                });
                modalInstance.result.then(function (feedBack) {
                    FeedBack.save(feedBack, function (data) {
                        vm.feedBack = data;
                        Alerta.success("Obrigado...", "Feedback salvo com sucesso!");
                    })
                });
            }
        }

    }

)
();

angular
    .module('chamadosApp')
    .controller('FeedBackChamadoController', FeedBackChamadoController);

FeedBackChamadoController.$inject = ['$uibModalInstance', 'feedBack'];


function FeedBackChamadoController($uibModalInstance, feedBack) {
    var vm = this;
    vm.feedBack = feedBack;

    vm.ok = function () {
        vm.isSaving = true;
        vm.feedBack.criadoEm = new Date();
        $uibModalInstance.close(vm.feedBack);
    };

};

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('solicitacaoDesenvolvimento', {
                parent: 'entity',
                url: '/tarefa?page&sort&search',
                data: {
                    authorities: ['ROLE_DESENVOLVEDOR', 'ROLE_PO', 'ROLE_SCRUM', 'ROLE_ATENDENTE'],
                    pageTitle: 'chamadosApp.solicitacaoDesenvolvimento.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/solicitacaodesenvolvimento/solicitacaodesenvolvimento.html',
                        controller: 'SolicitacaoDesenvolvimentoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('situacaoTarefa');
                        $translatePartialLoader.addPart('tipoHora');
                        return $translate.refresh();
                    }]
                }
            })
            .state('solicitacaoDesenvolvimento.new', {
                parent: 'solicitacaoDesenvolvimento',
                url: 'new',
                data: {
                    authorities: ['ROLE_PO', 'ROLE_DESENVOLVEDOR', 'ROLE_SCRUM']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/solicitacaodesenvolvimento/solicitacaodesenvolvimento-edit.html',
                        controller: 'SolicitacaoDesenvolvimentoEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {situacao: 'A_FAZER', chamado: {situacao: 'EM_DESENVOLVIMENTO'}};
                    },
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('tipoHora');
                        return $translate.refresh();
                    }]
                }
            })
            .state('solicitacaoDesenvolvimento.edit', {
                parent: 'solicitacaoDesenvolvimento',
                url: 'tarefa/{id}/edit',
                data: {
                    authorities: ['ROLE_PO', 'ROLE_SCRUM'],
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/solicitacaodesenvolvimento/solicitacaodesenvolvimento-edit.html',
                        controller: 'SolicitacaoDesenvolvimentoEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'SolicitacaoDesenvolvimento', function ($stateParams, SolicitacaoDesenvolvimento) {
                        return SolicitacaoDesenvolvimento.get({id: $stateParams.id}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('tipoHora');
                        return $translate.refresh();
                    }]

                }
            })
            .state('solicitacaoDesenvolvimento.detail', {
                parent: 'solicitacaoDesenvolvimento',
                url: '/{id}/detail',
                data: {
                    authorities: ['ROLE_DESENVOLVEDOR', 'ROLE_PO', 'ROLE_SCRUM', 'ROLE_ATENDENTE'],
                },
                ncyBreadcrumb: {
                    label: 'Tarefa'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/solicitacaodesenvolvimento/solicitacaodesenvolvimento-detail.html',
                        controller: 'SolicitacaoDesenvolvimentoDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'SolicitacaoDesenvolvimento', function ($stateParams, SolicitacaoDesenvolvimento) {
                        return SolicitacaoDesenvolvimento.get({id: $stateParams.id}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('tipoHora');
                        $translatePartialLoader.addPart('complexidadeChamado');
                        return $translate.refresh();
                    }]

                }
            })
            .state('solicitacaoDesenvolvimento.importar', {
                parent: 'entity',
                url: '/importar',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/solicitacaodesenvolvimento/solicitacaodesenvolvimento-importar.html',
                        controller: 'SolicitacaoDesenvolvimentoImportarController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    tipo: 'HISTORIA',
                                    situacao: 'A_FAZER',
                                    id: null
                                };
                            }
                        }
                    }).result.then(function (result) {
                        if (result && result.id) {
                            $state.go("solicitacaoDesenvolvimento.detail", {id: result.id});
                        } else {
                            $state.go('solicitacaoDesenvolvimento', null, {reload: 'solicitacaoDesenvolvimento'});
                        }
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
    }
})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('SolicitacaoDesenvolvimento', SolicitacaoDesenvolvimento);

    SolicitacaoDesenvolvimento.$inject = ['$resource', '$uibModal', '$state', 'DateUtils'];

    function SolicitacaoDesenvolvimento($resource, $uibModal, $state, DateUtils) {
        var resourceUrl = 'api/solicitacaoDesenvolvimento/:id';

        var service = $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'getBranches': {url: 'api/solicitacao-desenvolvimento-branches/:id', method: 'GET', isArray: true},
            'getByNumero': {url: 'api/solicitacao-desenvolvimento-por-numero/:numero', method: 'GET', isArray: false},
            'getBranchesByName': {url: 'api/branch-por-nome', method: 'GET', isArray: true},
            'getAllConcluidasSprint': {url: 'api/total-concluidos-sprint-atual', method: 'POST', isArray: true},
            'getAllRejeitadasSprint': {url: 'api/total-rejeicoes-sprint-atual', method: 'POST', isArray: true},
            'getGitRepositories': {url: 'api/git-repositories', method: 'GET', isArray: true},
            'getBySprint': {url: 'api/solicitacao-desenvolvimento-por-sprint/:id', method: 'GET', isArray: true},
            'getBySprintAndUsuario': {
                url: 'api/solicitacao-desenvolvimento-por-sprint-usuario',
                method: 'GET',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'atribuir': {url: 'api/atribuir-tarefa', method: 'PUT'},
            'trocarResponsavel': {url: 'api/trocar-responsavel-tarefa', method: 'PUT'},
            'dasatribuir': {url: 'api/dasatribuir-tarefa', method: 'PUT'},
            'sincronizarGit': {url: 'api/sincronizar-git/:id', method: 'GET'},
            'alocar': {url: 'api/alocar-tarefa', method: 'PUT'},
            'alocarPlanejamento': {url: 'api/tarefas-alocar-planejamento', method: 'PUT'},
            'desalocarPlanejamento': {url: 'api/tarefas-desalocar-planejamento', method: 'PUT'},
            'queryBySprintSistema': {
                url: 'api/tarefas-by-sprint',
                method: 'GET',
                isArray: true
            },
            'avancar': {url: 'api/avancar-tarefa', method: 'PUT'},
            'criarBranch': {url: 'api/criar-branch', method: 'PUT'},
            'importarRedmine': {url: 'api/copiar-tarefas-redmine-produto', method: 'PUT'},
            'update': {method: 'PUT'},
            'getTempoGastoByTicket': {
                url: 'api/tempo-gasto-by-ticket/:id',
                method: 'GET',
                isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            },
            'getAllEmDesenvolvimento': {
                url: 'api/solicitacao-desenvolvimento-em-andamento',
                method: 'POST',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        for (var i = 0; i < data.length; i++) {
                            var sol = data[i];
                            if (sol.concluidaEm) {
                                sol.concluidaEm = DateUtils.convertDateTimeFromServer(sol.concluidaEm);
                            }
                        }
                    }
                    return data;
                }
            },
            'getStatusBySolicitacao': {
                url: 'api/historico-desenvolvimento',
                method: 'GET',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        for (var i = 0; i < data.length; i++) {
                            var sol = data[i];
                            if (sol.inicio) {
                                sol.inicio = DateUtils.convertDateTimeFromServer(sol.inicio);
                            }
                            if (sol.fim) {
                                sol.fim = DateUtils.convertDateTimeFromServer(sol.fim);
                            }
                        }
                    }
                    return data;
                }
            },
            'getComentarios': {
                method: 'GET',
                url: 'api/comentarios-da-solicitacao/:id',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.criadoEm = DateUtils.convertDateTimeFromServer(data.criadoEm);
                    }
                    return data;
                }
            },
            'getSituacoePossiveis': {
                method: 'GET',
                url: 'api/solicitacao-situacoes-possiveis/:situacao',
                isArray: true
            },
            'comentarSolicitacao': {
                method: 'POST',
                url: 'api/comentar-solicitacao-desenvolvimento'
            }
        });

        return service;
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('SolicitacaoDesenvolvimentoController', SolicitacaoDesenvolvimentoController);

    SolicitacaoDesenvolvimentoController.$inject = ['$scope', '$state', 'SolicitacaoDesenvolvimento', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Alerta'];

    function SolicitacaoDesenvolvimentoController($scope, $state, SolicitacaoDesenvolvimento, ParseLinks, AlertService, paginationConstants, pagingParams, Alerta) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.loadAll = loadAll;
        vm.remover = remover;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.filtro = "";


        loadAll();

        function loadAll() {
            SolicitacaoDesenvolvimento.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                filtro: vm.filtro
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.solicitacaoDesenvolvimentos = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function remover(id) {
            Alerta.confirm("Atenção", "Tem certeza que deseja remover esse SolicitacaoDesenvolvimento?", "warning", function () {
                SolicitacaoDesenvolvimento.delete({id: id},
                    function () {
                        Alerta.success("Operação realizada", "O SolicitacaoDesenvolvimento foi removido!");
                        loadAll();
                    });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('AlterarSituacaoTarefaController', AlterarSituacaoTarefaController);

    AlterarSituacaoTarefaController.$inject = ['$uibModalInstance', '$timeout', '$scope', '$stateParams', 'solicitacaoDesenvolvimento', 'tempoGasto',
        'SolicitacaoDesenvolvimento', '$state', 'Sprint', 'Principal', 'Chamado', 'Alerta'];

    function AlterarSituacaoTarefaController($uibModalInstance, $timeout, $scope, $stateParams, solicitacaoDesenvolvimento, tempoGasto,
                                             SolicitacaoDesenvolvimento, $state, Sprint, Principal, Chamado, Alerta
    ) {
        var vm = this;
        vm.solicitacaoDesenvolvimento = solicitacaoDesenvolvimento;

        vm.tempoGasto = tempoGasto;
        vm.avancarTarefa = avancarTarefa;
        vm.save = save;
        vm.isSaving = false;
        vm.clear = clear;
        vm.adicionarRepositorio = adicionarRepositorio;

        function ajustarSituacaoAtual() {
            vm.situacaoAtual = vm.solicitacaoDesenvolvimento.situacao;
            if (vm.solicitacaoDesenvolvimento.situacao === 'A_FAZER') {
                Sprint.getBySituacao({situacao: 'EM_ANDAMENTO'}, function (sprint) {
                    vm.solicitacaoDesenvolvimento.sprint = sprint;
                    vm.solicitacaoDesenvolvimento.sprintOriginal = sprint;
                });
                vm.solicitacaoDesenvolvimento.situacao = 'FAZENDO';
                return;
            }
            if (vm.solicitacaoDesenvolvimento.situacao === 'FAZENDO') {
                vm.solicitacaoDesenvolvimento.situacao = 'CODE_REVIEW';
                return;
            }
            if (vm.solicitacaoDesenvolvimento.situacao === 'CODE_REVIEW') {
                vm.solicitacaoDesenvolvimento.situacao = 'A_TESTAR';
                vm.tempoGasto.tipo = 'CODE_REVIEW';
                return;
            }
            if (vm.solicitacaoDesenvolvimento.situacao === 'A_TESTAR') {
                vm.solicitacaoDesenvolvimento.situacao = 'TESTANDO';
                return;
            }
            if (vm.solicitacaoDesenvolvimento.situacao === 'TESTANDO') {
                vm.tempoGasto.tipo = 'TESTE';
                vm.solicitacaoDesenvolvimento.situacao = 'CONCLUIDA';
                return;
            }
        }

        ajustarSituacaoAtual();

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });


        Principal.identity().then(function (account) {
            vm.account = account;
        });


        function save() {
            vm.isSaving = true;
            SolicitacaoDesenvolvimento.update(vm.solicitacaoDesenvolvimento, onSaveSuccess, onSaveError);
        }

        function avancarTarefa() {
            vm.isSaving = true;
            vm.editTarefa = false;
            SolicitacaoDesenvolvimento.avancar(vm.solicitacaoDesenvolvimento, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.solicitacaoDesenvolvimento = result;
            vm.isSaving = false;
            vm.editTarefa = false;
            if (vm.tempoGasto.horas || vm.tempoGasto.minutos) {
                definirTempoGasto();
            } else {
                Alerta.success("Operação realizada!", "Tarefa Alterada com sucesso!");
                $uibModalInstance.close(vm.solicitacaoDesenvolvimento);
            }
        }

        function definirTempoGasto() {
            vm.isSaving = true;
            vm.tempoGasto.tempo = vm.tempoGasto.horas + (vm.tempoGasto.minutos / 60);
            vm.tempoGasto.solicitacaoDesenvolvimento = vm.solicitacaoDesenvolvimento;
            vm.tempoGasto.chamado = vm.solicitacaoDesenvolvimento.chamado;
            Chamado.defirnirTempo(vm.tempoGasto, function (data) {
                vm.openChat = false;
                Alerta.success("Operação realizada!", "Tarefa Alterada e tempo apontado com sucesso!");
                $uibModalInstance.close(vm.solicitacaoDesenvolvimento);
            });
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function carregarSituacoes() {
            vm.situacoes = SolicitacaoDesenvolvimento.getSituacoePossiveis({situacao: vm.situacaoAtual})
        }

        function adicionarRepositorio() {
            if (!vm.solicitacaoDesenvolvimento.projetosGit) {
                vm.solicitacaoDesenvolvimento.projetosGit = [];
            }
            vm.solicitacaoDesenvolvimento.projetosGit
                .push({
                    projetoGit: vm.projetoGit.key,
                    repositorioGit: vm.repositorioGit.name
                })
            vm.projetoGit = {};
        }

        function carregarRepositories() {
            if (vm.solicitacaoDesenvolvimento.sistema && !vm.solicitacaoDesenvolvimento.projetosGit) {
                vm.solicitacaoDesenvolvimento.projetosGit = [];
                vm.solicitacaoDesenvolvimento.projetosGit
                    .push({
                        projetoGit: vm.solicitacaoDesenvolvimento.sistema.projetoGit,
                        repositorioGit: vm.solicitacaoDesenvolvimento.sistema.repositorioGit
                    })
            }
            vm.projetos = SolicitacaoDesenvolvimento.getGitRepositories()
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        carregarSituacoes();
        carregarRepositories();

    }

})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('AlterarResponsavelTarefaController', AlterarResponsavelTarefaController);

    AlterarResponsavelTarefaController.$inject = ['$uibModalInstance', 'solicitacaoDesenvolvimento', 'SolicitacaoDesenvolvimento', 'User'];

    function AlterarResponsavelTarefaController($uibModalInstance, solicitacaoDesenvolvimento, SolicitacaoDesenvolvimento, User) {
        var vm = this;

        vm.solicitacaoDesenvolvimento = solicitacaoDesenvolvimento;
        vm.responsavelSelecionado = solicitacaoDesenvolvimento.responsavel || null;
        vm.isSaving = false;
        vm.save = save;
        vm.clear = clear;

        User.getAllInternos({}, function (data) {
            vm.users = data;
        });

        function save() {
            vm.isSaving = true;
            var payload = angular.copy(vm.solicitacaoDesenvolvimento);
            payload.responsavel = vm.responsavelSelecionado ? {id: vm.responsavelSelecionado.id} : null;

            SolicitacaoDesenvolvimento.trocarResponsavel(payload, onSaveSuccess, onSaveError);
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('SistemaDialogController', SistemaDialogController);

    SistemaDialogController.$inject = ['$timeout', '$scope', 'Modulo', '$uibModalInstance', 'entity', 'Sistema', 'User', 'Cliente'];

    function SistemaDialogController($timeout, $scope, Modulo, $uibModalInstance, entity, Sistema, User, Cliente) {
        var vm = this;

        vm.sistema = entity;
        vm.clear = clear;
        vm.save = save;
        vm.indexModulo = indexModulo;
        vm.adicionarModulo = adicionarModulo;
        vm.removerModulo = removerModulo;
        vm.modulos = Modulo.query({page: 0, size: 99});

        if (!vm.sistema.modulos) {
            vm.sistema.modulos = [];
        }

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.sistema.id !== null) {
                Sistema.update(vm.sistema, onSaveSuccess, onSaveError);
            } else {
                Sistema.save(vm.sistema, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('chamadosApp:sistemaUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function indexModulo(id) {
            for (var i = 0; i < vm.sistema.modulos.length; i++) {
                if (vm.sistema.modulos[i].id === id) {
                    return i;
                }
            }
            return -1;
        }

        function adicionarModulo(modulo) {
            vm.sistema.modulos.push(modulo);
            vm.subModulos = [];
        }

        function removerModulo(modulo) {
            vm.sistema.modulos.splice(vm.indexModulo(modulo.id), 1)

        }

    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('sistema', {
                parent: 'entity',
                url: '/sistema?page&sort&search',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'chamadosApp.sistema.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/sistema/sistema.html',
                        controller: 'SistemaController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('sistema.new', {
                parent: 'sistema',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/sistema/sistema-dialog.html',
                        controller: 'SistemaDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    descricao: null,
                                    projetoRedMine: null,
                                    id: null
                                };
                            }
                        }
                    }).result.then(function () {
                        $state.go('sistema', null, {reload: 'sistema'});
                    }, function () {
                        $state.go('sistema');
                    });
                }]
            })
            .state('sistema.edit', {
                parent: 'sistema',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/sistema/sistema-dialog.html',
                        controller: 'SistemaDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Sistema', function (Sistema) {
                                return Sistema.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('sistema', null, {reload: 'sistema'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })

    }

})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('Sistema', Sistema);

    Sistema.$inject = ['$resource'];

    function Sistema($resource) {
        var resourceUrl = 'api/sistemas/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'getByCliente': {url: "api/sistemas-by-cliente/:clienteId", method: 'GET', isArray: true},
            'getByUser': {url: "api/sistemas-by-user", method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('SistemaController', SistemaController);

    SistemaController.$inject = ['$scope', '$state', 'Sistema', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Alerta', 'SweetAlert'];

    function SistemaController($scope, $state, Sistema, ParseLinks, AlertService, paginationConstants, pagingParams, Alerta, SweetAlert) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.remover = remover;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll() {
            Sistema.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.sistemas = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }


        function remover(id) {
            Alerta.confirm("Atenção", "Tem certeza que deseja remover esse sistema?", "warning", function () {
                Sistema.delete({id: id},
                    function () {
                        Alerta.success("Operação realizada", "O Sistema foi removido!");
                        loadAll();
                    });
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('scrumboard', {
            parent: 'app',
            url: '/scrum-board',
            data: {
                authorities: ['ROLE_USER'],
            },
            ncyBreadcrumb: {
                label: 'ScrumBoard'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/scrumboard/scrumboard.html',
                    controller: 'ScrumBoardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    $translatePartialLoader.addPart('situacaoTarefa');
                    $translatePartialLoader.addPart('situacaoSprint');
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('ScrumBoardController', ScrumBoardController);

    ScrumBoardController.$inject = ['$timeout', '$rootScope', '$filter', 'Principal', '$state', 'Chamado', 'Sprint', 'SolicitacaoDesenvolvimento', 'ChartJs', 'Account'];

    function ScrumBoardController($timeout, $rootScope, $filter, Principal, $state, Chamado, Sprint, SolicitacaoDesenvolvimento, ChartJs, Account) {
        var SCRUMBOARD_FILTERS_LS_KEY = 'chamados.scrumBoard.filters';
        var vm = this;

        function readPersistedScrumFilters() {
            try {
                var raw = window.localStorage.getItem(SCRUMBOARD_FILTERS_LS_KEY);
                if (!raw) {
                    return null;
                }
                return angular.fromJson(raw);
            } catch (e) {
                return null;
            }
        }

        function aplicarPreferenciasArmazenadas() {
            var p = readPersistedScrumFilters();
            vm.verGrafico = false;
            vm._filtroPersistidoModulo = null;
            vm._filtroPersistidoProjeto = null;
            vm._filtroPersistidoUsuarioKey = null;

            if (!p || typeof p !== 'object') {
                return;
            }

            if (angular.isArray(p.situacoesSprintSelecionadas) && p.situacoesSprintSelecionadas.length) {
                vm.situacoesSprintSelecionadas = angular.copy(p.situacoesSprintSelecionadas);
            }

            if (typeof p.atribuidasParaMim === 'boolean') {
                vm.atribuidasParaMim = p.atribuidasParaMim;
            }

            vm.verGrafico = !!p.verGrafico;

            vm._filtroPersistidoModulo = p.hasOwnProperty('modulo') ? p.modulo : null;
            vm._filtroPersistidoProjeto = p.hasOwnProperty('projeto') ? p.projeto : null;
            vm._filtroPersistidoUsuarioKey = p.hasOwnProperty('usuarioAssigneeKey') ? p.usuarioAssigneeKey : null;
        }

        function persistScrumBoardFilters() {
            try {
                var payload = {
                    modulo: vm.modulo,
                    projeto: vm.projeto,
                    usuarioAssigneeKey: vm.usuarioBoardFiltro ? vm.usuarioBoardFiltro.key : null,
                    situacoesSprintSelecionadas: angular.copy(vm.situacoesSprintSelecionadas),
                    atribuidasParaMim: !!vm.atribuidasParaMim,
                    verGrafico: !!vm.verGrafico
                };
                window.localStorage.setItem(SCRUMBOARD_FILTERS_LS_KEY, angular.toJson(payload));
            } catch (e) {
                // quota / modo privado
            }
        }

        function aplicarPersistenciaListaModulosProjetos() {
            vm.modulo = null;
            if (vm._filtroPersistidoModulo !== null &&
                vm._filtroPersistidoModulo !== undefined &&
                vm.modulos.indexOf(vm._filtroPersistidoModulo) >= 0) {
                vm.modulo = vm._filtroPersistidoModulo;
            }
            vm.projeto = null;
            if (vm._filtroPersistidoProjeto !== null &&
                vm._filtroPersistidoProjeto !== undefined &&
                vm.projetos.indexOf(vm._filtroPersistidoProjeto) >= 0) {
                vm.projeto = vm._filtroPersistidoProjeto;
            }
        }

        function aplicarPersistenciaUsuarioBoard() {
            vm.usuarioBoardFiltro = null;
            if (!vm._filtroPersistidoUsuarioKey) {
                return;
            }
            for (var i = 0; i < vm.usuariosBoard.length; i++) {
                var u = vm.usuariosBoard[i];
                if (u.key === vm._filtroPersistidoUsuarioKey) {
                    vm.usuarioBoardFiltro = u;
                    break;
                }
            }
        }

        vm.load = load;
        vm.mover = mover;
        vm.imprimir = imprimir;
        vm.definirModoApresentacao = definirModoApresentacao;
        vm.selecionaModulo = selecionaModulo;
        vm.selecionaProjeto = selecionaProjeto;
        vm.selecionaUsuarioBoard = selecionaUsuarioBoard;
        vm.iniciaisUsuarioBoard = iniciaisUsuarioBoard;
        vm.toggleVerGrafico = toggleVerGrafico;
        vm.getColunaPorSituacao = getColunaPorSituacao;
        vm.usuariosBoard = [];
        vm.usuarioBoardFiltro = null;
        vm.usuarios = [];
        vm.sistemas = [];
        vm.projeto = null;
        vm.modulo = null;
        vm.verGrafico = false;
        vm.pieSeries = ['Sprint'];
        vm.pieOptions = {legend: {display: true}};
        vm.situacoesSprintSelecionadas = ['EM_ANDAMENTO'];
        vm.atribuidasParaMim = true;
        vm.user;

        aplicarPreferenciasArmazenadas();

        $rootScope.$on('chamadosApp:solicitacaoDesenvolvimentoUpdate', function () {
            if ($rootScope.modoApresentacao) {
                load();
            }
        });

        function mover(tarefa, situacao) {
            if (tarefa.situacao != situacao.situacao) {
                tarefa.situacao = situacao.situacao;
                SolicitacaoDesenvolvimento.update(tarefa, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function selecionaModulo(modulo) {
            if (vm.modulo === modulo) {
                vm.modulo = null
            } else {
                vm.modulo = modulo;
            }
            filtrar();
        }

        function selecionaProjeto(projeto) {
            if (vm.projeto === projeto) {
                vm.projeto = null
            } else {
                vm.projeto = projeto
            }
            filtrar();
        }

        function tarefaAssigneeBoardKey(tarefa) {
            if (tarefa.usuarioId != null) {
                return 'id:' + tarefa.usuarioId;
            }
            if (tarefa.usuarioLogin) {
                return 'login:' + tarefa.usuarioLogin;
            }
            if (tarefa.usuario) {
                return 'nome:' + tarefa.usuario;
            }
            return 'sem';
        }

        function montarUsuariosBoard() {
            var byKey = {};
            angular.forEach(vm.solicitacoesDesenvolvimento, function (t) {
                var key = tarefaAssigneeBoardKey(t);
                if (!byKey[key]) {
                    byKey[key] = {
                        key: key,
                        usuarioId: t.usuarioId,
                        login: t.usuarioLogin,
                        nome: t.usuario || (key === 'sem' ? 'Sem responsável' : ''),
                        semResponsavel: key === 'sem',
                        imagem: null
                    };
                }
            });
            vm.usuariosBoard = Object.keys(byKey).map(function (k) {
                return byKey[k];
            }).sort(function (a, b) {
                if (a.semResponsavel) {
                    return 1;
                }
                if (b.semResponsavel) {
                    return -1;
                }
                return (a.nome || '').localeCompare(b.nome || '', 'pt-BR');
            });
            angular.forEach(vm.usuariosBoard, function (u) {
                if (u.login) {
                    Account.getImagemAjustadaByLogin({login: u.login}, function (data) {
                        u.imagem = data.imagemAjustada;
                    });
                }
            });
            vm._usuariosBoardByKey = byKey;
            angular.forEach(vm.solicitacoesDesenvolvimento, function (t) {
                t._assigneeBoard = vm._usuariosBoardByKey[tarefaAssigneeBoardKey(t)];
            });
        }

        function selecionaUsuarioBoard(ent) {
            if (vm.usuarioBoardFiltro === ent) {
                vm.usuarioBoardFiltro = null;
            } else {
                vm.usuarioBoardFiltro = ent;
            }
            filtrar();
        }

        function iniciaisUsuarioBoard(nome) {
            if (!nome) {
                return '?';
            }
            var trimmed = nome.trim();
            var parts = trimmed.split(/\s+/);
            if (parts.length >= 2) {
                return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
            }
            return trimmed.substring(0, Math.min(2, trimmed.length)).toUpperCase();
        }

        function tarefaPassaFiltroUsuario(tarefa) {
            var uf = vm.usuarioBoardFiltro;
            if (!uf) {
                return true;
            }
            if (uf.semResponsavel) {
                return tarefa.usuarioId == null && !tarefa.usuario;
            }
            if (tarefa.usuarioId != null && uf.usuarioId != null) {
                return tarefa.usuarioId === uf.usuarioId;
            }
            if (uf.login && tarefa.usuarioLogin) {
                return uf.login === tarefa.usuarioLogin;
            }
            return (tarefa.usuario || '') === (uf.nome || '');
        }

        function zerarColunas() {
            vm.colunas = [
                {situacao: "A_FAZER", tarefas: [], especial: false, tempoEstimado: 0, tempoGasto: 0},
                {situacao: "FAZENDO", tarefas: [], especial: false, tempoEstimado: 0, tempoGasto: 0},
                {situacao: "CODE_REVIEW", tarefas: [], especial: false, tempoEstimado: 0, tempoGasto: 0},
                {situacao: "A_TESTAR", tarefas: [], especial: false, tempoEstimado: 0, tempoGasto: 0},
                {situacao: "TESTANDO", tarefas: [], especial: false, tempoEstimado: 0, tempoGasto: 0},
                {situacao: "CONCLUIDA", tarefas: [], especial: false, tempoEstimado: 0, tempoGasto: 0},
                {situacao: "IMPEDIDO", tarefas: [], especial: true, tempoEstimado: 0, tempoGasto: 0},
                {situacao: "REJEITADO", tarefas: [], especial: true, tempoEstimado: 0, tempoGasto: 0}
            ];
            vm.pieLabels = [];
            vm.pieDataHoras = [];
            vm.pieDataQuantidade = [];
            for (var i = 0; i < vm.colunas.length; i++) {
                var coluna = vm.colunas[i];
                vm.pieLabels.push(coluna.situacao);
                vm.pieDataHoras.push(0);
                vm.pieDataQuantidade.push(0);
            }

        }

        function filtrar() {
            zerarColunas();
            vm.tarefasAtrasadas = 0;
            vm.tempoPlanejado = 0;
            vm.tempoGasto = 0;
            vm.tarefas = [];

            vm.totalPlanejados = 0;
            vm.totalNaoPlanejados = 0;
            vm.totalDessaSprint = 0;
            vm.concluidasPlanejadas = 0;
            vm.concluidasNaoPlanejadas = 0;

            angular.forEach(vm.solicitacoesDesenvolvimento, function (tarefa) {
                if ((vm.modulo == null || vm.modulo == tarefa.modulo) &&
                    (vm.projeto == null || vm.projeto == tarefa.projeto) &&
                    tarefaPassaFiltroUsuario(tarefa)) {
                    if (tarefa.concluidaEm && tarefa.concluidaEm < vm.sprint.inicio) {
                        tarefa.concluidaEm = new Date(vm.sprint.inicio);
                    }
                    vm.tarefas.push(tarefa);
                    if (tarefa.chamado && tarefa.sprintChamado && tarefa.sprintChamado != tarefa.sprint) {
                        tarefa.atrasado = true;
                        vm.tarefasAtrasadas++;
                    } else {
                        vm.totalDessaSprint++;
                    }
                    var coluna = getColunaPorSituacao(tarefa.aberto ? tarefa.situacao : 'CONCLUIDA');
                    coluna.tarefas.push(tarefa);
                    coluna.tempoEstimado += tarefa.tempoEstimado;
                    coluna.tempoGasto += tarefa.tempoGasto;
                    vm.tempoPlanejado += tarefa.tempoEstimado;
                    vm.tempoGasto += tarefa.tempoGasto;
                    vm.pieDataHoras[vm.pieLabels.indexOf(coluna.situacao)] += tarefa.tempoEstimado;
                    vm.pieDataQuantidade[vm.pieLabels.indexOf(coluna.situacao)] += 1;


                    vm.totalPlanejados += tarefa.planejado ? 1 : 0;
                    vm.totalNaoPlanejados += tarefa.planejado ? 0 : 1;

                    vm.concluidasPlanejadas += tarefa.planejado && tarefa.situacao === 'CONCLUIDA' ? 1 : 0;
                    vm.concluidasNaoPlanejadas += !tarefa.planejado && tarefa.situacao === 'CONCLUIDA' ? 1 : 0;

                }
            });
            vm.efetividade = (vm.concluidasNaoPlanejadas + vm.concluidasPlanejadas) * 100 / vm.totalDessaSprint;

            vm.efetividadePlanejado = (vm.concluidasPlanejadas) * 100 / vm.totalDessaSprint;

            var hoje = new Date();
            vm.diasRestantes = (vm.sprint.fim.getTime() - hoje.getTime()) / (1000 * 3600 * 24);
            vm.burnDownData = [[], [], []];
            vm.burnDownLabels = [];
            vm.burnDownSeries = ['Base', 'Esperado', 'Realizado'];
            vm.dias = [];
            for (var d = new Date(vm.sprint.inicio); d <= vm.sprint.fim; d.setDate(d.getDate() + 1)) {
                vm.dias.push(new Date(d));
            }
            var tempoPorDia = vm.tempoPlanejado / vm.dias.length;
            var tempoGastoAcumulado = 0;
            for (var c = 0; c < vm.dias.length; c++) {
                var dia = new Date(vm.dias[c]);
                vm.burnDownLabels.push($filter('date')(dia));
                vm.burnDownData[0].push(0);
                vm.burnDownData[1].push(tempoPorDia * (c + 1));
                var coluna = getColunaPorSituacao('CONCLUIDA');
                var tempoGastoDia = 0;
                for (var i = 0; i < coluna.tarefas.length; i++) {
                    var tarefa = coluna.tarefas[i];
                    if (tarefa.concluidaEm && $filter('date')(tarefa.concluidaEm) == $filter('date')(dia)) {
                        tempoGastoDia += tarefa.tempoEstimado;
                    }
                }
                if (dia <= hoje) {
                    vm.burnDownData[2].push(tempoGastoAcumulado + tempoGastoDia);
                    tempoGastoAcumulado = tempoGastoAcumulado + tempoGastoDia
                }
            }

            persistScrumBoardFilters();

        }

        function toggleVerGrafico() {
            vm.verGrafico = !vm.verGrafico;
            persistScrumBoardFilters();
        }

        function load() {
            zerarColunas();
            vm.modulos = [];
            vm.projetos = [];

            Sprint.getBySituacao({situacao: 'EM_ANDAMENTO'}, function (aberta) {
                vm.sprint = aberta;
                var consulta = {
                    idUsuario: vm.atribuidasParaMim === true ? vm.user.id : null,
                    situacoesSprint: vm.situacoesSprintSelecionadas
                }
                SolicitacaoDesenvolvimento.getAllEmDesenvolvimento(consulta, function (data) {
                    vm.solicitacoesDesenvolvimento = data;
                    angular.forEach(vm.solicitacoesDesenvolvimento, function (tarefa) {

                        if (vm.modulos.indexOf(tarefa.modulo) < 0) {
                            vm.modulos.push(tarefa.modulo)
                        }
                        if (vm.projetos.indexOf(tarefa.projeto) < 0) {
                            vm.projetos.push(tarefa.projeto)
                        }
                    });
                    aplicarPersistenciaListaModulosProjetos();
                    montarUsuariosBoard();
                    aplicarPersistenciaUsuarioBoard();

                    filtrar();
                })
            });

        }

        function getColunaPorSituacao(situacao) {
            for (var i = 0; i < vm.colunas.length; i++) {
                var coluna = vm.colunas[i];
                if (coluna.situacao === situacao) {
                    return coluna;
                }
            }
            var coluna = {situacao: situacao, tarefas: []};
            vm.colunas.push(coluna);
            return coluna;
        }


        function definirModoApresentacao() {
            $rootScope.modoApresentacao = !$rootScope.modoApresentacao;
            verificarModoApresentacao();
        }

        function verificarModoApresentacao() {
            if ($rootScope.modoApresentacao) {
                $timeout(function () {
                    $state.go("burnup")
                }, 60000);
            }
        }

        verificarModoApresentacao();

        Principal.identity().then(function (account) {
            vm.user = account;
            load();
        });

        function imprimir() {

            var docDefinition = {
                pageSize: 'A4',

                // by default we use portrait, you can change it to landscape if you wish
                pageOrientation: 'portrait',

                // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
                pageMargins: [40, 10, 40, 10],

                content: [
                    {text: 'Webpublico - Helpdesk', style: 'header', alignment: 'center'},
                    {text: 'Relatório de Acompanhamento dos tickets', style: 'subheader'},
                    ticketsImpressao()
                ],
                styles: {
                    header: {
                        fontSize: 12,
                        bold: true,
                        margin: [0, 5, 0, 5]
                    },
                    subheader: {
                        fontSize: 10,
                        italic: true,
                        margin: [0, 5, 0, 5]
                    },
                    tableExample: {
                        margin: [0, 5, 0, 5],
                        fontSize: 8,
                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 8,
                        color: 'black'
                    }
                }
            };


            // download the PDF
            pdfMake.createPdf(docDefinition).download('Tickets.pdf');
        }

        function ticketsImpressao() {
            var filasImprimir = [];

            filasImprimir.push(
                {
                    text: "Impedidos",
                    style: 'header'
                },
                table(getChamadosParaImpressao(getColunaPorSituacao('IMPEDIDO').tarefas), ['Número', 'Titulo', 'Usuário']),
                {
                    text: "Rejeitados",
                    style: 'header'
                },
                table(getChamadosParaImpressao(getColunaPorSituacao('REJEITADO').tarefas), ['Número', 'Titulo', 'Usuário']),
                {
                    text: "A Fazer",
                    style: 'header'
                },
                table(getChamadosParaImpressao(getColunaPorSituacao('A_FAZER').tarefas), ['Número', 'Titulo', 'Usuário']),
                {
                    text: "Fazendo",
                    style: 'header'
                },
                table(getChamadosParaImpressao(getColunaPorSituacao('FAZENDO').tarefas), ['Número', 'Titulo', 'Usuário']),
                {
                    text: "Code Review",
                    style: 'header'
                },
                table(getChamadosParaImpressao(getColunaPorSituacao('CODE_REVIEW').tarefas), ['Número', 'Titulo', 'Usuário']),
                {
                    text: "A Testar",
                    style: 'header'
                },
                table(getChamadosParaImpressao(getColunaPorSituacao('A_TESTAR').tarefas), ['Número', 'Titulo', 'Usuário']),
                {
                    text: "Concluídos",
                    style: 'header'
                },
                table(getChamadosParaImpressao(getColunaPorSituacao('CONCLUIDA').tarefas), ['Número', 'Titulo', 'Usuário'])
            );


            return filasImprimir;

        }

        function table(data, columns) {
            if (data.length > 0) {
                return {
                    table: {
                        style: 'tableExample',
                        headerRows: 1,
                        widths: [100, '*', 100],
                        fontSize: 8,
                        body: buildTableBody(data, columns)
                    },
                    layout: 'lightHorizontalLines'
                };
            } else {
                return {
                    text: "Nenhum Registro",
                    style: 'subheader'
                }
            }
        }

        function getChamadosParaImpressao(tickets) {
            var retorno = []
            angular.forEach(tickets, function (ticket) {
                retorno.push(
                    {
                        'Número': ticket.numero,
                        'Titulo': ticket.titulo,
                        'Usuário': ticket.usuario ? ticket.usuario : ''
                    }
                )

            });
            return retorno;
        }

        function buildTableBody(data, columns) {
            var body = [];

            body.push(columns);

            data.forEach(function (row) {
                var dataRow = [];

                columns.forEach(function (column) {
                    if (row[column]) {
                        dataRow.push(row[column].toString());
                    } else {
                        dataRow.push(" ");
                    }
                });

                body.push(dataRow);
            });

            return body;
        }
    }

})();



(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('pesquisa', {
                parent: 'entity',
                url: '/pesquisa?search',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_CLIENTE', 'ROLE_RESPONSAVEL', 'ROLE_DESENVOLVEDOR', 'ROLE_PO'],
                    pageTitle: 'Pesquisa'
                },
                ncyBreadcrumb: {
                    label: 'Pesquisa'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/pesquisa/pesquisa.html',
                        controller: 'PesquisaController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('chamado');
                        $translatePartialLoader.addPart('severidade');
                        $translatePartialLoader.addPart('tipoChamado');
                        $translatePartialLoader.addPart('complexidadeChamado');
                        $translatePartialLoader.addPart('tipoHora');
                        $translatePartialLoader.addPart('situacaoChamado');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('PesquisaController', PesquisaController);

    PesquisaController.$inject = ['$scope', 'Principal', '$state',
        'Chamado', 'SolicitacaoDesenvolvimento', 'ParseLinks', 'AlertService', 'paginationConstants',
        'pagingParams', 'Ata'];

    function PesquisaController($scope, Principal, $state,
                                Chamado, SolicitacaoDesenvolvimento, ParseLinks, AlertService, paginationConstants,
                                pagingParams, Ata) {
        var vm = this;

        vm.loadAll = loadAll;

        if (pagingParams.search) {
            vm.search = pagingParams.search;
            loadAll();
        }

        function loadAll() {
            vm.chamado = {};

            var texto = vm.search.match(/[^0-9]/g);
            if (texto) {
                vm.chamado.titulo = vm.search;
            } else {
                var numero = vm.search.match(/\d+$/);
                vm.chamado.id = numero ? numero [0] : null;
            }

            vm.chamado.size = 999;
            vm.chamado.page = 0;

            Chamado.queryByFiltro(vm.chamado, function (data) {
                vm.chamados = data;

                SolicitacaoDesenvolvimento.query({
                    page: 0,
                    size: 999,
                    filtro: vm.search
                }, function (data) {
                    vm.solicitacaoDesenvolvimentos = data;

                    Ata.query({
                        page: 0,
                        size: 999,
                        filtro: vm.search
                    }, function (data) {
                        vm.atas = data;
                        if (vm.chamados.length === 1 && vm.solicitacaoDesenvolvimentos.length === 0 && vm.atas.length === 0) {
                            $state.go("edit-chamado", {id: vm.chamados[0].id, sitaucao: null, search: null});
                        }
                        if (vm.chamados.length === 0 && vm.solicitacaoDesenvolvimentos.length === 1 && vm.atas.length === 0) {
                            $state.go("solicitacaoDesenvolvimento.detail", {id: vm.solicitacaoDesenvolvimentos[0].id});
                        }
                        if (vm.chamados.length === 0 && vm.solicitacaoDesenvolvimentos.length === 0 && vm.atas.length === 1) {
                            $state.go("detail-ata", {id: vm.atas[0].id});
                        }
                    }, onError)


                }, onError);
            }, onError);


            function onError(error) {
                AlertService.error(error.data.message);
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('OcorrenciaDialogController', OcorrenciaDialogController);

    OcorrenciaDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Principal', 'Cliente', 'Ocorrencia', 'User', 'Sistema', 'Chamado'];

    function OcorrenciaDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Principal, Cliente, Ocorrencia, User, Sistema, Chamado) {
        var vm = this;

        vm.ocorrencia = entity;
        vm.clear = clear;
        vm.save = save;
        vm.carregarCliente = carregarCliente;
        vm.carregarSistemas = carregarSistemas;
        vm.adicionarChamado = adicionarChamado;
        vm.removerChamado = removerChamado;
        vm.indexOcorrencia = indexOcorrencia;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.ocorrenciaChamado = {chamado: null, ocorrencia: null};

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        carregarCliente();

        function carregarCliente() {
            Cliente.getByUser({}, function (data) {
                vm.clientes = data;
                if (vm.ocorrencia.id === null) {
                    vm.ocorrencia.cliente = vm.clientes[0];
                }
                carregarSistemas();
            });
        }

        function carregarSistemas() {
            if (vm.ocorrencia.cliente) {
                Sistema.getByCliente({clienteId: vm.ocorrencia.cliente.id}, function (data) {
                    vm.sistemas = data;
                })
            } else {
                vm.sistemas = [];
            }
        }

        function adicionarChamado(id) {
            if (vm.ocorrencia.chamados === undefined) {
                vm.ocorrencia.chamados = [];
            }
            Chamado.get({id: id}, function (chamado) {
                vm.ocorrenciaChamado.chamado = chamado;
                vm.ocorrenciaChamado.ocorrencia = vm.ocorrenci;
                vm.ocorrencia.chamados.push(vm.ocorrenciaChamado);
                vm.ocorrenciaChamado = {chamado: null, ocorrencia: null};
                vm.adicionar = null;
            });

        }

        function indexOcorrencia(id) {
            for (var i = 0; i < vm.ocorrencia.chamados.length; i++) {
                if (vm.ocorrencia.chamados[i].id === id) {
                    return i;
                }
            }
            return -1;
        }

        function removerChamado(chamados) {
            vm.ocorrencia.chamados.splice(vm.indexOcorrencia(chamados.id), 1)
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.ocorrencia.id !== null) {
                Ocorrencia.update(vm.ocorrencia, onSaveSuccess, onSaveError);
            } else {
                Ocorrencia.save(vm.ocorrencia, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('chamadosApp:clienteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('ocorrencia', {
            parent: 'entity',
            url: '/ocorrencia?page&sort&search',
            data: {
                authorities: ['ROLE_OCORRENCIA_CHAMADO'],
                pageTitle: 'chamadosApp.ocorrencia.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/ocorrencia/ocorrencia.html',
                    controller: 'OcorrenciaController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('ocorrencia');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('ocorrencia.new', {
            parent: 'ocorrencia',
            url: '/new',
            data: {
                authorities: ['ROLE_OCORRENCIA_CHAMADO']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ocorrencia/ocorrencia-dialog.html',
                    controller: 'OcorrenciaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                url: null,
                                id: null,
                                cliente: null,
                                sistema: null,
                                ocorrencias: []
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('ocorrencia', null, { reload: 'ocorrencia' });
                }, function() {
                    $state.go('ocorrencia');
                });
            }]
        })
        .state('ocorrencia.edit', {
            parent: 'ocorrencia',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_OCORRENCIA_CHAMADO']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/ocorrencia/ocorrencia-dialog.html',
                    controller: 'OcorrenciaDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Ocorrencia', function(Ocorrencia) {
                            return Ocorrencia.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('ocorrencia', null, { reload: 'ocorrencia' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }

})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('Ocorrencia', Ocorrencia);

    Ocorrencia.$inject = ['$resource', 'DateUtils'];

    function Ocorrencia($resource, DateUtils) {
        var resourceUrl = 'api/ocorrencias/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.data = DateUtils.convertLocalDateFromServer(data.data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('OcorrenciaController', OcorrenciaController);

    OcorrenciaController.$inject = ['$scope', '$state', 'Ocorrencia', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Alerta', 'Cliente'];

    function OcorrenciaController($scope, $state, Ocorrencia, ParseLinks, AlertService, paginationConstants, pagingParams, Alerta, Cliente) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.remover = remover;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.selecionarCliente = selecionarCliente;

        loadAll();

        function carregarClientes() {
            Cliente.getByUser({}, function (data) {
                vm.clientes = data;
                vm.cliente = data[0];
                carregarOcorrencias();
            })
        }

        function loadAll() {
            carregarClientes();

        }

        function carregarOcorrencias() {
            Ocorrencia.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.ocorrencias = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                angular.forEach(data, function (ocorrencia) {
                    if (ocorrencia.cliente.id === vm.cliente.id) {
                        vm.ocorrencias.push(ocorrencia);
                    }
                });

                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function selecionarCliente(cliente) {
            vm.cliente = cliente;
            carregarOcorrencias();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function remover(id) {
            Alerta.confirm("Atenção", "Tem certeza que deseja remover esse Ocorrencia?", "warning", function () {
                Ocorrencia.delete({id: id},
                    function () {
                        Alerta.success("Operação realizada", "O Ocorrencia foi removido!");
                        loadAll();
                    });
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('NotificacaoDetailController', NotificacaoDetailController);

    NotificacaoDetailController.$inject = ['$scope', '$rootScope', '$sce', 'previousState', 'entity', 'Notificacao'];

    function NotificacaoDetailController($scope, $rootScope, $sce, previousState, entity, Notificacao) {
        var vm = this;

        vm.notificacao = entity;
        vm.previousState = previousState.name;
        vm.trustAsHtml = trustAsHtml;

        if (!vm.notificacao.lida) {
            vm.notificacao.lida = true;
            Notificacao.update(vm.notificacao, function (result) {
                $rootScope.$broadcast('chamadosApp:notificacaoUpdate');
            });
        }

        function trustAsHtml(value) {
            return $sce.trustAsHtml(value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('notificacao', {
            parent: 'entity',
            url: '/notificacao?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Notificações do Usuário'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/notificacao/notificacoes.html',
                    controller: 'NotificacaoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('notificacao-detail', {
            parent: 'notificacao',
            url: '/notificacao/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'Notificação do Usuário'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/notificacao/notificacao-detail.html',
                    controller: 'NotificacaoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'Notificacao', function($stateParams, Notificacao) {
                    return Notificacao.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'notificacao',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        });
    }

})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('Notificacao', Notificacao);

    Notificacao.$inject = ['$resource'];

    function Notificacao($resource) {
        var resourceUrl = 'api/notificacoes/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'queryNaoLidas': {url: 'api/notificacoes-nao-lidas', method: 'GET', isArray: true},
            'marcarComoLida': {url: 'api/notificacoes-marcar-como-lidas', method: 'GET'},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'notificar': {url: 'api/notificar', method: 'GET'},
            'deploy': {url: 'public/riobranco/deploy-producao/:id', method: 'GET'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('NotificacaoController', NotificacaoController);

    NotificacaoController.$inject = ['$scope', '$state', 'Notificacao', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function NotificacaoController ($scope, $state, Notificacao, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Notificacao.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.notificacoes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('myboard', {
            parent: 'app',
            url: '/my-board',
            data: {
                authorities: ['ROLE_USER'],
            },
            ncyBreadcrumb: {
                label: 'MyBoard'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/myboard/myboard.html',
                    controller: 'MyBoardController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('situacaoTarefa');
                    $translatePartialLoader.addPart('tipoChamado');
                    $translatePartialLoader.addPart('situacaoTarefa');
                    $translatePartialLoader.addPart('tipoHora');
                    $translatePartialLoader.addPart('complexidadeChamado');
                    $translatePartialLoader.addPart('situacaoSprint');
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('MyBoardController', MyBoardController);

    MyBoardController.$inject = ['$scope', '$rootScope', '$filter', 'Principal', '$state',
        'Chamado', 'Sprint', 'SolicitacaoDesenvolvimento', 'Account', 'Modulo', 'User'];

    function MyBoardController($scope, $rootScope, $filter, Principal, $state,
                               Chamado, Sprint, SolicitacaoDesenvolvimento, Account, Modulo, User) {
        var vm = this;
        vm.modulos = Modulo.queryByUser();
        vm.load = load;
        vm.recuperarTickets = recuperarTickets;
        vm.buscarTarrefasDaSprint = buscarTarrefasDaSprint;
        vm.getQuantidadeTickets = getQuantidadeTickets;
        vm.openCalendar = openCalendar;

        vm.totalHoraTrabalhadas = 0;
        vm.totalTarefasTrabalhadas = 0;
        vm.totalTarefasAjudadas = 0;
        vm.users = User.getAllWithEquipe();
        vm.concluidas = [];
        vm.rejeitadas = [];
        vm.datePickerOpenStatus = {};
        vm.situacoesSprintSelecionadas = [null, "EM_ANDAMENTO"];

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function getQuantidadeTickets(situacao) {
            var quantidade = 0;
            angular.forEach(vm.tarefas, function (tipo) {
                angular.forEach(vm.tarefas[tipo], function (ticket) {
                    if (ticket.situacao == situacao) {
                        quantidade = quantidade + 1;
                    }
                });

            });
            return quantidade;
        }


        function load() {
            Sprint.query({}, function (data) {
                vm.sprints = data;
                vm.sprint = vm.sprints[1];
                Principal.identity().then(function (account) {
                    vm.account = account;
                    vm.filtro = {};
                    vm.filtro.user = vm.account;
                    buscarTarrefasDaSprint();

                });
            });

        }

        function buscarTarrefasDaSprint() {
            vm.filtro.inicio = vm.sprint.inicio;
            vm.filtro.fim = vm.sprint.fim;
            var consulta = {
                idUsuario: vm.filtro.user.id,
                situacoesSprint: vm.situacoesSprintSelecionadas
            }
            SolicitacaoDesenvolvimento.getAllEmDesenvolvimento(consulta, function (data) {
                vm.tarefasDaSprint = data;
                vm.tarefasRejeitadas = [];
                vm.tarefasFazendo = [];
                vm.tarefasImpedidas = [];
                vm.tarefasAtrasadas = [];
                for (var i = 0; i < data.length; i++) {
                    var tarefa = data[i];
                    if (tarefa.situacao === 'FAZENDO') {
                        vm.tarefasFazendo.push(tarefa);
                    }
                    if (tarefa.situacao === 'REJEITADO') {
                        vm.tarefasRejeitadas.push(tarefa);
                    }
                    if (tarefa.situacao === 'IMPEDIDO') {
                        vm.tarefasImpedidas.push(tarefa);
                    }
                    if (tarefa.sprintChamado && tarefa.sprint !== vm.sprint.descricao) {
                        vm.tarefasAtrasadas.push(tarefa);
                    }
                }
                recuperarTickets();
            });
        }

        function recuperarTickets() {
            vm.mostrarTarefas = vm.tarefasDaSprint.length > 0;
            vm.tarefas = {};
            vm.todasTarefas = [];

            vm.chamados = [];
            vm.horasPorModulo = [];
            vm.horasPonto = [];
            vm.atividades = [];
            if (!vm.filtro.user.imagem) {
                Account.getImagemAjustadaByLogin({login: vm.filtro.user.login}, function (data) {
                    vm.filtro.user.imagem = data.imagemAjustada;
                });
            }
            recuperarHorasApontada();
        }

        function adicionarTarefa(atividade) {
            if (atividade.solicitacaoDesenvolvimento) {
                if (atividade.tipo === 'CODE_REVIEW') {
                    return;
                }
                var tem = false;
                for (var i = 0; i < vm.tarefasDaSprint.length; i++) {
                    var tarefaDaSprint = vm.tarefasDaSprint[i];
                    if (tarefaDaSprint.id === atividade.solicitacaoDesenvolvimento.id) {
                        tem = true;
                        if (!tarefaDaSprint.tempoGasto) {
                            tarefaDaSprint.tempoGasto = 0;
                        }
                        tarefaDaSprint.tempoGasto += atividade.tempo;
                        break;
                    }
                }
                var tipo = atividade.tipo ? $filter('translate')('chamadosApp.TipoHora.' + atividade.tipo) : atividade.conteudo;
                if (!vm.tarefas[tipo]) {
                    vm.tarefas[tipo] = [];
                }
                var tarefa = atividade.solicitacaoDesenvolvimento;
                var indice = vm.tarefas[tipo].map(function (value) {
                    return value.numero
                }).indexOf(tarefa.numero);


                if (indice > -1) {
                    vm.tarefas[tipo][indice].tempoGasto += atividade.tempo;
                } else {
                    tarefa.tempoGasto = atividade.tempo;
                    vm.tarefas[tipo].push(tarefa);
                    if (atividade.solicitacaoDesenvolvimento.responsavel && atividade.solicitacaoDesenvolvimento.responsavel.login === vm.filtro.user.login) {
                        vm.totalTarefasTrabalhadas = vm.totalTarefasTrabalhadas + 1;
                    } else {
                        vm.totalTarefasAjudadas = vm.totalTarefasAjudadas + 1;
                    }
                }
            } else {
            }
        }


        function recuperarHorasApontada() {
            vm.horaApontadaPorDia = [];
            var loop = new Date(vm.filtro.inicio);
            while (loop < new Date(vm.filtro.fim)) {
                var newDate = loop.setDate(loop.getDate() + 1);
                loop = new Date(newDate);
                if (loop.getDay() === 6 || loop.getDay() === 0) {
                    continue;
                }
                var criadoEm = $filter('date')(newDate, 'yyyy-MM-dd');

                vm.horaApontadaPorDia.push({dia: criadoEm, tempoGasto: 0, horaPonto: 0, percentual: 0});
            }

            Chamado.queryTempoGasto(vm.filtro, function (data) {
                vm.atividades = data;
                vm.totalTarefasTrabalhadas = 0;
                vm.totalTarefasAjudadas = 0;

                vm.totalHoraTrabalhadas = 0;

                angular.forEach(vm.atividades, function (atividade) {
                    var criadoEm = $filter('date')(atividade.criadoEm, 'yyyy-MM-dd');

                    for (var i = 0; i < vm.horaApontadaPorDia.length; i++) {
                        if (vm.horaApontadaPorDia[i].dia === criadoEm) {
                            vm.horaApontadaPorDia[i].tempoGasto = vm.horaApontadaPorDia[i].tempoGasto + atividade.tempo;
                        }
                    }
                    vm.totalHoraTrabalhadas = vm.totalHoraTrabalhadas + atividade.tempo;
                    adicionarTarefa(atividade);
                });

                recuperarHorasPonto();

                SolicitacaoDesenvolvimento.getAllConcluidasSprint(vm.filtro, function (data) {
                    vm.concluidas = data;
                });

                SolicitacaoDesenvolvimento.getAllRejeitadasSprint(vm.filtro, function (data) {
                    vm.rejeitadas = data;
                });
            });
        }

        function recuperarHorasPonto() {
            Chamado.queryTempoGastoPonto(vm.filtro, function (data) {
                vm.horasPonto = data;
                angular.forEach(vm.horasPonto, function (ponto) {
                    if (ponto.horasTrabalhadas) {
                        var criadoEm = $filter('date')(ponto.data, 'yyyy-MM-dd');
                        for (var i = 0; i < vm.horaApontadaPorDia.length; i++) {
                            if (vm.horaApontadaPorDia[i].dia === criadoEm) {
                                vm.horaApontadaPorDia[i].horaPonto += timeToDecimal(ponto.horasTrabalhadasString);
                            }
                        }
                    }
                });
                calculaPercentual();
            }, function (error) {
                calculaPercentual();
            });
        }

        function calculaPercentual() {
            angular.forEach(vm.horaApontadaPorDia, function (dia) {
                var horaPonto = dia.horaPonto;
                if (horaPonto <= 0) {
                    horaPonto = 8.48;
                }
                dia.percentual = ((dia.tempoGasto * 100) / horaPonto);
            });
            montarGraficoHoras();
        }

        function montarGraficoHoras() {
            vm.labelsHoras = [];
            vm.dataHoras = [[], [], [], []];
            vm.serieHoras = ["Trabalhado", "Esperado", "Apontado", "Minimo"];
            angular.forEach(vm.horaApontadaPorDia, function (dia) {
                vm.labelsHoras.push($filter('date')(dia.dia, 'dd/MM/yyyy'));
                vm.dataHoras[0].push(dia.horaPonto);
                vm.dataHoras[1].push(8.48);
                vm.dataHoras[2].push(dia.tempoGasto);
                vm.dataHoras[3].push(0);
            });
            montarGraficoModulos();
        }

        function montarGraficoModulos() {
            vm.labelsModulo = [];
            vm.dataModulo = [];
            vm.totalModulo = 0;
            angular.forEach(vm.atividades, function (atividade) {
                if (!atividade.chamado) {
                    return;
                }
                if (vm.labelsModulo.indexOf(atividade.chamado.modulo.descricao) < 0) {
                    vm.labelsModulo.push(atividade.chamado.modulo.descricao);
                }
            });
            angular.forEach(vm.labelsModulo, function (modulo) {
                angular.forEach(vm.atividades, function (atividade) {
                    if (!atividade.chamado) {
                        return;
                    }
                    if (atividade.chamado.modulo.descricao === modulo) {
                        if (!vm.dataModulo[vm.labelsModulo.indexOf(modulo)]) {
                            vm.dataModulo[vm.labelsModulo.indexOf(modulo)] = 0;
                        }
                        vm.dataModulo[vm.labelsModulo.indexOf(modulo)] =
                            vm.dataModulo[vm.labelsModulo.indexOf(modulo)] + atividade.tempo;
                        vm.totalModulo += atividade.tempo;
                    }
                });
            });
            montarGraficoTipos()
        }

        function montarGraficoTipos() {
            vm.labelsTipo = [];
            vm.dataTipo = [];
            vm.totalTipo = 0;
            angular.forEach(vm.atividades, function (atividade) {
                if (!atividade.chamado) {
                    return;
                }
                var tipo = atividade.tipo ? $filter('translate')('chamadosApp.TipoHora.' + atividade.tipo) : atividade.conteudo;
                if (vm.labelsTipo.indexOf(tipo) < 0) {
                    vm.labelsTipo.push(tipo);
                }
            });
            angular.forEach(vm.labelsTipo, function (tipo) {
                angular.forEach(vm.atividades, function (atividade) {
                    if (!atividade.chamado) {
                        return;
                    }
                    var tipoAtividade = atividade.tipo ? $filter('translate')('chamadosApp.TipoHora.' + atividade.tipo) : atividade.conteudo;

                    if (tipoAtividade === tipo) {
                        if (!vm.dataTipo[vm.labelsTipo.indexOf(tipo)]) {
                            vm.dataTipo[vm.labelsTipo.indexOf(tipo)] = 0;
                        }
                        vm.dataTipo[vm.labelsTipo.indexOf(tipo)] =
                            vm.dataTipo[vm.labelsTipo.indexOf(tipo)] + atividade.tempo;
                        vm.totalTipo += atividade.tempo;
                    }
                });
            });
            montarGraficoComplexidade()
        }

        function montarGraficoComplexidade() {
            vm.labelsComplexidade = [];
            vm.dataComplexidade = [];
            vm.totalComplexidade = 0;
            angular.forEach(vm.atividades, function (atividade) {
                if (!atividade.chamado) {
                    return;
                }
                var complexidade = atividade.chamado.complexidade ? $filter('translate')('chamadosApp.ComplexidadeChamado.' + atividade.chamado.complexidade) : "Sem Comple.";
                if (vm.labelsComplexidade.indexOf(complexidade) < 0) {
                    vm.labelsComplexidade.push(complexidade);
                }
            });
            angular.forEach(vm.labelsComplexidade, function (complexidade) {
                angular.forEach(vm.atividades, function (atividade) {
                    if (!atividade.chamado) {
                        return;
                    }
                    var complexidadeAtividade = $filter('translate')('chamadosApp.ComplexidadeChamado.' + atividade.chamado.complexidade);

                    if (complexidadeAtividade === complexidade) {
                        if (!vm.dataComplexidade[vm.labelsComplexidade.indexOf(complexidade)]) {
                            vm.dataComplexidade[vm.labelsComplexidade.indexOf(complexidade)] = 0;
                        }
                        vm.dataComplexidade[vm.labelsComplexidade.indexOf(complexidade)] =
                            vm.dataComplexidade[vm.labelsComplexidade.indexOf(complexidade)] + atividade.tempo;
                        vm.totalComplexidade += atividade.tempo;
                    }
                });
            });
            montarGraficoProjeto();
        }


        function montarGraficoProjeto() {
            vm.labelsProjeto = [];
            vm.dataProjeto = [];
            vm.totalProjeto = 0;
            angular.forEach(vm.atividades, function (atividade) {
                if (!atividade.chamado) {
                    return;
                }
                var projeto = atividade.chamado.cliente.nome;
                if (vm.labelsProjeto.indexOf(projeto) < 0) {
                    vm.labelsProjeto.push(projeto);
                }
            });
            angular.forEach(vm.labelsProjeto, function (projeto) {
                angular.forEach(vm.atividades, function (atividade) {
                    if (!atividade.chamado) {
                        return;
                    }
                    var projetoAtividade = atividade.chamado.cliente.nome;

                    if (projetoAtividade === projeto) {
                        if (!vm.dataProjeto[vm.labelsProjeto.indexOf(projeto)]) {
                            vm.dataProjeto[vm.labelsProjeto.indexOf(projeto)] = 0;
                        }
                        vm.dataProjeto[vm.labelsProjeto.indexOf(projeto)] =
                            vm.dataProjeto[vm.labelsProjeto.indexOf(projeto)] + atividade.tempo;
                        vm.totalProjeto += atividade.tempo;
                    }
                });
            });
        }

        function timeToDecimal(t) {
            var arr = t.split(':');
            var dec = parseInt((arr[1] / 6) * 10, 10);

            return parseFloat(parseInt(arr[0], 10) + '.' + (dec < 10 ? '0' : '') + dec);
        }

        load();

    }

})();



(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('ModuloDialogController', ModuloDialogController);

    ModuloDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Modulo', 'User', 'Cliente'];

    function ModuloDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Modulo, User, Cliente) {
        var vm = this;

        vm.modulo = entity;
        vm.clear = clear;

        vm.save = save;

        vm.clientes = Cliente.query({
            page: 0,
            size: 100
        });

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.modulo.id !== null) {
                Modulo.update(vm.modulo, onSaveSuccess, onSaveError);
            } else {
                Modulo.save(vm.modulo, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('chamadosApp:moduloUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('modulo', {
            parent: 'entity',
            url: '/modulo?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'chamadosApp.modulo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/modulo/modulos.html',
                    controller: 'ModuloController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('modulo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('modulo.new', {
            parent: 'modulo',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modulo/modulo-dialog.html',
                    controller: 'ModuloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                descricao: null,
                                projetoRedMine: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('modulo', null, { reload: 'modulo' });
                }, function() {
                    $state.go('modulo');
                });
            }]
        })
        .state('modulo.edit', {
            parent: 'modulo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN'],
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/modulo/modulo-dialog.html',
                    controller: 'ModuloDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Modulo', function(Modulo) {
                            return Modulo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('modulo', null, { reload: 'modulo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();

(function() {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('Modulo', Modulo);

    Modulo.$inject = ['$resource'];

    function Modulo ($resource) {
        var resourceUrl =  'api/modulos/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'queryByUser': { url:'api/modulos-by-user', method: 'GET', isArray: true},
            'getBySistema': { url:'api/modulos-by-sistema/:id', method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('ModuloController', ModuloController);

    ModuloController.$inject = ['$scope', '$state', 'Modulo', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Alerta'];

    function ModuloController ($scope, $state, Modulo, ParseLinks, AlertService, paginationConstants, pagingParams, Alerta) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.remover = remover;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Modulo.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.modulos = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function remover(id) {
            Alerta.confirm("Atenção", "Tem certeza que deseja remover esse Módulo?", "warning", function () {
                Modulo.delete({id: id},
                    function () {
                        Alerta.success("Operação realizada", "O Módulo foi removido!");
                        loadAll();
                    });
            });
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('ImagemController', ImagemController);

    ImagemController.$inject = ['$scope', '$q', 'Principal', 'AnexoChamado', '$state', 'Upload', '$window', '$uibModalInstance', 'Alerta'];

    function ImagemController($scope, $q, Principal, AnexoChamado, $state, Upload, $window, $uibModalInstance, Alerta) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;

        vm.clear = clear;
        vm.submit = submit;
        vm.upload = upload;
        vm.rotateImage = rotateImage;
        vm.ok = ok;
        vm.progressPercentage = null;
        vm.carregando = false;

        vm.fileOriginal = null;
        vm.cropper = {sourceImage: null, croppedImage: null};
        vm.bounds = {left: 0, right: 0, top: 0, bottom: 0};

        vm.cropper.sourceImage = vm.fileOriginal;

        function ok() {
            console.log("vm.cropper ", vm.cropper);
            submit();
        }


        function clear() {
            $uibModalInstance.dismiss('close');
        }


        function rotateImage() {
            vm.carregando = true;
            convertImage(function () {
                vm.carregando = false;
            });
        }

        function convertImage(callback) {
            var img = new Image();
            img.src = vm.cropper.sourceImage;
            var canvas = document.createElement('CANVAS');
            var ctx = canvas.getContext("2d");
            canvas.width = img.height;
            canvas.height = img.width;
            ctx.drawImage(img, 0, 0);
            ctx.translate(canvas.width / 2, canvas.height / 2);
            ctx.rotate(90 * Math.PI / 180);
            ctx.drawImage(img, -img.width / 2, -img.height / 2);
            vm.cropper.sourceImage = canvas.toDataURL();
            callback();
        }


        function submit() {
            if (vm.anexo) {
                vm.carregando = true;
                AnexoChamado.upload(vm.anexo, function (data) {
                    vm.anexo = data;
                    $uibModalInstance.close(data);
                    vm.carregando = false;
                }, function (error) {
                    vm.carregando = false;
                });
            }
        }


        function upload($file) {
            if ($file) {
                vm.anexo = {};
                vm.anexo.descricao = $file.name;
                vm.anexo.mimeType = $file.type;
                Upload.dataUrl($file, true).then(
                    function (conteudo) {
                        vm.fileOriginal = conteudo;
                        vm.anexo.conteudo = conteudo;
                    }
                );
            } else {
                Alerta.warn("Atenção!", "Você deve selecionar um arquivo de até 10Mb");
            }
        }


    }
})();


(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('TransicaoSituacao', TransicaoSituacao);

    TransicaoSituacao.$inject = ['$resource'];

    function TransicaoSituacao($resource) {
        var resourceUrl = 'api/transicao-situacao/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'save': {method: 'POST'},
            'delete': {method: 'DELETE'},
            'permitidas': {
                method: 'GET',
                url: 'api/transicao-situacao/permitidas',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('SituacaoConfig', SituacaoConfig);

    SituacaoConfig.$inject = ['$resource'];

    function SituacaoConfig($resource) {
        var resourceUrl = 'api/situacao-config/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {method: 'GET'},
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'},
            'clonar': {
                method: 'POST',
                url: 'api/situacao-config/clonar/:clienteId',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('fluxo-situacao', {
                parent: 'entity',
                url: '/fluxo-situacao',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Fluxo de Situações'
                },
                ncyBreadcrumb: {
                    label: 'Fluxo de Situações'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/fluxo-situacao/fluxo-situacao.html',
                        controller: 'FluxoSituacaoController',
                        controllerAs: 'vm'
                    }
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('FluxoSituacaoController', FluxoSituacaoController);

    FluxoSituacaoController.$inject = ['SituacaoConfig', 'TransicaoSituacao', 'Cliente', 'AlertService'];

    function FluxoSituacaoController(SituacaoConfig, TransicaoSituacao, Cliente, AlertService) {
        var vm = this;

        vm.clientes = [];
        vm.clienteSelecionado = null;
        vm.situacoes = [];
        vm.transicoes = [];
        vm.novaSituacao = {
            permiteCriarTarefa: true,
            permiteInserirAnalisePo: true,
            inicial: false,
            authorities: ['ROLE_PO', 'ROLE_ATENDENTE']
        };
        vm.novaTransicao = {};
        vm.editando = null;

        vm.carregarClientes = carregarClientes;
        vm.selecionarCliente = selecionarCliente;
        vm.carregarSituacoes = carregarSituacoes;
        vm.carregarTransicoes = carregarTransicoes;
        vm.salvarSituacao = salvarSituacao;
        vm.editarSituacao = editarSituacao;
        vm.cancelarEdicao = cancelarEdicao;
        vm.removerSituacao = removerSituacao;
        vm.adicionarTransicao = adicionarTransicao;
        vm.removerTransicao = removerTransicao;
        vm.clonarPadrao = clonarPadrao;

        vm.opcoesAuthorities = [
            'ROLE_PO',
            'ROLE_ATENDENTE',
            'ROLE_SCRUM',
            'ROLE_DESENVOLVEDOR',
            'ROLE_CLIENTE',
            'ROLE_RESPONSAVEL',
            'ROLE_ADMIN'
        ];

        vm.toggleRole = toggleRole;
        vm.roleMarcado = roleMarcado;
        vm.rolesResumo = rolesResumo;

        carregarClientes();

        function toggleRole(target, authority) {
            if (!target.authorities || !angular.isArray(target.authorities)) {
                target.authorities = [];
            }
            var idx = target.authorities.indexOf(authority);
            if (idx !== -1) {
                target.authorities.splice(idx, 1);
            } else {
                target.authorities.push(authority);
            }
        }

        function roleMarcado(target, authority) {
            var list = target && angular.isArray(target.authorities) ? target.authorities : [];
            return list.indexOf(authority) !== -1;
        }

        function rolesResumo(s) {
            if (!s || !angular.isArray(s.authorities) || s.authorities.length === 0) {
                return '';
            }
            return s.authorities.slice().sort().join(', ');
        }

        function carregarClientes() {
            Cliente.query(function (result) {
                vm.clientes = result;
            });
        }

        function selecionarCliente() {
            carregarSituacoes();
            carregarTransicoes();
        }
        selecionarCliente();

        function getClienteId() {
            return vm.clienteSelecionado ? vm.clienteSelecionado.id : null;
        }

        function carregarSituacoes() {
            SituacaoConfig.query({clienteId: getClienteId()}, function (result) {
                vm.situacoes = result;
            });
        }

        function carregarTransicoes() {
            TransicaoSituacao.query({clienteId: getClienteId()}, function (result) {
                vm.transicoes = result;
            });
        }

        function salvarSituacao() {
            var situacao = vm.editando || vm.novaSituacao;
            if (vm.clienteSelecionado) {
                situacao.cliente = vm.clienteSelecionado;
            }
            if (situacao.id) {
                SituacaoConfig.update(situacao, function () {
                    AlertService.success('Situação atualizada');
                    vm.editando = null;
                    carregarSituacoes();
                });
            } else {
                SituacaoConfig.save(situacao, function () {
                    AlertService.success('Situação criada');
                    vm.novaSituacao = {
                        permiteCriarTarefa: true,
                        permiteInserirAnalisePo: true,
                        inicial: false,
                        authorities: ['ROLE_PO', 'ROLE_ATENDENTE']
                    };
                    carregarSituacoes();
                });
            }
        }

        function editarSituacao(situacao) {
            vm.editando = angular.copy(situacao);
            if (!angular.isArray(vm.editando.authorities)) {
                vm.editando.authorities = [];
            }
        }

        function cancelarEdicao() {
            vm.editando = null;
        }

        function removerSituacao(situacao) {
            if (confirm('Deseja remover a situação "' + situacao.descricao + '"?')) {
                SituacaoConfig.delete({id: situacao.id}, function () {
                    AlertService.success('Situação removida');
                    carregarSituacoes();
                });
            }
        }

        function adicionarTransicao() {
            var transicao = {
                situacaoOrigem: vm.novaTransicao.origem,
                situacaoDestino: vm.novaTransicao.destino,
                ativo: true
            };
            if (vm.clienteSelecionado) {
                transicao.cliente = vm.clienteSelecionado;
            }
            TransicaoSituacao.save(transicao, function () {
                AlertService.success('Transição criada');
                vm.novaTransicao = {};
                carregarTransicoes();
            });
        }

        function removerTransicao(transicao) {
            if (confirm('Deseja remover esta transição?')) {
                TransicaoSituacao.delete({id: transicao.id}, function () {
                    AlertService.success('Transição removida');
                    carregarTransicoes();
                });
            }
        }

        function clonarPadrao() {
            if (!vm.clienteSelecionado) {
                AlertService.warning('Selecione um cliente');
                return;
            }
            SituacaoConfig.clonar({clienteId: vm.clienteSelecionado.id}, function (result) {
                AlertService.success('Fluxo padrão clonado para o cliente');
                vm.situacoes = result;
                carregarTransicoes();
            }, function (error) {
                AlertService.error(error.data.message || 'Erro ao clonar fluxo');
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('FeedBackDialogController', FeedBackDialogController);

    FeedBackDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'FeedBack', 'User', 'Sistema'];

    function FeedBackDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, FeedBack, User, Sistema) {
        var vm = this;

        vm.feedBack = entity;
        vm.clear = clear;
        vm.save = save;


        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.feedBack.id !== null) {
                FeedBack.update(vm.feedBack, onSaveSuccess, onSaveError);
            } else {
                FeedBack.save(vm.feedBack, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('chamadosApp:FeedBackUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('feedback', {
            parent: 'entity',
            url: '/feedback?page&sort&search',
            data: {
                authorities: ['ROLE_ATENDENTE'],
                pageTitle: 'chamadosApp.feedBack.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/feedback/feedback.html',
                    controller: 'FeedBackController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('feedBack');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
            .state('feedback.new', {
                parent: 'feedback',
                url: '/new',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/feedback/feedback-dialog.html',
                        controller: 'FeedBackDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                };
                            },
                            translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                                $translatePartialLoader.addPart('feedBack');
                                return $translate.refresh();
                            }],
                        }
                    }).result.then(function() {
                        $state.go('feedback', null, { reload: 'feedback' });
                    }, function() {
                        $state.go('feedback');
                    });
                }]
            })
            .state('feedback.edit', {
                parent: 'feedback',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/feedback/feedback-dialog.html',
                        controller: 'FeedBackDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: ['Feedback', function(Feedback) {
                                return Feedback.get({id : $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function() {
                        $state.go('feedback', null, { reload: 'feedback' });
                    }, function() {
                        $state.go('^');
                    });
                }]
            })
    }

})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('FeedBack', FeedBack);

    FeedBack.$inject = ['$resource', 'DateUtils'];

    function FeedBack($resource, DateUtils) {
        var resourceUrl = 'api/feedbacks/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.criadoEm = DateUtils.convertDateTimeFromServer(data.criadoEm);
                    }
                    return data;
                }
            },
            'getUltimo': {
                method: 'GET',
                url: 'api/feedbacks/ultimo',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.criadoEm = DateUtils.convertDateTimeFromServer(data.criadoEm);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('FeedBackController', FeedBackController);

    FeedBackController.$inject = ['$scope', '$state', 'FeedBack', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams'];

    function FeedBackController ($scope, $state, FeedBack, ParseLinks, AlertService, paginationConstants, pagingParams) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            FeedBack.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.feedBacks = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('EquipeDialogController', EquipeDialogController);

    EquipeDialogController.$inject = ['$scope', '$http', '$q', 'entity', '$uibModalInstance', 'Equipe', 'AlertService'];

    function EquipeDialogController($scope, $http, $q, entity, $uibModalInstance, Equipe, AlertService) {
        var vm = this;

        vm.equipe = entity;
        vm.clear = clear;
        vm.save = save;
        vm.buscarUsuarios = buscarUsuarios;
        vm.buscarSistemas = buscarSistemas;
        vm.selecionarUsuario = selecionarUsuario;
        vm.selecionarSistema = selecionarSistema;
        vm.removerUsuario = removerUsuario;
        vm.removerSistema = removerSistema;
        vm.usuarioBusca = null;
        vm.sistemaBusca = null;

        if (!vm.equipe.usuarios) {
            vm.equipe.usuarios = [];
        }
        if (!vm.equipe.sistemas) {
            vm.equipe.sistemas = [];
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.equipe.id !== null) {
                Equipe.update(vm.equipe, onSaveSuccess, onSaveError);
            } else {
                Equipe.save(vm.equipe, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('chamadosApp:equipeUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError(error) {
            vm.isSaving = false;
            if (error && error.data && error.data.message) {
                AlertService.error(error.data.message);
            }
        }

        function buscarUsuarios(filtro) {
            if (!filtro || filtro.length < 2) {
                return $q.when([]);
            }
            return $http.get('api/users-internos/search', {
                params: { filtro: filtro, page: 0, size: 10 }
            }).then(function (res) {
                var ids = vm.equipe.usuarios.map(function (u) { return u.usuario.id; });
                return res.data.filter(function (u) { return ids.indexOf(u.id) < 0; });
            }, function () {
                return [];
            });
        }

        function buscarSistemas(filtro) {
            if (!filtro || filtro.length < 2) {
                return $q.when([]);
            }
            return $http.get('api/sistemas/search', {
                params: { filtro: filtro, page: 0, size: 10 }
            }).then(function (res) {
                var ids = vm.equipe.sistemas.map(function (s) { return s.id; });
                return res.data.filter(function (s) { return ids.indexOf(s.id) < 0; });
            }, function () {
                return [];
            });
        }

        function selecionarUsuario(item) {
            vm.equipe.usuarios.push({ usuario: item, funcao: 'DESENVOLVEDOR', cargo: null });
            vm.usuarioBusca = null;
        }

        function selecionarSistema(item) {
            vm.equipe.sistemas.push(item);
            vm.sistemaBusca = null;
        }

        function removerUsuario(userEquipe) {
            for (var i = 0; i < vm.equipe.usuarios.length; i++) {
                if (vm.equipe.usuarios[i].usuario.id === userEquipe.usuario.id) {
                    vm.equipe.usuarios.splice(i, 1);
                    return;
                }
            }
        }

        function removerSistema(sistema) {
            for (var i = 0; i < vm.equipe.sistemas.length; i++) {
                if (vm.equipe.sistemas[i].id === sistema.id) {
                    vm.equipe.sistemas.splice(i, 1);
                    return;
                }
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('equipe', {
            parent: 'entity',
            url: '/equipe',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'chamadosApp.equipe.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/equipe/equipe.html',
                    controller: 'EquipeController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('equipe');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('equipe.new', {
            parent: 'equipe',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/equipe/equipe-dialog.html',
                    controller: 'EquipeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                sistemas: [],
                                usuarios: [],
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('equipe', null, { reload: 'equipe' });
                }, function() {
                    $state.go('equipe');
                });
            }]
        })
        .state('equipe.edit', {
            parent: 'equipe',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/equipe/equipe-dialog.html',
                    controller: 'EquipeDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Equipe', function(Equipe) {
                            return Equipe.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('equipe', null, { reload: 'equipe' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }

})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('Equipe', Equipe);

    Equipe.$inject = ['$resource'];

    function Equipe($resource) {
        var resourceUrl = 'api/equipes/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'save': {method: 'POST'},
            'update': {method: 'PUT'},
            'delete': {method: 'DELETE'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('EquipeController', EquipeController);

    EquipeController.$inject = ['$scope', '$state', 'Equipe', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Alerta'];

    function EquipeController ($scope, $state, Equipe, ParseLinks, AlertService, paginationConstants, pagingParams, Alerta) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.remover = remover;
        
        loadAll();

        function loadAll () {
            Equipe.query({
                page: 0,
                size: 99
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.equipes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function remover(id) {
            Alerta.confirm("Atenção", "Tem certeza que deseja remover essa Equipe?", "warning", function () {
                Equipe.delete({id: id},
                    function () {
                        Alerta.success("Operação realizada", "A Equipe foi removida!");
                        loadAll();
                    });
            });
        }
        
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('entity', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('ClienteDialogController', ClienteDialogController);

    ClienteDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Cliente', 'User', 'Sistema'];

    function ClienteDialogController($timeout, $scope, $stateParams, $uibModalInstance, entity, Cliente, User, Sistema) {
        var vm = this;

        vm.cliente = entity;
        vm.clear = clear;
        vm.save = save;
        vm.indexSistema = indexSistema;
        vm.adicionarSistema = adicionarSistema;
        vm.removerSistema = removerSistema;
        vm.sistemas = Sistema.query({page: 0, size: 99});

        if (!vm.cliente.sistemas) {
            vm.cliente.sistemas = [];
        }

        vm.users = User.query({
            page: 0,
            size: 100,
            filtro: ''
        });

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            vm.isSaving = true;
            if (vm.cliente.id !== null) {
                Cliente.update(vm.cliente, onSaveSuccess, onSaveError);
            } else {
                Cliente.save(vm.cliente, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('chamadosApp:clienteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function indexSistema(id) {
            for (var i = 0; i < vm.cliente.sistemas.length; i++) {
                if (vm.cliente.sistemas[i].id === id) {
                    return i;
                }
            }
            return -1;
        }

        function adicionarSistema(sistema) {
            vm.cliente.sistemas.push(sistema);
        }

        function removerSistema(sistema) {
            vm.cliente.sistemas.splice(vm.indexSistema(sistema.id), 1)

        }

    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('cliente', {
            parent: 'entity',
            url: '/cliente?page&sort&search',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'chamadosApp.cliente.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/cliente/clientes.html',
                    controller: 'ClienteController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('cliente');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('cliente.new', {
            parent: 'cliente',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cliente/cliente-dialog.html',
                    controller: 'ClienteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                projetoRedMine: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('cliente', null, { reload: 'cliente' });
                }, function() {
                    $state.go('cliente');
                });
            }]
        })
        .state('cliente.edit', {
            parent: 'cliente',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/cliente/cliente-dialog.html',
                    controller: 'ClienteDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Cliente', function(Cliente) {
                            return Cliente.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('cliente', null, { reload: 'cliente' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }

})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('Cliente', Cliente);

    Cliente.$inject = ['$resource'];

    function Cliente($resource) {
        var resourceUrl = 'api/clientes/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'getByUser': {url: 'api/clientes-usuario', method: 'GET', isArray: true},
            'getBySistema': {url: 'api/clientes-sistema', method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'}
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('ClienteController', ClienteController);

    ClienteController.$inject = ['$scope', '$state', 'Cliente', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Alerta'];

    function ClienteController ($scope, $state, Cliente, ParseLinks, AlertService, paginationConstants, pagingParams, Alerta) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.remover = remover;
        vm.itemsPerPage = paginationConstants.itemsPerPage;

        loadAll();

        function loadAll () {
            Cliente.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort()
            }, onSuccess, onError);
            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }
            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.clientes = data;
                vm.page = pagingParams.page;
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function remover(id) {
            Alerta.confirm("Atenção", "Tem certeza que deseja remover esse Cliente?", "warning", function () {
                Cliente.delete({id: id},
                    function () {
                        Alerta.success("Operação realizada", "O Cliente foi removido!");
                        loadAll();
                    });
            });
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('Cidade', Cidade);

    Cidade.$inject = ['$resource'];

    function Cidade($resource) {
        return $resource('api/cidades/:id', {}, {
            'findByUf': {
                url: 'api/cidades-by-uf',
                method: 'GET',
                isArray: true
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('ChamadoDesenvolvimentoController', ChamadoDesenvolvimentoController);
    ChamadoDesenvolvimentoController.$inject = ['chamado', 'situacaoId', 'Chamado', '$state', 'Upload', 'AnexoChamado', 'SweetAlert', '$showdown'];

    function ChamadoDesenvolvimentoController(chamado, situacaoId, Chamado, $state, Upload, AnexoChamado, SweetAlert, $showdown) {
        var vm = this;
        vm.chamado = chamado;
        vm.chamado.alteracaoCodigo = true;
        vm.solicitacaoDesenvolvimento = {
            chamado: chamado,
            conteudo: chamado.conteudo,
            titulo: chamado.titulo
        };
        vm.chamado.complexidade = 'BAIXA';
        vm.chamado.releaseNotes = null;
        vm.calcularPlanoDesenvolvimento = calcularPlanoDesenvolvimento;
        vm.atualizarHoraEstimada = atualizarHoraEstimada;
        vm.conferirTempoApontadoComMedia = conferirTempoApontadoComMedia;
        vm.buscarHorasDoModuloAndSubmodulo = buscarHorasDoModuloAndSubmodulo;
        vm.melhorarComIa = melhorarComIa;
        console.log(">> >> >> >> > >  ", situacaoId)

        function buscarHorasDoModuloAndSubmodulo() {
            if (!vm.horasPorModulo || vm.horasPorModulo.length === 0) {
                Chamado.getTempoPorModuloSubModulo(vm.chamado, function (data) {
                    vm.horasPorModulo = data;
                    calcularPlanoDesenvolvimento();
                });
            }
        }

        buscarHorasDoModuloAndSubmodulo();

        function calcularPlanoDesenvolvimento() {
            vm.tempoTarefa = 0;
            if (vm.chamado.complexidade && chamado.tempoEstimado) {
                Chamado.calcularPlanoDesenvolvimento(vm.chamado, function (data) {
                    vm.chamado.planoDesenvolvimento = data;
                    var total = 0;
                    for (var i = 0; i < vm.chamado.planoDesenvolvimento.length; i++) {
                        var plano = vm.chamado.planoDesenvolvimento[i];
                        total = total + plano.tempoEstimado;

                        if (plano.tipoHora === 'DESENVOLVIMENTO' ||
                            plano.tipoHora === 'REVISAO') {
                            vm.tempoTarefa = vm.tempoTarefa + plano.tempoEstimado;
                        }

                    }
                });
                vm.conferirTempoApontadoComMedia();
            }
        }

        function melhorarComIa() {
            vm.gerandoComIa = true;
            Chamado.descricaoPOComIa({id: vm.chamado.id}, function (data) {
                vm.chamado.descricaoPo = $showdown.makeHtml(data.mensagem);
                vm.gerandoComIa = false;
            }, function (err) {
                vm.gerandoComIa = false;
            });
        }


        function atualizarHoraEstimada() {
            var horas = 0;
            angular.forEach(vm.chamado.planoDesenvolvimento, function (plano) {
                horas = horas + plano.tempoEstimado;
            });

            vm.chamado.tempoEstimado = horas;
        }


        function conferirTempoApontadoComMedia() {
            vm.tempoEstimadoMenorQueMedia = false;
            for (var i = 0; i < vm.horasPorModulo.length; i++) {
                var media = vm.horasPorModulo[i];
                media.escolhida = false;
                if (media.tipoChamado === vm.chamado.tipoChamado
                    && media.complexidade === vm.chamado.complexidade
                    && vm.chamado.tempoEstimado < media.tempoGasto) {
                    vm.tempoEstimadoMenorQueMedia = true;
                    media.escolhida = true;
                    vm.verHorasModulo = true;
                }
            }
        }

        vm.ok = function () {
            vm.isSaving = true;
            if (vm.criterio)
                vm.chamado.criterio = vm.criterio;
            Chamado.update(vm.chamado, function (chamado) {
                vm.tempoGasto = {chamado: vm.chamado, criadoEm: new Date(), horas: 0, minutos: 0};
                vm.tempoGasto.criadoEm = new Date();
                vm.tempoGasto.numero = 23;
                vm.tempoGasto.conteudo = 'Análise';
                vm.tempoGasto.tempo = vm.horaAnalise;
                Chamado.defirnirTempo(vm.tempoGasto);
                Chamado.moverSituacao({
                    id: chamado.id,
                    situacaoConfigId: situacaoId
                }, {}, function (result) {
                    $state.go('edit-chamado', {id: chamado.id}, {reload: true});
                }, function () {
                    vm.isSaving = false;
                });

            }, function (error) {
            });

        };

        vm.cancel = function () {
            // $uibModalInstance.dismiss('cancel');
            $state.go('edit-chamado', {id: vm.chamado.id}, {reload: true});
        };

        vm.removerAnexo = function (index, anexos) {
            SweetAlert.swal({
                    title: "Atenção",
                    text: "Tem certeza que deseja remover esse anexo?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        var anexo = anexos[index];
                        if (anexo.id) {
                            AnexoChamado.delete({id: anexo.id});
                        }
                        anexos.splice(index, 1);
                    }
                });

        };

        vm.upload = function ($file) {
            if ($file) {
                if (!vm.anexos) {
                    vm.anexos = [];
                }
                Upload.dataUrl($file, true).then(
                    function (conteudo) {
                        var anexo = {};
                        anexo.descricao = $file.name;
                        anexo.conteudo = conteudo;
                        anexo.tipo = 'INTERNO';
                        anexo.mimeType = $file.type;
                        if (vm.chamado.id) {
                            anexo.chamado = vm.chamado;
                            AnexoChamado.save(anexo, function (data) {
                                vm.anexosInternos.push(data);
                            });

                        } else {
                            vm.anexosInternos.push(anexo);
                        }
                    }
                );
            } else {
                Alerta.warn("Atenção!", "Você deve selecionar um arquivo de até 100Mb");
            }
        };

        function carregarAnexos() {
            vm.anexos = [];
            vm.anexosInternos = [];
            vm.chamado.id ? AnexoChamado.query({id: vm.chamado.id}, function (data) {
                for (var i = 0; i < data.length; i++) {
                    var anexo = data[i];
                    if (anexo.tipo === 'PUBLICO') {
                        vm.anexos.push(anexo);
                    } else {
                        vm.anexosInternos.push(anexo);
                    }
                }
            }) : [];
        }

        carregarAnexos();
    };

    angular
        .module('chamadosApp')
        .controller('ReestimarChamadoController', ReestimarChamadoController);
    ReestimarChamadoController.$inject = ['$uibModalInstance', 'chamado', 'Chamado'];

    function ReestimarChamadoController($uibModalInstance, chamado, Chamado) {
        var vm = this;
        vm.chamado = chamado;
        vm.calcularPlanoDesenvolvimento = calcularPlanoDesenvolvimento;
        vm.atualizarHoraEstimada = atualizarHoraEstimada;


        function calcularPlanoDesenvolvimento() {
            if (vm.chamado.complexidade && chamado.tempoEstimado)
                Chamado.calcularPlanoDesenvolvimento(vm.chamado, function (data) {
                    vm.chamado.planoDesenvolvimento = data;
                    var total = 0;
                    for (var i = 0; i < vm.chamado.planoDesenvolvimento.length; i++) {
                        var plano = vm.chamado.planoDesenvolvimento[i];
                        total = total + plano.tempoEstimado;
                    }
                });
        }

        function atualizarHoraEstimada() {
            var horas = 0;
            angular.forEach(vm.chamado.planoDesenvolvimento, function (plano) {
                horas = horas + plano.tempoEstimado;
            });

            vm.chamado.tempoEstimado = horas;
        }

        vm.ok = function () {
            vm.isSaving = true;
            $uibModalInstance.close(vm.chamado);
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    };

    angular
        .module('chamadosApp')
        .controller('ChamadoRejeicaoController', ChamadoRejeicaoController);
    ChamadoRejeicaoController.$inject = ['$uibModalInstance', 'comentario'];

    function ChamadoRejeicaoController($uibModalInstance, comentario) {
        var vm = this;
        vm.comentario = comentario;


        vm.ok = function () {
            vm.isSaving = true;
            vm.comentario.descricao = "<strong>Rejeição do Chamado:</strong><br/>" +
                "<strong>Ambiente em que o teste foi realizado: </strong><br/>" +
                "" + vm.ambiente + "<br/> <br/>" +
                "<strong>Motivo da Rejeição: <br/></strong>" +
                "" + (vm.motivoRejeicao === 'NAO_ATENDIDO' ? 'Um ou mais de um item solicitado originalmente não foi atendido.' : ' O solicitado originalmente foi atendido porém correções são necessárias para liberação.') + "<br/> <br/>" +
                (vm.motivoRejeicao === 'NAO_ATENDIDO' ? '<strong>Item ou os itens que não foram atendidos: </strong><br/> ' : '') +
                (vm.motivoRejeicao === 'NAO_ATENDIDO' ? vm.itemNaoAtendido + ' <br/> <br/>' : '') +
                "<strong>Como realizar o teste e o motivo da rejeição: </strong><br/>" +
                vm.descricaoRejeicao + "<br/> <br/>";
            $uibModalInstance.close(vm.comentario);
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    };

    angular
        .module('chamadosApp')
        .controller('ChamadoTesteController', ChamadoTesteController);
    ChamadoTesteController.$inject = ['$uibModalInstance', 'comentario', 'Upload', 'Alerta'];

    function ChamadoTesteController($uibModalInstance, comentario, Upload, Alerta) {
        var vm = this;
        vm.comentario = comentario;
        vm.upload = upload;
        vm.removerAnexo = removerAnexo;
        vm.descricaoTeste = '';

        function upload($file) {
            if ($file) {
                if (!vm.anexos) {
                    vm.anexos = [];
                }
                Upload.dataUrl($file, true).then(
                    function (conteudo) {
                        var anexo = {};
                        anexo.descricao = $file.name;
                        anexo.conteudo = conteudo;
                        anexo.mimeType = $file.type;
                        vm.descricaoTeste = vm.descricaoTeste + " Anexado o arquivo - " + anexo.descricao + "\n";
                        vm.anexos.push(anexo);
                    }
                );
            } else {
                Alerta.warn("Atenção!", "Você deve selecionar um arquivo de até 10Mb");
            }
        }


        function removerAnexo(index) {
            SweetAlert.swal({
                    title: "Atenção",
                    text: "Tem certeza que deseja remover esse anexo?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        vm.anexos.splice(index, 1);
                    }
                });
        }

        vm.ok = function () {
            vm.isSaving = true;
            vm.comentario.descricao = "<strong>Teste do Chamado:</strong><br/>" +
                "<strong>Ambiente em que o teste foi realizado: </strong><br/>" +
                "" + vm.ambiente + "<br/> <br/>" +
                "<strong>Descrição do teste: <br/></strong>" +
                vm.descricaoTeste + "<br/> <br/>" +
                "<strong>Houve atualização do manual? <br/></strong>" +
                vm.manual + "<br/> <br/>";
            vm.comentario.anexos = vm.anexos;
            $uibModalInstance.close(vm.comentario);
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    };

    angular
        .module('chamadosApp')
        .controller('ChamadoImpedidoController', ChamadoImpedidoController);
    ChamadoImpedidoController.$inject = ['$uibModalInstance', 'comentario'];

    function ChamadoImpedidoController($uibModalInstance, comentario) {
        var vm = this;
        vm.comentario = comentario;

        vm.ok = function () {
            vm.isSaving = true;
            vm.comentario.descricao = "<strong>Chamado Impedido:</strong><br/>" + vm.motivoImpedido + "<br/> <br/>";
            $uibModalInstance.close(vm.comentario);
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    };

    angular
        .module('chamadosApp')
        .controller('ChamadoReabertoController', ChamadoReabertoController);
    ChamadoReabertoController.$inject = ['$uibModalInstance', 'comentario', 'Upload'];

    function ChamadoReabertoController($uibModalInstance, comentario, Upload) {
        var vm = this;
        vm.comentario = comentario;
        vm.upload = upload;
        vm.removerAnexo = removerAnexo;

        function upload($file) {
            if ($file) {
                if (!vm.anexos) {
                    vm.anexos = [];
                }
                Upload.dataUrl($file, true).then(
                    function (conteudo) {
                        var anexo = {};
                        anexo.descricao = $file.name;
                        anexo.conteudo = conteudo;
                        anexo.mimeType = $file.type;
                        vm.descricaoTeste = vm.descricaoTeste + " Anexado o arquivo - " + anexo.descricao + "\n";
                        vm.anexos.push(anexo);
                    }
                );
            } else {
                Alerta.warn("Atenção!", "Você deve selecionar um arquivo de até 10Mb");
            }
        }


        function removerAnexo(index) {
            SweetAlert.swal({
                    title: "Atenção",
                    text: "Tem certeza que deseja remover esse anexo?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        vm.anexos.splice(index, 1);
                    }
                });
        }


        vm.ok = function () {
            vm.comentario.anexos = vm.anexos;
            vm.isSaving = true;
            vm.comentario.descricao = "<strong>Chamado Reaberto:</strong><br/>" + vm.motivoReabrir + "<br/> <br/>";
            $uibModalInstance.close(vm.comentario);
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    };

    angular
        .module('chamadosApp')
        .controller('AjustarChamadoController', AjustarChamadoController);
    AjustarChamadoController.$inject = ['$uibModalInstance', 'chamado', 'Sprint', 'Modulo', 'SubModulo', 'Sistema', 'Cliente'];

    function AjustarChamadoController($uibModalInstance, chamado, Sprint, Modulo, SubModulo, Sistema, Cliente) {
        var vm = this;

        vm.chamado = chamado;
        vm.sprints = Sprint.query();
        vm.modulos = Modulo.queryByUser();
        vm.sistemas = Sistema.query;

        vm.carregarSubModulo = carregarSubModulo;
        vm.carregarSistemas = carregarSistemas;

        vm.ok = function () {
            vm.isSaving = true;
            $uibModalInstance.close(vm.chamado);
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function carregarSubModulo() {
            if (vm.chamado.modulo) {
                vm.submodulos = SubModulo.queryByModulo({id: vm.chamado.modulo.id});
            }
        }

        function carregarSistemas() {
            if (vm.chamado.cliente) {
                Sistema.getByCliente({clienteId: vm.chamado.cliente.id}, function (data) {
                    vm.sistemas = data;
                });
            } else {
                vm.sistemas = [];
            }
        }

        Cliente.getByUser({}, function (data) {
            vm.clientes = data;
        });


        carregarSubModulo();
        carregarSistemas();
    };

    angular
        .module('chamadosApp')
        .controller('ChamadoAceiteController', ChamadoAceiteController);
    ChamadoAceiteController.$inject = ['$uibModalInstance', 'chamado', 'Cliente'];

    function ChamadoAceiteController($uibModalInstance, entity) {
        var vm = this;

        vm.chamado = entity;
        vm.clear = clear;
        vm.confirmAceite = confirmAceite;
        vm.renderPergunta = renderPergunta;
        vm.isRequiredPergunta = isRequiredPergunta;
        vm.minLenghtPergunta = minLenghtPergunta;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmAceite() {
            vm.chamado.conteudo += montarString();
            $uibModalInstance.close(vm.chamado);
        }

        function init() {
            switch (vm.chamado.tipoChamado) {
            case 'BUG':
                vm.pergunta1 = 'O que você espera que a funcionalidade faça? ';
                vm.pergunta2 = 'O que ele está fazendo? ';
                vm.pergunta3 = 'O caminho do erro (a URL inteira, tela) ';
                vm.pergunta4 = 'Qual a base de teste, aplicação? ';
                break;
            case 'MELHORIA':
                vm.pergunta1 = 'O que você espera que a funcionalidade faça? ';
                vm.pergunta2 = 'Como essa melhoria ira te ajudar? ';
                vm.pergunta3 = 'Em qual menu está melhoria devera fica? ';
                vm.pergunta4 = 'Há fundamentação legal? Se sim, informar ';
                break;
            case 'NOVA_FUNCIONALIDADE':
                vm.pergunta1 = 'Qual o caminho no menu para chegar na nova funcionalidade? ';
                vm.pergunta2 = 'Há fundamentação legal? Se sim, informar ';
            }
        }

        function montarString() {
            switch (vm.chamado.tipoChamado) {
            case 'BUG' :
            case 'MELHORIA':
                return "<p><strong>" + vm.pergunta1 + "</strong></p><p>" + (vm.resposta1 ? vm.resposta1 : 'não informado') + "</p>" +
                    "<p><strong>" + vm.pergunta2 + "</strong></p><p>" + (vm.resposta2 ? vm.resposta2 : 'não informado') + "</p>" +
                    "<p><strong>" + vm.pergunta3 + "</strong></p><p>" + (vm.resposta3 ? vm.resposta3 : 'não informado') + "</p>" +
                    "<p><strong>" + vm.pergunta4 + "</strong></p><p>" + (vm.resposta4 ? vm.resposta4 : 'não informado') + "</p>";
            case 'NOVA_FUNCIONALIDADE':
                return "<p><strong>" + vm.pergunta1 + "</strong></p><p>" + (vm.resposta1 ? vm.resposta1 : 'não informado') + "</p>" +
                    "<p><strong>" + vm.pergunta2 + "</strong></p><p>" + (vm.resposta2 ? vm.resposta2 : 'não informado') + "</p>";
            }
        }

        function renderPergunta(numero) {
            switch (vm.chamado.tipoChamado) {
            case 'BUG':
                return numero <= 4;
            case 'MELHORIA':
                return numero <= 4;
            case 'NOVA_FUNCIONALIDADE':
                return numero <= 2;
            }
        }

        function isRequiredPergunta(numero) {
            switch (vm.chamado.tipoChamado) {
            case 'BUG':
                return true;
            case 'MELHORIA':
                return numero !== 4;
            case 'NOVA_FUNCIONALIDADE':
                return numero === 1;
            }
        }

        function minLenghtPergunta(numero) {
            switch (vm.chamado.tipoChamado) {
            case 'BUG':
                if (numero === 4)
                    return 5;
            case 'MELHORIA':
                if (numero === 1 || numero === 2)
                    return 50;
                if (numero === 3)
                    return 10;
                break;
            case 'NOVA_FUNCIONALIDADE':
                if (numero === 1)
                    return 10;
                break;
            }
            return 0;
        }


        init();
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('NovaTarefaChamadoController', NovaTarefaChamadoController);

    NovaTarefaChamadoController.$inject = ['chamado', 'SolicitacaoDesenvolvimento', '$state', 'Alerta'];

    function NovaTarefaChamadoController(chamado, SolicitacaoDesenvolvimento, $state, Alerta) {
        var vm = this;
        vm.chamado = chamado;
        vm.tiposTarefa = ['BUG', 'HISTORIA', 'SCRUM', 'REUNIAO', 'SPIKE'];
        vm.isSaving = false;

        vm.solicitacaoDesenvolvimento = {
            chamado: {id: chamado.id},
            titulo: tituloPadrao(),
            tipo: tipoPadrao(),
            tempoEstimado: chamado.tempoEstimado || 1,
            conteudo: chamado.conteudo,
            criterio: chamado.criterio
        };

        vm.salvar = salvar;
        vm.cancelar = cancelar;

        function tituloPadrao() {
            var base = chamado.titulo || ('Chamado #' + chamado.id);
            var qtd = chamado.solicitacoesDesenvolvimento ? chamado.solicitacoesDesenvolvimento.length : 0;
            if (qtd > 0) {
                return base + ' — tarefa ' + (qtd + 1);
            }
            return base;
        }

        function tipoPadrao() {
            var map = {
                BUG: 'BUG',
                MELHORIA: 'HISTORIA',
                NOVA_FUNCIONALIDADE: 'HISTORIA',
                SUPORTE: 'SPIKE',
                ATA: 'REUNIAO'
            };
            return map[chamado.tipoChamado] || 'HISTORIA';
        }

        function salvar() {
            if (!vm.solicitacaoDesenvolvimento.titulo || !vm.solicitacaoDesenvolvimento.tipo) {
                Alerta.warn('Atenção', 'Preencha título e tipo da tarefa.');
                return;
            }
            if (!vm.solicitacaoDesenvolvimento.tempoEstimado || vm.solicitacaoDesenvolvimento.tempoEstimado <= 0) {
                Alerta.warn('Atenção', 'Informe o tempo estimado em horas.');
                return;
            }
            vm.isSaving = true;
            vm.solicitacaoDesenvolvimento.chamado = {id: chamado.id};
            vm.solicitacaoDesenvolvimento.conteudo = chamado.conteudo;
            vm.solicitacaoDesenvolvimento.criterio = chamado.criterio;

            SolicitacaoDesenvolvimento.save(vm.solicitacaoDesenvolvimento, function (result) {
                vm.isSaving = false;
                Alerta.success('Operação realizada', 'Tarefa #' + result.numero + ' criada.');
                $state.go('edit-chamado', {id: chamado.id}, {reload: true});
            }, function () {
                vm.isSaving = false;
                Alerta.error('Operação não realizada', 'Não foi possível criar a tarefa. Verifique permissões e situação do chamado.');
            });
        }

        function cancelar() {
            $state.go('edit-chamado', {id: chamado.id});
        }
    }
})();

(function () {
    'use strict';

    var template = '<table class="jh-table table table-striped table-hover">' +
        '<tbody>' +
        '<tr>' +
        '<th>Ordem</th>' +
        '<th class="issue-info">' +
        'Nº do chamado' +
        '<small>Titulo</small>' +
        '</th>' +
        '<th class="issue-info">' +
        'Solicitante' +
        '<small>Responsável</small>' +
        '</th>' +
        '<th>Data</th>' +
        '<th>Tempo</th>' +
        '<th>Módulo</th>' +
        '</tr>' +
        '<tr ng-repeat="chamado in chamados track by chamado.id">' +
        '<td>' +
        '{{chamado.ordem}}' +
        '</td>' +
        '<td class="issue-info" style="width: 30%">' +
        '<a ui-sref="edit-chamado({id:chamado.id})">' +
        '#{{chamado.id}} - ' +
        '<span class="text-{{getCorPorTipo(chamado.tipoChamado)}}"  data-translate="{{\'chamadosApp.TipoChamado.\' + chamado.tipoChamado}}">{{chamado.tipoChamado}}</span>' +
        '</a>' +
        '<small>' +
        '{{chamado.titulo}}' +
        '</small>' +
        '</td>' +
        '<td class="issue-info" style="width: 10%">' +
        '{{chamado.solicitante.firstName}}' +
        '<small>' +
        '{{chamado.responsavel.firstName}}' +
        '</small>' +
        '</td>' +
        '<td>{{chamado.criadoEm | date:\'mediumDate\'}}</td>' +
        '<td>' +
        '' +
        '<i ng-if="chamado.tempoEstimado" class="fa fa-clock-o"></i>' +
        '{{chamado.tempoEstimado}}' +
        '</td>' +
        '<td>' +
        '{{chamado.modulo.descricao}}' +
        '</td>' +
        '</tr>' +
        '</tbody>' +
        '</table>';


    angular
        .module('chamadosApp')
        .directive('listChamado', listChamado);

    function listChamado() {
        var directive = {
            template: template,
            restrict: 'E',
            scope: {
                chamados: '=value'
            },
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, ngModel) {

            scope.getCorPorTipo = function(tipo) {
                switch (tipo) {
                    case 'SUPORTE':
                        return 'warning';
                    case 'BUG':
                        return 'danger';
                    case 'MELHORIA':
                        return 'info';
                    case 'NOVA_FUNCIONALIDADE':
                        return 'success';
                    default:
                        return 'info';
                }
            }

            scope.getCorPorSituacao = function(tipo) {
                switch (tipo) {
                    case 'AGUARDANDO_TESTE':
                        return 'warning';
                    case 'IMPEDIDO':
                        return 'danger';
                    case 'ABERTO':
                        return 'info';
                    case 'EM_DESENVOLVIMENTO':
                        return 'success';
                    default:
                        return 'info';
                }
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('ChamadoEditController', ChamadoEditController);

    ChamadoEditController.$inject = ['$timeout', '$scope',
        '$state', 'previousState', 'entity',
        'Cliente', 'Sistema', 'Chamado', 'Sprint',
        'Modulo', 'Principal',
        '$uibModal', 'Alerta',
        'Upload', 'AnexoChamado',
        'Account', '$http',
        'SweetAlert', 'SubModulo', '$sanitize',
        'SolicitacaoDesenvolvimento', '$filter', 'Agrupador', 'Solicitante', 'SituacaoConfig'];

    function ChamadoEditController($timeout, $scope,
        $state, previousState, entity,
        Cliente, Sistema, Chamado, Sprint,
        Modulo, Principal,
        $uibModal, Alerta,
        Upload, AnexoChamado,
        Account, $http,
        SweetAlert, SubModulo, $sanitize,
        SolicitacaoDesenvolvimento, $filter, Agrupador, Solicitante, SituacaoConfig) {
        var vm = this;
        vm.chamado = entity;
        vm.ordemOriginal = vm.chamado.ordem;
        vm.solicitacoes = [];
        vm.datePickerOpenStatus = {};
        vm.tempoGasto = {chamado: vm.chamado, criadoEm: new Date(), horas: 0, minutos: 0};
        vm.save = save;
        vm.saveAndSolicitaDev = saveAndSolicitaDev;
        vm.saveAndEnviaBackLog = saveAndEnviaBackLog;
        vm.saveSuporte = saveSuporte;
        vm.aceitar = aceitar;
        vm.comentar = comentar;
        vm.solicitarDesenvolvimento = solicitarDesenvolvimento;
        vm.solicitarDesenvolvimentoTicketExistente = solicitarDesenvolvimentoTicketExistente;
        vm.encaminharPO = encaminharPO;
        vm.liberarTeste = liberarTeste;
        vm.retornarDesenvolvimento = retornarDesenvolvimento;
        vm.liberarTesteSuporte = liberarTesteSuporte;
        vm.reprovarDesenvolvimento = reprovarDesenvolvimento;
        vm.impedir = impedir;
        vm.reabrir = reabrir;
        vm.copiar = copiar;
        vm.melhorarComIa = melhorarComIa;
        vm.copiarSimples = copiarSimples;
        vm.encerrar = encerrar;
        vm.validarTeste = validarTeste;
        vm.validarTesteUsuario = validarTesteUsuario;
        vm.rejeitar = rejeitar;
        vm.upload = upload;
        vm.removerAnexo = removerAnexo;
        vm.inserirAnexoConteudo = inserirAnexoConteudo;
        vm.removerSolicitacaoDesenvolvimento = removerSolicitacaoDesenvolvimento;
        vm.downloadAnexo = downloadAnexo;
        vm.calcularOrdem = calcularOrdem;
        vm.buscarRedMine = buscarRedMine;
        vm.definirTempoGasto = definirTempoGasto;
        vm.carregarSubModulo = carregarSubModulo;
        vm.criarDependencia = criarDependencia;
        vm.removerDependencia = removerDependencia;
        vm.removerTodasDependencia = removerTodasDependencia;
        vm.html5Entities = html5Entities;
        vm.trustAsHtml = trustAsHtml;
        vm.carregarSistemas = carregarSistemas;
        vm.sprints = Sprint.query();
        vm.modulos = Modulo.queryByUser();
        vm.previousState = previousState.name;
        vm.ajustarChamado = ajustarChamado;
        vm.aprovarChamado = aprovarChamado;
        vm.reestimarChamado = reestimarChamado;
        vm.alocarChamadoSprintAtual = alocarChamadoSprintAtual;
        vm.desalocarChamadoSprintAtual = desalocarChamadoSprintAtual;
        vm.adicionarTag = adicionarTag;
        vm.moverParaSituacao = moverParaSituacao;
        vm.proximasSituacoes = [];
        vm.tags = [];
        vm.situacoesIniciais = [];

        vm.situacoesMoverFiltradas = situacoesMoverFiltradas;

        if (vm.chamado.tempoEstimado) {
            vm.temposEstimados = [];
        }

        getAccount();

        function html5Entities(value) {
            return value.replace(/[\u00A0-\u9999<>\&\'\"]/gim, function (i) {
                return '&#' + i.charCodeAt(0) + ';';
            });
        };

        function trustAsHtml(value) {
            return $sanitize(value);
        };

        $timeout(function () {
            buscarTagsPorChamado();
            angular.element('.form-group:eq(1)>input').focus();
            carregarSistemas();
            carregarSubModulo();
            carregarAnexos();
            carregarSolicitacoesDev();
            contarTempoGasto();
            carregarComentarios();
            carregarFotoSolicitante();
            carregarDependentes();
            carregarAgrupadores();
            carregarProximasSituacoes();
        });

        function buscarTagsPorChamado() {
            if (vm.chamado.id) {
                vm.tags = Chamado.getTagsPorChamado({id: vm.chamado.id});
            }
        }

        function alocarChamadoSprintAtual() {
            // Mid-sprint (EM_ANDAMENTO): api/alocar-tarefa — não usar APIs de planejamento (ABERTA).
            vm.isSaving = true;
            Chamado.getSolicitacoes({id: vm.chamado.id}, function (tarefas) {
                var elegiveis = (tarefas || []).filter(function (tarefa) {
                    return tarefa.situacao === 'A_FAZER' && !tarefa.sprint;
                });
                if (!elegiveis.length) {
                    vm.isSaving = false;
                    Alerta.warn('Atenção!', 'Não há tarefas A fazer sem sprint para alocar na sprint em andamento.');
                    return;
                }
                processarTarefasMidSprint(elegiveis, 0, true);
            }, onSaveError);
        }

        function desalocarChamadoSprintAtual() {
            // Mid-sprint: limpa sprint das tarefas A_FAZER via update (sem endpoint desalocar-tarefa).
            vm.isSaving = true;
            Chamado.getSolicitacoes({id: vm.chamado.id}, function (tarefas) {
                var elegiveis = (tarefas || []).filter(function (tarefa) {
                    return tarefa.situacao === 'A_FAZER' && !!tarefa.sprint;
                });
                if (!elegiveis.length) {
                    vm.isSaving = false;
                    Alerta.warn('Atenção!', 'Não há tarefas A fazer alocadas para remover da sprint.');
                    return;
                }
                processarTarefasMidSprint(elegiveis, 0, false);
            }, onSaveError);
        }

        function processarTarefasMidSprint(tarefas, index, alocar) {
            if (index >= tarefas.length) {
                vm.chamado.situacao = alocar ? 'EM_DESENVOLVIMENTO' : 'AGUARDANDO_DESENVOLVIMENTO';
                Chamado.update(vm.chamado, onSaveSuccess, onSaveError);
                return;
            }
            var tarefa = tarefas[index];
            if (alocar) {
                SolicitacaoDesenvolvimento.alocar(tarefa, function () {
                    processarTarefasMidSprint(tarefas, index + 1, alocar);
                }, onSaveError);
            } else {
                tarefa.sprint = null;
                tarefa.sprintOriginal = null;
                SolicitacaoDesenvolvimento.update(tarefa, function () {
                    processarTarefasMidSprint(tarefas, index + 1, alocar);
                }, onSaveError);
            }
        }

        function carregarFotoSolicitante() {
            Account.getImagemAjustadaByLogin({login: vm.chamado.solicitante.login}, function (data) {
                vm.fotoSolicitante = data.imagemAjustada;
            });
        }

        function carregarComentarios() {
            if (vm.chamado.id) {
                Chamado.getComentarios({id: vm.chamado.id}, function (data) {
                    vm.comentarios = data;
                    angular.forEach(vm.comentarios, function (comentario) {
                        Account.getImagemAjustadaByLogin({login: comentario.usuario.login}, function (data) {
                            comentario.imagemUsuario = data.imagemAjustada;
                        });
                        if (comentario.descricao === 'Aceite de chamado') {
                            vm.aceitoPor = comentario;
                        }
                    });
                });
                vm.comentario = {chamado: vm.chamado, usuario: vm.account};
            }
        }

        function carregarSolicitacoesDev() {
            if (vm.chamado.id) {
                Chamado.getSolicitacoes({id: vm.chamado.id}, function (data) {
                    vm.solicitacoes = data;
                    if (vm.solicitacoes.length > 0) {
                        if (vm.chamado.situacao === 'EM_DESENVOLVIMENTO') {
                            vm.chamado.desenvolvimentoIniciado = true;
                        }
                        for (var i = 0; i < vm.solicitacoes.length; i++) {
                            if (vm.solicitacoes[i].situacao === "A fazer") {
                                vm.chamado.desenvolvimentoIniciado = false;
                            }
                        }
                    }
                });
            }
        }

        function carregarDependentes() {
            if (vm.chamado.id) {
                vm.dependentes = Chamado.getDependentes({id: vm.chamado.id});
                vm.relacoes = Chamado.getRelacoes({id: vm.chamado.id});
            }
        }

        function carregarAgrupadores() {
            if (vm.chamado.id) {
                vm.agrupadores = Agrupador.getBychamado({id: vm.chamado.id});
            }
        }

        function carregarProximasSituacoes() {
            if (vm.chamado.id && vm.chamado.situacaoConfig) {
                Chamado.getProximasSituacoes({
                    situacaoAtualId: vm.chamado.situacaoConfig.id,
                    clienteId: vm.chamado.cliente ? vm.chamado.cliente.id : null
                }, function (data) {
                    vm.proximasSituacoes = data;
                });
            }
        }

        function usuarioPodeMoverParaSituacaoDestino(destinoConfig) {
            if (!destinoConfig) {
                return false;
            }
            var roles = destinoConfig.authorities;
            if (!angular.isArray(roles) || roles.length === 0) {
                return true;
            }
            return Principal.hasAnyAuthority(roles);
        }

        function situacoesMoverFiltradas() {
            var list = vm.proximasSituacoes;
            if (!list || !list.length) {
                return [];
            }
            return list.filter(function (situacaoDestino) {
                return usuarioPodeMoverParaSituacaoDestino(situacaoDestino);
            });
        }

        function moverParaSituacao(situacao) {
            if (situacaoInicial(vm.chamado)) {
                abrirConferenciaMovimentacao(situacao);
                return;
            }
            confirmarMovimentacao(situacao);
        }

        function situacaoInicial(chamado) {
            return !!(chamado && chamado.situacaoConfig && chamado.situacaoConfig.inicial);
        }

        function confirmarMovimentacao(situacao) {
            Alerta.confirm("Confirme a operação",
                "Deseja mover o chamado para '" + situacao.descricao + "'?",
                "warning",
                function () {
                    executarMovimentacao(situacao);
                },
                function () {
                    vm.isSaving = false;
                });
        }

        function executarMovimentacao(situacao) {
            vm.isSaving = true;
            if (situacao && situacao.permiteInserirAnalisePo) {
                $state.go('solicitar-desenvolvimento', {id: vm.chamado.id, situacaoId: situacao.id});
            } else {
                Chamado.moverSituacao({
                    id: vm.chamado.id,
                    situacaoConfigId: situacao.id
                }, {}, function (result) {
                    vm.chamado = result;
                    vm.isSaving = false;
                    carregarProximasSituacoes();
                    carregarComentarios();
                }, function () {
                    vm.isSaving = false;
                    carregarProximasSituacoes();
                });
            }
        }

        function abrirConferenciaMovimentacao(situacao) {
            var copia = angular.copy(vm.chamado);
            var modalInstance = $uibModal.open({
                size: 'md',
                animation: true,
                templateUrl: 'conferirMovimentacaoDialog.html',
                controller: 'ConferirMovimentacaoChamadoController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'modal-grande',
                resolve: {
                    chamado: function () {
                        return copia;
                    }
                }
            });

            modalInstance.result.then(function (chamadoConferido) {
                var modulo = vm.chamado.modulo;
                var subModulo = vm.chamado.subModulo;
                var cliente = vm.chamado.cliente;
                var severidade = vm.chamado.severidade;
                var sistema = vm.chamado.sistema;
                var tipoChamado = vm.chamado.tipoChamado;
                vm.chamado.modulo = chamadoConferido.modulo;
                vm.chamado.subModulo = chamadoConferido.subModulo;
                vm.chamado.cliente = chamadoConferido.cliente;
                vm.chamado.severidade = chamadoConferido.severidade;
                vm.chamado.sistema = chamadoConferido.sistema;
                vm.chamado.tipoChamado = chamadoConferido.tipoChamado;
                vm.isSaving = true;
                Chamado.update(vm.chamado, function (salvo) {
                    if (salvo && salvo.version !== undefined) {
                        vm.chamado.version = salvo.version;
                    }
                    executarMovimentacao(situacao);
                }, function () {
                    vm.chamado.modulo = modulo;
                    vm.chamado.subModulo = subModulo;
                    vm.chamado.cliente = cliente;
                    vm.chamado.severidade = severidade;
                    vm.chamado.sistema = sistema;
                    vm.chamado.tipoChamado = tipoChamado;
                    vm.isSaving = false;
                });
            }, angular.noop);
        }

        function contarTempoGasto() {
            if (vm.chamado.id) {
                Chamado.getTempoGasto({id: vm.chamado.id}, function (data) {
                    vm.tempos = {};
                    vm.tempoTotalGasto = 0;
                    angular.forEach(data, function (tempo) {
                        vm.tempoTotalGasto = vm.tempoTotalGasto + tempo.tempo;
                        if (!vm.tempos[tempo.tipo]) {

                            vm.tempos[tempo.tipo] = {
                                tipo: tempo.tipo ? $filter('translate')('chamadosApp.TipoHora.' + tempo.tipo) : tempo.conteudo,
                                tempo: tempo.tempo
                            };
                        } else {
                            vm.tempos[tempo.tipo].tempo = vm.tempos[tempo.tipo].tempo + tempo.tempo;
                        }
                    });
                });
            }
        }

        function carregarAnexos() {
            vm.anexos = [];
            vm.anexosInternos = [];
            vm.chamado.id ? AnexoChamado.query({id: vm.chamado.id}, function (data) {
                for (var i = 0; i < data.length; i++) {
                    var anexo = data[i];
                    if (anexo.tipo === 'PUBLICO') {
                        vm.anexos.push(anexo);
                    } else {
                        vm.anexosInternos.push(anexo);
                    }
                }
            }) : [];
        }

        function removerAnexo(index, anexos) {
            SweetAlert.swal({
                    title: "Atenção",
                    text: "Tem certeza que deseja remover esse anexo?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        var anexo = anexos[index];
                        if (anexo.id) {
                            AnexoChamado.delete({id: anexo.id});
                        }
                        anexos.splice(index, 1);
                        comentarTextoChamado("Anexo " + anexo.descricao + " removido");

                    }
                });

        }

        function inserirAnexoConteudo(index) {
            var anexo = vm.anexos[index];

            if (!vm.chamado.conteudo)
                vm.chamado.conteudo = "";
            vm.chamado.conteudo += "\n";

            if (anexo.mimeType.includes("image")) {
                vm.chamado.conteudo += "<img style='width: 50%; height: 50%;' src=\"" + anexo.conteudo + "\">";
                vm.anexos.splice(index, 1);
            }
        }

        function removerSolicitacaoDesenvolvimento(index) {
            SweetAlert.swal({
                    title: "Atenção",
                    text: "Tem certeza que deseja remover esse vinculo com o ticket?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        var solicitacao = vm.solicitacoes[index];
                        if (solicitacao.id) {
                            Chamado.removerSolicitacaoDesenvolvimento({id: solicitacao.id});
                        }
                        vm.solicitacoes.splice(index, 1);
                    }
                });
        }

        function comentarTextoChamado(texto) {
            Chamado.comentar({
                chamado: vm.chamado,
                usuario: vm.account,
                descricao: texto
            }, function (data) {
                vm.comentario = {chamado: vm.chamado};
                carregarComentarios();
                vm.isSaving = false;
            }, onSaveError);
        }

        function downloadAnexo(index, lista) {
            var anexo = lista[index];
            AnexoChamado.downloadAnexo(anexo);
        }


        function saveAndEnviaBackLog() {
            SweetAlert.swal({
                    title: "Atenção",
                    text: "Tem certeza que deseja enviar esse chamado para Backlog e aguardar aprovação do cliente?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        vm.chamado.situacao = 'BACKLOG';
                        save();
                    }
                });
        }

        function saveAndSolicitaDev() {
            SweetAlert.swal({
                    title: "Atenção",
                    text: "Tem certeza que deseja salvar esse chamado e solciitar o seu desenvolvimento?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        vm.solicitarDesenvolvimentoNoRetornoDoSave = true;
                        save();
                    }
                });
        }

        function save() {
            vm.isSaving = true;
            confirmSave();
        }

        function saveSuporte() {
            vm.chamado.severidade = 'SEM_SEVERIDADE';
            delete vm.chamado.situacao;
            vm.tempoGasto = {chamado: vm.chamado, criadoEm: new Date(), horas: 0, minutos: 0};
            vm.tempoGasto.tipo = vm.tipo;
            Chamado.saveSuporte(vm.tempoGasto, onSaveSuccess, onSaveError);
        }


        function confirmSave() {
            if (vm.chamado.id !== null) {
                Chamado.update(vm.chamado, onSaveSuccess, onSaveError);
            } else {
                Chamado.save(vm.chamado, onSaveSuccess, onSaveError);
            }
        }

        function calcularOrdem() {
            Chamado.getProximaOrdem({modulo: vm.chamado.modulo.id}, function (data) {
                vm.chamado.ordem = data.ordem;
            });
        }

        function buscarRedMine() {
            if (vm.ticketRedmine) {
                vm.chamado = Chamado.getChamadoRedmine({id: vm.ticketRedmine}, carregarSubModulo);
            }
        }

        function aceitar() {
            if (vm.chamado.tipoChamado !== 'SUPORTE' && vm.chamado.cliente.perguntasAoAceitar) {
                var modalInstance = $uibModal.open({
                    size: 'lg',
                    animation: true,
                    templateUrl: 'aceitarDialog.html',
                    controller: 'ChamadoAceiteController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    windowClass: 'modal-grande',
                    resolve: {
                        chamado: vm.chamado
                    }
                });

                modalInstance.result.then(function (chamado) {
                    vm.chamado = chamado;
                    Chamado.aceitar(vm.chamado, onSaveSuccess, onSaveError);
                });
            } else {
                vm.isSaving = true;
                Alerta.confirm("Confirme a operação",
                    "Você tem certeza que quer Aceitar esse chamado? Ao continuar o chamado irá mudar de situação, certifique-se do total entendimento do relatado para prosseguir",
                    "warning",
                    function () {
                        Chamado.aceitar(vm.chamado, onSaveSuccess, onSaveError);
                    },
                    onSaveError);
            }
        }

        function comentar() {
            vm.isSaving = true;
            Chamado.comentar(vm.comentario, function (data) {
                vm.comentario = {chamado: vm.chamado};
                carregarComentarios();
                vm.isSaving = false;
            }, onSaveError);
        }

        function definirTempoGasto() {
            vm.isSaving = true;
            vm.tempoGasto.numero = vm.tempoGasto.atividade.id;
            vm.tempoGasto.conteudo = vm.tempoGasto.atividade.name;
            vm.tempoGasto.tempo = vm.tempoGasto.horas + (vm.tempoGasto.minutos / 60);
            Chamado.defirnirTempo(vm.tempoGasto, function (data) {
                vm.tempoGasto = {chamado: vm.chamado, criadoEm: new Date(), horas: 0, minutos: 0};
                vm.isSaving = false;
                contarTempoGasto();
                vm.inserirHora = false;
            }, onSaveError);
        }

        function liberarTesteSuporte() {
            Alerta.confirm("Confirme a operação",
                "Você tem certeza que quer encaminhar esse chamado para o teste do suporte? Ao continuar o chamado irá mudar de situação, certifique-se do total entendimento do relatado para prosseguir",
                "warning",
                function () {
                    vm.isSaving = true;
                    vm.chamado.situacao = 'TESTE_SUPORTE';
                    Chamado.update(vm.chamado, onSaveSuccess, onSaveError);
                },
                onSaveError);
        }

        function reprovarDesenvolvimento() {
            Alerta.confirm("Confirme a operação",
                "Você tem certeza que quer reprovar esse chamado, enviando para a analise do P.O.? Ao continuar o chamado irá mudar de situação, certifique-se do total entendimento do relatado para prosseguir",
                "warning",
                function () {
                    vm.isSaving = true;
                    vm.chamado.situacao = 'EM_ANALISE';
                    Chamado.update(vm.chamado, onSaveSuccess, onSaveError);
                },
                onSaveError);
        }

        function retornarDesenvolvimento() {
            Alerta.confirm("Confirme a operação",
                "Você tem certeza que quer retornar esse chamado para Desenvolvimento?",
                "warning",
                function () {
                    vm.isSaving = true;
                    vm.chamado.situacao = 'EM_DESENVOLVIMENTO';
                    Chamado.update(vm.chamado, onSaveSuccess, onSaveError);
                },
                onSaveError);
        }

        function liberarTeste() {
            var modalInstance = $uibModal.open({
                size: 'lg',
                animation: true,
                templateUrl: 'testarContent.html',
                controller: 'ChamadoTesteController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'modal-grande',
                resolve: {
                    comentario: vm.comentario
                }
            });
            modalInstance.result.then(function (comentario) {
                vm.isSaving = true;
                vm.comentario = comentario;
                comentar();

                if (comentario.anexos) {
                    angular.forEach(comentario.anexos, function (anexo) {
                        anexo.chamado = vm.chamado;
                        AnexoChamado.save(anexo, function (data) {
                            vm.anexos.push(data);
                        });
                    });
                }
                vm.chamado.situacao = 'AGUARDANDO_TESTE';
                Chamado.update(vm.chamado, onSaveSuccess, onSaveError);
            });

        }

        function validarTeste() {
            vm.isSaving = true;
            vm.chamado.situacao = 'AGUARDANDO_VALIDACAO';
            Chamado.update(vm.chamado, onSaveSuccess, onSaveError);
        }

        function validarTesteUsuario() {
            if (vm.chamado.cliente.releaseNote) {
                if (!vm.chamado.releaseNote) {
                    vm.chamado.releaseNote = vm.chamado.titulo;
                }
                var modalInstance = $uibModal.open({
                    size: 'lg',
                    animation: true,
                    templateUrl: 'validarDialog.html',
                    controller: 'ChamadoValidarController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    windowClass: 'modal-grande',
                    resolve: {
                        chamado: vm.chamado
                    }
                });
                modalInstance.result.then(function (chamado) {
                    vm.chamado = chamado;
                    vm.isSaving = true;
                    vm.chamado.situacao = 'VALIDADO';
                    Chamado.update(vm.chamado, onSaveSuccess, onSaveError);
                });
            } else {
                vm.isSaving = true;
                vm.chamado.situacao = 'VALIDADO';
                Chamado.update(vm.chamado, onSaveSuccess, onSaveError);
            }
        }

        function impedir() {
            var modalInstance = $uibModal.open({
                size: 'lg',
                animation: true,
                templateUrl: 'impedirContent.html',
                controller: 'ChamadoImpedidoController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'modal-grande',
                resolve: {
                    comentario: vm.comentario
                }
            });
            modalInstance.result.then(function (comentario) {
                vm.comentario = comentario;
                comentar();
                vm.isSaving = true;
                vm.chamado.situacao = 'IMPEDIDO';
                Chamado.update(vm.chamado, onSaveSuccess, onSaveError);
            });

        }

        function reabrir() {
            vm.isSaving = true;

            var modalInstance = $uibModal.open({
                size: 'lg',
                animation: true,
                templateUrl: 'reabrirContent.html',
                controller: 'ChamadoReabertoController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'modal-grande',
                resolve: {
                    comentario: vm.comentario
                }
            });
            modalInstance.result.then(function (comentario) {
                vm.comentario = comentario;
                comentar();

                if (comentario.anexos) {
                    angular.forEach(comentario.anexos, function (anexo) {
                        anexo.chamado = vm.chamado;
                        AnexoChamado.save(anexo, function (data) {
                            vm.anexos.push(data);
                        });
                    });
                }

                vm.chamado.situacao = 'ABERTO';
                vm.chamado.sprint = null;
                vm.chamado.solicitante = vm.account;
                Chamado.update(vm.chamado, onSaveSuccess, onSaveError);

            });
        }

        function copiar() {
            vm.isSaving = true;
            Alerta.confirm("Confirme a operação",
                "Você tem certeza que quer Re-abrir esse chamado já fechado? Ao continuar o chamado será copiado e vinculado para manter a relação ",
                "warning",
                function () {
                    Chamado.copiar({id: vm.chamado.id}, onSaveSuccess, onSaveError);
                },
                onSaveError);
        }

        function melhorarComIa() {
            vm.isSaving = true;
            Chamado.melhorarComIa({id: vm.chamado.id}, function (data) {
                vm.chamado.descricaoIa = data.mensagem;
                vm.isSaving = false;
            });
        }

        function copiarSimples() {
            vm.isSaving = true;
            Alerta.confirm("Confirme a operação",
                "Você tem certeza que quer copiar esse chamado? Ao continuar um novo chamado será criado idêntico a esse, possibilitando a edição",
                "info",
                function () {
                    Chamado.copiar({id: vm.chamado.id}, onSaveSuccess, onSaveError);
                },
                onSaveError);
        }

        function confirmEcerrar() {
            vm.chamado.situacao = 'FECHADO';
            Chamado.update(vm.chamado, onSaveSuccess, onSaveError);
        }

        function encerrar() {
            vm.isSaving = true;
            Alerta.confirm("Confirme a operação",
                "Você tem certeza que quer ENCERRAR esse chamado?",
                "warning",
                confirmEcerrar,
                onSaveError);
        }

        function confirmEncaminharPO() {
            vm.chamado.situacao = 'EM_ANALISE';
            Chamado.update(vm.chamado, onSaveSuccess, onSaveError);
        }

        function encaminharPO() {
            if (vm.chamado.tipoChamado === 'SUPORTE') {
                Alerta.warn("Tipo de Chamado não compativel",
                    "Você pode apenas encaminhar para análise chamados de Melhoria, Bug ou Nova Funcionalidade!");
            } else {
                vm.isSaving = true;
                Alerta.confirm("Confirme a operação",
                    "Você tem certeza que quer encaminhar esse chamado para o P.O?",
                    "warning",
                    confirmEncaminharPO,
                    onSaveError);
            }
        }

        function confirmRejeitar() {
            if (vm.chamado.situacao === 'AGUARDANDO_VALIDACAO') {
                vm.chamado.situacao = 'AGUARDANDO_TESTE';
            } else {
                vm.chamado.situacao = 'REJEITADO';
            }
            Chamado.update(vm.chamado, onSaveSuccess, onSaveError);
        }

        function rejeitar() {
            var modalInstance = $uibModal.open({
                size: 'lg',
                animation: true,
                templateUrl: 'rejeitarContent.html',
                controller: 'ChamadoRejeicaoController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'modal-grande',
                resolve: {
                    comentario: vm.comentario
                }
            });
            modalInstance.result.then(function (comentario) {
                vm.comentario = comentario;
                comentar();
                confirmRejeitar();
            });
        }

        function solicitarDesenvolvimento() {
            var modalInstance = $uibModal.open({
                size: 'lg',
                animation: true,
                templateUrl: 'myModalContent.html',
                controller: 'ChamadoDesenvolvimentoController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'modal-grande',
                resolve: {
                    chamado: vm.chamado
                }
            });
            modalInstance.result.then(function (solicitacao) {
                vm.tempoGasto = {chamado: vm.chamado, criadoEm: new Date(), horas: 0, minutos: 0};
                vm.tempoGasto.criadoEm = new Date();
                vm.tempoGasto.numero = 23;
                vm.tempoGasto.conteudo = 'Análise';
                vm.tempoGasto.tempo = solicitacao.horaAnalise;
                Chamado.defirnirTempo(vm.tempoGasto);
                $state.go('edit-chamado', {id: vm.chamado.id}, {reload: true});
                Alerta.success("Operação realizada!", "Ticket " + solicitacao.numero + " criado no redmine!");
            });
        }

        function criarDependencia() {
            if (vm.dependente) {
                Chamado.get({id: vm.dependente}, function (chamado) {
                    Chamado.criarDependente({chamado: chamado, dependente: vm.chamado}, function (data) {
                        Alerta.success("Operação realizada!", "Dependência criada com sucesso!");
                        carregarDependentes();
                        vm.inserirDependenciaManual = false;
                    }, function (error) {
                        Alerta.error("Operação Não realizada!", "Dependência não pode ser criada!");
                    });
                }, function (error) {
                    Alerta.error("Operação Não realizada!", "Não foi possivel encontrar o chamado com o numero " + vm.dependente);
                });
            }
        }

        function removerTodasDependencia() {
            SweetAlert.swal({
                    title: "Atenção",
                    text: "Tem certeza que deseja remover todas dependências?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        angular.forEach(vm.dependentes, function (dependencia) {
                            Chamado.removerDependente({id: dependencia.id}, function (data) {
                                carregarDependentes();
                            });
                        });
                    }
                });

        }

        function removerDependencia(index) {
            SweetAlert.swal({
                    title: "Atenção",
                    text: "Tem certeza que deseja remover essa dependência?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        var dependencia = vm.dependentes[index];
                        if (dependencia.id) {
                            Chamado.removerDependente({id: dependencia.id}, function (data) {
                                carregarDependentes();
                            });
                        }
                    }
                });

        }

        function solicitarDesenvolvimentoTicketExistente(novoTicketRedmine) {
            vm.solicitacaoDesenvolvimento = {numero: novoTicketRedmine, chamado: vm.chamado};
            SolicitacaoDesenvolvimento.save(vm.solicitacaoDesenvolvimento, function (solicitacao) {
                carregarSolicitacoesDev();
                vm.inserirTicketManual = false;
                Alerta.success("Operação realizada!", "Ticket " + solicitacao.numero + " criado no redmine!");
            });
        }

        function onSaveSuccess(result) {
            if (vm.anexos) {
                angular.forEach(vm.anexos, function (anexo) {
                    if (!anexo.id) {
                        anexo.chamado = result;
                        AnexoChamado.save(anexo);
                    }
                });
            }
            $scope.$emit('chamadosApp:chamadoUpdate', result);
            vm.isSaving = false;
            if (vm.solicitarDesenvolvimentoNoRetornoDoSave) {
                $state.go('solicitar-desenvolvimento', {id: result.id}, {reload: true});
            } else {
                $state.go('edit-chamado', {id: result.id}, {reload: true});
            }
            Alerta.success("Operação realizada!", "Chamado " + result.id + " - " + result.titulo + " salvo com sucesso!");
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;

                Cliente.getByUser({}, function (data) {
                    vm.clientes = data;
                    if (data.length == 1) {
                        vm.chamado.cliente = data[0];
                        carregarSistemas();
                    }
                });

            });
        }

        function carregarSistemas() {
            if (vm.chamado.cliente) {
                carregarSolicitantes();

                Sistema.getByCliente({clienteId: vm.chamado.cliente.id}, function (data) {
                    vm.sistemas = data;
                    if (data.length == 1 && vm.chamado.sistema == null) {
                        vm.chamado.sistema = data[0];
                    }
                });
            } else {
                vm.sistemas = [];
            }
            carregarSituacoesIniciais();
        }

        function carregarSituacoesIniciais() {
            if (vm.chamado.id) {
                return;
            }
            if (!vm.chamado.cliente || !vm.chamado.cliente.id) {
                vm.situacoesIniciais = [];
                return;
            }
            SituacaoConfig.query({clienteId: vm.chamado.cliente.id, inicial: true}, function (result) {
                vm.situacoesIniciais = result || [];
                if (!vm.situacoesIniciais.length) {
                    return;
                }
                var atual = vm.chamado.situacao;
                var found = vm.situacoesIniciais.some(function (s) {
                    return s.codigo === atual;
                });
                if (!found) {
                    vm.chamado.situacao = vm.situacoesIniciais[0].codigo;
                }
            });
        }

        function carregarSolicitantes() {
            if (vm.chamado.cliente) {
                Solicitante.getByCliente({clienteId: vm.chamado.cliente.id}, function (data) {
                    vm.solicitantes = data;
                });
            } else {
                vm.solicitantes = [];
            }
        }

        function upload($file) {
            if ($file) {
                if (!vm.anexos) {
                    vm.anexos = [];
                }
                Upload.dataUrl($file, true).then(
                    function (conteudo) {
                        var anexo = {};
                        anexo.descricao = $file.name;
                        anexo.conteudo = conteudo;
                        anexo.mimeType = $file.type;
                        if (vm.chamado.id) {
                            anexo.chamado = vm.chamado;
                            AnexoChamado.save(anexo, function (data) {
                                vm.anexos.push(data);
                                comentarTextoChamado("Anexo " + anexo.descricao + " adicionado");
                            });

                        } else {
                            vm.anexos.push(anexo);
                        }
                    }
                );
            } else {
                Alerta.warn("Atenção!", "Você deve selecionar um arquivo de até 100Mb");
            }
        }

        function carregarSubModulo() {
            if (vm.chamado.modulo) {
                vm.submodulos = SubModulo.queryByModulo({id: vm.chamado.modulo.id});
            }
        }

        function ajustarChamado() {
            var modalInstance = $uibModal.open({
                size: 'md',
                animation: true,
                templateUrl: 'ajustarDialog.html',
                controller: 'AjustarChamadoController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'modal-grande',
                resolve: {
                    chamado: vm.chamado
                }
            });


            modalInstance.result.then(function (chamado) {
                vm.chamado = chamado;
                confirmSave();
            });
        }

        function adicionarTag() {
            var modalInstance = $uibModal.open({
                size: 'md',
                animation: true,
                templateUrl: 'adicionarTagDialog.html',
                controller: 'AjustarChamadoController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'modal-grande',
                resolve: {
                    chamado: vm.chamado
                }
            });

            modalInstance.result.then(function (chamado) {
                vm.chamado = chamado;
                confirmSave();
            });
        }

        function aprovarChamado() {
            SweetAlert.swal({
                    title: "Atenção",
                    text: "Tem certeza que deseja aprovar esse Chamado?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        vm.chamado.situacao = 'EM_ANALISE';
                        vm.chamado.solicitante = vm.account;
                        confirmSave();
                    }
                });
        }

        function reestimarChamado() {
            var modalInstance = $uibModal.open({
                size: 'md',
                animation: true,
                templateUrl: 'reestimarChamado.html',
                controller: 'ReestimarChamadoController',
                controllerAs: 'vm',
                backdrop: 'static',
                windowClass: 'modal-grande',
                resolve: {
                    chamado: vm.chamado
                }
            });


            modalInstance.result.then(function (chamado) {
                vm.chamado = chamado;
                confirmSave();
            });
        }
    }

    angular
        .module('chamadosApp')
        .controller('ReestimarChamadoController', ReestimarChamadoController);
    ReestimarChamadoController.$inject = ['$uibModalInstance', 'chamado', 'Chamado'];

    function ReestimarChamadoController($uibModalInstance, chamado, Chamado) {
        var vm = this;
        vm.chamado = chamado;
        vm.calcularPlanoDesenvolvimento = calcularPlanoDesenvolvimento;
        vm.atualizarHoraEstimada = atualizarHoraEstimada;


        function calcularPlanoDesenvolvimento() {
            if (vm.chamado.complexidade && chamado.tempoEstimado)
                Chamado.calcularPlanoDesenvolvimento(vm.chamado, function (data) {
                    vm.chamado.planoDesenvolvimento = data;
                    var total = 0;
                    for (var i = 0; i < vm.chamado.planoDesenvolvimento.length; i++) {
                        var plano = vm.chamado.planoDesenvolvimento[i];
                        total = total + plano.tempoEstimado;
                    }
                });
        }

        function atualizarHoraEstimada() {
            var horas = 0;
            angular.forEach(vm.chamado.planoDesenvolvimento, function (plano) {
                horas = horas + plano.tempoEstimado;
            });

            vm.chamado.tempoEstimado = horas;
        }

        vm.ok = function () {
            vm.isSaving = true;
            $uibModalInstance.close(vm.chamado);
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    };

    angular
        .module('chamadosApp')
        .controller('ChamadoRejeicaoController', ChamadoRejeicaoController);
    ChamadoRejeicaoController.$inject = ['$uibModalInstance', 'comentario'];

    function ChamadoRejeicaoController($uibModalInstance, comentario) {
        var vm = this;
        vm.comentario = comentario;


        vm.ok = function () {
            vm.isSaving = true;
            vm.comentario.descricao = "<strong>Rejeição do Chamado:</strong><br/>" +
                "<strong>Ambiente em que o teste foi realizado: </strong><br/>" +
                "" + vm.ambiente + "<br/> <br/>" +
                "<strong>Motivo da Rejeição: <br/></strong>" +
                "" + (vm.motivoRejeicao === 'NAO_ATENDIDO' ? 'Um ou mais de um item solicitado originalmente não foi atendido.' : ' O solicitado originalmente foi atendido porém correções são necessárias para liberação.') + "<br/> <br/>" +
                (vm.motivoRejeicao === 'NAO_ATENDIDO' ? '<strong>Item ou os itens que não foram atendidos: </strong><br/> ' : '') +
                (vm.motivoRejeicao === 'NAO_ATENDIDO' ? vm.itemNaoAtendido + ' <br/> <br/>' : '') +
                "<strong>Como realizar o teste e o motivo da rejeição: </strong><br/>" +
                vm.descricaoRejeicao + "<br/> <br/>";
            $uibModalInstance.close(vm.comentario);
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    };

    angular
        .module('chamadosApp')
        .controller('ChamadoTesteController', ChamadoTesteController);
    ChamadoTesteController.$inject = ['$uibModalInstance', 'comentario', 'Upload', 'Alerta'];

    function ChamadoTesteController($uibModalInstance, comentario, Upload, Alerta) {
        var vm = this;
        vm.comentario = comentario;
        vm.upload = upload;
        vm.removerAnexo = removerAnexo;
        vm.descricaoTeste = '';

        function upload($file) {
            if ($file) {
                if (!vm.anexos) {
                    vm.anexos = [];
                }
                Upload.dataUrl($file, true).then(
                    function (conteudo) {
                        var anexo = {};
                        anexo.descricao = $file.name;
                        anexo.conteudo = conteudo;
                        anexo.mimeType = $file.type;
                        vm.descricaoTeste = vm.descricaoTeste + " Anexado o arquivo - " + anexo.descricao + "\n";
                        vm.anexos.push(anexo);
                    }
                );
            } else {
                Alerta.warn("Atenção!", "Você deve selecionar um arquivo de até 10Mb");
            }
        }


        function removerAnexo(index) {
            SweetAlert.swal({
                    title: "Atenção",
                    text: "Tem certeza que deseja remover esse anexo?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        vm.anexos.splice(index, 1);
                    }
                });
        }

        vm.ok = function () {
            vm.isSaving = true;
            vm.comentario.descricao = "<strong>Teste do Chamado:</strong><br/>" +
                "<strong>Ambiente em que o teste foi realizado: </strong><br/>" +
                "" + vm.ambiente + "<br/> <br/>" +
                "<strong>Descrição do teste: <br/></strong>" +
                vm.descricaoTeste + "<br/> <br/>" +
                "<strong>Houve atualização do manual? <br/></strong>" +
                vm.manual + "<br/> <br/>";
            vm.comentario.anexos = vm.anexos;
            $uibModalInstance.close(vm.comentario);
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    };

    angular
        .module('chamadosApp')
        .controller('ChamadoValidarController', ChamadoValidarController);
    ChamadoValidarController.$inject = ['$uibModalInstance', 'chamado'];

    function ChamadoValidarController($uibModalInstance, chamado) {
        var vm = this;
        vm.chamado = chamado;

        vm.ok = function () {
            $uibModalInstance.close(vm.chamado);
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    };

    angular
        .module('chamadosApp')
        .controller('ChamadoImpedidoController', ChamadoImpedidoController);
    ChamadoImpedidoController.$inject = ['$uibModalInstance', 'comentario'];

    function ChamadoImpedidoController($uibModalInstance, comentario) {
        var vm = this;
        vm.comentario = comentario;

        vm.ok = function () {
            vm.isSaving = true;
            vm.comentario.descricao = "<strong>Chamado Impedido:</strong><br/>" + vm.motivoImpedido + "<br/> <br/>";
            $uibModalInstance.close(vm.comentario);
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    };

    angular
        .module('chamadosApp')
        .controller('ChamadoReabertoController', ChamadoReabertoController);
    ChamadoReabertoController.$inject = ['$uibModalInstance', 'comentario', 'Upload'];

    function ChamadoReabertoController($uibModalInstance, comentario, Upload) {
        var vm = this;
        vm.comentario = comentario;
        vm.upload = upload;
        vm.removerAnexo = removerAnexo;

        function upload($file) {
            if ($file) {
                if (!vm.anexos) {
                    vm.anexos = [];
                }
                Upload.dataUrl($file, true).then(
                    function (conteudo) {
                        var anexo = {};
                        anexo.descricao = $file.name;
                        anexo.conteudo = conteudo;
                        anexo.mimeType = $file.type;
                        vm.descricaoTeste = vm.descricaoTeste + " Anexado o arquivo - " + anexo.descricao + "\n";
                        vm.anexos.push(anexo);
                    }
                );
            } else {
                Alerta.warn("Atenção!", "Você deve selecionar um arquivo de até 10Mb");
            }
        }


        function removerAnexo(index) {
            SweetAlert.swal({
                    title: "Atenção",
                    text: "Tem certeza que deseja remover esse anexo?",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#DD6B55", confirmButtonText: "Sim",
                    cancelButtonText: "Não",
                    closeOnConfirm: true,
                    closeOnCancel: true
                },
                function (isConfirm) {
                    if (isConfirm) {
                        vm.anexos.splice(index, 1);
                    }
                });
        }


        vm.ok = function () {
            vm.comentario.anexos = vm.anexos;
            vm.isSaving = true;
            vm.comentario.descricao = "<strong>Chamado Reaberto:</strong><br/>" + vm.motivoReabrir + "<br/> <br/>";
            $uibModalInstance.close(vm.comentario);
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    };

    angular
        .module('chamadosApp')
        .controller('AjustarChamadoController', AjustarChamadoController);
    AjustarChamadoController.$inject = ['$uibModalInstance', 'chamado', 'Sprint', 'Modulo', 'SubModulo', 'Sistema', 'Cliente', 'Chamado', '$state'];

    function AjustarChamadoController($uibModalInstance, chamado, Sprint, Modulo, SubModulo, Sistema, Cliente, Chamado, $state) {
        var vm = this;

        vm.chamado = chamado;
        vm.sprints = Sprint.query();
        vm.modulos = Modulo.queryByUser();
        vm.sistemas = Sistema.query;

        vm.tag = {
            cor: 'DC0F0F',
            descricao: '',
            chamado: [vm.chamado]
        };

        vm.options = {
            name: 'Cor',
            restrictToFormat: true,
            format: 'hex',
            case: 'upper',
        };

        vm.selecionou = function ($item, $model, $label) {
            vm.tag.descricao = $item.descricao;
            vm.tag.cor = $item.cor;
            vm.tag.id = $item.id;
        };

        vm.saiuDoCampo = function () {
            vm.tag.descricao = vm.filtroTag.descricao;
        };
        vm.search = function () {
            Chamado.getTags({chamado: '', descricao: vm.filtroTag}, function (data) {
                vm.tags = data;
            });
        };

        vm.carregarSubModulo = carregarSubModulo;
        vm.carregarSistemas = carregarSistemas;

        vm.salvarTag = function () {
            vm.tag.descricao = vm.tag.descricao == null ? vm.filtroTag : vm.tag.descricao;
            vm.response = Chamado.salvarTagChamado(vm.tag);
            $state.go('edit-chamado', {id: vm.chamado.id}, {reload: true});
            $uibModalInstance.close(vm.chamado);
        };

        vm.ok = function () {
            vm.isSaving = true;
            $uibModalInstance.close(vm.chamado);
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function carregarSubModulo() {
            if (vm.chamado.modulo) {
                vm.submodulos = SubModulo.queryByModulo({id: vm.chamado.modulo.id});
            }
        }

        function carregarSistemas() {
            if (vm.chamado.cliente) {
                Sistema.getByCliente({clienteId: vm.chamado.cliente.id}, function (data) {
                    vm.sistemas = data;
                });
            } else {
                vm.sistemas = [];
            }
        }

        Cliente.getByUser({}, function (data) {
            vm.clientes = data;
        });


        carregarSubModulo();
        carregarSistemas();
    };

    angular
        .module('chamadosApp')
        .controller('ConferirMovimentacaoChamadoController', ConferirMovimentacaoChamadoController);
    ConferirMovimentacaoChamadoController.$inject = ['$uibModalInstance', 'chamado', 'Modulo', 'SubModulo', 'Sistema', 'Cliente'];

    function ConferirMovimentacaoChamadoController($uibModalInstance, chamado, Modulo, SubModulo, Sistema, Cliente) {
        var vm = this;
        vm.chamado = chamado;
        vm.modulos = Modulo.queryByUser();
        vm.carregarSubModulo = carregarSubModulo;
        vm.carregarSistemas = carregarSistemas;

        vm.ok = function () {
            $uibModalInstance.close(vm.chamado);
        };

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };

        function carregarSubModulo() {
            if (vm.chamado.modulo) {
                vm.submodulos = SubModulo.queryByModulo({id: vm.chamado.modulo.id});
            } else {
                vm.submodulos = [];
                vm.chamado.subModulo = null;
            }
        }

        function carregarSistemas() {
            if (vm.chamado.cliente) {
                Sistema.getByCliente({clienteId: vm.chamado.cliente.id}, function (data) {
                    vm.sistemas = data;
                });
            } else {
                vm.sistemas = [];
                vm.chamado.sistema = null;
            }
        }

        Cliente.getByUser({}, function (data) {
            vm.clientes = data;
        });

        carregarSubModulo();
        carregarSistemas();
    }

    angular
        .module('chamadosApp')
        .controller('ChamadoAceiteController', ChamadoAceiteController);
    ChamadoAceiteController.$inject = ['$uibModalInstance', 'chamado', 'Cliente'];

    function ChamadoAceiteController($uibModalInstance, entity) {
        var vm = this;

        vm.chamado = entity;
        vm.clear = clear;
        vm.confirmAceite = confirmAceite;
        vm.renderPergunta = renderPergunta;
        vm.isRequiredPergunta = isRequiredPergunta;
        vm.minLenghtPergunta = minLenghtPergunta;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmAceite() {
            vm.chamado.conteudo += montarString();
            $uibModalInstance.close(vm.chamado);
        }

        function init() {
            switch (vm.chamado.tipoChamado) {
            case 'BUG':
                vm.pergunta1 = 'Descreva o teste realizado:';
                vm.pergunta2 = 'Descreva o resultado do teste: ';
                vm.pergunta3 = 'Descreva qual o resultado esperado: ';
                vm.pergunta4 = 'Qual o ambiente que o teste foi realizado (url, nome): ';
                break;
            case 'MELHORIA':
                vm.pergunta1 = 'Descreva o caso de uso que receberá a melhoria (caminho, menu, nome da tela): ';
                vm.pergunta2 = 'Descreva como o caso de uso funciona atualmente:';
                vm.pergunta3 = 'Descreva como o caso de uso deve funcionar após a melhoria ser implementada: ';
                vm.pergunta4 = 'Como testar? Qual a resposta esperada?';
                break;
            case 'NOVA_FUNCIONALIDADE':
                vm.pergunta1 = 'Descreva como o caso de uso deve funcionar após ser implementado: ';
                vm.pergunta2 = 'Descreva onde deverá ser implementado (menu, caminho ou nome da tela) :';
                vm.pergunta3 = 'Como testar? Qual a resposta esperada?';
            }
        }

        function montarString() {
            switch (vm.chamado.tipoChamado) {
            case 'BUG' :
            case 'MELHORIA':
                return "<p><strong>" + vm.pergunta1 + "</strong></p><p>" + (vm.resposta1 ? vm.resposta1 : 'não informado') + "</p>" +
                    "<p><strong>" + vm.pergunta2 + "</strong></p><p>" + (vm.resposta2 ? vm.resposta2 : 'não informado') + "</p>" +
                    "<p><strong>" + vm.pergunta3 + "</strong></p><p>" + (vm.resposta3 ? vm.resposta3 : 'não informado') + "</p>" +
                    "<p><strong>" + vm.pergunta4 + "</strong></p><p>" + (vm.resposta4 ? vm.resposta4 : 'não informado') + "</p>";
            case 'NOVA_FUNCIONALIDADE':
                return "<p><strong>" + vm.pergunta1 + "</strong></p><p>" + (vm.resposta1 ? vm.resposta1 : 'não informado') + "</p>" +
                    "<p><strong>" + vm.pergunta2 + "</strong></p><p>" + (vm.resposta2 ? vm.resposta2 : 'não informado') + "</p>";
            }
        }

        function renderPergunta(numero) {
            switch (vm.chamado.tipoChamado) {
            case 'BUG':
                return numero <= 4;
            case 'MELHORIA':
                return numero <= 4;
            case 'NOVA_FUNCIONALIDADE':
                return numero <= 3;
            }
        }

        function isRequiredPergunta(numero) {
            switch (vm.chamado.tipoChamado) {
            case 'BUG':
                return true;
            case 'MELHORIA':
                return numero !== 4;
            case 'NOVA_FUNCIONALIDADE':
                return numero === 1;
            }
        }

        function minLenghtPergunta(numero) {
            switch (vm.chamado.tipoChamado) {
            case 'BUG':
                if (numero === 4)
                    return 5;
                break;
            case 'MELHORIA':
                if (numero === 1 || numero === 2 || numero === 3)
                    return 10;
                break;
            case 'NOVA_FUNCIONALIDADE':
                if (numero === 1)
                    return 10;
                break;
            }
            return 0;
        }

        init();
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('ChamadoDetailController', ChamadoDetailController);

    ChamadoDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Chamado', 'User', 'Cliente'];

    function ChamadoDetailController($scope, $rootScope, $stateParams, previousState, entity, Chamado, User, Cliente) {
        var vm = this;

        vm.chamado = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('chamadosApp:chamadoUpdate', function(event, result) {
            vm.chamado = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('ChamadoDeleteController',ChamadoDeleteController);

    ChamadoDeleteController.$inject = ['$uibModalInstance', 'entity', 'Chamado'];

    function ChamadoDeleteController($uibModalInstance, entity, Chamado) {
        var vm = this;

        vm.chamado = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Chamado.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('chamado', {
                parent: 'entity',
                url: '/chamado?page&sort&search&situacao&clienteId&tipoChamado&moduloId',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_CLIENTE', 'ROLE_RESPONSAVEL', 'ROLE_DESENVOLVEDOR'],
                    pageTitle: 'Chamados'
                },
                ncyBreadcrumb: {
                    label: 'Chamados'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chamado/chamados.html',
                        controller: 'ChamadoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    situacao: null,
                    tipoChamado: null,
                    clienteId: null,
                    moduloId: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            situacao: $stateParams.situacao,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            tipoChamado: $stateParams.tipoChamado,
                            moduloId: $stateParams.moduloId,
                            clienteId: $stateParams.clienteId
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('chamado');
                        $translatePartialLoader.addPart('severidade');
                        $translatePartialLoader.addPart('tipoChamado');
                        $translatePartialLoader.addPart('complexidadeChamado');
                        $translatePartialLoader.addPart('tipoHora');
                        $translatePartialLoader.addPart('situacaoChamado');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('new-chamado', {
                parent: 'chamado',
                url: '/chamado-new',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_CLIENTE', 'ROLE_DESENVOLVEDOR'],
                    pageTitle: 'Inclusão de Chamado'
                },
                ncyBreadcrumb: {
                    label: 'Inclusão de Chamado'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chamado/chamado-edit.html',
                        controller: 'ChamadoEditController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    entity: ['Chamado', function (Chamado) {
                        return Chamado.criar().$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('chamado');
                        $translatePartialLoader.addPart('tipoChamado');
                        $translatePartialLoader.addPart('complexidadeChamado');
                        $translatePartialLoader.addPart('severidade');
                        $translatePartialLoader.addPart('tipoHora');
                        $translatePartialLoader.addPart('situacaoChamado');
                        return $translate.refresh();
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('new-suporte', {
                parent: 'chamado',
                url: '/chamado-suporte',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_PO', 'ROLE_DESENVOLVEDOR'],
                    pageTitle: 'Registro de Atividade'
                },
                ncyBreadcrumb: {
                    label: 'Registro de Atividade'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chamado/chamado-suporte.html',
                        controller: 'ChamadoEditController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    entity: ['Chamado', function (Chamado) {
                        return Chamado.criar().$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('chamado');
                        $translatePartialLoader.addPart('tipoChamado');
                        $translatePartialLoader.addPart('complexidadeChamado');
                        $translatePartialLoader.addPart('tipoHora');
                        $translatePartialLoader.addPart('severidade');
                        $translatePartialLoader.addPart('situacaoChamado');
                        return $translate.refresh();
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('edit-chamado', {
                parent: 'chamado',
                url: '/chamado-edit/{id}',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_CLIENTE', 'ROLE_RESPONSAVEL', 'ROLE_DESENVOLVEDOR'],
                    pageTitle: 'Edição de Chamado'
                },
                ncyBreadcrumb: {
                    label: 'Edição de Chamado'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chamado/chamado-edit.html',
                        controller: 'ChamadoEditController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'Chamado', function ($stateParams, Chamado) {
                        return Chamado.get({id: $stateParams.id}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('chamado');
                        $translatePartialLoader.addPart('tipoChamado');
                        $translatePartialLoader.addPart('complexidadeChamado');
                        $translatePartialLoader.addPart('tipoHora');
                        $translatePartialLoader.addPart('severidade');
                        $translatePartialLoader.addPart('situacaoChamado');
                        return $translate.refresh();
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('solicitar-desenvolvimento', {
                parent: 'edit-chamado',
                url: '/criar-tarefa/{situacaoId}',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_CLIENTE', 'ROLE_RESPONSAVEL', 'ROLE_DESENVOLVEDOR'],
                    pageTitle: 'Solci'
                },
                ncyBreadcrumb: {
                    label: 'Solicitação de desenvolvimento'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chamado/solicitar-tarefa.html',
                        controller: 'ChamadoDesenvolvimentoController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    chamado: ['$stateParams', 'Chamado', function ($stateParams, Chamado) {
                        return Chamado.get({id: $stateParams.id}).$promise;
                    }],
                    situacaoId: ['$stateParams', function ($stateParams) {
                        return $stateParams.situacaoId;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('chamado');
                        $translatePartialLoader.addPart('tipoChamado');
                        $translatePartialLoader.addPart('complexidadeChamado');
                        $translatePartialLoader.addPart('tipoHora');
                        $translatePartialLoader.addPart('severidade');
                        $translatePartialLoader.addPart('situacaoChamado');
                        return $translate.refresh();
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('aprovar-desenvolvimento', {
                parent: 'edit-chamado',
                url: '/aprovar-tarefa/{situacaoId}',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_CLIENTE', 'ROLE_RESPONSAVEL', 'ROLE_DESENVOLVEDOR'],
                    pageTitle: 'Solcitação de Desenvolvimento'
                },
                ncyBreadcrumb: {
                    label: 'Aprovação de Desenvolvimento'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/chamado/aprovar-tarefa.html',
                        controller: 'AprovarDesenvolvimentoController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    chamado: ['$stateParams', 'Chamado', function ($stateParams, Chamado) {
                        return Chamado.get({id: $stateParams.id}).$promise;
                    }],
                    situacaoId: ['$stateParams', function ($stateParams) {
                        return $stateParams.situacaoId;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('chamado');
                        $translatePartialLoader.addPart('tipoChamado');
                        $translatePartialLoader.addPart('complexidadeChamado');
                        $translatePartialLoader.addPart('tipoHora');
                        $translatePartialLoader.addPart('severidade');
                        $translatePartialLoader.addPart('situacaoChamado');
                        return $translate.refresh();
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('delete-chamado', {
                parent: 'chamado',
                url: '/chamado-delete/{id}',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_CLIENTE'],
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/chamado/chamado-delete-dialog.html',
                        controller: 'ChamadoDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['Chamado', function (Chamado) {
                                return Chamado.get({id: $stateParams.id}).$promise;
                            }]
                        }
                    }).result.then(function () {
                        $state.go('home', null, {reload: 'home'});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('Chamado', Chamado);

    Chamado.$inject = ['$resource', 'DateUtils'];

    function Chamado($resource, DateUtils) {
        var resourceUrl = 'api/chamados/:id';

        function covertData(data) {
            if (data) {
                data = angular.fromJson(data);
                data.criadoEm = DateUtils.convertLocalDateFromServer(data.criadoEm);
                data.prazo = DateUtils.convertLocalDateFromServer(data.prazo);
            }
            return data;
        }

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'queryBySituacao': {
                method: 'GET',
                url: 'api/chamados-by-situacao/:situacao',
                isArray: true
            },
            'queryBySprint': {
                method: 'GET',
                url: 'api/chamados-by-sprint',
                isArray: true
            },
            'getChamadosSprintAtual': {
                method: 'GET',
                url: 'api/chamados-by-sprint-atual/:sprintId',
                isArray: true
            },
            'getChamadosByRelease': {
                method: 'GET',
                url: 'api/chamados-by-release/:releaseId',
                isArray: true
            },
            'queryValidadosSemRelease': {
                method: 'GET',
                url: 'api/chamados-validados-sem-release',
                isArray: true
            },
            'sincronizarArquivos': {
                method: 'GET',
                url: 'api/sincronizar-arquivos'
            },
            'queryByFiltro': {
                method: 'POST',
                url: 'api/chamados-by-filtro/',
                isArray: true
            },
            'getTempoPorModuloSubModulo': {
                method: 'POST',
                url: 'api/tempos-por-modulo/',
                isArray: true
            },
            'contarByFiltro': {
                method: 'POST',
                url: 'api/contar-chamados/',
                isArray: true
            },
            'solicitarDesenvolvimento': {
                method: 'POST',
                url: 'api/soliciar-desenvolvimento',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.criadoEm = DateUtils.convertLocalDateToServer(copy.criadoEm);
                    copy.prazo = DateUtils.convertLocalDateToServer(copy.prazo);
                    return angular.toJson(copy);
                }
            },
            'getSituacoes': {
                method: 'GET',
                url: 'api/situacoes',
                isArray: true
            },
            'getSeveridades': {
                method: 'GET',
                url: 'api/severidades',
                isArray: true
            },
            'getProximasSprints': {
                method: 'GET',
                url: 'api/proximas-sprints',
                isArray: true
            },
            'getSolicitacoes': {
                method: 'GET',
                url: 'api/solicitacoes/:id',
                isArray: true
            },
            'removerSolicitacaoDesenvolvimento': {
                method: 'DELETE',
                url: 'api/solicitacoes/:id',
                isArray: true
            },
            'getTempoGasto': {
                method: 'GET',
                url: 'api/tempo-gasto/:id',
                isArray: true
            },
            'getAtividades': {
                method: 'GET',
                url: 'api/atividades',
                isArray: true
            },
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    return covertData(data);
                }
            },
            'copiar': {
                method: 'GET',
                url: 'api/copiar/:id',
                transformResponse: function (data) {
                    return covertData(data);
                }
            },
            'contarPorSituacao': {
                method: 'GET',
                url: 'api/countar-por-situacao',
                isArray: true
            },
            'criar': {
                method: 'GET',
                url: 'api/chamados-criar',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.criadoEm = DateUtils.convertLocalDateFromServer(data.criadoEm);
                        data.prazo = DateUtils.convertLocalDateFromServer(data.prazo);
                    }
                    return data;
                }
            },
            'aceitar': {
                method: 'POST',
                url: 'api/chamados-aceitar',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.criadoEm = DateUtils.convertLocalDateFromServer(data.criadoEm);
                        data.prazo = DateUtils.convertLocalDateFromServer(data.prazo);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.criadoEm = DateUtils.convertLocalDateToServer(copy.criadoEm);
                    copy.prazo = DateUtils.convertLocalDateToServer(copy.prazo);
                    return angular.toJson(copy);
                }
            },
            'alocar': {
                method: 'PUT',
                url: 'api/chamados-alocar',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.criadoEm = DateUtils.convertLocalDateToServer(copy.criadoEm);
                    copy.prazo = DateUtils.convertLocalDateToServer(copy.prazo);
                    return angular.toJson(copy);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.criadoEm = DateUtils.convertLocalDateToServer(copy.criadoEm);
                    copy.prazo = DateUtils.convertLocalDateToServer(copy.prazo);
                    return angular.toJson(copy);
                }
            },
            'saveSuporte': {
                url: 'api/chamados-suporte',
                method: 'POST',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.criadoEm = DateUtils.convertLocalDateToServer(copy.criadoEm);
                    copy.prazo = DateUtils.convertLocalDateToServer(copy.prazo);
                    return angular.toJson(copy);
                }
            },
            'comentar': {
                method: 'POST',
                url: 'api/chamados-comentar'
            },
            'defirnirTempo': {
                method: 'POST',
                url: 'api/tempo-gasto'
            },
            'atualizarTempo': {
                method: 'PUT',
                url: 'api/tempo-gasto'
            },
            'excluirTempo': {
                method: 'DELETE',
                url: 'api/tempo-gasto/:id'
            },
            'queryTempoGasto': {
                url: 'api/buscar-tempo-gasto',
                method: 'POST',
                isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            },
            'queryTempoGastoPonto': {
                url: 'api/buscar-horas-apontadas-ponto',
                method: 'POST',
                isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.data = DateUtils.convertLocalDateFromServer(copy.data);
                    copy.hora = DateUtils.convertDateTimeFromServer(copy.hora);
                    return angular.toJson(copy);
                }
            },
            'getProximaOrdem': {
                method: 'GET',
                url: 'api/proxima-ordem/:modulo'
            },
            'getChamadoRedmine': {
                method: 'GET',
                url: 'api/chamados-redmine/:id'
            },
            'getDependentes': {
                method: 'GET',
                isArray: true,
                url: 'api/dependentes-chamados/:id'
            },
            'getRelacoes': {
                method: 'GET',
                isArray: true,
                url: 'api/relacoes-chamados/:id'
            },
            'criarDependente': {
                method: 'POST',
                url: 'api/dependentes-chamados'
            },
            'calcularPlanoDesenvolvimento': {
                isArray: true,
                method: 'POST',
                url: 'api/calcular-plano-desenvolvimento'
            },
            'removerDependente': {
                method: 'DELETE',
                url: 'api/dependentes-chamados/:id'
            },
            'downloadAnexo': {
                method: 'GET',
                url: 'api/download-anexo/:id'
            },
            'getComentarios': {
                method: 'GET',
                url: 'api/comentarios/:id',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.criadoEm = DateUtils.convertDateTimeFromServer(data.criadoEm);
                    }
                    return data;
                }
            },
            'melhorarComIa': {
                method: 'GET',
                url: 'api/melhorar-com-ia/:id',
            },
            'descricaoPOComIa': {
                method: 'GET',
                url: 'api/gerar-descricao-po-com-ia/:id',
            },
            'descricaoDevComIa': {
                method: 'GET',
                url: 'api/gerar-descricao-dev-com-ia/:id',
            },
            'getComentariosMeiaHora': {
                method: 'GET',
                url: 'api/comentarios/',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.criadoEm = DateUtils.convertDateTimeFromServer(data.criadoEm);
                    }
                    return data;
                }
            },
            'migrarRedmineByQuery': {
                method: 'GET',
                url: 'api/migrar-chamados-redmine'
            },
            'montarRelatorioAtividades': {
                method: 'POST',
                url: 'api/montar-relatorio-atividades',
                isArray: false,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.inicio = DateUtils.convertLocalDateToServer(copy.inicio);
                    copy.fim = DateUtils.convertLocalDateToServer(copy.fim);
                    return angular.toJson(copy);
                }
            },
            'getChamadosBornup': {
                method: 'POST',
                url: 'api/chamados-bornup',
                isArray: true,
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    /*copy.inicio = DateUtils.convertLocalDateToServer(copy.inicio);
                    copy.fim = DateUtils.convertLocalDateToServer(copy.fim);*/
                    return angular.toJson(copy);
                }
            },
            'alocarSprintAtual': {url: 'api/alocar-chamado', method: 'PUT'},
            'desalocarChamadoSprintAtual': {url: 'api/desalocar-chamado', method: 'PUT'},
            'getProximasSituacoes': {
                method: 'GET',
                url: 'api/transicao-situacao/permitidas',
                isArray: true
            },
            'moverSituacao': {
                method: 'PUT',
                url: 'api/chamados/:id/mover-situacao/:situacaoConfigId',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.criadoEm = DateUtils.convertLocalDateFromServer(data.criadoEm);
                        data.prazo = DateUtils.convertLocalDateFromServer(data.prazo);
                    }
                    return data;
                }
            },

            'salvarTagChamado': {
                method: 'POST',
                url: 'api/nova-tag-chamado',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    return angular.toJson(copy);
                }
            },
            'getTags': {
                method: 'GET',
                url: 'api/buscar-tags?descricao=:descricao&chamado=:chamado',
                isArray: true
            },
            'getTagsPorChamado': {
                method: 'GET',
                url: 'api/buscar-tags-por-chamado/:id',
                isArray: true
            },

        });
    }
})();

(function () {
    'use strict';


    angular
        .module('chamadosApp')
        .controller('ChamadoController', ChamadoController);

    ChamadoController.$inject = ['$scope', 'Principal', '$state',
        'Chamado', 'ParseLinks', 'AlertService', 'paginationConstants',
        'pagingParams', 'Modulo', 'SubModulo', 'Sprint', '$filter', 'localStorageService', 'Cliente', 'Solicitante'];

    function ChamadoController($scope, Principal, $state,
                               Chamado, ParseLinks, AlertService, paginationConstants,
                               pagingParams, Modulo, SubModulo, Sprint, $filter, localStorageService, Cliente,
                               Solicitante) {
        var vm = this;

        vm.account = null;
        vm.isAuthenticated = null;
        vm.login = login;
        vm.register = register;
        vm.editarChamado = editarChamado;
        vm.loadPage = loadPage;
        vm.sincronizarArquivos = sincronizarArquivos;
        vm.migrarDoRedmineByQueryId = migrarDoRedmineByQueryId;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.selecionarCliente = selecionarCliente;
        vm.carregarSolicitantes = carregarSolicitantes;
        vm.loadAll = loadAll;
        vm.limpar = limpar;
        vm.getCorPorTipo = getCorPorTipo;
        vm.filtrarApenasPorModulo = filtrarApenasPorModulo;
        vm.filtrarApenasPorTipoChamado = filtrarApenasPorTipoChamado;
        vm.imprimir = imprimir;
        vm.tagdescricao = '';
        vm.tags = [];


        Chamado.getTags({chamado: '', descricao: vm.filtroTag}, function (data) {
            vm.tags = data;
        });

        vm.chamado = {id: null, modulo: null, tipoChamado: null, titulo: null};

        function carregarClientes() {
            Cliente.getByUser({}, function (data) {
                vm.clientes = data;
                contarPorFiltro(vm.chamado, loadAll);
            });
        }

        function contarPorFiltro(filtro, callback) {
            Chamado.contarByFiltro(filtro, function (data) {
                vm.chamadosContados = data;
                vm.clientesChamado = {};
                vm.tiposChamado = {};
                vm.modulosChamado = {};
                for (var j = 0; j < vm.chamadosContados.length; j++) {
                    if (!vm.tiposChamado[vm.chamadosContados[j].tipoChamado]) {
                        vm.tiposChamado[vm.chamadosContados[j].tipoChamado] = {
                            quantidade: 0,
                            nome: vm.chamadosContados[j].tipoChamado
                        };
                    }
                    vm.tiposChamado[vm.chamadosContados[j].tipoChamado].quantidade += vm.chamadosContados[j].quantidade;

                    if (!vm.modulosChamado[vm.chamadosContados[j].modulo]) {
                        vm.modulosChamado[vm.chamadosContados[j].modulo] = {
                            quantidade: 0,
                            nome: vm.chamadosContados[j].modulo,
                            id: vm.chamadosContados[j].moduloId
                        };
                    }
                    vm.modulosChamado[vm.chamadosContados[j].modulo].quantidade += vm.chamadosContados[j].quantidade;

                    if (!vm.clientesChamado[vm.chamadosContados[j].cliente]) {
                        vm.clientesChamado[vm.chamadosContados[j].cliente] = {
                            quantidade: 0,
                            nome: vm.chamadosContados[j].cliente,
                            id: vm.chamadosContados[j].clienteId
                        };
                    }
                    vm.clientesChamado[vm.chamadosContados[j].cliente].quantidade += vm.chamadosContados[j].quantidade;

                }
                callback();
            })
        }

        function filtrarApenasPorTipoChamado(tipoChamado) {
            vm.chamado.tipoChamado = vm.chamado.tipoChamado && vm.chamado.tipoChamado == tipoChamado.nome ? null : tipoChamado.nome;
            transition();
        }

        function filtrarApenasPorModulo(modulo) {
            vm.chamado.modulo = vm.chamado.modulo && vm.chamado.modulo.id == modulo.id ? null : {id: modulo.id};
            transition();
        }

        function selecionarCliente(cliente) {
            vm.chamado.cliente = vm.chamado.cliente && vm.chamado.cliente.id == cliente.id ? null : cliente;
            transition();
        }

        function carregarSolicitantes() {
            if (vm.chamado.cliente) {
                Solicitante.getByCliente({clienteId: vm.chamado.cliente.id}, function (data) {
                    vm.solicitantes = data;
                })
            } else {
                vm.solicitantes = [];
            }
        }

        function login() {
            $state.go('login');
        }

        function limpar() {
            vm.chamado = {id: null, modulo: null, tipoChamado: null, titulo: null};
            loadAll();
        }

        getAccount();


        function migrarDoRedmineByQueryId() {
            if (vm.queryId && vm.projectId) {
                Chamado.migrarRedmineByQuery({queryId: vm.queryId, projectId: vm.projectId});
            }
        }

        function isPesquisandoChamado() {
            return vm.chamado &&
                (vm.chamado.id
                    || vm.chamado.modulo
                    || vm.chamado.tipoChamado
                    || vm.chamado.titulo
                    || vm.chamado.sprint
                    || vm.chamado.subModulo
                    || vm.chamado.situacao);
        }

        function loadAll() {
            vm.chamado.size = vm.itemsPerPage;
            vm.chamado.sort = sort();
            vm.chamado.page = pagingParams.page - 1;
            vm.chamado.tag = vm.tagdescricao.descricao;
            Chamado.queryByFiltro(vm.chamado, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'ordem') {
                    result.push('ordem');
                }
                return result;
            }

            function onSuccess(data, headers) {
                localStorageService.set("chamado", vm.chamado);
                vm.filasProntas = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                vm.chamados = data;
                if (pagingParams.search && vm.chamados.length === 1) {
                    $state.go("edit-chamado", {id: vm.chamados[0].id, sitaucao: null, search: null});
                }

                angular.forEach(vm.chamados, function (chamado) {
                    if (vm.filasProntas.indexOf(chamado.situacao) < 0) {
                        vm.filasProntas.push(chamado.situacao);
                    }
                });

            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            var params = {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch,
                situacao: vm.situacao,
                clienteId: vm.chamado.cliente ? vm.chamado.cliente.id : null,
                moduloId: vm.chamado.modulo ? vm.chamado.modulo.id : null,
                tipoChamado: vm.chamado.tipoChamado ? vm.chamado.tipoChamado : null
            };
            $state.transitionTo($state.$current, params);
        }


        function carregarCombos(account) {
            vm.situacoes = account.filas;
            vm.modulos = Modulo.query({page: 0, size: 99});
            vm.subModulos = SubModulo.query({page: 0, size: 99});
            vm.sprints = Sprint.query({page: 0, size: 99});
        }

        function carregarPagingParams() {
            if (pagingParams.search) {
                var texto = pagingParams.search.match(/[^0-9]/g);
                if (texto) {
                    vm.chamado.titulo = pagingParams.search;
                } else {
                    var numero = pagingParams.search.match(/\d+$/);
                    vm.chamado.id = numero ? numero [0] : null;
                }
            }
            if (pagingParams.situacao) {
                vm.chamado.situacao = pagingParams.situacao;
                vm.situacao = pagingParams.situacao;
            }
            if (pagingParams.tipoChamado) {
                vm.chamado.tipoChamado = pagingParams.tipoChamado;
            }
            if (pagingParams.moduloId) {
                vm.chamado.modulo = {id: pagingParams.moduloId};
            }
            if (pagingParams.clienteId) {
                vm.chamado.cliente = {id: pagingParams.clienteId};
            }
        }

        function getAccount() {
            Principal.identity().then(function (account) {
                vm.account = account;
                vm.isAuthenticated = Principal.isAuthenticated;
                carregarCombos(account);
                carregarPagingParams();
                // if (localStorageService.get("chamado")) {
                //     vm.chamado = localStorageService.get("chamado");
                // }
                carregarClientes();
            });
        }

        function register() {
            $state.go('register');
        }

        function editarChamado(chamado) {
            $state.go('edit-chamado', ({id: chamado.id}));
        }


        function getCorPorTipo(tipo) {
            switch (tipo) {
                case 'SUPORTE':
                    return 'warning';
                case 'BUG':
                    return 'danger';
                case 'MELHORIA':
                    return 'info';
                case 'NOVA_FUNCIONALIDADE':
                    return 'success';
                default:
                    return 'info';
            }
        }


        function sincronizarArquivos() {
            Chamado.sincronizarArquivos();
        }


        function imprimir() {

            var docDefinition = {
                pageSize: 'A4',

                // by default we use portrait, you can change it to landscape if you wish
                pageOrientation: 'landscape',

                // [left, top, right, bottom] or [horizontal, vertical] or just a number for equal margins
                pageMargins: [40, 60, 40, 60],

                content: [
                    {text: 'Webpublico - Helpdesk', style: 'header', alignment: 'center'},
                    {text: 'Relatório de Acompanhamento dos Chamados por Fila', style: 'subheader'},
                    filasImpressao()
                ],
                styles: {
                    header: {
                        fontSize: 18,
                        bold: true,
                        margin: [0, 0, 0, 10]
                    },
                    subheader: {
                        fontSize: 16,
                        bold: true,
                        margin: [0, 10, 0, 5]
                    },
                    footer: {
                        fontSize: 14,
                        italic: true,
                        margin: [0, 10, 0, 5]
                    },
                    tableExample: {
                        margin: [0, 5, 0, 15]
                    },
                    tableHeader: {
                        bold: true,
                        fontSize: 13,
                        color: 'black'
                    }
                }
            };

            // download the PDF
            pdfMake.createPdf(docDefinition).download('Chamados.pdf');
        }

        function buildTableBody(data, columns) {
            var body = [];

            body.push(columns);

            data.forEach(function (row) {
                var dataRow = [];

                columns.forEach(function (column) {
                    if (row[column]) {
                        dataRow.push(row[column].toString());
                    } else {
                        dataRow.push(" ");
                    }
                });

                body.push(dataRow);
            });

            return body;
        }

        function filasImpressao() {
            var filasImprimir = [];

            angular.forEach(vm.filasProntas, function (fila) {

                filasImprimir.push(
                    {
                        text: $filter('translate')('chamadosApp.SituacaoChamado.' + fila),
                        style: 'header',
                        alignment: 'center',
                        margin: [5, 10, 5, 10]
                    },
                    table(getChamadosParaImpressao(fila), ['Severidade', 'Tipo', 'Chamado', 'Título', 'Módulo', 'Sub-Módulo'])
                );

            });

            return filasImprimir;

        }

        function table(data, columns) {
            return {
                table: {
                    margin: [5, 10, 5, 10],
                    style: 'tableExample',
                    headerRows: 1,
                    body: buildTableBody(data, columns)
                },
                layout: 'lightHorizontalLines'
            };
        }

        function getChamadosParaImpressao(situacao) {
            var chamados = [];

            angular.forEach(vm.chamados, function (chamado) {
                if (chamado.situacao === situacao) {
                    chamados.push(
                        {
                            'Severidade': $filter('translate')('chamadosApp.Severidade.' + chamado.severidade),
                            'Tipo': $filter('translate')('chamadosApp.TipoChamado.' + chamado.tipoChamado),
                            'Chamado': chamado.id,
                            'Título': chamado.titulo,
                            'Módulo': chamado.modulo.descricao,
                            'Sub-Módulo': chamado.subModulo
                        }
                    )
                }
            });


            return chamados;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('AprovarDesenvolvimentoController', AprovarDesenvolvimentoController);
    AprovarDesenvolvimentoController.$inject = ['chamado', 'situacaoId', 'Chamado', '$state', 'SolicitacaoDesenvolvimento', '$showdown'];

    function AprovarDesenvolvimentoController(chamado, situacaoId, Chamado, $state, SolicitacaoDesenvolvimento, $showdown) {
        var vm = this;
        vm.chamado = chamado;
        vm.chamado.alteracaoCodigo = true;
        vm.solicitacaoDesenvolvimento = {
            chamado: chamado, conteudo: chamado.conteudo, titulo: chamado.titulo
        };
        console.log(">> >> >> >> > >  ", situacaoId)
        vm.chamado.complexidade = '';
        vm.calcularPlanoDesenvolvimento = calcularPlanoDesenvolvimento;
        vm.atualizarHoraEstimada = atualizarHoraEstimada;
        vm.conferirTempoApontadoComMedia = conferirTempoApontadoComMedia;
        vm.buscarHorasDoModuloAndSubmodulo = buscarHorasDoModuloAndSubmodulo;
        vm.melhorarComIa = melhorarComIa;

        function buscarHorasDoModuloAndSubmodulo() {
            if (!vm.horasPorModulo || vm.horasPorModulo.length === 0) {
                Chamado.getTempoPorModuloSubModulo(vm.chamado, function (data) {
                    vm.horasPorModulo = data;
                    calcularPlanoDesenvolvimento();
                });
            }
        }

        function melhorarComIa() {
            vm.gerandoComIa = true;
            Chamado.descricaoDevComIa({id: vm.chamado.id}, function (data) {
                vm.complemento = $showdown.makeHtml(data.mensagem);
                vm.gerandoComIa = false;
            }, function (err) {
                vm.gerandoComIa = false;
            });
        }


        buscarHorasDoModuloAndSubmodulo();

        function calcularPlanoDesenvolvimento() {
            vm.tempoTarefa = 0;
            if (vm.chamado.complexidade && chamado.tempoEstimado) {
                Chamado.calcularPlanoDesenvolvimento(vm.chamado, function (data) {
                    vm.chamado.planoDesenvolvimento = data;
                    var total = 0;
                    for (var i = 0; i < vm.chamado.planoDesenvolvimento.length; i++) {
                        var plano = vm.chamado.planoDesenvolvimento[i];
                        total = total + plano.tempoEstimado;

                        if (plano.tipoHora === 'DESENVOLVIMENTO' || plano.tipoHora === 'REVISAO') {
                            vm.tempoTarefa = vm.tempoTarefa + plano.tempoEstimado;
                        }

                    }
                });
                vm.conferirTempoApontadoComMedia();
            }
        }

        function atualizarHoraEstimada() {
            var horas = 0;
            angular.forEach(vm.chamado.planoDesenvolvimento, function (plano) {
                horas = horas + plano.tempoEstimado;
            });

            vm.chamado.tempoEstimado = horas;
        }


        function conferirTempoApontadoComMedia() {
            vm.tempoEstimadoMenorQueMedia = false;
            for (var i = 0; i < vm.horasPorModulo.length; i++) {
                var media = vm.horasPorModulo[i];
                media.escolhida = false;
                if (media.tipoChamado === vm.chamado.tipoChamado && media.complexidade === vm.chamado.complexidade && vm.chamado.tempoEstimado < media.tempoGasto) {
                    vm.tempoEstimadoMenorQueMedia = true;
                    media.escolhida = true;
                    vm.verHorasModulo = true;
                }
            }
        }

        vm.ok = function () {
            vm.isSaving = true;
            vm.solicitacaoDesenvolvimento.chamado = vm.chamado;
            if (vm.chamado.criterio) {
                vm.solicitacaoDesenvolvimento.criterio = vm.chamado.criterio;
            }
            vm.solicitacaoDesenvolvimento.conteudo =
                +"<p><b>Resumo Técnico</b></p>" + "<p>" + vm.complemento + "</p>"
                + "<p><b>Prevê Alteração no código fonte? </b>" + (vm.chamado.alteracaoCodigo ? 'Sim' : 'Não')
                + "</p>" + "<p><b>Prevê Alteração na estrutura de tabelas? " + (vm.chamado.alteracaoTabela ? 'Sim' : 'Não')
                + "</p>" + "<p><b>Prevê Alteração na arquitetura do sistema? " + (vm.chamado.alteracaoArquitetura ? 'Sim' : 'Não') + "</p>"
                + "<p><b>Outros Casos de Uso que podem sofrer impacto</b></p>" + "<p>" + vm.impacto + "</p>";

            vm.solicitacaoDesenvolvimento.tempoEstimado = vm.tempoTarefa;

            SolicitacaoDesenvolvimento.save(vm.solicitacaoDesenvolvimento, function (solicitacao) {
                solicitacao.horaAnalise = vm.horaAnalise;
                // $uibModalInstance.close(solicitacao);

                vm.tempoGasto = {chamado: vm.chamado, criadoEm: new Date(), horas: 0, minutos: 0};
                vm.tempoGasto.criadoEm = new Date();
                vm.tempoGasto.numero = 23;
                vm.tempoGasto.conteudo = 'Análise';
                vm.tempoGasto.tempo = solicitacao.horaAnalise;
                Chamado.defirnirTempo(vm.tempoGasto);
                $state.go('edit-chamado', {id: vm.chamado.id}, {reload: true});
            }, function (error) {
            });

        };

        vm.cancel = function () {
            // $uibModalInstance.dismiss('cancel');
            $state.go('edit-chamado', {id: vm.chamado.id}, {reload: true});
        };
    };


})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('AnexoChamado', AnexoChamado);

    AnexoChamado.$inject = ['$resource', '$http'];

    function AnexoChamado($resource, $http) {
        var resourceUrl = 'api/anexo-chamados/:id';

        var resource = $resource(resourceUrl, {}, {
            'query': {url: 'api/anexo-chamados-por-chamado/:id', method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'upload': {url: 'api/upload', method: 'POST'}
        });


        function baixarBlob(anexo, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function () {
                callback(xhr.response);
            };
            xhr.open('GET', anexo.conteudo);
            xhr.responseType = 'blob';
            xhr.send();
        }

        function downloadFile(anexo, callback) {
            $http.get('/api/download-anexo/' + anexo.id, {responseType: 'arraybuffer'})
                .success(function (data) {
                    var file = new Blob([data], {type: anexo.mimeType});
                    callback(file);
                });
        }

        resource.downloadFile = downloadFile;

        resource.downloadAnexo = function (anexo) {
            if (anexo.sincronizado) {
                baixarBlob(anexo, function (file) {
                    saveAs(file, anexo.descricao);
                });

            } else {
                downloadFile(anexo, function (file) {
                    saveAs(file, anexo.descricao);
                });
            }
        };

        return resource;
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('burnup', {
            parent: 'app',
            url: '/burnup',
            data: {
                authorities: ['ROLE_PO', 'ROLE_ATENDENTE', 'ROLE_DESENVOLVEDOR'],
            },
            ncyBreadcrumb: {
                label: 'Bornup'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/burnup/burnup.html',
                    controller: 'BornupController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('home');
                    $translatePartialLoader.addPart('situacaoChamado');
                    $translatePartialLoader.addPart('tipoChamado');
                    $translatePartialLoader.addPart('situacaoTarefa');
                    return $translate.refresh();
                }]
            }
        })
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('BornupController', BornupController);

    BornupController.$inject = ['$scope', '$rootScope', '$filter', 'Principal', '$state', 'Chamado', 'Sprint', 'Cliente', '$timeout', 'Modulo', 'User'];

    function BornupController($scope, $rootScope, $filter, Principal, $state, Chamado, Sprint, Cliente, $timeout, Modulo, User) {
        var vm = this;
        vm.recuperarChamados = recuperarChamados;
        vm.getChamadosNaoPlanejados = getChamadosNaoPlanejados;
        vm.getChamadosDevEntregues = getChamadosDevEntregues;
        vm.getChamadosSupEntregues = getChamadosSupEntregues;
        vm.definirModoApresentacao = definirModoApresentacao;
        vm.quantidadeRodadas = 0;

        vm.chartOptions = {
            scales: {
                yAxes: [
                    {
                        id: 'y-axis-1',
                        type: 'linear',
                        display: true,
                        position: 'left'
                    },
                    {
                        id: 'y-axis-2',
                        type: 'linear',
                        display: true,
                        position: 'right'
                    }
                ]
            }
        };
        vm.colors = ['#6f6d74', '#ff7c00', '#DCDCDC', '#46BFBD', '#FDB45C', '#949FB1', '#4D5360'];


        vm.sprints = Sprint.query();

        function load() {
            vm.tarefas = [];
            Principal.identity().then(function (account) {
                vm.account = account;
                Sprint.getBySituacao({situacao: 'EM_ANDAMENTO'}, function (aberta) {
                    vm.sprint = aberta;

                    Cliente.getByUser({}, function (data) {
                        vm.clientes = data;
                        vm.cliente = data[0];
                        recuperarChamados();
                    });
                });
            });
        }

        function inicializarGraficos() {
            vm.labelsGraficoDev = [];
            vm.labelsGraficoSup = [];

            vm.dataGraficoDev = [];
            vm.dataGraficoSup = [];

            var horaCliente = [];
            var dataHoje = new Date(vm.sprint.inicio);
            var dataFim = new Date(vm.sprint.fim);


            dataFim.setDate(dataFim.getDate() - 1);

            while ($filter('date')(dataHoje, 'yyyy-MM-dd') <= $filter('date')(dataFim, 'yyyy-MM-dd')) {
                vm.labelsGraficoDev.push($filter('date')(dataHoje, 'dd/MM/yyyy'));
                vm.labelsGraficoSup.push($filter('date')(dataHoje, 'dd/MM/yyyy'));
                horaCliente.push(vm.cliente.tempoPlanejado);
                dataHoje.setDate(dataHoje.getDate() + 1);
            }
            vm.dataGraficoDev.push(horaCliente);
            vm.dataGraficoSup.push(horaCliente);
        }

        function recuperarChamados() {
            var filtro = {
                sprint: vm.sprint,
                cliente: vm.cliente,
            };
            Chamado.getChamadosBornup(filtro, function (chamados) {
                vm.chamados = chamados;

                vm.cliente.tempoPlanejado = 0;
                angular.forEach(vm.chamados, function (chamado) {
                    if (chamado.tipoChamado !== 'SUPORTE') {
                        vm.cliente.tempoPlanejado = vm.cliente.tempoPlanejado + chamado.tempoEstimado;
                    }
                });

                inicializarGraficos();

                var dataHoje = new Date(vm.sprint.inicio)
                var dataFim = new Date(vm.sprint.fim);

                var horasEntregeDev = [];
                var horasEntregeSup = [];

                while ($filter('date')(dataHoje, 'yyyy-MM-dd') <= $filter('date')(dataFim, 'yyyy-MM-dd')) {
                    var horasEntregeDiaDev = 0;
                    var horasEntregeDiaSup = 0;

                    var date = new Date($filter('date')(dataHoje, 'yyyy-MM-dd'));
                    date.setHours(0, 0, 0, 0);

                    angular.forEach(vm.chamados, function (chamado) {
                        if (chamado.fimDesenvolvimento) {
                            if ($filter('date')(chamado.fimDesenvolvimento, 'yyyy-MM-dd') == $filter('date')(dataHoje, 'yyyy-MM-dd')) {
                                horasEntregeDiaDev = horasEntregeDiaDev + chamado.tempoEstimado;
                            }
                        }
                        if (chamado.fimTeste) {
                            if ($filter('date')(chamado.fimTeste, 'yyyy-MM-dd') == $filter('date')(dataHoje, 'yyyy-MM-dd')) {
                                horasEntregeDiaSup = horasEntregeDiaSup + chamado.tempoEstimado;
                            }
                        }
                    });

                    if (horasEntregeDev.length > 0) {
                        var horasNovas = horasEntregeDev[horasEntregeDev.length - 1] + horasEntregeDiaDev;
                        horasEntregeDev.push(horasNovas);
                    } else {
                        horasEntregeDev.push(horasEntregeDiaDev);
                    }

                    if (horasEntregeSup.length > 0) {
                        var horasNovas = horasEntregeSup[horasEntregeSup.length - 1] + horasEntregeDiaSup;
                        horasEntregeSup.push(horasNovas);
                    } else {
                        horasEntregeSup.push(horasEntregeDiaSup);
                    }

                    dataHoje.setDate(dataHoje.getDate() + 1);
                }
                if (horasEntregeDev.length > 0) {
                    vm.dataGraficoDev.push(horasEntregeDev)
                }
                if (horasEntregeSup.length > 0) {
                    vm.dataGraficoSup.push(horasEntregeSup)
                }
            });
        }


        load();

        function getChamadosNaoPlanejados() {
            var total = 0;
            angular.forEach(vm.chamados, function (chamado) {
                if (!chamado.planejado) {
                    total = total + chamado.tempoEstimado;
                }
            });
            return total;
        }

        function getChamadosDevEntregues() {
            var total = 0;
            var dataFim = new Date(vm.sprint.fim)
            angular.forEach(vm.chamados, function (chamado) {
                if (chamado.fimDesenvolvimento) {
                    if ($filter('date')(chamado.fimDesenvolvimento, 'yyyy-MM-dd') <= $filter('date')(dataFim, 'yyyy-MM-dd')) {
                        total = total + 1;
                    }
                }
            });
            return total;
        }

        function getChamadosSupEntregues() {
            var total = 0;
            var dataFim = new Date(vm.sprint.fim)
            angular.forEach(vm.chamados, function (chamado) {
                if (chamado.fimTeste) {
                    if ($filter('date')(chamado.fimTeste, 'yyyy-MM-dd') <= $filter('date')(dataFim, 'yyyy-MM-dd')) {
                        total = total + 1;
                    }
                }
            });
            return total;
        }

        function definirModoApresentacao() {
            $rootScope.modoApresentacao = !$rootScope.modoApresentacao;
            verificarModoApresentacao();
        }


        function verificarModoApresentacao() {
            if ($rootScope.modoApresentacao) {
                $timeout(function () {
                    if (vm.quantidadeRodadas === vm.clientes.length) {
                        $state.go("home");
                    } else {
                        vm.quantidadeRodadas ++;
                        vm.cliente = vm.clientes[vm.quantidadeRodadas];
                        vm.recuperarChamados();
                        verificarModoApresentacao();
                    }
                }, 30000);
            }
        }

        verificarModoApresentacao();

    }

})();



(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('AtaEditController', AtaEditController);

    AtaEditController.$inject = ['$scope', '$state', 'entity', 'Ata'];

    function AtaEditController($scope, $state, entity, Ata) {
        var vm = this;
        vm.ata = entity;
        vm.cancel = cancel;
        vm.save = save;



        function cancel() {
            $state.go('ata');
        }

        function save() {
            vm.isSaving = true;
            if (vm.ata.id !== null) {
                Ata.update(vm.ata, onSaveSuccess, onSaveError);
            } else {
                Ata.save(vm.ata, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('chamadosApp:sprintUpdate', result);
            cancel();
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('AtaDetailController', AtaDetailController);

    AtaDetailController.$inject = ['$scope', 'entity', 'Ata'];

    function AtaDetailController($scope, entity, Ata) {
        var vm = this;
        vm.ata = entity;

        vm.temposGastos = Ata.getTempoGasto({id: vm.ata.id});
    }
})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('Ata', Ata);

    Ata.$inject = ['$resource'];

    function Ata($resource) {
        var resourceUrl = 'api/ata/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'getTempoGasto': {url: 'api/tempo-gasto-by-ata/:id', method: 'GET', isArray: true},
            'get': {
                method: 'GET'
            },
            'getByNumero': {
                url: 'api/ata/por-numero/:numero',
                method: 'GET'
            },
            'update': {method: 'PUT'},
            'criarPlanejamento': {
                method: 'PUT',
                url: 'api/ata/criar-planejamento',
            },
            'criarEncerramento': {
                method: 'PUT',
                url: 'api/ata/criar-encerramento',
            },
            'criarReuniaoDiaria': {
                method: 'PUT',
                url: 'api/ata/criar-reuniaodiaria',
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('ata', {
                parent: 'entity',
                url: '/ata?page&sort&search',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_DESENVOLVEDOR', 'ROLE_PO'],
                    pageTitle: 'Ata'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/ata/ata.html',
                        controller: 'AtaController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,desc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('edit-ata', {
                parent: 'ata',
                url: '/ata-edit/{id}',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_DESENVOLVEDOR', 'ROLE_PO'],
                    pageTitle: 'Edição de ATA'
                },
                ncyBreadcrumb: {
                    label: 'Edição de ATA'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/ata/ata-edit.html',
                        controller: 'AtaEditController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'Ata', function ($stateParams, Ata) {
                        return Ata.get({id: $stateParams.id}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('detail-ata', {
                parent: 'ata',
                url: '/ata-detail/{id}',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_DESENVOLVEDOR', 'ROLE_PO'],
                    pageTitle: 'Detalhes da Ata'
                },
                ncyBreadcrumb: {
                    label: 'Detalhes da Ata'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/ata/ata-detail.html',
                        controller: 'AtaDetailController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'Ata', function ($stateParams, Ata) {
                        return Ata.get({id: $stateParams.id}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tipoHora');

                        return $translate.refresh();
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })
            .state('new-ata', {
                parent: 'ata',
                url: '/ata-new/{id}',
                data: {
                    authorities: ['ROLE_ATENDENTE', 'ROLE_DESENVOLVEDOR', 'ROLE_PO'],
                    pageTitle: 'Nova ATA'
                },
                ncyBreadcrumb: {
                    label: 'Nova ATA'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/ata/ata-edit.html',
                        controller: 'AtaEditController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'Ata', function ($stateParams, Ata) {
                        return {};
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        return $translate.refresh();
                    }],
                    previousState: ["$state", function ($state) {
                        var currentStateData = {
                            name: $state.current.name || 'home',
                            params: $state.params,
                            url: $state.href($state.current.name, $state.params)
                        };
                        return currentStateData;
                    }]
                }
            })


    }

})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('AtaController', AtaController);

    AtaController.$inject = ['$scope', '$state', 'Ata', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Alerta'];

    function AtaController($scope, $state, Ata, ParseLinks, AlertService, paginationConstants, pagingParams, Alerta) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.remover = remover;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.atas;

        function loadAll() {
            Ata.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                filtro: vm.filtro
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.atas = data;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        vm.loadAll();

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function remover(id) {
            Alerta.confirm("Atenção", "Tem certeza que deseja remover essa Ação?", "warning", function () {
                Ata.delete({id: id},
                    function () {
                        Alerta.success("Operação realizada", "O Ação foi removida!");
                        vm.loadAll();
                        $scope.$emit('chamadosApp:ataUpdate');

                    });
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('AplicacaoDialogController', AplicacaoDialogController);

    AplicacaoDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance',
        'entity', 'Principal', 'Cliente', 'Aplicacao', 'User', 'Sistema', 'Cidade', 'Uf'];

    function AplicacaoDialogController($timeout, $scope, $stateParams, $uibModalInstance,
                                       entity, Principal, Cliente, Aplicacao, User, Sistema,
                                       Cidade, Uf) {
        var vm = this;

        vm.aplicacao = entity;
        vm.clear = clear;
        vm.save = save;
        vm.carregarCliente = carregarCliente;
        vm.carregarSistemas = carregarSistemas;
        vm.adicionarOcorrencia = adicionarOcorrencia;
        vm.removerOcorrencia = removerOcorrencia;
        vm.indexOcorrencia = indexOcorrencia;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.ocorrencia = {};
        vm.ufs = [];
        vm.loadUfs = loadUfs;
        vm.cidades = [];
        vm.loadCidades = loadCidades;

        $timeout(function () {
            vm.loadUfs();
            if (vm.aplicacao && vm.aplicacao.cidade) {
                vm.aplicacao.uf = vm.aplicacao.cidade.uf;
                vm.loadCidades();
            }
            angular.element('.form-group:eq(1)>input').focus();
        });

        carregarCliente();

        function carregarCliente() {
            Cliente.getByUser({}, function (data) {
                vm.clientes = data;
                if (vm.aplicacao.id === null) {
                    vm.aplicacao.cliente = vm.clientes[0];
                }
                carregarSistemas();
            })
        }

        function carregarSistemas() {
            if (vm.aplicacao.cliente) {
                Sistema.getByCliente({clienteId: vm.aplicacao.cliente.id}, function (data) {
                    vm.sistemas = data;
                })
            } else {
                vm.sistemas = [];
            }
        }

        function adicionarOcorrencia() {
            if (vm.aplicacao.ocorrencias === undefined) {
                vm.aplicacao.ocorrencias = [];
            }
            vm.aplicacao.ocorrencias.push(vm.ocorrencia);
            vm.ocorrencia = {};
        }

        function indexOcorrencia(id) {
            for (var i = 0; i < vm.aplicacao.ocorrencias.length; i++) {
                if (vm.aplicacao.ocorrencias[i].id === id) {
                    return i;
                }
            }
            return -1;
        }

        function removerOcorrencia(ocorrencia) {
            vm.aplicacao.ocorrencias.splice(vm.indexOcorrencia(ocorrencia.id), 1)
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function save() {
            console.log('aa ..:' + JSON.stringify(vm.aplicacao))
            vm.isSaving = true;
            if (vm.aplicacao.id !== null) {
                Aplicacao.update(vm.aplicacao, onSaveSuccess, onSaveError);
            } else {
                Aplicacao.save(vm.aplicacao, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('chamadosApp:clienteUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function loadUfs() {
            vm.ufs = [];
            Uf.findAll({}, function (data) {
                vm.ufs = data;
            });
        }

        function loadCidades() {
            vm.cidades = [];
            if (vm.aplicacao.uf) {
                Cidade.findByUf({idUf: vm.aplicacao.uf.id}, function (data) {
                    vm.cidades = data;
                });
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('aplicacao', {
            parent: 'entity',
            url: '/aplicacao?page&sort&search',
            data: {
                authorities: ['ROLE_PO', 'ROLE_DESENVOLVEDOR'],
                pageTitle: 'chamadosApp.aplicacao.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/aplicacao/aplicacao.html',
                    controller: 'AplicacaoController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('aplicacao');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('aplicacao.new', {
            parent: 'aplicacao',
            url: '/new',
            data: {
                authorities: ['ROLE_PO', 'ROLE_DESENVOLVEDOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aplicacao/aplicacao-dialog.html',
                    controller: 'AplicacaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nome: null,
                                url: null,
                                id: null,
                                cliente: null,
                                sistema: null,
                                ocorrencias: []
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('aplicacao', null, { reload: 'aplicacao' });
                }, function() {
                    $state.go('aplicacao');
                });
            }]
        })
        .state('aplicacao.edit', {
            parent: 'aplicacao',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_PO', 'ROLE_DESENVOLVEDOR']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/aplicacao/aplicacao-dialog.html',
                    controller: 'AplicacaoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['Aplicacao', function(Aplicacao) {
                            return Aplicacao.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('aplicacao', null, { reload: 'aplicacao' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
    }

})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('Aplicacao', Aplicacao);

    Aplicacao.$inject = ['$resource', 'DateUtils'];

    function Aplicacao($resource, DateUtils) {
        var resourceUrl = 'api/aplicacaos/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.criadoEm = DateUtils.convertLocalDateFromServer(data.criadoEm);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'verififcarSituacao': {
                method: 'GET',
                url: 'api/aplicacaos-status/:id',
                isArray: false
            },
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('AplicacaoController', AplicacaoController);

    AplicacaoController.$inject = ['$scope', '$state', 'Aplicacao', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Alerta', 'Cliente'];

    function AplicacaoController($scope, $state, Aplicacao, ParseLinks, AlertService, paginationConstants, pagingParams, Alerta, Cliente) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.remover = remover;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.selecionarCliente = selecionarCliente;
        vm.verificarSituacao = verificarSituacao;

        loadAll();

        function carregarClientes() {
            Cliente.getByUser({}, function (data) {
                vm.clientes = data;
                vm.cliente = data[0];
                carregarAplicacoes();
            })
        }

        function loadAll() {
            carregarClientes();

        }

        function carregarAplicacoes() {
            Aplicacao.query({
                page: pagingParams.page - 1,
                size: 9999,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.agrupador = {};
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                for (var i = 0; i < data.length; i++) {
                    if (!vm.agrupador[data[i].agrupador]) {
                        vm.agrupador[data[i].agrupador] = {nome: data[i].agrupador, aplicacoes: []};
                    }
                    vm.agrupador[data[i].agrupador].aplicacoes.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function selecionarCliente(cliente) {
            vm.cliente = cliente;
            carregarAplicacoes();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function remover(id) {
            Alerta.confirm("Atenção", "Tem certeza que deseja remover esse Aplicacao?", "warning", function () {
                Aplicacao.delete({id: id},
                    function () {
                        Alerta.success("Operação realizada", "O Aplicacao foi removido!");
                        loadAll();
                    });
            });
        }

        function verificarSituacao(id) {

            Aplicacao.verififcarSituacao({id: id},
                function () {
                    loadAll();
                });

        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('AgrupadorDialogController', AgrupadorDialogController);

    AgrupadorDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'previousState', 'entity', 'Principal', 'Cliente', 'Agrupador', 'User', 'Chamado'];

    function AgrupadorDialogController($timeout, $scope, $stateParams, $uibModalInstance, previousState, entity, Principal, Cliente, Agrupador, User, Chamado) {
        var vm = this;

        vm.previousState = previousState;
        vm.agrupador = entity;
        vm.clear = clear;
        vm.save = save;
        vm.carregarCliente = carregarCliente;
        vm.datePickerOpenStatus = {};
        vm.openCalendar = openCalendar;
        vm.alocar = alocar;
        vm.desalocar = desalocar;
        vm.getTamanhoBarraPorSituacao = getTamanhoBarraPorSituacao;
        vm.ocorrencia = {};

        $timeout(function () {
            angular.element('.form-group:eq(1)>input').focus();
        });

        carregarCliente();

        function carregarCliente() {
            Cliente.getByUser({}, function (data) {
                vm.clientes = data;
                if (vm.agrupador.cliente) {
                    for (var i = 0; i < vm.clientes.length; i++) {
                        if (vm.clientes[i].id === vm.agrupador.cliente.id) {
                            vm.agrupador.cliente = vm.clientes[i];
                            break;
                        }
                    }
                } else {
                    vm.agrupador.cliente = vm.clientes[0];
                }
            })
        }


        function clear() {
            $uibModalInstance.close(previousState);
        }

        function save() {
            vm.isSaving = true;
            if (vm.agrupador.id !== null) {
                Agrupador.update(vm.agrupador, onSaveSuccess, onSaveError);
            } else {
                Agrupador.save(vm.agrupador, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            $scope.$emit('chamadosApp:agrupadorUpdate', result);
            $uibModalInstance.close(vm.previousState);
            vm.isSaving = false;
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function alocar(chamado) {
            if (!vm.agrupador.chamados) {
                vm.agrupador.chamados = [];
            }
            Chamado.get({id: chamado}, function (data) {
                vm.agrupador.chamados.push(data);
                vm.adicionar = '';
            })

        }

        function desalocar(chamado) {
            vm.agrupador.chamados.splice(indexChamado(chamado.id), 1);
        }

        function agruparChamados(data) {
            vm.agrupador = data;
        }

        function indexChamado(id) {
            for (var i = 0; i < vm.agrupador.chamados.length; i++) {
                if (vm.agrupador.chamados[i].id === id) {
                    return i;
                }
            }
            return -1;
        }


        function getTamanhoBarraPorSituacao(situacao) {
            switch (situacao) {
                case 'ABERTO':
                    return '0%';
                case 'IMPEDIDO':
                    return '0%';
                case 'EM_SUPORTE':
                    return '10%';
                case 'EM_ANALISE':
                    return '20%';
                case 'TESTE_SUPORTE':
                    return '70%';
                case 'EM_DESENVOLVIMENTO':
                    return '60%';
                case 'AGUARDANDO_TESTE':
                    return '80%';
                case 'AGUARDANDO_VALIDACAO':
                    return '90%';
                case 'FECHADO':
                    return '100%';
                case 'REJEITADO':
                    return '0%';
                case 'VALIDADO':
                    return '100%';
                case 'AGUARDANDO_DESENVOLVIMENTO':
                    return '30%';
                default:
                    return '0%';
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('agrupador', {
                parent: 'entity',
                url: '/agrupador?page&sort&search&clienteId',
                data: {
                    authorities: ['ROLE_USER'],
                    pageTitle: 'chamadosApp.agrupador.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/entities/agrupador/agrupador.html',
                        controller: 'AgrupadorController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null,
                    clienteId: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search,
                            clienteId: $stateParams.clienteId
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('agrupador');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('agrupador.new', {
                parent: 'agrupador',
                url: '/new',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/agrupador/agrupador-dialog.html',
                        controller: 'AgrupadorDialogController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        size: 'lg',
                        resolve: {
                            entity: function () {
                                return {
                                    nome: null,
                                    url: null,
                                    id: null,
                                    cliente: null,
                                    criadoEm: null,
                                    previsaoEntrega: null,
                                    chamados: []
                                };
                            },
                            previousState: ["$state", function ($state) {
                                var currentStateData = {
                                    name: $state.current.name || 'home',
                                    params: $state.params,
                                    url: $state.href($state.current.name, $state.params)
                                };
                                return currentStateData;
                            }]
                        }
                    }).result.then(function (previousState) {
                        $state.go(previousState.name);
                    }, function () {
                        $state.go('agrupador');
                    });
                }]
            })
            .state('agrupador.edit', {
                parent: 'agrupador',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_USER']
                },
                onEnter: ['$stateParams', '$state', '$uibModal',
                    function ($stateParams, $state, $uibModal) {
                        $uibModal.open({
                            templateUrl: 'app/entities/agrupador/agrupador-dialog.html',
                            controller: 'AgrupadorDialogController',
                            controllerAs: 'vm',
                            backdrop: 'static',
                            size: 'lg',
                            resolve: {
                                entity: ['Agrupador', function (Agrupador) {
                                    return Agrupador.get({id: $stateParams.id}).$promise;
                                }],
                                previousState: ["$state", function ($state) {
                                    var currentStateData = {
                                        name: $state.current.name || 'home',
                                        params: $state.params,
                                        url: $state.href($state.current.name, $state.params)
                                    };
                                    return currentStateData;
                                }]
                            },

                        }).result.then(function (previousState) {
                            $state.go(previousState.name);
                        }, function () {
                            $state.go('^');
                        });
                    }]
            })
    }

})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('Agrupador', Agrupador);

    Agrupador.$inject = ['$resource', 'DateUtils'];

    function Agrupador($resource, DateUtils) {
        var resourceUrl = 'api/chamado-agrupador/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'contarPorCliente': {url: 'api/agrupador/contar-por-cliente', method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.criadoEm = DateUtils.convertLocalDateFromServer(data.criadoEm);
                        data.previsaoEntrega = DateUtils.convertLocalDateFromServer(data.previsaoEntrega);
                    }
                    return data;
                }
            },
            'update': {method: 'PUT'},
            'alocar': {
                method: 'POST',
                url: 'api/agrupar-chamado',
                transformRequest: function (data) {
                    var copy = angular.copy(data);
                    copy.criadoEm = DateUtils.convertLocalDateFromServer(copy.criadoEm);
                    copy.previsaoEntrega = DateUtils.convertLocalDateFromServer(copy.previsaoEntrega);
                    return angular.toJson(copy);
                }
            },
            'getBychamado': {
                method: 'GET',
                url: 'api/agrupador-by-chamado/:id',
                isArray: true,
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.criadoEm = DateUtils.convertLocalDateFromServer(data.criadoEm);
                        data.previsaoEntrega = DateUtils.convertLocalDateFromServer(data.previsaoEntrega);
                    }
                    return data;
                }
            },
            'getBySituacao': {
                method: 'GET',
                url: 'api/agrupador-por-situacao',
                isArray: true,

            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('AgrupadorController', AgrupadorController);

    AgrupadorController.$inject = ['$scope', '$state', 'Agrupador', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Alerta'];

    function AgrupadorController($scope, $state, Agrupador, ParseLinks, AlertService, paginationConstants, pagingParams, Alerta) {
        var vm = this;

        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.remover = remover;
        vm.loadAll = loadAll;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.selecionarCliente = selecionarCliente;
        vm.filtro = pagingParams.search ? pagingParams.search : "";

        loadAll();

        function carregarClientes() {
            Agrupador.contarPorCliente({}, function (data) {
                vm.clientes = data;
                if (vm.clientes.length === 0) {
                    vm.cliente = null;
                    vm.agrupadores = [];
                    return;
                }
                selecionarClienteInicial();
                carregarAplicacoes();
            })
        }

        function selecionarClienteInicial() {
            if (pagingParams.clienteId) {
                for (var i = 0; i < vm.clientes.length; i++) {
                    if (vm.clientes[i].id == pagingParams.clienteId) {
                        vm.cliente = vm.clientes[i];
                        return;
                    }
                }
            }
            vm.cliente = vm.clientes[0];
        }

        function loadAll() {
            carregarClientes();
        }

        function carregarAplicacoes() {
            if (!vm.cliente) {
                vm.agrupadores = [];
                return;
            }
            Agrupador.query({
                clienteId: vm.cliente.id,
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                filtro: vm.filtro,
                sort: sort()
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.agrupadores = [];
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                vm.agrupadores = data;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function selecionarCliente(cliente) {
            vm.cliente = cliente;
            carregarAplicacoes();
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.filtro,
                clienteId: vm.cliente ? vm.cliente.id : null,
            });
        }

        function remover(id) {
            Alerta.confirm("Atenção", "Tem certeza que deseja remover esse Agrupador?", "warning", function () {
                Agrupador.delete({id: id},
                    function () {
                        Alerta.success("Operação realizada", "O Agrupador foi removido!");
                        loadAll();
                    });
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();

(function(){
    'use strict';

    angular
        .module('chamadosApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split('>;');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ">;"');
                }
                var url = section[0].replace(/<(.*)/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();

(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Exibindo {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'de {{$ctrl.queryCount}} itens.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('chamadosApp')
        .component('jhiItemCount', jhiItemCount);
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {
            if (input !== null) {
                input = input.toLowerCase();
                input = input.substring(0, 1).toUpperCase() + input.substring(1);
            }
            return input;
        }
    }
})();

(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('chamadosApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3,
                enc1, enc2, enc3, enc4,
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }
            }

            return output;
        }
    }
})();

angular.module('chamadosApp')
    .component('situacoesSprint', {
        bindings: {
            situacoesSprintSelecionadas: '=',
            mostrarBotaoAtribuidasParaMim: '<',
            atribuidasParaMim: '=',
            onSelecionar: '&'
        },
        templateUrl: 'app/components/situacoesSprint/situacoesSprint.component.html',
        controller: function() {
            var $ctrl = this;
            $ctrl.situacoesSprint = [null, 'ABERTA', 'EM_ANDAMENTO', 'FECHADA'];
            $ctrl.mostrarBotaoAtribuidasParaMim = $ctrl.mostrarBotaoAtribuidasParaMim !== undefined ?
                $ctrl.mostrarBotaoAtribuidasParaMim : true;

            $ctrl.isSelecionado = function(situacao) {
                return $ctrl.situacoesSprintSelecionadas.indexOf(situacao) >= 0;
            };

            $ctrl.isAtribuidasParaMim = function () {
                return $ctrl.atribuidasParaMim === true;
            }

            $ctrl.inverterAtribuidasParaMim = function () {
                $ctrl.atribuidasParaMim = !$ctrl.atribuidasParaMim;
                $ctrl.onSelecionar();
            }

            $ctrl.inverterSituacao = function (situacao) {
                var index = $ctrl.situacoesSprintSelecionadas.indexOf(situacao);
                if (index >= 0) {
                    $ctrl.situacoesSprintSelecionadas.splice(index, 1);
                } else {
                    $ctrl.situacoesSprintSelecionadas.push(situacao);
                }
                $ctrl.onSelecionar();
            };
        }
    });

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('Alerta', Alerta);

    Alerta.$inject = ['SweetAlert'];

    function Alerta(SweetAlert) {
        return {
            success: function (title, message) {
                SweetAlert.swal({title: title, text: message, type: "success", html: true});
            },
            error: function (title, message) {
                SweetAlert.swal({title: title, text: message, type: "error", html: true});
            },
            info: function (title, message) {
                SweetAlert.swal({title: title, text: message, type: "info", html: true});
            },
            warn: function (title, message) {
                SweetAlert.swal({title: title, text: message, type: "warning", html: true});
            },
            confirm: function (title, text, type, callBackSuccess, callBackCancel) {
                SweetAlert.swal({
                        title: title,
                        text: text,
                        type: type,
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Sim",
                        cancelButtonText: "Não",
                        closeOnConfirm: true,
                        closeOnCancel: true
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            callBackSuccess();
                        } else {
                            callBackCancel();
                        }
                    });
            },
            confirmDelete: function (callBack) {
                SweetAlert.swal({
                        title: "Confirme a exclusão",
                        text: "Você tem certeza que quer excluir o registro selecionado?",
                        type: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#DD6B55", confirmButtonText: "Sim, Excluir",
                        cancelButtonText: "Não, Cancelar",
                        closeOnConfirm: false,
                        closeOnCancel: false
                    },
                    function (isConfirm) {
                        if (isConfirm) {
                            callBack();
                            SweetAlert.swal("Removido!", "O registro foi removido com sucesso.", "success");
                        } else {
                            SweetAlert.swal("Cancelado", "O registro não foi removido :)", "error");
                        }
                    });
            }
        }
    }
})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .directive('sideNavigation', sideNavigation);

    sideNavigation.$inject = ['$timeout'];

    function sideNavigation($timeout) {
        return {
            restrict: 'A',
            link: function(scope, element) {
                // Call the metsiMenu plugin and plug it to sidebar navigation
                $timeout(function(){
                    element.metisMenu();

                });
            }
        };
    };
})();


(function () {
    'use strict';


    var minimalizaSidebar = {
        restrict: 'A',
        template: '<a class="navbar-minimalize minimalize-styl-2 text-white" href="" ng-click="minimalize()"><i class="fa fa-bars"></i></a>',
        controller: minimalizaSidebarController
    }

    angular
        .module('chamadosApp')
        .component('minimalizaSidebar', minimalizaSidebar);

    minimalizaSidebarController.$inject = ['$scope'];


    function minimalizaSidebarController($scope) {

        $scope.minimalize = function () {
            $("body").toggleClass("mini-navbar");
            if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
                // Hide menu in order to smoothly turn on when maximize menu
                $('#side-menu').hide();
                // For smoothly turn on menu
                setTimeout(
                    function () {
                        $('#side-menu').fadeIn(500);
                    }, 100);
            } else if ($('body').hasClass('fixed-sidebar')) {
                $('#side-menu').hide();
                setTimeout(
                    function () {
                        $('#side-menu').fadeIn(500);
                    }, 300);
            } else {
                // Remove all inline style from jquery fadeIn function to reset menu state
                $('#side-menu').removeAttr('style');
            }
        }

    };
})();



(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .directive('loading', loading);

    loading.$inject = ['$http'];

    function loading($http) {
        return {
            restrict: 'A',
            link: function (scope, elm, attrs) {
                scope.isLoading = function () {
                    return $http.pendingRequests.length > 0;
                };
                scope.$watch(scope.isLoading, function (v) {
                    if (v) {
                        elm.show();
                    } else {
                        elm.hide();
                    }
                });
            }
        }
    }
})();


(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService ($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll () {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent () {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'et': 'Eesti',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Nederlands',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sr': 'Srpski',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'vi': 'Tiếng Việt',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'pt-pt'
            // jhipster-needle-i18n-language-constant - JHipster will add/remove languages in this array
        ]
    );
})();

(function () {
    'use strict';

    $(document).ready(function () {

        // Full height of sidebar
        function fix_height() {
            var heightWithoutNavbar = $("body > #wrapper").height() - 61;
            $(".sidebard-panel").css("min-height", heightWithoutNavbar + "px");

            var navbarHeigh = $('nav.navbar-default').height();
            var wrapperHeigh = $('#page-wrapper').height();

            if (navbarHeigh > wrapperHeigh) {
                $('#page-wrapper').css("min-height", navbarHeigh + "px");
            }

            if (navbarHeigh < wrapperHeigh) {
                $('#page-wrapper').css("min-height", $(window).height() + "px");
            }

            if ($('body').hasClass('fixed-nav')) {
                $('#page-wrapper').css("min-height", $(window).height() - 60 + "px");
            }
        }

        $(window).bind("load resize scroll", function () {
            if (!$("body").hasClass('body-small')) {
                fix_height();
            }
        });

        // Move right sidebar top after scroll
        $(window).scroll(function () {
            if ($(window).scrollTop() > 0 && !$('body').hasClass('fixed-nav')) {
                $('#right-sidebar').addClass('sidebar-top');
            } else {
                $('#right-sidebar').removeClass('sidebar-top');
            }
        });

        setTimeout(function () {
            fix_height();
        });

    });

// Minimalize menu when screen is less than 768px
    $(function () {
        $(window).bind("load resize", function () {
            if ($(this).width() < 769) {
                $('body').addClass('body-small')
            } else {
                $('body').removeClass('body-small')
            }
        })
    });
})();

// (function () {
//     'use strict';
//     angular
//         .module('chamadosApp')
//         .directive('gravatar', gravatar);
//
//
//     function gravatar() {
//         return {
//             restrict: 'E',
//             replace: true,
//             scope: {
//                 name: '@',
//                 height: '@',
//                 width: '@',
//                 email: '@'
//             },
//             link: function (scope, el, attr) {
//                 scope.defaultImage = 'https://somedomain.com/images/avatar.png';
//             },
//             template: '<img class="img-circle" title="{{ name }}" alt="{{ name }}" height="{{ height }}"  width="{{ width }}" ' +
//             'src="https://secure.gravatar.com/avatar/{{ email | gravatar }}.jpg?s={{ width }}&d=mm">'
//         };
//     };
// })();
//

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(configTextArea);


    configTextArea.$inject = ['$provide'];

    function configTextArea($provide) {

        $provide.decorator('taOptions', ['taRegisterTool', '$delegate', '$uibModal', function (taRegisterTool, taOptions, $uibModal) { // $delegate is the taOptions we are decorating

            taRegisterTool('customImageUpload', {
                iconclass: "fa fa-image",
                action: function ($deferred, restoreSelection) {
                    var textAngular = this;

                    var modalInstance = $uibModal.open({
                        size: 'lg',
                        animation: true,
                        templateUrl: 'app/entities/imagem/imagem-upload.html',
                        controller: 'ImagemController',
                        controllerAs: 'vm',
                        backdrop: 'static',
                    });

                    modalInstance.result.then(function (anexo) {
                        restoreSelection();
                        textAngular.$editor().wrapSelection('insertImage', anexo.conteudo);
                        $deferred.resolve();
                    });
                    return false;
                }
            });
            taOptions.toolbar[3].push('customImageUpload');
            taOptions.toolbar[3].splice(taOptions.toolbar[3].indexOf('insertImage'), 1);
            return taOptions;
        }]);
    }

})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, formCtrl) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        var inputName = $input.attr('name');
                        scope.$watch(function() {
                            return formCtrl[inputName].$invalid && formCtrl[inputName].$dirty;
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .directive('searchBox', searchBox);

    var tmplt = "<div class='form-group input-group'>\
                            <input type='text' class='form-control'\
                                 ng-model='ngModel' id='searchQuery'\
                                 ng-keyup='keyPressPlanItem($event)'\
                                 placeholder='{{&quot;global.form.search&quot; | translate}}'>\
                                    <span class='input-group-btn'>\
                                        <button class='btn btn-info' ng-click='search()'><span\
                                             class='glyphicon glyphicon-search'></span>\
                                        </button>\
                                    </span>\
                    </div>";

    function searchBox () {
        var directive = {
            restrict: 'E',
            scope: {
                ngModel: '=',
                searchMethod: '&searchMethod'
            },
            require: '?ngModel',
            template: tmplt,
            replace: true,
            link: function (scope, elm, attrs, ctrl) {
                scope.search = function () {
                    scope.searchMethod();
                }
                scope.keyPressPlanItem = function ($event) {
                    if ($event.keyCode == 13) {
                        scope.search();
                    }
                };

            }
        };

        return directive;
    }
})();


(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .directive('escapeHtml', escapeHtml);


    escapeHtml.$inject =['$sanitize'];

    function escapeHtml ($sanitize) {

        var directive = {
            restrict: 'E',
            scope: {
                conteudo: '=conteudo'
            },
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs) {
            if (!scope.conteudo) {
                return;
            }

            element.text((scope.conteudo));

        }
    }

})();

/*! @source http://purl.eligrey.com/github/FileSaver.js/blob/master/FileSaver.js */
var saveAs=saveAs||function(e){"use strict";if(typeof e==="undefined"||typeof navigator!=="undefined"&&/MSIE [1-9]\./.test(navigator.userAgent)){return}var t=e.document,n=function(){return e.URL||e.webkitURL||e},r=t.createElementNS("http://www.w3.org/1999/xhtml","a"),o="download"in r,a=function(e){var t=new MouseEvent("click");e.dispatchEvent(t)},i=/constructor/i.test(e.HTMLElement)||e.safari,f=/CriOS\/[\d]+/.test(navigator.userAgent),u=function(t){(e.setImmediate||e.setTimeout)(function(){throw t},0)},s="application/octet-stream",d=1e3*40,c=function(e){var t=function(){if(typeof e==="string"){n().revokeObjectURL(e)}else{e.remove()}};setTimeout(t,d)},l=function(e,t,n){t=[].concat(t);var r=t.length;while(r--){var o=e["on"+t[r]];if(typeof o==="function"){try{o.call(e,n||e)}catch(a){u(a)}}}},p=function(e){if(/^\s*(?:text\/\S*|application\/xml|\S*\/\S*\+xml)\s*;.*charset\s*=\s*utf-8/i.test(e.type)){return new Blob([String.fromCharCode(65279),e],{type:e.type})}return e},v=function(t,u,d){if(!d){t=p(t)}var v=this,w=t.type,m=w===s,y,h=function(){l(v,"writestart progress write writeend".split(" "))},S=function(){if((f||m&&i)&&e.FileReader){var r=new FileReader;r.onloadend=function(){var t=f?r.result:r.result.replace(/^data:[^;]*;/,"data:attachment/file;");var n=e.open(t,"_blank");if(!n)e.location.href=t;t=undefined;v.readyState=v.DONE;h()};r.readAsDataURL(t);v.readyState=v.INIT;return}if(!y){y=n().createObjectURL(t)}if(m){e.location.href=y}else{var o=e.open(y,"_blank");if(!o){e.location.href=y}}v.readyState=v.DONE;h();c(y)};v.readyState=v.INIT;if(o){y=n().createObjectURL(t);setTimeout(function(){r.href=y;r.download=u;a(r);h();c(y);v.readyState=v.DONE});return}S()},w=v.prototype,m=function(e,t,n){return new v(e,t||e.name||"download",n)};if(typeof navigator!=="undefined"&&navigator.msSaveOrOpenBlob){return function(e,t,n){t=t||e.name||"download";if(!n){e=p(e)}return navigator.msSaveOrOpenBlob(e,t)}}w.abort=function(){};w.readyState=w.INIT=0;w.WRITING=1;w.DONE=2;w.error=w.onwritestart=w.onprogress=w.onwrite=w.onabort=w.onerror=w.onwriteend=null;return m}(typeof self!=="undefined"&&self||typeof window!=="undefined"&&window||this.content);if(typeof module!=="undefined"&&module.exports){module.exports.saveAs=saveAs}else if(typeof define!=="undefined"&&define!==null&&define.amd!==null){define("FileSaver.js",function(){return saveAs})}

(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('chamadosApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('chamadosApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var headers = Object.keys(httpResponse.headers()).filter(function (header) {
                    return header.indexOf('app-error', header.length - 'app-error'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
                }).sort();
                var errorHeader = httpResponse.headers(headers[0]);
                var entityKey = httpResponse.headers(headers[1]);
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('chamadosApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .provider('AlertService', AlertService);

    function AlertService () {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService ($timeout, $sce,$translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 5000; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning : warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts = [];
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function (alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if(!alert.scoped) {
                    alerts.push(alert);
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                alertOptions.msg = $translate.instant(alertOptions.msg, alertOptions.params);
                var that = this;
                var alert = this.factory(alertOptions);
                if (alertOptions.timeout && alertOptions.timeout > 0) {
                    $timeout(function () {
                        that.closeAlert(alertOptions.alertId, extAlerts);
                    }, alertOptions.timeout);
                }
                return alert;
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) { return e.id; }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();

(function() {
    'use strict';

    var jhiAlert = {
        template: '<div class="alerts" ng-cloak="" role="alert">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre ng-bind-html="alert.msg"></pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertController
    };

    angular
        .module('chamadosApp')
        .component('jhiAlert', jhiAlert);

    jhiAlertController.$inject = ['$scope', 'AlertService'];

    function jhiAlertController($scope, AlertService) {
        var vm = this;

        vm.alerts = AlertService.get();
        $scope.$on('$destroy', function () {
            vm.alerts = [];
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var headers = Object.keys(response.headers()).filter(function (header) {
                return header.indexOf('app-alert', header.length - 'app-alert'.length) !== -1 || header.indexOf('app-params', header.length - 'app-params'.length) !== -1;
            }).sort();
            var alertKey = response.headers(headers[0]);
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers(headers[1])});
            }
            return response;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('chamadosApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);

    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector'];

    function authExpiredInterceptor($rootScope, $q, $injector) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            console.error(response);
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && angular.isDefined(response.data.path) && response.data.path.indexOf('/api/account') === -1) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                if (to.name !== 'accessdenied') {
                    Auth.storePreviousState(to.name, params);
                }
                var $state = $injector.get('$state');
                if ($state.parent !== 'account') {
                    $state.go('login');
                }
            }
            // }else if(response.status === 401){
            //     var $state = $injector.get('$state');
            //     var Alerta = $injector.get('Alerta');
            //     $state.go('home');
            //     Alerta.error("Atenção", "Você não tem permissão para acesso a esse conteúdo");
            // }


            if (response.status === 409) {
                var Alerta = $injector.get('Alerta');
                Alerta.error("Atenção", "O registro que você está tentando salvar está em uma versão diferente, provavelmente foi alterado por outro usuário, atualize a página e tente novamente");
            }
            if (response.status === 400) {
                var Alerta = $injector.get('Alerta');
                if (response.data.fieldErrors && response.data.fieldErrors.length > 0) {
                    var campos = "";
                    for (var i = 0; i < response.data.fieldErrors.length; i++) {
                        campos = response.data.fieldErrors[i];
                    }
                    Alerta.error("Atenção", campos);
                } else if (response.data.message) {
                    Alerta.error(response.data.message);
                } else if (response.message) {
                    Alerta.error(response.message);
                } else if (response.data.error == 'invalid_grant') {
                    //Alerta.error("Error - " + [status]);
                } else {
                    var headers = null;
                    angular.forEach(Object.keys(response.headers()), function (header) {
                        if(header.contains('alert')){
                            headers = header;
                        }
                    });
                    if(headers != null){
                        var mensagem = response.headers(headers);
                        Alerta.error(mensagem);
                    }
                }
            }
            if (status === 500) {
                Alerta.error(" Error - " + [status]);
            }


            return $q.reject(response);
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('authInterceptor', authInterceptor);

    authInterceptor.$inject = ['localStorageService']

    function authInterceptor(localStorageService) {
        return {
            request: function (config) {
                config.headers = config.headers || {};
                // if (localStorageService.get('clientePrincipal')) {
                //     config.headers.clienteId = localStorageService.get('clientePrincipal').id;
                // }
                return config;
            }
        };
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate'];

    function translationHandler($rootScope, $window, $state, $translate) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function() {
                updateTitle();
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null){
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precedence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function (title) {
                $window.document.title = title;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function (event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }

                // Update the language
                JhiLanguageService.getCurrent().then(function (language) {
                    $translate.use(language);
                });
            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess',  function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title' ;

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);

                document.body.scrollTop = document.documentElement.scrollTop =0;
            });

            $rootScope.$on('$destroy', function () {
                if(angular.isDefined(stateChangeStart) && stateChangeStart !== null){
                    stateChangeStart();
                }
                if(angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null){
                    stateChangeSuccess();
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to preferred language "pt-pt"');
                $cookies.putObject(name, 'pt-pt');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('pt-pt');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('jhi-');
        $sessionStorageProvider.setKeyPrefix('jhi-');
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //Cache everything except rest api requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*api.*/, /.*protected.*/], true);

        $urlRouterProvider.otherwise('/login');

        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');
        $httpProvider.interceptors.push('authInterceptor');
        // jhipster-needle-angularjs-add-interceptor JHipster will add new application http interceptor here

        $urlMatcherFactoryProvider.type('boolean', {
            name : 'boolean',
            decode: function(val) { return val === true || val === 'true'; },
            encode: function(val) { return val ? 1 : 0; },
            equals: function(a, b) { return this.is(a) && a === b; },
            is: function(val) { return [true,false,0,1].indexOf(val) >= 0; },
            pattern: /bool|true|0|1/
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('app', {
            abstract: true,
            views: {
                'navbar@': {
                    templateUrl: 'app/layouts/navbar/navbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                },
                'menu@': {
                    templateUrl: 'app/layouts/menu/menu.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                },
                'footer@': {
                    templateUrl: 'app/layouts/footer/footer.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                },
                'notifications@': {
                    templateUrl: 'app/layouts/notification/ws-notification.html',
                    controller: 'BrowserNotificationController',
                    controllerAs: 'vm'
                },
                'filas@': {
                    templateUrl: 'app/layouts/filasbar/filasbar.html',
                    controller: 'NavbarController',
                    controllerAs: 'vm'
                }
            },
            data: {
                specialClass: "body-bg"
            },
            resolve: {
                authorize: ['Auth',
                    function (Auth) {
                        return Auth.authorize();
                    }
                ],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('tipoChamado');
                    $translatePartialLoader.addPart('situacaoChamado');
                }]
            }
        });



    }
})();

(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('chamadosApp')
        .constant('VERSION', "1.17.0")
        .constant('DEBUG_INFO_ENABLED', false)
;
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('UserManagementResetController', UserManagementResetController);

    UserManagementResetController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementResetController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmReset = confirmReset;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmReset (login) {
            User.reset({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('UserManagementDialogController', UserManagementDialogController);

    UserManagementDialogController.$inject = ['Cliente', 'entity', 'User', 'JhiLanguageService', 'Modulo', 'SubModulo', 'Chamado', 'Sistema', '$state', 'Account', 'Upload'];

    function UserManagementDialogController(Cliente, entity, User, JhiLanguageService, Modulo, SubModulo, Chamado, Sistema, $state, Account, Upload) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN', 'ROLE_CLIENTE', 'ROLE_ATENDENTE', 'ROLE_PO', 'ROLE_SCRUM', 'ROLE_RESPONSAVEL', 'ROLE_DESENVOLVEDOR', 'ROLE_SOLICITAR_RELEASE', 'ROLE_PLANEJAMENTO_SPRINT', 'ROLE_OCORRENCIA_CHAMADO','ROLE_DEVOPS'];
        vm.notificacoes = ['DEPLOY_PRODUCAO'];
        vm.languages = null;
        vm.save = save;
        vm.indexCliente = indexCliente;
        vm.indexModulo = indexModulo;
        vm.indexSistema = indexSistema;
        vm.adicionarMdulo = adicionarMdulo;
        vm.adicionarTodosSubModulos = adicionarTodosSubModulos;
        vm.adicionarSistema = adicionarSistema;
        vm.removerTodosSubModulos = removerTodosSubModulos;
        vm.removerMdulo = removerMdulo;
        vm.removerSistema = removerSistema;
        vm.indexSubModulo = indexSubModulo;
        vm.removerFila = removerFila;
        vm.hasFila = hasFila;
        vm.adicionarFila = adicionarFila;
        vm.getNotificacaoLabel = getNotificacaoLabel;
        vm.selecionarSistemasCliente = selecionarSistemasCliente;
        vm.removerSistemasCliente = removerSistemasCliente;
        vm.user = entity;
        vm.clientes = Cliente.query({page: 0, size: 99});
        vm.sistemas = [];
        vm.modulos = Modulo.query({page: 0, size: 99});
        vm.subModulosTodos = SubModulo.query({page: 0, size: 99});
        vm.filas = [];
        Chamado.getSituacoes({}, function (data) {
            vm.filas = data;
        });
        if (!vm.user.sistemas) {
            vm.user.sistemas = [];
        }
        if (!vm.user.clientes) {
            vm.user.clientes = [];
        }

        if (!vm.user.authorities) {
            vm.user.authorities = [];
        }
        if (!vm.user.notificacoes) {
            vm.user.notificacoes = [];
        }

        if (!vm.user.filas) {
            vm.user.filas = [];
        } else {
            angular.forEach(vm.user.filas, function (fila) {
                vm.notificacoes.push(fila);
            });
        }
        if (!vm.user.modulos) {
            vm.user.modulos = [];
        }
        if (!vm.user.subModulos) {
            vm.user.subModulos = [];
        } else {
            vm.subModulos = vm.user.subModulos;
        }


        function recuperarImagem() {
            if (vm.user.login) {
                Account.getImagemAjustadaByLogin({login: vm.user.login}, function (data) {
                    if (data.imagemAjustada) {
                        vm.imagemOginal = data.imagemAjustada;
                    }
                });
            }
        }

        recuperarImagem();

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function onSaveSuccess(result) {
            if (vm.picFile) {

                Upload.dataUrl(vm.picFile, true).then(
                    function (original) {
                        if (original && vm.croppedDataUrl) {
                            Account.saveImagem({
                                imagemOriginal: original,
                                imagemAjustada: vm.croppedDataUrl,
                                usuario: vm.user
                            }, function (data) {
                                vm.imagemOginal = data.imagemOriginal;
                                vm.croppedDataUrl = data.imagemAjustada;
                                $rootScope.$broadcast('authenticationSuccess');
                            });
                        }
                    }
                );
            }

            vm.isSaving = false;
            $state.go('user-management-detail', {login: result.login})
        }

        function onSaveError() {
            vm.isSaving = false;
        }

        function save() {
            vm.isSaving = true;
            if (vm.user.id !== null) {
                User.update(vm.user, onSaveSuccess, onSaveError);
            } else {
                User.save(vm.user, onSaveSuccess, onSaveError);
            }
        }

        function indexCliente(id) {
            for (var i = 0; i < vm.user.clientes.length; i++) {
                if (vm.user.clientes[i].id === id) {
                    return i;
                }
            }
            return -1;
        }

        function indexModulo(id) {
            for (var i = 0; i < vm.user.modulos.length; i++) {
                if (vm.user.modulos[i].id === id) {
                    return i;
                }
            }
            return -1;
        }

        function indexSistema(id) {
            for (var i = 0; i < vm.user.sistemas.length; i++) {
                if (vm.user.sistemas[i].id === id) {
                    return i;
                }
            }
            return -1;
        }


        function indexSistemaDisponivel(id) {
            for (var i = 0; i < vm.sistemas.length; i++) {
                if (vm.sistemas[i].id === id) {
                    return i;
                }
            }
            return -1;
        }

        function adicionarMdulo(modulo) {
            vm.user.modulos.push(modulo);
            vm.subModulos = [];
            angular.forEach(vm.subModulosTodos, function (submodulo) {
                if (submodulo.modulo != null) {
                    angular.forEach(vm.user.modulos, function (moduloUser) {
                        if (submodulo.modulo.id === moduloUser.id) {
                            vm.subModulos.push(submodulo);
                            vm.user.subModulos.push(submodulo);
                        }
                    });
                }
            });
        }

        function adicionarSistema(sistema) {
            vm.user.sistemas.push(sistema);
        }

        function adicionarTodosSubModulos() {
            angular.forEach(vm.subModulos, function (submodulo) {
                if (submodulo.modulo != null) {
                    angular.forEach(vm.user.modulos, function (moduloUser) {
                        if (submodulo.modulo.id === moduloUser.id) {
                            vm.user.subModulos.push(submodulo);
                        }
                    });
                }
            });
        }

        function selecionarSistemasCliente() {
            vm.sistemas = [];
            angular.forEach(vm.user.clientes, function (cliente) {
                    Cliente.get({id: cliente.id}, function (data) {
                        if (data.sistemas) {
                            angular.forEach(data.sistemas, function (sistema) {
                                if (indexSistemaDisponivel(sistema.id) < 0) {
                                    vm.sistemas.push(sistema);
                                }
                            });
                        }
                    });
                }
            );
        }

        function removerSistemasCliente(cliente) {
            if (vm.user.sistemas) {
                Cliente.get({id: cliente.id}, function (data) {
                    if (data.sistemas) {
                        angular.forEach(data.sistemas, function (sistema) {
                            if (indexSistema(sistema.id) >= 0) {
                                removerSistema(sistema);
                            }
                        });
                    }
                });
            }
            selecionarSistemasCliente();
        }

        selecionarSistemasCliente();

        function removerSistema(sistema) {
            vm.user.sistemas.splice(vm.indexSistema(sistema.id), 1);
        }

        function removerMdulo(modulo) {
            vm.user.modulos.splice(vm.indexModulo(modulo.id), 1)
            angular.forEach(vm.subModulosTodos, function (submodulo) {
                if (submodulo.modulo != null) {
                    if (submodulo.modulo.id === modulo.id) {
                        vm.user.subModulos.splice(vm.indexSubModulo(submodulo.id), 1)
                        vm.subModulos.splice(vm.subModulos.map(function (item) {
                            return item.id;
                        }).indexOf(submodulo.id), 1)
                    }
                }
            });
        }

        function removerTodosSubModulos() {
            angular.forEach(vm.subModulosTodos, function (submodulo) {
                if (submodulo.modulo != null) {
                    vm.user.subModulos.splice(vm.indexSubModulo(submodulo.id), 1)
                }
            });
        }


        function indexSubModulo(id) {
            for (var i = 0; i < vm.user.subModulos.length; i++) {
                if (vm.user.subModulos[i].id === id) {
                    return i;
                }
            }
            return -1;
        }

        function hasFila(fila) {
            return vm.user.filas.indexOf(fila.codigo) > -1;
        }

        function adicionarFila(fila) {
            if (vm.user.filas.indexOf(fila.codigo) < 0) {
                vm.user.filas.push(fila.codigo);
            }
            if (vm.notificacoes.indexOf(fila.codigo) < 0) {
                vm.notificacoes.push(fila.codigo);
            }
        }

        function removerFila(fila) {
            var codigo = fila.codigo || fila;
            var idxFila = vm.user.filas.indexOf(codigo);
            if (idxFila > -1) {
                vm.user.filas.splice(idxFila, 1);
            }
            var idxNotificacao = vm.notificacoes.indexOf(codigo);
            if (idxNotificacao > -1) {
                vm.notificacoes.splice(idxNotificacao, 1);
                var idxUserNotificacao = vm.user.notificacoes.indexOf(codigo);
                if (idxUserNotificacao > -1) {
                    vm.user.notificacoes.splice(idxUserNotificacao, 1);
                }
            }
        }

        function getNotificacaoLabel(notificacao) {
            if (typeof notificacao !== 'string') {
                return notificacao;
            }
            for (var i = 0; i < vm.filas.length; i++) {
                if (vm.filas[i].codigo === notificacao) {
                    return vm.filas[i].descricao;
                }
            }
            return notificacao;
        }
    }
})
();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('UserManagementDetailController', UserManagementDetailController);

    UserManagementDetailController.$inject = ['$stateParams', 'User', 'Chamado'];

    function UserManagementDetailController ($stateParams, User, Chamado) {
        var vm = this;

        vm.load = load;
        vm.getFilaDescricao = getFilaDescricao;
        vm.user = {};
        vm.situacoesPorCodigo = {};

        Chamado.getSituacoes({}, function (data) {
            angular.forEach(data, function (situacao) {
                vm.situacoesPorCodigo[situacao.codigo] = situacao.descricao;
            });
        });

        vm.load($stateParams.login);

        function load (login) {
            User.get({login: login}, function(result) {
                vm.user = result;
            });
        }

        function getFilaDescricao(codigo) {
            return vm.situacoesPorCodigo[codigo] || codigo;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('UserManagementDeleteController', UserManagementDeleteController);

    UserManagementDeleteController.$inject = ['$uibModalInstance', 'entity', 'User'];

    function UserManagementDeleteController ($uibModalInstance, entity, User) {
        var vm = this;

        vm.user = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (login) {
            User.delete({login: login},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('user-management', {
                parent: 'admin',
                url: '/user-management?page&sort',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'userManagement.home.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management.html',
                        controller: 'UserManagementController',
                        controllerAs: 'vm'
                    }
                }, params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    }
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort)
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]

                }
            })
            .state('user-management.new', {
                url: '/new',

                parent: 'user-management',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Criação de Usuário'
                },
                ncyBreadcrumb: {
                    label: 'Criação de Usuário'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management-dialog.html',
                        controller: 'UserManagementDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'User', function ($stateParams, User) {
                        return {
                            id: null, login: null, firstName: null, lastName: null, email: null,
                            activated: true, langKey: null, createdBy: null, createdDate: null,
                            lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                            resetKey: null, authorities: null
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]
                }
            })
            .state('user-management.edit', {
                url: '/{login}/edit',
                parent: 'user-management',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'Edição de Usuário'
                },
                ncyBreadcrumb: {
                    label: 'Edição de Usuário'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management-dialog.html',
                        controller: 'UserManagementDialogController',
                        controllerAs: 'vm',
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'User', function ($stateParams, User) {
                        return User.get({login: $stateParams.login}).$promise;
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]
                }
            })
            .state('user-management-detail', {
                parent: 'user-management',
                url: '/user/{login}',
                data: {
                    authorities: ['ROLE_ADMIN'],
                    pageTitle: 'user-management.detail.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/user-management/user-management-detail.html',
                        controller: 'UserManagementDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('user-management');
                        return $translate.refresh();
                    }]
                }
            })
            .state('user-management.delete', {
                url: '/{login}/delete',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/user-management/user-management-delete-dialog.html',
                        controller: 'UserManagementDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['User', function (User) {
                                return User.get({login: $stateParams.login});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('user-management', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            })
            .state('user-management.reset', {
                url: '/{login}/reset',
                data: {
                    authorities: ['ROLE_ADMIN']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/admin/user-management/user-management-reset-dialog.html',
                        controller: 'UserManagementResetController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['User', function (User) {
                                return User.get({login: $stateParams.login});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('user-management', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('UserManagementController', UserManagementController);

    UserManagementController.$inject = ['Principal', 'User', 'ParseLinks', 'AlertService', '$state', 'pagingParams', 'paginationConstants', 'JhiLanguageService'];

    function UserManagementController(Principal, User, ParseLinks, AlertService, $state, pagingParams, paginationConstants, JhiLanguageService) {
        var vm = this;

        vm.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        vm.currentAccount = null;
        vm.languages = null;
        vm.loadAll = loadAll;
        vm.setActive = setActive;
        vm.users = [];
        vm.page = 1;
        vm.totalItems = null;
        vm.clear = clear;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.transition = transition;
        vm.filtro = "";

        vm.loadAll();
        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });
        Principal.identity().then(function (account) {
            vm.currentAccount = account;
        });

        function setActive(user, isActivated) {
            user.activated = isActivated;
            User.update(user, function () {
                vm.loadAll();
                vm.clear();
            });
        }

        function loadAll() {
            User.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                filtro: vm.filtro
            }, onSuccess, onError);
        }

        function onSuccess(data, headers) {
            //hide anonymous user from user management: it's a required user for Spring Security
            var hiddenUsersSize = 0;
            for (var i in data) {
                if (data[i]['login'] === 'anonymoususer') {
                    data.splice(i, 1);
                    hiddenUsersSize++;
                }
            }
            vm.links = ParseLinks.parse(headers('link'));
            vm.totalItems = headers('X-Total-Count') - hiddenUsersSize;
            vm.queryCount = vm.totalItems;
            vm.page = pagingParams.page;
            vm.users = data;
        }

        function onError(error) {
            AlertService.error(error.data.message);
        }

        function clear() {
            vm.user = {
                id: null, login: null, firstName: null, lastName: null, email: null,
                activated: null, langKey: null, createdBy: null, createdDate: null,
                lastModifiedBy: null, lastModifiedDate: null, resetDate: null,
                resetKey: null, authorities: null
            };
        }

        function sort() {
            var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
            if (vm.predicate !== 'id') {
                result.push('id');
            }
            return result;
        }

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-tracker', {
            parent: 'admin',
            url: '/tracker',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'Real-time user activities'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/tracker/tracker.html',
                    controller: 'JhiTrackerController',
                    controllerAs: 'vm'
                }
            },
            onEnter: ['JhiTrackerService', function(JhiTrackerService) {
                JhiTrackerService.subscribe();
            }],
            onExit: ['JhiTrackerService', function(JhiTrackerService) {
                JhiTrackerService.unsubscribe();
            }]
        });
    }
})();

(function () {
    'use strict';
    /* globals SockJS, Stomp */

    angular
        .module('chamadosApp')
        .factory('JhiTrackerService', JhiTrackerService);

    JhiTrackerService.$inject = ['$rootScope', '$window', '$cookies', '$http', '$q', 'AuthServerProvider'];

    function JhiTrackerService($rootScope, $window, $cookies, $http, $q, AuthServerProvider) {
        var stompClient = null;
        var subscriber = null;
        var listener = $q.defer();
        var connected = $q.defer();
        var alreadyConnectedOnce = false;

        var service = {
            connect: connect,
            disconnect: disconnect,
            receive: receive,
            sendActivity: sendActivity,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };

        return service;

        function connect() {
            //building absolute path so that websocket doesn't fail when deploying with a context path
            var loc = $window.location;
            var url = '//' + loc.host + loc.pathname + 'websocket/tracker';
            var authToken = AuthServerProvider.getToken();
            if (authToken) {
                url += '?access_token=' + authToken;
            }
            var socket = new SockJS(url);
            stompClient = Stomp.over(socket);
            var stateChangeStart;
            var headers = {};
            stompClient.connect(headers, function () {
                connected.resolve('success');
                sendActivity();
                if (!alreadyConnectedOnce) {
                    stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
                        sendActivity();
                    });
                    alreadyConnectedOnce = true;
                }
            });
            $rootScope.$on('$destroy', function () {
                if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
                    stateChangeStart();
                }
            });
        }

        function disconnect() {
            if (stompClient !== null) {
                stompClient.disconnect();
                stompClient = null;
            }
        }

        function receive() {
            return listener.promise;
        }

        function sendActivity() {
            if (stompClient !== null && stompClient.connected) {
                stompClient
                    .send('/topic/activity',
                        {},
                        angular.toJson({'page': $rootScope.toState.name}));
            }
        }

        function subscribe() {
            connected.promise.then(function () {
                subscriber = stompClient.subscribe('/topic/tracker', function (data) {
                    listener.notify(angular.fromJson(data.body));
                });
            }, null, null);
        }

        function unsubscribe() {
            if (subscriber !== null) {
                subscriber.unsubscribe();
            }
            listener = $q.defer();
        }

    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('JhiTrackerController', JhiTrackerController);

    JhiTrackerController.$inject = ['$cookies', '$http', 'JhiTrackerService'];

    function JhiTrackerController ($cookies, $http, JhiTrackerService) {
        // This controller uses a Websocket connection to receive user activities in real-time.
        var vm = this;

        vm.activities = [];

        JhiTrackerService.receive().then(null, null, function(activity) {
            showActivity(activity);
        });

        function showActivity(activity) {
            var existingActivity = false;
            for (var index = 0; index < vm.activities.length; index++) {
                if(vm.activities[index].sessionId === activity.sessionId) {
                    existingActivity = true;
                    if (activity.page === 'logout') {
                        vm.activities.splice(index, 1);
                    } else {
                        vm.activities[index] = activity;
                    }
                }
            }
            if (!existingActivity && (activity.page !== 'logout')) {
                vm.activities.push(activity);
            }
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-metrics', {
            parent: 'admin',
            url: '/metrics',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'metrics.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/metrics/metrics.html',
                    controller: 'JhiMetricsMonitoringController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('metrics');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('JhiMetricsService', JhiMetricsService);

    JhiMetricsService.$inject = ['$rootScope', '$http'];

    function JhiMetricsService ($rootScope, $http) {
        var service = {
            getMetrics: getMetrics,
            threadDump: threadDump
        };

        return service;

        function getMetrics () {
            return $http.get('management/metrics').then(function (response) {
                return response.data;
            });
        }

        function threadDump () {
            return $http.get('management/dump').then(function (response) {
                return response.data;
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('JhiMetricsMonitoringModalController', JhiMetricsMonitoringModalController);

    JhiMetricsMonitoringModalController.$inject = ['$uibModalInstance', 'threadDump'];

    function JhiMetricsMonitoringModalController ($uibModalInstance, threadDump) {
        var vm = this;

        vm.cancel = cancel;
        vm.getLabelClass = getLabelClass;
        vm.threadDump = threadDump;
        vm.threadDumpAll = 0;
        vm.threadDumpBlocked = 0;
        vm.threadDumpRunnable = 0;
        vm.threadDumpTimedWaiting = 0;
        vm.threadDumpWaiting = 0;

        angular.forEach(threadDump, function(value) {
            if (value.threadState === 'RUNNABLE') {
                vm.threadDumpRunnable += 1;
            } else if (value.threadState === 'WAITING') {
                vm.threadDumpWaiting += 1;
            } else if (value.threadState === 'TIMED_WAITING') {
                vm.threadDumpTimedWaiting += 1;
            } else if (value.threadState === 'BLOCKED') {
                vm.threadDumpBlocked += 1;
            }
        });

        vm.threadDumpAll = vm.threadDumpRunnable + vm.threadDumpWaiting +
            vm.threadDumpTimedWaiting + vm.threadDumpBlocked;

        function cancel () {
            $uibModalInstance.dismiss('cancel');
        }

        function getLabelClass (threadState) {
            if (threadState === 'RUNNABLE') {
                return 'label-success';
            } else if (threadState === 'WAITING') {
                return 'label-info';
            } else if (threadState === 'TIMED_WAITING') {
                return 'label-warning';
            } else if (threadState === 'BLOCKED') {
                return 'label-danger';
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('JhiMetricsMonitoringController', JhiMetricsMonitoringController);

    JhiMetricsMonitoringController.$inject = ['$scope','JhiMetricsService', '$uibModal'];

    function JhiMetricsMonitoringController ($scope, JhiMetricsService, $uibModal) {
        var vm = this;

        vm.cachesStats = {};
        vm.metrics = {};
        vm.refresh = refresh;
        vm.refreshThreadDumpData = refreshThreadDumpData;
        vm.servicesStats = {};
        vm.updatingMetrics = true;

        vm.refresh();

        $scope.$watch('vm.metrics', function (newValue) {
            vm.servicesStats = {};
            angular.forEach(newValue.timers, function (value, key) {
                if (key.indexOf('web.rest') !== -1 || key.indexOf('service') !== -1) {
                    vm.servicesStats[key] = value;
                }
            });

            vm.cachesStats = {};
            angular.forEach(newValue.gauges, function (value, key) {
                if (key.indexOf('jcache.statistics') !== -1) {
                    // remove gets or puts
                    var index = key.lastIndexOf('.');
                    var newKey = key.substr(0, index);

                    // Keep the name of the domain
                    vm.cachesStats[newKey] = {
                        'name': newKey.substr(18),
                        'value': value
                    };
                }
            });
        });

        function refresh () {
            vm.updatingMetrics = true;
            JhiMetricsService.getMetrics().then(function (promise) {
                vm.metrics = promise;
                vm.updatingMetrics = false;
            }, function (promise) {
                vm.metrics = promise.data;
                vm.updatingMetrics = false;
            });
        }

        function refreshThreadDumpData () {
            JhiMetricsService.threadDump().then(function(data) {
                $uibModal.open({
                    templateUrl: 'app/admin/metrics/metrics.modal.html',
                    controller: 'JhiMetricsMonitoringModalController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        threadDump: function() {
                            return data;
                        }

                    }
                });
            });
        }


    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('logs', {
            parent: 'admin',
            url: '/logs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'logs.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/logs/logs.html',
                    controller: 'LogsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('logs');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('LogsService', LogsService);

    LogsService.$inject = ['$resource'];

    function LogsService ($resource) {
        var service = $resource('management/logs', {}, {
            'findAll': { method: 'GET', isArray: true},
            'changeLevel': { method: 'PUT'}
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('LogsController', LogsController);

    LogsController.$inject = ['LogsService'];

    function LogsController (LogsService) {
        var vm = this;

        vm.changeLevel = changeLevel;
        vm.loggers = LogsService.findAll();

        function changeLevel (name, level) {
            LogsService.changeLevel({name: name, level: level}, function () {
                vm.loggers = LogsService.findAll();
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('integracao-parceiro', {
            parent: 'admin',
            url: '/integracao-parceiro',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'integracaoParceiro.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/integracao-parceiro/integracao-parceiro.html',
                    controller: 'IntegracaoParceiroController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('integracaoParceiro');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('IntegracaoParceiro', IntegracaoParceiro);

    IntegracaoParceiro.$inject = ['$http'];

    function IntegracaoParceiro($http) {
        var resourceUrl = 'api/integracao-parceiros';

        var service = {
            query: query,
            get: get,
            create: create,
            update: update,
            remove: remove
        };

        return service;

        function query() {
            return $http.get(resourceUrl);
        }

        function get(id) {
            return $http.get(resourceUrl + '/' + id);
        }

        function create(body) {
            return $http.post(resourceUrl, body);
        }

        function update(id, body) {
            return $http.put(resourceUrl + '/' + id, body);
        }

        function remove(id) {
            return $http.delete(resourceUrl + '/' + id);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('IntegracaoParceiroController', IntegracaoParceiroController);

    IntegracaoParceiroController.$inject = [
        'IntegracaoParceiro',
        'Cliente',
        'Sistema',
        'Modulo',
        'SubModulo',
        'User',
        'Alerta',
        'AlertService'
    ];

    function IntegracaoParceiroController(
        IntegracaoParceiro,
        Cliente,
        Sistema,
        Modulo,
        SubModulo,
        User,
        Alerta,
        AlertService
    ) {
        var vm = this;

        vm.parceiros = [];
        vm.clientes = [];
        vm.sistemas = [];
        vm.modulos = [];
        vm.subModulos = [];
        vm.usuarios = [];
        vm.loading = true;
        vm.saving = false;

        vm.tiposChamado = ['SUPORTE', 'BUG', 'MELHORIA', 'NOVA_FUNCIONALIDADE', 'ATA'];
        vm.severidades = ['SEVERIDADE_0', 'SEVERIDADE_1', 'SEVERIDADE_2', 'SEVERIDADE_3', 'SEM_SEVERIDADE'];

        vm.load = load;
        vm.save = save;
        vm.edit = edit;
        vm.remove = remove;
        vm.resetForm = resetForm;
        vm.onModuloChange = onModuloChange;
        vm.subModulosDoModulo = subModulosDoModulo;

        resetForm();
        loadLookups();
        load();

        function emptyForm() {
            return {
                id: null,
                codigo: '',
                nome: '',
                ativo: true,
                webhookUrl: '',
                webhookToken: '',
                webhookTokenMasked: null,
                clienteId: null,
                sistemaId: null,
                moduloId: null,
                subModuloId: null,
                solicitanteId: null,
                tipoChamado: null,
                severidade: null
            };
        }

        function resetForm() {
            vm.form = emptyForm();
        }

        function loadLookups() {
            Cliente.query(function (result) {
                vm.clientes = result;
            });
            Sistema.query(function (result) {
                vm.sistemas = result;
            });
            Modulo.query(function (result) {
                vm.modulos = result;
            });
            SubModulo.query({page: 0, size: 200}, function (result) {
                vm.subModulos = result;
            });
            User.getAllInternos({}, function (result) {
                vm.usuarios = result;
            });
        }

        function load() {
            vm.loading = true;
            IntegracaoParceiro.query().then(function (response) {
                vm.parceiros = response.data;
            }, function (error) {
                AlertService.error(error.data && error.data.message ? error.data.message : 'error.http.' + error.status);
            }).finally(function () {
                vm.loading = false;
            });
        }

        function edit(p) {
            vm.form = {
                id: p.id,
                codigo: p.codigo,
                nome: p.nome,
                ativo: p.ativo !== false,
                webhookUrl: p.webhookUrl || '',
                webhookToken: '',
                webhookTokenMasked: p.webhookToken,
                clienteId: p.clienteId,
                sistemaId: p.sistemaId,
                moduloId: p.moduloId,
                subModuloId: p.subModuloId,
                solicitanteId: p.solicitanteId,
                tipoChamado: p.tipoChamado,
                severidade: p.severidade
            };
        }

        function buildPayload() {
            var payload = {
                codigo: vm.form.codigo,
                nome: vm.form.nome,
                ativo: vm.form.ativo,
                webhookUrl: vm.form.webhookUrl,
                clienteId: vm.form.clienteId,
                sistemaId: vm.form.sistemaId,
                moduloId: vm.form.moduloId,
                subModuloId: vm.form.subModuloId,
                solicitanteId: vm.form.solicitanteId,
                tipoChamado: vm.form.tipoChamado,
                severidade: vm.form.severidade
            };
            if (vm.form.webhookToken) {
                payload.webhookToken = vm.form.webhookToken;
            }
            return payload;
        }

        function subModulosDoModulo() {
            if (!vm.form.moduloId) {
                return [];
            }
            return (vm.subModulos || []).filter(function (sm) {
                return sm.modulo && sm.modulo.id === vm.form.moduloId;
            });
        }

        function onModuloChange() {
            var ids = subModulosDoModulo().map(function (sm) { return sm.id; });
            if (ids.indexOf(vm.form.subModuloId) === -1) {
                vm.form.subModuloId = null;
            }
        }

        function save() {
            if (!vm.form.id && !vm.form.webhookToken) {
                Alerta.error('Atenção', 'O token do webhook é obrigatório na criação.');
                return;
            }

            vm.saving = true;
            var request;
            if (vm.form.id) {
                request = IntegracaoParceiro.update(vm.form.id, buildPayload());
            } else {
                request = IntegracaoParceiro.create(buildPayload());
            }

            request.then(function () {
                Alerta.success('Operação realizada', 'Integração de parceiro salva com sucesso.');
                resetForm();
                load();
            }, function (error) {
                AlertService.error(error.data && error.data.message ? error.data.message : 'error.http.' + error.status);
            }).finally(function () {
                vm.saving = false;
            });
        }

        function remove(p) {
            Alerta.confirm('Atenção', 'Tem certeza que deseja remover a integração "' + p.nome + '"?', 'warning', function () {
                IntegracaoParceiro.remove(p.id).then(function () {
                    Alerta.success('Operação realizada', 'Integração de parceiro removida.');
                    if (vm.form.id === p.id) {
                        resetForm();
                    }
                    load();
                }, function (error) {
                    AlertService.error(error.data && error.data.message ? error.data.message : 'error.http.' + error.status);
                });
            }, angular.noop);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-health', {
            parent: 'admin',
            url: '/health',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'health.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/health/health.html',
                    controller: 'JhiHealthCheckController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('health');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('JhiHealthService', JhiHealthService);

    JhiHealthService.$inject = ['$rootScope', '$http'];

    function JhiHealthService ($rootScope, $http) {
        var separator = '.';
        var service = {
            checkHealth: checkHealth,
            transformHealthData: transformHealthData,
            getBaseName: getBaseName,
            getSubSystemName: getSubSystemName
        };

        return service;

        function checkHealth () {
            return $http.get('management/health').then(function (response) {
                return response.data;
            });
        }

        function transformHealthData (data) {
            var response = [];
            flattenHealthData(response, null, data);
            return response;
        }

        function getBaseName (name) {
            if (name) {
                var split = name.split('.');
                return split[0];
            }
        }

        function getSubSystemName (name) {
            if (name) {
                var split = name.split('.');
                split.splice(0, 1);
                var remainder = split.join('.');
                return remainder ? ' - ' + remainder : '';
            }
        }

        /* private methods */
        function flattenHealthData (result, path, data) {
            angular.forEach(data, function (value, key) {
                if (isHealthObject(value)) {
                    if (hasSubSystem(value)) {
                        addHealthObject(result, false, value, getModuleName(path, key));
                        flattenHealthData(result, getModuleName(path, key), value);
                    } else {
                        addHealthObject(result, true, value, getModuleName(path, key));
                    }
                }
            });
            return result;
        }

        function addHealthObject (result, isLeaf, healthObject, name) {

            var healthData = {
                'name': name
            };
            var details = {};
            var hasDetails = false;

            angular.forEach(healthObject, function (value, key) {
                if (key === 'status' || key === 'error') {
                    healthData[key] = value;
                } else {
                    if (!isHealthObject(value)) {
                        details[key] = value;
                        hasDetails = true;
                    }
                }
            });

            // Add the of the details
            if (hasDetails) {
                angular.extend(healthData, { 'details': details});
            }

            // Only add nodes if they provide additional information
            if (isLeaf || hasDetails || healthData.error) {
                result.push(healthData);
            }
            return healthData;
        }

        function getModuleName (path, name) {
            var result;
            if (path && name) {
                result = path + separator + name;
            }  else if (path) {
                result = path;
            } else if (name) {
                result = name;
            } else {
                result = '';
            }
            return result;
        }

        function hasSubSystem (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value) {
                if (value && value.status) {
                    result = true;
                }
            });
            return result;
        }

        function isHealthObject (healthObject) {
            var result = false;
            angular.forEach(healthObject, function (value, key) {
                if (key === 'status') {
                    result = true;
                }
            });
            return result;
        }

    }
})();

(function() {
    'use strict';

    angular.module('chamadosApp')
        .controller('HealthModalController', HealthModalController);

    HealthModalController.$inject = ['$uibModalInstance', 'currentHealth', 'baseName', 'subSystemName'];

    function HealthModalController ($uibModalInstance, currentHealth, baseName, subSystemName) {
        var vm = this;

        vm.cancel = cancel;
        vm.currentHealth = currentHealth;
        vm.baseName = baseName;
        vm.subSystemName = subSystemName;

        function cancel() {
            $uibModalInstance.dismiss('cancel');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('JhiHealthCheckController', JhiHealthCheckController);

    JhiHealthCheckController.$inject = ['JhiHealthService', '$uibModal'];

    function JhiHealthCheckController (JhiHealthService, $uibModal) {
        var vm = this;

        vm.updatingHealth = true;
        vm.getLabelClass = getLabelClass;
        vm.refresh = refresh;
        vm.showHealth = showHealth;
        vm.baseName = JhiHealthService.getBaseName;
        vm.subSystemName = JhiHealthService.getSubSystemName;

        vm.refresh();

        function getLabelClass (statusState) {
            if (statusState === 'UP') {
                return 'label-success';
            } else {
                return 'label-danger';
            }
        }

        function refresh () {
            vm.updatingHealth = true;
            JhiHealthService.checkHealth().then(function (response) {
                vm.healthData = JhiHealthService.transformHealthData(response);
                vm.updatingHealth = false;
            }, function (response) {
                vm.healthData =  JhiHealthService.transformHealthData(response.data);
                vm.updatingHealth = false;
            });
        }

        function showHealth (health) {
            $uibModal.open({
                templateUrl: 'app/admin/health/health.modal.html',
                controller: 'HealthModalController',
                controllerAs: 'vm',
                size: 'lg',
                resolve: {
                    currentHealth: function() {
                        return health;
                    },
                    baseName: function() {
                        return vm.baseName;
                    },
                    subSystemName: function() {
                        return vm.subSystemName;
                    }

                }
            });
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('gitlab-config', {
            parent: 'admin',
            url: '/gitlab-config',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'gitlabConfig.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/gitlab-config/gitlab-config.html',
                    controller: 'GitLabConfigController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('gitlabConfig');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('GitLabConfig', GitLabConfig);

    GitLabConfig.$inject = ['$http'];

    function GitLabConfig($http) {
        var resourceUrl = 'api/gitlab-config';

        var service = {
            get: get,
            save: save,
            remove: remove
        };

        return service;

        function get() {
            return $http.get(resourceUrl);
        }

        function save(config) {
            return $http.put(resourceUrl, config);
        }

        function remove() {
            return $http.delete(resourceUrl);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('GitLabConfigController', GitLabConfigController);

    GitLabConfigController.$inject = ['GitLabConfig', 'Alerta', 'AlertService'];

    function GitLabConfigController(GitLabConfig, Alerta, AlertService) {
        var vm = this;

        vm.config = {
            url: '',
            token: ''
        };
        vm.exists = false;
        vm.maskedToken = null;
        vm.loading = true;
        vm.saving = false;

        vm.load = load;
        vm.save = save;
        vm.remove = remove;

        load();

        function load() {
            vm.loading = true;
            GitLabConfig.get().then(function (response) {
                vm.exists = true;
                vm.maskedToken = response.data.token;
                vm.config = {
                    url: response.data.url || '',
                    token: ''
                };
            }, function (error) {
                if (error.status === 404) {
                    vm.exists = false;
                    vm.maskedToken = null;
                    vm.config = {
                        url: '',
                        token: ''
                    };
                } else {
                    AlertService.error(error.data && error.data.message ? error.data.message : 'error.http.' + error.status);
                }
            }).finally(function () {
                vm.loading = false;
            });
        }

        function save() {
            if (!vm.config.url) {
                return;
            }
            if (!vm.exists && !vm.config.token) {
                Alerta.error('Atenção', 'O token é obrigatório na criação da configuração.');
                return;
            }

            var payload = {
                url: vm.config.url
            };
            if (vm.config.token) {
                payload.token = vm.config.token;
            }

            vm.saving = true;
            GitLabConfig.save(payload).then(function () {
                Alerta.success('Operação realizada', 'Configuração do GitLab salva com sucesso.');
                load();
            }, function (error) {
                AlertService.error(error.data && error.data.message ? error.data.message : 'error.http.' + error.status);
            }).finally(function () {
                vm.saving = false;
            });
        }

        function remove() {
            Alerta.confirm('Atenção', 'Tem certeza que deseja remover a configuração do GitLab?', 'warning', function () {
                GitLabConfig.remove().then(function () {
                    Alerta.success('Operação realizada', 'Configuração do GitLab removida.');
                    load();
                }, function (error) {
                    AlertService.error(error.data && error.data.message ? error.data.message : 'error.http.' + error.status);
                });
            }, angular.noop);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('docs', {
            parent: 'admin',
            url: '/docs',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'global.menu.admin.apidocs'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/docs/docs.html'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', function ($translate) {
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('jhi-configuration', {
            parent: 'admin',
            url: '/configuration',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'configuration.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/configuration/configuration.html',
                    controller: 'JhiConfigurationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('configuration');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('JhiConfigurationService', JhiConfigurationService);

    JhiConfigurationService.$inject = ['$filter', '$http'];

    function JhiConfigurationService ($filter, $http) {
        var service = {
            get: get,
            getEnv: getEnv
        };

        return service;

        function get () {
            return $http.get('management/configprops').then(getConfigPropsComplete);

            function getConfigPropsComplete (response) {
                var properties = [];
                angular.forEach(response.data, function (data) {
                    properties.push(data);
                });
                var orderBy = $filter('orderBy');
                return orderBy(properties, 'prefix');
            }
        }

        function getEnv () {
            return $http.get('management/env').then(getEnvComplete);

            function getEnvComplete (response) {
                var properties = {};
                angular.forEach(response.data, function (val,key) {
                    var vals = [];
                    angular.forEach(val, function (v,k) {
                        vals.push({ key:k, val:v });
                    });
                    properties[key] = vals;
                });
                return properties;
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('JhiConfigurationController', JhiConfigurationController);

    JhiConfigurationController.$inject = ['$filter','JhiConfigurationService'];

    function JhiConfigurationController (filter,JhiConfigurationService) {
        var vm = this;

        vm.allConfiguration = null;
        vm.configuration = null;

        JhiConfigurationService.get().then(function(configuration) {
            vm.configuration = configuration;
        });
        JhiConfigurationService.getEnv().then(function (configuration) {
            vm.allConfiguration = configuration;
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('audits', {
            parent: 'admin',
            url: '/audits',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'audits.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/admin/audits/audits.html',
                    controller: 'AuditsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('audits');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('AuditsService', AuditsService);

    AuditsService.$inject = ['$resource'];

    function AuditsService ($resource) {
        var service = $resource('management/audits/:id', {}, {
            'get': {
                method: 'GET',
                isArray: true
            },
            'query': {
                method: 'GET',
                isArray: true,
                params: {fromDate: null, toDate: null}
            }
        });

        return service;
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('AuditsController', AuditsController);

    AuditsController.$inject = ['$filter', 'AuditsService', 'ParseLinks'];

    function AuditsController ($filter, AuditsService, ParseLinks) {
        var vm = this;

        vm.audits = null;
        vm.fromDate = null;
        vm.links = null;
        vm.loadPage = loadPage;
        vm.onChangeDate = onChangeDate;
        vm.page = 1;
        vm.previousMonth = previousMonth;
        vm.toDate = null;
        vm.today = today;
        vm.totalItems = null;

        vm.today();
        vm.previousMonth();
        vm.onChangeDate();

        function onChangeDate () {
            var dateFormat = 'yyyy-MM-dd';
            var fromDate = $filter('date')(vm.fromDate, dateFormat);
            var toDate = $filter('date')(vm.toDate, dateFormat);

            AuditsService.query({page: vm.page -1, size: 20, fromDate: fromDate, toDate: toDate}, function(result, headers){
                vm.audits = result;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
            });
        }

        // Date picker configuration
        function today () {
            // Today + 1 day - needed if the current day must be included
            var today = new Date();
            vm.toDate = new Date(today.getFullYear(), today.getMonth(), today.getDate() + 1);
        }

        function previousMonth () {
            var fromDate = new Date();
            if (fromDate.getMonth() === 0) {
                fromDate = new Date(fromDate.getFullYear() - 1, 11, fromDate.getDate());
            } else {
                fromDate = new Date(fromDate.getFullYear(), fromDate.getMonth() - 1, fromDate.getDate());
            }

            vm.fromDate = fromDate;
        }

        function loadPage (page) {
            vm.page = page;
            vm.onChangeDate();
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig ($stateProvider) {
        $stateProvider.state('admin', {
            abstract: true,
            parent: 'app'
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('AcaoJustificativaDialogController', AcaoJustificativaDialogController);

    AcaoJustificativaDialogController.$inject = ['$scope', '$uibModalInstance', 'Acao'];

    function AcaoJustificativaDialogController($scope, $uibModalInstance, Acao) {
        var vm = this;

        vm.clear = clear;
        vm.justificar = justificar;
        vm.acoes;

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function buscarAcoesPendentes() {
            Acao.byUserPendente(function (data) {
                vm.acoes = data;
                if (!vm.acoes || vm.acoes.length == 0)
                    clear();
            });
        }

        buscarAcoesPendentes();

        function justificar(acao) {
            acao.situacaoAcao = 'FINALIZADA';
            Acao.update(acao, function () {
                $scope.$emit('chamadosApp:acaoUpdate');
                buscarAcoesPendentes();
            });
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('AcaoEditController', AcaoEditController);

    AcaoEditController.$inject = ['$rootScope', '$scope', '$state', 'entity', 'Acao', 'SolicitacaoDesenvolvimento', 'Chamado', 'User', 'Ata'];

    function AcaoEditController($rootScope, $scope, $state, entity, Acao, SolicitacaoDesenvolvimento, Chamado, User, Ata) {
        var vm = this;

        vm.save = save;
        vm.buscarChamadoOrTarefa = buscarChamadoOrTarefa;
        vm.getAllUsers = getAllUsers;
        vm.isSaving = false;
        vm.acao = entity;
        vm.numeroBusca;
        vm.users;

        function save() {
            vm.isSaving = true;
            if (vm.acao.id !== null) {
                Acao.update(vm.acao, onSucessSave, onErrorSave);
            } else {
                Acao.save(vm.acao, onSucessSave, onErrorSave);
            }
        }

        function getAllUsers() {
            User.getAllInternos(function (data) {
                vm.users = data;
                if (vm.acao.user) {
                    for (var i = 0; i < vm.users.length; i++) {
                        var user = vm.users[i];
                        if (user.login === vm.acao.user.login) {
                            vm.acao.user = user;
                            break;
                        }
                    }
                }
            });
        }

        vm.getAllUsers();

        function onSucessSave() {
            $scope.$emit('chamadosApp:acaoUpdate', vm.acao);
            $state.go('acao');
        }

        function onErrorSave() {
            vm.isSaving = false;
        }

        function buscarChamadoOrTarefa() {
            if(!vm.numeroBusca){
                return;
            }
            SolicitacaoDesenvolvimento.getByNumero({numero: vm.numeroBusca},
                function (ticket) {
                    vm.acao.solicitacaoDesenvolvimento = ticket;
                }, function (error) {
                    Chamado.get({id: vm.numeroBusca}, function (chamado) {
                        vm.acao.chamado = chamado;
                    }, function (error) {
                        Ata.getByNumero({numero: vm.numeroBusca}, function (ata) {
                            vm.acao.ata = ata;
                        }, function (error) {
                            Alerta.error("Ops!", "Não foi possível encontrar chamado, tarefa ou ata com o número" + vm.numeroBusca + "!");
                        });
                    });
                });
        }

        function defineVariaveisTransient() {
            vm.numeroBusca = vm.acao.chamado ? vm.acao.chamado.numero :
                vm.acao.solicitacaoDesenvolvimento ? vm.acao.solicitacaoDesenvolvimento.numero :  vm.acao.ata?
                    vm.acao.ata.numero : null;


        }

        defineVariaveisTransient();
    }
})();

(function () {
    'use strict';
    angular
        .module('chamadosApp')
        .factory('Acao', Acao);

    Acao.$inject = ['$resource'];

    function Acao($resource) {
        var resourceUrl = 'api/acao/:id';

        return $resource(resourceUrl, {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET'
            },
            'update': {method: 'PUT'},
            'byUserPendente': {
                method: 'GET',
                url: 'api/acao/by-user-pendente',
                isArray: true
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('acao', {
                parent: 'admin',
                url: '/acao?page&sort&search',
                data: {
                    authorities: ['ROLE_SCRUM'],
                    pageTitle: 'Ação'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/acao/acao.html',
                        controller: 'AcaoController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicate: PaginationUtil.parsePredicate($stateParams.sort),
                            ascending: PaginationUtil.parseAscending($stateParams.sort),
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('situacaoAcao');
                        return $translate.refresh();
                    }]
                }
            })
            .state('acao.new', {
                parent: 'acao',
                url: '/new',
                data: {
                    authorities: ['ROLE_SCRUM']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/acao/acao-edit.html',
                        controller: 'AcaoEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: function () {
                        return {situacaoAcao: 'PENDENTE'};
                    }
                },
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('situacaoAcao');
                    return $translate.refresh();
                }]
            })
            .state('acao.edit', {
                parent: 'acao',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_SCRUM']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/admin/acao/acao-edit.html',
                        controller: 'AcaoEditController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    entity: ['$stateParams', 'Acao', function ($stateParams, Acao) {
                        return Acao.get({id: $stateParams.id}).$promise;
                    }]
                },
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('situacaoAcao');
                    return $translate.refresh();
                }]
            })
    }

})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('AcaoController', AcaoController);

    AcaoController.$inject = ['$scope', '$state', 'Acao', 'ParseLinks', 'AlertService', 'paginationConstants', 'pagingParams', 'Alerta'];

    function AcaoController($scope, $state, Acao, ParseLinks, AlertService, paginationConstants, pagingParams, Alerta) {
        var vm = this;

        vm.loadAll = loadAll;
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.remover = remover;
        vm.itemsPerPage = paginationConstants.itemsPerPage;
        vm.acoes;

        function loadAll() {
            Acao.query({
                page: pagingParams.page - 1,
                size: vm.itemsPerPage,
                sort: sort(),
                filtro: vm.filtro
            }, onSuccess, onError);

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.acoes = data;
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        vm.loadAll();

        function loadPage(page) {
            vm.page = page;
            vm.transition();
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function remover(id) {
            Alerta.confirm("Atenção", "Tem certeza que deseja remover essa Ação?", "warning", function () {
                Acao.delete({id: id},
                    function () {
                        Alerta.success("Operação realizada", "O Ação foi removida!");
                        vm.loadAll();
                        $scope.$emit('chamadosApp:acaoUpdate');

                    });
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('SocialRegisterController', SocialRegisterController);

    SocialRegisterController.$inject = ['$filter', '$stateParams'];

    function SocialRegisterController ($filter, $stateParams) {
        var vm = this;

        vm.success = $stateParams.success;
        vm.error = !vm.success;
        vm.provider = $stateParams.provider;
        vm.providerLabel = $filter('capitalize')(vm.provider);
        vm.success = $stateParams.success;
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('social-register', {
            parent: 'account',
            url: '/social-register/:provider?{success:boolean}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'social.register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/social/social-register.html',
                    controller: 'SocialRegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('social');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .factory('SocialService', SocialService);

    SocialService.$inject = ['$http', '$cookies'];

    function SocialService ($http, $cookies) {
        var socialService = {
            getProviderSetting: getProviderSetting,
            getProviderURL: getProviderURL,
            getCSRF: getCSRF
        };

        return socialService;

        function getProviderSetting (provider) {
            switch(provider) {
            case 'google': return 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email';
            case 'facebook': return 'public_profile,email';
            case 'twitter': return '';
                // jhipster-needle-add-social-button
            default: return 'Provider setting not defined';
            }
        }

        function getProviderURL (provider) {
            return 'signin/' + provider;
        }

        function getCSRF () {
            return $cookies.get($http.defaults.xsrfCookieName);
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .directive('jhSocial', jhSocial);

    jhSocial.$inject = ['$translatePartialLoader', '$translate', '$filter', 'SocialService'];

    function jhSocial($translatePartialLoader, $translate, $filter, SocialService) {
        var directive = {
            restrict: 'E',
            scope: {
                provider: '@ngProvider'
            },
            templateUrl: 'app/account/social/directive/social.html',
            link: linkFunc
        };

        return directive;

        /* private helper methods */

        function linkFunc(scope) {
            
            $translatePartialLoader.addPart('social');
            $translate.refresh();
            
            scope.label = $filter('capitalize')(scope.provider);
            scope.providerSetting = SocialService.getProviderSetting(scope.provider);
            scope.providerURL = SocialService.getProviderURL(scope.provider);
            scope.csrf = SocialService.getCSRF();
        }

    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'entity',
            url: '/settings',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    $translatePartialLoader.addPart('apiTokens');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['Principal', 'Auth', 'JhiLanguageService', '$translate', 'Upload', 'Account', '$rootScope', 'ApiTokens'];

    function SettingsController(Principal, Auth, JhiLanguageService, $translate, Upload, Account, $rootScope, ApiTokens) {
        var vm = this;

        vm.error = null;
        vm.save = save;
        vm.settingsAccount = null;
        vm.success = null;
        vm.notificacoes = ['DEPLOY_PRODUCAO'];

        vm.copied = false;
        vm.createToken = createToken;
        vm.createdToken = null;
        vm.loadTokens = loadTokens;
        vm.newTokenName = '';
        vm.revokeToken = revokeToken;
        vm.copyToken = copyToken;
        vm.tokenError = null;
        vm.tokenSuccess = null;
        vm.tokens = [];

        var copyAccount = function (account) {
            return {
                activated: account.activated,
                email: account.email,
                firstName: account.firstName,
                langKey: account.langKey,
                lastName: account.lastName,
                login: account.login,
                notificacoes: account.notificacoes
            };
        };

        Principal.identity().then(function (account) {
            vm.settingsAccount = copyAccount(account);

            angular.forEach(account.filas, function (fila) {
                vm.notificacoes.push(fila);
            });


            Account.getImagem({}, function (data) {
                if (data.id) {
                    vm.picFile = Upload.dataUrltoBlob(data.imagemOriginal, 'Original');
                    vm.croppedDataUrl = data.imagemAjustada;
                }
            });
        });

        loadTokens();

        function save() {
            Auth.updateAccount(vm.settingsAccount).then(function () {
                vm.error = null;
                vm.success = 'OK';
                Principal.identity(true).then(function (account) {
                    vm.settingsAccount = copyAccount(account);
                });
                JhiLanguageService.getCurrent().then(function (current) {
                    if (vm.settingsAccount.langKey !== current) {
                        $translate.use(vm.settingsAccount.langKey);
                    }
                });
                Upload.dataUrl(vm.picFile, true).then(
                    function (original) {
                        if (original && vm.croppedDataUrl) {
                            Account.saveImagem({
                                imagemOriginal: original,
                                imagemAjustada: vm.croppedDataUrl
                            }, function (data) {
                                vm.imagemOginal = data.imagemOriginal;
                                vm.croppedDataUrl = data.imagemAjustada;
                                $rootScope.$broadcast('authenticationSuccess');
                            });
                        }
                    }
                );
            }).catch(function () {
                vm.success = null;
                vm.error = 'ERROR';
            });
        }

        function loadTokens() {
            vm.tokens = ApiTokens.getAll();
        }

        function createToken() {
            vm.tokenError = null;
            vm.tokenSuccess = null;
            vm.copied = false;
            vm.createdToken = null;

            ApiTokens.create({name: vm.newTokenName}, function (response) {
                vm.createdToken = response.token;
                vm.newTokenName = '';
                vm.tokenSuccess = 'CREATED';
                loadTokens();
            }, function () {
                vm.tokenSuccess = null;
                vm.tokenError = 'CREATE';
            });
        }

        function revokeToken(id) {
            ApiTokens.delete({id: id}, function () {
                vm.tokenError = null;
                vm.tokenSuccess = 'REVOKED';
                loadTokens();
            }, function () {
                vm.tokenSuccess = null;
                vm.tokenError = 'REVOKE';
            });
        }

        function copyToken() {
            var input = document.getElementById('created-api-token');
            if (!input) {
                return;
            }
            input.select();
            document.execCommand('copy');
            vm.copied = true;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('sessions', {
            parent: 'entity',
            url: '/sessions',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.menu.account.sessions'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/sessions/sessions.html',
                    controller: 'SessionsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('sessions');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('SessionsController', SessionsController);

    SessionsController.$inject = ['Sessions', 'Principal'];

    function SessionsController (Sessions, Principal) {
        var vm = this;

        vm.account = null;
        vm.error = null;
        vm.invalidate = invalidate;
        vm.sessions = Sessions.getAll();
        vm.success = null;


        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function invalidate (series) {
            Sessions.delete({series: encodeURIComponent(series)},
                function () {
                    vm.error = null;
                    vm.success = 'OK';
                    vm.sessions = Sessions.getAll();
                },
                function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('requestReset', {
            parent: 'account',
            url: '/reset/request',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/request/reset.request.html',
                    controller: 'RequestResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('RequestResetController', RequestResetController);

    RequestResetController.$inject = ['$timeout', 'Auth'];

    function RequestResetController ($timeout, Auth) {
        var vm = this;

        vm.error = null;
        vm.errorEmailNotExists = null;
        vm.requestReset = requestReset;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#email').focus();});

        function requestReset () {

            vm.error = null;
            vm.errorEmailNotExists = null;

            Auth.resetPasswordInit(vm.resetAccount.email).then(function () {
                vm.success = 'OK';
            }).catch(function (response) {
                vm.success = null;
                if (response.status === 400 && response.data === 'e-mail address not registered') {
                    vm.errorEmailNotExists = 'ERROR';
                } else {
                    vm.error = 'ERROR';
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('finishReset', {
            parent: 'account',
            url: '/reset/finish?key',
            data: {
                authorities: []
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/reset/finish/reset.finish.html',
                    controller: 'ResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('ResetFinishController', ResetFinishController);

    ResetFinishController.$inject = ['$state','$stateParams', '$timeout', 'Auth'];

    function ResetFinishController ($state, $stateParams, $timeout, Auth) {
        var vm = this;

        vm.keyMissing = angular.isUndefined($stateParams.key);
        vm.confirmPassword = null;
        vm.doNotMatch = null;
        vm.error = null;
        vm.finishReset = finishReset;
        vm.login = login;
        vm.resetAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#password').focus();});

        function login(){
            $state.go('login');
        }

        function finishReset() {
            vm.doNotMatch = null;
            vm.error = null;
            if (vm.resetAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                Auth.resetPasswordFinish({key: $stateParams.key, newPassword: vm.resetAccount.password}).then(function () {
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'account',
            url: '/register',
            data: {
                authorities: [],
                pageTitle: 'register.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$state','$translate', '$timeout', 'Auth'];

    function RegisterController ($state, $translate, $timeout, Auth) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = login;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;

        $timeout(function (){angular.element('#login').focus();});

        function login() {
            $state.go('login');
        }

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'e-mail address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('redmine', {
            parent: 'entity',
            url: '/redmine',
            data: {
                authorities: ['ROLE_ATENDENTE', 'ROLE_PO', 'ROLE_DESENVOLVEDOR'],
                pageTitle: 'global.menu.account.settings'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/redmine/redmine.html',
                    controller: 'RedmineController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('RedmineController', RedmineController);

    RedmineController.$inject = ['$state', 'Account', 'Alerta'];

    function RedmineController($state, Account, Alerta) {
        var vm = this;
        vm.error = null;
        vm.save = save;
        vm.saveGit = saveGit;
        vm.redmineAccount = Account.getRedmine();

        function save() {
            Account.saveRedmine(vm.redmineAccount, function (data) {
                $state.go('redmine', {}, {reload: true});
                Alerta.success("Operação realizada!", "Vinculo com Redmine criado");
            }, function (error) {
                Alerta.error("Operação NÃO realizada!", "Vinculo com Redmine não pode ser criado");
            });
        }

        function saveGit() {
            Account.saveGit(vm.redmineAccount, function (data) {
                $state.go('redmine', {}, {reload: true});
                Alerta.success("Operação realizada!", "Vinculo com Git criado");
            }, function (error) {
                Alerta.error("Operação NÃO realizada!", "Vinculo com Git não pode ser criado");
            });
        }
    }
})();

/* globals $ */
(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .directive('passwordStrengthBar', passwordStrengthBar);

    function passwordStrengthBar () {
        var directive = {
            replace: true,
            restrict: 'E',
            template: '<div id="strength">' +
                '<small data-translate="global.messages.validate.newpassword.strength">Password strength:</small>' +
                '<ul id="strengthBar">' +
                '<li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li><li class="point"></li>' +
                '</ul>' +
                '</div>',
            scope: {
                passwordToCheck: '='
            },
            link: linkFunc
        };

        return directive;

        /* private helper methods*/

        function linkFunc(scope, iElement) {
            var strength = {
                colors: ['#F00', '#F90', '#FF0', '#9F0', '#0F0'],
                mesureStrength: function (p) {

                    var _force = 0;
                    var _regex = /[$-/:-?{-~!"^_`\[\]]/g; // "

                    var _lowerLetters = /[a-z]+/.test(p);
                    var _upperLetters = /[A-Z]+/.test(p);
                    var _numbers = /[0-9]+/.test(p);
                    var _symbols = _regex.test(p);

                    var _flags = [_lowerLetters, _upperLetters, _numbers, _symbols];
                    var _passedMatches = $.grep(_flags, function (el) {
                        return el === true;
                    }).length;

                    _force += 2 * p.length + ((p.length >= 10) ? 1 : 0);
                    _force += _passedMatches * 10;

                    // penalty (short password)
                    _force = (p.length <= 6) ? Math.min(_force, 10) : _force;

                    // penalty (poor variety of characters)
                    _force = (_passedMatches === 1) ? Math.min(_force, 10) : _force;
                    _force = (_passedMatches === 2) ? Math.min(_force, 20) : _force;
                    _force = (_passedMatches === 3) ? Math.min(_force, 40) : _force;

                    return _force;

                },
                getColor: function (s) {

                    var idx;
                    if (s <= 10) {
                        idx = 0;
                    }
                    else if (s <= 20) {
                        idx = 1;
                    }
                    else if (s <= 30) {
                        idx = 2;
                    }
                    else if (s <= 40) {
                        idx = 3;
                    }
                    else {
                        idx = 4;
                    }

                    return { idx: idx + 1, col: this.colors[idx] };
                }
            };
            scope.$watch('passwordToCheck', function (password) {
                if (password) {
                    var c = strength.getColor(strength.mesureStrength(password));
                    iElement.removeClass('ng-hide');
                    iElement.find('ul').children('li')
                        .css({ 'background-color': '#DDD' })
                        .slice(0, c.idx)
                        .css({ 'background-color': c.col });
                }
            });
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password', {
            parent: 'entity',
            url: '/password',
            data: {
                authorities: [],
                pageTitle: 'global.menu.account.password'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/password/password.html',
                    controller: 'PasswordController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('PasswordController', PasswordController);

    PasswordController.$inject = ['Auth', 'Principal'];

    function PasswordController (Auth, Principal) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        Principal.identity().then(function(account) {
            vm.account = account;
        });

        function changePassword () {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('login', {
                parent: 'account',
                url: '/login',
                data: {
                    roles: [],
                    pageTitle: 'login.title',
                    specialClass: "login-page"
                },
                ncyBreadcrumb: {
                    label: 'Autênticação '
                },
                views: {
                    'content@': {
                        templateUrl: 'app/account/login/login.html',
                        controller: 'LoginController',
                        controllerAs: 'vm'
                    },
                    'menu@': {},
                    'navbar@': {}
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('login');
                        return $translate.refresh();
                    }],
                }
            });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', '$timeout', 'Auth', 'Principal', '$location', '$anchorScroll','Alerta'];

    function LoginController($rootScope, $state, $timeout, Auth, Principal, $location, $anchorScroll, Alerta) {
        var vm = this;

        vm.authenticationError = false;
        vm.credentials = {};
        vm.login = login;
        vm.password = null;
        vm.register = register;
        vm.rememberMe = true;
        vm.requestResetPassword = requestResetPassword;
        vm.username = null;
        vm.ano = new Date().getFullYear();



        $timeout(function () {
            angular.element('#username').focus();
            if (angular.element("#box-login").height() > 0) {
                var tamanho =  angular.element('#box-login > .widget').height();
                angular.element('#box-logo > .widget').height(tamanho);
            }
        }, 500);

        Principal.identity().then(function (account) {
            if (account) {
                //manda p o home caso tente acessar o login e já está logado
                $state.go('home', {reload: true});
            }
        });

        function login(event) {
            event.preventDefault();
            Auth.login({
                username: vm.username,
                password: vm.password,
                rememberMe: vm.rememberMe
            }).then(function () {
                vm.authenticationError = false;
                $rootScope.$broadcast('authenticationSuccess');
                $state.go('home');
                // if ($state.current.name === 'login' ||
                //     $state.current.name === 'register' || $state.current.name === 'activate' ||
                //     $state.current.name === 'finishReset' || $state.current.name === 'requestReset') {
                //     $state.go('home');
                // } else {
                //     // previousState was set in the authExpiredInterceptor before being redirected to login modal.
                //     // since login is successful, go to stored previousState and clear previousState
                //     if (Auth.getPreviousState()) {
                //         var previousState = Auth.getPreviousState();
                //         Auth.resetPreviousState();
                //         $state.go(previousState.name, previousState.params);
                //     }
                // }
            }).catch(function () {
                vm.authenticationError = true;
                Alerta.warn("Atenção!", "Usuário ou senha inválidos, digite novamente");
            });
        }

        function register() {
            $state.go('register');
        }

        function requestResetPassword() {
            $state.go('requestReset');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('activate', {
            parent: 'account',
            url: '/activate?key',
            data: {
                authorities: [],
                pageTitle: 'activate.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/account/activate/activate.html',
                    controller: 'ActivationController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('activate');
                    return $translate.refresh();
                }]
            }
        });
    }
})();

(function () {
    'use strict';

    angular
        .module('chamadosApp')
        .controller('ActivationController', ActivationController);

    ActivationController.$inject = ['$state', '$stateParams', 'Auth'];

    function ActivationController($state, $stateParams, Auth) {
        var vm = this;

        Auth.activateAccount({key: $stateParams.key}).then(function () {
            vm.error = null;
            vm.success = 'OK';
        }).catch(function () {
            vm.success = null;
            vm.error = 'ERROR';
        });

        vm.login = login;

        function login() {
            $state.go('login');
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('chamadosApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('account', {
            abstract: true,
            parent: 'app',
            data: {
                specialClass: "body-bg"
            }
        });
    }
})();
(function(){angular.module('chamadosApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/home/home.html','<div ng-cloak ng-switch="vm.isAuthenticated()"><div class="row" ng-switch-when="true"><div class="row"><div ng-show="vm.mostraColunaDetalhesUsuario" class="col-md-3"><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-md-12 text-center"><img ng-src="{{vm.filtro.user.imagem}}" ng-show="vm.filtro.user.imagem" width="62" class="img-circle" alt="foto do usuario"> <img alt="image" class="img-circle" ng-show="!vm.filtro.user.imagem" width="62" ng-src="/content/images/user-default.png"><h3>{{vm.filtro.user.firstName}} {{vm.filtro.user.lastName}}</h3></div><div class="col-md-12"><label>Ciclo</label><select class="form-control" id="field_sprint" name="modulo" ng-model="vm.sprintSelecionada" ng-change="vm.changeSprint()" ng-options="sprint as sprint.descricao for sprint in vm.sprints track by sprint.id"><option value=""></option></select><div class="progress progress-striped m-t-sm"><div style="width: {{(vm.diasPercorridos * 100) / vm.totalDias}}%" aria-valuemax="100" aria-valuemin="0" aria-valuenow="{{(vm.diasPercorridos * 100) / vm.totalDias}}" role="progressbar" class="progress-bar progress-bar-navy-light">Andamento &ensp; {{(vm.diasPercorridos * 100) / vm.totalDias | number:0}}%</div></div></div><div has-any-authority="ROLE_ATENDENTE, ROLE_PO, ROLE_DESENVOLVEDOR"><div class="col-md-12" ng-show="vm.alertas && vm.alertas.length > 0"><div class="panel panel-danger"><div class="panel-heading"><label>Alertas</label></div><div class="panel-body" style="max-height: 400px; overflow-y: scroll; overflow-x: hidden"><div class="col-lg-12"><table class="table"><tr ng-repeat="alerta in vm.alertas | orderBy:\'tipo\'" class="text-{{alerta.tipo}}"><td><i class="fa fa-exclamation-triangle m-r-md"></i> {{alerta.titulo}}</td></tr></table></div></div></div></div><div class="col-md-12"><div class="table-responsive" style="max-height: 350px; overflow: auto"><table class="jh-table table table-striped table-hover"><tr><th class="text-center">Dia</th><th class="text-center">Ponto</th><th class="text-center">Apontado</th><th class="text-center">%</th></tr><tr class="text-center" ng-repeat="dia in vm.horaApontadaPorDia | orderBy:\'dia.dia\'"><td>{{dia.dia | date:\'dd/MM\'}}</td><td class="text-center">{{dia.horaPonto | number: 2}}</td><td class="text-center"><a ui-sref="tempo-gasto({dia: dia.dia})">{{dia.tempoGasto | number: 2}}</a></td><td class="text-center"><span class="{{dia.percentual < 80 ? \'text-danger\': \'text-info\'}}">{{dia.percentual | number: 2}}%</span></td></tr><tr><td colspan="4" class="text-center"><strong>Total: <span class="text-success">{{vm.totalHoraTrabalhadas | number: 2}}hs</span></strong></td></tr></table></div></div></div></div></div></div></div><div class="{{vm.mostraColunaDetalhesUsuario ? \'col-md-9\' :\'col-md-12\'}}"><div class="row"><div class="col-lg-12" has-any-authority="ROLE_DESENVOLVEDOR"><div class="panel panel-success"><div class="panel-heading"><label>Suas Tarefas</label></div><div class="panel-body"><situacoes-sprint situacoes-sprint-selecionadas="vm.situacoesSprintSelecionadas" on-selecionar="vm.changeSituacoesSprint()" mostrar-botao-atribuidas-para-mim="false"></situacoes-sprint><div class="col-md-2 no-padding no-margins" ng-repeat="tarefa in vm.tarefasDaSprint | orderBy:\'situacao\'"><div class="issue issue__{{tarefa.tipo}}" style="margin: 2px;background-color: {{tarefa.corModulo}}"><div class="row"><div class="col-md-12"><a class="font-bold" ui-sref="solicitacaoDesenvolvimento.detail({id:tarefa.id})">#{{tarefa.numero}}</a> <small class="pull-right label small" data-translate="{{\'chamadosApp.SituacaoTarefa.\' + tarefa.situacao}}">{{tarefa.situacao}}</small><p class="issue__title text-resume" title="{{tarefa.titulo}}">{{tarefa.titulo}}</p><p class="small text-resume" style="white-space: nowrap; margin: 0">{{tarefa.projeto}}/{{tarefa.modulo}}</p><small class="text-danger" title="Tarefa n\xE3o planejada" ng-if="!tarefa.planejado"><i class="fa fa-clock-o"></i> N.P </small><small class="text-danger" title="{{tarefa.sprintChamado}}" ng-if="tarefa.sprintOriginal != vm.sprint.descricao && tarefa.sprintChamado"><i class="fa fa-exclamation-triangle"></i> Atrasado</small></div></div></div></div></div></div></div><div class="col-lg-12 m-b-md" has-any-authority="ROLE_PO, ROLE_ATENDENTE, ROLE_DESENVOLVEDOR"><iframe allowtransparency frameborder="0" height="800" src="{{vm.dashBoardUrl}}" style="width: 100%"></iframe></div><div class="col-lg-12"><div class="panel panel-success"><div class="panel-heading"><label>Planejado Do Ciclo {{vm.sprintSelecionada.descricao}}</label></div><div class="panel-body" style="max-height: 400px; overflow-y: scroll; overflow-x: hidden"><div class="row"><div class="col-md-12 m-t-sm"><table class="table"><tr><th>Projeto</th><th class="text-right">Planejado</th><th class="text-right">Alocado</th><th class="text-right">Excedente</th><th class="text-right">Suporte</th></tr><tr ng-repeat="cliente in vm.chamadosPorCliente" ng-click="vm.verChamadosProjeto(cliente)" class="{{vm.tempoExcedente(cliente) > 0? \'danger\':\'\'}}"><td>{{cliente.cliente}}</td><td class="text-right">{{cliente.disponivel | number: 1}}h</td><td class="text-right">{{cliente.alocado | number: 1}}h</td><td class="text-right"><span ng-if="vm.tempoExcedente(cliente) <= 0">0h </span><span ng-if="vm.tempoExcedente(cliente) > 0" class="label label-danger">+ {{vm.tempoExcedente(cliente) | number: 1}}h</span></td><td class="text-right">{{cliente.suporte | number: 1}}h</td></tr></table></div></div></div></div><div class="row"><div class="col-md-4"><div class="panel panel-success"><div class="panel-heading"><label>Sistemas</label></div><div class="panel-body" style="max-height: 400px; overflow-y: scroll; overflow-x: hidden"><table class="table"><tr><th>Sistema</th><th class="text-right">Alocado</th><th class="text-right">Suporte</th></tr><tr ng-repeat="sistema in vm.chamadosPorSistema"><td>{{sistema.sistema}}</td><td class="text-right">{{sistema.alocado | number: 1}}h</td><td class="text-right">{{sistema.suporte | number: 1}}h</td></tr></table></div></div></div><div class="col-md-4"><div class="panel panel-success"><div class="panel-heading"><label>M\xF3dulos</label></div><div class="panel-body" style="max-height: 400px; overflow-y: scroll; overflow-x: hidden"><table class="table"><tr><th>M\xF3dulo</th><th class="text-right">Alocado</th><th class="text-right">Suporte</th></tr><tr ng-repeat="modulo in vm.chamadosPorModulo"><td>{{modulo.modulo}}</td><td class="text-right">{{modulo.alocado | number: 1}}h</td><td class="text-right">{{modulo.suporte | number: 1}}h</td></tr></table></div></div></div><div class="col-md-4"><div class="panel panel-success"><div class="panel-heading"><label>Tipo de Chamado</label></div><div class="panel-body" style="max-height: 400px; overflow-y: scroll; overflow-x: hidden"><table class="table"><tr><th>Tipo de Chamado</th><th class="text-right">Alocado</th></tr><tr ng-repeat="tipo in vm.chamadosPorTipo"><td><span data-translate="{{\'chamadosApp.TipoChamado.\' + tipo.tipo}}">{{tipo.tipo}}</span></td><td class="text-right">{{tipo.alocado | number: 1}}h</td></tr></table></div></div></div></div></div></div></div></div></div></div><script type="text/ng-template" id="chamadosCliente.html"><div class="modal-header">\n        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"\n                ng-click="vm.ok()">&times;\n        </button>\n        <h3 class="modal-title">Chamados do Projeto {{vm.cliente.cliente}}</h3>\n    </div>\n    <div class="modal-body">\n        <table class="jh-table table table-striped table-hover">\n            <tr class="small">\n                <th class="issue-info">\n                    Severidade\n                    <small>Tipo</small>\n                </th>\n                <th>\n                    Titulo\n                </th>\n                <th class="issue-info">\n\n                    Criado Em\n                    <small>\n                        T. Estimado\n                    </small>\n                </th>\n                <th class="issue-info ">\n                    M\xF3dulo\n                    <small>\n                        Sub-M\xF3dulo\n                    </small>\n                </th>\n                <th>\n                    Situa\xE7\xE3o\n                </th>\n            </tr>\n            <tbody>\n\n            <tr\n                class="{{!chamado.planejado && chamado.tipoChamado != \'SUPORTE\' ? \'danger\':\'\'}} {{chamado.tipoChamado == \'SUPORTE\'? \'warning\':\'\'}}"\n                ng-repeat="chamado in vm.cliente.chamados track by chamado.id">\n\n\n                <td class="issue-info">\n                    <a ui-sref="edit-chamado({id:chamado.id, search: null, situacao: null})">\n                        #{{chamado.id}}\n                    </a>\n                    <small>\n                                                <span\n                                                    data-translate="{{\'chamadosApp.TipoChamado.\' + chamado.tipoChamado}}">{{chamado.tipoChamado}}</span>\n\n\n                    </small>\n                </td>\n                <td class="issue-info" style="width: 30%">\n\n                    <span title="{{chamado.titulo}}">\n                        {{chamado.ordem}}-{{chamado.titulo | limitTo: 50 }}{{chamado.titulo.length >\n                    50 ?\n                        \'...\' : \'\'}}\n                    </span>\n                    <small ng-if="!chamado.planejado" class="strong">N\xE3o Planejado</small>\n\n                </td>\n                <td class="issue-info">\n                    {{chamado.criadoEm | date:\'mediumDate\'}}\n                    <small>\n                        <i ng-if="chamado.tempoEstimado" class="fa fa-clock-o"></i>\n                        {{chamado.tempoEstimado}}\n                    </small>\n                </td>\n                <td class="issue-info">\n                    {{chamado.modulo}}\n                    <small title=" {{chamado.subModulo}}">\n                        {{chamado.subModulo | limitTo: 50 }}{{chamado.subModulo.length > 50\n                        ?\n                        \'...\' : \'\'}}\n\n                    </small>\n                </td>\n\n                <td>\n                                            <span\n                                                data-translate="{{\'chamadosApp.SituacaoChamado.\' + chamado.situacao}}">{{chamado.situacao}}</span>\n                </td>\n                </td>\n            </tr>\n            </tbody>\n        </table>\n    </div>\n    <div class="modal-footer">\n\n        <button class="btn btn-info" type="button"\n                ng-click="vm.ok()">\n            <i class="fa fa-check-circle-o"></i>\n            Ok\n        </button>\n    </div></script>');
$templateCache.put('app/planejamento/planejamento.html','<ul class="nav nav-tabs" role="tablist"><li ng-repeat="sistema in vm.sistemas" ng-click="vm.selecionarSistema(sistema)"><a class="nav-link {{sistema.id === vm.sistema.id ? \'active\': \'\'}}" title="{{sistema.nome}}">{{sistema.nome | limitTo: 15 }}{{sistema.nome.length > 15 ? \'...\' : \'\'}}</a></li></ul><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-md-12" ng-if="!vm.sprintAberta"><div class="alert alert-warning text-center"><strong>Aten\xE7\xE3o!</strong> Ainda n\xE3o h\xE1 um Ciclo aberto cadastrado, verifique com o suporte.</div></div><div class="col-md-12" ng-if="vm.sprintAberta"><div class="panel panel-primary m-t-md"><div class="panel-heading text-center">Planejamento do pr\xF3ximo Ciclo ({{vm.sprintAberta.descricao}})</div><div class="panel-body"><div class="alert alert-info text-center" ng-show="!vm.sprintAberta.tarefas || vm.sprintAberta.tarefas.length == 0">Ainda n\xE3o h\xE1 tarefas alocadas para o ciclo <strong>\'{{vm.sprintAberta.descricao}}\'</strong>.</div><div class="tabs-container"><ul class="nav nav-tabs" role="tablist"><li ng-repeat="modulo in vm.modulos" ng-click="vm.modulo = modulo"><a class="nav-link {{modulo.id === vm.modulo.id ? \'active\': \'\'}}">{{modulo.descricao}} &nbsp; <small class="text-muted">{{vm.getHorasPormodulo(modulo)}} h</small></a></li></ul><div class="tab-content"><div class="tab-pane active"><div class="panel-body"><div class="table-responsive"><table class="jh-table table table-striped table-hover"><tr><th>Ordem</th><th class="issue-info">N\xBA da tarefa <small>Titulo</small></th><th class="issue-info">Solicitante <small>Respons\xE1vel</small></th><th>Tempo</th><th class="issue-info">M\xF3dulo <small>Projeto</small></th><th class="text-center" has-authority="ROLE_PLANEJAMENTO_SPRINT">Retirar</th></tr><tbody><tr ng-repeat="tarefa in vm.getTarefasSprintPorModulo(vm.modulo) track by tarefa.id"><td style="width: 10%!important"><input type="text" class="form-control" ng-model="tarefa.ordem" ng-blur="vm.atualizarTarefa(tarefa)"></td><td class="issue-info"><a ui-sref="solicitacaoDesenvolvimento.detail({id:tarefa.id})">#{{tarefa.numero}} </a><span ng-if="tarefa.chamado"><a ui-sref="edit-chamado({id:tarefa.chamado.id})" class="text-muted">(#{{tarefa.chamado.id}}) </a></span><small>{{tarefa.titulo}}</small></td><td class="issue-info">{{tarefa.solicitante.firstName}} <small>{{tarefa.responsavel.firstName}}</small></td><td class="text-muted"><strong class="text-success">{{tarefa.tempoEstimado || 0}}</strong>h. <span class="text-warning" ng-if="!tarefa.tempoEstimado">sem estimativa</span></td><td class="issue-info">{{tarefa.modulo.descricao}} <small>{{tarefa.cliente.nome}}</small></td><td class="text-center" has-authority="ROLE_PLANEJAMENTO_SPRINT"><button type="button" ng-disabled="!vm.sprintAberta" ng-click="vm.desalocarTarefa(tarefa)" class="btn btn-sm btn-warning"><i class="fa fa-arrow-down"></i></button></td></tr></tbody></table></div></div></div></div></div></div></div></div></div><div class="row"><div class="col-md-12"><div class="panel panel-default m-t-md"><table class="table table-striped"><tr><th>Tempo planejado</th><th class="text-right">Alocado</th></tr><tr ng-repeat="cliente in vm.clientes | orderBy:\'cliente.nome\'" ng-show="vm.usuarioTemCliente(cliente)"><td><a ng-click="cliente.selecionado = !cliente.selecionado; vm.agruparChamados()"><i class="fa {{cliente.selecionado ?\'fa-check-circle-o\':\'fa-circle-o\'}}"></i> </a>&ensp; <strong>{{cliente.nome}}</strong></td><td class="text-right"><strong class="{{ vm.horasDisponiveisCliente[cliente.id].horasDisponiveis != vm.horasDisponiveisCliente[cliente.id].horasOcupadas ? \'text-danger\':\'\'}}">{{vm.horasDisponiveisCliente[cliente.id].horasOcupadas | number:1 }}h </strong>/ {{ vm.horasDisponiveisCliente[cliente.id].horasDisponiveis | number:1 }}h <span class="label {{ vm.horasDisponiveisCliente[cliente.id].horasDisponiveis < vm.horasDisponiveisCliente[cliente.id].horasSemDependencia ? \'label-success\':\'label-danger\'}}" has-authority="ROLE_PO">{{vm.horasDisponiveisCliente[cliente.id].horasSemDependencia | number:1 }}h</span></td></tr></table></div></div></div><div class="row"><div class="col-md-12"><div class="tabs-container"><ul class="nav nav-tabs" role="tablist"><li ng-repeat="modulo in vm.modulos" ng-click="vm.modulo = modulo"><a class="nav-link {{modulo.id === vm.modulo.id ? \'active\': \'\'}}">{{modulo.descricao}} &nbsp; <small class="text-muted">{{vm.getQtdTarefasParaAlocar(modulo)}} <span has-authority="ROLE_PO" ng-show="vm.chamadosPorModulo[modulo.id]">/{{vm.chamadosPorModulo[modulo.id].tempoDisponivel | number:1}}h</span></small></a></li></ul><div class="tab-content"><div class="tab-pane active"><div class="alert alert-info text-center" ng-show="vm.getTarefasParaAlocar(vm.modulo).length === 0">Nenhuma tarefa dispon\xEDvel para alocar neste m\xF3dulo.</div><table class="jh-table table table-striped table-hover" ng-show="vm.getTarefasParaAlocar(vm.modulo).length > 0"><tr><th class="issue-info">Tarefa <small>\xC9pico</small></th><th class="issue-info">Solicitante <small>Respons\xE1vel</small></th><th class="issue-info">Tempo <small>Projeto</small></th><th class="text-center" has-authority="ROLE_PLANEJAMENTO_SPRINT">Alocar</th></tr><tbody><tr ng-repeat="item in vm.getTarefasParaAlocar(vm.modulo) | orderBy:[\'epico.chamado.cliente.nome\',\'epico.chamado.criadoEm\',\'tarefa.numero\'] track by item.tarefa.id"><td class="issue-info"><a ui-sref="solicitacaoDesenvolvimento.detail({id:item.tarefa.id})">#{{item.tarefa.numero}} </a><small>{{item.tarefa.titulo}} <span class="text-danger" ng-if="item.epico.dependentes && item.epico.dependentes.length > 0" title="Possui depend\xEAncias"><i class="fa fa-exclamation"></i></span></small><div class="text-muted small">\xC9pico <a ui-sref="edit-chamado({id:item.epico.chamado.id})">#{{item.epico.chamado.id}} </a>\u2014 {{item.epico.chamado.titulo | limitTo: 60}}{{item.epico.chamado.titulo.length > 60 ? \'\u2026\' : \'\'}}</div></td><td class="issue-info">{{item.tarefa.solicitante.firstName || item.epico.chamado.solicitante.firstName}} <small>{{item.tarefa.responsavel.firstName || item.epico.chamado.responsavel.firstName}}</small></td><td class="issue-info"><strong class="text-success">{{item.tarefa.tempoEstimado | number:1 || 0}}h</strong>. <span class="text-warning" ng-if="!item.tarefa.tempoEstimado | number:1">sem estimativa </span><small class="strong">{{item.epico.chamado.cliente.nome}}</small></td><td class="text-center" has-authority="ROLE_PLANEJAMENTO_SPRINT"><button type="button" ng-disabled="!vm.podeAlocarTarefa(item.epico)" ng-click="vm.alocarTarefa(item.tarefa, item.epico)" title="Alocar tarefa na sprint aberta. Depend\xEAncias pendentes s\xE3o validadas no servidor." class="btn btn-sm btn-info"><i class="fa {{!vm.podeAlocarTarefa(item.epico) ? \'fa-times\':\'fa-arrow-up\'}}"></i></button></td></tr></tbody></table><div class="m-t-md" ng-show="vm.getEpicosSemTarefa(vm.modulo).length > 0"><a href="" class="text-muted" ng-click="vm.toggleEpicosSemTarefa()"><i class="fa" ng-class="vm.epicosSemTarefaAbertos ? \'fa-chevron-down\' : \'fa-chevron-right\'"></i> \xC9picos sem tarefa ({{vm.getEpicosSemTarefa(vm.modulo).length}})</a><table class="jh-table table table-condensed table-hover m-t-sm" ng-show="vm.epicosSemTarefaAbertos"><tr><th class="issue-info">\xC9pico <small>Criado em</small></th><th class="issue-info">T\xEDtulo</th><th class="issue-info">Projeto</th><th></th></tr><tbody><tr ng-repeat="epico in vm.getEpicosSemTarefa(vm.modulo) | orderBy:[\'chamado.cliente.nome\',\'chamado.criadoEm\'] track by epico.chamado.id" class="small"><td class="issue-info"><a ui-sref="edit-chamado({id:epico.chamado.id})">#{{epico.chamado.id}} </a><small>{{epico.chamado.criadoEm | date:\'dd/MM/yyyy\'}}</small></td><td class="issue-info">{{epico.chamado.titulo}} <span class="text-danger" ng-if="epico.dependentes && epico.dependentes.length > 0"><i class="fa fa-exclamation"></i> Possui Depend\xEAncias</span></td><td class="issue-info">{{epico.chamado.cliente.nome}}</td><td class="text-right"><a ui-sref="edit-chamado({id:epico.chamado.id})">criar tarefa</a></td></tr></tbody></table></div></div></div></div></div></div></div></div>');
$templateCache.put('app/release/release-detail.html','<div class="ibox"><div class="ibox-title"><h2><i class="fa fa-code-fork"></i> {{vm.release.versao}} - {{vm.release.sistema.nome}}</h2></div><div class="ibox-content"><div class="row"><div class="col-md-12"><div class="col-md-3"><div class="col-md-12"><h3><strong><span data-translate="{{\'chamadosApp.SituacaoRelease.\' + vm.release.situacao}}">{{vm.release.situacao}}</span></strong></h3><address>Solicitado em: {{vm.release.solicitacao | date:\'mediumDate\'}}<br>Liberado em: {{vm.release.liberacao | date:\'mediumDate\'}}<br></address><address>Solicitado por: {{vm.release.solicitante.firstName}}<br>Liberado por: {{vm.release.responsavel.firstName}}<br></address><h3><strong>Projetos</strong></h3><a ng-click="vm.sincronizartGit()"><i class="fa fa-refresh"></i> Sincronizar</a><address><span class="{{projeto.tipoGit == \'STASH\'? \'text-success\': \'text-danger\'}}" ng-repeat="projeto in vm.projetosGit"><i class="fa {{projeto.tipoGit == \'STASH\'? \'fa-bitbucket\': \'fa-gitlab\'}}"></i> {{projeto.repositorioGit}}<br></span></address><div class="form-group" ng-if="vm.release.situacao == \'ABERTO\'" has-authority="ROLE_PO"><label class="control-label">Vers\xE3o</label><input type="text" class="form-control" id="versao" name="versao" ng-model="vm.release.versao"><label class="control-label">Tipo</label><select class="form-control" name="tipoVersao" ng-model="vm.release.tipo" id="field_tipoVersao" required><option value="MAJOR">Vers\xE3o</option><option value="MINOR">Release</option><option value="BUILD">Modifica\xE7\xE3o</option></select></div></div><div class="col-md-12 m-b-md"><button type="button" ng-if="vm.release.situacao == \'ABERTO\'" class="btn btn-warning btn-block m-t-md" has-authority="ROLE_PO" ng-click="vm.iniciarRelease()"><span class="fa fa-code-fork"></span> Iniciar</button> <button type="button" ng-if="vm.release.situacao == \'AGUARDANDO\'" class="btn btn-warning btn-block m-t-md" has-authority="ROLE_PO" ng-click="vm.encerrarRelease()"><span class="fa fa-code-fork"></span> Encerrar</button> <button type="button" class="btn btn-success btn-block" ng-click="vm.salvar()"><span class="fa fa-save"></span> Salvar</button> <button type="button" class="btn btn-danger btn-block" has-authority="ROLE_PO" ng-click="vm.remover()"><span class="fa fa-trash"></span> Remover</button> <button type="submit" ui-sref="release" class="btn btn-block"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div><div class="col-md-12"><h3><strong>Detalhes</strong></h3></div><div class="col-lg-12" ng-repeat="detalhes in vm.release.detalhesRelease"><div class="widget style1 {{detalhes.cor}}"><div class="row"><div class="col-lg-4"><i class="fa {{detalhes.icon}} fa-4x"></i></div><div class="col-lg-8 text-right"><span>{{detalhes.texto}}</span><h2 class="font-bold">{{detalhes.quantidade}}</h2></div></div></div></div></div><div class="col-md-9 no-padding"><div has-authority="ROLE_PO" class="m-b-md"><div class="input-group"><input type="number" class="form-control" ng-model="vm.adicionar" placeholder="N\xFAmero do Chamado"> <span class="input-group-btn"><button class="btn btn-success" ng-click="vm.alocar(vm.adicionar)" type="button"><i class="fa fa-save"></i></button></span></div></div><table class="table table-striped table-hover"><tr><th>Chamado</th><th>M\xF3dulo</th><th>Altera\xE7\xF5es</th><th has-authority="ROLE_PO">#</th></tr><tr ng-repeat="chamado in vm.chamados  | orderBy:\'modulo.descricao\'  track by chamado.id"><td class="issue-info"><strong><a target="_blank" ui-sref="edit-chamado({id:chamado.id, search: null, situacao: null})">#{{chamado.id}} &ensp; {{chamado.titulo}} </a></strong><small style="margin-top: 5px"><span ng-repeat="solicitacao in chamado.solicitacoes track by solicitacao.id"><span class="label label-default" has-authority="ROLE_PO"><a target="_blank" ui-sref="solicitacaoDesenvolvimento.detail({id:solicitacao.id})">#{{solicitacao.numero}} </a>&ensp; <a ng-click="vm.copyToClipboard(solicitacao.numero)"><i class="fa fa-copy"></i> </a></span><span class="m-l-sm {{git.tipoGit == \'STASH\'? \'text-success\': \'text-danger\'}}" ng-repeat="git in solicitacao.projetosGit"><i class="fa {{git.tipoGit == \'STASH\'? \'fa-bitbucket\': \'fa-gitlab\'}}"></i> {{git.repositorioGit}}</span></span></small></td><td><span class="text-success">{{chamado.modulo.descricao}}</span></td><td><small><span ng-show="chamado.alteracaoCodigo">&ensp; <i class="small fa fa-code"></i> C\xF3digo </span><span ng-show="chamado.alteracaoTabela">&ensp; <i class="small fa fa-database"></i> Banco de dados </span><span ng-show="chamado.alteracaoArquitetura">&ensp; <i class="small fa fa-cubes"></i> Arquitetura</span></small></td><td has-authority="ROLE_PO"><a class="text-danger" ng-click="vm.desalocar(chamado)"><i class="fa fa-trash"></i></a></td></tr></table><div class="col-md-12"><strong>Notas</strong> <a class="small" ng-click="vm.atualizarNotas()"><i class="fa fa-refresh"></i> Re-gerar Notas</a><text-angular name="conteudo" required ng-model="vm.release.notas"></text-angular></div></div></div></div></div></div>');
$templateCache.put('app/release/release.html','<div class="ibox"><div class="ibox-content"><div class="row"><div class="col-md-12"><ul class="nav nav-tabs" role="tablist"><li class="{{sistema.id === vm.sistema.id ? \'active\': \'\'}}" ng-repeat="sistema in vm.sistemas | orderBy: \'id\'" ng-click="vm.selecionarSistema(sistema)"><a>{{sistema.nome}} <small ng-show="vm.chamadosPorSistema[sistema.id].chamados.length" class="small m-l-sm label label-primary pull-right">{{vm.chamadosPorSistema[sistema.id].chamados.length}}</small></a></li></ul></div></div><div class="row" ng-show="vm.sistema"><div class="col-md-12 m-t-lg"><div class="col-md-12"><div class="forum-icon"><i class="fa fa-bolt"></i></div><a class="forum-item-title">Pr\xF3xima Release <span class="text-success">{{vm.sistema.nome}}</span></a><div class="forum-sub-title">Abaixo s\xE3o listados todos os chamados j\xE1 validados e aptos a incorporar uma nova Release</div><div class="col-md-12 text-center m-t-lg m-b-lg"><span ng-if="vm.chamadosPorSistema[vm.sistema.id].chamados.length == 0">Nenhum chamado validado </span><span ng-if="vm.chamadosPorSistema[vm.sistema.id].chamados.length > 0">{{vm.chamadosPorSistema[vm.sistema.id].chamados.length}} Chamados validados <span class="text-danger" ng-show="vm.sistema.bugs>0">&ensp; <i class="fa fa-bug"></i> {{vm.sistema.bugs}} Bugs </span><span class="text-navy" ng-show="vm.sistema.melhorias>0">&ensp; <i class="fa fa-level-up"></i> {{vm.sistema.melhorias}} Melhorias </span><span class="text-success" ng-show="vm.sistema.funcionalidades>0">&ensp; <i class="fa fa-plus-square-o"></i> {{vm.sistema.funcionalidades}} Novas Funcionalidades </span><span class="text-warning" ng-show="vm.sistema.suporte>0">&ensp; <i class="fa fa-comment"></i> {{vm.sistema.suporte}} Suportes</span></span></div></div></div><div class="col-md-12"><table class="table table-striped table-hover"><tr><th class="issue-info">N\xBA do chamado <small>Titulo</small></th><th class="issue-info">Modulo <small>Subm\xF3dulo</small></th><th class="issue-info">Tipo de Altera\xE7\xE3o <small>Agrupador</small></th><th has-authority="ROLE_SOLICITAR_RELEASE" class="text-center"><i class="fa fa-check-circle-o" ng-click="vm.alocarTodos()" ng-show="vm.chamadosPorSistema[vm.sistema.id].chamados.length != vm.release.chamados.length"></i> <i class="fa fa-times" ng-click="vm.desalocarTodos()" ng-show="vm.chamadosPorSistema[vm.sistema.id].chamados.length == vm.release.chamados.length"></i></th></tr><tbody><tr class="{{chamado.numeroAgrupadores >0 ? \'muted\':\'\'}}" ng-repeat="chamado in vm.chamadosPorSistema[vm.sistema.id].chamados | orderBy:\'numeroAgrupadores\' track by chamado.id "><td class="issue-info"><a ui-sref="edit-chamado({id:chamado.id})" class="strong">#{{chamado.id}} <span class="{{chamado.tipoChamado === \'BUG\' ? \'text-danger\':\'text-navy\'}} small" data-translate="{{\'chamadosApp.TipoChamado.\' + chamado.tipoChamado}}">{{chamado.tipoChamado}}</span> </a><small>{{chamado.titulo}}</small></td><td class="issue-info">{{chamado.modulo.descricao}} <small>{{chamado.subModulo.descricao}}</small></td><td class="issue-info"><span class="text-muted" ng-show="chamado.alteracaoCodigo"><i class="small fa fa-code"></i> C\xF3digo </span><span class="text-muted" ng-show="chamado.alteracaoTabela"><i class="small fa fa-database"></i> Banco de dados </span><span class="text-muted" ng-show="chamado.alteracaoArquitetura"><i class="small fa fa-cubes"></i> Arquitetura </span><small><span ng-repeat="agrupador in chamado.agrupadores track by agrupador.id" ng-if="chamado.agrupadores.length > 0"><a ui-sref="agrupador.edit({id:agrupador.id})" title="{{agrupador.nome}}" class="text-success"><i class="fa fa-code-fork"></i> Agrup. {{agrupador.nome | limitTo: 20 }}{{agrupador.nome.length > 20 ? \'...\' : \'\'}}</a></span></small></td><td class="text-center vertical-align {{ vm.chamadosPorSistema[vm.sistema.id].chamados.indexOf(chamado) > -1 ? \'text-navy\' : \'text-muted\'}}" has-authority="ROLE_SOLICITAR_RELEASE"><i class="fa fa-circle-o fa-2x" ng-click="vm.alocar(chamado)" ng-show=" vm.release.chamados.indexOf(chamado) < 0"></i> <i class="fa fa-check-circle-o fa-2x" ng-click="vm.desalocar(chamado)" ng-show=" vm.release.chamados.indexOf(chamado) > -1"></i></td></tr></tbody></table><table class="table"><tr><td><button type="button" class="btn btn-default btn-block" has-authority="ROLE_SOLICITAR_RELEASE" ng-click="vm.sistema =null"><i class="fa fa-times"></i> Cancelar</button></td><td><button type="button" class="btn btn-success btn-block" has-authority="ROLE_SOLICITAR_RELEASE" ng-if=" vm.chamadosPorSistema[vm.sistema.id].chamados.length > 0" ng-click="vm.solicitar()"><i class="fa fa-check-square-o"></i> Solicitar Release</button></td></tr></table></div></div></div></div><div class="col-md-12 m-t-md"><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-md-12"><div class="forum-item"><div class="row"><div class="col-md-12"><div class="forum-icon"><i class="fa fa-code-fork"></i></div><a class="forum-item-title">Releases Anteriores</a><div class="forum-sub-title">Abaixo s\xE3o listados todas as Releases anteriores</div></div></div></div><table class="jh-table table table-striped"><tbody><tr ng-repeat="release in vm.releases track by release.id"><td class="issue-info"><a ui-sref="release-detail({id:release.id})"><span class="font-bold">V.{{release.versao}}</span> &ensp; <span data-translate="{{\'chamadosApp.TipoRelease.\' + release.tipo}}">{{release.tipo}} </span>- {{release.sistema.nome}} </a><small>Solicitado em {{release.solicitacao | date:\'mediumDate\'}} por <span class="text-success">{{release.solicitante.firstName}}</span> <span ng-show="release.liberacao">&ensp; Aprovado em {{release.liberacao | date:\'mediumDate\'}} por <span class="text-success">{{release.responsavel.firstName}}</span></span></small></td><td class="text-right"><span class="label label-primary" data-translate="{{\'chamadosApp.SituacaoRelease.\' + release.situacao}}">{{release.situacao}}</span></td></tr></tbody></table></div><div class="col-md-12"><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div>');
$templateCache.put('app/account/activate/activate.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="activate.title">Activation</h1><div class="alert alert-success" ng-show="vm.success" data-translate="activate.messages.success" translate-compile><strong>Your user has been activated.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="activate.messages.error"><strong>Your user could not be activated.</strong> Please use the registration form to sign up.</div></div></div></div>');
$templateCache.put('app/account/login/login.html','<div class="animated fadeInDown" style="margin-top: 5%"><div class="col-md-2 col-sm-6 hidden-xs no-padding col-md-offset-2" id="box-logo"><div class="widget blue-bg p-xl text-center" style="border-bottom-right-radius: 0; border-top-right-radius: 0"><div class="row"><div class="col-md-12 m-t-xl"><img alt="image" style="max-width: 60%" class="img-rounded" src="content/images/arquivologo.png"></div><div class="col-md-12 m-t-xl"><h1 class="m-t-md">WebDesk</h1><h4>Webpublico \xA9</h4></div><div class="col-md-12 m-t-xl"><p class="m-t-md text-white">Helpdesk e Taskboad, tudo em um s\xF3 lugar :)</p></div></div></div></div><div class="col-md-6 col-sm-6 col-xs-12 no-margins no-padding" id="box-login"><div class="widget white-bg p-xl text-center" style="border-bottom-left-radius: 0; border-top-left-radius: 0"><div class="row"><div class="col-md-8 col-md-offset-2 col-sm-12"><h1 class="m-t-lg">Bem-vindo(a)</h1><h3>Fa\xE7a o login para acessar sua conta.</h3><div class="m-t-xl"><form class="form" role="form" ng-submit="vm.login($event)"><div class="form-group"><input type="text" class="form-control" id="username" placeholder="Usu\xE1rio" ng-model="vm.username"></div><div class="form-group"><input type="password" class="form-control" id="password" placeholder="Senha" ng-model="vm.password"></div><button type="submit" class="btn btn-info block full-width m-b m-t-xl">Entrar</button></form><div class="form-group text-center m-t-md"><span class="text-small text-muted">Ainda n\xE3o tem acesso?</span> <a class="btn btn-success btn-block m-t-md" href="#" ng-click="vm.register()">Solicitar Acesso</a></div><div class="form-group text-center m-t-md"><a href="#" ng-click="vm.requestResetPassword()"><small>Esqueceu a senha?</small></a></div><p class="m-t"><small>Essa aplica\xE7\xE3o faz parte do conjuto de plataformas do Webpublico \xA9 2011 - {{vm.ano}}</small></p></div></div></div></div></div></div>');
$templateCache.put('app/account/password/password.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h2 data-translate="password.title" translate-values="{username: \'{{vm.account.login}}\'}">Password for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="password.messages.success"><strong>Password changed!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="password.messages.error"><strong>An error has occurred!</strong> The password could not be changed.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form name="form" role="form" novalidate ng-submit="vm.changePassword()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="password.form.button">Save</button></form></div></div></div>');
$templateCache.put('app/account/register/register.html','<div class="col-md-12"><div class="col-md-6 col-md-offset-3"><div class="ibox float-e-margins"><div class="ibox-title text-center"><h5>Solicita\xE7\xE3o de Acesso</h5></div><div class="ibox-content"><div class="row"><div class="col-md-12"><div class="alert alert-success" ng-show="vm.success"><strong>Solicita\xE7\xE3o efetuada!</strong> Assim que sua solicita\xE7\xE3o de acesso for aprovada voc\xEA ser\xE1 notificada no e-mail que cadastrou.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><div class="alert alert-danger" ng-show="vm.errorUserExists" data-translate="register.messages.error.userexists"><strong>Login name already registered!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.errorEmailExists" data-translate="register.messages.error.emailexists"><strong>E-mail is already in use!</strong> Please choose another one.</div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.register()" show-validation><div class="form-group"><label class="control-label" for="login">Login</label><input type="text" class="form-control" id="login" name="login" ng-model="vm.registerAccount.login" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/" required><div ng-show="form.login.$dirty && form.login.$invalid"><p class="help-block" ng-show="form.login.$error.required" data-translate="register.messages.validate.login.required">Your username is required.</p><p class="help-block" ng-show="form.login.$error.minlength" data-translate="register.messages.validate.login.minlength">Your username is required to be at least 1 character.</p><p class="help-block" ng-show="form.login.$error.maxlength" data-translate="register.messages.validate.login.maxlength">Your username cannot be longer than 50 characters.</p><p class="help-block" ng-show="form.login.$error.pattern" data-translate="register.messages.validate.login.pattern">Your username can only contain lower-case letters and digits.</p></div></div><div class="form-group"><label class="control-label" for="email">e-Mail</label><input type="email" class="form-control" id="email" name="email" ng-model="vm.registerAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" for="password">Senha</label><input type="password" class="form-control" id="password" name="password" ng-model="vm.registerAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.registerAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword">Confirme a Senha</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your confirmation password is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your confirmation password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your confirmation password cannot be longer than 50 characters.</p></div></div><div class="form-group"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary btn-block">Solicitar Acesso</button></div></form></div></div></div></div></div></div>');
$templateCache.put('app/account/redmine/redmine.html','<div class="row m-t-lg"><div class="col-lg-12"><div class="ibox"><div class="ibox-title"><span>Configura\xE7\xE3o de Usu\xE1rio do GIT</span></div><div class="ibox-content"><div class="row"><div class="col-md-8 col-md-offset-2"><form name="formGit" role="form" novalidate ng-submit="vm.saveGit()" show-validation><div class="form-group col-md-12"><label class="control-label" for="firstNameGit">Nome de Usu\xE1rio do Git</label><input type="text" class="form-control" id="firstNameGit" name="firstNameGit" ng-model="vm.redmineAccount.usuarioGit" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="formGit.firstNameGit.$dirty && formGit.firstName.$invalid"><p class="help-block" ng-show="formGit.firstNameGit.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="formGit.firstNameGit.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="formGit.firstNameGit.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group col-md-12"><label class="control-label" for="passwordGit">Password do Git</label><input type="password" class="form-control" id="passwordGit" name="passwordGit" ng-model="vm.redmineAccount.senhaGit" ng-minlength="4" ng-maxlength="50" required><div ng-show="formGit.passwordGit.$dirty && form.passwordGit.$invalid"><p class="help-block" ng-show="formGit.passwordGit.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="formGit.passwordGit.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="formGit.passwordGit.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div></div><div class="form-group col-md-12"><button type="submit" ng-disabled="formGit.$invalid" class="btn btn-primary" data-translate="settings.form.button">Save</button></div></form></div></div></div></div></div></div>');
$templateCache.put('app/account/sessions/sessions.html','<div><h2 data-translate="sessions.title" translate-values="{username: \'{{vm.account.login}}\'}">Active sessions for [<b>{{vm.account.login}}</b>]</h2><div class="alert alert-success" ng-show="vm.success" data-translate="sessions.messages.success"><strong>Session invalidated!</strong></div><div class="alert alert-danger" ng-show="vm.error" data-translate="sessions.messages.error"><strong>An error has occured!</strong> The session could not be invalidated.</div><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="sessions.table.ipaddress">IP Address</th><th data-translate="sessions.table.useragent">User agent</th><th data-translate="sessions.table.date">Date</th><th></th></tr></thead><tbody><tr ng-repeat="session in vm.sessions"><td>{{session.ipAddress}}</td><td>{{session.userAgent}}</td><td>{{session.tokenDate | date:\'longDate\'}}</td><td><button type="submit" class="btn btn-primary" ng-click="vm.invalidate(session.series)" data-translate="sessions.table.button">Invalidate</button></td></tr></tbody></table></div></div>');
$templateCache.put('app/account/settings/settings.html','<div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title"><span data-translate="settings.title" translate-values="{username: \'{{vm.settingsAccount.login}}\'}">User settings for [<b>{{vm.settingsAccount.login}}</b>]</span></div><div class="ibox-content"><div class="row"><div class="col-md-4"><div class="form-group col-md-12 text-center" ng-show="vm.picFile && !vm.trocarImagem"><img ng-src="{{vm.croppedDataUrl}}" class="img-circle"><br><button type="button" class="btn btn-default m-t-md" ng-click="vm.trocarImagem =true"><i class="fa fa-refresh"></i> Trocar Imagem</button></div><div ng-show="vm.trocarImagem || !vm.picFile"><div class="form-group col-md-12"><button ngf-select class="btn btn-primary btn-block" ng-model="vm.picFile" accept="image/*"><i class="fa fa-upload"></i> Selecione uma imagem para seu perfil</button></div><div class="form-group col-md-12 text-center" ng-show="vm.picFile"><label>Voc\xEA pode ajustar sua imagem</label><br><div ngf-drop ng-model="vm.picFile" ngf-pattern="image/*" class="cropArea"><img-crop image="vm.picFile | ngfDataUrl" result-image="vm.croppedDataUrl" ng-init="vm.croppedDataUrl=\'\'"></img-crop></div></div><div class="form-group col-md-12 text-center" ng-show="vm.picFile"><label>Resultado final</label><br><img ng-src="{{vm.croppedDataUrl}}" class="img-circle"></div></div></div><div class="col-md-8"><div class="alert alert-success" ng-show="vm.success" data-translate="settings.messages.success"><strong>Settings saved!</strong></div><jhi-alert-error></jhi-alert-error><form name="form" role="form" novalidate ng-submit="vm.save()" show-validation><div class="form-group col-md-6"><label class="control-label" for="firstName" data-translate="settings.form.firstname">First Name</label><input type="text" class="form-control" id="firstName" name="firstName" placeholder="{{\'settings.form.firstname.placeholder\' | translate}}" ng-model="vm.settingsAccount.firstName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.firstName.$dirty && form.firstName.$invalid"><p class="help-block" ng-show="form.firstName.$error.required" data-translate="settings.messages.validate.firstname.required">Your first name is required.</p><p class="help-block" ng-show="form.firstName.$error.minlength" data-translate="settings.messages.validate.firstname.minlength">Your first name is required to be at least 1 character.</p><p class="help-block" ng-show="form.firstName.$error.maxlength" data-translate="settings.messages.validate.firstname.maxlength">Your first name cannot be longer than 50 characters.</p></div></div><div class="form-group col-md-6"><label class="control-label" for="lastName" data-translate="settings.form.lastname">Last Name</label><input type="text" class="form-control" id="lastName" name="lastName" placeholder="{{\'settings.form.lastname.placeholder\' | translate}}" ng-model="vm.settingsAccount.lastName" ng-minlength="1" ng-maxlength="50" required maxlength="50"><div ng-show="form.lastName.$dirty && form.lastName.$invalid"><p class="help-block" ng-show="form.lastName.$error.required" data-translate="settings.messages.validate.lastname.required">Your last name is required.</p><p class="help-block" ng-show="form.lastName.$error.minlength" data-translate="settings.messages.validate.lastname.minlength">Your last name is required to be at least 1 character.</p><p class="help-block" ng-show="form.lastName.$error.maxlength" data-translate="settings.messages.validate.lastname.maxlength">Your last name cannot be longer than 50 characters.</p></div></div><div class="form-group col-md-12"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.settingsAccount.email" ng-minlength="5" ng-maxlength="100" required maxlength="100"><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><div class="form-group col-md-12"><label for="langKey" data-translate="settings.form.language">Language</label><select id="langKey" name="langKey" class="form-control" ng-model="vm.settingsAccount.langKey" ng-controller="JhiLanguageController as languageVm" ng-options="code as (code | findLanguageFromKey) for code in languageVm.languages"></select></div><div class="form-group col-md-12"><div class="panel panel-default"><div class="panel-heading"><label>Notifica\xE7\xF5es</label></div><div class="panel-body"><table class="table"><tr class="{{vm.settingsAccount.notificacoes.indexOf(notificacao) > -1 ? \'success\':\'\'}}" ng-repeat="notificacao in vm.notificacoes track by $index"><td><i class="fa fa-circle-o" ng-click="vm.settingsAccount.notificacoes.push(notificacao)" ng-show="vm.settingsAccount.notificacoes.indexOf(notificacao) < 0"></i> <i class="fa fa-check-circle-o" ng-click="vm.settingsAccount.notificacoes.splice(vm.settingsAccount.notificacoes.indexOf(notificacao),1)" ng-show="vm.settingsAccount.notificacoes.indexOf(notificacao) > -1"></i></td><td>{{notificacao}}</td></tr></table></div></div></div><div class="form-group col-md-12"><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary btn-block"><i class="fa fa-save"></i> Salvar</button></div></form><div class="form-group col-md-12 m-t-lg"><div class="panel panel-default"><div class="panel-heading"><label data-translate="global.menu.account.apiTokens">Tokens de API</label></div><div class="panel-body"><p class="text-muted" data-translate="apiTokens.description">Gere tokens pessoais para integra\xE7\xF5es externas (por exemplo, MCP no Cursor). Cada token s\xF3 \xE9 exibido uma vez na cria\xE7\xE3o.</p><div class="alert alert-success" ng-show="vm.tokenSuccess === \'REVOKED\'" data-translate="apiTokens.messages.revoked"><strong>Token revogado com sucesso!</strong></div><div class="alert alert-danger" ng-show="vm.tokenError === \'CREATE\'" data-translate="apiTokens.messages.createError"><strong>Ocorreu um erro!</strong> O token n\xE3o p\xF4de ser gerado.</div><div class="alert alert-danger" ng-show="vm.tokenError === \'REVOKE\'" data-translate="apiTokens.messages.revokeError"><strong>Ocorreu um erro!</strong> O token n\xE3o p\xF4de ser revogado.</div><div class="alert alert-warning" ng-show="vm.createdToken"><h4 data-translate="apiTokens.messages.createdTitle"><strong>Token gerado \u2014 copie agora!</strong></h4><p data-translate="apiTokens.messages.createdWarning">Este valor <strong>n\xE3o ser\xE1 exibido novamente</strong>. Guarde-o em local seguro (por exemplo, vari\xE1vel de ambiente <code>CHAMADOS_API_TOKEN</code>).</p><div class="input-group"><input type="text" class="form-control" id="created-api-token" readonly="readonly" ng-model="vm.createdToken" onclick="this.select()"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.copyToken()" data-translate="apiTokens.form.copy">Copiar</button></span></div><p class="help-block m-t-sm" ng-show="vm.copied" data-translate="apiTokens.messages.copied">Token copiado para a \xE1rea de transfer\xEAncia.</p></div><form name="tokenForm" role="form" novalidate ng-submit="vm.createToken()" show-validation><div class="form-group"><label class="control-label" for="tokenName" data-translate="apiTokens.form.name">Nome</label><input type="text" class="form-control" id="tokenName" name="tokenName" placeholder="{{\'apiTokens.form.name.placeholder\' | translate}}" ng-model="vm.newTokenName" ng-minlength="1" ng-maxlength="100" required maxlength="100"><div ng-show="tokenForm.tokenName.$dirty && tokenForm.tokenName.$invalid"><p class="help-block" ng-show="tokenForm.tokenName.$error.required" data-translate="apiTokens.messages.validate.name.required">O nome \xE9 obrigat\xF3rio.</p><p class="help-block" ng-show="tokenForm.tokenName.$error.maxlength" data-translate="apiTokens.messages.validate.name.maxlength">O nome n\xE3o pode ter mais de 100 caracteres.</p></div></div><button type="submit" ng-disabled="tokenForm.$invalid" class="btn btn-primary" data-translate="apiTokens.form.button">Gerar</button></form><div class="table-responsive m-t-md"><table class="table table-striped"><thead><tr><th data-translate="apiTokens.table.name">Nome</th><th data-translate="apiTokens.table.prefix">Prefixo</th><th data-translate="apiTokens.table.created">Criado em</th><th data-translate="apiTokens.table.lastUsed">\xDAltimo uso</th><th></th></tr></thead><tbody><tr ng-repeat="token in vm.tokens"><td>{{token.name}}</td><td><code>{{token.tokenPrefix}}</code></td><td>{{token.createdDate | date:\'medium\'}}</td><td><span ng-if="token.lastUsedDate">{{token.lastUsedDate | date:\'medium\'}}</span> <span ng-if="!token.lastUsedDate" class="text-muted" data-translate="apiTokens.table.neverUsed">Nunca usado</span></td><td><button type="button" class="btn btn-danger btn-sm" ng-click="vm.revokeToken(token.id)" data-translate="apiTokens.table.revoke">Revogar</button></td></tr><tr ng-if="!vm.tokens.length"><td colspan="5" class="text-muted text-center" data-translate="apiTokens.table.empty">Nenhum token cadastrado.</td></tr></tbody></table></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/account/social/social-register.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 ng-show="success" data-translate="social.register.title" translate-values="{ label: vm.providerLabel }">Registration with</h1><h1 ng-show="error" data-translate="social.register.errorTitle">Registration</h1><div class="alert alert-success" ng-show="vm.success" data-translate="social.register.messages.success"><strong>Registration saved!</strong> Please check your email for confirmation.</div><div class="alert alert-danger" ng-show="vm.error" data-translate="social.register.messages.error.fail"><strong>Registration failed!</strong> Please try again later.</div><jh-social ng-if="vm.success" ng-provider="{{ vm.provider }}"></jh-social><br><div class="alert alert-warning" data-translate="global.messages.info.authenticated">If you want to <a class="alert-link" href="#/login">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div></div></div></div>');
$templateCache.put('app/admin/acao/acao-edit.html','<form name="editForm" ng-submit="vm.save()" role="form" novalidate><div class="ibox"><div class="ibox-title"><h2><h2>Inserir/Alterar A\xE7\xE3o</h2></h2></div><div class="ibox-content"><div class="row"><div class="form-group col-md-12" style="text-align: right"><td><span class="label {{vm.acao.situacaoAcao == \'FINALIZADA\' ? \'label-primary\' : \'label-warning\'}} m-r-sm">{{\'chamadosApp.SituacaoAcao.\' + vm.acao.situacaoAcao | translate}}</span></td></div></div><div class="row"><div class="form-group col-md-4"><label for="field_usuarios">Usu\xE1rios</label><select class="form-control" id="field_usuarios" name="usuario" required ng-model="vm.acao.user" ng-options="user as user.firstName || user.login for user in vm.users | orderBy: \'firstName\'"><option value=""></option></select><div ng-show="editForm.usuario.$invalid"><p class="help-block" ng-show="editForm.usuario.$error.required">O campo \xE9 obrigat\xF3rio.</p></div></div><div class="form-group col-md-3"><label class="control-label">Chamado/Tarefa/Ata</label><div class="input-group"><input type="number" class="form-control" ng-model="vm.numeroBusca" ng-blur="vm.buscarChamadoOrTarefa()" placeholder="Digite o n\xFAmero"> <span class="input-group-btn"><button class="btn btn-success" ng-click="vm.buscarChamadoOrTarefa()" type="button"><i class="fa fa-search"></i></button></span></div></div><div class="form-group col-md-5"><label class="control-label">T\xEDtulo do Chamado/Tarefa/Ata</label><label class="form-control font-noraml">{{vm.acao.chamado ? vm.acao.chamado.titulo : vm.acao.solicitacaoDesenvolvimento? vm.acao.solicitacaoDesenvolvimento.titulo : vm.acao.ata.titulo}}</label></div></div><div class="row"><div class="form-group col-md-12"><label class="control-label" for="titulo">T\xEDtulo da A\xE7\xE3o</label><input type="text" class="form-control" id="titulo" name="titulo" required ng-model="vm.acao.titulo"><div ng-show="editForm.titulo.$invalid"><p class="help-block" ng-show="editForm.titulo.$error.required">O campo \xE9 obrigat\xF3rio.</p></div></div></div><div class="row"><div class="form-group col-md-12"><label class="control-label" for="descricao">Descri\xE7\xE3o da A\xE7\xE3o</label><textarea type="text" class="form-control" name="descricao" id="descricao" rows="10" style="overflow: auto" ng-model="vm.acao.descricao" required ng-minlength="2"> </textarea><div ng-show="editForm.descricao.$invalid"><p class="help-block" ng-show="editForm.descricao.$error.required">O campo \xE9 obrigat\xF3rio.</p></div></div></div></div><div class="ibox-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span> <span>&nbsp;Salvar</span></button> <button type="button" class="btn btn-default" ui-sref="acao"><span class="glyphicon glyphicon-ban-circle"></span> <span>&nbsp;Cancelar</span></button></div></div></form>');
$templateCache.put('app/admin/acao/acao-justificativa-dialog.html','<div class="modal-header"><small class="chat-date pull-right" ng-click="vm.clear()">x</small><h4>A\xE7\xF5es para serem justificadas</h4></div><div class="modal-body"><div class="form-group" style="max-height: 400px; overflow-x: auto"><div class="ibox-content" ng-repeat="acao in vm.acoes"><div class="row"><div class="col-md-12"><label class="control-label">Chamado/Tarefa:</label><label class="font-noraml">{{acao.chamado ? acao.chamado.id : acao.solicitacaoDesenvolvimento.numero}}</label></div><div class="col-md-12"><label class="control-label">T\xEDtulo do Chamado/Tarefa:</label><label class="font-noraml">{{acao.chamado ? acao.chamado.titulo : acao.solicitacaoDesenvolvimento.titulo}}</label></div><div class="col-md-12"><label class="control-label">T\xEDtulo da A\xE7\xE3o:</label><label class="font-noraml">{{acao.titulo}}</label></div><div class="col-md-12"><label class="control-label">Descri\xE7\xE3o da A\xE7\xE3o:</label><label class="font-noraml">{{acao.descricao}}</label></div><div class="col-md-12"><label class="control-label">Justifique:</label><textarea type="text" class="form-control" name="descricao" id="descricao" rows="10" style="overflow: auto" ng-model="acao.justificativa" required ng-minlength="2"></textarea></div><div class="col-md-12 m-t-sm"><button type="button" ng-disabled="!acao.justificativa" ng-click="vm.justificar(acao)" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span> <span>&nbsp;Enviar</span></button></div></div></div></div></div>');
$templateCache.put('app/admin/acao/acao.html','<div class="ibox"><div class="ibox-title"><h2><h2>A\xE7\xF5es</h2></h2></div><div class="ibox-content"><div class="row"><div class="col-md-8"><search-box ng-model="vm.filtro" search-method="vm.loadAll()"></search-box></div><div class="col-md-2"><button class="btn btn-primary" ui-sref="acao.new"><span class="glyphicon glyphicon-plus"></span> <span>Nova A\xE7\xE3o</span></button></div><br><div class="col-md-12"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th><span>Chamado/Ticket/Ata</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="user"><span>Usu\xE1rio</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="titulo"><span>T\xEDtulo</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span>Descri\xE7\xE3o</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="justificativa"><span>Justificativa</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="situacaoAcao"><span>Situa\xE7\xE3o</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="criadoEm"><span>Data</span><span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="acao in vm.acoes track by acao.id"><td>{{acao.chamado ? acao.chamado.id : acao.solicitacaoDesenvolvimento ? acao.solicitacaoDesenvolvimento.numero : acao.ata.numero}}</td><td>{{acao.user.firstName}}</td><td>{{acao.titulo}}</td><td>{{acao.descricao}}</td><td>{{acao.justificativa}}</td><td><span class="label {{acao.situacaoAcao == \'FINALIZADA\' ? \'label-primary\' : \'label-warning\'}} m-r-sm">{{\'chamadosApp.SituacaoAcao.\' + acao.situacaoAcao | translate}}</span></td><td>{{acao.criadoEm | date:\'dd/MM/yyyy\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="acao.edit({id:acao.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" ng-click="vm.remover(acao.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/admin/audits/audits.html','<div><h2 data-translate="audits.title">Audits</h2><div class="row"><div class="col-md-5"><h4 data-translate="audits.filter.title">Filter by date</h4><p class="input-group"><span class="input-group-addon" data-translate="audits.filter.from">from</span> <input type="date" class="input-sm form-control" name="start" ng-model="vm.fromDate" ng-change="vm.onChangeDate()" required> <span class="input-group-addon" data-translate="audits.filter.to">to</span> <input type="date" class="input-sm form-control" name="end" ng-model="vm.toDate" ng-change="vm.onChangeDate()" required></p></div></div><table class="table table-condensed table-striped table-bordered table-responsive"><thead><tr><th ng-click="predicate = \'timestamp\'; reverse=!reverse"><span data-translate="audits.table.header.date">Date</span></th><th ng-click="predicate = \'principal\'; reverse=!reverse"><span data-translate="audits.table.header.principal">User</span></th><th ng-click="predicate = \'type\'; reverse=!reverse"><span data-translate="audits.table.header.status">State</span></th><th ng-click="predicate = \'data.message\'; reverse=!reverse"><span data-translate="audits.table.header.data">Extra data</span></th></tr></thead><tr ng-repeat="audit in vm.audits | filter:filter | orderBy:predicate:reverse" ng-hide="audit.filtered"><td><span>{{audit.timestamp| date:\'medium\'}}</span></td><td><small>{{audit.principal}}</small></td><td>{{audit.type}}</td><td><span ng-show="audit.data.message">{{audit.data.message}}</span> <span ng-show="audit.data.remoteAddress"><span data-translate="audits.table.data.remoteAddress">Remote Address</span> {{audit.data.remoteAddress}}</span></td></tr></table><div class="text-center"><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.loadPage(vm.page)"></uib-pagination></div></div>');
$templateCache.put('app/admin/configuration/configuration.html','<div><h2 data-translate="configuration.title">Configuration</h2><span data-translate="configuration.filter">Filter (by prefix)</span> <input type="text" ng-model="filter" class="form-control"><label ng-hide="filteredConfig.length == 0">Spring configuration</label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filteredConfig.length == 0"><thead><tr><th ng-click="predicate = \'prefix\'; reverse=!reverse" class="col-sm-4"><span data-translate="configuration.table.prefix">Prefix</span></th><th data-translate="configuration.table.properties" class="col-sm-8">Properties</th></tr></thead><tr ng-repeat="entry in filtered = (vm.configuration | filter:filter | orderBy:predicate:reverse)"><td><span>{{entry.prefix}}</span></td><td><div class="row" ng-repeat="(key, value) in entry.properties"><div class="col-md-4">{{key}}</div><div class="col-md-8"><span class="pull-right label label-default break">{{value}}</span></div></div></td></tr></table><div ng-repeat="(key, value) in vm.allConfiguration"><label ng-hide="filtered.length == 0"><span>{{key}}</span></label><table class="table table-condensed table-striped table-bordered table-responsive" style="table-layout:fixed" ng-hide="filtered.length == 0"><thead><tr><th class="col-sm-4">Property</th><th class="col-sm-8">Value</th></tr></thead><tbody><tr ng-repeat="item in filtered = (value | filter:filter)"><td class="break">{{item.key}}</td><td class="break"><span class="pull-right label label-default break">{{item.val}}</span></td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/docs/docs.html','<iframe src="swagger-ui/index.html" frameborder="0" marginheight="0" marginwidth="0" width="100%" height="900" scrolling="auto" target="_top" title="Swagger UI"></iframe>');
$templateCache.put('app/admin/gitlab-config/gitlab-config.html','<div><h2 data-translate="gitlabConfig.title">Configura\xE7\xE3o do GitLab</h2><p class="text-muted" data-translate="gitlabConfig.description">URL e token usados pelas integra\xE7\xF5es GitLab da aplica\xE7\xE3o.</p><div class="alert alert-info" ng-if="!vm.loading && !vm.exists" data-translate="gitlabConfig.messages.empty">Ainda n\xE3o h\xE1 configura\xE7\xE3o do GitLab. Informe a URL e o token para come\xE7ar.</div><form name="gitlabConfigForm" role="form" novalidate ng-submit="vm.save()" ng-if="!vm.loading"><div class="form-group"><label class="control-label" for="gitlabUrl" data-translate="gitlabConfig.form.url">URL</label><input type="url" class="form-control" id="gitlabUrl" name="url" ng-model="vm.config.url" placeholder="{{\'gitlabConfig.form.url.placeholder\' | translate}}" required maxlength="255"><div ng-show="gitlabConfigForm.url.$dirty && gitlabConfigForm.url.$invalid"><p class="help-block" ng-show="gitlabConfigForm.url.$error.required" data-translate="gitlabConfig.messages.validate.url.required">A URL \xE9 obrigat\xF3ria.</p></div></div><div class="form-group"><label class="control-label" for="gitlabToken" data-translate="gitlabConfig.form.token">Token</label><p class="help-block" ng-if="vm.exists && vm.maskedToken"><span data-translate="gitlabConfig.form.token.current">Token atual:</span> <code>{{vm.maskedToken}}</code></p><input type="password" class="form-control" id="gitlabToken" name="token" ng-model="vm.config.token" placeholder="{{\'gitlabConfig.form.token.placeholder\' | translate}}" autocomplete="new-password" ng-required="!vm.exists" maxlength="512"><p class="help-block" ng-if="vm.exists" data-translate="gitlabConfig.form.token.hint">Deixe em branco para manter o token atual.</p><div ng-show="gitlabConfigForm.token.$dirty && gitlabConfigForm.token.$invalid"><p class="help-block" ng-show="gitlabConfigForm.token.$error.required" data-translate="gitlabConfig.messages.validate.token.required">O token \xE9 obrigat\xF3rio na cria\xE7\xE3o.</p></div></div><button type="submit" class="btn btn-primary" ng-disabled="gitlabConfigForm.$invalid || vm.saving" data-translate="gitlabConfig.form.save">Salvar</button> <button type="button" class="btn btn-danger" ng-if="vm.exists" ng-click="vm.remove()" ng-disabled="vm.saving" data-translate="gitlabConfig.form.remove">Remover</button></form></div>');
$templateCache.put('app/admin/health/health.html','<div><h2 data-translate="health.title">Health Checks</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="health.refresh.button">Refresh</span></button></p><table id="healthCheck" class="table table-striped"><thead><tr><th class="col-md-7" data-translate="health.table.service">Service Name</th><th class="col-md-2 text-center" data-translate="health.table.status">Status</th><th class="col-md-2 text-center" data-translate="health.details.details">Details</th></tr></thead><tbody><tr ng-repeat="health in vm.healthData"><td>{{\'health.indicator.\' + vm.baseName(health.name) | translate}} {{vm.subSystemName(health.name)}}</td><td class="text-center"><span class="label" ng-class="vm.getLabelClass(health.status)">{{\'health.status.\' + health.status | translate}}</span></td><td class="text-center"><a class="hand" ng-click="vm.showHealth(health)" ng-show="health.details || health.error"><i class="glyphicon glyphicon-eye-open"></i></a></td></tr></tbody></table></div>');
$templateCache.put('app/admin/health/health.modal.html','<div class="modal-header"><button aria-label="Close" data-dismiss="modal" class="close" type="button" ng-click="vm.cancel()"><span aria-hidden="true">&times;</span></button><h4 class="modal-title" id="showHealthLabel">{{\'health.indicator.\' + vm.baseName(vm.currentHealth.name) | translate}} {{vm.subSystemName(vm.currentHealth.name)}}</h4></div><div class="modal-body pad"><div ng-show="vm.currentHealth.details"><h4 data-translate="health.details.properties">Properties</h4><table class="table table-striped"><thead><tr><th class="col-md-6 text-left" data-translate="health.details.name">Name</th><th class="col-md-6 text-left" data-translate="health.details.value">Value</th></tr></thead><tbody><tr ng-repeat="(k,v) in vm.currentHealth.details"><td class="col-md-6 text-left">{{k}}</td><td class="col-md-6 text-left">{{v}}</td></tr></tbody></table></div><div ng-show="vm.currentHealth.error"><h4 data-translate="health.details.error">Error</h4><pre>{{vm.currentHealth.error}}</pre></div></div><div class="modal-footer"><button data-dismiss="modal" class="btn btn-default pull-left" type="button" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/integracao-parceiro/integracao-parceiro.html','<div><h2 data-translate="integracaoParceiro.title">Integra\xE7\xE3o de chamados (terceiros)</h2><p class="text-muted" data-translate="integracaoParceiro.description">Cadastro de parceiros externos que recebem chamados via webhook.</p><div class="row" ng-if="!vm.loading"><div class="col-md-12"><h3 data-translate="integracaoParceiro.list.title">Parceiros cadastrados</h3><div class="alert alert-info" ng-if="!vm.parceiros.length" data-translate="integracaoParceiro.messages.empty">Nenhum parceiro cadastrado.</div><table class="table table-striped table-hover" ng-if="vm.parceiros.length"><thead><tr><th data-translate="integracaoParceiro.form.codigo">C\xF3digo</th><th data-translate="integracaoParceiro.form.nome">Nome</th><th data-translate="integracaoParceiro.form.ativo">Ativo</th><th data-translate="integracaoParceiro.form.webhookUrl">URL do webhook</th><th style="width: 100px"></th></tr></thead><tbody><tr ng-repeat="p in vm.parceiros"><td>{{p.codigo}}</td><td>{{p.nome}}</td><td><i class="fa" ng-class="p.ativo ? \'fa-check text-success\' : \'fa-times text-danger\'"></i></td><td class="small">{{p.webhookUrl}}</td><td><button type="button" class="btn btn-xs btn-primary" ng-click="vm.edit(p)" title="Editar"><i class="fa fa-pencil"></i></button> <button type="button" class="btn btn-xs btn-danger" ng-click="vm.remove(p)" title="Remover"><i class="fa fa-trash"></i></button></td></tr></tbody></table></div></div><hr ng-if="!vm.loading"><h3 ng-if="!vm.loading"><span ng-if="!vm.form.id" data-translate="integracaoParceiro.form.new">Novo parceiro</span> <span ng-if="vm.form.id" data-translate="integracaoParceiro.form.edit">Editar parceiro</span></h3><form name="integracaoParceiroForm" role="form" novalidate ng-submit="vm.save()" ng-if="!vm.loading"><div class="row"><div class="form-group col-md-4"><label class="control-label" for="codigo" data-translate="integracaoParceiro.form.codigo">C\xF3digo</label><input type="text" class="form-control" id="codigo" name="codigo" ng-model="vm.form.codigo" ng-disabled="vm.form.id" required maxlength="64" pattern="^[a-z0-9-]+$"><div ng-show="integracaoParceiroForm.codigo.$dirty && integracaoParceiroForm.codigo.$invalid"><p class="help-block" ng-show="integracaoParceiroForm.codigo.$error.required" data-translate="integracaoParceiro.messages.validate.codigo.required">O c\xF3digo \xE9 obrigat\xF3rio.</p><p class="help-block" ng-show="integracaoParceiroForm.codigo.$error.pattern" data-translate="integracaoParceiro.messages.validate.codigo.pattern">Use apenas letras min\xFAsculas, n\xFAmeros e h\xEDfen.</p></div></div><div class="form-group col-md-8"><label class="control-label" for="nome" data-translate="integracaoParceiro.form.nome">Nome</label><input type="text" class="form-control" id="nome" name="nome" ng-model="vm.form.nome" required maxlength="255"><div ng-show="integracaoParceiroForm.nome.$dirty && integracaoParceiroForm.nome.$invalid"><p class="help-block" ng-show="integracaoParceiroForm.nome.$error.required" data-translate="integracaoParceiro.messages.validate.nome.required">O nome \xE9 obrigat\xF3rio.</p></div></div></div><div class="row"><div class="form-group col-md-12"><label><input type="checkbox" ng-model="vm.form.ativo"> <span data-translate="integracaoParceiro.form.ativo">Ativo</span></label></div></div><div class="row"><div class="form-group col-md-6"><label class="control-label" for="webhookUrl" data-translate="integracaoParceiro.form.webhookUrl">URL do webhook</label><input type="url" class="form-control" id="webhookUrl" name="webhookUrl" ng-model="vm.form.webhookUrl" required maxlength="2048"><div ng-show="integracaoParceiroForm.webhookUrl.$dirty && integracaoParceiroForm.webhookUrl.$invalid"><p class="help-block" ng-show="integracaoParceiroForm.webhookUrl.$error.required" data-translate="integracaoParceiro.messages.validate.webhookUrl.required">A URL do webhook \xE9 obrigat\xF3ria.</p></div></div><div class="form-group col-md-6"><label class="control-label" for="webhookToken" data-translate="integracaoParceiro.form.webhookToken">Segredo HMAC (JWT HS256)</label><p class="help-block" ng-if="vm.form.id && vm.form.webhookTokenMasked"><span data-translate="integracaoParceiro.form.webhookToken.current">Segredo atual:</span> <code>{{vm.form.webhookTokenMasked}}</code></p><input type="password" class="form-control" id="webhookToken" name="webhookToken" ng-model="vm.form.webhookToken" ng-attr-placeholder="{{vm.form.id ? (\'integracaoParceiro.form.webhookToken.placeholder.edit\' | translate) : (\'integracaoParceiro.form.webhookToken.placeholder.create\' | translate)}}" autocomplete="new-password" ng-required="!vm.form.id" maxlength="512"><p class="help-block" ng-if="vm.form.id" data-translate="integracaoParceiro.form.webhookToken.hint">Deixe em branco para manter o token atual.</p><div ng-show="integracaoParceiroForm.webhookToken.$dirty && integracaoParceiroForm.webhookToken.$invalid"><p class="help-block" ng-show="integracaoParceiroForm.webhookToken.$error.required" data-translate="integracaoParceiro.messages.validate.webhookToken.required">O token \xE9 obrigat\xF3rio na cria\xE7\xE3o.</p></div></div></div><div class="row"><div class="form-group col-md-3"><label class="control-label" for="clienteId" data-translate="integracaoParceiro.form.cliente">Cliente</label><select class="form-control" id="clienteId" name="clienteId" ng-model="vm.form.clienteId" ng-options="c.id as c.nome for c in vm.clientes" required><option value=""></option></select><div ng-show="integracaoParceiroForm.clienteId.$dirty && integracaoParceiroForm.clienteId.$invalid"><p class="help-block" ng-show="integracaoParceiroForm.clienteId.$error.required" data-translate="integracaoParceiro.messages.validate.cliente.required">O cliente \xE9 obrigat\xF3rio.</p></div></div><div class="form-group col-md-3"><label class="control-label" for="sistemaId" data-translate="integracaoParceiro.form.sistema">Sistema</label><select class="form-control" id="sistemaId" name="sistemaId" ng-model="vm.form.sistemaId" ng-options="s.id as s.nome for s in vm.sistemas" required><option value=""></option></select><div ng-show="integracaoParceiroForm.sistemaId.$dirty && integracaoParceiroForm.sistemaId.$invalid"><p class="help-block" ng-show="integracaoParceiroForm.sistemaId.$error.required" data-translate="integracaoParceiro.messages.validate.sistema.required">O sistema \xE9 obrigat\xF3rio.</p></div></div><div class="form-group col-md-3"><label class="control-label" for="moduloId" data-translate="integracaoParceiro.form.modulo">M\xF3dulo</label><select class="form-control" id="moduloId" name="moduloId" ng-model="vm.form.moduloId" ng-change="vm.onModuloChange()" ng-options="m.id as m.descricao for m in vm.modulos" required><option value=""></option></select><div ng-show="integracaoParceiroForm.moduloId.$dirty && integracaoParceiroForm.moduloId.$invalid"><p class="help-block" ng-show="integracaoParceiroForm.moduloId.$error.required" data-translate="integracaoParceiro.messages.validate.modulo.required">O m\xF3dulo \xE9 obrigat\xF3rio.</p></div></div><div class="form-group col-md-3"><label class="control-label" for="subModuloId" data-translate="integracaoParceiro.form.subModulo">Subm\xF3dulo</label><select class="form-control" id="subModuloId" name="subModuloId" ng-model="vm.form.subModuloId" ng-options="sm.id as sm.descricao for sm in vm.subModulosDoModulo()" ng-disabled="!vm.form.moduloId" required><option value=""></option></select><div ng-show="integracaoParceiroForm.subModuloId.$dirty && integracaoParceiroForm.subModuloId.$invalid"><p class="help-block" ng-show="integracaoParceiroForm.subModuloId.$error.required" data-translate="integracaoParceiro.messages.validate.subModulo.required">O subm\xF3dulo \xE9 obrigat\xF3rio.</p></div></div><div class="form-group col-md-3"><label class="control-label" for="solicitanteId" data-translate="integracaoParceiro.form.solicitante">Solicitante</label><select class="form-control" id="solicitanteId" name="solicitanteId" ng-model="vm.form.solicitanteId" ng-options="u.id as ((u.firstName || \'\') + \' \' + (u.lastName || \'\') + \' (\' + u.login + \')\') for u in vm.usuarios" required><option value=""></option></select><div ng-show="integracaoParceiroForm.solicitanteId.$dirty && integracaoParceiroForm.solicitanteId.$invalid"><p class="help-block" ng-show="integracaoParceiroForm.solicitanteId.$error.required" data-translate="integracaoParceiro.messages.validate.solicitante.required">O solicitante \xE9 obrigat\xF3rio.</p></div></div></div><div class="row"><div class="form-group col-md-6"><label class="control-label" for="tipoChamado" data-translate="integracaoParceiro.form.tipoChamado">Tipo do chamado</label><select class="form-control" id="tipoChamado" name="tipoChamado" ng-model="vm.form.tipoChamado" required><option value="SUPORTE" data-translate="chamadosApp.TipoChamado.SUPORTE">Suporte/Ajuda</option><option value="BUG" data-translate="chamadosApp.TipoChamado.BUG">Bug</option><option value="MELHORIA" data-translate="chamadosApp.TipoChamado.MELHORIA">Melhoria</option><option value="NOVA_FUNCIONALIDADE" data-translate="chamadosApp.TipoChamado.NOVA_FUNCIONALIDADE">N. Funcionalidade</option><option value="ATA" data-translate="chamadosApp.TipoChamado.ATA">Ata</option></select><div ng-show="integracaoParceiroForm.tipoChamado.$dirty && integracaoParceiroForm.tipoChamado.$invalid"><p class="help-block" ng-show="integracaoParceiroForm.tipoChamado.$error.required" data-translate="integracaoParceiro.messages.validate.tipoChamado.required">O tipo do chamado \xE9 obrigat\xF3rio.</p></div></div><div class="form-group col-md-6"><label class="control-label" for="severidade" data-translate="integracaoParceiro.form.severidade">Severidade</label><select class="form-control" id="severidade" name="severidade" ng-model="vm.form.severidade" required><option ng-repeat="sev in vm.severidades" value="{{sev}}" data-translate="{{\'chamadosApp.Severidade.\' + sev}}">{{sev}}</option></select><div ng-show="integracaoParceiroForm.severidade.$dirty && integracaoParceiroForm.severidade.$invalid"><p class="help-block" ng-show="integracaoParceiroForm.severidade.$error.required" data-translate="integracaoParceiro.messages.validate.severidade.required">A severidade \xE9 obrigat\xF3ria.</p></div></div></div><button type="submit" class="btn btn-primary" ng-disabled="integracaoParceiroForm.$invalid || vm.saving" data-translate="integracaoParceiro.form.save">Salvar</button> <button type="button" class="btn btn-default" ng-click="vm.resetForm()" ng-disabled="vm.saving" data-translate="integracaoParceiro.form.cancel">Cancelar</button></form></div>');
$templateCache.put('app/admin/logs/logs.html','<div class="table-responsive"><h2 data-translate="logs.title">Logs</h2><p data-translate="logs.nbloggers" translate-values="{total: \'{{ vm.loggers.length }}\'}">There are {{ vm.loggers.length }} loggers.</p><span data-translate="logs.filter">Filter</span> <input type="text" ng-model="filter" class="form-control"><table class="table table-condensed table-striped table-bordered"><thead><tr title="click to order"><th ng-click="predicate = \'name\'; reverse=!reverse"><span data-translate="logs.table.name">Name</span></th><th ng-click="predicate = \'level\'; reverse=!reverse"><span data-translate="logs.table.level">Level</span></th></tr></thead><tr ng-repeat="logger in vm.loggers | filter:filter | orderBy:predicate:reverse"><td><small>{{logger.name | characters:140}}</small></td><td><button ng-click="vm.changeLevel(logger.name, \'TRACE\')" ng-class="(logger.level==\'TRACE\') ? \'btn-danger\' : \'btn-default\'" class="btn btn-default btn-xs">TRACE</button> <button ng-click="vm.changeLevel(logger.name, \'DEBUG\')" ng-class="(logger.level==\'DEBUG\') ? \'btn-warning\' : \'btn-default\'" class="btn btn-default btn-xs">DEBUG</button> <button ng-click="vm.changeLevel(logger.name, \'INFO\')" ng-class="(logger.level==\'INFO\') ? \'btn-info\' : \'btn-default\'" class="btn btn-default btn-xs">INFO</button> <button ng-click="vm.changeLevel(logger.name, \'WARN\')" ng-class="(logger.level==\'WARN\') ? \'btn-success\' : \'btn-default\'" class="btn btn-default btn-xs">WARN</button> <button ng-click="vm.changeLevel(logger.name, \'ERROR\')" ng-class="(logger.level==\'ERROR\') ? \'btn-primary\' : \'btn-default\'" class="btn btn-default btn-xs">ERROR</button></td></tr></table></div>');
$templateCache.put('app/admin/metrics/metrics.html','<div><h2 data-translate="metrics.title">Application Metrics</h2><p><button type="button" class="btn btn-primary" ng-click="vm.refresh()"><span class="glyphicon glyphicon-refresh"></span>&nbsp;<span data-translate="metrics.refresh.button">Refresh</span></button></p><h3 data-translate="metrics.jvm.title">JVM Metrics</h3><div class="row" ng-hide="vm.updatingMetrics"><div class="col-md-4"><b data-translate="metrics.jvm.memory.title">Memory</b><p><span data-translate="metrics.jvm.memory.total">Total Memory</span> ({{vm.metrics.gauges[\'jvm.memory.total.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.total.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.total.max\'].value" value="vm.metrics.gauges[\'jvm.memory.total.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.total.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.total.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.heap">Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.heap.max\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.heap.max\'].value" value="vm.metrics.gauges[\'jvm.memory.heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.heap.max\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.memory.nonheap">Non-Heap Memory</span> ({{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value / 1000000 | number:0}}M / {{vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value / 1000000 | number:0}}M)</p><uib-progressbar min="0" max="vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value" value="vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.memory.non-heap.used\'].value * 100 / vm.metrics.gauges[\'jvm.memory.non-heap.committed\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.threads.title">Threads</b> (Total: {{vm.metrics.gauges[\'jvm.threads.count\'].value}}) <a class="hand" ng-click="vm.refreshThreadDumpData()" data-toggle="modal" data-target="#threadDump"><i class="glyphicon glyphicon-eye-open"></i></a><p><span data-translate="metrics.jvm.threads.runnable">Runnable</span> {{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value}}</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.runnable.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.runnable.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.timedwaiting">Timed Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.timed_waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.waiting">Waiting</span> ({{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.waiting.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="warning"><span>{{vm.metrics.gauges[\'jvm.threads.waiting.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar><p><span data-translate="metrics.jvm.threads.blocked">Blocked</span> ({{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value}})</p><uib-progressbar min="0" value="vm.metrics.gauges[\'jvm.threads.blocked.count\'].value" max="vm.metrics.gauges[\'jvm.threads.count\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'jvm.threads.blocked.count\'].value * 100 / vm.metrics.gauges[\'jvm.threads.count\'].value | number:0}}%</span></uib-progressbar></div><div class="col-md-4"><b data-translate="metrics.jvm.gc.title">Garbage collections</b><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweepcount">Mark Sweep count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.marksweeptime">Mark Sweep time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-MarkSweep.time\'].value}}ms</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengecount">Scavenge count</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.count\'].value}}</div></div><div class="row"><div class="col-md-9" data-translate="metrics.jvm.gc.scavengetime">Scavenge time</div><div class="col-md-3 text-right">{{vm.metrics.gauges[\'jvm.garbage.PS-Scavenge.time\'].value}}ms</div></div></div></div><div class="well well-lg" ng-show="vm.updatingMetrics" data-translate="metrics.updating">Updating...</div><h3 data-translate="metrics.jvm.http.title">HTTP requests (events per second)</h3><p><span data-translate="metrics.jvm.http.active">Active requests</span> <b>{{vm.metrics.counters[\'com.codahale.metrics.servlet.InstrumentedFilter.activeRequests\'].count | number:0}}</b> - <span data-translate="metrics.jvm.http.total">Total requests</span> <b>{{vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count | number:0}}</b></p><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.jvm.http.table.code">Code</th><th data-translate="metrics.jvm.http.table.count">Count</th><th class="text-right" data-translate="metrics.jvm.http.table.mean">Mean</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (1 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (5 min)</th><th class="text-right"><span data-translate="metrics.jvm.http.table.average">Average</span> (15 min)</th></tr></thead><tbody><tr><td data-translate="metrics.jvm.http.code.ok">OK</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.ok\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.notfound">Not Found</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.notFound\'].m15_rate | number:2}}</td></tr><tr><td data-translate="metrics.jvm.http.code.servererror">Server error</td><td><uib-progressbar min="0" max="vm.metrics.timers[\'com.codahale.metrics.servlet.InstrumentedFilter.requests\'].count" value="vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count" class="progress-striped active" type="success"><span>{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].count}}</span></uib-progressbar></td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].mean_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m1_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m5_rate | number:2}}</td><td class="text-right">{{vm.metrics.meters[\'com.codahale.metrics.servlet.InstrumentedFilter.responseCodes.serverError\'].m15_rate | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.servicesstats.title">Services statistics (time in millisecond)</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.servicesstats.table.name">Service name</th><th class="text-right" data-translate="metrics.servicesstats.table.count">Count</th><th class="text-right" data-translate="metrics.servicesstats.table.mean">Mean</th><th class="text-right" data-translate="metrics.servicesstats.table.min">Min</th><th class="text-right" data-translate="metrics.servicesstats.table.p50">p50</th><th class="text-right" data-translate="metrics.servicesstats.table.p75">p75</th><th class="text-right" data-translate="metrics.servicesstats.table.p95">p95</th><th class="text-right" data-translate="metrics.servicesstats.table.p99">p99</th><th class="text-right" data-translate="metrics.servicesstats.table.max">Max</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.servicesStats"><td>{{k}}</td><td class="text-right">{{v.count}}</td><td class="text-right">{{v.mean * 1000 | number:0}}</td><td class="text-right">{{v.min * 1000 | number:0}}</td><td class="text-right">{{v.p50 * 1000 | number:0}}</td><td class="text-right">{{v.p75 * 1000 | number:0}}</td><td class="text-right">{{v.p95 * 1000 | number:0}}</td><td class="text-right">{{v.p99 * 1000 | number:0}}</td><td class="text-right">{{v.max * 1000 | number:0}}</td></tr></tbody></table></div><h3 data-translate="metrics.cache.title">Cache statistics</h3><div class="table-responsive"><table class="table table-striped"><thead><tr><th data-translate="metrics.cache.cachename">Cache name</th><th class="text-right" data-translate="metrics.cache.hits">Cache Hits</th><th class="text-right" data-translate="metrics.cache.misses">Cache Misses</th><th class="text-right" data-translate="metrics.cache.gets">Cache Gets</th><th class="text-right" data-translate="metrics.cache.puts">Cache Puts</th><th class="text-right" data-translate="metrics.cache.removals">Cache Removals</th><th class="text-right" data-translate="metrics.cache.evictions">Cache Evictions</th><th class="text-right" data-translate="metrics.cache.hitPercent">Cache Hit %</th><th class="text-right" data-translate="metrics.cache.missPercent">Cache Miss %</th><th class="text-right" data-translate="metrics.cache.averageGetTime">Average get time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averagePutTime">Average put time (\xB5s)</th><th class="text-right" data-translate="metrics.cache.averageRemoveTime">Average remove time (\xB5s)</th></tr></thead><tbody><tr ng-repeat="(k, v) in vm.cachesStats" ng-once><td>{{v.name}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hits\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-misses\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-gets\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-puts\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-removals\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-evictions\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-hit-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.cache-miss-percentage\'].value}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-get-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-put-time\'].value | number:2}}</td><td class="text-right">{{vm.metrics.gauges[k + \'.average-remove-time\'].value | number:2}}</td></tr></tbody></table></div><h3 data-translate="metrics.datasource.title" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0">DataSource statistics (time in millisecond)</h3><div class="table-responsive" ng-show="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value > 0"><table class="table table-striped"><thead><tr><th><span data-translate="metrics.datasource.usage">Usage</span> ({{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value}} / {{vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value}})</th><th class="text-right" data-translate="metrics.datasource.count">Count</th><th class="text-right" data-translate="metrics.datasource.mean">Mean</th><th class="text-right" data-translate="metrics.datasource.min">Min</th><th class="text-right" data-translate="metrics.datasource.p50">p50</th><th class="text-right" data-translate="metrics.datasource.p75">p75</th><th class="text-right" data-translate="metrics.datasource.p95">p95</th><th class="text-right" data-translate="metrics.datasource.p99">p99</th><th class="text-right" data-translate="metrics.datasource.max">Max</th></tr></thead><tbody><tr><td><div class="progress progress-striped"><uib-progressbar min="0" max="vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value" value="vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value" class="progress-striped active" type="success"><span>{{vm.metrics.gauges[\'HikariPool-1.pool.ActiveConnections\'].value * 100 / vm.metrics.gauges[\'HikariPool-1.pool.TotalConnections\'].value | number:0}}%</span></uib-progressbar></div></td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].count}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].mean | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].min | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p50 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p75 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p95 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].p99 | number:2}}</td><td class="text-right">{{vm.metrics.histograms[\'HikariPool-1.pool.Usage\'].max | number:2}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/metrics/metrics.modal.html','<!-- Modal used to display the threads dump --><div class="modal-header"><button type="button" class="close" ng-click="vm.cancel()">&times;</button><h4 class="modal-title" data-translate="metrics.jvm.threads.dump.title">Threads dump</h4></div><div class="modal-body pad"><span class="label label-primary" ng-click="threadDumpFilter = {}">All&nbsp;<span class="badge">{{vm.threadDumpAll}}</span></span>&nbsp; <span class="label label-success" ng-click="threadDumpFilter = {threadState: \'RUNNABLE\'}">Runnable&nbsp;<span class="badge">{{vm.threadDumpRunnable}}</span></span>&nbsp; <span class="label label-info" ng-click="threadDumpFilter = {threadState: \'WAITING\'}">Waiting&nbsp;<span class="badge">{{vm.threadDumpWaiting}}</span></span>&nbsp; <span class="label label-warning" ng-click="threadDumpFilter = {threadState: \'TIMED_WAITING\'}">Timed Waiting&nbsp;<span class="badge">{{vm.threadDumpTimedWaiting}}</span></span>&nbsp; <span class="label label-danger" ng-click="threadDumpFilter = {threadState: \'BLOCKED\'}">Blocked&nbsp;<span class="badge">{{vm.threadDumpBlocked}}</span></span>&nbsp;<div class="voffset2">&nbsp;</div>Filter <input type="text" ng-model="threadDumpFilter" class="form-control"><div class="row pad" ng-repeat="(k, v) in vm.threadDump | filter:threadDumpFilter"><h5><span class="label" ng-class="vm.getLabelClass(v.threadState)">{{v.threadState}}</span>&nbsp;{{v.threadName}} (ID {{v.threadId}}) <a ng-click="show = !show"><span ng-show="!show" data-translate="metrics.jvm.threads.dump.show">Show StackTrace</span> <span ng-show="show" data-translate="metrics.jvm.threads.dump.hide">Hide StackTrace</span></a></h5><div class="well" ng-show="show"><div ng-repeat="(stK, stV) in v.stackTrace">{{stV.className}}.{{stV.methodName}}({{stV.fileName}}:{{stV.lineNumber}}) <span class="voffset1"></span></div></div><table class="table table-condensed"><thead><tr><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedtime">Blocked Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.blockedcount">Blocked Count</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedtime">Waited Time</th><th class="text-right" data-translate="metrics.jvm.threads.dump.waitedcount">Waited Count</th><th data-translate="metrics.jvm.threads.dump.lockname">Lock Name</th></tr></thead><tbody><tr><td>{{v.blockedTime}}</td><td>{{v.blockedCount}}</td><td>{{v.waitedTime}}</td><td>{{v.waitedCount}}</td><td>{{v.lockName}}</td></tr></tbody></table></div></div><div class="modal-footer"><button type="button" class="btn btn-default pull-left" data-dismiss="modal" ng-click="vm.cancel()">Done</button></div>');
$templateCache.put('app/admin/tracker/tracker.html','<div><h2>Real-time user activities</h2><div class="table-responsive"><table class="table table-striped"><thead><tr><th>User</th><th>IP Address</th><th>Current page</th><th>Time</th><th></th></tr></thead><tbody><tr ng-repeat="activity in vm.activities"><td>{{activity.userLogin}}</td><td>{{activity.ipAddress}}</td><td>{{activity.page}}</td><td>{{activity.time | date:\'yyyy-MM-dd HH:mm:ss\'}}</td></tr></tbody></table></div></div>');
$templateCache.put('app/admin/user-management/user-management-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="userManagement.delete.question" translate-values="{login: \'{{vm.user.login}}\'}">Are you sure you want to delete this User?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/admin/user-management/user-management-detail.html','<div class="ibox"><div class="ibox-content"><div class="row"><div class="col-md-12"><h2><span data-translate="userManagement.detail.title">User</span> "{{vm.user.login}}"</h2><dl class="row"><div class="col-md-6"><dt><span data-translate="userManagement.login">Login</span></dt><dd><span>{{vm.user.login}}</span></dd><dt><span data-translate="userManagement.firstName">First Name</span></dt><dd>{{vm.user.firstName}}</dd><dt><span data-translate="userManagement.lastName">Last Name</span></dt><dd>{{vm.user.lastName}}</dd><dt><span data-translate="userManagement.email">Email</span></dt><dd>{{vm.user.email}}</dd><dt><span data-translate="userManagement.activated">Activated</span></dt><dd>{{vm.user.activated}}</dd><dt><span data-translate="userManagement.langKey">Lang Key</span></dt><dd>{{vm.user.langKey}}</dd><dt><span data-translate="userManagement.createdBy">Created By</span></dt><dd>{{vm.user.createdBy}}</dd><dt><span data-translate="userManagement.createdDate">Created Date</span></dt><dd>{{vm.user.createdDate | date:\'dd/MM/yy HH:mm\' }}</dd><dt><span data-translate="userManagement.lastModifiedBy">Last Modified By</span></dt><dd>{{vm.user.lastModifiedBy}}</dd><dt><span data-translate="userManagement.lastModifiedDate">Last Modified Date</span></dt><dd>{{vm.user.lastModifiedDate | date:\'dd/MM/yy HH:mm\'}}</dd></div><div class="col-md-6"><dt><span data-translate="userManagement.profiles">Profiles</span></dt><dd><ul class="list-unstyled"><li ng-repeat="authority in vm.user.authorities"><span>{{authority}}</span></li></ul></dd><dt><span>Notifica\xE7\xF5es</span></dt><dd><ul class="list-unstyled"><li ng-repeat="notificacao in vm.user.notificacoes"><span>{{notificacao}}</span></li></ul></dd><dt><span>Clientes</span></dt><dd><ul class="list-unstyled"><li ng-repeat="cliente in vm.user.clientes"><span>{{cliente.nome}}</span></li></ul></dd><dt><span>M\xF3dulos</span></dt><dd><ul class="list-unstyled"><li ng-repeat="modulo in vm.user.modulos"><span>{{modulo.descricao}}</span></li></ul></dd><dt><span>SubM\xF3dulos</span></dt><dd><ul class="list-unstyled"><li ng-repeat="subModulo in vm.user.subModulos"><span>{{subModulo.descricao}}</span></li></ul></dd><dt><span>Filas</span></dt><dd><ul class="list-unstyled"><li ng-repeat="fila in vm.user.filas"><span>{{vm.getFilaDescricao(fila)}}</span></li></ul></dd></div></dl><button type="submit" ui-sref="user-management" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div></div></div></div>');
$templateCache.put('app/admin/user-management/user-management-dialog.html','<div class="ibox"><div class="ibox-content"><div class="row"><form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="col-md-4"><div class="form-group col-md-12 text-center" ng-show="vm.imagemOginal && !vm.trocarImagem"><img ng-src="{{vm.imagemOginal}}" class="img-circle" ng-show="!vm.picFile"><br><img ng-src="{{vm.croppedDataUrl}}" class="img-circle" ng-show="vm.picFile"><br></div><div><div class="form-group col-md-12"><button ngf-select class="btn btn-primary btn-block" ng-model="vm.picFile" accept="image/*"><i class="fa fa-upload"></i> Selecione uma imagem</button></div><div class="form-group col-md-12 text-center" ng-show="vm.picFile"><label>Voc\xEA pode ajustar sua imagem</label><br><div ngf-drop ng-model="vm.picFile" ngf-pattern="image/*" class="cropArea"><img-crop image="vm.picFile | ngfDataUrl" result-image="vm.croppedDataUrl" ng-init="vm.croppedDataUrl=\'\'"></img-crop></div></div></div></div><div class="col-md-8"><jhi-alert-error></jhi-alert-error><div class="form-group col-md-6"><label data-translate="global.field.id">ID</label><input type="text" class="form-control" name="id" ng-model="vm.user.id" readonly="readonly"></div><div class="form-group col-md-6"><label class="control-label" data-translate="userManagement.login">Login</label><input type="text" class="form-control" name="login" ng-model="vm.user.login" ng-required="vm.user.id == null" ng-minlength="1" ng-maxlength="50" ng-pattern="/^[_\'.@A-Za-z0-9-]*$/"><div ng-show="editForm.login.$invalid"><p class="help-block" ng-show="editForm.login.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.login.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group col-md-6"><label class="control-label" data-translate="userManagement.firstName">First Name</label><input type="text" class="form-control" name="firstName" ng-model="vm.user.firstName" ng-maxlength="50"><div ng-show="editForm.firstName.$invalid"><p class="help-block" ng-show="editForm.firstName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group col-md-6"><label data-translate="userManagement.lastName">Last Name</label><input type="text" class="form-control" name="lastName" ng-model="vm.user.lastName" ng-maxlength="50"><div ng-show="editForm.lastName.$invalid"><p class="help-block" ng-show="editForm.lastName.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group col-md-6"><label class="control-label" data-translate="userManagement.email">Email</label><input type="email" class="form-control" name="email" ng-model="vm.user.email" required ng-maxlength="100"><div ng-show="editForm.email.$invalid"><p class="help-block" ng-show="editForm.email.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.email.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p><p class="help-block" ng-show="editForm.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p></div></div><div class="form-group col-md-3"><label for="activated"><input ng-disabled="vm.user.id === null" type="checkbox" id="activated" name="activated" ng-model="vm.user.activated"> <span data-translate="userManagement.activated">Activated</span></label></div><div class="form-group col-md-3"><label data-translate="userManagement.langKey">Lang Key</label><select class="form-control" name="langKey" ng-model="vm.user.langKey" ng-options="language as language for language in vm.languages track by language"></select></div></div><div class="col-md-12"><div class="col-md-4"><div class="panel panel-default"><div class="panel-heading"><label>Perfis de Acesso</label></div><div class="panel-body" style="overflow: auto; max-height: 300px"><table class="table"><tr class="{{vm.user.authorities.indexOf(authority) > -1 ? \'success\':\'\'}}" ng-repeat="authority in vm.authorities track by $index"><td><i class="fa fa-circle-o" ng-click="vm.user.authorities.push(authority)" ng-show="vm.user.authorities.indexOf(authority) < 0"></i> <i class="fa fa-check-circle-o" ng-click="vm.user.authorities.splice(vm.user.authorities.indexOf(authority),1)" ng-show="vm.user.authorities.indexOf(authority) > -1"></i></td><td>{{authority}}</td></tr></table></div></div></div><div class="col-md-4"><div class="panel panel-default"><div class="panel-heading"><label>Filas</label></div><div class="panel-body" style="overflow: auto; max-height: 300px"><table class="table"><tr class="{{vm.hasFila(fila) ? \'success\':\'\'}}" ng-repeat="fila in vm.filas track by fila.id"><td><i class="fa fa-circle-o" ng-click="vm.adicionarFila(fila)" ng-show="!vm.hasFila(fila)"></i> <i class="fa fa-check-circle-o" ng-click="vm.removerFila(fila)" ng-show="vm.hasFila(fila)"></i></td><td>{{fila.descricao}}</td></tr></table></div></div></div><div class="col-md-4"><div class="panel panel-default"><div class="panel-heading"><label>Notifica\xE7\xF5es</label></div><div class="panel-body" style="overflow: auto; max-height: 300px"><table class="table"><tr class="{{vm.user.notificacoes.indexOf(notificacao) > -1 ? \'success\':\'\'}}" ng-repeat="notificacao in vm.notificacoes track by $index"><td><i class="fa fa-circle-o" ng-click="vm.user.notificacoes.push(notificacao)" ng-show="vm.user.notificacoes.indexOf(notificacao) < 0"></i> <i class="fa fa-check-circle-o" ng-click="vm.user.notificacoes.splice(vm.user.notificacoes.indexOf(notificacao),1)" ng-show="vm.user.notificacoes.indexOf(notificacao) > -1"></i></td><td>{{vm.getNotificacaoLabel(notificacao)}}</td></tr></table></div></div></div></div><div class="col-md-12"><div class="col-md-6"><div class="panel panel-default"><div class="panel-heading"><label>Clientes</label></div><div class="panel-body" style="overflow: auto; max-height: 300px"><table class="table"><tr class="{{vm.indexCliente(cliente.id) > -1 ? \'success\':\'\'}}" ng-repeat="cliente in vm.clientes track by $index"><td><i class="fa fa-circle-o" ng-click="vm.user.clientes.push(cliente); vm.selecionarSistemasCliente()" ng-show="vm.indexCliente(cliente.id) < 0"></i> <i class="fa fa-check-circle-o" ng-click="vm.user.clientes.splice(vm.indexCliente(cliente.id),1); vm.removerSistemasCliente(cliente)" ng-show="vm.indexCliente(cliente.id) > -1"></i></td><td>{{cliente.nome}}</td></tr></table></div></div></div><div class="col-md-6"><div class="panel panel-default"><div class="panel-heading"><label>Sistemas</label></div><div class="panel-body" style="overflow: auto; max-height: 300px"><table class="table"><tr class="{{vm.indexSistema(sistema.id) > -1 ? \'success\':\'\'}}" ng-repeat="sistema in vm.sistemas track by $index"><td><i class="fa fa-circle-o" ng-click="vm.user.sistemas.push(sistema)" ng-show="vm.indexSistema(sistema.id) < 0"></i> <i class="fa fa-check-circle-o" ng-click="vm.user.sistemas.splice(vm.indexSistema(sistema.id),1)" ng-show="vm.indexSistema(sistema.id) > -1"></i></td><td>{{sistema.nome}}</td></tr></table></div></div></div></div><div class="col-md-12"><div class="col-md-6"><div class="panel panel-default"><div class="panel-heading"><label>M\xF3dulos</label></div><div class="panel-body" style="overflow: auto; max-height: 300px"><table class="table"><tr class="{{vm.indexModulo(modulo.id) > -1 ? \'success\':\'\'}}" ng-repeat="modulo in vm.modulos track by $index"><td><i class="fa fa-circle-o" ng-click="vm.adicionarMdulo(modulo)" ng-show="vm.indexModulo(modulo.id) < 0"></i> <i class="fa fa-check-circle-o" ng-click="vm.removerMdulo(modulo)" ng-show="vm.indexModulo(modulo.id) > -1"></i></td><td>{{modulo.descricao}}</td></tr></table></div></div></div><div class="col-md-6"><div class="panel panel-default"><div class="panel-heading"><label>SubModulos</label></div><div class="panel-body" style="overflow: auto; max-height: 300px"><div class="text-center"><i class="fa fa-check-circle-o" ng-click="vm.adicionarTodosSubModulos()">Selecionar Todos</i> <i class="fa fa-circle-o" ng-click="vm.removerTodosSubModulos()">Remover Todos</i></div><table class="table"><tr class="{{vm.indexSubModulo(submodulo.id) > -1 ? \'success\':\'\'}}" ng-repeat="submodulo in vm.subModulos track by $index"><td><i class="fa fa-circle-o" ng-click="vm.user.subModulos.push(submodulo)" ng-show="vm.indexSubModulo(submodulo.id) < 0"></i> <i class="fa fa-check-circle-o" ng-click="vm.user.subModulos.splice(vm.indexSubModulo(submodulo.id),1)" ng-show="vm.indexSubModulo(submodulo.id) > -1"></i></td><td>{{submodulo.descricao}}</td></tr></table></div></div></div></div><div class="form-group col-md-12"><button class="btn btn-default" type="button" ui-sref="user-management"><i class="fa fa-ban"></i> Cancelar</button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="fa fa-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form></div></div></div>');
$templateCache.put('app/admin/user-management/user-management-reset-dialog.html','<form name="resetForm" ng-submit="vm.confirmReset(vm.user.login)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Confirme a Opera\xE7\xE3o</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p>Tem certeza que deseja confirmar a reinicializa\xE7\xE3o de senha desse usuario?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" class="btn btn-danger"><span class="glyphicon glyphicon-refresh"></span>&nbsp;Continuar</button></div></form>');
$templateCache.put('app/admin/user-management/user-management.html','<div class="ibox"><div class="ibox-content"><div class="row"><div class="col-md-12"><h2>Usu\xE1rios</h2><jhi-alert></jhi-alert><div class="row"><div class="col-md-10"><search-box ng-model="vm.filtro" search-method="vm.loadAll()"></search-box></div><div class="col-md-2"><button class="btn btn-primary btn-block" ui-sref="user-management.new"><i class="fa fa-plus-circle"></i> Adicionar</button></div></div><div class="table-responsive"><table class="table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="login"><span data-translate="userManagement.login">Login</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="email"><span data-translate="userManagement.email">Email</span> <span class="glyphicon glyphicon-sort"></span></th><th></th><th><span data-translate="userManagement.profiles">Profiles</span></th><th></th></tr></thead><tbody><tr ng-repeat="user in vm.users track by user.id"><td><a ui-sref="user-management-detail({login:user.login})">{{user.id}}</a></td><td>{{user.login}}</td><td>{{user.email}}</td><td><span class="label label-danger" ng-click="vm.setActive(user, true)" ng-show="!user.activated" data-translate="userManagement.deactivated" style="cursor: pointer">Deactivated</span> <span class="label label-success" ng-click="vm.setActive(user, false)" ng-show="user.activated" data-translate="userManagement.activated" style="cursor: pointer">Activated</span></td><td><div ng-repeat="authority in user.authorities"><span class="label label-info">{{ authority }}</span></div></td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="user-management-detail({login:user.login})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span></button> <button type="submit" ui-sref="user-management.edit({login:user.login})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="submit" ui-sref="user-management.reset({login:user.login})" class="btn btn-warning btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="fa fa-key"></span></button> <button type="submit" ui-sref="user-management.delete({login:user.login})" class="btn btn-danger btn-sm" ng-disabled="vm.currentAccount.login==user.login"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/components/notify/alerta.html','<div class="cg-notify-message inspinia-notify" ng-class="$classes"><div class="p-lg"><div ng-show="!$messageTemplate">{{$message}}</div><div ng-show="$messageTemplate" class="cg-notify-message-template"></div><button type="button" class="cg-notify-close" ng-click="$close()"><span aria-hidden="true">&times;</span> <span class="cg-notify-sr-only">Close</span></button></div></div>');
$templateCache.put('app/components/situacoesSprint/situacoesSprint.component.html','<div class="row m-b-lg"><div class="col-md-12 m-t-sm text-center" style="display: flex; align-items: center; justify-content: center">Sprint:&ensp; <a ng-repeat="situacao in $ctrl.situacoesSprint" ng-click="$ctrl.inverterSituacao(situacao)" class="m-r-sm btn btn-sm {{$ctrl.isSelecionado(situacao) ? \'btn-info\' : \'btn-default\'}}"><i class="fa {{$ctrl.isSelecionado(situacao) ? \'fa-toggle-on\': \'fa-toggle-off\'}}"></i> <span data-translate="{{\'chamadosApp.SituacaoSprint.\' + situacao}}">{{situacao}}</span> </a><a ng-show="$ctrl.mostrarBotaoAtribuidasParaMim" ng-click="$ctrl.inverterAtribuidasParaMim()" class="m-r-sm btn btn-sm {{$ctrl.isAtribuidasParaMim() ? \'btn-info\' : \'btn-default\'}}"><i class="fa {{$ctrl.isAtribuidasParaMim() ? \'fa-toggle-on\': \'fa-toggle-off\'}}"></i> <span>Atribu\xEDdas para mim</span></a></div></div>');
$templateCache.put('app/entities/agrupador/agrupador-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myClienteLabel" data-translate="chamadosApp.agrupador.home.createOrEditLabel">Create or edit a Cliente</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.agrupador.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.agrupador.id" readonly="readonly"></div><div class="row"><div class="col-md-6 form-group"><label class="control-label" data-translate="chamadosApp.agrupador.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.agrupador.nome" required ng-minlength="2" ng-maxlength="100"><div ng-show="editForm.nome.$invalid"><p class="help-block" ng-show="editForm.nome.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nome.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.nome.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="col-md-6 form-group"><label class="control-label" for="field_cliente">Cliente</label><select class="form-control" id="field_cliente" name="cliente" ng-model="vm.agrupador.cliente" ng-options="cliente as cliente.nome for cliente in vm.clientes track by cliente.id"></select></div></div><div class="row"><div class="col-md-4 form-group"><label class="control-label" for="field_situacao">Situa\xE7\xE3o</label><select class="form-control" name="situacao" ng-model="vm.agrupador.situacao" id="field_situacao" required><option value="ABERTO">Aberto</option><option value="FINALIZADO">Finalizado</option></select></div><div class="col-md-4 form-group"><label class="control-label" for="field_criadoEm">Solitado em</label><div class="input-group"><input id="field_criadoEm" type="text" class="form-control" name="criadoEm" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.agrupador.criadoEm" is-open="vm.datePickerOpenStatus.criadoEm"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'criadoEm\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="col-md-4 form-group"><label class="control-label" for="field_previsaoEntrega">Previs\xE3o de Entrega</label><div class="input-group"><input id="field_previsaoEntrega" type="text" class="form-control" name="previsaoEntrega" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.agrupador.previsaoEntrega" is-open="vm.datePickerOpenStatus.previsaoEntrega"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'previsaoEntrega\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="row"><div class="col-md-12"><div has-authority="ROLE_PO" ng-if="vm.agrupador.situacao == \'ABERTO\'" class="m-b-md"><div class="input-group"><input type="number" class="form-control" ng-model="vm.adicionar" placeholder="N\xFAmero do Chamado"> <span class="input-group-btn"><button class="btn btn-success" ng-click="vm.alocar(vm.adicionar)" type="button"><i class="fa fa-save"></i></button></span></div></div><table class="table"><tr><th>Chamado</th><th>Situa\xE7\xE3o</th><th>Porcentagem</th><th></th></tr><tr ng-repeat="chamado in vm.agrupador.chamados track by chamado.id"><td class="issue-info col-md-5"><strong><a target="_blank" ui-sref="edit-chamado({id:chamado.id, search: null, situacao: null})">#{{chamado.id}} </a></strong><small>{{chamado.titulo}}</small></td><td class="issue-info"><span data-translate="{{\'chamadosApp.SituacaoChamado.\' + chamado.situacao}}">{{chamado.situacao}} </span><small>{{chamado.modulo.descricao}}</small></td><td><div class="progress mb-1"><div style="width: {{vm.getTamanhoBarraPorSituacao(chamado.situacao)}}" class="progress-bar progress-bar-striped progress-bar-animated">{{vm.getTamanhoBarraPorSituacao(chamado.situacao)}}</div></div><small>Planejado em <strong>{{chamado.tempoEstimado ? chamado.tempoEstimado : 0}}</strong> horas</small></td><td has-authority="ROLE_PO"><button type="button" ng-if="vm.agrupador.situacao == \'ABERTO\'" class="btn btn-warning btn-sm" has-authority="ROLE_PO" ng-click="vm.desalocar(chamado)"><i class="fa fa-trash"></i></button></td></tr></table></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" has-authority="ROLE_PO" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/agrupador/agrupador.html','<div class="row"><div class="col-md-2"><div class="file-manager"><h5>Projetos</h5><ul class="folder-list m-b-md" style="padding: 0"><li ng-repeat="cliente in vm.clientes"><a ng-click="vm.selecionarCliente(cliente)" title="{{cliente.nome}}"><i class="fa {{vm.cliente && vm.cliente.id === cliente.id ?\'fa-check-circle-o\':\'fa-circle-o\'}}"></i> {{cliente.nome| limitTo: 15 }}{{cliente.nome.length > 15 ? \'...\' : \'\'}} <span class="label {{vm.cliente && vm.cliente.id === cliente.id ?\'label-success\':\'label-default\'}} float-right pull-right">{{cliente.quantidade}}</span></a></li></ul></div></div><div class="col-md-10" ng-if="!vm.cliente"><div class="alert alert-info m-t-md">Nenhum projeto dispon\xEDvel para o seu usu\xE1rio.</div></div><div class="col-md-10" ng-if="vm.cliente"><div class="ibox"><div class="ibox-title">Agrupadores</div><div class="ibox-content"><div class="row"><div class="col-md-12"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-md-10"><search-box ng-model="vm.filtro" search-method="vm.loadAll()"></search-box></div><div class="col-md-2 no-padding-left"><button class="btn btn-primary btn-block" ui-sref="agrupador.new" has-authority="ROLE_PO"><i class="fa fa-plus-circle"></i> Novo Agrupador</button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="nome"><span data-translate="chamadosApp.agrupador.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="criadoEm"><span data-translate="chamadosApp.agrupador.criadoEm">Criado em</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="previsaoEntrega"><span data-translate="chamadosApp.agrupador.previsaoEntrega">Previs\xE3o</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="situacao">Situa\xE7\xE3o <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="agrupador in vm.agrupadores track by agrupador.id"><td>{{agrupador.nome}}</td><td>{{agrupador.criadoEm | date:\'mediumDate\'}}</td><td>{{agrupador.previsaoEntrega | date:\'mediumDate\'}}</td><td>{{agrupador.situacao}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="agrupador.edit({id:agrupador.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" has-authority="ROLE_PO" ng-click="vm.remover(agrupador.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/aplicacao/aplicacao-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myClienteLabel" data-translate="chamadosApp.aplicacao.home.createOrEditLabel">Create or edit a Cliente</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row m-b-sm" ng-show="vm.aplicacao.id"><div class="form-group"><div class="col-md-2"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.aplicacao.id" readonly="readonly"></div></div></div><div class="row m-b-sm"><div class="form-group"><div class="col-md-12"><label class="control-label" data-translate="chamadosApp.aplicacao.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.aplicacao.nome" required ng-minlength="2" ng-maxlength="100"><div ng-show="editForm.nome.$invalid"><p class="help-block" ng-show="editForm.nome.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nome.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.nome.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div></div><div class="row m-b-sm"><div class="form-group"><div class="col-md-12"><label class="control-label" for="field_nome">Agrupador</label><input type="text" class="form-control" name="agrupador" id="field_agrupador" ng-model="vm.aplicacao.agrupador" required ng-minlength="2" ng-maxlength="100"><div ng-show="editForm.agrupador.$invalid"><p class="help-block" ng-show="editForm.agrupador.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.agrupador.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.agrupador.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div></div><div class="row m-b-sm"><div class="form-group"><div class="col-md-6"><label class="control-label" data-translate="chamadosApp.aplicacao.url" for="field_url">URL</label><input type="text" class="form-control" name="url" id="field_url" ng-model="vm.aplicacao.url" required ng-minlength="2" ng-maxlength="100"><div ng-show="editForm.url.$invalid"><p class="help-block" ng-show="editForm.url.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.url.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.url.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="col-md-6"><label class="control-label" data-translate="chamadosApp.aplicacao.api" for="field_api">Api</label><input type="text" class="form-control" name="api" id="field_api" ng-model="vm.aplicacao.api" required ng-minlength="2" ng-maxlength="100"><div ng-show="editForm.api.$invalid"><p class="help-block" ng-show="editForm.api.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.api.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.api.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div></div><div class="row m-b-sm"><div class="form-group"><div class="col-md-1"><label class="control-label" for="field_ativo">Ativo?</label><input type="checkbox" name="ativo" id="field_ativo" ng-model="vm.aplicacao.ativo"></div></div></div><div class="row m-b-sm"><div class="form-group"><div class="col-md-4"><label class="control-label" for="field_estado">UF</label><select class="form-control" id="field_estado" name="uf" ng-change="vm.loadCidades()" ng-model="vm.aplicacao.uf" ng-options="uf as uf.uf + \' - \' + uf.nome for uf in vm.ufs track by uf.id"></select></div><div class="col-md-8"><label class="control-label" for="field_cidade">Cidade</label><select class="form-control" id="field_cidade" name="cidade" ng-model="vm.aplicacao.cidade" ng-options="cidade as cidade.nome for cidade in vm.cidades track by cidade.id"></select></div></div></div><div class="row m-b-sm"><div class="form-group"><div class="col-md-12"><label class="control-label" for="field_cliente">Cliente</label><select class="form-control" id="field_cliente" name="cliente" ng-change="vm.carregarSistemas()" ng-model="vm.aplicacao.cliente" ng-options="cliente as cliente.nome for cliente in vm.clientes track by cliente.id"></select></div></div></div><div class="row m-b-sm"><div class="form-group"><div class="col-md-12"><label class="control-label" for="field_sistema">Sistema</label><select class="form-control" id="field_sistema" name="sistema" ng-model="vm.aplicacao.sistema" ng-options="sistema as sistema.nome for sistema in vm.sistemas track by sistema.id"></select></div></div></div><div class="row m-b-sm"><div class="form-group"><div class="col-md-12"><div class="panel panel-default"><div class="panel-heading"><label>Ocorr\xEAncias</label></div><div class="panel-body"><div class="form-group"><label class="control-label">Data:</label><div class="input-group"><input id="field_inicio" type="text" class="form-control" name="criadoEm" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.ocorrencia.criadoEm" is-open="vm.datePickerOpenStatus.criadoEm"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'criadoEm\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label">Observa\xE7\xE3o</label><input type="text" class="form-control" name="observacao" id="field_observacao" ng-model="vm.ocorrencia.observacao" ng-minlength="2" ng-maxlength="100"></div><button type="button" class="btn btn-default" ng-click="vm.adicionarOcorrencia()"><span class="fa fa-plus-circle"></span>&nbsp;<span>Adicionar</span></button><table class="table"><tr ng-repeat="ocorrencia in vm.aplicacao.ocorrencias track by $index"><td><button type="button" class="btn btn-default" ng-click="vm.removerOcorrencia(ocorrencia)"><span class="fa fa-trash"></span></button></td><td>{{ocorrencia.criadoEm | date:\'mediumDate\'}}</td><td>{{ocorrencia.observacao}}</td></tr></table></div></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/aplicacao/aplicacao.html','<div class="ibox no-padding"><div class="ibox-content"><div class="row"><div class="col-md-12 text-center m-b-md"><a ui-sref="aplicacao.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="chamadosApp.aplicacao.home.createLabel">Create new Aplica\xE7\xE3o</span></a></div></div><div class="row"><div class="col-md-12 text-center m-b-md"><div class="input-group"><input type="number" class="form-control" ng-model="vm.search" placeholder="Procurar ..."> <span class="input-group-btn"><button class="btn btn-success" type="button"><i class="fa fa-search"></i></button></span></div></div></div><div class="row"><div class="col-md-12 table-responsive"><table class="table table-striped"><tr ng-repeat-start="(key, value) in vm.agrupador"><td>{{key}}</td></tr><tr ng-repeat-end><td><table class="table table-hover"><tr ng-repeat="aplicacao in vm.agrupador[key].aplicacoes |  orderBy:\'aplicacao.nome\' track by aplicacao.id"><td style="white-space: nowrap"><a href="{{aplicacao.url}}" title="{{aplicacao.url}}" target="_blank">{{aplicacao.nome}} </a>({{aplicacao.sistema.nome}})</td><td class="text-center col-md-1"><span title="{{aplicacao.usuariosAtivos}} Usu\xE1rios Online" class="label {{aplicacao.usuariosAtivos ? \'label-primary\':\'label-warning\'}}">{{aplicacao.usuariosAtivos}}</span> <i ng-show="aplicacao.ativo" title="APLICA\xC7\xC3O ONLINE" class="text-navy fa fa-check-circle"></i> <i ng-show="!aplicacao.ativo" title="APLICA\xC7\xC3O OFFLINE" class="text-danger fa fa-unlink"></i></td><td class="text-center col-md-1"><a class="font-bold" title="Atualizar dados da aplica\xE7\xE3o" ng-click="vm.verificarSituacao(aplicacao.id)"><i class="fa fa-refresh"></i></a></td><td class="text-center col-md-1"><a class="font-bold" title="Editar Aplica\xE7\xE3o" ui-sref="aplicacao.edit({id:aplicacao.id})"><i class="fa fa-pencil"></i></a></td><td class="text-center col-md-1"><a ng-click="vm.remover(aplicacao.id)" title="Remover Aplica\xE7\xE3o" class="font-bold text-danger"><i class="fa fa-times"></i></a></td></tr></table></td></tr></table></div></div></div></div>');
$templateCache.put('app/entities/ata/ata-detail.html','<div class="ibox"><div class="ibox-title"><h2>Ata {{vm.ata.numero}} - {{vm.ata.titulo}}</h2></div><div class="ibox-content"><div class="row"><div class="col-md-12"><div class="small angular-with-newlines p-md" style="overflow: auto" ng-bind-html="vm.ata.descricao"></div></div></div><div class="row"><div class="col-md-12"><h2>Horas Apontadas</h2><div class="table-responsive"><table class="jh-table table table-striped table-hover"><tr><th>Data</th><th>Tempo gasto</th><th>Tipo</th><th>Usu\xE1rio</th></tr><tbody><tr ng-repeat="atividade in vm.temposGastos track by atividade.id"><td>{{atividade.criadoEm | date:\'mediumDate\'}}</td><td>{{atividade.tempo | number : fractionSize }}</td><td>{{\'chamadosApp.TipoHora.\' + atividade.tipo | translate}}</td><td>{{atividade.user.firstName}}</td></tr></tbody></table></div></div></div><div class="row m-t-lg"><div class="col-md-12"><button class="btn btn-default" ui-sref="ata"><i class="fa fa-ban"></i> Cancelar</button> <button class="btn btn-info" ui-sref="edit-ata({id:vm.ata.id})"><i class="fa fa-pencil"></i> Editar</button></div></div></div></div>');
$templateCache.put('app/entities/ata/ata-edit.html','<div class="ibox"><div class="ibox-title"><h2>Ata {{vm.ata.numero}}</h2></div><div class="ibox-content"><form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="row"><div class="col-md-12"><div class="form-group"><label class="control-label" for="field_titulo">Titulo</label><input type="text" class="form-control" name="titulo" id="field_titulo" ng-model="vm.ata.titulo"></div></div><div class="col-md-12"><text-angular name="conteudo" required ng-model="vm.ata.descricao"></text-angular></div></div><div class="row"><div class="col-md-12"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancel()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;Cancelar</button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;Salvar</button></div></div></form></div></div>');
$templateCache.put('app/entities/ata/ata.html','<div class="ibox"><div class="ibox-title"><h2><h2>Atas</h2></h2></div><div class="ibox-content"><div class="row"><div class="col-md-10"><search-box ng-model="vm.filtro" search-method="vm.loadAll()"></search-box></div><div class="col-md-2"><button class="btn btn-primary btn-block" ui-sref="new-ata"><span class="glyphicon glyphicon-plus"></span> <span>Nova Ata</span></button></div><br><div class="col-md-12"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="numero"><span>N\xFAmero</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="user"><span>Usu\xE1rio</span><span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="titulo"><span>Titulo</span><span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="ata in vm.atas track by ata.id"><td><a ui-sref="detail-ata({id:ata.id})">{{ata.numero}}</a></td><td>{{ata.usuario.firstName}}</td><td>{{ata.titulo}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" has-authority="ROLE_SCRUM" ui-sref="edit-ata({id:ata.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" has-authority="ROLE_SCRUM" ng-click="vm.remover(ata.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/burnup/burnup.html','<div class="row text-center m-b-lg" has-any-authority="ROLE_ATENDENTE, ROLE_PO, ROLE_DESENVOLVEDOR"><div data-toggle="buttons-checkbox" class="btn-group"><a ui-sref="home" class="btn btn-primary" type="button"><i class="fa fa-dashboard"></i> Dashboard Ciclo</a> <a ui-sref="scrumboard" class="btn btn-primary" type="button"><i class="fa fa-code-fork"></i> Task Board</a> <a ui-sref="myboard" class="btn btn-primary" type="button"><i class="fa fa-user"></i> My Board</a> <a ui-sref="burnup" class="btn btn-primary active" type="button"><i class="fa fa-line-chart"></i> Burnup</a></div><br><a class="small" ng-click="vm.definirModoApresentacao()"><i class="fa {{modoApresentacao ? \'fa-check-circle-o\' : \'fa-circle-o\'}}"></i> Apresenta\xE7\xE3o</a></div><div class="col-md-12"><div class="col-md-4 text-center"></div><div class="col-md-4 text-center"><h2>Bornup</h2></div></div><div class="col-md-12 no-padding no-margins"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-content"><div class="row"><form><div class="form-group col-md-5"><label class="control-label" for="field_sprint">Sprint</label><select class="form-control" required id="field_sprint" name="sprint" ng-model="vm.sprint" ng-options="sprint as sprint.descricao for sprint in vm.sprints track by sprint.id"><option value=""></option></select><h5>{{vm.sprint.inicio | date:\'dd/MM/yyyy\'}} at\xE9 {{vm.sprint.fim | date:\'dd/MM/yyyy\'}}</h5></div><div class="form-group col-md-5"><label for="field_usuarios">Clientes</label><select class="form-control" id="field_usuarios" name="usuarios" ng-model="vm.cliente" ng-options="cliente as cliente.nome for cliente in vm.clientes | orderBy: \'nome\'"></select></div><div class="form-group col-md-2"><label class="control-label">&ensp;</label><button ng-click="vm.recuperarChamados()" class="btn btn-success btn-block"><i class="fa fa-search"></i> Buscar</button></div></form></div></div></div></div></div><div class="ibox" ng-if="vm.sprint"><div class="ibox-content"><div class="row"><div class="col-md-12"><div class="col-md-4 text-center"></div><div class="col-md-4 text-center"><h2>Entregas Realizadas</h2></div></div></div><div class="row"><div class="col-md-6 no-margins"><h2 class="text-center">Desenvolvimento</h2><canvas id="chart-bornup-dev" class="chart chart-line" chart-options="vm.chartOptions" chart-data="vm.dataGraficoDev" chart-colors="vm.colors" chart-labels="vm.labelsGraficoDev"></canvas></div><div class="col-md-6 no-margins"><h2 class="text-center">Suporte</h2><canvas id="chart-bornup-sup" class="chart chart-line" chart-options="vm.chartOptions" chart-data="vm.dataGraficoSup" chart-colors="vm.colors" chart-labels="vm.labelsGraficoSup"></canvas></div></div><div class="row"><div class="col-lg-2"><div class="widget style1 navy-bg"><div class="row vertical-align"><div class="col-xs-3"><i class="fa fa-tasks fa-3x"></i></div><div class="col-xs-9 text-right"><h3 class="font-bold">{{vm.chamados.length}}</h3></div></div><div class="row"><div class="col-md-12 text-center"><h3 class="font-bold">Total de chamados</h3></div></div></div></div><div class="col-lg-2"><div class="widget style1 navy-bg"><div class="row vertical-align"><div class="col-xs-3"><i class="fa fa-check-circle-o fa-3x"></i></div><div class="col-xs-9 text-right"><h3 class="font-bold">{{vm.cliente.tempoPlanejado}} h</h3></div></div><div class="row"><div class="col-md-12 text-center"><h3 class="font-bold">Horas Alocadas</h3></div></div></div></div><div class="col-lg-2"><div class="widget style1 red-bg"><div class="row vertical-align"><div class="col-xs-3"><i class="fa fa-warning fa-3x"></i></div><div class="col-xs-9 text-right"><h3 class="font-bold">{{vm.getChamadosNaoPlanejados()}} h</h3></div></div><div class="row"><div class="col-md-12 text-center"><h3 class="font-bold">Horas n\xE3o planejadas</h3></div></div></div></div></div><div class="row"><div class="col-lg-2"><div class="widget style1 lazur-bg"><div class="row vertical-align"><div class="col-xs-3"><i class="fa fa-code fa-3x"></i></div><div class="col-xs-9 text-right"><h3 class="font-bold">{{vm.getChamadosDevEntregues()}}</h3></div></div><div class="row"><div class="col-md-12 text-center"><h3 class="font-bold">Entregues</h3></div></div></div></div><div class="col-lg-2"><div class="widget style1 yellow-bg"><div class="row vertical-align"><div class="col-xs-3"><i class="fa fa-thumbs-up fa-3x"></i></div><div class="col-xs-9 text-right"><h3 class="font-bold">{{(vm.getChamadosDevEntregues() * 100) / vm.chamados.length | number : 2}} %</h3></div></div><div class="row"><div class="col-md-12 text-center"><h3 class="font-bold">% entrega</h3></div></div></div></div><div class="col-lg-2"></div><div class="col-lg-2"><div class="widget style1 lazur-bg"><div class="row vertical-align"><div class="col-xs-3"><i class="fa fa-users fa-3x"></i></div><div class="col-xs-9 text-right"><h3 class="font-bold">{{vm.getChamadosSupEntregues()}}</h3></div></div><div class="row"><div class="col-md-12 text-center"><h3 class="font-bold">Entregues</h3></div></div></div></div><div class="col-lg-2"><div class="widget style1 yellow-bg"><div class="row vertical-align"><div class="col-xs-3"><i class="fa fa-thumbs-up fa-3x"></i></div><div class="col-xs-9 text-right"><h3 class="font-bold">{{(vm.getChamadosSupEntregues() * 100) / vm.chamados.length | number : 2}} %</h3></div></div><div class="row"><div class="col-md-12 text-center"><h3 class="font-bold">% entrega</h3></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/chamado/aprovar-tarefa.html','<div class="ibox"><div class="ibox-content" id="modal-body"><div class="col-md-12"><h2><strong>#{{vm.chamado.id}}</strong> {{vm.chamado.titulo}}</h2><h4 class="no-margins"><span class="m-r-sm" data-translate="{{\'chamadosApp.TipoChamado.\' + vm.chamado.tipoChamado}}">tipo </span><small class="text-muted m-r-sm">{{vm.chamado.cliente.nome}} </small><small class="text-muted m-r-sm">{{vm.chamado.sistema.nome}} </small><small class="text-muted m-r-sm">{{vm.chamado.modulo.descricao}} </small><small class="text-muted m-r-sm">{{vm.chamado.subModulo.descricao}}</small></h4></div><div class="row m-t-md"><div class="col-md-12"><form name="editFormSolicitacao" role="form" novalidate show-validation><div class="form-group col-md-12"><div class="mail-box"><strong>Descri\xE7\xE3o do Chamado</strong><div ng-bind-html="vm.chamado.conteudo"></div></div><div class="mail-box"><strong>Criterio de Valida\xE7\xE3o</strong><div class="small angular-with-newlines">{{vm.chamado.criterio}}</div></div><div class="alert alert-info"><strong>Observa\xE7\xF5es do P.O</strong><div ng-bind-html="vm.chamado.descricaoPo" class="small angular-with-newlines"></div></div><div class="alert alert-warning text-center"><strong><i class="fa fa-clock-o"></i> Chamado Estimado em<h2>{{ vm.chamado.tempoEstimado}}hs</h2></strong></div></div><div class="form-group col-md-12"><label class="control-label" for="field_titulo">Titulo da Tarefa</label><input type="text" class="form-control" name="titulo" id="field_titulo" ng-model="vm.solicitacaoDesenvolvimento.titulo" required ng-minlength="2" ng-maxlength="255"><div ng-show="editFormSolicitacao.titulo.$invalid"><p class="help-block" ng-show="editFormSolicitacao.titulo.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editFormSolicitacao.titulo.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="50">This field is required to be at least 50 characters.</p><p class="help-block" ng-show="editFormSolicitacao.titulo.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="3000">This field cannot be longer than 3000 characters.</p></div></div><div class="form-group col-md-2"><label class="control-label" for="field_complexidade">Complexidade</label><select class="form-control" name="field_complexidade" ng-model="vm.chamado.complexidade" id="field_complexidade" ng-change="vm.calcularPlanoDesenvolvimento()" required><option value=""></option><option value="MUITO_BAIXA">(1) Muito Baixa</option><option value="BAIXA">(2) Baixa</option><option value="MEDIA">(3) M\xE9dia</option><option value="ALTA">(4) Alta</option><option value="MUITO_ALTA">(5) Muito Alta</option></select><div ng-show="editFormSolicitacao.field_complexidade.$invalid"><p class="help-block" ng-show="editFormSolicitacao.field_complexidade.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-md-2"><label class="control-label" for="field_tempo">Tempo da Tarefa</label><input type="number" class="form-control" name="tempoTarefa" id="field_tempo" ng-model="vm.tempoTarefa" required> <small class="help-block">O tempo da tarefa pode ser diferente do chamado! (Default: desenvolvimento + codereview)</small><div ng-show="editFormSolicitacao.tempoTarefa.$invalid"><p class="help-block" ng-show="editFormSolicitacao.tempoTarefa.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-4"><label class="control-label" for="horaAnalise">Horas utilizadas para an\xE1lise</label><input type="number" class="form-control" name="horaAnalise" id="horaAnalise" ng-model="vm.horaAnalise" required ng-minlength="0" ng-maxlength="9999"><div ng-show="editFormSolicitacao.horaAnalise.$invalid"><p class="help-block" ng-show="editFormSolicitacao.horaAnalise.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-4"></div><div class="form-group col-md-12"><label class="control-label" for="field_conteudo_socilitacao">Resumo da Tarefa</label><small>(Descri\xE7\xE3o resumida para entendimento t\xE9cnico do desenvolvedor)</small> <a ng-click="vm.melhorarComIa()" ng-show="!vm.gerandoComIa"><i class="fa fa-magic"></i> Gerar com I.A. </a><span ng-show="vm.gerandoComIa"><i class="fa fa-spinner fa-spin"></i> Gerando Texto, isso pode levar alguns minutos!</span><text-angular type="text" name="conteudo" id="field_conteudo_socilitacao" ng-model="vm.complemento" rows="7" required ng-minlength="15"></text-angular><div ng-show="editFormSolicitacao.conteudo.$invalid"><p class="help-block" ng-show="editFormSolicitacao.conteudo.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editFormSolicitacao.conteudo.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="15">This field is required to be at least 15 characters.</p></div></div><div class="form-group col-md-12"><label class="control-label" for="field_impacto">Pontos de Impacto</label><small>(Caso exista impacto em outro caso de uso, ele deve ser listado abaixo)</small><textarea type="text" class="form-control" name="impacto" id="field_impacto" ng-model="vm.impacto" rows="4" required ng-minlength="2" ng-maxlength="3000"></textarea><div ng-show="editFormSolicitacao.impacto.$invalid"><p class="help-block" ng-show="editFormSolicitacao.impacto.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editFormSolicitacao.impacto.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editFormSolicitacao.impacto.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="3000">This field cannot be longer than 3000 characters.</p></div></div><div class="form-group col-md-12" ng-if="!vm.chamado.criterio"><label class="control-label" for="field_impacto">Crit\xE9rio de valida\xE7\xE3o</label><small>(O Chamado n\xE3o tem crit\xE9rio de valida\xE7\xE3o, infome para que o desenvolvedor consiga efetuar o teste)</small><textarea type="text" class="form-control" name="criterio" ng-model="vm.solicitacaoDesenvolvimento.criterio" rows="4" required ng-minlength="10" ng-maxlength="3000"></textarea><div ng-show="editFormSolicitacao.criterio.$invalid"><p class="help-block" ng-show="editFormSolicitacao.criterio.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editFormSolicitacao.criterio.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="10">This field is required to be at least 50 characters.</p><p class="help-block" ng-show="editFormSolicitacao.criterio.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="3000">This field cannot be longer than 3000 characters.</p></div></div></form></div><div class="form-group col-md-12 text-center text-danger" ng-show="vm.tempoEstimadoMenorQueMedia"><h4><i class="fa fa-exclamation-triangle"></i> Aten\xE7\xE3o! Tempo estimado menor que a m\xE9dia gasta no mesmo m\xF3dulo e sub m\xF3dulo</h4></div><div class="form-group col-md-12"><table class="table small"><tr><th colspan="4" class="text-center"><a ng-click="vm.verHorasModulo = !vm.verHorasModulo; vm.buscarHorasDoModuloAndSubmodulo()"><i class="fa {{vm.verHorasModulo? \'fa-times\':\'fa-search\'}}"></i> M\xE9dia de horas no m\xF3dulo e subm\xF3dulo</a></th></tr><tr ng-if="vm.verHorasModulo "><th>Tipo de Chamado</th><th>Complexidade</th><th>Estimado</th><th>Gasto</th></tr><tr ng-repeat="horinha in vm.horasPorModulo" ng-if="vm.verHorasModulo " class="{{horinha.escolhida? \'danger\':\'\'}}"><td>{{\'chamadosApp.TipoChamado.\' + horinha.tipoChamado | translate}}</td><td>{{\'chamadosApp.ComplexidadeChamado.\' + horinha.complexidade | translate}}</td><td>{{horinha.tempoEstimado | number:2}}</td><td>{{horinha.tempoGasto | number:2}}</td></tr></table></div></div><button class="btn btn-default" type="button" ng-click="vm.cancel()"><i class="fa fa-ban"></i> Cancelar</button> <button class="btn btn-success" type="button" ng-disabled="editFormSolicitacao.$invalid || vm.isSaving" ng-click="vm.ok()"><i class="fa fa-desktop"></i> Encaminhar</button></div></div>');
$templateCache.put('app/entities/chamado/chamado-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.chamado.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="chamadosApp.chamado.delete.question" translate-values="{id: \'{{vm.chamado.id}}\'}">Are you sure you want to delete this Chamado?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/chamado/chamado-detail.html','<div><h2><span data-translate="chamadosApp.chamado.detail.title">Chamado</span> {{vm.chamado.id}}</h2><hr><jhi-alert-error></jhi-alert-error><dl class="row jh-entity-details"><dt><span data-translate="chamadosApp.chamado.titulo">Titulo</span></dt><dd><span>{{vm.chamado.titulo}}</span></dd><dt><span data-translate="chamadosApp.chamado.conteudo">Conteudo</span></dt><dd><span>{{vm.chamado.conteudo}}</span></dd><dt><span data-translate="chamadosApp.chamado.tipoChamado">Tipo Chamado</span></dt><dd><span data-translate="{{\'chamadosApp.TipoChamado.\' + vm.chamado.tipoChamado}}">{{vm.chamado.tipoChamado}}</span></dd><dt><span data-translate="chamadosApp.chamado.criadoEm">Criado Em</span></dt><dd><span>{{vm.chamado.criadoEm | date:\'mediumDate\'}}</span></dd><dt><span data-translate="chamadosApp.chamado.prazo">Prazo</span></dt><dd><span>{{vm.chamado.prazo | date:\'mediumDate\'}}</span></dd><dt><span data-translate="chamadosApp.chamado.ordem">Ordem</span></dt><dd><span>{{vm.chamado.ordem}}</span></dd><dt><span data-translate="chamadosApp.chamado.solicitante">Solicitante</span></dt><dd>{{vm.chamado.solicitante.login}}</dd><dt><span data-translate="chamadosApp.chamado.responsavel">Responsavel</span></dt><dd>{{vm.chamado.responsavel.login}}</dd><dt><span data-translate="chamadosApp.chamado.cliente">Cliente</span></dt><dd><a ui-sref="cliente-detail({id:vm.chamado.cliente.id})">{{vm.chamado.cliente.nome}}</a></dd></dl><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button type="button" ui-sref="chamado-detail.edit({id:vm.chamado.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button></div>');
$templateCache.put('app/entities/chamado/chamado-edit.html','<div class="col-lg-12" ng-if="(!vm.chamado.id || vm.chamado.isEditing)"><div class="ibox" style="border-left: 5px solid #ed5565"><div class="ibox-title"><span class="label label-danger m-r-sm" style="font-size: 11px; vertical-align: middle" title="Esta tela \xE9 um chamado"><i class="fa fa-ticket"></i> Chamado </span>Novo Chamado</div><div class="ibox-content"><div class="row" ng-show="vm.dependentes && vm.dependentes.length > 0"><div class="col-md-10 col-md-offset-1"><div class="alert alert-danger text-center"><strong>Aten\xE7\xE3o!</strong><br>Existem outros chamados no ciclo de desenvolvimento que podem entrar em conflito como essa nova solicita\xE7\xE3o, caso julgue necess\xE1rio o P.O poder\xE1 <strong>impedir</strong> essa solicita\xE7\xE3o at\xE9 a finaliza\xE7\xE3o das demais.<br><strong>Depend\xEAncias: </strong><a ui-sref="edit-chamado({id: dependente.chamadoId, search: null, situacao: null})" ng-repeat="dependente in vm.dependentes track by dependente.id"><span class="label label-danger">{{dependente.chamadoId}}</span></a></div></div></div><div class="row"><form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="form-group col-md-4"><label for="field_cliente">Projeto</label><select class="form-control" required id="field_cliente" name="cliente" ng-model="vm.chamado.cliente" ng-change="vm.carregarSistemas()" ng-options="cliente as cliente.nome for cliente in vm.clientes track by cliente.id"><option value=""></option></select><div ng-show="editForm.cliente.$invalid"><p class="help-block small" ng-show="editForm.cliente.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-md-4"><label for="field_cliente">Sistema</label><select class="form-control" required id="field_sistema" name="sistema" ng-model="vm.chamado.sistema" ng-options="sistema as sistema.nome for sistema in vm.sistemas track by sistema.id"><option value=""></option></select><div ng-show="editForm.sistema.$invalid"><p class="help-block small" ng-show="editForm.sistema.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-md-4"><label class="control-label" data-translate="chamadosApp.chamado.tipoChamado" for="field_tipoChamado">Tipo Chamado</label><select class="form-control" name="tipoChamado" ng-model="vm.chamado.tipoChamado" id="field_tipoChamado" required><option value="SUPORTE">Suporte ou D\xFAvida</option><option value="BUG">Bug</option><option value="MELHORIA">Melhoria</option><option value="NOVA_FUNCIONALIDADE">Nova Funcionalidade</option></select><div ng-show="editForm.tipoChamado.$invalid"><p class="help-block small" ng-show="editForm.tipoChamado.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-md-4"><label for="field_modulo">M\xF3dulo</label><select class="form-control" required ng-change="vm.carregarSubModulo()" id="field_modulo" name="modulo" ng-model="vm.chamado.modulo" ng-options="modulo as modulo.descricao for modulo in vm.modulos track by modulo.id"><option value=""></option></select><div ng-show="editForm.modulo.$invalid"><p class="help-block small" ng-show="editForm.modulo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-md-4"><label for="field_submodulo">Sub-M\xF3dulo</label><select class="form-control" required id="field_submodulo" name="submodulo" ng-model="vm.chamado.subModulo" ng-options="submodulo as submodulo.descricao for submodulo in vm.submodulos track by submodulo.id"><option value=""></option></select><div ng-show="editForm.submodulo.$invalid"><p class="help-block small" ng-show="editForm.submodulo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-md-4"><label class="control-label" data-translate="chamadosApp.chamado.severidade" for="field_severidade">Severidade</label><select class="form-control" name="severidade" ng-model="vm.chamado.severidade" id="field_severidade" required><option value="SEVERIDADE_0">Severidade 0</option><option value="SEVERIDADE_1">Severidade 1</option><option value="SEVERIDADE_2">Severidade 2</option><option value="SEVERIDADE_3">Severidade 3</option><option value="SEM_SEVERIDADE">Sem Severidade</option></select><div ng-show="editForm.severidade.$invalid"><p class="help-block small" ng-show="editForm.severidade.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-md-8"><label class="control-label" data-translate="chamadosApp.chamado.titulo" for="field_titulo">Titulo</label><input type="text" class="form-control" name="titulo" id="field_titulo" ng-model="vm.chamado.titulo" ng-blur="vm.chamado.releaseNotes = vm.chamado.titulo" required ng-minlength="2" ng-maxlength="255"><div ng-show="editForm.titulo.$invalid"><p class="help-block small" ng-show="editForm.titulo.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block small" ng-show="editForm.titulo.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block small" ng-show="editForm.titulo.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div><div class="form-group col-md-2" ng-if="!vm.chamado.id"><label for="field_situacao_inicial">Situa\xE7\xE3o inicial</label><select class="form-control" id="field_situacao_inicial" name="situacaoInicial" required ng-model="vm.chamado.situacao" ng-disabled="!vm.situacoesIniciais.length" ng-options="s.codigo as s.descricao for s in vm.situacoesIniciais"><option value="">{{ vm.chamado.cliente ? (vm.situacoesIniciais.length ? \'Selecione\' : \'Nenhuma situa\xE7\xE3o inicial configurada\') : \'Selecione o projeto\' }}</option></select></div><div class="form-group col-md-2" has-authority="ROLE_PO"><label class="control-label" for="tempoEstimado">Tempo Estimado em Horas</label><input type="number" class="form-control" name="tempoEstimado" id="tempoEstimado" ng-model="vm.chamado.tempoEstimado" required ng-minlength="0" ng-maxlength="9999"><div ng-show="editFormSolicitacao.tempoEstimado.$invalid"><p class="help-block" ng-show="editFormSolicitacao.tempoEstimado.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-md-12" ng-if="vm.chamado.cliente.exigirEntidadeSolicitante"><label for="entidadeSolicitante">Solicitante:</label><select class="form-control" required id="entidadeSolicitante" name="entidadeSolicitante" ng-model="vm.chamado.entidadeSolicitante" ng-options="entidadeSolicitante as entidadeSolicitante.nome for entidadeSolicitante in vm.solicitantes track by entidadeSolicitante.id"><option value=""></option></select><div ng-show="editForm.entidadeSolicitante.$invalid"><p class="help-block small" ng-show="editForm.entidadeSolicitante.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-md-12"><label class="control-label">Descri\xE7\xE3o</label><text-angular name="conteudo" required ng-model="vm.chamado.conteudo"></text-angular><div ng-show="editForm.conteudo.$invalid"><p class="help-block" ng-show="editForm.conteudo.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.conteudo.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="20">This field is required to be at least 20 characters.</p></div></div><div class="form-group col-md-12" ng-if="vm.chamado.id"><label class="control-label">Observa\xE7\xF5es do P.O.</label><text-angular name="descricaoPo" ng-model="vm.chamado.descricaoPo"></text-angular></div><div class="form-group col-md-12" ng-if="vm.chamado.tipoChamado != \'SUPORTE\'"><label class="control-label" for="field_criterio">Crit\xE9rio de Valida\xE7\xE3o (Descri\xE7\xE3o de como efetuar o teste)</label><textarea type="text" class="form-control" name="criterio" id="field_criterio" rows="5" style="overflow: auto" ng-model="vm.chamado.criterio" ng-minlength="2"> </textarea></div><div class="form-group col-md-12"><div class="mail-attachment m-b-md"><div class="file-manager"><ul class="folder-list" style="padding: 0"><ul class="folder-list" style="padding: 0"><li ng-repeat="anexo in vm.anexos"><i class="fa fa-trash m-r-lg" ng-click="vm.removerAnexo($index, vm.anexos)"></i> <i class="fa {{anexo.sincronizado? \'fa-cloud-download\' : \'fa-download\'}} m-r-lg" ng-click="vm.downloadAnexo($index, vm.anexos)"></i> <strong>{{anexo.criadoEm | date:\'mediumDate\' }}</strong> {{anexo.descricao}}</li><li ng-repeat="anexo in vm.anexosInternos" has-authority="ROLE_PO"><i class="fa fa-trash m-r-lg" ng-click="vm.removerAnexo($index, vm.anexosInternos)"></i> <i class="fa {{anexo.sincronizado? \'fa-cloud-download\' : \'fa-download\'}} m-r-lg" ng-click="vm.downloadAnexo($index, vm.anexosInternos)"></i> <strong>{{anexo.criadoEm | date:\'mediumDate\' }}</strong> {{anexo.descricao}}</li></ul></ul></div><div class="form-group col-md-12"><button ngf-select="vm.upload($file)" ngf-max-size="100MB" class="btn btn-block btn-default btn-outline"><i class="fa fa-upload"></i> Selecione um arquivo para anexar</button></div></div></div><div class="form-group col-md-12 text-center"><button type="button" class="btn btn-default" data-dismiss="modal" ui-sref="{{ vm.previousState }}"><span class="fa fa-ban"></span>&nbsp;<span>Voltar</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><i class="fa fa-save"></i> &nbsp;<span>Salvar</span></button> <button type="button" has-authority="ROLE_ATENDENTE" ng-show="vm.chamado.id && vm.chamado.situacao == \'ABERTO\'" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-success" ng-click="vm.aceitar()"><i class="fa fa-check"></i> &nbsp;<span>Aceitar</span></button> <button type="button" has-authority="ROLE_ATENDENTE" ng-show="vm.chamado.situacao != \'IMPEDIDO\' && vm.chamado.situacao != \'FECHADO\' && vm.chamado.id" ng-click="vm.impedir()" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-warning"><span class="fa fa-warning"></span> &nbsp;Impedir</button></div></form></div></div></div></div><div class="row" ng-if="vm.chamado.id && !vm.chamado.isEditing"><!-- Coluna Principal (Esquerda) --><div class="col-md-8"><div class="ibox" style="border-left: 5px solid #3d8cc3"><div class="ibox-title"><div class="pull-right"><a class="btn btn-primary btn-xs" ng-click="vm.chamado.isEditing = true" has-authority="ROLE_PO" ng-disabled="vm.isSaving"><i class="fa fa-pencil"></i> Editar</a></div><h3 style="margin-top: 0; margin-bottom: 10px"><span class="text-muted">Chamado: #{{vm.chamado.id}}</span></h3><h2 style="margin-top: 0; margin-bottom: 10px">{{vm.chamado.titulo}}</h2><div class="m-t-sm" style="flex-wrap: wrap; display: flex; gap: 4px"><span class="label label-default" data-translate="{{\'chamadosApp.TipoChamado.\' + vm.chamado.tipoChamado}}"></span> <span class="label label-danger" data-translate="{{\'chamadosApp.Severidade.\' + vm.chamado.severidade}}"></span> <span class="label label-success" ng-if="vm.chamado.complexidade">{{\'chamadosApp.ComplexidadeChamado.\' + vm.chamado.complexidade | translate}}</span> <span class="label label-info" data-translate="{{\'chamadosApp.SituacaoChamado.\' + vm.chamado.situacao}}"></span> <span class="label label-primary" ng-if="vm.chamado.sprint"><i class="fa fa-code-fork"></i> {{vm.chamado.sprint.descricao}}</span> <span class="label label-danger" ng-if="vm.chamado.sprint && !vm.chamado.planejado">NP</span> <a class="label label-primary" ui-sref="release-detail({versao:vm.chamado.release.versao, sistemaId: vm.chamado.release.sistema.id})" ng-if="vm.chamado.release"><i class="fa fa-code-fork"></i> {{vm.chamado.release.versao}} </a><span class="label label-primary" ng-if="vm.chamado.desenvolvimentoIniciado"><i class="fa fa-code-fork"></i> Desenvolvimento Iniciado</span> <span class="label label-default" ng-show="vm.chamado.alteracaoCodigo"><i class="fa fa-code"></i> C\xF3digo</span> <span class="label label-default" ng-show="vm.chamado.alteracaoTabela"><i class="fa fa-database"></i> Banco</span> <span class="label label-default" ng-show="vm.chamado.alteracaoArquitetura"><i class="fa fa-cubes"></i> Arquitetura</span> <span class="label" ng-repeat="tag in vm.tags" style="color: white; font-weight: bold; background: {{\'#\' + tag.cor}}">#{{tag.descricao}}</span> <a class="label label-default" title="Adicionar TAG" ng-click="vm.adicionarTag()" ng-show="vm.tags"><i class="fa fa-plus"></i> Tag</a></div></div><div class="ibox-content"><div class="row"><div class="col-md-12"><h4>Descri\xE7\xE3o</h4><div class="angular-with-newlines p-sm" style="background-color: #f9f9f9; border-radius: 4px" ng-bind-html="vm.chamado.conteudo"></div></div></div><div class="row m-t-md" ng-if="vm.chamado.criterio"><div class="col-md-12"><h4>Crit\xE9rio de Valida\xE7\xE3o</h4><div class="angular-with-newlines p-sm" style="background-color: #fcf8e3; border-radius: 4px; border-left: 4px solid #f8ac59" ng-bind-html="vm.chamado.criterio"></div></div></div><div class="row m-t-md" ng-if="vm.chamado.releaseNotes"><div class="col-md-12"><h4>Nota de Release</h4><div class="angular-with-newlines p-sm" style="background-color: #e2efda; border-radius: 4px; border-left: 4px solid #1ab394" ng-bind-html="vm.chamado.releaseNotes"></div></div></div><div class="row m-t-md" ng-if="vm.chamado.descricaoPo" has-any-authority="ROLE_ATENDENTE, ROLE_PO"><div class="col-md-12"><h4>Observa\xE7\xF5es do P.O.</h4><div class="angular-with-newlines p-sm" style="background-color: #d9edf7; border-radius: 4px; border-left: 4px solid #23c6c8" ng-bind-html="vm.chamado.descricaoPo"></div></div></div></div></div><!-- Coment\xE1rios --><div class="ibox m-t-md"><div class="ibox-title"><h5>Coment\xE1rios</h5></div><div class="ibox-content"><div class="chat-activity-list"><div class="chat-element {{comentario.usuario.id == vm.chamado.solicitante.id ? \'\' : \'right\'}}" ng-repeat="comentario in vm.comentarios | orderBy: \'criadoEm\'"><a href="#" class="{{comentario.usuario.id == vm.chamado.solicitante.id ? \'pull-left\' : \'pull-right\'}}"><img ng-src="{{comentario.imagemUsuario}}" ng-show="comentario.imagemUsuario" class="img-circle"> <img alt="image" class="img-circle" ng-show="!comentario.imagemUsuario" ng-src="/content/images/user-default.png"></a><div class="media-body {{comentario.usuario.id == vm.chamado.solicitante.id? \'\' : \'text-right\'}}"><small class="{{comentario.usuario.id != vm.chamado.solicitante.id? \'pull-left\' : \'pull-right\'}} text-muted">{{ comentario.criadoEm | date:\'dd/MM/yyyy HH:mm\'}} </small><strong>{{comentario.usuario.firstName}}</strong><div class="m-b-xs" style="white-space: pre-wrap" ng-bind-html="vm.trustAsHtml(\'<p>\' + comentario.descricao + \'</p>\')"></div></div></div></div><div class="chat-form m-t-md"><form role="form"><div class="form-group"><textarea type="text" class="form-control" placeholder="Escreva um coment\xE1rio..." name="comentario" id="field_comentario" ng-model="vm.comentario.descricao" ng-minlength="2" rows="3"></textarea></div><div class="text-right"><button type="button" ng-click="vm.comentar()" class="btn btn-sm btn-primary"><i class="fa fa-comments-o"></i> Comentar</button></div></form></div></div></div></div><!-- Coluna Lateral (Direita) --><div class="col-md-4"><!-- A\xE7\xF5es --><div class="ibox"><div class="ibox-title"><h5>A\xE7\xF5es</h5></div><div class="ibox-content"><button type="button" has-authority="ROLE_PO" ng-if="!vm.dependentes || vm.dependentes.length == 0" class="btn btn-danger btn-outline btn-block btn-sm" ng-click="vm.inserirDependenciaManual = true"><i class="fa fa-code-fork"></i> Criar Depend\xEAncia</button> <button type="button" has-any-authority="ROLE_ATENDENTE, ROLE_PO" class="btn btn-info btn-outline btn-block btn-sm" ng-click="vm.ajustarChamado()"><i class="fa fa-refresh"></i> Ajustar</button><div class="btn-group btn-block m-t-xs m-b-xs" uib-dropdown ng-if="vm.situacoesMoverFiltradas().length > 0"><button type="button" class="btn btn-primary btn-outline btn-block btn-sm" uib-dropdown-toggle ng-disabled="vm.isSaving"><i class="fa fa-arrow-right"></i> Mover <span class="caret"></span></button><ul class="dropdown-menu" uib-dropdown-menu role="menu" style="width: 100%"><li ng-repeat="situacao in vm.situacoesMoverFiltradas() track by situacao.id"><a href ng-click="vm.moverParaSituacao(situacao)"><i class="fa fa-circle" ng-style="{\'color\': situacao.cor || \'#999\', \'border-color\': situacao.cor || \'#999\'}"></i> &nbsp;{{situacao.descricao}}</a></li></ul></div><button type="button" has-authority="ROLE_PO" ui-sref="aprovar-desenvolvimento" ng-if="vm.chamado.situacaoConfig && vm.chamado.situacaoConfig.permiteCriarTarefa" ng-disabled="editForm.$invalid || vm.isSaving || !vm.chamado.id" class="btn btn-success btn-outline btn-block btn-sm"><i class="fa fa-code-fork"></i> Criar Tarefa</button> <button type="button" has-authority="ROLE_PO" ng-click="vm.copiarSimples()" ng-disabled="editForm.$invalid || vm.isSaving || !vm.chamado.id" class="btn btn-success btn-outline btn-block btn-sm"><i class="fa fa-copy"></i> Copiar</button> <button type="button" has-authority="ROLE_PO" ng-show="vm.chamado.situacao == \'AGUARDANDO_DESENVOLVIMENTO\'" ng-click="vm.alocarChamadoSprintAtual()" ng-disabled="editForm.$invalid || vm.isSaving || !vm.chamado.id" class="btn btn-success btn-outline btn-block btn-sm"><i class="fa fa-code-fork"></i> Alocar na sprint</button> <button type="button" has-authority="ROLE_PO" ng-show="vm.chamado.situacao == \'EM_DESENVOLVIMENTO\'" ng-click="vm.desalocarChamadoSprintAtual()" ng-disabled="editForm.$invalid || vm.isSaving || !vm.chamado.id" class="btn btn-danger btn-outline btn-block btn-sm"><i class="fa fa-code-fork"></i> Remover da sprint</button></div></div><!-- Detalhes --><div class="ibox"><div class="ibox-title"><h5>Detalhes</h5></div><div class="ibox-content no-padding"><ul class="list-group"><li class="list-group-item"><span class="pull-right text-muted">{{vm.chamado.cliente.nome}}</span> <strong>Cliente</strong></li><li class="list-group-item"><span class="pull-right text-muted">{{vm.chamado.sistema.nome}}</span> <strong>Sistema</strong></li><li class="list-group-item"><span class="pull-right text-muted">{{vm.chamado.modulo.descricao}}</span> <strong>M\xF3dulo</strong></li><li class="list-group-item" ng-if="vm.chamado.subModulo"><span class="pull-right text-muted">{{vm.chamado.subModulo.descricao}}</span> <strong>Sub-m\xF3dulo</strong></li></ul></div></div><!-- Pessoas --><div class="ibox"><div class="ibox-title"><h5>Pessoas</h5></div><div class="ibox-content no-padding"><ul class="list-group"><li class="list-group-item"><strong>Solicitante</strong><div class="m-t-sm"><img ng-src="{{vm.fotoSolicitante || \'/content/images/user-default.png\'}}" class="img-circle m-r-xs" width="24" alt="profile"> {{vm.chamado.solicitante.firstName}}<div class="text-muted small m-t-xs" ng-show="vm.chamado.entidadeSolicitante">Solicitado por: {{vm.chamado.entidadeSolicitante.nome}}</div><div class="text-muted small m-t-xs">Criado em: {{vm.chamado.criadoEm | date:\'mediumDate\'}}</div></div></li><li class="list-group-item" ng-show="vm.aceitoPor"><strong>Aceito Por</strong><div class="m-t-sm"><img ng-src="{{vm.aceitoPor.imagemUsuario || \'/content/images/user-default.png\'}}" class="img-circle m-r-xs" width="24" alt="profile"> {{vm.aceitoPor.usuario.firstName}}<div class="text-muted small m-t-xs"><time-ago from-time="{{vm.aceitoPor.criadoEm}}" format="dd/MM/yyyy h:mm a"></time-ago></div></div></li></ul></div></div><!-- Tickets em Desenvolvimento --><div class="ibox" has-authority="ROLE_ATENDENTE" ng-show="vm.solicitacoes.length > 0 || vm.inserirTicketManual"><div class="ibox-title"><h5>Tickets em Desenvolvimento</h5></div><div class="ibox-content no-padding"><ul class="list-group"><li class="list-group-item" ng-repeat="solicitacao in vm.solicitacoes | orderBy: \'numero\'"><a ui-sref="solicitacaoDesenvolvimento.detail({id:solicitacao.id})"><strong>#{{solicitacao.numero}}</strong> - {{solicitacao.tipo}} <span class="label label-success pull-right">{{solicitacao.situacao}}</span></a></li></ul></div></div><!-- Depend\xEAncias --><div class="ibox" ng-show="(vm.dependentes && vm.dependentes.length > 0) || vm.inserirDependenciaManual || (vm.relacoes && vm.relacoes.length > 0)"><div class="ibox-title"><h5>Depend\xEAncias</h5><div class="ibox-tools"><a class="text-danger" has-authority="ROLE_PO" ng-click="vm.removerTodasDependencia()" title="Remover Todas"><i class="fa fa-trash"></i></a></div></div><div class="ibox-content no-padding"><ul class="list-group"><li class="list-group-item" ng-repeat="dependente in vm.relacoes track by dependente.id"><i class="fa fa-level-down text-muted"></i> <a ui-sref="edit-chamado({id: dependente.chamadoId, search: null, situacao: null})" target="_blank"><strong>#{{dependente.chamadoId}}</strong> </a><span class="small text-muted">- {{dependente.tituloChamado | limitTo: 30}}{{dependente.tituloChamado.length > 30 ? \'...\' : \'\'}}</span> <a class="text-danger pull-right" has-authority="ROLE_PO" ng-click="vm.removerDependencia($index)"><i class="fa fa-times"></i></a></li><li class="list-group-item" ng-repeat="dependente in vm.dependentes track by dependente.id"><i class="fa fa-level-up text-muted"></i> <a ui-sref="edit-chamado({id: dependente.chamadoId, search: null, situacao: null})" target="_blank"><strong>#{{dependente.chamadoId}}</strong> </a><span class="small text-muted">- {{dependente.tituloChamado | limitTo: 30}}{{dependente.tituloChamado.length > 30 ? \'...\' : \'\'}}</span> <a class="text-danger pull-right" has-authority="ROLE_PO" ng-click="vm.removerDependencia($index)"><i class="fa fa-times"></i></a></li></ul><div class="p-sm" has-authority="ROLE_PO"><button class="btn btn-block btn-outline btn-danger btn-sm" ng-if="!vm.inserirDependenciaManual" ng-click="vm.inserirDependenciaManual = true" type="button"><i class="fa fa-code-fork"></i> Nova Depend\xEAncia</button><div class="input-group" ng-if="vm.inserirDependenciaManual"><input type="number" class="form-control input-sm" ng-model="vm.dependente" placeholder="N\xFAmero do Chamado"> <span class="input-group-btn"><button class="btn btn-danger btn-sm" ng-click="vm.criarDependencia()" type="button"><i class="fa fa-save"></i></button></span></div></div></div></div><!-- Tempo / Plano de Desenvolvimento --><div class="ibox" ng-show="vm.chamado.tempoEstimado || vm.tempoTotalGasto > 0 || vm.inserirHora"><div class="ibox-title"><h5>Tempo</h5></div><div class="ibox-content no-padding"><div class="p-sm text-center" style="background-color: #f8f8f9; border-bottom: 1px solid #e7eaec"><div class="row"><div class="col-xs-6"><small class="text-muted">Estimado</small><h3 class="no-margins">{{vm.chamado.tempoEstimado | number: fractionSize}}h</h3></div><div class="col-xs-6"><small class="text-muted">Gasto</small><h3 class="no-margins {{vm.chamado.tempoEstimado > vm.tempoTotalGasto ? \'text-success\' : \'text-danger\'}}">{{vm.tempoTotalGasto | number: fractionSize}}h</h3></div></div></div><table class="table small m-b-none" ng-show="vm.chamado.planoDesenvolvimento && vm.chamado.planoDesenvolvimento.length > 0"><thead><tr><th colspan="2" class="bg-muted">Plano de Desenvolvimento</th></tr></thead><tbody><tr ng-repeat="plano in vm.chamado.planoDesenvolvimento"><td class="p-l-md">{{\'chamadosApp.TipoHora.\' + plano.tipoHora | translate}}</td><td class="text-right p-r-md"><strong>{{plano.tempoEstimado | number: fractionSize}}h</strong></td></tr></tbody></table><table class="table small m-b-none" ng-show="vm.tempos && vm.tempos.length > 0"><thead><tr><th colspan="2" class="bg-muted">Tempo Gasto</th></tr></thead><tbody><tr ng-repeat="tempo in vm.tempos"><td class="p-l-md">{{tempo.tipo}}</td><td class="text-right p-r-md"><strong>{{tempo.tempo | number: fractionSize}}h</strong></td></tr></tbody></table></div></div><!-- Agrupador --><div class="ibox" ng-show="vm.agrupadores.length > 0"><div class="ibox-title"><h5>Agrupador</h5></div><div class="ibox-content no-padding"><table class="table small m-b-none"><tr ng-repeat="agrupador in vm.agrupadores"><td class="p-l-md"><a ui-sref="agrupador.edit({id:agrupador.id})">{{agrupador.nome}}</a></td><td>{{agrupador.criadoEm | date:\'mediumDate\'}}</td><td class="p-r-md">{{agrupador.previsaoEntrega | date:\'mediumDate\'}}</td></tr></table></div></div><!-- Anexos --><div class="ibox"><div class="ibox-title"><h5>Anexos</h5></div><div class="ibox-content no-padding"><table class="table small m-b-none"><tr ng-repeat="anexo in vm.anexos"><td class="p-l-md p-r-md"><a ng-click="vm.downloadAnexo($index, vm.anexos)" class="text-navy"><i class="fa {{anexo.sincronizado ? \'fa-cloud-download\' : \'fa-download\'}}"></i> {{anexo.descricao}} </a><a ng-click="vm.removerAnexo($index, vm.anexos)" class="text-danger pull-right"><i class="fa fa-trash"></i></a><br><small class="text-muted">{{anexo.criadoEm | date:\'mediumDate\'}}</small></td></tr><tr ng-repeat="anexo in vm.anexosInternos" has-authority="ROLE_PO"><td class="p-l-md p-r-md" style="background-color: #fdfdfd"><span class="label label-warning pull-right" style="margin-left: 5px">Interno</span> <a ng-click="vm.downloadAnexo($index, vm.anexosInternos)" class="text-navy"><i class="fa {{anexo.sincronizado ? \'fa-cloud-download\' : \'fa-download\'}}"></i> {{anexo.descricao}} </a><a ng-click="vm.removerAnexo($index, vm.anexosInternos)" class="text-danger pull-right"><i class="fa fa-trash"></i></a><br><small class="text-muted">{{anexo.criadoEm | date:\'mediumDate\'}}</small></td></tr></table><div class="p-sm text-center" style="background-color: #f8f8f9"><a ngf-select="vm.upload($file)" ngf-max-size="100MB" accept="image/*,application/pdf" class="btn btn-default btn-xs btn-block"><i class="fa fa-upload"></i> Anexar arquivo</a></div></div></div></div></div><script type="text/ng-template" id="rejeitarContent.html"><div class="modal-header">\n        <h3 class="modal-title" id="rejeicao-title">Rejei\xE7\xE3o de Chamado</h3>\n    </div>\n    <div class="modal-body" id="rejeicao-body">\n        <div class="row">\n            <div class="alert alert-danger text-center">\n                Qual o motivo para a rejei\xE7\xE3o do chamado?\n            </div>\n            <div class="col-md-12">\n                <table class="table">\n                    <tr class="{{vm.motivoRejeicao === \'NAO_ATENDIDO\' ? \'success\':\'\'}}">\n                        <td>\n                            <i class="fa fa-circle-o"\n                               ng-click="vm.motivoRejeicao = \'NAO_ATENDIDO\'"\n                               ng-show="vm.motivoRejeicao === \'ATENDIDO\' || !vm.motivoRejeicao"></i>\n                            <i class="fa fa-check-circle-o"\n                               ng-show="vm.motivoRejeicao === \'NAO_ATENDIDO\'"></i>\n                        </td>\n                        <td>\n                            Um ou mais de um item solicitado originalmente n\xE3o foi atendido.\n                        </td>\n                    </tr>\n                    <tr class="{{vm.motivoRejeicao === \'ATENDIDO\' ? \'success\':\'\'}}">\n                        <td>\n                            <i class="fa fa-circle-o"\n                               ng-click="vm.motivoRejeicao = \'ATENDIDO\'"\n                               ng-show="vm.motivoRejeicao === \'NAO_ATENDIDO\' || !vm.motivoRejeicao"></i>\n                            <i class="fa fa-check-circle-o"\n                               ng-show="vm.motivoRejeicao === \'ATENDIDO\'"></i>\n                        </td>\n                        <td>\n                            O solicitado originalmente foi atendido por\xE9m corre\xE7\xF5es s\xE3o necess\xE1rias para\n                            libera\xE7\xE3o.\n                        </td>\n                    </tr>\n                </table>\n            </div>\n        </div>\n\n        <div class="row" ng-if="vm.motivoRejeicao">\n            <form name="editFormRejeicao" role="form" novalidate show-validation>\n                <div class="form-group col-md-12" ng-if="vm.motivoRejeicao === \'NAO_ATENDIDO\'">\n                    <label class="control-label" for="field_item_rejeicao">Descreva o item ou os itens\n                        que n\xE3o foram\n                        atendidos</label>\n                    <textarea type="text" class="form-control"\n                              name="itemNaoAtendido" id="field_item_rejeicao"\n                              ng-model="vm.itemNaoAtendido"\n                              rows="10"\n                              required ng-minlength="20" ng-maxlength="3000"></textarea>\n\n                    <div ng-show="editFormRejeicao.itemNaoAtendido.$invalid">\n                        <p class="help-block"\n                           ng-show="editFormRejeicao.itemNaoAtendido.$error.required"\n                           data-translate="entity.validation.required">\n                            This field is required.\n                        </p>\n                        <p class="help-block"\n                           ng-show="editFormRejeicao.itemNaoAtendido.$error.minlength"\n                           data-translate="entity.validation.minlength"\n                           translate-value-min="20">\n                            This field is required to be at least 20 characters.\n                        </p>\n                        <p class="help-block"\n                           ng-show="editFormRejeicao.itemNaoAtendido.$error.maxlength"\n                           data-translate="entity.validation.maxlength"\n                           translate-value-max="3000">\n                            This field cannot be longer than 3000 characters.\n                        </p>\n                    </div>\n                </div>\n                <div class="form-group col-md-12">\n                    <label class="control-label" for="field_conteudo_rejeicao">\n                        {{vm.motivoRejeicao === \'NAO_ATENDIDO\' ? \'Descreva como realizar o teste e o\n                        motivo\n                    da\n                    rejei\xE7\xE3o\n                    \':\'\n                    Informe as melhorias\n                    necess\xE1rias\n                    para\n                    libera\xE7\xE3o\n                    do\n                    chamado\n                    \'}}\n                    </label>\n                    <textarea type="text" class="form-control"\n                              name="descricaoRejeicao" id="field_conteudo_rejeicao"\n                              ng-model="vm.descricaoRejeicao"\n                              rows="10"\n                              required ng-minlength="100" ng-maxlength="3000"></textarea>\n\n                    <div ng-show="editFormRejeicao.descricaoRejeicao.$invalid">\n                        <p class="help-block"\n                           ng-show="editFormRejeicao.descricaoRejeicao.$error.required"\n                           data-translate="entity.validation.required">\n                            This field is required.\n                        </p>\n                        <p class="help-block"\n                           ng-show="editFormRejeicao.descricaoRejeicao.$error.minlength"\n                           data-translate="entity.validation.minlength"\n                           translate-value-min="100">\n                            This field is required to be at least 100 characters.\n                        </p>\n                        <p class="help-block"\n                           ng-show="editFormRejeicao.descricaoRejeicao.$error.maxlength"\n                           data-translate="entity.validation.maxlength"\n                           translate-value-max="3000">\n                            This field cannot be longer than 3000 characters.\n                        </p>\n                    </div>\n                </div>\n                <div class="form-group col-md-12 text-center">\n                    <div class="alert alert-info">\n                        O motivo da rejei\xE7\xE3o deve ser claro, indicando os casos de teste que levaram a\n                        rejei\xE7\xE3o do\n                        chamado,\n                        os links das telas utilizadas e tamb\xE9m em qual ambiente foram realizados.\n                        <strong>Lembre-se de descrever o m\xE1ximo poss\xEDvel sobre as regras que envolvam o\n                            caso de\n                            uso;</strong>\n                    </div>\n                </div>\n                <div class="form-group col-md-12">\n                    <label class="control-label" for="field_ambiente">Em qua ambiente foi realizado e\n                        teste? (Ex.\n                        producao, homologacao, pre-producao e etc)</label>\n                    <input type="text" class="form-control"\n                           name="ambiente" id="field_ambiente"\n                           ng-model="vm.ambiente"\n                           required ng-minlength="5" ng-maxlength="150">\n\n                    <div ng-show="editFormRejeicao.ambiente.$invalid">\n                        <p class="help-block"\n                           ng-show="editFormRejeicao.ambiente.$error.required"\n                           data-translate="entity.validation.required">\n                            This field is required.\n                        </p>\n                        <p class="help-block"\n                           ng-show="editFormRejeicao.ambiente.$error.minlength"\n                           data-translate="entity.validation.minlength"\n                           translate-value-min="5">\n                            This field is required to be at least 5 characters.\n                        </p>\n                        <p class="help-block"\n                           ng-show="editFormRejeicao.ambiente.$error.maxlength"\n                           data-translate="entity.validation.maxlength"\n                           translate-value-max="150">\n                            This field cannot be longer than 150 characters.\n                        </p>\n                    </div>\n                </div>\n            </form>\n        </div>\n\n    </div>\n    <div class="modal-footer">\n        <button class="btn btn-default" type="button" ng-click="vm.cancel()">\n            <i class="fa fa-ban"></i>\n            Cancelar\n        </button>\n        <button class="btn btn-danger" type="button"\n                ng-disabled="!vm.ambiente || !vm.descricaoRejeicao || (vm.motivoRejeicao === \'NAO_ATENDIDO\' && !vm.itemNaoAtendido)"\n                ng-click="vm.ok()">\n            <i class="fa fa-exclamation-triangle"></i>\n            Rejeitar\n        </button>\n    </div></script><script type="text/ng-template" id="testarContent.html"><div class="modal-header">\n        <h3 class="modal-title" id="testar-title">Teste de Chamado</h3>\n    </div>\n    <div class="modal-body" id="testar-body">\n\n        <div class="row">\n            <form name="editFormRejeicao" role="form" novalidate show-validation>\n                <div class="form-group col-md-12">\n                    <label class="control-label" for="field_ambiente">Em qua ambiente foi realizado e\n                        teste? (Ex.\n                        producao, homologacao, pre-producao e etc)</label>\n                    <input type="text" class="form-control"\n                           name="ambiente" id="field_ambiente_teste"\n                           ng-model="vm.ambiente"\n                           required ng-minlength="5" ng-maxlength="150">\n\n                    <div ng-show="editFormRejeicao.ambiente.$invalid">\n                        <p class="help-block"\n                           ng-show="editFormRejeicao.ambiente.$error.required"\n                           data-translate="entity.validation.required">\n                            This field is required.\n                        </p>\n                        <p class="help-block"\n                           ng-show="editFormRejeicao.ambiente.$error.minlength"\n                           data-translate="entity.validation.minlength"\n                           translate-value-min="5">\n                            This field is required to be at least 5 characters.\n                        </p>\n                        <p class="help-block"\n                           ng-show="editFormRejeicao.ambiente.$error.maxlength"\n                           data-translate="entity.validation.maxlength"\n                           translate-value-max="150">\n                            This field cannot be longer than 150 characters.\n                        </p>\n                    </div>\n                </div>\n                <div class="form-group col-md-12">\n                    <label class="control-label">Houve atualiza\xE7\xE3o do manual?</label>\n                    <br/>\n                    <label>\n                        <input type="radio" ng-model="vm.manual" value="Sim">\n                        Sim\n                    </label><br/>\n                    <label>\n                        <input type="radio" ng-model="vm.manual" value="N\xE3o">\n                        N\xE3o\n                    </label><br/>\n\n                </div>\n                <div class="form-group col-md-12">\n                    <label class="control-label" for="field_item_rejeicao">Descreva como o teste foi\n                        realizado</label>\n                    <textarea type="text" class="form-control"\n                              name="itemNaoAtendido" id="field_item_teste"\n                              ng-model="vm.descricaoTeste"\n                              rows="5"\n                              required ng-minlength="20" ng-maxlength="3000"></textarea>\n\n                    <div ng-show="editFormRejeicao.itemNaoAtendido.$invalid">\n                        <p class="help-block"\n                           ng-show="editFormRejeicao.itemNaoAtendido.$error.required"\n                           data-translate="entity.validation.required">\n                            This field is required.\n                        </p>\n                        <p class="help-block"\n                           ng-show="editFormRejeicao.itemNaoAtendido.$error.minlength"\n                           data-translate="entity.validation.minlength"\n                           translate-value-min="20">\n                            This field is required to be at least 20 characters.\n                        </p>\n                        <p class="help-block"\n                           ng-show="editFormRejeicao.itemNaoAtendido.$error.maxlength"\n                           data-translate="entity.validation.maxlength"\n                           translate-value-max="3000">\n                            This field cannot be longer than 3000 characters.\n                        </p>\n                    </div>\n                </div>\n                <div class="form-group col-md-12">\n                    <ul class="folder-list" style="padding: 0">\n                        <li ng-repeat="anexo in vm.anexos">\n                            <i class="fa fa-trash m-r-lg" ng-click="vm.removerAnexo($index, vm.anexos)"></i>\n                            <i class="fa {{anexo.sincronizado? \'fa-cloud-download\' : \'fa-download\'}} m-r-lg"\n                               ng-click="vm.downloadAnexo($index, vm.anexos)"></i>\n                            <strong> {{anexo.criadoEm | date:\'mediumDate\' }}</strong>\n                            {{anexo.descricao}}\n                        </li>\n\n                        <li ng-repeat="anexo in vm.anexosInternos" has-authority="ROLE_PO">\n                            <i class="fa fa-trash m-r-lg" ng-click="vm.removerAnexo($index, vm.anexosInternos)"></i>\n                            <i class="fa {{anexo.sincronizado? \'fa-cloud-download\' : \'fa-download\'}} m-r-lg"\n                               ng-click="vm.downloadAnexo($index, vm.anexosInternos)"></i>\n                            <strong> {{anexo.criadoEm | date:\'mediumDate\' }}</strong>\n                            {{anexo.descricao}}\n                        </li>\n                    </ul>\n                </div>\n                <div class="form-group col-md-12">\n                    <button ngf-select="vm.upload($file)"\n                            ngf-max-size="100MB"\n                            class="btn btn-block btn-default btn-outline"\n                            accept="image/*,application/pdf">\n                        <i class="fa fa-upload"></i>\n                        Ou Selecione um arquivo para anexar\n                    </button>\n                </div>\n\n\n            </form>\n        </div>\n\n    </div>\n    <div class="modal-footer">\n        <button class="btn btn-default" type="button" ng-click="vm.cancel()">\n            <i class="fa fa-ban"></i>\n            Cancelar\n        </button>\n        <button class="btn btn-info" type="button"\n                ng-disabled="!vm.ambiente || !vm.descricaoTeste || !vm.manual"\n                ng-click="vm.ok()">\n            <i class="fa fa-exclamation-triangle"></i>\n            Encaminhar para Teste\n        </button>\n    </div></script><script type="text/ng-template" id="impedirContent.html"><div class="modal-header">\n        <h3 class="modal-title" id="impedir-title">Impedir Chamado</h3>\n    </div>\n    <div class="modal-body" id="impedir-body">\n        <div class="row">\n            <div class="alert alert-info text-center">\n                Qual o motivo para impedir do chamado?\n            </div>\n            <div class="col-md-12">\n                <form name="formImpedirChamado" role="form">\n                    <div class="form-group col-md-12">\n                        <label class="control-label" for="field_item_impedido">Descreva o motivo que o chamado foi\n                            impedido</label>\n                        <textarea type="text" class="form-control"\n                                  name="itemNaoAtendido" id="field_item_impedido"\n                                  ng-model="vm.motivoImpedido"\n                                  rows="10"\n                                  required ng-minlength="2" ng-maxlength="3000"></textarea>\n                    </div>\n                </form>\n            </div>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button class="btn btn-default" type="button" ng-click="vm.cancel()">\n            <i class="fa fa-ban"></i>\n            Cancelar\n        </button>\n        <button class="btn btn-danger" type="button"\n                ng-disabled="!vm.motivoImpedido"\n                ng-click="vm.ok()">\n            <i class="fa fa-exclamation-triangle"></i>\n            Impedir\n        </button>\n    </div></script><script type="text/ng-template" id="reabrirContent.html"><div class="modal-header">\n        <h3 class="modal-title" id="reabrirContent-title">Impedir Chamado</h3>\n    </div>\n    <div class="modal-body" id="reabrirContent-body">\n        <div class="row">\n            <div class="alert alert-info text-center">\n                Qual o motivo para reabrir do chamado?\n            </div>\n            <div class="col-md-12">\n                <form name="formReabrirChamado" role="form">\n                    <div class="form-group col-md-12">\n                        <label class="control-label" for="field_item_reabrir">Descreva o motivo que o chamado foi\n                            reaberto</label>\n                        <textarea type="text" class="form-control"\n                                  name="reabrir" id="field_item_reabrir"\n                                  ng-model="vm.motivoReabrir"\n                                  rows="10"\n                                  required ng-minlength="2" ng-maxlength="3000"></textarea>\n                    </div>\n                </form>\n            </div>\n            <div class="form-group col-md-12">\n                <ul class="folder-list" style="padding: 0">\n                    <li ng-repeat="anexo in vm.anexos">\n                        <i class="fa fa-trash m-r-lg" ng-click="vm.removerAnexo($index, vm.anexos)"></i>\n                        <i class="fa {{anexo.sincronizado? \'fa-cloud-download\' : \'fa-download\'}} m-r-lg"\n                           ng-click="vm.downloadAnexo($index, vm.anexos)"></i>\n                        <strong> {{anexo.criadoEm | date:\'mediumDate\' }}</strong>\n                        {{anexo.descricao}}\n                    </li>\n\n                    <li ng-repeat="anexo in vm.anexosInternos" has-authority="ROLE_PO">\n                        <i class="fa fa-trash m-r-lg" ng-click="vm.removerAnexo($index, vm.anexosInternos)"></i>\n                        <i class="fa {{anexo.sincronizado? \'fa-cloud-download\' : \'fa-download\'}} m-r-lg"\n                           ng-click="vm.downloadAnexo($index, vm.anexosInternos)"></i>\n                        <strong> {{anexo.criadoEm | date:\'mediumDate\' }}</strong>\n                        {{anexo.descricao}}\n                    </li>\n                </ul>\n            </div>\n            <div class="form-group col-md-12">\n                <button ngf-select="vm.upload($file)"\n                        ngf-max-size="100MB"\n                        class="btn btn-block btn-default btn-outline"\n                        accept="image/*,application/pdf">\n                    <i class="fa fa-upload"></i>\n                    Selecione um arquivo para anexar\n                </button>\n            </div>\n\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button class="btn btn-default" type="button" ng-click="vm.cancel()">\n            <i class="fa fa-ban"></i>\n            Cancelar\n        </button>\n        <button class="btn btn-danger" type="button"\n                ng-disabled="!vm.motivoReabrir"\n                ng-click="vm.ok()">\n            <i class="fa fa-exclamation-triangle"></i>\n            ReAbrir\n        </button>\n    </div></script><script type="text/ng-template" id="conferirMovimentacaoDialog.html"><div class="modal-header">\n        <h3 class="modal-title">Conferir chamado</h3>\n    </div>\n    <div class="modal-body">\n        <div class="row" ng-form="conferirForm">\n            <div class="form-group col-md-6">\n                <label for="field_modulo_conferir">M\xF3dulo</label>\n                <select class="form-control" required\n                        id="field_modulo_conferir" name="modulo"\n                        ng-model="vm.chamado.modulo"\n                        ng-change="vm.carregarSubModulo()"\n                        ng-options="modulo as modulo.descricao for modulo in vm.modulos track by modulo.id">\n                    <option value=""></option>\n                </select>\n            </div>\n            <div class="form-group col-md-6">\n                <label for="field_submodulo_conferir">Sub-M\xF3dulo</label>\n                <select class="form-control" required\n                        id="field_submodulo_conferir" name="submodulo"\n                        ng-model="vm.chamado.subModulo"\n                        ng-options="submodulo as submodulo.descricao for submodulo in vm.submodulos track by submodulo.id">\n                    <option value=""></option>\n                </select>\n            </div>\n            <div class="form-group col-md-6">\n                <label for="field_severidade_conferir">Severidade</label>\n                <select class="form-control" required\n                        name="severidade" id="field_severidade_conferir"\n                        ng-model="vm.chamado.severidade">\n                    <option value="SEVERIDADE_0">Severidade 0</option>\n                    <option value="SEVERIDADE_1">Severidade 1</option>\n                    <option value="SEVERIDADE_2">Severidade 2</option>\n                    <option value="SEVERIDADE_3">Severidade 3</option>\n                </select>\n            </div>\n            <div class="form-group col-md-6">\n                <label for="field_tipo_conferir">Tipo</label>\n                <select class="form-control" required\n                        name="tipoChamado" id="field_tipo_conferir"\n                        ng-model="vm.chamado.tipoChamado">\n                    <option value="SUPORTE">Suporte ou D\xFAvida</option>\n                    <option value="BUG">Bug</option>\n                    <option value="MELHORIA">Melhoria</option>\n                    <option value="NOVA_FUNCIONALIDADE">Nova Funcionalidade</option>\n                </select>\n            </div>\n            <div class="form-group col-md-6">\n                <label for="field_cliente_conferir">Projeto</label>\n                <select class="form-control" required\n                        id="field_cliente_conferir" name="cliente"\n                        ng-model="vm.chamado.cliente"\n                        ng-change="vm.carregarSistemas()"\n                        ng-options="cliente as cliente.nome for cliente in vm.clientes track by cliente.id">\n                    <option value=""></option>\n                </select>\n            </div>\n            <div class="form-group col-md-6">\n                <label for="field_sistema_conferir">Sistema</label>\n                <select class="form-control" required\n                        id="field_sistema_conferir" name="sistema"\n                        ng-model="vm.chamado.sistema"\n                        ng-options="sistema as sistema.nome for sistema in vm.sistemas track by sistema.id">\n                    <option value=""></option>\n                </select>\n            </div>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" ng-click="vm.cancel()">\n            <span class="fa fa-ban"></span>&nbsp;<span>Cancelar</span>\n        </button>\n        <button type="button" class="btn btn-primary"\n                ng-click="vm.ok()"\n                ng-disabled="conferirForm.$invalid || vm.isSaving">\n            <i class="fa fa-save"></i>&nbsp;<span>Confirmar</span>\n        </button>\n    </div></script><script type="text/ng-template" id="ajustarDialog.html"><div class="modal-header">\n        <h3 class="modal-title" id="ajustarDialog-title">Ajustar Chamado</h3>\n    </div>\n\n    <div class="modal-body" id="ajustarDialog-body">\n        <div class="row m-t-md"\n             ng-form="editFormPo">\n\n            <div class="form-group col-md-6" has-authority="ROLE_SCRUM">\n                <label for="field_situacaoChamado">Situa\xE7\xE3o</label>\n                <select class="form-control"\n                        name="situacaoChamado" ng-model="vm.chamado.situacao"\n                        id="field_situacaoChamado"\n                        required>\n                    <option value="BACKLOG">Backlog</option>\n                    <option value="ABERTO">Aberto</option>\n                    <option value="IMPEDIDO">Impedido</option>\n                    <option value="EM_SUPORTE">Fila Suporte</option>\n                    <option value="AGUARDANDO_DESENVOLVIMENTO">Fila Desenvolvimento</option>\n                    <option value="EM_DESENVOLVIMENTO">Em Desenvolvimento</option>\n                    <option value="AGUARDANDO_TESTE">Aguardando valida\xE7\xE3o t\xE9cnica</option>\n                    <option value="AGUARDANDO_VALIDACAO">Aguardando valida\xE7\xE3o do usu\xE1rio</option>\n                    <option value="EM_ANALISE">Em An\xE1lise</option>\n                    <option value="VALIDADO">Validado</option>\n                    <option value="FECHADO">Fechado</option>\n                    <option value="REJEITADO">Rejeitado</option>\n                    <option value="TESTE_SUPORTE">Teste do Suporte</option>\n                </select>\n                <div ng-show="editFormPo.situacaoChamado.$invalid">\n                    <p class="help-block"\n                       ng-show="editFormPo.situacaoChamado.$error.required"\n                       data-translate="entity.validation.required">\n                        This field is required.\n                    </p>\n                </div>\n            </div>\n\n            <div class="form-group col-md-6" has-authority="ROLE_SCRUM">\n                <label for="field_modulo">Ciclo</label>\n                <select class="form-control"\n\n                        id="field_sprint" name="modulo" ng-model="vm.chamado.sprint"\n                        ng-options="sprint as sprint.descricao for sprint in vm.sprints track by sprint.id">\n                    <option value=""></option>\n                </select>\n            </div>\n\n            <div class="form-group col-md-6">\n                <label for="field_moduloPO">M\xF3dulo</label>\n                <select class="form-control"\n                        required\n                        ng-change="vm.calcularOrdem(); vm.carregarSubModulo()"\n                        id="field_moduloPO" name="modulo" ng-model="vm.chamado.modulo"\n                        ng-options="modulo as modulo.descricao for modulo in vm.modulos track by modulo.id">\n                    <option value=""></option>\n                </select>\n                <div ng-show="editFormPo.modulo.$invalid">\n                    <p class="help-block"\n                       ng-show="editFormPo.modulo.$error.required"\n                       data-translate="entity.validation.required">\n                        This field is required.\n                    </p>\n                </div>\n            </div>\n\n            <div class="form-group col-md-6">\n                <label for="field_submoduloPO">Sub-M\xF3dulo</label>\n                <select class="form-control"\n                        required\n                        id="field_submoduloPO" name="submodulo" ng-model="vm.chamado.subModulo"\n                        ng-options="submodulo as submodulo.descricao for submodulo in vm.submodulos track by submodulo.id">\n                    <option value=""></option>\n                </select>\n                <div ng-show="editFormPo.submodulo.$invalid">\n                    <p class="help-block"\n                       ng-show="editFormPo.submodulo.$error.required"\n                       data-translate="entity.validation.required">\n                        This field is required.\n                    </p>\n                </div>\n            </div>\n\n            <div class="form-group col-md-6">\n                <label class="control-label" data-translate="chamadosApp.chamado.severidade"\n                       for="field_severidade"> Severidade</label>\n                <select class="form-control"\n                        name="severidade" ng-model="vm.chamado.severidade" id="field_severidade"\n                        required>\n                    <option value="SEVERIDADE_0">Severidade 0</option>\n                    <option value="SEVERIDADE_1">Severidade 1</option>\n                    <option value="SEVERIDADE_2">Severidade 2</option>\n                    <option value="SEVERIDADE_3">Severidade 3</option>\n                </select>\n                <div ng-show="editForm.severidade.$invalid">\n                    <p class="help-block"\n                       ng-show="editForm.severidade.$error.required"\n                       data-translate="entity.validation.required">\n                        This field is required.\n                    </p>\n                </div>\n            </div>\n\n            <div class="form-group col-md-6">\n                <label class="control-label" data-translate="chamadosApp.chamado.tipoChamado"\n                       for="field_tipoChamado">Tipo\n                    Chamado</label>\n                <select class="form-control"\n                        name="tipoChamado" ng-model="vm.chamado.tipoChamado" id="field_tipoChamado"\n                        required>\n                    <option value="SUPORTE">Suporte ou D\xFAvida</option>\n                    <option value="BUG">Bug</option>\n                    <option value="MELHORIA">Melhoria</option>\n                    <option value="NOVA_FUNCIONALIDADE">Nova Funcionalidade</option>\n                </select>\n                <div ng-show="editForm.tipoChamado.$invalid">\n                    <p class="help-block"\n                       ng-show="editForm.tipoChamado.$error.required"\n                       data-translate="entity.validation.required">\n                        This field is required.\n                    </p>\n                </div>\n            </div>\n            <div class="form-group col-md-6">\n                <label for="field_cliente">Projeto</label>\n                <select class="form-control"\n                        required\n                        id="field_cliente" name="cliente" ng-model="vm.chamado.cliente"\n                        ng-change="vm.carregarSistemas()"\n                        ng-options="cliente as cliente.nome for cliente in vm.clientes track by cliente.id">\n                    <option value=""></option>\n                </select>\n                <div ng-show="editForm.cliente.$invalid">\n                    <p class="help-block"\n                       ng-show="editForm.cliente.$error.required"\n                       data-translate="entity.validation.required">\n                        This field is required.\n                    </p>\n                </div>\n            </div>\n\n            <div class="form-group col-md-6">\n                <label for="field_cliente">Sistema</label>\n                <select class="form-control"\n                        required\n                        id="field_sistema" name="sistema" ng-model="vm.chamado.sistema"\n                        ng-options="sistema as sistema.nome for sistema in vm.sistemas track by sistema.id">\n                    <option value=""></option>\n                </select>\n                <div ng-show="editForm.sistema.$invalid">\n                    <p class="help-block"\n                       ng-show="editForm.sistema.$error.required"\n                       data-translate="entity.validation.required">\n                        This field is required.\n                    </p>\n                </div>\n            </div>\n\n            <div class="form-group col-md-12">\n\n                <table class="table">\n                    <tr>\n                        <th colspan="3">\n                            Tipo de Altera\xE7\xE3o\n                        </th>\n                    </tr>\n                    <tr>\n                        <td>\n                            <input type="checkbox" name="alteracaoCodigo" ng-model="vm.chamado.alteracaoCodigo">\n                            C\xF3digo Fonte\n                        </td>\n                        <td>\n                            <input type="checkbox" name="alteracaoTabela" ng-model="vm.chamado.alteracaoTabela">\n                            Banco de Dados\n                        </td>\n                        <td>\n                            <input type="checkbox" name="alteracaoArquitetura"\n                                   ng-model="vm.chamado.alteracaoArquitetura">\n                            Arquitetura\n                        </td>\n                    </tr>\n                </table>\n            </div>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal"\n                ng-click="vm.cancel()">\n            <span class="fa fa-ban"></span>&nbsp;<span>Cancelar</span>\n        </button>\n        <button type="button"\n                ng-click="vm.ok()"\n                ng-disabled="editFormPo.$invalid || vm.isSaving" class="btn btn-primary">\n            <i class="fa fa-save"></i>\n            &nbsp;<span>Salvar</span>\n        </button>\n    </div></script><script type="text/ng-template" id="reestimarChamado.html"><div class="modal-header">\n        <h3 class="modal-title">Re-estimar Chamado</h3>\n    </div>\n    <div class="modal-body">\n        <div class="row">\n            <form name="editFormSolicitacao" role="form" novalidate show-validation>\n\n                <div class="form-group col-md-6">\n                    <label class="control-label" for="tempoEstimado">Tempo Estimado em Horas </label>\n                    <input type="number"\n                           class="form-control" name="tempoEstimado"\n                           ng-model="vm.chamado.tempoEstimado"\n                           ng-change="vm.calcularPlanoDesenvolvimento()"\n                           required ng-minlength="0" ng-maxlength="9999">\n                    <div ng-show="editFormSolicitacao.tempoEstimado.$invalid">\n                        <p class="help-block"\n                           ng-show="editFormSolicitacao.tempoEstimado.$error.required"\n                           data-translate="entity.validation.required">\n                            This field is required.\n                        </p>\n                    </div>\n                </div>\n\n                <div class="form-group col-md-6">\n                    <label class="control-label"\n                           for="field_complexidade">Complexidade</label>\n                    <select class="form-control"\n                            name="field_complexidade" ng-model="vm.chamado.complexidade"\n                            ng-change="vm.calcularPlanoDesenvolvimento()"\n                            required>\n                        <option value="MUITO_BAIXA">(1) Muito Baixa</option>\n                        <option value="BAIXA">(2) Baixa</option>\n                        <option value="MEDIA">(3) M\xE9dia</option>\n                        <option value="ALTA">(4) Alta</option>\n                        <option value="MUITO_ALTA">(5) Muito Alta</option>\n                    </select>\n\n                    <div ng-show="editFormSolicitacao.field_complexidade.$invalid">\n                        <p class="help-block"\n                           ng-show="editFormSolicitacao.field_complexidade.$error.required"\n                           data-translate="entity.validation.required">\n                            This field is required.\n                        </p>\n                    </div>\n\n                </div>\n\n                <div class="form-group col-md-12" ng-show="vm.chamado.planoDesenvolvimento">\n\n                    <table class="table">\n                        <tr>\n                            <th colspan="2" class="text-center">\n                                Plano de Desenvolvimento do Chamado\n                            </th>\n                        </tr>\n                        <tr ng-repeat="plano in vm.chamado.planoDesenvolvimento">\n                            <td>{{\'chamadosApp.TipoHora.\' + plano.tipoHora | translate}}</td>\n                            <td class="col-md-4" ng-form="formPlanoDesenvolvimento">\n\n                                <input type="number"\n                                       class="form-control" name="planoEstimado"\n                                       ng-model="plano.tempoEstimado"\n                                       ng-change="vm.atualizarHoraEstimada()"\n                                       required ng-minlength="0" ng-maxlength="9999">\n\n                                <div ng-show="formPlanoDesenvolvimento.planoEstimado.$invalid">\n                                    <p class="help-block"\n                                       ng-show="formPlanoDesenvolvimento.planoEstimado.$error.required"\n                                       data-translate="entity.validation.required">\n                                        This field is required.\n                                    </p>\n                                </div>\n                            </td>\n                        </tr>\n                    </table>\n                </div>\n            </form>\n        </div>\n\n    </div>\n    <div class="modal-footer">\n        <button class="btn btn-default" type="button" ng-click="vm.cancel()">\n            <i class="fa fa-ban"></i>\n            Cancelar\n        </button>\n        <button class="btn btn-success" type="button"\n                ng-disabled="editFormSolicitacao.$invalid || vm.isSaving"\n                ng-click="vm.ok()">\n            <i class="fa fa-save"></i>\n            Salvar\n        </button>\n    </div></script><script type="text/ng-template" id="aceitarDialog.html"><form name="editarForm">\n        <div class="modal-header">\n            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">\n                &times;\n            </button>\n            <h4 class="modal-title">Confirme para prosseguir com o chamado</h4>\n        </div>\n        <div class="modal-body">\n            <div class="modal-body">\n                <div class="row">\n                    <div class="col-md-12">\n                        <div class="form-group col-md-12" ng-show="vm.renderPergunta(1)">\n                            <label class="control-label">\n                                {{vm.pergunta1}} (min. {{vm.minLenghtPergunta(1)}})\n                            </label>\n                            <textarea type="text"\n                                      class="form-control"\n                                      name="resposta1"\n                                      ng-model="vm.resposta1"\n                                      rows="3"\n                                      ng-required="vm.isRequiredPergunta(1)"\n                                      ng-minlength="vm.minLenghtPergunta(1)"\n                                      ng-maxlength="3000"></textarea>\n                        </div>\n                        <div class="form-group col-md-12" ng-show="vm.renderPergunta(2)">\n                            <label class="control-label">\n                                {{vm.pergunta2}} (min. {{vm.minLenghtPergunta(2)}})\n                            </label>\n                            <textarea type="text"\n                                      class="form-control"\n                                      name="resposta2"\n                                      ng-model="vm.resposta2"\n                                      rows="3"\n                                      ng-required="vm.isRequiredPergunta(2)"\n                                      ng-minlength="vm.minLenghtPergunta(2)"\n                                      ng-maxlength="3000"></textarea>\n                        </div>\n                        <div class="form-group col-md-12" ng-show="vm.renderPergunta(3)">\n                            <label class="control-label">\n                                {{vm.pergunta3}} (min. {{vm.minLenghtPergunta(3)}})\n                            </label>\n                            <textarea type="text"\n                                      class="form-control"\n                                      name="resposta3"\n                                      ng-model="vm.resposta3"\n                                      rows="3"\n                                      ng-required="vm.isRequiredPergunta(3)"\n                                      ng-minlength="vm.minLenghtPergunta(3)"\n                                      ng-maxlength="3000"></textarea>\n                        </div>\n                        <div class="form-group col-md-12" ng-show="vm.renderPergunta(4)">\n                            <label class="control-label">\n                                {{vm.pergunta4}} (min. {{vm.minLenghtPergunta(4)}})\n                            </label>\n                            <textarea type="text"\n                                      class="form-control"\n                                      name="resposta24"\n                                      ng-model="vm.resposta4"\n                                      rows="3"\n                                      ng-required="vm.isRequiredPergunta(4)"\n                                      ng-minlength="vm.minLenghtPergunta(4)"\n                                      ng-maxlength="3000"></textarea>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()">\n                <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancelar</span>\n            </button>\n            <button ng-disabled="editarForm.$invalid" class="btn btn-info" ng-click="vm.confirmAceite()">\n                <span class="glyphicon glyphicon-remove-circle"></span>&nbsp;Salvar\n            </button>\n        </div>\n    </form></script><script type="text/ng-template" id="validarDialog.html"><form name="editarForm">\n        <div class="modal-header">\n            <button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">\n                &times;\n            </button>\n            <h4 class="modal-title">Confirme a nota de release para continuar</h4>\n        </div>\n        <div class="modal-body">\n            <div class="modal-body">\n                <div class="row">\n                    <div class="form-group col-md-12">\n                        <label class="control-label"\n                               for="field_criterio">Nota de Release (Texto que ir\xE1 aparecer para o cliente)</label>\n                        <textarea type="text" class="form-control"\n                                  name="releaseNote" id="field_release_note_confirm"\n                                  rows="10"\n                                  style="overflow: auto"\n                                  ng-model="vm.chamado.releaseNotes"\n                                  required ng-minlength="2"> </textarea>\n                        <div ng-show="editForm.releaseNote.$invalid">\n                            <p class="help-block"\n                               ng-show="editForm.releaseNote.$error.required"\n                               data-translate="entity.validation.required">\n                                This field is required.\n                            </p>\n                            <p class="help-block"\n                               ng-show="editForm.releaseNote.$error.minlength"\n                               data-translate="entity.validation.minlength"\n                               translate-value-min="2">\n                                This field is required to be at least 2 characters.\n                            </p>\n                        </div>\n\n                        <div class="alert alert-info text-center m-t-sm">\n                            A nota de release vai aparecer ao cliente quando o chamado for enviado \xE0 produ\xE7\xE3o\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n        <div class="modal-footer">\n            <button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.cancel()">\n                <span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span>Cancelar</span>\n            </button>\n            <button ng-disabled="editarForm.$invalid" class="btn btn-info" ng-click="vm.ok()">\n                <span class="fa fa-save"></span>&nbsp;Salvar\n            </button>\n        </div>\n    </form></script><script type="text/ng-template" id="adicionarTagDialog.html"><div class="modal-body" id="adicionarTagDialog-body">\n        <div class="row m-t-md"\n             ng-form="editFormTag">\n            <div class="form-group col-md-8">\n                <label for="inputTag">Descri\xE7\xE3o</label>\n                <input type="text" ng-model="vm.filtroTag" placeholder="Descreva o nome da TAG"\n                       name="inputTag" ng-keypress="vm.search()"\n                       autocomplete="off"\n                       typeahead-on-select="vm.selecionou($item, $model, $label)"\n                       ng-blur="vm.saiuDoCampo()"\n                       uib-typeahead="tag as tag.descricao for tag in vm.tags  | limitTo:8"\n                       class="form-control" id="inputTag">\n            </div>\n            <div class="form-group col-md-4">\n                <label>Cor</label>\n                <color-picker\n                    ng-model="vm.tag.cor"\n                    options="vm.options"\n                ></color-picker>\n            </div>\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button type="button" class="btn btn-default" data-dismiss="modal"\n                ng-click="vm.cancel()">\n            <span class="fa fa-ban"></span>&nbsp;<span>Cancelar</span>\n        </button>\n        <button type="button" class="btn btn-success" ng-disabled="editFormTag.$invalid"\n                ng-click="vm.salvarTag()">\n            <i class="fa fa-save"></i>\n            &nbsp;<span>Salvar</span>\n        </button>\n    </div></script>');
$templateCache.put('app/entities/chamado/chamado-suporte.html','<div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-title">Registro de Atendimento ou Tarefa Extra</div><div class="ibox-content"><div class="row"><div class="col-md-12"><form name="editForm" role="form" novalidate ng-submit="vm.saveSuporte()" show-validation><div class="row"><div class="form-group col-md-3"><label for="field_cliente">Projeto</label><select class="form-control" required id="field_cliente" name="cliente" ng-model="vm.chamado.cliente" ng-change="vm.carregarSistemas()" ng-options="cliente as cliente.nome for cliente in vm.clientes track by cliente.id"><option value=""></option></select><div ng-show="editForm.cliente.$invalid"><p class="help-block" ng-show="editForm.cliente.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-md-3"><label for="field_cliente">Sistema</label><select class="form-control" required id="field_sistema" name="sistema" ng-model="vm.chamado.sistema" ng-options="sistema as sistema.nome for sistema in vm.sistemas track by sistema.id"><option value=""></option></select><div ng-show="editForm.sistema.$invalid"><p class="help-block" ng-show="editForm.sistema.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-md-3"><label for="field_modulo">M\xF3dulo</label><select class="form-control" required ng-change="vm.carregarSubModulo()" ng-disabled="(vm.chamado.id && vm.chamado.situacao != \'ABERTO\') || (vm.account.id != vm.chamado.solicitante.id)" id="field_modulo" name="modulo" ng-model="vm.chamado.modulo" ng-options="modulo as modulo.descricao for modulo in vm.modulos track by modulo.id"><option value=""></option></select><div ng-show="editForm.modulo.$invalid"><p class="help-block" ng-show="editForm.modulo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-md-3"><label for="field_submoduloPO">Sub-M\xF3dulo</label><select class="form-control" required id="field_submoduloPO" name="submodulo" ng-model="vm.chamado.subModulo" ng-options="submodulo as submodulo.descricao for submodulo in vm.submodulos track by submodulo.id"><option value=""></option></select><div ng-show="editFormPo.submodulo.$invalid"><p class="help-block" ng-show="editFormPo.submodulo.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="row"><div class="col-md-3"><label class="control-label">Data</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.chamado.criadoEm" is-open="vm.opened" required name="criadoEm" close-text="Close"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.opened = true"><i class="fa fa-calendar"></i></button></span></p><div ng-show="editForm.criadoEm.$invalid"><p class="help-block" ng-show="editForm.criadoEm.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-3 form-group"><label class="control-label">Atividade</label><select class="form-control text-black" ng-model="vm.tipo" placeholder="Tipo da atividade" required><option value=""></option><option value="DESENVOLVIMENTO">Desenvolvimento</option><option value="TESTE">Teste</option><option value="CERIMONIA_SCRUM">Cerim\xF4nia do SCRUM</option><option value="CORRECAO">Corre\xE7\xE3o</option><option value="DOCUMENTACAO">Documenta\xE7\xE3o</option><option value="ESTUDO">Estudo</option><option value="ANALISE">An\xE1lise</option><option value="AUDITORIA">Auditoria</option><option value="GERENCIA">Ger\xEAncia</option><option value="SUPORTE">Suporte</option><option value="CODE_REVIEW">Code Review</option><option value="REUNIAO">Reuni\xE3o</option><option value="INFRAESTRUTURA">Infraestrutura</option><option value="TREINAMENTO">Treinamento</option></select></div><div class="col-md-3 form-group"><label class="control-label">Complexidade</label><select class="form-control" name="field_complexidade" ng-model="vm.chamado.complexidade" required><option value="MUITO_BAIXA">(1) Muito Baixa</option><option value="BAIXA">(2) Baixa</option><option value="MEDIA">(3) M\xE9dia</option><option value="ALTA">(4) Alta</option><option value="MUITO_ALTA">(5) Muito Alta</option></select></div><div class="form-group col-md-3"><label class="control-label" for="field_tempo">Tempo Gasto</label><input type="number" class="form-control" required name="tempoEstimado" id="field_tempo" ng-model="vm.chamado.tempoEstimado"><div ng-show="editForm.tempoEstimado.$invalid"><p class="help-block" ng-show="editForm.tempoEstimado.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.tempoEstimado.$error.number" data-translate="entity.validation.number">This field should be a number.</p></div></div></div><div class="row"><div class="form-group col-md-12"><label class="control-label" for="field_conteudo">Descri\xE7\xE3o</label><textarea type="text" ng-readonly="(vm.chamado.id && vm.chamado.situacao != \'ABERTO\') || (vm.account.id != vm.chamado.solicitante.id)" class="form-control" name="conteudo" id="field_conteudo" ng-model="vm.chamado.conteudo" rows="10" required ng-minlength="2" ng-maxlength="30000"></textarea><div ng-show="editForm.conteudo.$invalid"><p class="help-block" ng-show="editForm.conteudo.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.conteudo.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.conteudo.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="255">This field cannot be longer than 255 characters.</p></div></div></div><div class="form-group col-md-12 text-center"><button type="button" class="btn btn-default" data-dismiss="modal" ui-sref="{{ vm.previousState }}"><span class="fa fa-ban"></span>&nbsp;<span>Voltar</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><i class="fa fa-save"></i> &nbsp;<span>Salvar</span></button></div></form></div></div></div></div></div></div>');
$templateCache.put('app/entities/chamado/chamados.html','<div ng-cloak ng-switch="vm.isAuthenticated()"><div class="row" ng-switch-when="false"><div class="col-md-12"><div class="alert alert-warning" data-translate="global.messages.info.authenticated" translate-compile>If you want to <a class="alert-link" href="" ng-click="vm.login()">sign in</a>, you can try the default accounts:<br>- Administrator (login="admin" and password="admin")<br>- User (login="user" and password="user").</div><div class="alert alert-warning" ng-switch-when="false" data-translate="global.messages.info.register" translate-compile>You don\'t have an account yet? <a class="alert-link" ui-sref="register">Register a new account</a></div></div></div><div class="row" ng-switch-when="true"><div class="row" ng-show="!vm.situacao"><div class="col-md-12"><div class="ibox"><div class="ibox-title">Filtros</div><div class="ibox-content"><div class="row"><form name="editForm" role="form" novalidate show-validation><div class="form-group col-md-2"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.chamado.id"></div><div class="form-group col-md-3"><label for="field_modulo">M\xF3dulo</label><select class="form-control" required id="field_modulo" name="modulo" ng-model="vm.chamado.modulo" ng-options="modulo as modulo.descricao for modulo in vm.modulos track by modulo.id"><option value=""></option></select></div><div class="form-group col-md-4"><label for="field_submodulo">Sub-M\xF3dulo</label><select class="form-control" required id="field_submodulo" name="submodulo" ng-model="vm.chamado.subModulo" ng-options="subModulo as subModulo.descricao for subModulo in vm.subModulos track by subModulo.id"><option value=""></option></select></div><div class="form-group col-md-3"><label for="field_cliente">Projeto</label><select class="form-control" id="field_cliente" name="cliente" ng-model="vm.chamado.cliente" ng-change="vm.carregarSolicitantes()" ng-options="cliente as cliente.nome for cliente in vm.clientes track by cliente.id"><option value=""></option></select></div><div class="form-group col-md-3"><label for="field_modulo">Ciclo</label><select class="form-control" id="field_sprint" name="modulo" ng-model="vm.chamado.sprint" ng-options="sprint as sprint.descricao for sprint in vm.sprints track by sprint.id"><option value=""></option></select></div><div class="form-group col-md-3"><label class="control-label" data-translate="chamadosApp.chamado.tipoChamado" for="field_tipoChamado">Tipo Chamado</label><select class="form-control" name="tipoChamado" ng-model="vm.chamado.tipoChamado" id="field_tipoChamado"><option value="SUPORTE">Suporte ou D\xFAvida</option><option value="BUG">Bug</option><option value="MELHORIA">Melhoria</option><option value="NOVA_FUNCIONALIDADE">Nova Funcionalidade</option></select></div><div class="form-group col-md-3"><label class="control-label" for="field_relacionados">Solicitante/Respos\xE1vel</label><select class="form-control" name="field_relacionados" ng-model="vm.chamado.apenasMeus" id="field_relacionados"><option value="{{false}}">Todos</option><option value="{{true}}">Apenas eu</option></select></div><div class="form-group col-md-3"><label for="field_situacaoChamado">Situa\xE7\xE3o</label><select class="form-control" name="situacaoChamado" ng-model="vm.chamado.situacao" ng-options="situacao as \'chamadosApp.SituacaoChamado.\' + situacao | translate for situacao in vm.situacoes" id="field_situacaoChamado"><option value=""></option></select></div><div class="form-group col-md-12" ng-show="vm.chamado.cliente.exigirEntidadeSolicitante"><label for="field_entidadeSolicitante">Solicitante:</label><select class="form-control" required id="field_entidadeSolicitante" name="field_entidadeSolicitante" ng-model="vm.chamado.entidadeSolicitante" ng-options="entidadeSolicitante as entidadeSolicitante.nome for entidadeSolicitante in vm.solicitantes track by entidadeSolicitante.id"><option value=""></option></select></div><div class="form-group col-md-8"><label class="control-label" for="titulo">Titulo/Descri\xE7\xE3o</label><input type="text" class="form-control" id="titulo" name="titulo" ng-model="vm.chamado.titulo"></div><div class="col-md-4"><label for="inputTag">Tag</label><input type="text" ng-model="vm.tagdescricao" placeholder="Selecione um TAG" autocomplete="off" uib-typeahead="tag as tag.descricao for tag in vm.tags | filter:vm.tagdescricao  | limitTo:8" class="form-control" id="inputTag"></div><div class="form-group col-md-2"><label class="control-label">&ensp;</label><button ng-click="vm.loadAll()" class="btn btn-success btn-block"><i class="fa fa-search"></i> Buscar</button></div><div class="form-group col-md-2"><label class="control-label">&ensp;</label><button ng-click="vm.limpar()" class="btn btn-default btn-block"><i class="fa fa-times"></i> Limpar</button></div></form></div></div></div></div></div><div class="row p-md"><div class="col-md-2" ng-if="vm.situacao"><div class="ibox"><div class="ibox-content mailbox-content no-padding"><div class="file-manager"><h5>Projetos</h5><ul class="folder-list m-b-md" style="padding: 0"><li ng-repeat="cliente in vm.clientesChamado"><a ng-click="vm.selecionarCliente(cliente)" title="{{cliente.nome}}"><i class="fa {{vm.chamado.cliente.id == cliente.id ?\'fa-close\':\'fa-circle-o\'}}"></i> {{cliente.nome| limitTo: 15 }}{{cliente.nome.length > 15 ? \'...\' : \'\'}} <span class="label {{vm.chamado.cliente.id == cliente.id ?\'label-success\':\'label-default\'}} float-right pull-right">{{vm.clientesChamado[cliente.nome].quantidade}}</span></a></li></ul><h5>Tipos</h5><ul class="folder-list m-b-md" style="padding: 0"><li ng-repeat="tipoChamado in vm.tiposChamado"><a title="{{\'chamadosApp.TipoChamado.\' +tipoChamado.nome | translate}}" ng-click="vm.filtrarApenasPorTipoChamado(tipoChamado)"><i class="fa {{vm.chamado.tipoChamado == tipoChamado.nome ?\'fa-close\':\'fa-circle-o\'}}"></i> {{(\'chamadosApp.TipoChamado.\' + tipoChamado.nome | translate)| limitTo: 15 }}{{tipoChamado.nome > 15 ? \'...\' : \'\'}} <span class="label label-{{vm.getCorPorTipo(tipoChamado.nome)}} float-right pull-right">{{tipoChamado.quantidade}}</span></a></li></ul><h5>M\xF3dulos</h5><ul class="category-list" style="padding: 0"><li ng-repeat="modulo in vm.modulosChamado"><a ng-click="vm.filtrarApenasPorModulo(modulo); "><i class="fa {{vm.chamado.modulo.id == modulo.id ?\'fa-close\':\'fa-circle-o\'}}"></i> {{modulo.nome}} <span class="label float-right pull-right">{{modulo.quantidade}}</span></a></li></ul><div class="clearfix"></div></div></div></div></div><div class="{{vm.situacao? \'col-md-10\': \'col-md-12\'}} no-margins"><div class="ibox"><div class="ibox-content no-margins"><div class="table-responsive"><table class="table table-striped table-hover"><tr class="small" jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th class="issue-info cursor-pointer"><span jh-sort-by="chamado.severidade">Severidade </span><small jh-sort-by="chamado.tipo_chamado">Tipo</small></th><th class="issue-info cursor-pointer"><span jh-sort-by="chamado.id">N\xBA do chamado </span><small><span jh-sort-by="chamado.ordem">Ordem</span>/ <span jh-sort-by="chamado.titulo">Titulo</span></small></th><th class="issue-info cursor-pointer"><span jh-sort-by="solicitante.first_name">Solicitante </span><small jh-sort-by="responsavel.first_name">Respons\xE1vel</small></th><th class="issue-info cursor-pointer"><span jh-sort-by="chamado.criado_em">Criado Em </span><small jh-sort-by="chamado.tempo_estimado">T. Estimado</small></th><th class="issue-info cursor-pointer"><span jh-sort-by="modulo.descricao">M\xF3dulo </span><small jh-sort-by="sub_modulo.descricao">Sub-M\xF3dulo</small></th><th class="text-center cursor-pointer"><span jh-sort-by="sistema.nome">Sistema</span></th><th class="cursor-pointer" ng-show="!vm.situacao"><span jh-sort-by="chamado.situacao">Situa\xE7\xE3o</span></th><th class="cursor-pointer" ng-if="vm.situacao == \'EM_DESENVOLVIMENTO\' || vm.situacao == \'TESTE_SUPORTE\'"><span jh-sort-by="sprint.descricao">Ciclo</span></th></tr><tbody><tr class="{{chamado.situacao == \'REJEITADO\'? \'danger\':\'\'}} {{chamado.situacao == \'TESTE_SUPORTE\'? \'warning\':\'\'}} {{chamado.situacao == \'VALIDADO\'? \'info\':\'\'}}" ng-repeat="chamado in vm.chamados track by chamado.id"><td class="issue-info"><span class="strong" data-translate="{{\'chamadosApp.Severidade.\' + chamado.severidade}}">{{chamado.severidade}}</span> <small><span class="text-{{vm.getCorPorTipo(chamado.tipoChamado)}}" data-translate="{{\'chamadosApp.TipoChamado.\' + chamado.tipoChamado}}">{{chamado.tipoChamado}}</span></small></td><td class="issue-info" style="width: 30%"><a ui-sref="edit-chamado({id:chamado.id, search: null, situacao: null})">#{{chamado.id}} <span class="text-danger small" ng-if="chamado.possuiDependencias"><i class="fa fa-exclamation-triangle"></i> Possui Depend\xEAncias </span><span class="text-info small" has-authority="ROLE_PO" ng-if="chamado.chamadoAdiantado"><i class="fa fa-check"></i> (Adiantado) </span><span class="text-success small" has-authority="ROLE_PO" ng-if="chamado.situacaoTicket">{{chamado.situacaoTicket}} </span></a><span ng-if="chamado.sprint && !chamado.planejado" class="small label">NP</span> <small title="{{chamado.titulo}}">{{chamado.ordem}}-{{chamado.titulo | limitTo: 50 }}{{chamado.titulo.length > 50 ? \'...\' : \'\'}}</small></td><td class="issue-info" style="width: 10%">{{chamado.solicitante}} <small>{{chamado.responsavel}}</small></td><td class="issue-info">{{chamado.criadoEm | date:\'mediumDate\'}} <small><i ng-if="chamado.tempoEstimado" class="fa fa-clock-o"></i> {{chamado.tempoEstimado}}</small></td><td class="issue-info">{{chamado.modulo}} <small title=" {{chamado.subModulo}}">{{chamado.subModulo | limitTo: 50 }}{{chamado.subModulo.length > 50 ? \'...\' : \'\'}}</small></td><td class="text-center">{{chamado.sistema}}</td><td ng-show="!vm.situacao"><span data-translate="{{\'chamadosApp.SituacaoChamado.\' + chamado.situacao}}">{{chamado.situacao}}</span></td><td ng-if="vm.situacao == \'EM_DESENVOLVIMENTO\' || vm.situacao == \'TESTE_SUPORTE\'">{{chamado.sprint}}</td></tr></tbody></table><a ng-click="vm.imprimir()" class="pull-right"><i class="fa fa-print"></i> Imprimir</a></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div><script type="text/ng-template" id="myModalContent.html"><div class="modal-header">\n        <h3 class="modal-title" id="modal-title">Rejei\xE7\xE3o de Chamado</h3>\n    </div>\n    <div class="modal-body" id="modal-body">\n        <div class="alert alert-warning">Tem certeza que deseja rejeitar esse chamado?</div>\n        <label class="control-label" for="field_conteudo">Motivo</label>\n        <textarea type="text" class="form-control" name="conteudo" id="field_conteudo"\n                  required ng-minlength="2" ng-maxlength="3000"/>\n    </div>\n    <div class="modal-footer">\n        <button class="btn btn-default" type="button" ng-click="vm.cancel()">Cancelar</button>\n        <button class="btn btn-danger" type="button" ng-click="vm.ok()">\n            <i class="glyphicon glyphicon-warning-sign"></i>\n            N\xE3o foi cumprido\n        </button>\n        <button class="btn btn-warning" type="button" ng-click="vm.cancel()">\n            <i class="glyphicon glyphicon-console"></i>\n            Solciitar Melhorias\n        </button>\n    </div></script>');
$templateCache.put('app/entities/chamado/nova-tarefa-chamado.html','<div class="ibox"><div class="ibox-title"><h2><span class="label label-warning m-r-sm">Nova tarefa</span> Chamado <strong>#{{vm.chamado.id}}</strong> \u2014 {{vm.chamado.titulo}}</h2><p class="text-muted small m-t-xs" ng-if="vm.chamado.situacaoConfig">Situa\xE7\xE3o atual: {{vm.chamado.situacaoConfig.descricao}} <span class="text-info">(a situa\xE7\xE3o do chamado n\xE3o ser\xE1 alterada)</span></p></div><div class="ibox-content"><form name="novaTarefaForm" role="form" novalidate ng-submit="vm.salvar()"><div class="row"><div class="form-group col-md-8"><label for="field_titulo_tarefa">T\xEDtulo da tarefa</label><input type="text" class="form-control" id="field_titulo_tarefa" name="titulo" ng-model="vm.solicitacaoDesenvolvimento.titulo" required ng-minlength="2" ng-maxlength="255"></div><div class="form-group col-md-4"><label for="field_tipo_tarefa">Tipo</label><select class="form-control" id="field_tipo_tarefa" name="tipo" ng-model="vm.solicitacaoDesenvolvimento.tipo" required ng-options="t as t for t in vm.tiposTarefa"></select></div></div><div class="row"><div class="form-group col-md-4"><label for="field_tempo_tarefa">Tempo estimado (horas)</label><input type="number" class="form-control" id="field_tempo_tarefa" name="tempoEstimado" ng-model="vm.solicitacaoDesenvolvimento.tempoEstimado" required min="0.5" step="0.5"></div></div><div class="alert alert-info small">M\xF3dulo, crit\xE9rio e descri\xE7\xE3o ser\xE3o herdados do chamado. Voc\xEA pode criar quantas tarefas forem necess\xE1rias enquanto o chamado estiver nesta situa\xE7\xE3o.</div><div class="text-right"><button type="button" class="btn btn-default" ng-click="vm.cancelar()" ng-disabled="vm.isSaving">Cancelar</button> <button type="submit" class="btn btn-primary" ng-disabled="novaTarefaForm.$invalid || vm.isSaving"><i class="fa fa-save"></i> Criar tarefa</button></div></form></div></div>');
$templateCache.put('app/entities/chamado/solicitar-tarefa.html','<div class="ibox"><div class="ibox-content" id="modal-body"><div class="col-md-12"><h2><strong>#{{vm.chamado.id}}</strong> {{vm.chamado.titulo}}</h2><h4 class="no-margins"><span class="m-r-sm" data-translate="{{\'chamadosApp.TipoChamado.\' + vm.chamado.tipoChamado}}">tipo </span><small class="text-muted m-r-sm">{{vm.chamado.cliente.nome}} </small><small class="text-muted m-r-sm">{{vm.chamado.sistema.nome}} </small><small class="text-muted m-r-sm">{{vm.chamado.modulo.descricao}} </small><small class="text-muted m-r-sm">{{vm.chamado.subModulo.descricao}}</small></h4></div><div class="row"><form name="editFormSolicitacao" role="form" novalidate show-validation><div class="form-group col-md-12 p-md"><div class="mail-box"><strong>Descri\xE7\xE3o do Chamado</strong><div ng-bind-html="vm.chamado.conteudo"></div></div><div class="mail-box"><strong>Criterio de Valida\xE7\xE3o</strong><div class="small angular-with-newlines">{{vm.chamado.criterio}}</div></div></div><div class="form-group col-md-12"><label class="control-label" for="field_conteudo_socilitacao">Observa\xE7\xF5es do P.O</label><small>(Descri\xE7\xE3o resumida para entendimento t\xE9cnico do desenvolvedor)</small> <a ng-click="vm.melhorarComIa()" ng-show="!vm.gerandoComIa"><i class="fa fa-magic"></i> Gerar com I.A. </a><span ng-show="vm.gerandoComIa"><i class="fa fa-spinner fa-spin"></i> Gerando Texto, isso pode levar alguns minutos!</span><text-angular name="conteudo" required ng-minlength="15" name="conteudo" id="field_conteudo_socilitacao" ng-model="vm.chamado.descricaoPo"></text-angular><div ng-show="editFormSolicitacao.conteudo.$invalid"><p class="help-block" ng-show="editFormSolicitacao.conteudo.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editFormSolicitacao.conteudo.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="15">This field is required to be at least 15 characters.</p><p class="help-block" ng-show="editFormSolicitacao.conteudo.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="3000">This field cannot be longer than 3000 characters.</p></div></div><div class="form-group col-md-12"><label class="control-label" for="field_criterio">Nota de Release (Texto que ir\xE1 aparecer para o cliente)</label><input type="text" class="form-control" name="releaseNote" id="field_release_note" ng-model="vm.chamado.releaseNotes" required ng-minlength="2"><div ng-show="editFormSolicitacao.releaseNote.$invalid"><p class="help-block" ng-show="editFormSolicitacao.releaseNote.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editFormSolicitacao.releaseNote.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p></div></div><div class="form-group col-md-12" ng-if="!vm.chamado.criterio"><label class="control-label" for="field_criterio">Crit\xE9rio de valida\xE7\xE3o</label><small>(O Chamado n\xE3o tem crit\xE9rio de valida\xE7\xE3o, infome para que o desenvolvedor consiga efetuar o teste)</small><textarea type="text" class="form-control" name="criterio" id="field_criterio" ng-model="vm.criterio" rows="4" required ng-minlength="10" ng-maxlength="3000"></textarea><div ng-show="editFormSolicitacao.criterio.$invalid"><p class="help-block" ng-show="editFormSolicitacao.criterio.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editFormSolicitacao.criterio.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="10">This field is required to be at least 50 characters.</p><p class="help-block" ng-show="editFormSolicitacao.criterio.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="3000">This field cannot be longer than 3000 characters.</p></div></div><div class="form-group"><div class="col-md-4"><label class="control-label" for="tempoEstimado">Tempo Estimado em Horas</label><input type="number" class="form-control" name="tempoEstimado" id="tempoEstimado" ng-model="vm.chamado.tempoEstimado" ng-change="vm.calcularPlanoDesenvolvimento()" required ng-minlength="0" ng-maxlength="9999"><div ng-show="editFormSolicitacao.tempoEstimado.$invalid"><p class="help-block" ng-show="editFormSolicitacao.tempoEstimado.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-4"><label class="control-label" for="horaAnalise">Horas utilizadas para an\xE1lise</label><input type="number" class="form-control" name="horaAnalise" id="horaAnalise" ng-model="vm.horaAnalise" required ng-minlength="0" ng-maxlength="9999"><div ng-show="editFormSolicitacao.horaAnalise.$invalid"><p class="help-block" ng-show="editFormSolicitacao.horaAnalise.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="col-md-4"><label class="control-label" for="horaAnalise">&ensp;</label><button ngf-select="vm.upload($file)" ngf-max-size="100MB" class="btn btn-block btn-default btn-outline"><i class="fa fa-upload"></i> Selecione um arquivo para anexar</button><div class="file-manager"><ul class="folder-list" style="padding: 0"><ul class="folder-list" style="padding: 0"><li ng-repeat="anexo in vm.anexos"><i class="fa fa-trash m-r-lg" ng-click="vm.removerAnexo($index, vm.anexos)"></i> <i class="fa {{anexo.sincronizado? \'fa-cloud-download\' : \'fa-download\'}} m-r-lg" ng-click="vm.downloadAnexo($index, vm.anexos)"></i> <strong>{{anexo.criadoEm | date:\'mediumDate\' }}</strong> {{anexo.descricao}}</li><li ng-repeat="anexo in vm.anexosInternos" has-authority="ROLE_PO"><i class="fa fa-trash m-r-lg" ng-click="vm.removerAnexo($index, vm.anexosInternos)"></i> <i class="fa {{anexo.sincronizado? \'fa-cloud-download\' : \'fa-download\'}} m-r-lg" ng-click="vm.downloadAnexo($index, vm.anexosInternos)"></i> <strong>{{anexo.criadoEm | date:\'mediumDate\' }}</strong> {{anexo.descricao}}</li></ul></ul></div></div></div><div class="form-group col-md-12 m-t-sm" ng-show="vm.chamado.planoDesenvolvimento"><div class="col-md-3" ng-repeat="plano in vm.chamado.planoDesenvolvimento"><label class="control-label">{{\'chamadosApp.TipoHora.\' + plano.tipoHora | translate}} (Hrs)</label><input type="number" class="form-control" name="planoEstimado" ng-model="plano.tempoEstimado" ng-change="vm.atualizarHoraEstimada()" required ng-minlength="0" ng-maxlength="9999"><div ng-show="formPlanoDesenvolvimento.planoEstimado.$invalid"><p class="help-block" ng-show="formPlanoDesenvolvimento.planoEstimado.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div></form></div><button class="btn btn-default" type="button" ng-click="vm.cancel()"><i class="fa fa-ban"></i> Cancelar</button> <button class="btn btn-success" type="button" ng-disabled="editFormSolicitacao.$invalid || vm.isSaving" ng-click="vm.ok()"><i class="fa fa-desktop"></i> Encaminhar</button></div></div>');
$templateCache.put('app/entities/cliente/cliente-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myClienteLabel" data-translate="chamadosApp.cliente.home.createOrEditLabel">Create or edit a Cliente</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.cliente.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.cliente.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="chamadosApp.cliente.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.cliente.nome" required ng-minlength="2" ng-maxlength="100"><div ng-show="editForm.nome.$invalid"><p class="help-block" ng-show="editForm.nome.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nome.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.nome.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="chamadosApp.cliente.projetoRedMine" for="field_projetoRedMine">Projeto Red Mine</label><input type="text" class="form-control" name="projetoRedMine" id="field_projetoRedMine" ng-model="vm.cliente.projetoRedMine"></div><div class="form-group"><label class="control-label" for="field_horas">Horas Dispon\xEDveis</label><input type="text" class="form-control" name="horas" id="field_horas" ng-model="vm.cliente.horasDisponiveis"></div><div class="form-group"><label class="control-label" for="field_perguntas">O suporte responde pergunta?</label><select class="form-control" id="field_perguntas" name="modulo" ng-model="vm.cliente.perguntasAoAceitar" ng-options="o.v as o.n for o in [{ n: \'Sim\', v: true }, { n: \'N\xE3o\', v: false }]"></select></div><div class="form-group"><label class="control-label" for="field_release">Habilita Release Notes?</label><select class="form-control" id="field_release" name="modulo" ng-model="vm.cliente.releaseNote" ng-options="o.v as o.n for o in [{ n: \'Sim\', v: true }, { n: \'N\xE3o\', v: false }]"></select></div><div class="form-group"><label class="control-label" for="exigirEntidadeSolicitante">Exigir entidade Solicitante na abertura de chamado?</label><select class="form-control" id="exigirEntidadeSolicitante" name="modulo" ng-model="vm.cliente.exigirEntidadeSolicitante" ng-options="o.v as o.n for o in [{ n: \'Sim\', v: true }, { n: \'N\xE3o\', v: false }]"></select></div><div class="form-group"><div class="panel panel-default"><div class="panel-heading"><label>Sistemas</label></div><div class="panel-body"><table class="table"><tr class="{{vm.indexSistema(sistema.id) > -1 ? \'success\':\'\'}}" ng-repeat="sistema in vm.sistemas track by $index"><td><i class="fa fa-circle-o" ng-click="vm.adicionarSistema(sistema)" ng-show="vm.indexSistema(sistema.id) < 0"></i> <i class="fa fa-check-circle-o" ng-click="vm.removerSistema(sistema)" ng-show="vm.indexSistema(sistema.id) > -1"></i></td><td>{{sistema.nome}}</td></tr></table></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/cliente/clientes.html','<div class="ibox"><div class="ibox-title"><h2><h2 data-translate="chamadosApp.cliente.home.title">Clientes</h2></h2></div><div class="ibox-content"><div class="row"><div class="col-md-12"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="cliente.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="chamadosApp.cliente.home.createLabel">Create new Cliente</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="chamadosApp.cliente.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="projetoRedMine"><span data-translate="chamadosApp.cliente.projetoRedMine">Projeto Red Mine</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="projetoRedMine"><span data-translate="chamadosApp.cliente.exigirEntidadeSolicitante">Exigir Solicitante?</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="cliente in vm.clientes track by cliente.id"><td>{{cliente.id}}</td><td>{{cliente.nome}}</td><td>{{cliente.projetoRedMine}}</td><td>{{cliente.exigirEntidadeSolicitante ? \'Sim\' : \'N\xE3o\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="cliente.edit({id:cliente.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="button" ng-click="vm.remover(cliente.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/equipe/equipe-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myEquipeLabel" data-translate="chamadosApp.equipe.home.createOrEditLabel">Create or edit a Equipe</h4></div><div class="modal-body"><div class="row"><div class="col-md-12"><div class="form-group"><label class="control-label" data-translate="chamadosApp.equipe.nome" for="field_nome">Nome Equipe</label><input type="text" class="form-control" name="nomeEquipe" id="field_nome" ng-model="vm.equipe.nome" required ng-minlength="2" ng-maxlength="100"><div ng-show="editForm.nome.$invalid"><p class="help-block" ng-show="editForm.nome.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nome.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.nome.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="row"><div class="col-md-6"><div class="panel panel-default"><div class="panel-heading"><label>Sistemas</label></div><div class="panel-body"><input type="text" class="form-control" ng-model="vm.sistemaBusca" placeholder="Buscar sistema..." uib-typeahead="s as s.nome for s in vm.buscarSistemas($viewValue)" typeahead-min-length="2" typeahead-wait-ms="300" typeahead-editable="false" typeahead-on-select="vm.selecionarSistema($item)"><table class="table small" ng-if="vm.equipe.sistemas.length"><tbody><tr ng-repeat="sistema in vm.equipe.sistemas track by sistema.id"><td>{{sistema.nome}}</td><td class="text-right"><button type="button" class="btn btn-link btn-xs" ng-click="vm.removerSistema(sistema)"><i class="fa fa-times"></i></button></td></tr></tbody></table></div></div></div><div class="col-md-6"><div class="panel panel-default"><div class="panel-heading"><label>Usu\xE1rios</label></div><div class="panel-body"><input type="text" class="form-control" ng-model="vm.usuarioBusca" placeholder="Buscar usu\xE1rio..." uib-typeahead="u as u.nomeExibicao for u in vm.buscarUsuarios($viewValue)" typeahead-min-length="2" typeahead-wait-ms="300" typeahead-editable="false" typeahead-on-select="vm.selecionarUsuario($item)"><table class="table small" ng-if="vm.equipe.usuarios.length"><tbody><tr ng-repeat="userEquipe in vm.equipe.usuarios track by userEquipe.usuario.id"><td>{{userEquipe.usuario.nomeExibicao}}</td><td><select class="form-control" style="height: 20px; margin: 0px; padding: 0px; font-size: 1em" ng-model="userEquipe.funcao" required><option value="DESENVOLVEDOR">Desenvolvedor</option><option value="ANALISTA">Analista</option><option value="LIDER">Lider</option><option value="GERENTE">Gerente</option><option value="SUPORTE">Suporte</option><option value="PO">P.O.</option></select></td><td><input class="form-control" style="height: 20px; margin: 0px; padding: 0px; font-size: 1em" ng-model="userEquipe.cargo"></td><td class="text-right"><button type="button" class="btn btn-link btn-xs" ng-click="vm.removerUsuario(userEquipe)"><i class="fa fa-times"></i></button></td></tr></tbody></table></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span> &nbsp <span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span> &nbsp <span data-translate="entity.action.save">Save</span></button></div></div></div></form>');
$templateCache.put('app/entities/equipe/equipe.html','<div class="ibox"><div class="ibox-title"><h2><h2 data-translate="chamadosApp.equipe.home.title">Equipes</h2></h2></div><div class="ibox-content"><div class="row"><div class="col-md-12"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="equipe.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="chamadosApp.equipe.home.createLabel">Create new Equipe</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="chamadosApp.equipe.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="equipe in vm.equipes track by equipe.id"><td>{{equipe.id}}</td><td>{{equipe.nome}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="equipe.edit({id:equipe.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="button" ng-click="vm.remover(equipe.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div></div></div></div></div>');
$templateCache.put('app/entities/feedback/feedback-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myFeedBackLabel" data-translate="chamadosApp.feedBack.home.createOrEditLabel">Create or edit a FeedBack</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.feedBack.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.feedBack.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="chamadosApp.feedBack.descricao" for="field_descricao">Descri\xE7\xE3o</label><input type="text" class="form-control" name="descricao" id="field_descricao" ng-model="vm.feedBack.descricao" required ng-minlength="2" ng-maxlength="100"><div ng-show="editForm.descricao.$invalid"><p class="help-block" ng-show="editForm.descricao.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.descricao.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.descricao.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="chamadosApp.feedBack.nota" for="field_descricao">Nota</label><input type="text" class="form-control" name="nota" id="field_nota" ng-model="vm.feedBack.nota" required ng-minlength="1" ng-maxlength="2"><div ng-show="editForm.nota.$invalid"><p class="help-block" ng-show="editForm.nota.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nota.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.nota.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/feedback/feedback.html','<div class="ibox"><div class="ibox-title"><h2>FeedBack</h2></div><div class="ibox-content"><div class="row"><div class="col-md-12"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="feedback.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="chamadosApp.feedBack.home.createLabel">Create new Cliente</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="criadoEm"><span data-translate="chamadosApp.feedBack.criadoEm">Criado Em</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="chamadosApp.feedBack.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="chamadosApp.feedBack.chamado">Chamado</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nota"><span data-translate="chamadosApp.feedBack.nota">Nota</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="usuario.firstName"><span>Usu\xE1rio</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="feedBack in vm.feedBacks track by feedBack.id"><td><a ui-sref="feedBack-detail({id:feedBack.id})">{{feedBack.id}}</a></td><td>{{feedBack.criadoEm | date:\'mediumDate\'}}</td><td>{{feedBack.descricao}}</td><td>{{feedBack.chamado.id}} - {{feedBack.chamado.titulo}}</td><td>{{feedBack.nota}}</td><td>{{feedBack.usuario.firstName}}</td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/fluxo-situacao/fluxo-situacao.html','<div class="container-fluid"><h2>Fluxo de Situa\xE7\xF5es</h2><div class="row"><div class="col-md-4"><div class="form-group"><label>Cliente</label><select class="form-control" ng-model="vm.clienteSelecionado" ng-options="c as c.nome for c in vm.clientes" ng-change="vm.selecionarCliente()"><option value="">-- Padr\xE3o (Global) --</option></select></div></div><div class="col-md-4" ng-if="vm.clienteSelecionado"><label>&nbsp;</label><div><button class="btn btn-default" ng-click="vm.clonarPadrao()"><i class="fa fa-copy"></i> Clonar Fluxo Padr\xE3o</button></div></div></div><hr><div class="row"><div class="col-md-12"><h3>Situa\xE7\xF5es</h3><table class="table table-striped table-hover"><thead><tr><th>C\xF3digo</th><th>Descri\xE7\xE3o</th><th>Ordem</th><th>Cor</th><th>Menu</th><th>Pode Reordenar</th><th>Terminal</th><th>Inicial (novo chamado)</th><th>An\xE1lise P.O.</th><th>Criar tarefa</th><th>Ativo</th><th>Autoridades (Spring Security)</th><th style="width: 120px">A\xE7\xF5es</th></tr></thead><tbody><tr ng-repeat="s in vm.situacoes | orderBy:\'ordemApresentacao\'"><td ng-if="vm.editando.id !== s.id">{{s.codigo}}</td><td ng-if="vm.editando.id !== s.id">{{s.descricao}}</td><td ng-if="vm.editando.id !== s.id">{{s.ordemApresentacao}}</td><td ng-if="vm.editando.id !== s.id"><span class="label" ng-style="{\'background-color\': s.cor}">&nbsp;&nbsp;&nbsp;</span> {{s.cor}}</td><td ng-if="vm.editando.id !== s.id"><i class="fa" ng-class="s.disponivelMenu ? \'fa-check text-success\' : \'fa-times text-muted\'"></i></td><td ng-if="vm.editando.id !== s.id"><i class="fa" ng-class="s.podeAlterarOrdem ? \'fa-check text-success\' : \'fa-times text-muted\'"></i></td><td ng-if="vm.editando.id !== s.id"><i class="fa" ng-class="s.terminal ? \'fa-check text-success\' : \'fa-times text-muted\'"></i></td><td ng-if="vm.editando.id !== s.id"><i class="fa" ng-class="s.inicial ? \'fa-check text-success\' : \'fa-times text-muted\'"></i></td><td ng-if="vm.editando.id !== s.id"><i class="fa" ng-class="s.permiteInserirAnalisePo ? \'fa-check text-success\' : \'fa-times text-muted\'"></i></td><td ng-if="vm.editando.id !== s.id"><i class="fa" ng-class="s.permiteCriarTarefa ? \'fa-check text-success\' : \'fa-times text-muted\'"></i></td><td ng-if="vm.editando.id !== s.id"><i class="fa" ng-class="s.ativo ? \'fa-check text-success\' : \'fa-times text-danger\'"></i></td><td ng-if="vm.editando.id !== s.id" class="small">{{ vm.rolesResumo(s) }}</td><td ng-if="vm.editando.id !== s.id"><button class="btn btn-xs btn-primary" ng-click="vm.editarSituacao(s)" title="Editar"><i class="fa fa-pencil"></i></button> <button class="btn btn-xs btn-danger" ng-click="vm.removerSituacao(s)" title="Remover"><i class="fa fa-trash"></i></button></td><td ng-if="vm.editando.id === s.id"><input class="form-control input-sm" ng-model="vm.editando.codigo"></td><td ng-if="vm.editando.id === s.id"><input class="form-control input-sm" ng-model="vm.editando.descricao"></td><td ng-if="vm.editando.id === s.id"><input type="number" class="form-control input-sm" ng-model="vm.editando.ordemApresentacao"></td><td ng-if="vm.editando.id === s.id"><input class="form-control input-sm" ng-model="vm.editando.cor" placeholder="#FFFFFF"></td><td ng-if="vm.editando.id === s.id"><input type="checkbox" ng-model="vm.editando.disponivelMenu"></td><td ng-if="vm.editando.id === s.id"><input type="checkbox" ng-model="vm.editando.podeAlterarOrdem"></td><td ng-if="vm.editando.id === s.id"><input type="checkbox" ng-model="vm.editando.terminal"></td><td ng-if="vm.editando.id === s.id"><input type="checkbox" ng-model="vm.editando.inicial"></td><td ng-if="vm.editando.id === s.id"><input type="checkbox" ng-model="vm.editando.permiteInserirAnalisePo"></td><td ng-if="vm.editando.id === s.id"><input type="checkbox" ng-model="vm.editando.permiteCriarTarefa"></td><td ng-if="vm.editando.id === s.id"><input type="checkbox" ng-model="vm.editando.ativo"></td><td ng-if="vm.editando.id === s.id" class="small" style="max-width: 220px"><div ng-repeat="auth in vm.opcoesAuthorities"><label class="checkbox small" style="font-weight:normal; margin-bottom: 2px"><input type="checkbox" ng-checked="vm.roleMarcado(vm.editando, auth)" ng-click="vm.toggleRole(vm.editando, auth)"> {{auth}}</label></div></td><td ng-if="vm.editando.id === s.id"><button class="btn btn-xs btn-success" ng-click="vm.salvarSituacao()" title="Salvar"><i class="fa fa-check"></i></button> <button class="btn btn-xs btn-default" ng-click="vm.cancelarEdicao()" title="Cancelar"><i class="fa fa-times"></i></button></td></tr></tbody></table><div class="panel panel-default" ng-if="!vm.editando"><div class="panel-heading">Nova Situa\xE7\xE3o</div><div class="panel-body"><form class="form-inline" ng-submit="vm.salvarSituacao()"><div class="form-group"><input class="form-control" ng-model="vm.novaSituacao.codigo" placeholder="C\xF3digo" required></div><div class="form-group"><input class="form-control" ng-model="vm.novaSituacao.descricao" placeholder="Descri\xE7\xE3o" required></div><div class="form-group"><input type="number" class="form-control" ng-model="vm.novaSituacao.ordemApresentacao" placeholder="Ordem" style="width:80px"></div><div class="form-group"><input class="form-control" ng-model="vm.novaSituacao.cor" placeholder="#FFFFFF" style="width:90px"></div><div class="checkbox"><label><input type="checkbox" ng-model="vm.novaSituacao.disponivelMenu"> Menu</label></div><div class="checkbox"><label><input type="checkbox" ng-model="vm.novaSituacao.terminal"> Terminal</label></div><div class="checkbox"><label><input type="checkbox" ng-model="vm.novaSituacao.inicial"> Inicial (novo chamado)</label></div><div class="checkbox"><label><input type="checkbox" ng-model="vm.novaSituacao.permiteInserirAnalisePo"> Bot\xE3o an\xE1lise P.O.</label></div><div class="checkbox"><label><input type="checkbox" ng-model="vm.novaSituacao.permiteCriarTarefa"> Bot\xE3o criar tarefa</label></div><div class="m-t-sm"><strong>Perfis autorizados (has-any-authority)</strong><div class="checkbox" ng-repeat="auth in vm.opcoesAuthorities"><label><input type="checkbox" ng-checked="vm.roleMarcado(vm.novaSituacao, auth)" ng-click="vm.toggleRole(vm.novaSituacao, auth)"> {{auth}}</label></div></div><button type="submit" class="btn btn-primary"><i class="fa fa-plus"></i> Adicionar</button></form></div></div></div></div><hr><div class="row"><div class="col-md-12"><h3>Transi\xE7\xF5es</h3><table class="table table-striped table-hover"><thead><tr><th>Origem</th><th></th><th>Destino</th><th style="width: 80px">A\xE7\xF5es</th></tr></thead><tbody><tr ng-repeat="t in vm.transicoes"><td><span class="label" ng-style="{\'background-color\': t.situacaoOrigem.cor}">{{t.situacaoOrigem.descricao}}</span></td><td class="text-center"><i class="fa fa-arrow-right"></i></td><td><span class="label" ng-style="{\'background-color\': t.situacaoDestino.cor}">{{t.situacaoDestino.descricao}}</span></td><td><button class="btn btn-xs btn-danger" ng-click="vm.removerTransicao(t)" title="Remover"><i class="fa fa-trash"></i></button></td></tr></tbody></table><div class="panel panel-default"><div class="panel-heading">Nova Transi\xE7\xE3o</div><div class="panel-body"><form class="form-inline" ng-submit="vm.adicionarTransicao()"><div class="form-group"><label>De:</label><select class="form-control" ng-model="vm.novaTransicao.origem" ng-options="s as s.descricao for s in vm.situacoes" required><option value="">Selecione</option></select></div><div class="form-group" style="margin-left: 10px"><label>Para:</label><select class="form-control" ng-model="vm.novaTransicao.destino" ng-options="s as s.descricao for s in vm.situacoes" required><option value="">Selecione</option></select></div><button type="submit" class="btn btn-primary" style="margin-left: 10px"><i class="fa fa-plus"></i> Adicionar</button></form></div></div></div></div></div>');
$templateCache.put('app/entities/imagem/imagem-upload.html','<div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.cancel()">&times;</button><h4 class="modal-title">Upload de Imagem</h4></div><div class="modal-body"><div class="row"><div class="col-md-12 text-center"><div class="form-group col-md-12" ng-show="vm.anexo"><img src="{{vm.anexo.conteudo}}" style="width: 100%"></div><div class="form-group col-md-12"><button ngf-select="vm.upload($file)" ngf-max-size="100MB" class="btn btn-block btn-default btn-outline" accept="image/*,application/pdf"><i class="fa fa-upload"></i> Selecione um arquivo para anexar</button></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-show="!vm.carregando" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span translate="entity.action.cancel">Cancel</span></button> <button type="button" ng-click="vm.submit()" ng-disabled="vm.carregando" class="btn btn-primary"><span class="fa {{vm.carregando ? \'fa-refresh fa-spin\':\'fa-save\'}}"></span> <span class="hidden-xs hidden-sm">{{vm.carregando ? \'Salvando ...\' : \'Salvar\'}}</span></button></div>');
$templateCache.put('app/entities/modulo/modulo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myModuloLabel" data-translate="chamadosApp.modulo.home.createOrEditLabel">Create or edit a Modulo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.modulo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.modulo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="chamadosApp.modulo.descricao" for="field_descricao">Descricao</label><input type="text" class="form-control" name="descricao" id="field_descricao" ng-model="vm.modulo.descricao" required ng-minlength="2" ng-maxlength="50"><div ng-show="editForm.descricao.$invalid"><p class="help-block" ng-show="editForm.descricao.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.descricao.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.descricao.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="chamadosApp.modulo.projetoRedMine" for="field_projetoRedMine">Projeto Red Mine</label><input type="text" class="form-control" name="projetoRedMine" id="field_projetoRedMine" ng-model="vm.modulo.projetoRedMine"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/modulo/modulos.html','<div class="ibox"><div class="ibox-title"><h2><h2 data-translate="chamadosApp.modulo.home.title">Modulos</h2></h2></div><div class="ibox-content"><div class="row"><div class="col-md-12"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="modulo.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="chamadosApp.modulo.home.createLabel">Create new Modulo</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="chamadosApp.modulo.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="projetoRedMine"><span data-translate="chamadosApp.modulo.projetoRedMine">Projeto Red Mine</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="modulo in vm.modulos track by modulo.id"><td>{{modulo.id}}</td><td>{{modulo.descricao}}</td><td>{{modulo.projetoRedMine}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="modulo.edit({id:modulo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ng-click="vm.remover(modulo.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/myboard/myboard.html','<div class="col-md-12"><div class="row text-center m-b-lg" has-any-authority="ROLE_ATENDENTE, ROLE_PO, ROLE_DESENVOLVEDOR"><div data-toggle="buttons-checkbox" class="btn-group"><a ui-sref="home" class="btn btn-primary" type="button"><i class="fa fa-dashboard"></i> Dashboard Ciclo</a> <a ui-sref="scrumboard" class="btn btn-primary" type="button"><i class="fa fa-code-fork"></i> Task Board</a> <a ui-sref="myboard" class="btn btn-primary active" type="button"><i class="fa fa-user"></i> Team Board</a> <a ui-sref="burnup" class="btn btn-primary" type="button"><i class="fa fa-line-chart"></i> Burnup</a></div></div></div><div class="col-md-12 no-padding no-margins"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-content"><div class="row"><form name="editForm"><div class="form-group col-md-6"><label>Ciclo de desenvolvimento</label><select class="form-control" id="field_sprint" name="modulo" ng-model="vm.sprint" ng-options="sprint as sprint.descricao for sprint in vm.sprints track by sprint.id"><option value=""></option></select></div><div class="form-group col-md-6"><label class="control-label">&ensp;</label><button ng-click="vm.buscarTarrefasDaSprint()" class="btn btn-success btn-block"><i class="fa fa-search"></i> Buscar</button></div></form></div><div class="row" has-any-authority="ROLE_SCRUM"><div class="col-lg-12 text-center"><a ng-click="vm.mostraTime = !vm.mostraTime"><h5>{{vm.mostraTime ? \'Esconder\' : \'Ver\'}} Time <i class="fa {{vm.mostraTime? \'fa-arrow-up\':\'fa-arrow-down\'}}"></i></h5></a></div><div class="col-lg-12 text-center" ng-show="vm.mostraTime"><button ng-repeat="user in vm.users | orderBy:\'firstName\' track by $index " class="btn m-sm {{vm.filtro.user.id == user.id ? \'btn-info active\' : \'\'}}" ng-click="vm.filtro.user = user; vm.buscarTarrefasDaSprint() ;" type="button">{{user.firstName}} <small style="font-size: xx-small">{{user.lastName}}</small></button></div></div></div></div></div></div></div><div class="row"><div class="col-md-4"><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-md-12 text-center"><img ng-src="{{vm.filtro.user.imagem}}" ng-show="vm.filtro.user.imagem" width="62" class="img-circle" alt="foto do usuario"> <img alt="image" class="img-circle" ng-show="!vm.filtro.user.imagem" width="62" ng-src="/content/images/user-default.png"><h3>{{vm.filtro.user.firstName}} {{vm.filtro.user.lastName}}</h3></div><div class="col-md-12"><div class="table-responsive" style="max-height: 350px; overflow: auto"><table class="jh-table table table-striped table-hover"><tr><th class="text-center">Dia</th><th class="text-center">Ponto</th><th class="text-center">Apontado</th><th class="text-center">%</th></tr><tr class="text-center" ng-repeat="dia in vm.horaApontadaPorDia | orderBy:\'dia.dia\'"><td>{{dia.dia | date:\'mediumDate\'}}</td><td class="text-center">{{dia.horaPonto | number: 2}}</td><td class="text-center">{{dia.tempoGasto | number: 2}}</td><td class="text-center"><span class="label {{dia.percentual < 80 ? \'label-danger\': \'label-info\'}}">{{dia.percentual | number: 2}}%</span></td></tr><tr><td colspan="4" class="text-center"><strong>Total: <span class="text-success">{{vm.totalHoraTrabalhadas | number: 2}}hs</span></strong></td></tr></table></div></div><div class="col-md-12 table-responsive"><h3>Projetos</h3><table class="table"><tr ng-repeat="projeto in vm.labelsProjeto track by $index"><td>{{vm.dataProjeto[vm.labelsProjeto.indexOf(projeto)] | number:1}}<small>h</small></td><td>{{projeto}}</td><td class="text-right"><small class="text-success">{{(vm.dataProjeto[vm.labelsProjeto.indexOf(projeto)] * 100) / vm.totalProjeto | number:0}}%</small></td></tr></table></div><div class="col-md-12 table-responsive"><h3>M\xF3dulos</h3><table class="table"><tr ng-repeat="modulo in vm.labelsModulo track by $index"><td>{{vm.dataModulo[vm.labelsModulo.indexOf(modulo)] | number:1}}<small>h</small></td><td>{{modulo}}</td><td class="text-right"><small class="text-success">{{(vm.dataModulo[vm.labelsModulo.indexOf(modulo)] * 100) / vm.totalModulo | number:0}}%</small></td></tr></table></div><div class="col-md-12 table-responsive"><h3>Tipo</h3><table class="table"><tr ng-repeat="tipo in vm.labelsTipo track by $index"><td>{{vm.dataTipo[vm.labelsTipo.indexOf(tipo)] | number:1}}<small>h</small></td><td>{{tipo}}</td><td class="text-right"><small class="text-success">{{(vm.dataTipo[vm.labelsTipo.indexOf(tipo)] * 100) / vm.totalTipo | number:0}}%</small></td></tr></table></div><div class="col-md-12 table-responsive"><h3>Complexidade</h3><table class="table"><tr ng-repeat="complexidade in vm.labelsComplexidade  track by $index"><td>{{vm.dataComplexidade[vm.labelsComplexidade.indexOf(complexidade)] | number:1}} <small>h</small></td><td>{{complexidade}}</td><td class="text-right"><small class="text-success">{{(vm.dataComplexidade[vm.labelsComplexidade.indexOf(complexidade)] * 100) / vm.totalComplexidade | number:0}}%</small></td></tr></table></div></div></div></div></div><div class="col-md-8"><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-md-12"><div class="tabs-container"><ul class="nav nav-tabs" role="tablist"><li ng-click="vm.mostrarTarefas = true"><a class="nav-link {{vm.mostrarTarefas ? \'active\': \'\'}}">Tarefas &nbsp;</a></li><li ng-click="vm.mostrarTarefas = false"><a class="nav-link {{!vm.mostrarTarefas ? \'active\': \'\'}}">Detalhado &nbsp;</a></li></ul></div></div><div class="tab-content" ng-show="vm.mostrarTarefas"><div class="tab-pane active"><div class="col-lg-12 m-md text-center"><p>Tarefa que est\xE3o em andamento na Sprint ou Atrasadas</p><p class="small text-danger" ng-show="vm.tarefasFazendo.length > 1"><i class="fa fa-exclamation-triangle"></i> {{vm.tarefasFazendo.length}} Tarefas em situa\xE7\xE3o de FAZENDO ao mesmo tempo</p><p class="small text-danger" ng-show="vm.tarefasRejeitadas.length > 0"><i class="fa fa-exclamation-triangle"></i> {{vm.tarefasRejeitadas.length}} Tarefa(s) Rejeitada(s)</p><p class="small text-danger" ng-show="vm.tarefasImpedidas.length > 0"><i class="fa fa-exclamation-triangle"></i> {{vm.tarefasImpedidas.length}} Tarefa(s) Impedidas(s)</p><p class="small text-danger" ng-show="vm.tarefasAtrasadas.length > 0"><i class="fa fa-exclamation-triangle"></i> {{vm.tarefasAtrasadas.length}} Tarefa(s) Atrasadas(s)</p></div><div class="col-lg-12"><situacoes-sprint situacoes-sprint-selecionadas="vm.situacoesSprintSelecionadas" on-selecionar="vm.buscarTarrefasDaSprint()" mostrar-botao-atribuidas-para-mim="false"></situacoes-sprint><div class="table-responsive"><table class="table table-condensed"><tr><th>Tarefa</th><th class="issue-info col-md-2">Projeto <small>M\xF3dulo</small></th><th class="issue-info col-md-2 text-right">Tempo Estimado<small>Apontado Acumulado</small></th></tr><tr ng-repeat="tarefa in vm.tarefasDaSprint | orderBy:\'id\'"><td class="issue-info"><a ui-sref="solicitacaoDesenvolvimento.detail({id:tarefa.id})">#{{tarefa.numero}} <span class="{{tarefa.situacao == \'CONCLUIDA\'? \'text-success\': \'\'}}">{{\'chamadosApp.SituacaoTarefa.\' + tarefa.situacao | translate}} </span><span class="small text-danger" ng-if="tarefa.sprintChamado && tarefa.sprint !== vm.sprint.descricao">Atrasado: {{tarefa.sprint}} </span><span class="small text-warning" ng-if="!tarefa.sprintChamado && tarefa.sprint !== vm.sprint.descricao"><i class="fa fa-star"></i> Adiantado! </span></a><small>{{tarefa.titulo}}</small></td><td class="issue-info">{{tarefa.projeto}} <small>{{tarefa.modulo}}</small></td><td class="issue-info text-right">{{tarefa.tempoEstimado | number:1}}h <small class="{{tarefa.tempoGasto > tarefa.tempoEstimado? \'text-danger\': \'text-success\'}}">{{tarefa.tempoGasto | number:1}}h</small></td></tr></table></div></div></div></div><div class="tab-content" ng-show="!vm.mostrarTarefas"><div class="tab-pane active"><div class="col-lg-12 m-md text-center"><small>Horas apontadas na Sprint</small></div><div class="col-md-12 m-b-md"><div class="col-lg-12"><div class="table-responsive"><table class="table table-condensed"><tr><th>Data</th><th class="issue-info">Tempo <small>Conte\xFAdo</small></th><th>Chamado/Tarefa</th></tr><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td>{{atividade.criadoEm | date:\'mediumDate\'}}</td><td class="issue-info">{{atividade.tempo | number: fractionSize }} <small>{{\'chamadosApp.TipoHora.\' + atividade.tipo | translate}}</small></td><td class="issue-info"><a ng-show="atividade.ata" ui-sref="detail-ata({id:atividade.ata.id})">#{{atividade.ata.numero}} <small>{{atividade.ata.titulo}}</small> </a><a ng-show="atividade.chamado" ui-sref="edit-chamado({id:atividade.chamado.id, search: null, situacao: null})">#{{atividade.chamado.id}} <small>{{atividade.chamado.titulo}}</small></a></td></tr></table></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/notificacao/notificacao-detail.html','<div class="ibox m-b-lg"><div class="ibox-title"><h5>{{vm.notificacao.titulo}}</h5></div><div class="ibox-content"><div class="row"><div class="col-md-12"><div ng-bind-html="vm.trustAsHtml(vm.notificacao.conteudo)"></div></div></div></div><div class="ibox-footer"><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button></div></div>');
$templateCache.put('app/entities/notificacao/notificacoes.html','<div class="ibox"><div class="ibox-title"><h2>Notifica\xE7\xF5es</h2></div><div class="ibox-content"><div class="row"><div class="col-md-12"><jhi-alert></jhi-alert><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="titulo">Titulo<span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="criadoEm">Data <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="lida">Lida<span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="notificacao in vm.notificacoes track by notificacao.id"><td><a ui-sref="notificacao-detail({id:notificacao.id})">{{notificacao.titulo}}</a></td><td>{{notificacao.criadoEm | date:\'mediumDate\'}}</td><td>{{notificacao.lida ? \'Sim\': \'N\xE3o\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="notificacao-detail({id:notificacao.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/ocorrencia/ocorrencia-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="myClienteLabel" data-translate="chamadosApp.ocorrencia.home.createOrEditLabel">Create or edit a Cliente</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.ocorrencia.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.ocorrencia.id" readonly="readonly"></div><div class="row"><div class="col-md-3"><div class="form-group"><label class="control-label">Data:</label><div class="input-group"><input id="field_inicio" type="text" required class="form-control" name="criadoEm" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.ocorrencia.data" is-open="vm.datePickerOpenStatus.data"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'data\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div></div><div class="col-md-9"><div class="form-group"><label class="control-label" data-translate="chamadosApp.ocorrencia.titulo" for="field_titulo">T\xEDtulo</label><input type="text" class="form-control" name="titulo" id="field_titulo" ng-model="vm.ocorrencia.titulo" required ng-minlength="2" ng-maxlength="100"></div></div></div><div class="form-group"><label class="control-label">Descri\xE7\xE3o</label><text-angular name="descricao" required ng-model="vm.ocorrencia.descricao"></text-angular></div><div class="row"><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_cliente">Cliente</label><select class="form-control" id="field_cliente" name="cliente" required ng-change="vm.carregarSistemas()" ng-model="vm.ocorrencia.cliente" ng-options="cliente as cliente.nome for cliente in vm.clientes track by cliente.id"></select></div></div><div class="col-md-6"><div class="form-group"><label class="control-label" for="field_sistema">Sistema</label><select class="form-control" id="field_sistema" name="sistema" required ng-model="vm.ocorrencia.sistema" ng-options="sistema as sistema.nome for sistema in vm.sistemas track by sistema.id"></select></div></div></div><div class="form-group"><div class="panel panel-default"><div class="panel-heading"><label>Chamados</label></div><div class="panel-body"><div has-authority="ROLE_PO" class="m-b-md"><div class="input-group"><input type="number" class="form-control" ng-model="vm.adicionar" placeholder="N\xFAmero do Chamado"> <span class="input-group-btn"><button class="btn btn-success" ng-click="vm.adicionarChamado(vm.adicionar)" type="button"><i class="fa fa-save"></i></button></span></div></div><table class="table"><tr ng-repeat="ocorrencia in vm.ocorrencia.chamados track by $index"><td><button type="button" has-authority="ROLE_PO" class="btn btn-default" ng-click="vm.removerChamado(ocorrencia.chamado)"><span class="fa fa-trash"></span></button></td><td>{{ocorrencia.chamado.id}} - {{ocorrencia.chamado.titulo}}</td></tr></table></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" has-authority="ROLE_PO" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/ocorrencia/ocorrencia.html','<div class="row"><div class="col-md-2"><div class="file-manager"><h5>Projetos</h5><ul class="folder-list m-b-md" style="padding: 0"><li ng-repeat="cliente in vm.clientes"><a ng-click="vm.selecionarCliente(cliente)" title="{{cliente.nome}}"><i class="fa {{vm.cliente.id === cliente.id ?\'fa-check-circle-o\':\'fa-circle-o\'}}"></i> {{cliente.nome| limitTo: 15 }}{{cliente.nome.length > 15 ? \'...\' : \'\'}} <span class="label {{vm.cliente.id === cliente.id ?\'label-success\':\'label-default\'}} float-right pull-right">{{cliente.quantidade}}</span></a></li></ul></div></div><div class="col-md-10"><div class="ibox"><div class="ibox-title">Ocorr\xEAncias</div><div class="ibox-content"><div class="row"><div class="col-md-12"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-md-2 no-padding-left"><button class="btn btn-primary btn-block" ui-sref="ocorrencia.new" has-authority="ROLE_PO"><i class="fa fa-plus-circle"></i> Nova Ocorr\xEAncia</button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="nome"><span data-translate="chamadosApp.ocorrencia.titulo">T\xEDtulo</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="criadoEm"><span data-translate="chamadosApp.ocorrencia.data">Data</span> <span class="glyphicon glyphicon-sort"></span></th></tr></thead><tbody><tr ng-repeat="ocorrencia in vm.ocorrencias track by ocorrencia.id"><td>{{ocorrencia.titulo}}</td><td>{{ocorrencia.data | date:\'mediumDate\'}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="ocorrencia.edit({id:ocorrencia.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" has-authority="ROLE_PO" ng-click="vm.remover(ocorrencia.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/pesquisa/pesquisa.html','<div ng-cloak><div class="row"><div class="tabs-container"><div class="tab-content"><div class="tab-pane active"><div class="panel-body"><div class="row"><form name="editForm" role="form" novalidate show-validation><div class="form-group col-md-10"><label class="control-label" for="titulo">Titulo/Descri\xE7\xE3o</label><input type="text" class="form-control" id="titulo" name="titulo" ng-model="vm.search"></div><div class="form-group col-md-2"><label class="control-label">&ensp;</label><button ng-click="vm.loadAll()" ng-disabled="!vm.search" class="btn btn-success btn-block"><i class="fa fa-search"></i> Buscar</button></div></form></div><div class="row"><div class="col-md-12 text-center"><p class="small"><a ui-sref="chamado({search:vm.search})"><i class="fa fa-file-code-o"></i> Apenas Chamados </a>&ensp; <a ui-sref="solicitacaoDesenvolvimento"><i class="fa fa-code-fork"></i> Apenas Tarefas</a></p></div><div class="col-md-12"><div class="table-responsive"><table class="table table-striped"><thead><tr><th colspan="2">Listando todos os chamados e tarefas</th></tr></thead><tbody><tr ng-repeat="chamado in vm.chamados track by chamado.id"><td class="issue-info"><span class="label label-success">Chamado </span>&ensp; <span class="strong"><a ui-sref="edit-chamado({id:chamado.id})">#{{chamado.id}}</a> </span><small>{{chamado.titulo}}</small></td><td class="issue-info"><span class="strong">{{chamado.modulo}}</span> <small>{{chamado.subModulo}}</small></td></tr><tr ng-repeat="solicitacao in vm.solicitacaoDesenvolvimentos track by solicitacao.id"><td class="issue-info"><span class="label label-primary">Tarefa </span>&nbsp; <span class="strong"><a ui-sref="solicitacaoDesenvolvimento.detail({id:solicitacao.id})">#{{solicitacao.numero}}</a> </span><small>{{solicitacao.titulo}}</small></td><td class="issue-info"><span class="strong">{{solicitacao.modulo.descricao}}</span> <small>{{solicitacao.subModulo.descricao}}</small></td></tr><tr ng-repeat="ata in vm.atas track by ata.id"><td class="issue-info"><span class="label label-primary">numero </span>&nbsp; <span class="strong"><a ui-sref="detail-ata({id:ata.id})">#{{ata.numero}}</a></span></td><td class="issue-info">{{ata.titulo}}</td></tr></tbody></table></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/scrumboard/scrumboard.html','<div class="row m-b-sm" has-any-authority="ROLE_ATENDENTE, ROLE_PO, ROLE_DESENVOLVEDOR"><div class="col-md-2"><h3 class="m-t-none m-b-xs text-primary">{{vm.sprint.descricao}}</h3><small class="text-muted"><i class="fa fa-calendar"></i> {{vm.sprint.inicio | date}} \xE0 {{vm.sprint.fim | date}}</small><br><div class="m-t-xs"><small><a ui-sref="detail-ata({id:vm.sprint.planejamento.id})" class="text-muted"><i class="fa fa-file-pdf-o text-danger"></i> Planejamento</a><br><a ui-sref="detail-ata({id:vm.sprint.reuniaoDiaria.id})" class="text-muted"><i class="fa fa-file-pdf-o text-danger"></i> Daily</a><br></small></div></div><div class="col-md-8 text-center"><div class="row"><div class="col-md-12 m-t-xs text-center" style="display: flex; flex-wrap: wrap; justify-content: center; gap: 8px"><span class="label label-info" style="font-size: 12px; padding: 6px 10px">{{vm.tarefas.length}} Tarefas</span> <span class="label label-primary" style="font-size: 12px; padding: 6px 10px">{{vm.totalPlanejados}} Planejadas</span> <span class="label label-warning" style="font-size: 12px; padding: 6px 10px">{{vm.totalNaoPlanejados}} N\xE3o Planejadas</span> <span ng-show="vm.tarefasAtrasadas>0" class="label label-danger" style="font-size: 12px; padding: 6px 10px">{{vm.tarefasAtrasadas}} Atrasadas</span> <span class="label label-success" style="font-size: 12px; padding: 6px 10px">{{vm.getColunaPorSituacao(\'CONCLUIDA\').tarefas.length}} Entregues</span> <span class="label {{vm.diasRestantes < 4 && vm.efetividadePlanejado < 60 ? \'label-danger\':\'label-success\'}}" style="font-size: 12px; padding: 6px 10px">{{vm.efetividadePlanejado | number:0}}% Efe.Planejado</span> <span class="label {{vm.diasRestantes < 4 && vm.efetividade < 60 ? \'label-danger\':\'label-success\'}}" style="font-size: 12px; padding: 6px 10px">{{vm.efetividade | number:0}}% Efe.Total</span> <span class="label label-default" style="font-size: 12px; padding: 6px 10px"><i class="fa fa-clock-o"></i> {{vm.diasRestantes | number:0}} Dias Restantes</span> <span class="label label-default" style="font-size: 12px; padding: 6px 10px"><i class="fa fa-hourglass-half"></i> {{ vm.tempoGasto | number:0}}h de {{ vm.tempoPlanejado | number:0}}h Alocadas</span></div></div><div class="row m-t-md"><div class="col-md-12 text-center" style="display: flex; flex-wrap: wrap; justify-content: center; gap: 6px"><span class="label {{vm.modulo == modulo ? \'label-info\': \'label-default\'}}" ng-click="vm.selecionaModulo(modulo)" ng-repeat="modulo in vm.modulos" style="cursor:pointer; font-size: 11px; padding: 5px 8px"><i class="fa fa-cube"></i> {{modulo}}</span></div></div><div class="row m-t-sm"><div class="col-md-12 text-center" style="display: flex; flex-wrap: wrap; justify-content: center; gap: 6px"><span class="label {{vm.projeto == projeto ? \'label-info\': \'label-default\'}}" ng-click="vm.selecionaProjeto(projeto)" ng-repeat="projeto in vm.projetos" style="cursor:pointer; font-size: 11px; padding: 5px 8px"><i class="fa fa-folder"></i> {{projeto}}</span></div></div><div class="row m-t-sm" ng-show="vm.usuariosBoard.length"><div class="col-md-12 text-center scrum-board__usuarios-bar"><button type="button" ng-repeat="u in vm.usuariosBoard track by u.key" class="scrum-board__avatar-chip" ng-class="{\'scrum-board__avatar-chip--ativo\': vm.usuarioBoardFiltro === u}" ng-click="vm.selecionaUsuarioBoard(u)" title="{{u.nome}}"><span class="scrum-board__avatar-wrap"><img ng-if="u.imagem" ng-src="{{u.imagem}}" alt="" class="img-circle scrum-board__avatar-img"> <span ng-if="!u.imagem" class="scrum-board__avatar-iniciais">{{vm.iniciaisUsuarioBoard(u.nome)}}</span></span></button></div></div></div><div class="col-md-2"><button class="btn btn-primary btn-block pull-right" ui-sref="solicitacaoDesenvolvimento.new" style="border-radius: 6px"><i class="fa fa-plus"></i> Criar Tarefa</button></div></div><div><situacoes-sprint situacoes-sprint-selecionadas="vm.situacoesSprintSelecionadas" on-selecionar="vm.load()" atribuidas-para-mim="vm.atribuidasParaMim"></situacoes-sprint><div class="row m-t-md"><div class="col-md-6 no-margins m-t-sm" ng-repeat="situacao in vm.colunas" ng-if="situacao.especial && situacao.tarefas.length >0"><h3 class="agile-board__column-title">{{\'chamadosApp.SituacaoTarefa.\' + situacao.situacao | translate}} <span class="badge badge-info">{{situacao.tarefas.length}}</span></h3><div class="col-md-4 no-padding no-margins" ng-repeat="tarefa in situacao.tarefas"><div class="issue issue__{{tarefa.tipo}}" ng-style="{\'border-left\': \'4px solid \' + (tarefa.corModulo || \'#1ab394\')}" style="margin: 4px"><div class="row"><div class="col-md-12"><div class="m-b-xs"><a class="font-bold text-primary" ui-sref="solicitacaoDesenvolvimento.detail({id:tarefa.id})">#{{tarefa.numero}}</a> <i class="fa fa-exclamation-triangle text-danger" title="Tarefa n\xE3o planejada" ng-if="!tarefa.planejado"></i> <i class="fa fa-clock-o text-danger" title="Atrasado: {{tarefa.sprintChamado}}" ng-if="tarefa.sprintOriginal != vm.sprint.descricao && tarefa.sprintChamado"></i><div class="pull-right scrum-board__assignee" title="{{tarefa.usuario}}"><span class="scrum-board__avatar-wrap scrum-board__avatar-wrap--card"><img ng-if="tarefa._assigneeBoard && tarefa._assigneeBoard.imagem" ng-src="{{tarefa._assigneeBoard.imagem}}" class="img-circle scrum-board__assignee-img" alt=""> <span ng-if="!tarefa._assigneeBoard || !tarefa._assigneeBoard.imagem" class="scrum-board__avatar-iniciais scrum-board__avatar-iniciais--card">{{vm.iniciaisUsuarioBoard(tarefa.usuario)}}</span></span></div></div><p class="issue__title text-resume" title="{{tarefa.titulo}}">{{tarefa.titulo}}</p><div class="clearfix m-t-sm"><div class="pull-left"><small class="text-muted"><i class="fa fa-tag"></i> {{tarefa.projeto}} <span ng-if="tarefa.modulo">/ {{tarefa.modulo}}</span></small></div></div></div></div></div></div></div></div><div class="row m-t-md"><div class="col-md-12 no-margins"><div class="agile-board"><div class="agile-board__column" ng-repeat="situacao in vm.colunas" ng-if="!situacao.especial"><h3 class="agile-board__column-title">{{\'chamadosApp.SituacaoTarefa.\' + situacao.situacao | translate}} <span class="badge">{{situacao.tarefas.length}}</span> <small class="pull-right" style="font-size: 11px; margin-top: 2px"><span class="text-success" title="Tempo Estimado"><i class="fa fa-clock-o"></i> {{situacao.tempoEstimado | number:1}}h</span> / <span class="text-danger" title="Tempo Gasto">{{situacao.tempoGasto | number:1}}h</span></small></h3><ul class="agile-board__issue-list"><li class="issue issue__{{tarefa.tipo}}" ng-repeat="tarefa in situacao.tarefas" ng-style="{\'border-left\': \'4px solid \' + (tarefa.corModulo || \'#1ab394\')}"><div class="row"><div class="col-md-12"><div class="m-b-xs"><a class="font-bold text-primary" ui-sref="solicitacaoDesenvolvimento.detail({id:tarefa.id})">#{{tarefa.numero}}</a> <i class="fa fa-exclamation-triangle text-danger" title="Tarefa n\xE3o planejada" ng-if="!tarefa.planejado"></i> <i class="fa fa-clock-o text-danger" title="Atrasado: {{tarefa.sprintChamado}}" ng-if="tarefa.sprintOriginal != vm.sprint.descricao && tarefa.sprintChamado"></i> <span class="label label-primary m-l-xs" ng-if="tarefa.chamado && !tarefa.sprintChamado">Adiantado</span><div class="pull-right scrum-board__assignee" title="{{tarefa.usuario}}"><span class="scrum-board__avatar-wrap scrum-board__avatar-wrap--card"><img ng-if="tarefa._assigneeBoard && tarefa._assigneeBoard.imagem" ng-src="{{tarefa._assigneeBoard.imagem}}" class="img-circle scrum-board__assignee-img" alt=""> <span ng-if="!tarefa._assigneeBoard || !tarefa._assigneeBoard.imagem" class="scrum-board__avatar-iniciais scrum-board__avatar-iniciais--card">{{vm.iniciaisUsuarioBoard(tarefa.usuario)}}</span></span></div></div><p class="issue__title text-resume" title="{{tarefa.titulo}}">{{tarefa.titulo}}</p><div class="clearfix m-t-sm"><div class="pull-left"><small class="text-muted"><i class="fa fa-tag"></i> {{tarefa.projeto}} <span ng-if="tarefa.modulo">/ {{tarefa.modulo}}</span></small></div><div class="pull-right"><small class="text-success" title="Tempo Estimado">{{tarefa.tempoEstimado | number:1}}h </small><small class="{{tarefa.tempoGasto > tarefa.tempoEstimado ? \'text-danger\':\'text-muted\'}}" title="Tempo Gasto">/ {{tarefa.tempoGasto | number:1}}h</small></div></div></div></div></li></ul></div></div></div></div></div>');
$templateCache.put('app/entities/sistema/sistema-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySistemaLabel">Sistema {{vm.sistema.id}}</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="row"><div class="form-group col-md-10"><label class="control-label" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.sistema.nome" required ng-minlength="2" ng-maxlength="50"><div ng-show="editForm.nome.$invalid"><p class="help-block" ng-show="editForm.nome.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nome.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.nome.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group col-md-2"><label class="control-label" for="activated">&ensp;</label><label for="activated"><input type="checkbox" id="activated" name="activated" ng-model="vm.sistema.ativo"> <span>Ativo</span></label></div><div class="form-group col-md-4"><label class="control-label" for="field_projetoGit">Projeto no Git</label><input type="text" class="form-control" name="projetoGit" id="field_projetoGit" ng-model="vm.sistema.projetoGit" required ng-minlength="2" ng-maxlength="50"><div ng-show="editForm.projetoGit.$invalid"><p class="help-block" ng-show="editForm.projetoGit.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.projetoGit.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.projetoGit.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group col-md-4"><label class="control-label" for="field_repositorioGit">Reposit\xF3rio no Git</label><input type="text" class="form-control" name="repositorioGit" id="field_repositorioGit" ng-model="vm.sistema.repositorioGit" required ng-minlength="2" ng-maxlength="50"><div ng-show="editForm.repositorioGit.$invalid"><p class="help-block" ng-show="editForm.repositorioGit.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.repositorioGit.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.repositorioGit.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group col-md-4"><label class="control-label" for="field_branchProducaoGit">Branch de Produ\xE7\xE3o no Git</label><input type="text" class="form-control" name="branchProducaoGit" id="field_branchProducaoGit" ng-model="vm.sistema.branchProducaoGit" required ng-minlength="2" ng-maxlength="50"><div ng-show="editForm.branchProducaoGit.$invalid"><p class="help-block" ng-show="editForm.branchProducaoGit.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.branchProducaoGit.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.branchProducaoGit.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group col-md-12"><div class="panel panel-default"><div class="panel-heading"><label>Modulos</label></div><div class="panel-body"><table class="table"><tr class="{{vm.indexModulo(modulo.id) > -1 ? \'success\':\'\'}}" ng-repeat="modulo in vm.modulos track by $index"><td><i class="fa fa-circle-o" ng-click="vm.adicionarModulo(modulo)" ng-show="vm.indexModulo(modulo.id) < 0"></i> <i class="fa fa-check-circle-o" ng-click="vm.removerModulo(modulo)" ng-show="vm.indexModulo(modulo.id) > -1"></i></td><td>{{modulo.descricao}}</td></tr></table></div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ui-sref="release"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/sistema/sistema.html','<div class="ibox"><div class="ibox-title"><h2>Sistemas</h2></div><div class="ibox-content"><div class="row"><div class="col-md-12"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="sistema.new"><span class="glyphicon glyphicon-plus"></span> Novo Sistema</button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome">Nome<span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="projetoGit">Projeto Git<span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="repositorioGit">Repositorio Git<span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="branchProducaoGit">Branch Git<span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="sistema in vm.sistemas track by sistema.id"><td>{{sistema.id}}</td><td>{{sistema.nome}}</td><td>{{sistema.projetoGit}}</td><td>{{sistema.repositorioGit}}</td><td>{{sistema.branchProducaoGit}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="sistema.edit({id:sistema.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="button" ng-click="vm.remover(sistema.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/solicitacaodesenvolvimento/alterar-responsavel.html','<div class="modal-header"><button type="button" class="close" ng-click="vm.clear()">&times;</button><h4 class="modal-title">Alterar respons\xE1vel da tarefa</h4></div><div class="modal-body"><form name="formResponsavel" novalidate><div class="form-group"><label for="field_responsavel">Respons\xE1vel</label><select class="form-control" id="field_responsavel" name="responsavel" ng-model="vm.responsavelSelecionado" ng-options="user as ((user.firstName || user.login) + (user.lastName ? \' \' + user.lastName : \'\')) for user in vm.users | orderBy: \'firstName\' track by user.id"><option value="">Nenhum</option></select></div></form></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="vm.clear()">Cancelar</button> <button type="button" class="btn btn-primary" ng-disabled="vm.isSaving" ng-click="vm.save()"><i class="fa fa-save"></i> Salvar</button></div>');
$templateCache.put('app/entities/solicitacaodesenvolvimento/alterar-situacao.html','<div class="modal-header"><small class="chat-date pull-right" ng-click="vm.clear()">x </small>Alterar Situacao da Tarefa</div><div class="modal-body" id="modal-body-apontar-hora"><div class="row fade in"><div class="col-md-12"><div ng-form="formAlteraSituacao"><div class="row"><div class="col-md-4 form-group"><label class="control-label">Situa\xE7\xE3o</label><select class="form-control" name="tipo" ng-model="vm.solicitacaoDesenvolvimento.situacao" id="field_situacao" ng-options="situacao as \'chamadosApp.SituacaoTarefa.\' + situacao | translate for situacao in vm.situacoes" required></select></div><div class="col-md-4 form-group"><label class="control-label">Data</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.tempoGasto.criadoEm" is-open="vm.opened" required close-text="Close"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.opened = true"><i class="fa fa-calendar"></i></button></span></p></div><div class="col-md-4 form-group"><label class="control-label">Atividade</label><select class="form-control text-black" ng-model="vm.tempoGasto.tipo" placeholder="Tipo da atividade" required><option value=""></option><option value="DESENVOLVIMENTO">Desenvolvimento</option><option value="TESTE">Teste</option><option value="CERIMONIA_SCRUM">Cerim\xF4nia do SCRUM</option><option value="CORRECAO">Corre\xE7\xE3o</option><option value="DOCUMENTACAO">Documenta\xE7\xE3o</option><option value="ESTUDO">Estudo</option><option value="ANALISE">An\xE1lise</option><option value="AUDITORIA">Auditoria</option><option value="GERENCIA">Ger\xEAncia</option><option value="SUPORTE">Suporte</option><option value="CODE_REVIEW">Code Review</option><option value="REUNIAO">Reuni\xE3o</option><option value="INFRAESTRUTURA">Infraestrutura</option><option value="TREINAMENTO">Treinamento</option></select></div></div><div class="row" ng-show="vm.solicitacaoDesenvolvimento.situacao === \'CODE_REVIEW\'"><div class="col-md-5 form-group"><label class="control-label">Projeto Git</label><select class="form-control" name="projeto" ng-model="vm.projetoGit" id="field_projeto" ng-options="projeto as projeto.name for projeto in vm.projetos" required></select></div><div class="col-md-5 form-group"><label class="control-label">Reposit\xF3rio Git</label><select class="form-control" name="repositorie" ng-model="vm.repositorioGit" id="field_repo" ng-options="repositorio as repositorio.name for repositorio in vm.projetoGit.repositories" required></select></div><div class="col-md-2 form-group"><button class="btn btn-block btn-outline btn-success compose-mail m-t-md" ng-click="vm.adicionarRepositorio()" type="button"><i class="fa fa-save"></i> Add</button></div><div class="col-md-12 text-center form-group"><small>Fez o Pull Request? Informe quais os projetos foram envolvidos</small></div><div class="col-md-12 form-group"><table class="table"><tr><th>Projeto</th><th>Reposit\xF3rio</th><th></th></tr><tr ng-repeat="repo in vm.solicitacaoDesenvolvimento.projetosGit"><td>{{repo.projetoGit}}</td><td>{{repo.repositorioGit}}</td><td class="text-center"><a class="text-danger" ng-click="vm.solicitacaoDesenvolvimento.projetosGit.splice($index, 1)"><i class="fa fa-times"></i></a></td></tr></table></div></div><div class="row"><div class="col-md-3 form-group"><label class="control-label">Horas</label><input type="number" class="form-control" ng-min="0" ng-max="99" name="horas" required ng-model="vm.tempoGasto.horas" placeholder="00"><p class="help-block" ng-show="!formAlteraSituacao.horas.$valid">Horas n\xE3o v\xE1lidas, deve estar entre 0 e 99</p></div><div class="col-md-3 form-group"><label class="control-label">Minutos</label><input type="number" class="form-control" ng-model="vm.tempoGasto.minutos" name="minutos" required ng-min="0" ng-max="59" placeholder="00"><p class="help-block" ng-show="!formAlteraSituacao.minutos.$valid">Minutos n\xE3o v\xE1lidos, deve estar entre 0 e 59</p></div><div class="col-md-6 form-group"><button class="btn btn-block btn-outline btn-success compose-mail m-t-md" ng-click="vm.save()" type="button"><i class="fa fa-save"></i> Salvar</button></div></div></div></div></div></div>');
$templateCache.put('app/entities/solicitacaodesenvolvimento/apontar-hora-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySolicitacaoDesenvolvimentoLabel">#{{vm.solicitacaoDesenvolvimento.numero}} - {{vm.solicitacaoDesenvolvimento.titulo}}</h4></div><div class="modal-body"><div class="row"><div class="col-lg-12"><strong>Detalhes</strong></div></div><div class="row m-t-sm"><div class="col-lg-6"><dl class="row mb-5"><div class="col-sm-4 text-right"><dt>Situa\xE7\xE3o:</dt></div><div class="col-sm-8 text-left"><dd class="mb-1"><span class="label label-primary">{{vm.solicitacaoDesenvolvimento.situacao}}</span></dd></div></dl><dl class="row mb-5"><div class="col-sm-4 text-right"><dt>Criado Por:</dt></div><div class="col-sm-8 text-left"><dd class="mb-1 text-info">{{vm.solicitacaoDesenvolvimento.solicitante.firstName}}</dd></div></dl><dl class="row mb-5"><div class="col-sm-4 text-right"><dt>Atribu\xEDdo para:</dt></div><div class="col-sm-8 text-left"><dd class="mb-1">{{vm.solicitacaoDesenvolvimento.responsavel.firstName}} <a ng-click="vm.atribuirTarefa()" ng-if="!vm.solicitacaoDesenvolvimento.responsavel || vm.solicitacaoDesenvolvimento.responsavel.login !== vm.account.login">&nbsp; <i class="fa fa-user"></i> Atribuir para mim</a></dd></div></dl><dl class="row mb-5"><div class="col-sm-4 text-right"><dt>Cliente:</dt></div><div class="col-sm-8 text-left"><dd class="mb-1"><span class="text-navy">{{vm.solicitacaoDesenvolvimento.cliente.nome}}</span></dd></div></dl><dl class="row mb-5"><div class="col-sm-4 text-right"><dt>Sistema:</dt></div><div class="col-sm-8 text-left"><dd class="mb-1"><span class="text-info">{{vm.solicitacaoDesenvolvimento.sistema.nome}}</span></dd></div></dl></div><div class="col-lg-6"><dl class="row mb-5"><div class="col-sm-4 text-right"><dt>Ciclo:</dt></div><div class="col-sm-8 text-left"><dd class="mb-1">{{vm.solicitacaoDesenvolvimento.sprint.descricao}} <a ng-click="vm.alocarTarefa()" ng-if="!vm.solicitacaoDesenvolvimento.sprint || vm.sprint.id !==  vm.solicitacaoDesenvolvimento.sprint.id">&nbsp; <i class="fa fa-refresh"></i> Alocar na sprint atual</a></dd></div></dl><dl class="row mb-5"><div class="col-sm-4 text-right"><dt>M\xF3dulo:</dt></div><div class="col-sm-8 text-left"><dd class="mb-1">{{vm.solicitacaoDesenvolvimento.modulo.descricao}}</dd></div></dl><dl class="row mb-5"><div class="col-sm-4 text-right"><dt>Sub-M\xF3dulo:</dt></div><div class="col-sm-8 text-left"><dd class="mb-1">{{vm.solicitacaoDesenvolvimento.subModulo.descricao}}</dd></div></dl><dl class="row mb-5" ng-show="vm.solicitacaoDesenvolvimento.chamado"><div class="col-sm-4 text-right"><dt>Chamado:</dt></div><div class="col-sm-8 text-left"><dd class="mb-1"><a target="_blank" ui-sref="edit-chamado({id:vm.solicitacaoDesenvolvimento.chamado.id}) ">{{vm.solicitacaoDesenvolvimento.chamado.id}}</a></dd></div></dl></div><div class="row"><div class="col-lg-12"><dl class="row mb-0"><div class="col-sm-2 text-right"><dt>Andamento:</dt></div><div class="col-sm-10 text-left"><dd><div class="progress mb-1"><div style="width: 60%" class="progress-bar progress-bar-striped progress-bar-animated"></div></div><small>Planejado em <strong>{{vm.solicitacaoDesenvolvimento.tempoEstimado}}</strong> horas. Foi gasto at\xE9 o momento {{vm.solicitacaoDesenvolvimento.tempoGasto}}.</small></dd></div></dl></div></div></div><div class="row m-t-md"><div class="col-md-12"><strong>Desenvolvimento</strong></div><div class="col-md-6 m-t-sm"><dl class="row mb-5" ng-if="vm.solicitacaoDesenvolvimento.numero"><div class="col-sm-4 text-right"><dt>Redmine:</dt></div><div class="col-sm-8 text-left"><dd class="mb-1"><a class="label label-danger" href="http://redmine.webpublico.com.br/issues/{{vm.solicitacaoDesenvolvimento.numero}}" target="_blank"><i class="fa fa-users"></i> {{vm.solicitacaoDesenvolvimento.numero}}</a></dd></div></dl><dl class="row mb-5" ng-if="vm.branches" ng-repeat="branch in vm.branches"><div class="col-sm-4 text-right"><dt>Branch:</dt></div><div class="col-sm-8 text-left"><dd class="mb-1"></dd><dd class="mb-1"><a class="label label-success" href="https://stash.webpublico.com.br/projects/{{vm.solicitacaoDesenvolvimento.sistema.projetoGit}}/repos/{{vm.solicitacaoDesenvolvimento.sistema.repositorioGit}}/compare/commits?sourceBranch=refs%2Fheads%2F{{branch.displayId}}&targetBranch=refs%2Fheads%2Fproducao" target="_blank"><i class="fa fa-code-fork"></i> {{branch.displayId}}</a></dd></div></dl></div></div><div class="row m-t-md"><div class="col-md-12"><div class="mail-box"><strong>Descri\xE7\xE3o da Tarefa</strong><div class="small angular-with-newlines">{{vm.solicitacaoDesenvolvimento.conteudo}}</div></div><div class="mail-box"><strong>Crit\xE9rio para valida\xE7\xE3o</strong><div class="small angular-with-newlines">{{vm.solicitacaoDesenvolvimento.criterio}}</div></div></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-click="vm.clear()" ui-sref="solicitacaoDesenvolvimento.edit({id:vm.solicitacaoDesenvolvimento.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> &nbsp;<span data-translate="entity.action.edit">Editar</span></button></div></form>');
$templateCache.put('app/entities/solicitacaodesenvolvimento/solicitacaodesenvolvimento-detail.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="row"><!-- Coluna Principal (Esquerda) --><div class="col-md-8"><div class="ibox" style="border-left: 5px solid #f8ac59"><div class="ibox-title"><div class="pull-right"><a ng-click="vm.alterarSituacao()" class="btn btn-primary btn-xs">{{\'chamadosApp.SituacaoTarefa.\' + vm.solicitacaoDesenvolvimento.situacao | translate}} <i class="fa fa-pencil m-l-xs"></i></a></div><h3 style="margin-top: 0; margin-bottom: 10px"><span class="text-muted">Tarefa: #{{vm.solicitacaoDesenvolvimento.numero}}</span></h3><h2 style="margin-top: 0; margin-bottom: 10px">{{vm.solicitacaoDesenvolvimento.titulo}}</h2><div class="m-t-sm" style="flex-wrap: wrap; display: flex; gap: 4px"><span class="label label-default m-r-xs" data-translate="{{\'chamadosApp.TipoTarefa.\' + vm.solicitacaoDesenvolvimento.tipo}}"></span> <span class="label label-default m-r-xs">Complexidade: {{\'chamadosApp.ComplexidadeChamado.\' + vm.solicitacaoDesenvolvimento.complexidade | translate}}</span> <span class="label label-warning-light m-r-xs" ng-if="vm.solicitacaoDesenvolvimento.chamado.release"><i class="fa fa-code-fork"></i> {{vm.solicitacaoDesenvolvimento.chamado.release.versao}} </span><span class="label label-danger m-r-xs" title="Tarefa n\xE3o planejada para esse ciclo" ng-if="!vm.solicitacaoDesenvolvimento.chamado.planejado"><i class="fa fa-clock-o"></i> N\xE3o Planejado </span><span class="label label-danger m-r-xs" ng-if="vm.solicitacaoDesenvolvimento.chamado && vm.solicitacaoDesenvolvimento.chamado.sprint && vm.solicitacaoDesenvolvimento.chamado.sprint.id < vm.solicitacaoDesenvolvimento.sprint.id"><i class="fa fa-exclamation-triangle"></i> Atrasado </span><span class="label label-info m-r-xs" ng-if="vm.solicitacaoDesenvolvimento.chamado && !vm.solicitacaoDesenvolvimento.chamado.sprint"><i class="fa fa-forward"></i> Adiantado</span></div></div><div class="ibox-content"><div ng-if="!vm.editandoDescricao"><div class="row"><div class="col-md-12"><div class="pull-right" has-authority="ROLE_PO"><button type="button" class="btn btn-default btn-xs" ng-click="vm.editandoDescricao = true"><i class="fa fa-pencil"></i> Editar Descri\xE7\xE3o</button></div><h4>Descri\xE7\xE3o da Tarefa</h4><div class="angular-with-newlines p-sm bg-muted" style="background-color: #f9f9f9; border-radius: 4px" ng-bind-html="vm.solicitacaoDesenvolvimento.conteudo"></div></div></div><div class="row m-t-md"><div class="col-md-12"><h4>Crit\xE9rio para valida\xE7\xE3o</h4><div class="angular-with-newlines p-sm" style="background-color: #fcf8e3; border-radius: 4px; border-left: 4px solid #f8ac59" ng-bind-html="vm.solicitacaoDesenvolvimento.criterio"></div></div></div><div class="row m-t-md" ng-show="vm.solicitacaoDesenvolvimento.chamado.descricaoPo"><div class="col-md-12"><h4>Observa\xE7\xF5es do P.O.</h4><div class="angular-with-newlines p-sm" style="background-color: #d9edf7; border-radius: 4px; border-left: 4px solid #23c6c8" ng-bind-html="vm.solicitacaoDesenvolvimento.chamado.descricaoPo"></div></div></div><div class="row m-t-md"><div class="col-md-12"><h4><a class="text-muted" ng-click="vm.verDescricaoChamado = !vm.verDescricaoChamado" style="font-size: 14px; font-weight: normal"><i class="fa {{vm.verDescricaoChamado ? \'fa-angle-down\' : \'fa-angle-right\'}}"></i> Descri\xE7\xE3o do Chamado Original</a></h4><div class="m-t-sm" ng-show="vm.verDescricaoChamado"><div class="angular-with-newlines p-sm" style="background-color: #f9f9f9; border-radius: 4px; border: 1px solid #e7eaec" ng-bind-html="vm.solicitacaoDesenvolvimento.chamado.conteudo"></div></div></div></div></div><!-- Modo Edi\xE7\xE3o --><div class="row" ng-if="vm.editandoDescricao" ng-form="formDescricao"><div class="col-md-12"><div class="form-group"><label>T\xEDtulo</label><input type="text" class="form-control" name="titulo" id="field_titulo" ng-model="vm.solicitacaoDesenvolvimento.titulo" required ng-minlength="2" ng-maxlength="255"></div><div class="form-group"><label>Descri\xE7\xE3o</label><text-angular name="conteudo" required ng-model="vm.solicitacaoDesenvolvimento.conteudo"></text-angular></div><div class="form-group"><label>Crit\xE9rio para valida\xE7\xE3o</label><textarea type="text" class="form-control" name="criterio" id="field_criterio" rows="5" style="overflow: auto" ng-model="vm.solicitacaoDesenvolvimento.criterio" required ng-minlength="2"></textarea></div><div class="m-t-md"><button type="submit" ng-disabled="formDescricao.$invalid || vm.isSaving" ng-click="vm.save()" class="btn btn-primary"><i class="fa fa-save"></i> Salvar</button> <button type="button" class="btn btn-default" ng-click="vm.reload()"><i class="fa fa-ban"></i> Cancelar</button></div></div></div></div><div class="ibox-footer"><button type="button" class="btn btn-primary btn-sm" ui-sref="solicitacaoDesenvolvimento.edit({id:vm.solicitacaoDesenvolvimento.id})"><i class="fa fa-pencil"></i> Editar Tarefa</button> <button type="button" has-authority="ROLE_USER" ng-click="vm.criarFeedback()" class="btn btn-success btn-sm"><i class="fa fa-feed"></i> Feedback</button> <button type="button" class="btn btn-default btn-sm" ui-sref="solicitacaoDesenvolvimento"><i class="fa fa-arrow-left"></i> Voltar para Lista</button></div></div><!-- Coment\xE1rios --><div class="ibox m-t-md"><div class="ibox-title"><h5>Coment\xE1rios</h5></div><div class="ibox-content"><div class="chat-activity-list"><div class="chat-element {{comentario.usuario.id == vm.solicitacaoDesenvolvimento.solicitante.id ? \'\' : \'right\'}}" ng-repeat="comentario in vm.comentarios | orderBy: \'criadoEm\'"><a href="#" class="{{comentario.usuario.id == vm.solicitacaoDesenvolvimento.solicitante.id ? \'pull-left\' : \'pull-right\'}}"><img ng-src="{{comentario.imagemUsuario}}" ng-show="comentario.imagemUsuario" class="img-circle"> <img alt="image" class="img-circle" ng-show="!comentario.imagemUsuario" ng-src="/content/images/user-default.png"></a><div class="media-body {{comentario.usuario.id == vm.solicitacaoDesenvolvimento.solicitante.id? \'\' : \'text-right\'}}"><small class="{{comentario.usuario.id != vm.solicitacaoDesenvolvimento.solicitante.id? \'pull-left\' : \'pull-right\'}} text-muted">{{ comentario.criadoEm | date:\'dd/MM/yyyy HH:mm\'}} </small><strong>{{comentario.usuario.firstName}}</strong><div class="m-b-xs" style="white-space: pre-wrap" ng-bind-html="vm.trustAsHtml(\'<p>\' + comentario.descricao + \'</p>\')"></div></div></div></div><div class="chat-form m-t-md"><form role="form"><div class="form-group"><textarea type="text" class="form-control" placeholder="Escreva um coment\xE1rio..." name="comentario" id="field_comentario" ng-model="vm.comentario.descricao" ng-minlength="2" rows="3"></textarea></div><div class="text-right"><button type="button" ng-disabled="!vm.comentario.descricao" ng-click="vm.comentar()" class="btn btn-sm btn-primary"><i class="fa fa-comments-o"></i> Comentar</button></div></form></div></div></div></div><!-- Coluna Lateral (Direita) --><div class="col-md-4"><!-- Detalhes --><div class="ibox"><div class="ibox-title"><h5>Detalhes</h5></div><div class="ibox-content no-padding"><ul class="list-group"><li class="list-group-item"><span class="pull-right text-muted">{{vm.solicitacaoDesenvolvimento.cliente.nome}}</span> <strong>Cliente</strong></li><li class="list-group-item"><span class="pull-right text-muted">{{vm.solicitacaoDesenvolvimento.sistema.nome}}</span> <strong>Sistema</strong></li><li class="list-group-item"><span class="pull-right text-muted">{{vm.solicitacaoDesenvolvimento.modulo.descricao}}</span> <strong>M\xF3dulo</strong></li><li class="list-group-item" ng-if="vm.solicitacaoDesenvolvimento.subModulo"><span class="pull-right text-muted">{{vm.solicitacaoDesenvolvimento.subModulo.descricao}}</span> <strong>Sub-m\xF3dulo</strong></li><li class="list-group-item"><span class="pull-right"><a ui-sref="edit-chamado({id:vm.solicitacaoDesenvolvimento.chamado.id})">#{{vm.solicitacaoDesenvolvimento.chamado.id}}</a> <small class="text-muted">({{\'chamadosApp.SituacaoChamado.\' + vm.solicitacaoDesenvolvimento.chamado.situacao | translate}})</small> </span><strong>Chamado</strong></li><li class="list-group-item"><span class="pull-right text-muted" title="Ciclo Original: {{vm.solicitacaoDesenvolvimento.sprintOriginal.descricao}}"><i class="fa fa-code-fork"></i> {{vm.solicitacaoDesenvolvimento.sprint.descricao}} <a ng-click="vm.desalocarTarefa()" class="text-danger m-l-xs" has-authority="ROLE_PO" ng-if="vm.solicitacaoDesenvolvimento.sprint && vm.sprint.id === vm.solicitacaoDesenvolvimento.sprint.id && (vm.solicitacaoDesenvolvimento.situacao == \'A_FAZER\' || vm.solicitacaoDesenvolvimento.situacao == \'CANCELADO\')"><i class="fa fa-times-circle"></i> </a></span><strong>Sprint</strong></li></ul></div></div><!-- Pessoas --><div class="ibox"><div class="ibox-title"><h5>Pessoas</h5></div><div class="ibox-content no-padding"><ul class="list-group"><li class="list-group-item"><strong>Respons\xE1vel</strong> <a ng-click="vm.alterarResponsavel()" class="pull-right text-muted" has-any-authority="ROLE_PO, ROLE_SCRUM, ROLE_ADMIN" title="Alterar respons\xE1vel"><i class="fa fa-pencil"></i></a><div class="m-t-sm"><div ng-if="vm.solicitacaoDesenvolvimento.responsavel"><img ng-src="{{vm.fotoSolicitante || \'/content/images/user-default.png\'}}" class="img-circle m-r-xs" width="24" alt="profile"> {{vm.solicitacaoDesenvolvimento.responsavel.firstName}} {{vm.solicitacaoDesenvolvimento.responsavel.lastName}} <a ng-click="vm.desatribuirTarefa()" class="text-danger pull-right" ng-if="vm.solicitacaoDesenvolvimento.responsavel.login === vm.account.login" title="Desatribuir"><i class="fa fa-times"></i> </a><a ng-click="vm.desatribuirTarefa()" class="text-danger pull-right m-r-xs" has-any-authority="ROLE_PO, ROLE_SCRUM, ROLE_ADMIN" ng-if="vm.solicitacaoDesenvolvimento.responsavel.login !== vm.account.login" title="Remover respons\xE1vel"><i class="fa fa-times"></i></a></div><div ng-if="!vm.solicitacaoDesenvolvimento.responsavel"><span class="text-muted">N\xE3o atribu\xEDdo</span> <a ng-click="vm.atribuirTarefa()" class="btn btn-default btn-xs pull-right">Atribuir a mim</a></div></div></li><li class="list-group-item"><strong>Solicitante</strong><div class="m-t-sm text-muted"><i class="fa fa-user-circle m-r-xs"></i> {{vm.solicitacaoDesenvolvimento.solicitante.firstName}} {{vm.solicitacaoDesenvolvimento.solicitante.lastName}}</div></li></ul></div></div><!-- Tempo --><div class="ibox" has-any-authority="ROLE_PO, ROLE_DESENVOLVEDOR, ROLE_SCRUM"><div class="ibox-title"><h5>Tempo</h5><div class="ibox-tools"><a ng-click="vm.verTodasHoras = !vm.verTodasHoras" class="text-muted"><i class="fa fa-refresh"></i> {{!vm.verTodasHoras ? \'Detalhes\' : \'Resumo\'}}</a></div></div><div class="ibox-content no-padding"><div class="p-sm text-center" style="border-bottom: 1px solid #e7eaec"><div class="row"><div class="col-xs-6"><small class="text-muted">Estimado</small><h3 class="no-margins">{{vm.solicitacaoDesenvolvimento.tempoEstimado | number:2}}h</h3></div><div class="col-xs-6"><small class="text-muted">Gasto</small><h3 class="no-margins {{vm.solicitacaoDesenvolvimento.tempoEstimado > vm.tempoTotalGasto ? \'text-success\' : \'text-danger\'}}">{{vm.tempoTotalGasto | number:2}}h</h3></div></div></div><table class="table small m-b-none"><tr ng-if="!vm.verTodasHoras" ng-repeat="tempo in vm.tempos"><td class="p-l-md">{{tempo.tipo}}</td><td class="text-right p-r-md"><strong>{{tempo.tempo | number: 2}}h</strong></td></tr><tr ng-if="vm.verTodasHoras" ng-repeat="horaApontadas in vm.horasApontadas"><td class="p-l-md">{{horaApontadas.criadoEm | date:\'dd/MM\'}}</td><td>{{horaApontadas.user.firstName}}</td><td>{{\'chamadosApp.TipoHora.\' + horaApontadas.tipo | translate}}</td><td class="text-right p-r-md"><strong>{{horaApontadas.tempo | number: 2}}h</strong></td></tr></table></div></div><!-- Anexos --><div class="ibox"><div class="ibox-title"><h5>Anexos</h5></div><div class="ibox-content no-padding"><table class="table small m-b-none"><tr ng-repeat="anexo in vm.anexos"><td class="p-l-md p-r-md"><a ng-click="vm.downloadAnexo($index)" class="text-navy"><i class="fa fa-paperclip"></i> {{anexo.descricao}}</a><br><small class="text-muted">{{anexo.criadoEm | date:\'mediumDate\'}}</small></td></tr></table><div class="p-sm text-center"><a ngf-select="vm.upload($file)" ngf-max-size="100MB" accept="image/*,application/pdf" class="btn btn-default btn-xs btn-block"><i class="fa fa-upload"></i> Anexar arquivo</a></div></div></div><!-- Desenvolvimento --><div class="ibox"><div class="ibox-title"><h5>Desenvolvimento</h5><div class="ibox-tools"><a ng-click="vm.sincronizarGit()" class="text-muted" title="Sincronizar Git"><i class="fa fa-refresh"></i></a></div></div><div class="ibox-content no-padding"><table class="table small m-b-none"><tr ng-repeat="branch in vm.branches"><td class="p-l-md" ng-show="branch.tipoGit == \'STASH\'"><i class="fa fa-bitbucket"></i> {{branch.projeto.key}}/{{branch.projeto.name}}</td><td class="p-l-md" ng-show="branch.tipoGit == \'GITLAB\'"><i class="fa fa-gitlab"></i> {{branch.projeto.name}}</td><td class="text-right p-r-md"><a class="label label-success" ng-show="branch.tipoGit == \'STASH\'" href="https://stash.webpublico.com.br/projects/{{branch.projeto.key}}/repos/{{branch.projeto.name}}/compare/commits?sourceBranch=refs%2Fheads%2F{{branch.displayId}}&targetBranch=refs%2Fheads%2Fproducao" target="_blank">#{{branch.displayId}} </a><a class="label label-danger" ng-show="branch.tipoGit == \'GITLAB\'" href="https://git.webpublico.com.br/{{branch.projeto.name}}/-/tree/{{branch.displayId}}" target="_blank">#{{branch.displayId}}</a></td></tr><tr ng-if="!vm.branches || vm.branches.length === 0"><td class="text-center text-muted p-sm">Nenhuma branch vinculada</td></tr></table></div></div><!-- Hist\xF3rico de Situa\xE7\xF5es --><div class="ibox"><div class="ibox-title"><h5><a class="text-inherit" ng-click="vm.verDetalhesHoras = !vm.verDetalhesHoras"><i class="fa {{vm.verDetalhesHoras ? \'fa-angle-down\' : \'fa-angle-right\'}}"></i> Hist\xF3rico de Situa\xE7\xF5es</a></h5></div><div class="ibox-content no-padding" ng-show="vm.verDetalhesHoras"><table class="table small m-b-none text-center"><thead><tr><th class="text-center">Situa\xE7\xE3o</th><th class="text-center">In\xEDcio</th><th class="text-center">Fim</th><th class="text-center">Tempo</th></tr></thead><tbody><tr ng-init="historico.tempo = vm.diffHour(historico)" ng-repeat="historico in vm.historicos | orderBy:\'id\'"><td><span class="label label-default">{{\'chamadosApp.SituacaoTarefa.\' + historico.situacao | translate}}</span></td><td>{{historico.inicio | date:\'dd/MM/yy HH:mm\'}}</td><td>{{!historico.fim ? \'Agora\' : historico.fim | date:\'dd/MM/yy HH:mm\'}}</td><td><strong class="text-navy">{{historico.tempo}}</strong></td></tr></tbody></table></div></div></div></div></form><script type="text/ng-template" id="feedbackContent.html"><div class="modal-header">\n        <h3 class="modal-title" id="testar-title">Avalie esse chamado/tarefa</h3>\n    </div>\n    <div class="modal-body" id="testar-body">\n\n        <div class="row">\n            <div class="col-md-12 text-center small">\n                <strong>Avalie-nos!</strong> Sua opini\xE3o \xE9 muito importante para n\xF3s, com ela \xE9 poss\xEDvel entendermos\n                melhor\n                os pontos positivos e negativos dos atendimentos e entregas das demandas solicitadas, assim,\n                melhorando\n                de\n                acordo com a sua necessidade.\n            </div>\n        </div>\n        <div class="row m-t-lg">\n            <form name="editFormfeedBack" role="form" novalidate show-validation>\n                <div class="form-group col-md-12 text-center">\n                    <h3>{{vm.feedBack.chamado.id}} - {{vm.feedBack.chamado.titulo}}</h3><br/>\n                    <label>D\xEA uma nota de 0 a 5</label><br/>\n                    <div class="btn-group">\n                        <button class="btn {{vm.feedBack.nota === 0 ? \'btn-danger\':\'btn-white\'}}" type="button"\n                                ng-click="vm.feedBack.nota = 0">0\n                        </button>\n                        <button class="btn {{vm.feedBack.nota === 1 ? \'btn-danger\':\'btn-white\'}}" type="button"\n                                ng-click="vm.feedBack.nota = 1">1\n                        </button>\n                        <button class="btn {{vm.feedBack.nota === 2 ? \'btn-warning\':\'btn-white\'}}" type="button"\n                                ng-click="vm.feedBack.nota = 2">2\n                        </button>\n                        <button class="btn {{vm.feedBack.nota === 3 ? \'btn-info\':\'btn-white\'}}" type="button"\n                                ng-click="vm.feedBack.nota = 3">3\n                        </button>\n                        <button class="btn {{vm.feedBack.nota === 4 ? \'btn-info\':\'btn-white\'}}" type="button"\n                                ng-click="vm.feedBack.nota = 4">4\n                        </button>\n                        <button class="btn {{vm.feedBack.nota === 5 ? \'btn-success\':\'btn-white\'}}" type="button"\n                                ng-click="vm.feedBack.nota = 5">5\n                        </button>\n                    </div>\n                </div>\n\n                <div class="form-group col-md-12">\n                    <label class="control-label" for="field_descricao">Diga o que voc\xEA pensa sobre esse\n                        chamado/tarefa</label>\n                    <textarea type="text" class="form-control"\n                              name="descricao" id="field_descricao"\n                              ng-model="vm.feedBack.descricao"\n                              rows="5"\n                              required ng-minlength="20" ng-maxlength="3000"></textarea>\n\n                    <div ng-show="editFormfeedBack.descricao.$invalid">\n                        <p class="help-block"\n                           ng-show="editFormfeedBack.v.$error.required"\n                           data-translate="entity.validation.required">\n                            This field is required.\n                        </p>\n                        <p class="help-block"\n                           ng-show="editFormfeedBack.descricao.$error.minlength"\n                           data-translate="entity.validation.minlength"\n                           translate-value-min="20">\n                            This field is required to be at least 20 characters.\n                        </p>\n                        <p class="help-block"\n                           ng-show="editFormfeedBack.descricao.$error.maxlength"\n                           data-translate="entity.validation.maxlength"\n                           translate-value-max="3000">\n                            This field cannot be longer than 3000 characters.\n                        </p>\n                    </div>\n                </div>\n            </form>\n        </div>\n\n    </div>\n    <div class="modal-footer">\n        <button class="btn btn-info" type="button"\n                ng-disabled="!vm.feedBack.nota || !vm.feedBack.descricao"\n                ng-click="vm.ok()">\n            <i class="fa fa-hand-o-up"></i>\n            Avaliar\n        </button>\n    </div></script>');
$templateCache.put('app/entities/solicitacaodesenvolvimento/solicitacaodesenvolvimento-edit.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="ibox"><div class="ibox-title"><h4>Nova Tarefa</h4></div><div class="ibox-content"><div class="row m-t-sm"><div class="form-group col-md-3"><label>Ordem</label><input type="number" class="form-control" name="ordem" id="ordem" ng-model="vm.solicitacaoDesenvolvimento.ordem" required ng-minlength="0" ng-maxlength="9999"></div><div class="form-group col-md-3"><label>Tipo</label><select class="form-control" name="tipo" ng-model="vm.solicitacaoDesenvolvimento.tipo" id="field_tipo" required><option value="BUG">Bug</option><option value="HISTORIA">Hist\xF3ria</option><option value="SPIKE">Spike</option><option value="SCRUM">Scrum</option><option value="REUNIAO">Reuni\xE3o</option></select></div><div class="form-group col-md-3"><label>Situa\xE7\xE3o</label><select class="form-control" name="tipo" ng-model="vm.solicitacaoDesenvolvimento.situacao" id="field_situacao" required><option value="A_FAZER">A Fazer</option><option value="FAZENDO">Fazendo</option><option value="CODE_REVIEW">Code Review</option><option value="IMPEDIDO">Impedido</option><option value="A_TESTAR">A Testar</option><option value="CONCLUIDA">Conclu\xEDdo</option><option value="REJEITADO">Rejeitado</option></select></div><div class="form-group col-md-3"><label>Tempo Estimado</label><input type="number" class="form-control" name="tempoEstimado" id="tempoEstimado" ng-model="vm.solicitacaoDesenvolvimento.tempoEstimado" required ng-minlength="0" ng-maxlength="9999"></div></div><div class="row m-t-sm"><div class="form-group col-md-4"><label>Projeto</label><select class="form-control" required id="field_cliente" name="cliente" ng-model="vm.solicitacaoDesenvolvimento.cliente" ng-change="vm.carregarSistemas()" ng-options="cliente as cliente.nome for cliente in vm.clientes track by cliente.id"><option value=""></option></select></div><div class="form-group col-md-4"><label>Sistema</label><select class="form-control" required id="field_sistema" name="sistema" ng-model="vm.solicitacaoDesenvolvimento.sistema" ng-options="sistema as sistema.nome for sistema in vm.sistemas track by sistema.id"><option value=""></option></select></div><div class="form-group col-md-2"><label class="control-label" for="field_complexidade">Complexidade</label><select class="form-control" name="field_complexidade" ng-model="vm.solicitacaoDesenvolvimento.complexidade" id="field_complexidade" required><option value="MUITO_BAIXA">(1) Muito Baixa</option><option value="BAIXA">(2) Baixa</option><option value="MEDIA">(3) M\xE9dia</option><option value="ALTA">(4) Alta</option><option value="MUITO_ALTA">(5) Muito Alta</option></select><div ng-show="editFormSolicitacao.field_complexidade.$invalid"><p class="help-block" ng-show="editFormSolicitacao.field_complexidade.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-md-2" ng-show="!vm.solicitacaoDesenvolvimento.chamado.id"><label>Gera Chamado Encerrado?</label><br><div class="btn-group"><a ng-click="vm.encerraChamado(true)" class="btn {{vm.solicitacaoDesenvolvimento.chamado.situacao == \'FECHADO\' ? \'btn-success active\': \'btn-default\'}}"><i class="fa fa-check-circle-o"></i> Sim </a><a ng-click="vm.encerraChamado(false)" class="btn {{vm.solicitacaoDesenvolvimento.chamado.situacao != \'FECHADO\' ? \'btn-success active\': \'btn-default\'}}"><i class="fa fa-times-circle-o"></i> N\xE3o</a></div></div></div><div class="row m-t-sm"><div class="form-group col-md-4"><label>M\xF3dulo</label><select class="form-control" required ng-change="vm.carregarSubModulo()" id="field_modulo" name="modulo" ng-model="vm.solicitacaoDesenvolvimento.modulo" ng-options="modulo as modulo.descricao for modulo in vm.modulos track by modulo.id"><option value=""></option></select></div><div class="form-group col-md-4"><label>Sub-M\xF3dulo</label><select class="form-control" required id="field_submodulo" name="submodulo" ng-model="vm.solicitacaoDesenvolvimento.subModulo" ng-options="submodulo as submodulo.descricao for submodulo in vm.submodulos track by submodulo.id"><option value=""></option></select></div><div class="form-group col-md-4"><label>Sprint</label><select class="form-control" required id="field_sprint" name="sprint" ng-model="vm.solicitacaoDesenvolvimento.sprint" ng-options="sprint as sprint.descricao for sprint in vm.sprints track by sprint.id"><option value=""></option></select></div></div><div class="row m-t-md"><div class="col-md-12"><div class="mail-box"><strong>Titulo</strong> <input type="text" class="form-control" name="titulo" id="field_titulo" ng-model="vm.solicitacaoDesenvolvimento.titulo" required ng-minlength="2" ng-maxlength="255"></div><div class="mail-box"><strong>Descri\xE7\xE3o</strong><text-angular name="conteudo" required ng-model="vm.solicitacaoDesenvolvimento.conteudo"></text-angular></div><div class="mail-box"><strong>Crit\xE9rio para valida\xE7\xE3o</strong><textarea type="text" class="form-control" name="criterio" id="field_criterio" rows="10" style="overflow: auto" ng-model="vm.solicitacaoDesenvolvimento.criterio" required ng-minlength="2"> </textarea></div></div></div></div><div class="ibox-footer"><button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span> <span>&nbsp;Salvar</span></button> <button type="button" class="btn btn-default" ui-sref="solicitacaoDesenvolvimento"><span class="glyphicon glyphicon-ban-circle"></span> <span>&nbsp;Cancelar</span></button></div></div></form>');
$templateCache.put('app/entities/solicitacaodesenvolvimento/solicitacaodesenvolvimento-importar.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button></div><div class="modal-body"><div class="row m-t-sm"><div class="col-lg-6"><dl class="row mb-5"><div class="col-sm-4 text-right"><dt>Query Id:</dt></div><div class="col-sm-8 text-left"><dd class="mb-1"><input type="number" class="form-control" name="numero" id="numero" ng-model="vm.solicitacaoDesenvolvimento.numero" required ng-minlength="0" ng-maxlength="9999"></dd></div></dl><dl class="row mb-5"><div class="col-sm-4 text-right"><dt>Cliente:</dt></div><div class="col-sm-8 text-left"><dd class="mb-1"><select class="form-control" required id="field_cliente" name="cliente" ng-model="vm.solicitacaoDesenvolvimento.cliente" ng-change="vm.carregarSistemas()" ng-options="cliente as cliente.nome for cliente in vm.clientes track by cliente.id"><option value=""></option></select></dd></div></dl></div><div class="col-lg-6"><dl class="row mb-5"><div class="col-sm-4 text-right"><dt>Sistema:</dt></div><div class="col-sm-8 text-left"><dd class="mb-1"><select class="form-control" required id="field_sistema" name="sistema" ng-model="vm.solicitacaoDesenvolvimento.sistema" ng-options="sistema as sistema.nome for sistema in vm.sistemas track by sistema.id"><option value=""></option></select></dd></div></dl><dl class="row mb-5"><div class="col-sm-4 text-right"><dt>M\xF3dulo:</dt></div><div class="col-sm-8 text-left"><dd class="mb-1"><select class="form-control" required ng-change="vm.carregarSubModulo()" id="field_modulo" name="modulo" ng-model="vm.solicitacaoDesenvolvimento.modulo" ng-options="modulo as modulo.descricao for modulo in vm.modulos track by modulo.id"><option value=""></option></select></dd></div></dl><dl class="row mb-5"><div class="col-sm-4 text-right"><dt>Sub-M\xF3dulo:</dt></div><div class="col-sm-8 text-left"><dd class="mb-1"><select class="form-control" required id="field_submodulo" name="submodulo" ng-model="vm.solicitacaoDesenvolvimento.subModulo" ng-options="submodulo as submodulo.descricao for submodulo in vm.submodulos track by submodulo.id"><option value=""></option></select></dd></div></dl></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;Cancelar</button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;Importar</button></div></form>');
$templateCache.put('app/entities/solicitacaodesenvolvimento/solicitacaodesenvolvimento.html','<div class="ibox"><div class="ibox-title"><h2><h2>Tarefas</h2></h2></div><div class="ibox-content"><div class="row"><div class="col-md-12"><div class="col-md-10"><search-box ng-model="vm.filtro" search-method="vm.loadAll()"></search-box></div><div class="col-md-2"><button class="btn btn-primary btn-block" ui-sref="solicitacaoDesenvolvimento.new"><i class="fa fa-plus"></i> Criar Tarefa</button></div><br><div class="col-md-12"><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="numero">N\xFAmero <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="titulo">Titulo <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="modulo.descricao">M\xF3dulo <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="situacao">Situa\xE7\xE3o <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="sprint">Ciclo <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="solicitacaoDesenvolvimento in vm.solicitacaoDesenvolvimentos track by solicitacaoDesenvolvimento.id"><td>{{solicitacaoDesenvolvimento.numero}}</td><td>{{solicitacaoDesenvolvimento.titulo}}</td><td>{{solicitacaoDesenvolvimento.modulo.descricao}}</td><td>{{solicitacaoDesenvolvimento.situacao}}</td><td>{{solicitacaoDesenvolvimento.sprint.descricao}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="button" ui-sref="solicitacaoDesenvolvimento.detail({id:solicitacaoDesenvolvimento.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-search"></span></button> <button type="button" has-authority="ROLE_SCRUM" ui-sref="solicitacaoDesenvolvimento.edit({id:solicitacaoDesenvolvimento.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span></button> <button type="button" has-authority="ROLE_SCRUM" ng-click="vm.remover(solicitacaoDesenvolvimento.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button></div></td></tr></tbody></table></div></div><br><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/solicitante/solicitante-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mysolicitanteLabel" data-translate="chamadosApp.solicitante.home.createOrEditLabel">Create or edit a solicitante</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.solicitante.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.solicitante.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="chamadosApp.solicitante.nome" for="field_nome">Nome</label><input type="text" class="form-control" name="nome" id="field_nome" ng-model="vm.solicitante.nome" required ng-minlength="2" ng-maxlength="100"><div ng-show="editForm.nome.$invalid"><p class="help-block" ng-show="editForm.nome.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.nome.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.nome.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="100">This field cannot be longer than 100 characters.</p></div></div><div class="form-group"><label for="field_cliente">Projeto</label><select class="form-control" required id="field_cliente" name="cliente" ng-model="vm.solicitante.cliente" ng-options="cliente as cliente.nome for cliente in vm.clientes track by cliente.id"><option value=""></option></select><div ng-show="editForm.cliente.$invalid"><p class="help-block small" ng-show="editForm.cliente.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/solicitante/solicitantes.html','<div class="ibox"><div class="ibox-title"><h2><h2 data-translate="chamadosApp.solicitante.home.title">Solicitantes</h2></h2></div><div class="ibox-content"><div class="row"><div class="col-md-12"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="solicitante.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="chamadosApp.solicitante.home.createLabel">Create new Solicitante</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="nome"><span data-translate="chamadosApp.solicitante.nome">Nome</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="projetoRedMine"><span data-translate="chamadosApp.solicitante.cliente">Cliente</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="solicitante in vm.solicitantes track by solicitante.id"><td>{{solicitante.id}}</td><td>{{solicitante.nome}}</td><td>{{solicitante.cliente.nome}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="solicitante.edit({id:solicitante.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="button" ng-click="vm.remover(solicitante.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/sprint/sprint-delete-dialog.html','<form name="deleteForm" ng-submit="vm.confirmDelete(vm.sprint.id)"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" data-translate="entity.delete.title">Confirm delete operation</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><p data-translate="chamadosApp.sprint.delete.question" translate-values="{id: \'{{vm.sprint.id}}\'}">Are you sure you want to delete this Sprint?</p></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="deleteForm.$invalid" class="btn btn-danger"><span class="glyphicon glyphicon-remove-circle"></span>&nbsp;<span data-translate="entity.action.delete">Delete</span></button></div></form>');
$templateCache.put('app/entities/sprint/sprint-detail.html','<div class="row"><div class="col-md-12"><div class="ibox"><div class="ibox-title"><h2>{{vm.sprint.descricao}}</h2></div><div class="ibox-content"><div class="row"><div class="col-md-12"><div class="col-md-4 text-center"><h3><strong><span data-translate="{{\'chamadosApp.SituacaoSprint.\' + vm.sprint.situacao}}">{{vm.sprint.situacao}}</span></strong></h3><address>In\xEDcio: {{vm.sprint.inicio | date:\'mediumDate\'}}<br>Final: {{vm.sprint.fim | date:\'mediumDate\'}}<br></address></div><div class="col-md-4 text-center"><p class="font-bold"><i class="fa fa-clock-o"></i> {{vm.sprint.horasDisponiveis}} Horas Disponiveis</p><p class="font-bold"><i class="fa fa-clock-o"></i> {{vm.horasPlanejadas | number: 1}} Horas Planejadas</p><p class="font-bold" has-authority="ROLE_ATENDENTE"><i class="fa {{vm.tempoTotalGasto > vm.horasPlanejadas ? \'fa-arrow-up\':\'fa-arrow-down\'}}"></i> {{vm.tempoTotalGasto | number: 1}} Horas Utilizadas</p><p class="font-bold text-center" has-authority="ROLE_ATENDENTE"></p><li class="text-left" ng-repeat="tempo in vm.tempos">{{tempo.tipo}} : {{tempo.tempo | number:2}}h</li><p></p></div><div class="col-md-4 text-center"><button class="btn btn-info btn-block" ng-click="vm.criarPlanejamento(vm.sprint)" ng-show="!vm.sprint.planejamento"><i class="fa fa-file"></i> Criar Ata de Planejamento</button> <button class="btn btn-info btn-block" ui-sref="detail-ata({id:vm.sprint.planejamento.id})" ng-show="vm.sprint.planejamento"><i class="fa fa-file"></i> Ver Ata de Planejamento</button> <button class="btn btn-success btn-block" ng-click="vm.criarEncerramento(vm.sprint)" ng-show="!vm.sprint.encerramento"><i class="fa fa-file"></i> Criar Ata de Encerramento</button> <button class="btn btn-success btn-block" ui-sref="detail-ata({id:vm.sprint.encerramento.id})" ng-show="vm.sprint.encerramento"><i class="fa fa-file"></i> Ver Ata de Encerramento</button> <button class="btn btn-warning btn-block" ng-click="vm.criarReuniaoDiaria(vm.sprint)" ng-show="!vm.sprint.reuniaoDiaria"><i class="fa fa-file"></i> Criar Ata de Reuni\xE3o Di\xE1ria</button> <button class="btn btn-warning btn-block" ui-sref="detail-ata({id:vm.sprint.reuniaoDiaria.id})" ng-show="vm.sprint.reuniaoDiaria"><i class="fa fa-file"></i> Ver Ata de Reuni\xE3o Di\xE1ria</button></div><div class="col-md-12 m-t-md"><iframe allowtransparency frameborder="0" height="800" src="{{vm.dashBoardUrl}}" style="width: 100%"></iframe></div></div><div class="col-md-12 m-t-md"><button type="submit" ui-sref="{{ vm.previousState }}" class="btn btn-info"><span class="glyphicon glyphicon-arrow-left"></span>&nbsp;<span data-translate="entity.action.back"> Back</span></button> <button has-authority="ROLE_SCRUM" type="button" ui-sref="sprint-detail.edit({id:vm.sprint.id})" class="btn btn-primary"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit">Edit</span></button> <button type="button" has-authority="ROLE_SCRUM" ng-if="vm.sprint.situacao == \'EM_ANDAMENTO\'" class="btn btn-warning" ng-click="vm.encerrarSprint()"><span class="fa fa-check-circle-o"></span> <span class="hidden-sm-down">Encerrar Sprint</span></button></div></div></div></div><div class="ibox"><div class="ibox-title"><h2>{{vm.sprintAberta.descricao}}</h2></div><div class="ibox-content"><div class="row"><div class="col-md-12"><div class="col-md-4 text-center"><h3><strong><span data-translate="{{\'chamadosApp.SituacaoSprint.\' + vm.sprintAberta.situacao}}">{{vm.sprintAberta.situacao}}</span></strong></h3><address>In\xEDcio: {{vm.sprintAberta.inicio | date:\'mediumDate\'}}<br>Final: {{vm.sprintAberta.fim | date:\'mediumDate\'}}<br></address></div><div class="col-md-4 text-center"><p class="font-bold"><i class="fa fa-clock-o"></i> {{vm.sprintAberta.horasDisponiveis}} Horas Disponiveis</p><p class="font-bold"><i class="fa fa-clock-o"></i> {{vm.horasPlanejadasSprintAberta | number: 1}} Horas Planejadas</p></div><div class="col-md-4 text-center"><button class="btn btn-info btn-block" ng-click="vm.criarPlanejamento(vm.sprintAberta)" ng-show="!vm.sprintAberta.planejamento"><i class="fa fa-file"></i> Criar Ata de Planejamento</button> <button class="btn btn-info btn-block" ui-sref="detail-ata({id:vm.sprintAberta.planejamento.id})" ng-show="vm.sprintAberta.planejamento"><i class="fa fa-file"></i> Ver Ata de Planejamento</button> <button class="btn btn-success btn-block" ng-click="vm.criarEncerramento(vm.sprintAberta)" ng-show="!vm.sprintAberta.encerramento"><i class="fa fa-file"></i> Criar Ata de Encerramento</button> <button class="btn btn-success btn-block" ui-sref="detail-ata({id:vm.sprintAberta.encerramento.id})" ng-show="vm.sprintAberta.encerramento"><i class="fa fa-file"></i> Ver Ata de Encerramento</button> <button class="btn btn-warning btn-block" ng-click="vm.criarReuniaoDiaria(vm.sprintAberta)" ng-show="!vm.sprintAberta.reuniaoDiaria"><i class="fa fa-file"></i> Criar Ata de Reuni\xE3o Di\xE1ria</button> <button class="btn btn-warning btn-block" ui-sref="detail-ata({id:vm.sprintAberta.reuniaoDiaria.id})" ng-show="vm.sprintAberta.reuniaoDiaria"><i class="fa fa-file"></i> Ver Ata de Reuni\xE3o Di\xE1ria</button></div><div class="col-md-12 m-t-md"><table class="table small"><tr><th class="text-center">M\xF3dulo</th><th class="text-center">Tempo Estimado</th><th class="text-center">Chamados a Fazer</th><th class="text-center">Chamados fazendo</th><th class="text-center">Chamados entregues</th><th class="text-center">Chamado sem tarefa</th></tr><tr ng-repeat="modulo in vm.modulosSprintAberta track by modulo.modulo.id"><td><strong>{{modulo.modulo.descricao}}</strong></td><td class="text-center">{{modulo.tempoEstimado}}</td><td class="text-center">{{modulo.chamadosAFazer}}</td><td class="text-center">{{modulo.chamadosFazendo}}</td><td class="text-center">{{modulo.chamadosEntregues}}</td><td class="text-center"><p class="font-bold text-center" has-authority="ROLE_ATENDENTE"></p><li class="text-left" ng-repeat="chamado in modulo.chamadosSemTarefas"><a ui-sref="edit-chamado({id:chamado.id}) ">{{chamado.id}} - {{chamado.titulo}}</a></li><p></p></td></tr></table></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/sprint/sprint-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()"><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySprintLabel" data-translate="chamadosApp.sprint.home.createOrEditLabel">Create or edit a Sprint</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.sprint.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.sprint.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="chamadosApp.sprint.inicio" for="field_inicio">Inicio</label><div class="input-group"><input id="field_inicio" type="text" class="form-control" name="inicio" uib-datepicker-popup="{{dateformat}}" ng-model="vm.sprint.inicio" is-open="vm.datePickerOpenStatus.inicio"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'inicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="chamadosApp.sprint.fim" for="field_fim">Fim</label><div class="input-group"><input id="field_fim" type="text" class="form-control" name="fim" uib-datepicker-popup="{{dateformat}}" ng-model="vm.sprint.fim" is-open="vm.datePickerOpenStatus.fim"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fim\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div></div><div class="form-group"><label class="control-label" data-translate="chamadosApp.sprint.descricao" for="field_descricao">Descricao</label><input type="text" class="form-control" name="descricao" id="field_descricao" ng-model="vm.sprint.descricao"></div><div class="form-group"><label class="control-label" data-translate="chamadosApp.sprint.situacao" for="field_situacao">Situacao</label><select class="form-control" name="situacao" ng-model="vm.sprint.situacao" id="field_situacao"><option value="ABERTA" data-translate="chamadosApp.SituacaoSprint.ABERTA">ABERTA</option><option value="FECHADA" data-translate="chamadosApp.SituacaoSprint.FECHADA">FECHADA</option><option value="EM_ANDAMENTO" data-translate="chamadosApp.SituacaoSprint.EM_ANDAMENTO">EM_ANDAMENTO</option></select></div><div class="form-group" ng-repeat="cliente in vm.sprint.clientes"><label class="control-label">{{cliente.cliente.nome}}</label><input type="number" class="form-control" name="horasDisponiveis" id="field_horasDisponiveis" ng-model="cliente.horasDisponiveis"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/sprint/sprints.html','<div class="ibox"><div class="ibox-title"><h2>Ciclo</h2></div><div class="ibox-content"><div class="row"><div class="col-md-12"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="sprint.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="chamadosApp.sprint.home.createLabel">Create new Sprint</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="inicio"><span data-translate="chamadosApp.sprint.inicio">Inicio</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="fim"><span data-translate="chamadosApp.sprint.fim">Fim</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="chamadosApp.sprint.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="situacao"><span data-translate="chamadosApp.sprint.situacao">Situacao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="horasDisponiveis"><span data-translate="chamadosApp.sprint.horasDisponiveis">Horas Disponiveis</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="sprint in vm.sprints track by sprint.id"><td><a ui-sref="sprint-detail({id:sprint.id})">{{sprint.id}}</a></td><td>{{sprint.inicio | date:\'mediumDate\'}}</td><td>{{sprint.fim | date:\'mediumDate\'}}</td><td>{{sprint.descricao}}</td><td data-translate="{{\'chamadosApp.SituacaoSprint.\' + sprint.situacao}}">{{sprint.situacao}}</td><td>{{sprint.horasDisponiveis}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="sprint-detail({id:sprint.id})" class="btn btn-info btn-sm"><span class="glyphicon glyphicon-eye-open"></span> <span class="hidden-sm-down" data-translate="entity.action.view"></span></button> <button type="submit" has-authority="ROLE_SCRUM" ui-sref="sprint.edit({id:sprint.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" has-authority="ROLE_SCRUM" ui-sref="sprint.delete({id:sprint.id})" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/submodulo/submodulo-dialog.html','<form name="editForm" role="form" novalidate ng-submit="vm.save()" show-validation><div class="modal-header"><button type="button" class="close" data-dismiss="modal" aria-hidden="true" ng-click="vm.clear()">&times;</button><h4 class="modal-title" id="mySubModuloLabel" data-translate="chamadosApp.subModulo.home.createOrEditLabel">Create or edit a SubModulo</h4></div><div class="modal-body"><jhi-alert-error></jhi-alert-error><div class="form-group" ng-show="vm.subModulo.id"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.subModulo.id" readonly="readonly"></div><div class="form-group"><label class="control-label" data-translate="chamadosApp.subModulo.descricao" for="field_descricao">Descricao</label><input type="text" class="form-control" name="descricao" id="field_descricao" ng-model="vm.subModulo.descricao" required ng-minlength="2" ng-maxlength="50"><div ng-show="editForm.descricao.$invalid"><p class="help-block" ng-show="editForm.descricao.$error.required" data-translate="entity.validation.required">This field is required.</p><p class="help-block" ng-show="editForm.descricao.$error.minlength" data-translate="entity.validation.minlength" translate-value-min="2">This field is required to be at least 2 characters.</p><p class="help-block" ng-show="editForm.descricao.$error.maxlength" data-translate="entity.validation.maxlength" translate-value-max="50">This field cannot be longer than 50 characters.</p></div></div><div class="form-group"><label class="control-label" data-translate="chamadosApp.subModulo.modulo" for="field_modulo">Projeto Red Mine</label><select class="form-control" id="field_modulo" name="modulo" ng-model="vm.subModulo.modulo" ng-options="modulo as modulo.descricao for modulo in vm.modulos track by modulo.id"></select></div></div><div class="modal-footer"><button type="button" class="btn btn-default" data-dismiss="modal" ng-click="vm.clear()"><span class="glyphicon glyphicon-ban-circle"></span>&nbsp;<span data-translate="entity.action.cancel">Cancel</span></button> <button type="submit" ng-disabled="editForm.$invalid || vm.isSaving" class="btn btn-primary"><span class="glyphicon glyphicon-save"></span>&nbsp;<span data-translate="entity.action.save">Save</span></button></div></form>');
$templateCache.put('app/entities/submodulo/submodulo.html','<div class="ibox"><div class="ibox-title"><h2 data-translate="chamadosApp.subModulo.home.title">SubModulos</h2></div><div class="ibox-content"><div class="row"><div class="col-md-12"><jhi-alert></jhi-alert><div class="container-fluid"><div class="row"><div class="col-xs-4 no-padding-left"><button class="btn btn-primary" ui-sref="subModulo.new"><span class="glyphicon glyphicon-plus"></span> <span data-translate="chamadosApp.subModulo.home.createLabel">Create new SubModulo</span></button></div></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th jh-sort-by="id"><span data-translate="global.field.id">ID</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="descricao"><span data-translate="chamadosApp.subModulo.descricao">Descricao</span> <span class="glyphicon glyphicon-sort"></span></th><th jh-sort-by="projetoRedMine"><span data-translate="chamadosApp.subModulo.modulo">Projeto Red Mine</span> <span class="glyphicon glyphicon-sort"></span></th><th></th></tr></thead><tbody><tr ng-repeat="subModulo in vm.subModulos track by subModulo.id"><td>{{subModulo.id}}</td><td>{{subModulo.descricao}}</td><td>{{subModulo.modulo.descricao}}</td><td class="text-right"><div class="btn-group flex-btn-group-container"><button type="submit" ui-sref="subModulo.edit({id:subModulo.id})" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> <span class="hidden-sm-down" data-translate="entity.action.edit"></span></button> <button type="submit" ng-click="vm.remover(subModulo.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span> <span class="hidden-sm-down" data-translate="entity.action.delete"></span></button></div></td></tr></tbody></table></div><div class="text-center"><jhi-item-count page="vm.page" total="vm.queryCount" items-per-page="vm.itemsPerPage"></jhi-item-count><uib-pagination class="pagination-sm" total-items="vm.totalItems" items-per-page="vm.itemsPerPage" ng-model="vm.page" ng-change="vm.transition()"></uib-pagination></div></div></div></div></div>');
$templateCache.put('app/entities/teamboard/teamboard.html','<div class="col-md-12"><div class="row text-center m-b-lg" has-any-authority="ROLE_ATENDENTE, ROLE_PO, ROLE_DESENVOLVEDOR"><div data-toggle="buttons-checkbox" class="btn-group"><a ui-sref="home" class="btn btn-primary" type="button"><i class="fa fa-dashboard"></i> Dashboard Ciclo </a><a ui-sref="scrumboard" class="btn btn-primary" type="button"><i class="fa fa-code-fork"></i> Task Board </a><a ui-sref="myboard" class="btn btn-primary" type="button"><i class="fa fa-user"></i> Team Board </a><a ui-sref="teamboard" class="btn btn-primary active" type="button"><i class="fa fa-users"></i> Team Board </a><a ui-sref="burnup" class="btn btn-primary" type="button"><i class="fa fa-line-chart"></i> Burnup</a></div></div><div class="col-md-4 text-center"></div><div class="col-md-4 text-center"><h2>MyBoard</h2></div></div><div class="col-md-12 no-padding no-margins"><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-content"><div class="row"><form><div class="form-group col-md-6"><label class="control-label" for="field_sprint">Sprint</label><select class="form-control" required id="field_sprint" name="sprint" ng-model="vm.sprint" ng-options="sprint as sprint.descricao for sprint in vm.sprints track by sprint.id"><option value=""></option></select></div><div class="form-group col-md-6"><label class="control-label">&ensp;</label><button ng-click="vm.recuperarTickets()" class="btn btn-success btn-block"><i class="fa fa-search"></i> Buscar</button></div></form></div><div class="row" has-authority="ROLE_SCRUM"><div class="col-lg-12 text-center"><a ng-click="vm.mostraTime = !vm.mostraTime"><h5>Time</h5></a></div><div class="col-lg-12 text-center" ng-show="vm.mostraTime"><button class="btn m-sm btn-white {{vm.filtro.user.id == user.id ? \'btn-info active\' : \'\'}}" ng-repeat="user in vm.users | orderBy:\'firstName\' track by $index " ng-click="vm.filtro.user = user; vm.recuperarTickets();" type="button">{{user.firstName}} <small>{{user.lastName}}</small></button></div></div></div></div></div></div></div><div class="col-md-12 text-center"><img ng-src="{{vm.filtro.user.imagem}}" ng-show="vm.filtro.user.imagem" width="100" class="img-circle" alt="foto do usuario"><h2>{{vm.filtro.user.firstName}} {{vm.filtro.user.lastName}}</h2></div><div class="ibox"><div class="ibox-content"><div class="row"><div class="col-md-12 text-center m-b-md"><h3>Horas Trabalhadas x Apontadas</h3></div><div class="col-md-4"><div class="table-responsive"><table class="jh-table table table-striped table-hover"><tr><th class="text-center">Dia</th><th class="text-center">Ponto</th><th class="text-center">Apontado</th><th class="text-center">%</th></tr><tr class="text-center" ng-repeat="dia in vm.horaApontadaPorDia"><td>{{dia.dia | date:\'mediumDate\'}}</td><td class="text-center">{{dia.horaPonto | number : 2}}</td><td class="text-center">{{dia.tempoGasto | number : 2}}</td><td class="text-center"><span class="label {{dia.percentual < 80 ? \'label-danger\': \'label-info\'}}">{{dia.percentual | number : 2}}%</span></td></tr><tr><td colspan="4" class="text-center"><small>*Ser\xE3o consideradas 8.48h para os dias sem ponto</small><br><a ui-sref="tempo-gasto"><i class="fa fa-link"></i> Detalhar</a></td></tr></table></div></div><div class="col-md-8"><canvas id="modulo" class="chart chart-line" legend="true" responsive="true" chart-data="vm.dataHoras" chart-series="vm.serieHoras" chart-labels="vm.labelsHoras"></canvas></div></div></div></div><div class="ibox"><div class="ibox-content"><div class="row m-t-md"><div class="col-md-12 text-center m-b-md"><h3>Tarefas</h3></div><div class="col-lg-12"><div class="table-responsive"><table class="table" ng-repeat="(key, value) in vm.tarefas"><tr><th colspan="4">{{key}}</th></tr><tr ng-repeat="tarefa in value | orderBy:\'situacao\'"><td class="col-md-6"><a ui-sref="solicitacaoDesenvolvimento.detail({id:tarefa.id})">#{{tarefa.numero}}</a> &ensp;{{tarefa.titulo}}</td><td class="text-center"><span class="label {{tarefa.situacao == \'CONCLUIDA\'? \'label-success\': \'label-warning\'}}">{{\'chamadosApp.SituacaoTarefa.\' + tarefa.situacao | translate}}</span></td><td has-any-authority="ROLE_PO, ROLE_SCRUM" class="text-right {{tarefa.tempoGasto > tarefa.tempoEstimado? \'text-danger\': \'text-success\'}}">{{tarefa.tempoEstimado |number:1}}<small>h</small> <i class="fa fa-clock-o"></i></td><td class="text-right">{{tarefa.tempoGasto |number:1}}<small>h</small> <i class="fa fa-line-chart"></i></td></tr></table></div></div><div class="col-md-12 text-center m-b-md" has-any-authority="ROLE_PO, ROLE_SCRUM, ROLE_ATENDENTE"><h3>Chamados</h3></div><div class="col-lg-12" has-any-authority="ROLE_PO, ROLE_SCRUM, ROLE_ATENDENTE"><div class="table-responsive"><table class="table"><tr ng-repeat="chamado in vm.chamados"><td class="col-md-6"><a ui-sref="chamado.edit({id:chamado.id})">#{{chamado.id}} </a>&ensp;{{chamado.titulo}}</td><td class="text-center">{{\'chamadosApp.SituacaoChamado.\' + chamado.situacao | translate}}</td><td has-any-authority="ROLE_PO, ROLE_SCRUM" class="text-right {{chamado.tempoGasto > chamado.tempoEstimado? \'text-danger\': \'text-success\'}}">{{chamado.tempoEstimado |number:1}}<small>h</small> <i class="fa fa-clock-o"></i></td><td class="text-right">{{chamado.tempoGasto |number:1}}<small>h</small> <i class="fa fa-line-chart"></i></td></tr></table></div></div></div></div></div><div class="ibox"><div class="ibox-content"><div class="row m-t-md"><div class="col-lg-4"><div class="ibox"><div class="ibox-content"><h3>M\xF3dulos</h3><canvas id="chart-modulo" class="chart chart-pie" legend="true" responsive="true" chart-data="vm.dataModulo" chart-labels="vm.labelsModulo"></canvas></div></div><div class="col-md-12"><table class="table"><tr ng-repeat="modulo in vm.labelsModulo track by $index"><td>{{vm.dataModulo[vm.labelsModulo.indexOf(modulo)] | number:1}}<small>h</small></td><td>{{modulo}}</td><td class="text-right"><small class="text-success">{{(vm.dataModulo[vm.labelsModulo.indexOf(modulo)] * 100) / vm.totalModulo | number:0}}%</small></td></tr></table></div></div><div class="col-lg-4"><div class="ibox"><div class="ibox-content"><h3>Tipo</h3><canvas id="chart-tipo" class="chart chart-polar-area" legend="true" responsive="true" chart-data="vm.dataTipo" chart-labels="vm.labelsTipo"></canvas></div></div><div class="col-md-12"><table class="table"><tr ng-repeat="tipo in vm.labelsTipo track by $index"><td>{{vm.dataTipo[vm.labelsTipo.indexOf(tipo)] | number:1}}<small>h</small></td><td>{{tipo}}</td><td class="text-right"><small class="text-success">{{(vm.dataTipo[vm.labelsTipo.indexOf(tipo)] * 100) / vm.totalTipo | number:0}}%</small></td></tr></table></div></div><div class="col-lg-4"><div class="ibox"><div class="ibox-content"><h3>Complexidade</h3><canvas id="chart-complexidade" class="chart chart-doughnut" legend="true" responsive="true" chart-data="vm.dataComplexidade" chart-labels="vm.labelsComplexidade"></canvas></div></div><div class="col-md-12"><table class="table"><tr ng-repeat="complexidade in vm.labelsComplexidade track by $index"><td>{{vm.dataComplexidade[vm.labelsComplexidade.indexOf(complexidade)] | number:1}} <small>h</small></td><td>{{complexidade}}</td><td class="text-right"><small class="text-success">{{(vm.dataComplexidade[vm.labelsComplexidade.indexOf(complexidade)] * 100) / vm.totalComplexidade | number:0}}%</small></td></tr></table></div></div></div></div></div><div class="col-lg-12"><div class="ibox"><div class="ibox-content"><h3>Resumo</h3><div class="col-lg-3"><div class="widget style1 lazur-bg"><div class="row vertical-align"><div class="col-xs-3"><i class="fa fa-clock-o fa-3x"></i></div><div class="col-xs-9 text-right"><h2 class="font-bold">{{vm.totalHoraTrabalhadas | number : 2}}</h2><small>Horas</small></div></div></div></div><div class="col-lg-3"><div class="widget style1 yellow-bg"><div class="row vertical-align"><div class="col-xs-3"><i class="fa fa-shield fa-3x"></i></div><div class="col-xs-9 text-right"><h2 class="font-bold" ng-if="vm.totalHoraTrabalhadas != 0">{{vm.totalHoraTrabalhadas / vm.totalTarefas | number : 2}}</h2><h2 class="font-bold" ng-if="vm.totalHoraTrabalhadas == 0">0</h2><small>Tempo M\xE9dio / {{vm.totalTarefas}} Tarefas</small></div></div></div></div><div class="col-lg-3"><div class="widget style1 red-bg"><div class="row vertical-align"><div class="col-xs-3"><i class="fa fa-thumbs-down fa-3x"></i></div><div class="col-xs-9 text-right"><h2 class="font-bold">{{vm.getQuantidadeTickets(\'REJEITADO\')}}</h2><small>Rejeitados</small></div></div></div></div><div class="col-lg-3"><div class="widget style1 green-bg"><div class="row vertical-align"><div class="col-xs-3"><i class="fa fa-thumbs-up fa-3x"></i></div><div class="col-xs-9 text-right"><h2 class="font-bold">{{vm.getQuantidadeTickets(\'CONCLUIDA\')}}</h2><small>Concluidos</small></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/tempogasto/tempogasto-dialog.html','<div class="modal-header"><small class="chat-date pull-right" ng-click="vm.clear()">x </small>Apontar Horas</div><div class="modal-body" id="modal-body-apontar-hora"><div class="row fade in"><div class="col-md-12"><div ng-form="formTempoGasto"><div class="row text-center" ng-show="vm.tempoGasto.ata"><strong>Ata #{{vm.tempoGasto.ata.numero}}</strong><br>{{vm.tempoGasto.ata.titulo}}</div><div class="row text-center" ng-show="vm.tempoGasto.chamado"><strong>Chamado #{{vm.tempoGasto.chamado.id}}</strong> <span class="label label-primary m-r-sm" ng-if="vm.tempoGasto.chamado.sprint"><i class="fa fa-code-fork"></i> {{vm.tempoGasto.chamado.sprint.descricao}} </span><span class="label label-info" data-translate="{{\'chamadosApp.SituacaoChamado.\' + vm.tempoGasto.chamado.situacao}}">{{vm.tempoGasto.chamado.situacao}}</span> <span ng-if="vm.tempoGasto.chamado.sprint && !vm.tempoGasto.chamado.planejado" class="small label">NP</span> <a ui-sref="release-detail({versao:vm.chamado.release.versao, sistemaId: vm.chamado.release.sistema.id})" class="label label-primary m-r-sm" ng-if="vm.tempoGasto.chamado.release"><i class="fa fa-code-fork"></i> {{vm.tempoGasto.chamado.release.versao}} </a><span class="label label-primary m-r-sm" ng-if="vm.tempoGasto.chamado.desenvolvimentoIniciado"><i class="fa fa-code-fork"></i> Desenvolvimento Iniciado</span></div><div class="row m-t-sm text-center" ng-show="vm.tempoGasto.solicitacaoDesenvolvimento"><strong>Tarefa #{{vm.tempoGasto.solicitacaoDesenvolvimento.numero}}</strong> <span class="label label-primary m-r-sm" ng-if="vm.tempoGasto.solicitacaoDesenvolvimento.sprint"><i class="fa fa-code-fork"></i> {{vm.tempoGasto.solicitacaoDesenvolvimento.sprint.descricao}} </span><span class="label label-success m-r-sm" ng-if="vm.tempoGasto.solicitacaoDesenvolvimento.tempoEstimado"><i class="fa fa-clock-o"></i> {{vm.tempoGasto.solicitacaoDesenvolvimento.tempoEstimado}}h </span><a class="label label-danger m-r-sm" href="http://redmine.webpublico.com.br/issues/{{vm.tempoGasto.solicitacaoDesenvolvimento.numero}}" target="_blank"><i class="fa fa-users"></i> {{vm.tempoGasto.solicitacaoDesenvolvimento.numero}} </a><a class="label label-success m-r-sm" ng-repeat="branch in vm.branches" href="https://stash.webpublico.com.br/projects/{{vm.tempoGasto.chamado.sistema.projetoGit}}/repos/{{vm.tempoGasto.chamado.sistema.repositorioGit}}/compare/commits?sourceBranch=refs%2Fheads%2F{{branch.displayId}}&targetBranch=refs%2Fheads%2Fproducao" target="_blank"><i class="fa fa-code-fork"></i> {{branch.displayId}}</a></div><div class="row m-t-md"><div class="col-md-3 form-group"><label class="control-label">Chamado/Tarefa/Ata</label><div class="input-group"><input type="number" class="form-control" ng-model="vm.numeroBusca" ng-blur="vm.buscar()" placeholder="Digite o n\xFAmero"> <span class="input-group-btn"><button class="btn btn-success" ng-click="vm.buscar()" type="button"><i class="fa fa-search"></i></button></span></div></div><div class="col-md-3 form-group"><label class="control-label">Data</label><p class="input-group"><input type="text" class="form-control" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.tempoGasto.criadoEm" is-open="vm.opened" required close-text="Close"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.opened = true"><i class="fa fa-calendar"></i></button></span></p></div><div class="col-md-6 form-group"><label class="control-label">Atividade</label><select class="form-control text-black" ng-model="vm.tempoGasto.tipo" placeholder="Tipo da atividade" required><option value=""></option><option value="DESENVOLVIMENTO">Desenvolvimento</option><option value="TESTE">Teste</option><option value="CERIMONIA_SCRUM">Cerim\xF4nia do SCRUM</option><option value="CORRECAO">Corre\xE7\xE3o</option><option value="DOCUMENTACAO">Documenta\xE7\xE3o</option><option value="ESTUDO">Estudo</option><option value="ANALISE">An\xE1lise</option><option value="AUDITORIA">Auditoria</option><option value="GERENCIA">Ger\xEAncia</option><option value="SUPORTE">Suporte</option><option value="CODE_REVIEW">Code Review</option><option value="REUNIAO">Reuni\xE3o</option><option value="INFRAESTRUTURA">Infraestrutura</option><option value="TREINAMENTO">Treinamento</option></select></div></div><div class="row"><div class="col-md-12 form-group"><label class="control-label">Coment\xE1rio</label><input type="text" class="form-control" name="comentario" ng-model="vm.tempoGasto.comentario"><p class="help-block" ng-show="!formTempoGasto.comentario.$valid">Informe um coment\xE1rio</p></div></div><div class="row"><div class="col-md-3 form-group"><label class="control-label">Horas</label><input type="number" class="form-control" ng-min="0" ng-max="99" name="horas" required ng-model="vm.tempoGasto.horas" placeholder="00"><p class="help-block" ng-show="!formTempoGasto.horas.$valid">Horas n\xE3o v\xE1lidas, deve estar entre 0 e 99</p></div><div class="col-md-3 form-group"><label class="control-label">Minutos</label><input type="number" class="form-control" ng-model="vm.tempoGasto.minutos" name="minutos" required ng-min="0" ng-max="59" placeholder="00"><p class="help-block" ng-show="!formTempoGasto.minutos.$valid">Minutos n\xE3o v\xE1lidos, deve estar entre 0 e 59</p></div><div class="col-md-6 form-group"><button class="btn btn-block btn-outline btn-success compose-mail m-t-md" ng-disabled="!formTempoGasto.$valid || (!vm.tempoGasto.chamado && !vm.tempoGasto.ata && !vm.tempoGasto.solicitacaoDesenvolvimento)" ng-click="vm.definirTempoGasto()" type="button"><i class="fa fa-clock-o"></i> Apontar Tempo</button></div></div></div></div></div></div>');
$templateCache.put('app/entities/tempogasto/tempogasto.html','<div ng-cloak><div class="row"><div class="col-lg-12"><div class="ibox"><div class="ibox-content"><div class="row"><form><div class="form-group col-md-3"><label class="control-label" for="field_inicio">In\xEDcio</label><div class="input-group"><input id="field_inicio" type="text" class="form-control" name="inicio" required uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.filtro.inicio" is-open="vm.datePickerOpenStatus.inicio"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'inicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.inicio.$invalid"><p class="help-block" ng-show="editForm.inicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-md-3"><label class="control-label" for="field_fim">Fim</label><div class="input-group"><input id="field_fim" type="text" class="form-control" name="fim" required uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.filtro.fim" is-open="vm.datePickerOpenStatus.fim"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fim\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.fim.$invalid"><p class="help-block" ng-show="editForm.fim.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-md-4" has-authority="ROLE_PO"><label for="field_usuarios">Usu\xE1rios</label><select class="form-control" id="field_usuarios" name="usuarios" ng-model="vm.filtro.user" ng-options="user as user.firstName || user.login for user in vm.users | orderBy: \'firstName\'"><option value=""></option></select></div><div class="form-group col-md-2"><label class="control-label">&ensp;</label><button ng-click="vm.loadAll()" class="btn btn-success btn-block"><i class="fa fa-refresh"></i> Carregar</button></div></form></div><div class="row m-t-lg text-center"><h3><i class="fa fa-clock-o"></i> Apontamento de Horas</h3></div><div class="row m-t-lg text-center"><button ng-click="vm.geral = true; vm.resumido = false; vm.detalhado = false;" class="btn btn-success {{vm.geral? \'btn-danger\' : \'\'}}"><i class="fa fa-list-alt"></i> Por Projeto</button> <button ng-click="vm.geral = false; vm.resumido = true; vm.detalhado = false;" class="btn btn-success {{vm.resumido? \'btn-danger\' : \'\'}}"><i class="fa fa-list-alt"></i> Resumido</button> <button ng-click="vm.geral = false; vm.detalhado = true; vm.resumido = false;" class="btn btn-success {{vm.detalhado? \'btn-danger\' : \'\'}}"><i class="fa fa-file"></i> Detalhado</button></div></div></div></div></div><div class="row" ng-show="!vm.geral"><div class="col-lg-12"><div class="ibox"><div class="ibox-content"><div class="row m-t-lg" ng-show="vm.detalhado"><div class="col-md-12"><div class="table-responsive"><table class="jh-table table table-striped table-hover"><tr><th>Data</th><th>Tempo gasto</th><th>Conte\xFAdo</th><th>Chamado/Tarefa</th><th>User</th><th class="text-center"></th></tr><tbody><tr ng-repeat="atividade in vm.atividades track by atividade.id"><td>{{atividade.criadoEm | date:\'mediumDate\'}}</td><td>{{atividade.tempo | number: fractionSize }}</td><td>{{\'chamadosApp.TipoHora.\' + atividade.tipo | translate}}</td><td class="issue-info"><a ng-show="atividade.ata" ui-sref="detail-ata({id:atividade.ata.id})">#{{atividade.ata.numero}} - {{atividade.ata.titulo}} </a><a ng-show="atividade.chamado" ui-sref="edit-chamado({id:atividade.chamado.id, search: null, situacao: null})">#{{atividade.chamado.id}} - {{atividade.chamado.titulo}} </a><small ng-show="atividade.solicitacaoDesenvolvimento"><a ui-sref="solicitacaoDesenvolvimento.detail({id:atividade.solicitacaoDesenvolvimento.id, search: null, situacao: null})">#{{atividade.solicitacaoDesenvolvimento.numero}} - {{atividade.solicitacaoDesenvolvimento.titulo}}</a></small></td><td>{{atividade.user.firstName}}</td><td class="text-center"><button type="button" ng-if="vm.account.id == atividade.user.id" ng-click="vm.excluir(atividade.id)" class="btn btn-danger btn-sm"><span class="glyphicon glyphicon-remove-circle"></span></button> <button type="button" ng-if="vm.account.id == atividade.user.id" ng-click="vm.editarApontamento(atividade)" class="btn btn-info btn-sm"><span class="fa fa-pencil"></span></button></td></tr></tbody></table></div></div></div><div class="row m-t-lg" ng-show="vm.resumido"><div class="col-md-12"><div class="table-responsive"><table class="jh-table table table-striped table-hover"><tr><th>Usu\xE1rio</th><th class="text-center" ng-repeat="dia in vm.dateArray">{{dia | date:\'mediumDate\'}}</th></tr><tr ng-repeat="usuario in vm.usuariosListados track by usuario"><td>{{vm.getUserByLogin(usuario).firstName}}</td><td class="text-center {{vm.getTempoPorDia(dia, usuario) < 6 ? \'danger\' : \'success\'}}" ng-repeat="dia in vm.dateArray">{{vm.getTempoPorDia(dia, usuario) | number: fractionSize}}</td></tr></table></div></div></div></div></div></div></div><div class="row" ng-show="vm.geral"><div class="col-lg-12" ng-repeat="cliente in vm.clientes"><div class="ibox" ng-show="vm.carregarTemposPorCliente(cliente) > 0"><div class="ibox-title"><h3>{{cliente.nome}}<div class="pull-right">{{vm.carregarTemposPorCliente(cliente) | number: 2}}h</div></h3></div><div class="ibox-content"><div class="row"><div class="col-md-12" ng-repeat="sistema in cliente.sistemas "><div class="panel panel-default" ng-show="vm.carregarTemposPorSistemaCliente(cliente, sistema) > 0"><div class="panel-heading">{{sistema.nome}} {{vm.carregarTemposPorSistemaCliente(cliente, sistema) | number: 2}}h</div><div class="panel-body"><div><div class="table-responsive"><table class="jh-table table table-hover"><tr><th>Usu\xE1rio</th><th class="text-right">Tempo</th></tr><tr ng-repeat="usuario in vm.usuariosListados track by usuario" ng-init="tempoUsuario = vm.getTempoTotalPorUsuario(usuario, cliente, sistema)" ng-show="tempoUsuario != 0"><td>{{vm.getUserByLogin(usuario).firstName}}</td><td class="text-right">{{tempoUsuario | number: 2}}h</td></tr></table></div></div></div></div></div></div></div></div></div></div></div>');
$templateCache.put('app/entities/wiki/wiki-detail.html','<div class="wiki-layout"><wiki-page-tree pages="vm.wikis" space-id="vm.space.id" current-page-id="vm.wiki.id" on-tree-change="vm.reloadTree()"></wiki-page-tree><div class="wiki-layout-content"><div ng-if="vm.wiki && vm.wiki.id"><div class="wiki-page-actions"><a class="btn btn-default btn-sm" ui-sref="edit-wiki({spaceId: vm.space.id, id: vm.wiki.id})"><i class="fa fa-pencil"></i> Editar </a><a class="btn btn-default btn-sm" ui-sref="new-wiki({spaceId: vm.space.id, superior: vm.wiki.id})"><i class="fa fa-plus"></i> Sub-p\xE1gina</a></div><nav class="wiki-breadcrumbs"><span ng-repeat="crumb in vm.breadcrumbs track by $index"><span class="separator" ng-if="$index > 0">\u203A</span> <a ng-if="crumb.id" ui-sref="detail-wiki({spaceId: vm.space.id, id: crumb.id})">{{crumb.titulo}}</a> <span ng-if="!crumb.id">{{crumb.titulo}}</span></span></nav><div class="wiki-page-header"><h1 class="wiki-page-title">{{vm.wiki.titulo}}</h1><div class="wiki-page-meta" ng-if="vm.wiki.user">Por <b>{{vm.wiki.user.firstName}}</b> \xB7 Atualizado em {{(vm.wiki.atualizadoEm || vm.wiki.criadoEm) | date:\'dd/MM/yyyy\'}} \xB7 Espa\xE7o: {{vm.space.nome}}</div></div><div class="wiki-page-body"><nav class="wiki-toc" ng-if="vm.toc.length"><div class="wiki-toc-title">Nesta p\xE1gina</div><ul class="wiki-toc-list"><li ng-repeat="item in vm.toc track by item.id" ng-class="\'toc-h\' + item.level"><a href="" ng-click="vm.scrollToHeading(item.id)">{{item.text}}</a></li></ul></nav><div class="wiki-content" ng-bind-html="vm.renderedContent"></div></div><div class="wiki-child-pages" ng-if="vm.childPages.length"><div class="wiki-child-pages-title">P\xE1ginas filhas</div><div class="wiki-child-pages-grid"><a class="wiki-child-card" ng-repeat="child in vm.childPages track by child.id" ui-sref="detail-wiki({spaceId: vm.space.id, id: child.id})"><i class="fa fa-file-text-o"></i> {{child.titulo}}</a></div></div></div><div ng-if="!vm.wiki || !vm.wiki.id" class="text-center p-lg"><p>Nenhuma p\xE1gina neste espa\xE7o.</p><a class="btn btn-primary" ui-sref="new-wiki({spaceId: vm.space.id})">Criar primeira p\xE1gina</a></div></div></div>');
$templateCache.put('app/entities/wiki/wiki-edit.html','<div class="wiki-layout"><wiki-page-tree pages="vm.wikis" space-id="vm.spaceId" current-page-id="vm.wiki.id"></wiki-page-tree><div class="wiki-layout-content"><div class="wiki-edit-toolbar"><a href="" ng-click="vm.goBack()"><i class="fa fa-arrow-left"></i> Voltar</a><div><button type="button" class="btn btn-default" ng-click="vm.cancel()">Cancelar</button> <button type="submit" form="wikiEditForm" ng-disabled="wikiEditForm.$invalid || vm.isSaving" class="btn btn-primary"><i class="fa fa-save"></i> Salvar</button></div></div><form id="wikiEditForm" name="wikiEditForm" novalidate ng-submit="vm.save()"><div class="form-group"><input type="text" class="form-control wiki-page-title-input" name="titulo" placeholder="T\xEDtulo da p\xE1gina" ng-model="vm.wiki.titulo" required></div><text-angular name="conteudo" required ng-model="vm.wiki.conteudo"></text-angular></form></div></div>');
$templateCache.put('app/entities/wiki/wiki-navbar.html','<nav class="navbar navbar-fixed-top wiki-navbar" role="navigation" style="margin: 0 !important"><ul class="nav navbar-nav navbar-left navbar-top-links"><li><a ui-sref="home" title="Voltar ao WebDesk"><i class="fa fa-home"></i> <small class="hidden-sm hidden-xs">WebDesk</small></a></li><li class="wiki-navbar-brand"><span class="navbar-text"><i class="fa fa-book"></i> <small class="hidden-xs">Wiki</small></span></li></ul><ul class="nav navbar-nav navbar-left navbar-top-links wiki-navbar-spaces"><li uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href=""><i class="fa fa-folder-open-o"></i> <small class="hidden-xs">{{ (vm.spaces | filter:{id: vm.currentSpaceId}:true)[0].nome || \'Espa\xE7o\' }} </small><span class="caret"></span></a><ul class="dropdown-menu" uib-dropdown-menu><li ng-repeat="space in vm.spaces track by space.id" ng-class="{\'active\': space.id === vm.currentSpaceId}"><a href="" ng-click="vm.switchSpace(space.id)">{{space.nome}}</a></li></ul></li><li><a href="" ng-click="vm.openNewSpaceDialog()" title="Novo Espa\xE7o"><i class="fa fa-plus"></i> <small class="hidden-sm hidden-xs">Novo Espa\xE7o</small></a></li><li ui-sref-active="active"><a ui-sref="wiki-spaces" title="Gerenciar Espa\xE7os"><i class="fa fa-cog"></i> <small class="hidden-sm hidden-xs">Gerenciar</small></a></li></ul><ul class="nav navbar-nav navbar-right navbar-top-links" ng-if="vm.account"><li uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href=""><i class="fa fa-user"></i> <small class="hidden-xs">{{vm.account.firstName}}</small> <span class="caret"></span></a><ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu><li><a ui-sref="settings"><i class="fa fa-gears"></i> <small>Configura\xE7\xF5es</small></a></li><li><a ui-sref="password"><i class="fa fa-key"></i> <small>Senha</small></a></li><li><a ui-sref="sessions"><i class="fa fa-cloud"></i> <small>Sess\xF5es</small></a></li><li class="divider"></li><li><a href="" ng-click="vm.logout()"><i class="fa fa-sign-out"></i> <small>Sair</small></a></li></ul></li></ul></nav>');
$templateCache.put('app/entities/wiki/wiki-page-tree.html','<div class="wiki-sidebar"><div class="wiki-sidebar-header"><span class="wiki-sidebar-title">P\xE1ginas</span> <a class="wiki-sidebar-new" ui-sref="new-wiki({spaceId: vm.spaceId})" title="Nova P\xE1gina"><i class="fa fa-plus"></i> <span class="hidden-xs">Nova P\xE1gina</span></a></div><div class="wiki-sidebar-tree" ng-if="vm.pages && vm.pages.length"><ul class="wiki-tree-root"><li ng-repeat="page in vm.pages track by page.id" ng-include="\'wiki_tree_node\'"></li></ul></div><div class="wiki-sidebar-empty" ng-if="!vm.pages || !vm.pages.length"><p class="text-muted small">Nenhuma p\xE1gina</p></div></div><script type="text/ng-template" id="wiki_tree_node"><div class="wiki-tree-node" ng-class="{\'is-active\': vm.isActive(page.id)}">\n        <div class="wiki-tree-row">\n            <button type="button"\n                    class="wiki-tree-toggle"\n                    ng-if="vm.hasChildren(page)"\n                    ng-click="vm.toggleExpand(page.id, $event)">\n                <i class="fa" ng-class="vm.isExpanded(page.id) ? \'fa-chevron-down\' : \'fa-chevron-right\'"></i>\n            </button>\n            <span class="wiki-tree-toggle-placeholder" ng-if="!vm.hasChildren(page)"></span>\n            <a class="wiki-tree-link" href="" ng-click="vm.openPage(page.id)">\n                <i class="fa fa-file-text-o wiki-tree-icon"></i>\n                <span class="wiki-tree-label">{{page.titulo}}</span>\n            </a>\n            <div class="wiki-tree-actions">\n                <button type="button" class="wiki-tree-action" title="Nova sub-p\xE1gina"\n                        ng-click="vm.addSubpage(page.id, $event)">\n                    <i class="fa fa-plus"></i>\n                </button>\n                <div class="btn-group" uib-dropdown dropdown-append-to-body>\n                    <button type="button" class="wiki-tree-action" uib-dropdown-toggle title="Mais a\xE7\xF5es">\n                        <i class="fa fa-ellipsis-h"></i>\n                    </button>\n                    <ul class="dropdown-menu dropdown-menu-right" uib-dropdown-menu>\n                        <li>\n                            <a href="" ng-click="vm.editPage(page.id, $event)">\n                                <i class="fa fa-pencil"></i> Editar\n                            </a>\n                        </li>\n                        <li>\n                            <a href="" ng-click="vm.deletePage(page, $event)">\n                                <i class="fa fa-trash text-danger"></i> Excluir\n                            </a>\n                        </li>\n                    </ul>\n                </div>\n            </div>\n        </div>\n        <ul class="wiki-tree-children" ng-if="vm.hasChildren(page) && vm.isExpanded(page.id)">\n            <li ng-repeat="page in page.filhos track by page.id"\n                ng-include="\'wiki_tree_node\'"></li>\n        </ul>\n    </div></script>');
$templateCache.put('app/entities/wiki/wiki-space-dialog.html','<form name="editForm" ng-submit="vm.save()"><div class="modal-header"><h4 class="modal-title">{{vm.space.id ? \'Editar\' : \'Novo\'}} Espa\xE7o</h4></div><div class="modal-body"><div class="form-group"><label for="spaceNome">Nome</label><input type="text" class="form-control" id="spaceNome" name="nome" ng-model="vm.space.nome" required maxlength="255"></div><div class="form-group"><label for="spaceDescricao">Descri\xE7\xE3o</label><input type="text" class="form-control" id="spaceDescricao" name="descricao" ng-model="vm.space.descricao" maxlength="500"></div></div><div class="modal-footer"><button type="button" class="btn btn-default" ng-click="vm.clear()">Cancelar</button> <button type="submit" class="btn btn-primary" ng-disabled="editForm.$invalid || vm.isSaving">Salvar</button></div></form>');
$templateCache.put('app/entities/wiki/wiki-space.html','<div class="ibox"><div class="ibox-title"><h2>Espa\xE7os Wiki</h2></div><div class="ibox-content"><div class="row"><div class="col-md-12"><button class="btn btn-primary" ng-click="vm.openCreate()"><span class="glyphicon glyphicon-plus"></span> Novo Espa\xE7o</button></div></div><br><div class="table-responsive"><table class="jh-table table table-striped"><thead><tr><th>Nome</th><th>Descri\xE7\xE3o</th><th>P\xE1ginas</th><th></th></tr></thead><tbody><tr ng-repeat="space in vm.spaces track by space.id"><td>{{space.nome}}</td><td>{{space.descricao}}</td><td>{{space.pageCount || 0}}</td><td class="text-right"><button type="button" ng-click="vm.edit(space)" class="btn btn-primary btn-sm"><span class="glyphicon glyphicon-pencil"></span> Editar</button> <button type="button" ng-click="vm.remove(space)" class="btn btn-danger btn-sm" ng-disabled="space.nome === \'Geral\' || space.pageCount > 0"><span class="glyphicon glyphicon-remove-circle"></span> Excluir</button></td></tr></tbody></table></div></div></div>');
$templateCache.put('app/entities/wiki/wiki.html','<div class="row"><div class="col-md-2 no no-padding no-margins"><div class="ibox"><div class="ibox-title"><h2><h2>Wiki</h2></h2></div><div class="ibox-content animate fadeInDown"><div class="row"><div class="col-md-12"><div class="row"><div class="dd"><ol class="dd-list"><li class="dd-item" ng-repeat="wiki in vm.wikis track by wiki.id" ng-include="\'tree_view\'"></li><li class="dd-item"><a ui-sref="new-wiki"><span class="glyphicon glyphicon-plus"></span> <span>Nova P\xE1gina</span></a></li></ol></div></div></div></div></div></div></div><div class="col-md-10"><div class="ibox"><div class="ibox-title"><h2><h2>{{vm.wiki.titulo}}</h2></h2></div><div class="ibox-content"><div class="row"><div class="col-md-12"><div class="small angular-with-newlines p-md" style="overflow: auto" ng-bind-html="vm.wiki.conteudo"></div></div><div class="col-md-12"><a class="pull-right" ui-sref="new-wiki({superior:vm.wiki.id})"><span class="glyphicon glyphicon-plus"></span> <span>Nova Sub-p\xE1gina</span></a></div></div></div></div></div></div><script type="text/ng-template" id="tree_view"><div class="dd-handle {{wiki.id == vm.wiki.id ? \'active\': \'\'}}" ng-click="vm.loadWiki(wiki.id)" style="cursor: pointer">\n     {{wiki.titulo }}\n    </div>\n    <ol class="dd-list" ng-if="wiki.filhos">\n        <li class="dd-item" ng-repeat="wiki in wiki.filhos" ng-include="\'tree_view\'">\n        </li>\n    </ol></script>');
$templateCache.put('app/layouts/error/accessdenied.html','<div class="ibox"><div class="ibox-title"><h1>Ops!</h1></div><div class="ibox-content"><div ng-cloak><div class="row"><div class="col-md-12"><div class="alert alert-danger" data-translate="error.403">You are not authorized to access the page.</div></div></div></div></div></div>');
$templateCache.put('app/layouts/error/error.html','<div class="ibox"><div class="ibox-title"><h1>Ops!</h1></div><div class="ibox-content"><div ng-cloak><div class="row"><div class="col-md-12"><div ng-show="errorMessage"><div class="alert alert-danger">{{errorMessage}}</div></div></div></div></div></div></div>');
$templateCache.put('app/layouts/filasbar/filasbar.html','<div class="row text-center navfilas rala" has-any-authority="ROLE_ATENDENTE, ROLE_PO, ROLE_CLIENTE, ROLE_RESPONSAVEL"><a class="btn btn-sm {{vm.estaNaTelaDeChamadosPorSituacao(situacao.codigo || situacao.situacaoChamado) ? \'btn-success\':\'btn-default\'}}" ng-repeat="situacao in vm.situacoes | orderBy:\'ordemApresentacao\'" ng-if="(situacao.disponivelMenu === undefined || situacao.disponivelMenu) && (situacao.codigo || situacao.situacaoChamado) != \'FECHADO\' && situacao.quantidade > 0" ui-sref="chamado({situacao: (situacao.codigo || situacao.situacaoChamado), search: null, tipoChamado:null, moduloId:null, clienteId:null})" style="margin-left: 2px"><i class="small fa {{vm.getIconePorSituacao(situacao)}}"></i> <small>{{situacao.descricao || (\'chamadosApp.SituacaoChamado.\' + (situacao.codigo || situacao.situacaoChamado) | translate)}}</small> <small ng-if="situacao.quantidade > 0" class="small label label-primary pull-right">{{situacao.quantidade}}</small></a></div>');
$templateCache.put('app/layouts/footer/footer.html','<div class="footer" id="footer"><div class="pull-right"><i class="fa fa-globe"></i> <strong>&nbsp;&nbsp;Webpublico</strong> - Sistema Integrado de Gest\xE3o P\xFAblica &copy;</div><div><strong><span>HelpDesk.</span> </strong>v {{VERSION}}</div></div>');
$templateCache.put('app/layouts/footer/no-footer.html','<div class="footer-externo text-black"><img alt="image" width="22" ng-src="/assets/images/logo-wp-62.png"> <strong>&nbsp;&nbsp;Webpublico</strong> - Sistema Integrado de Gest\xE3o P\xFAblica &copy; 2011-2017</div>');
$templateCache.put('app/layouts/menu/menu.html','<nav class="navbar-default navbar-static-side" role="navigation" ng-switch="vm.isAuthenticated()"><div class="sidebar-collapse"><ul side-navigation class="nav metismenu" id="side-menu"><li ng-switch-when="false" class="m-t-lg"><a ui-sref="login"><i class="fa fa-sign-in"></i> <span class="small">Entrar</span></a></li><li ng-switch-when="false"><a ui-sref="register"><i class="fa fa-user"></i> <span class="small">Registrar-se</span></a></li><li ng-switch-when="false"><a ui-sref="password"><i class="fa fa-key"></i> <span class="small">Esqueci a senha</span></a></li><li ng-switch-when="true"><a href="#"><i class="fa fa-user"></i> <span class="small">{{vm.account.firstName}}</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level collapse"><li class="second-subtitle landing_link"><a href="#"><i class="fa fa-list"></i> {{vm.account.firstName}} <span class="fa arrow"></span></a></li><li><a ui-sref="settings" ng-click="vm.collapseNavbar()"><i class="fa fa-gears"></i>&nbsp; <small class="small">Configura\xE7\xF5es</small></a></li><li><a ui-sref="password" ng-click="vm.collapseNavbar()"><i class="fa fa-lock"></i>&nbsp; <small class="small">Senha</small></a></li><li has-any-authority="ROLE_ATENDENTE, ROLE_PO, ROLE_DESENVOLVEDOR"><a ui-sref="redmine" ng-click="vm.collapseNavbar()"><i class="fa fa-git-square"></i>&nbsp; <small class="small">Git</small></a></li><li><a ui-sref="sessions" ng-click="vm.collapseNavbar()"><i class="fa fa-cloud"></i>&nbsp; <small class="small">Sess\xF5es</small></a></li><li><a href="" ng-click="vm.logout()" id="logoutbar"><i class="fa fa-sign-out"></i>&nbsp; <small class="small">Sair</small></a></li></ul></li></ul></div></nav>');
$templateCache.put('app/layouts/navbar/navbar.html','<nav class="navbar navbar-fixed-top animated fadeInDown" role="navigation" style="margin: 0 !important" ng-switch="vm.isAuthenticated()"><ul class="nav navbar-nav navbar-left navbar-top-links"><li><a class="hidden-lg hidden-md" ng-click="vm.mostrarMenuLateral = !vm.mostrarMenuLateral"><i class="fa fa-list"></i></a></li><li><a ui-sref="home"><i class="fa fa-home"></i> <small class="small hidden-sm hidden-xs">WebDesk</small></a></li></ul><ul class="nav navbar-nav navbar-left navbar-top-links hidden-sm hidden-xs" ng-switch-when="true"><li ng-repeat="menu in vm.menu | orderBy:\'ordem\'" has-any-authority="{{menu.authority}}" uib-dropdown class="{{menu.dropdown? \'dropdown\':\'\'}} pointer" ui-sref-active="active" has-fila="{{menu.fila}}"><a title="{{menu.label}}" ng-if="!menu.dropdown" ui-sref="{{menu.sref}}" ng-click="menu.click()"><i class="{{menu.icon}}"></i> <small class="hidden-sm hidden-xs">{{menu.label}}</small> </a><a title="{{menu.label}}" ng-if="menu.dropdown" class="dropdown-toggle" uib-dropdown-toggle href=""><i class="fa {{menu.icon}}"></i> <small class="hidden-sm hidden-xs">{{menu.label}}</small></a><ul ng-if="menu.dropdown" class="dropdown-menu" uib-dropdown-menu><li ng-repeat="filho in menu.filhos" has-any-authority="{{filho.authority}}" ui-sref-active="active" has-fila="{{filho.fila}}"><a ui-sref="{{filho.sref}}" ng-click="filho.click? filho.click(): {}()"><i class="{{filho.icon}}"></i> <small class="hidden-sm hidden-xs">{{filho.label}}</small></a></li></ul></li></ul><ul class="nav navbar-nav navbar-right navbar-top-links hidden-sm hidden-xs"><li ng-switch-when="true" has-authority="ROLE_ADMIN" uib-dropdown class="dropdown pointer"><a class="dropdown-toggle" uib-dropdown-toggle href=""><i class="fa fa-cogs"></i></a><ul class="dropdown-menu" uib-dropdown-menu><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="cliente"><i class="fa fa-group"></i> <small>Clientes</small></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="modulo"><i class="fa fa-pie-chart"></i> <small>M\xF3dulos</small></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="subModulo"><i class="fa fa-pied-piper-alt"></i> <small>Sub-M\xF3dulos</small></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="sistema"><i class="fa fa-pied-piper-alt"></i> <small>Sistemas</small></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="fluxo-situacao"><i class="fa fa-random"></i> <small>Fluxo de Situa\xE7\xF5es</small></a></li><li ui-sref-active="active"><a ui-sref="user-management"><i class="fa fa-user"></i> <small>Usu\xE1rios</small></a></li><li ui-sref-active="active"><a ui-sref="equipe"><i class="fa fa-users"></i> <small>Equipes</small></a></li><li ui-sref-active="active"><a ui-sref="jhi-metrics"><i class="fa fa-dashboard"></i> <small>M\xE9tricas</small></a></li><li ui-sref-active="active"><a ui-sref="jhi-health"><i class="fa fa-heart"></i> <small>Health</small></a></li><li ui-sref-active="active"><a ui-sref="jhi-configuration"><i class="fa fa-gear"></i> <small>Configura\xE7\xF5es</small></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="gitlab-config"><i class="fa fa-gitlab"></i> <small data-translate="global.menu.admin.gitlabConfig">Configura\xE7\xE3o do GitLab</small></a></li><li ui-sref-active="active" has-authority="ROLE_ADMIN"><a ui-sref="integracao-parceiro"><i class="fa fa-exchange"></i> <small data-translate="global.menu.admin.integracaoParceiro">Integra\xE7\xE3o de chamados (terceiros)</small></a></li><li ui-sref-active="active"><a ui-sref="audits"><i class="fa fa-bell"></i> <small>Auditoria</small></a></li><li ui-sref-active="active"><a ui-sref="logs"><i class="fa fa-tasks"></i> <small>Logs</small></a></li><li ui-sref-active="active"><a ui-sref="acao"><i class="fa fa-tasks"></i> <small>A\xE7\xF5es</small></a></li><li ui-sref-active="active"><a ui-sref="jhi-tracker"><o class="fa fa-tasks"></o><small class="small">Tracker</small></a></li><li ng-show="vm.swaggerEnabled"><a ui-sref="docs"><i class="fa fa-book"></i> <small>API</small></a></li></ul></li></ul><form role="search" class="navbar-form navbar-form-custom navbar-right" ng-switch-when="true" ng-submit="vm.buscar($event)"><div class="form-group"><input placeholder="Pesquisar ..." class="form-control small" ng-model="vm.textoBusca" name="top-search" id="top-search" type="text"></div></form></nav><div id="small-chat" ng-click="vm.abrirJanela()" has-any-authority="ROLE_ATENDENTE, ROLE_PO, ROLE_DESENVOLVEDOR" style="z-index: 99999"><a class="open-small-chat"><i class="fa fa-clock-o"></i></a></div><!--<div id="small-chat-second"--><!--     ng-click="vm.abrirJanelaAcao()"--><!--     ng-show="vm.hasAcaoPendente"--><!--     has-any-authority="ROLE_ATENDENTE, ROLE_PO, ROLE_DESENVOLVEDOR"--><!--     style="z-index: 99999">--><!--    <a class="open-small-chat-second  animated infinite pulse">--><!--        <i class="fa fa-bell  "></i>--><!--        A\xE7\xF5es Pendentes--><!--    </a>--><!--</div>--><div class="menu-mobile animate fadeInLeft" ng-if="vm.mostrarMenuLateral"><nav class="navbar-default" role="navigation" ng-switch="vm.isAuthenticated()"><ul side-navigation class="nav metismenu" id="side-menu"><li ng-repeat="menu in vm.menu  | orderBy:\'ordem\'" uib-dropdown class="{{menu.dropdown ? \'dropdown\': \'\'}} pointer" has-any-authority="{{menu.authority}}" ui-sref-active="active" has-fila="{{menu.fila}}"><a ng-if="!menu.dropdown" ui-sref="{{menu.sref}}" ng-click="menu.click? menu.click(): vm.mostrarMenuLateral =false"><i class="{{menu.icon}}"></i> <small class="small">{{menu.label}}</small> </a><a href="" ng-if="menu.dropdown"><i class="fa {{menu.icon}}"></i> <span class="small">{{menu.label}}</span> <span class="fa arrow"></span></a><ul class="nav nav-second-level collapse" ng-if="menu.dropdown"><li ng-repeat="filho in menu.filhos" has-any-authority="{{filho.authority}}" ui-sref-active="active" has-fila="{{filho.fila}}"><a ui-sref="{{filho.sref}}" ng-click="filho.click? filho.click():  vm.mostrarMenuLateral =false"><i class="{{filho.icon}}"></i> <small class="small">{{filho.label}}</small></a></li></ul></li></ul></nav></div>');
$templateCache.put('app/layouts/notification/ws-notification.html','<div></div>');
$templateCache.put('app/relatorios/acompanhamento-sprint/acompanhamento-sprint.html','<div class="ibox"><div class="ibox-title"><h3>Acompanhamento do Ciclo de Desenvolvimento</h3></div><div class="ibox-content"><div class="row"><div class="col-md-12"><form name="editForm" role="form" novalidate show-validation><div class="form-group col-md-8"><label for="field_sprint">Ciclo Chamado</label><select class="form-control" ng-change="vm.carregarSprintsRedmine()" id="field_sprint" name="sprint" ng-model="vm.sprint" ng-options="sprint as sprint.descricao for sprint in vm.sprints track by sprint.id"><option value=""></option></select></div><div class="form-group col-md-2"><label class="control-label">&ensp;</label><button ng-click="vm.loadAll()" class="btn btn-success btn-block"><i class="fa fa-group"></i> Completo</button></div><div class="form-group col-md-2"><label class="control-label">&ensp;</label><button ng-click="vm.loadUsers()" class="btn btn-info btn-block"><i class="fa fa-user"></i> Individual</button></div></form></div></div></div></div><div class="row" ng-show="vm.relatorio && vm.users && vm.users.length > 0"><div class="col-lg-12"><div class="ibox float-e-margins"><div class="ibox-title"><h5>Time</h5></div><div class="ibox-content"><div class="row"><div class="col-md-12 text-center"><button class="btn m-sm btn-white {{vm.user.id == user.id ? \'btn-info active\' : \'\'}}" ng-repeat="user in vm.users track by $index" ng-click="vm.loadByUser(user)" type="button">{{user.nome}}</button></div></div></div></div></div></div><div class="row" ng-show="vm.relatorio"><div class="col-lg-12 no-margins"><div class="row"><div class="col-md-4"><div class="contact-box center-version"><a><img alt="image" class="img-circle" ng-if="vm.user" src="https://secure.gravatar.com/avatar/{{ vm.user.email | gravatar }}.jpg"> <img aalt="image" class="img-circle" ng-if="!vm.user" src="content/images/logo-wp-62.png"><h3 class="m-b-xs"><strong>{{vm.user.nome}}</strong></h3><div class="font-bold">{{vm.user.email}}</div><address class="m-t-md"><strong><i class="fa fa-clock-o"></i> {{vm.relatorio.tempoGasto | number:2}} </strong>Horas no Ciclo<br><span ng-if="!vm.user"><strong>{{vm.relatorio.desenvolvedores.length}} </strong>Membros no time</span><br><span class="text-navy" ng-if="vm.user && vm.relatorio.desenvolvedores[0].alertas.length == 0"><i class="fa fa-thumbs-o-up"></i> <strong>Parab\xE9ns</strong> nenhuma irregularidade encontrada</span><table ng-if="vm.user" style="margin-bottom: 0 !important" class="table"><tr ng-repeat="alerta in vm.relatorio.desenvolvedores[0].alertas track by $index" class="text-danger"><td>{{alerta}}</td></tr></table></address></a></div></div><div class="col-md-4 no-margins"><canvas id="chart-tipo-tarefa" class="chart chart-pie" chart-options="vm.chartOptions" chart-data="vm.dataGraficoTipo" chart-labels="vm.labelsGraficoTipo"></canvas></div><div class="col-md-4 no-margins"><canvas id="chart-projetos" class="chart chart-pie" chart-options="vm.chartOptions" chart-data="vm.dataGraficoProjetos" chart-labels="vm.labelsGraficoProjetos"></canvas></div></div></div></div><div class="ibox m-t-sm" ng-show="vm.relatorio"><div class="ibox-content"><div class="row"><div class="col-md-12"><table class="table" style="margin-bottom: 0 !important" ng-repeat="desenvolvedor in vm.relatorio.desenvolvedores track by $index"><tr ng-if="!vm.user" class="alert-info"><th>{{desenvolvedor.nome}}</th><th class="text-right">{{desenvolvedor.totalHoras | number :2}} h</th></tr><tr ng-if="!vm.user"><td colspan="2"><table ng-repeat="alerta in desenvolvedor.alertas track by $index" style="margin-bottom: 0 !important" class="table"><tr class="text-danger"><td>{{alerta}}</td></tr></table></td></tr><tr><td colspan="2"><table ng-repeat="tipoTarefa in desenvolvedor.tiposTarefa track by $index" style="margin-bottom: 0 !important" class="table table-condensed"><tr><th><b>{{tipoTarefa.nome}}</b></th><th class="text-right"><b>{{tipoTarefa.tempoGasto | number:2}} h</b></th></tr><tr><td colspan="2"><table style="margin-bottom: 0 !important" class="table table-condensed"><tr ng-repeat="tarefa in tipoTarefa.tarefas track by $index"><td><a target="_blank" ng-if="tarefa.tipo == \'CHAMADO\'" ui-sref="edit-chamado({id:tarefa.tarefa, search: null, situacao: null})">Chamado #{{tarefa.tarefa}} </a><a target="_blank" ng-if="tarefa.tipo == \'TICKET\'" href="http://redmine.webpublico.com.br/issues/{{tarefa.tarefa}}">Ticket #{{tarefa.tarefa}} </a>{{tarefa.complemento}}</td><td><span ng-if="tarefa.tempoEstimado">Estimado: {{tarefa.tempoEstimado | number:2}} h</span></td><td><span ng-if="tarefa.tempoTotalGasto">Entregue: {{tarefa.tempoTotalGasto | number:2}} h</span></td><td><span class="text-success" ng-if="tarefa.tempoTotalGasto && tarefa.tempoEstimado && tarefa.tempoTotalGasto < tarefa.tempoEstimado"><i class="fa fa-thumbs-o-up"></i> </span><span class="text-danger" ng-if="tarefa.tempoTotalGasto && tarefa.tempoEstimado && tarefa.tempoTotalGasto > tarefa.tempoEstimado"><i class="fa fa-thumbs-o-down"></i></span></td><td class="text-right">{{tarefa.tempoGasto | number:2}} h</td></tr></table></td></tr></table></td></tr></table></div></div></div></div>');
$templateCache.put('app/relatorios/chamados-atrasados/chamados-atrasados.html','<div class="ibox"><div class="ibox-title"><h3>Chamados Entregues para o Teste do Suporte</h3></div><div class="ibox-content"><div class="row"><div class="col-md-12"><form name="editForm" role="form" novalidate show-validation><div class="form-group col-md-2"><label for="id" data-translate="global.field.id">ID</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.chamado.id"></div><div class="form-group col-md-3"><label for="field_modulo">M\xF3dulo</label><select class="form-control" required id="field_modulo" name="modulo" ng-model="vm.chamado.modulo" ng-options="modulo as modulo.descricao for modulo in vm.modulos track by modulo.id"><option value=""></option></select></div><div class="form-group col-md-4"><label for="field_submodulo">Sub-M\xF3dulo</label><select class="form-control" required id="field_submodulo" name="submodulo" ng-model="vm.chamado.subModulo" ng-options="subModulo as subModulo.descricao for subModulo in vm.subModulos track by subModulo.id"><option value=""></option></select></div><div class="form-group col-md-3"><label for="field_usuarios">Clientes</label><select class="form-control" id="field_usuarios" name="clientes" ng-model="vm.chamado.cliente" ng-options="cliente as cliente.nome for cliente in vm.clientes | orderBy: \'nome\'"></select></div><div class="form-group col-md-4"><label for="field_modulo">Ciclo</label><select class="form-control" id="field_sprint" name="modulo" ng-model="vm.chamado.sprint" ng-options="sprint as sprint.descricao for sprint in vm.sprints track by sprint.id"><option value=""></option></select></div><div class="form-group col-md-4"><label class="control-label" data-translate="chamadosApp.chamado.tipoChamado" for="field_tipoChamado">Tipo Chamado</label><select class="form-control" name="tipoChamado" ng-model="vm.chamado.tipoChamado" id="field_tipoChamado"><option value="SUPORTE">Suporte ou D\xFAvida</option><option value="BUG">Bug</option><option value="MELHORIA">Melhoria</option><option value="NOVA_FUNCIONALIDADE">Nova Funcionalidade</option></select></div><div class="form-group col-md-4"><label for="field_situacaoChamado">Situa\xE7\xE3o</label><select class="form-control" name="situacaoChamado" ng-model="vm.chamado.situacao" id="field_situacaoChamado"><option value="ABERTO">Aberto</option><option value="IMPEDIDO">Impedido</option><option value="EM_SUPORTE">Fila Suporte</option><option value="AGUARDANDO_DESENVOLVIMENTO">Fila Desenvolvimento</option><option value="EM_DESENVOLVIMENTO">Em Desenvolvimento</option><option value="AGUARDANDO_TESTE">Aguardando Valida\xE7\xE3o</option><option value="EM_ANALISE">Em An\xE1lise</option><option value="VALIDADO">Validade</option><option value="TESTE_SUPORTE">Em Teste</option><option value="REJEITADO">Rejeitado</option><option value="FECHADO">Fechado</option></select></div><div class="form-group col-md-4"><label for="field_modulo">Situa\xE7\xE3o da Entrega</label><select class="form-control" id="field_entrega" name="entrega" ng-model="vm.situacaoEntrega" ng-options="situacao as situacao for situacao in vm.labels track by situacao"><option value=""></option></select></div><div class="form-group col-md-8"><label class="control-label" for="titulo">Titulo/Descri\xE7\xE3o</label><input type="text" class="form-control" id="titulo" name="titulo" ng-model="vm.chamado.titulo"></div><div class="form-group col-md-3"><label class="control-label">Inicio do ciclo</label><p class="input-group"><input type="text" class="form-control" name="inicio" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.chamado.sprint.inicio" is-open="vm.opened" required close-text="Close"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.opened = true"><i class="fa fa-calendar"></i></button></span></p></div><div class="form-group col-md-3"><label class="control-label">Fim do ciclo</label><p class="input-group"><input type="text" class="form-control" name="fim" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.chamado.sprint.fim" is-open="vm.opened2" required close-text="Close"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.opened2 = true"><i class="fa fa-calendar"></i></button></span></p></div><div class="form-group col-md-2"><label class="control-label">&ensp;</label><button ng-click="vm.loadAll()" class="btn btn-success btn-block"><i class="fa fa-search"></i> Buscar</button></div></form></div></div><div class="row m-t-md" ng-show="vm.chamados"><div class="col-md-6"><div class="col-md-12"><h3><i class="fa fa-list"></i> Chamados por Situa\xE7\xE3o</h3><hr></div><div class="col-md-6"><canvas id="pie" class="chart chart-pie" chart-colors="vm.colors" chart-data="vm.data" chart-labels="vm.labels"></canvas></div><div class="col-md-6"><ul class="stat-list"><li ng-repeat="situacao in vm.labels"><h2 class="no-margins">{{vm.data[$index]}}</h2><small>{{situacao }}</small><div class="stat-percent">{{vm.percentual[$index]| number:2}}%</div><div class="progress progress-mini"><div style="width: {{vm.percentual[$index]}}%; background-color: {{vm.colors[$index]}}" class="progress-bar" st></div></div></li></ul></div></div><div class="col-md-6"><div class="col-md-12"><h3><i class="fa fa-calendar"></i> M\xE9dia de dias de Atraso</h3><hr></div><div class="col-md-6"><div class="widget red-bg p-lg text-center"><div class="m-b-md"><i class="fa fa-bell fa-4x"></i><h1 class="m-xs">{{vm.diasAtraso | number:2}}</h1><h3 class="font-bold no-margins">Dias de Atraso</h3><small>M\xE9dia Geral</small></div></div></div><div class="col-md-6"><ul class="stat-list"><li ng-repeat="modulo in vm.modulosAtrasados | orderBy : \'diasAtraso\'"><h2 class="no-margins">{{modulo.diasAtraso | number:1}} <small>dias</small></h2><small class="label label-default">{{modulo.modulo}}</small></li></ul></div></div></div><div class="row m-t-lg" ng-show="vm.chamados"><div class="col-md-12"><div class="table-responsive"><table class="jh-table table table-striped table-hover"><tr><th>Chamado</th><th class="issue-info">Titulo <small>M\xF3dulo/Ciclo</small></th><th>Prazo</th><th>Entregue Em</th><th>Situa\xE7\xE3o</th></tr><tbody><tr ng-repeat="chamado in vm.chamados track by chamado.id"><td class="issue-info"><strong><a ui-sref="edit-chamado({id:chamado.id, search: null, situacao: null})">#{{chamado.id}} </a></strong><small><span data-translate="{{\'chamadosApp.SituacaoChamado.\' + chamado.situacao}}">{{chamado.situacao}}</span></small></td><td class="issue-info">{{chamado.titulo}} <small class="text text-success">{{chamado.modulo}}/{{chamado.sprint}}</small></td><td class="issue-info">De {{chamado.inicio | date:\'mediumDate\'}} <small class="label label-success">At\xE9 {{chamado.fim | date:\'mediumDate\'}}</small></td><td class="issue-info">{{chamado.entrega | date:\'mediumDate\'}} <span ng-if="!chamado.entrega" class="badge badge-danger"><i class="fa fa-info"></i> </span><small ng-if="chamado.diasAtraso"><span class="text-danger">{{chamado.diasAtraso}} {{chamado.diasAtraso > 1 ? \'dias\' : \'dia\'}} de atraso</span></small></td><td><span class="label label-{{chamado.cor}}">{{chamado.situacaoEntrega}}</span></td></tr></tbody></table></div><button ng-click="vm.imprimir()" class="btn btn-success btn-block"><i class="fa fa-print"></i> Imprimir</button></div></div></div></div>');
$templateCache.put('app/relatorios/chamados-por-fila/chamados-por-fila.html','<div class="ibox"><div class="ibox-title"><h3>Chamados por Fila</h3></div><div class="ibox-content"><div class="row"><div class="col-md-12"><form name="editForm" role="form" novalidate show-validation><div class="col-md-9 no-margins"><div class="form-group col-md-2"><label for="id">Chamado</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.chamado.id"></div><div class="form-group col-md-3"><label for="field_modulo">M\xF3dulo</label><select class="form-control" required id="field_modulo" name="modulo" ng-model="vm.chamado.modulo" ng-options="modulo as modulo.descricao for modulo in vm.modulos track by modulo.id"><option value=""></option></select></div><div class="form-group col-md-3"><label for="field_submodulo">Sub-M\xF3dulo</label><select class="form-control" required id="field_submodulo" name="submodulo" ng-model="vm.chamado.subModulo" ng-options="subModulo as subModulo.descricao for subModulo in vm.subModulos track by subModulo.id"><option value=""></option></select></div><div class="form-group col-md-4"><label for="field_usuarios">Clientes</label><select class="form-control" id="field_usuarios" name="usuarios" has-authority="ROLE_ADMIN" ng-model="vm.chamado.cliente" ng-options="cliente as cliente.nome for cliente in vm.clientes | orderBy: \'nome\'"></select></div><div class="form-group col-md-4"><label for="field_modulo">Ciclo</label><select class="form-control" id="field_sprint" name="modulo" ng-model="vm.chamado.sprint" ng-options="sprint as sprint.descricao for sprint in vm.sprints track by sprint.id"><option value=""></option></select></div><div class="form-group col-md-4"><label class="control-label" data-translate="chamadosApp.chamado.tipoChamado" for="field_tipoChamado">Tipo Chamado</label><select class="form-control" name="tipoChamado" ng-model="vm.chamado.tipoChamado" id="field_tipoChamado"><option value="SUPORTE">Suporte ou D\xFAvida</option><option value="BUG">Bug</option><option value="MELHORIA">Melhoria</option><option value="NOVA_FUNCIONALIDADE">Nova Funcionalidade</option></select></div><div class="form-group col-md-4"><label for="field_modulo">Release</label><select class="form-control" id="field_release" name="release" ng-model="vm.chamado.release" ng-options="release as release.versao for release in vm.releases track by release.id"><option value=""></option></select></div><div class="form-group col-md-3"><label class="control-label">Aberto desde</label><p class="input-group"><input type="text" class="form-control" name="inicio" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.chamado.criadoEmInicio" is-open="vm.opened" required close-text="Close"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.opened = true"><i class="fa fa-calendar"></i></button></span></p></div><div class="form-group col-md-3"><label class="control-label">Aberto at\xE9</label><p class="input-group"><input type="text" class="form-control" name="fim" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.chamado.criadoEmFim" is-open="vm.opened2" required close-text="Close"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.opened2 = true"><i class="fa fa-calendar"></i></button></span></p></div><div class="form-group col-md-6"><label class="control-label" for="titulo">Titulo/Descri\xE7\xE3o</label><input type="text" class="form-control" id="titulo" name="titulo" ng-model="vm.chamado.titulo"></div></div><div class="col-md-3 no-margins"><div class="form-group"><label class="control-label">Filas</label><div style="max-height: 200px; overflow: auto"><table class="table"><tr class="{{vm.chamado.situacoes.indexOf(situacao) > -1 ? \'success\':\'\'}}" ng-repeat="situacao in vm.situacoes track by $index"><td><i class="fa fa-circle-o" ng-click="vm.chamado.situacoes.push(situacao)" ng-show="vm.chamado.situacoes.indexOf(situacao) < 0"></i> <i class="fa fa-check-circle-o" ng-click="vm.chamado.situacoes.splice(vm.chamado.situacoes.indexOf(situacao),1)" ng-show="vm.chamado.situacoes.indexOf(situacao) > -1"></i></td><td><span data-translate="{{\'chamadosApp.SituacaoChamado.\' + situacao}}">{{situacao}}</span></td></tr></table></div></div></div><div class="form-group col-md-3"><label class="control-label">&ensp;</label><button ng-click="vm.loadAll()" class="btn btn-success btn-block"><i class="fa fa-search"></i> Buscar</button></div></form></div></div><div class="row m-t-lg" ng-show="vm.chamados"><div class="col-md-12 bm" ng-repeat="fila in vm.filasProntas" ng-show="vm.chamadosAgrupados[fila].chamados && vm.chamadosAgrupados[fila].chamados.length > 0"><div class="col-md-12 text-center m-b-md"><h3><i class="fa {{vm.getIconePorSituacao(fila)}}"></i> <span data-translate="{{\'chamadosApp.SituacaoChamado.\' + fila}}"></span></h3><!--<small>Sprint iniciada em {{sprintPronta.inicio | date:\'mediumDate\'}} e--><!--finalizada em {{sprintPronta.fim | date:\'mediumDate\'}}--><!--</small>--></div><table class="jh-table table table-striped table-hover"><tr><th class="issue-info">Severidade <small>Tipo</small></th><th class="issue-info">N\xBA do chamado <small>Titulo</small></th><th class="issue-info">M\xF3dulo <small>Aberto em</small></th><th class="issue-info">Ciclo <small>Per\xEDodo </small><small>Tempo Estimado</small></th><th>Dev In\xEDcio</th><th>Dev Fim</th><th>Lib. Teste</th><th>Validado</th><th>\xDAltima Mov.</th></tr><tbody><tr ng-repeat="chamado in vm.chamadosAgrupados[fila].chamados | orderBy:\'-ultimaInteracao\' track by chamado.id "><td class="issue-info"><span data-translate="{{\'chamadosApp.Severidade.\' + chamado.severidade}}">{{chamado.severidade}}</span> <small><span class="font-bold text-{{vm.getCorPorTipo(chamado.tipoChamado)}}" data-translate="{{\'chamadosApp.TipoChamado.\' + chamado.tipoChamado}}">{{chamado.tipoChamado}}</span></small></td><td class="issue-info col-md-4"><a ui-sref="edit-chamado({id:chamado.id, search: null, situacao: null})">#{{chamado.id}} &ensp; </a><span ng-show="chamado.quantidadeRejeicao && chamado.quantidadeRejeicao >0" class="small text-danger">{{ chamado.quantidadeRejeicao + " " + (chamado.quantidadeRejeicao > 1 ? "rejei\xE7\xF5es": \'rejei\xE7\xE3o\') }} </span><small>{{chamado.titulo}}</small></td><td class="issue-info">{{chamado.modulo}} <small>{{chamado.criadoEm | date:\'shortDate\'}}</small></td><td class="issue-info"><span ng-if="chamado.sprint" class="label label-info">{{chamado.sprint}} </span><small ng-if="chamado.sprint">{{chamado.inicioSprint | date:\'shortDate\'}} \xE0 {{chamado.fimSprint | date:\'shortDate\'}} </small><small class="label label-primary"><i class="fa fa-clock-o"></i> {{chamado.tempoEstimado}}h</small></td><td class="issue-info">{{chamado.inicioDesenvolvimento | date:\'shortDate\'}}</td><td class="issue-info"><small ng-show="chamado.inicioDesenvolvimento && !chamado.fimDesenvolvimento">parado a<time-ago from-time="{{ chamado.inicioDesenvolvimento}}" format="dd/MM/yyyy h:mm a"></time-ago></small><span ng-show="chamado.inicioDesenvolvimento && chamado.fimDesenvolvimento">{{chamado.fimDesenvolvimento | date:\'shortDate\'}}</span></td><td class="issue-info">{{chamado.inicioTeste | date:\'shortDate\'}}</td><td class="issue-info"><small ng-show="chamado.inicioTeste && !chamado.fimTeste">parado a<time-ago from-time="{{ chamado.inicioTeste}}" format="dd/MM/yyyy h:mm a"></time-ago></small><span ng-show="chamado.inicioTeste && chamado.fimTeste">{{chamado.fimTeste | date:\'shortDate\'}}</span></td><td><small ng-show="chamado.ultimaInteracao"><time-ago from-time="{{ chamado.ultimaInteracao}}" format="dd/MM/yyyy h:mm a"></time-ago></small></td></tr><tr><td colspan="8" class="text-right">Total de Chamados na fila <strong data-translate="{{\'chamadosApp.SituacaoChamado.\' + fila}}"></strong>:</td><td>{{vm.chamadosAgrupados[fila].chamados.length}}</td></tr></tbody></table></div><button ng-click="vm.imprimir()" class="btn btn-success btn-block"><i class="fa fa-print"></i> Imprimir</button></div></div></div>');
$templateCache.put('app/relatorios/chamados-por-release/chamados-por-release.html','<div class="ibox"><div class="ibox-title"><h3>Relat\xF3rio de chamados por releases</h3></div><div class="ibox-content"><div class="row"><div class="col-md-12"><form name="editForm" role="form" novalidate show-validation><div class="form-group col-md-2"><label for="id">Chamado</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.chamado.id"></div><div class="form-group col-md-3"><label for="field_modulo">M\xF3dulo</label><select class="form-control" required id="field_modulo" name="modulo" ng-model="vm.chamado.modulo" ng-options="modulo as modulo.descricao for modulo in vm.modulos track by modulo.id"><option value=""></option></select></div><div class="form-group col-md-4"><label for="field_submodulo">Sub-M\xF3dulo</label><select class="form-control" required id="field_submodulo" name="submodulo" ng-model="vm.chamado.subModulo" ng-options="subModulo as subModulo.descricao for subModulo in vm.subModulos track by subModulo.id"><option value=""></option></select></div><div class="form-group col-md-3"><label for="field_usuarios">Clientes</label><select class="form-control" id="field_usuarios" name="clientes" ng-model="vm.chamado.cliente" ng-options="cliente as cliente.nome for cliente in vm.clientes | orderBy: \'nome\'"><option value=""></option></select></div><div class="form-group col-md-4"><label for="field_modulo">Ciclo</label><select class="form-control" id="field_sprint" name="modulo" ng-model="vm.chamado.sprint" ng-options="sprint as sprint.descricao for sprint in vm.sprints track by sprint.id"><option value=""></option></select></div><div class="form-group col-md-4"><label class="control-label" data-translate="chamadosApp.chamado.tipoChamado" for="field_tipoChamado">Tipo Chamado</label><select class="form-control" name="tipoChamado" ng-model="vm.chamado.tipoChamado" id="field_tipoChamado"><option value="SUPORTE">Suporte ou D\xFAvida</option><option value="BUG">Bug</option><option value="MELHORIA">Melhoria</option><option value="NOVA_FUNCIONALIDADE">Nova Funcionalidade</option></select></div><div class="form-group col-md-4"><label for="field_modulo">Release</label><select class="form-control" id="field_release" name="release" ng-model="vm.chamado.release" ng-options="release as release.versao for release in vm.releases track by release.id"><option value=""></option></select></div><div class="form-group col-md-4"><label class="control-label">Data Envio</label><p class="input-group"><input type="text" class="form-control" name="liberacao-producao" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.chamado.release.liberacao" is-open="vm.opened" required close-text="Close"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.opened = true"><i class="fa fa-calendar"></i></button></span></p></div><div class="form-group col-md-6"><label class="control-label" for="titulo">Titulo/Descri\xE7\xE3o</label><input type="text" class="form-control" id="titulo" name="titulo" ng-model="vm.chamado.titulo"></div><div class="form-group col-md-2"><label class="control-label">&ensp;</label><button ng-click="vm.loadAll()" class="btn btn-success btn-block"><i class="fa fa-search"></i> Buscar</button></div></form></div></div><div class="row m-t-lg" ng-show="vm.chamados"><div class="col-md-12 bm" ng-repeat="releasePronta in vm.realsesProntas"><div class="col-md-12 text-center m-b-md"><h3><i class="fa fa-code-fork"></i> <span>V.{{releasePronta.versao}}</span></h3><small ng-if="releasePronta.liberacao"><span class="label label-success">Liberado</span><br>em produ\xE7\xE3o em data de {{releasePronta.liberacao | date:\'mediumDate\'}} por {{releasePronta.responsavel.firstName}} </small><small ng-if="!releasePronta.liberacao"><span class="label label-warning">Aguardando Libera\xE7\xE3o em produ\xE7\xE3o</span></small></div><table class="jh-table table table-striped table-hover"><tr><th class="issue-info">Severidade <small>Tipo</small></th><th class="issue-info">N\xBA do chamado <small>Titulo</small></th><th class="issue-info">Solicitante <small>Respons\xE1vel</small></th><th class="issue-info">Data <small>Estimado</small></th><th class="issue-info">M\xF3dulo <small>Sub-M\xF3dulo</small></th></tr><tbody><tr ng-repeat="chamado in vm.chamadosAgrupados[releasePronta.versao].chamados track by chamado.id"><td class="issue-info"><span data-translate="{{\'chamadosApp.Severidade.\' + chamado.severidade}}">{{chamado.severidade}}</span> <small><span class="font-bold text-{{vm.getCorPorTipo(chamado.tipoChamado)}}" data-translate="{{\'chamadosApp.TipoChamado.\' + chamado.tipoChamado}}">{{chamado.tipoChamado}}</span></small></td><td class="issue-info" style="width: 30%"><a ui-sref="edit-chamado({id:chamado.id, search: null, situacao: null})">#{{chamado.id}} </a>{{chamado.titulo}}</td><td class="issue-info" style="width: 10%">{{chamado.solicitante.firstName}} <small>{{chamado.responsavel.firstName}}</small></td><td class="issue-info">{{chamado.criadoEm | date:\'mediumDate\'}} <small><i ng-if="chamado.tempoEstimado" class="fa fa-clock-o"></i> {{chamado.tempoEstimado}}</small></td><td class="issue-info">{{chamado.modulo.descricao}} <small>{{chamado.subModulo.descricao}}</small></td></tr></tbody></table></div><button ng-click="vm.imprimir()" class="btn btn-success btn-block"><i class="fa fa-print"></i> Imprimir</button></div></div></div>');
$templateCache.put('app/relatorios/chamados-por-solicitante/chamados-por-solicitante.html','<div class="ibox"><div class="ibox-title"><h3>Relat\xF3rio de chamados por solicitantes</h3></div><div class="ibox-content"><div class="row"><div class="col-md-12"><form name="editForm" role="form" novalidate show-validation><div class="form-group col-md-2"><label for="id">Chamado</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.chamado.id"></div><div class="form-group col-md-3"><label for="field_modulo">M\xF3dulo</label><select class="form-control" required id="field_modulo" name="modulo" ng-model="vm.chamado.modulo" ng-options="modulo as modulo.descricao for modulo in vm.modulos track by modulo.id"><option value=""></option></select></div><div class="form-group col-md-4"><label for="field_submodulo">Sub-M\xF3dulo</label><select class="form-control" required id="field_submodulo" name="submodulo" ng-model="vm.chamado.subModulo" ng-options="subModulo as subModulo.descricao for subModulo in vm.subModulos track by subModulo.id"><option value=""></option></select></div><div class="form-group col-md-3"><label for="field_usuarios">Clientes</label><select class="form-control" id="field_usuarios" name="clientes" ng-model="vm.chamado.cliente" ng-options="cliente as cliente.nome for cliente in vm.clientes | orderBy: \'nome\'"><option value=""></option></select></div><div class="form-group col-md-3"><label for="field_modulo">Ciclo</label><select class="form-control" id="field_sprint" name="modulo" ng-model="vm.chamado.sprint" ng-options="sprint as sprint.descricao for sprint in vm.sprints track by sprint.id"><option value=""></option></select></div><div class="form-group col-md-3"><label class="control-label" data-translate="chamadosApp.chamado.tipoChamado" for="field_tipoChamado">Tipo Chamado</label><select class="form-control" name="tipoChamado" ng-model="vm.chamado.tipoChamado" id="field_tipoChamado"><option value=""></option><option value="SUPORTE">Suporte ou D\xFAvida</option><option value="BUG">Bug</option><option value="MELHORIA">Melhoria</option><option value="NOVA_FUNCIONALIDADE">Nova Funcionalidade</option></select></div><div class="form-group col-md-3"><label for="field_modulo">Release</label><select class="form-control" id="field_release" name="release" ng-model="vm.chamado.release" ng-options="release as release.versao for release in vm.releases track by release.id"><option value=""></option></select></div><div class="form-group col-md-3"><label for="field_solicitante">Solicitante</label><select class="form-control" required id="field_solicitante" name="solicitante" ng-model="vm.chamado.entidadeSolicitante" ng-options="solicitante as solicitante.nome for solicitante in vm.solicitantes track by solicitante.id"><option value=""></option></select></div><div class="form-group col-md-3"><label class="control-label">Data Inicial</label><p class="input-group"><input type="text" class="form-control" name="dataInicial" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.chamado.criadoEmInicio" is-open="vm.opened" required close-text="Close"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.opened = true"><i class="fa fa-calendar"></i></button></span></p></div><div class="form-group col-md-3"><label class="control-label">Data Final</label><p class="input-group"><input type="text" class="form-control" name="dataFinal" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.chamado.criadoEmFim" is-open="vm.opened2" required close-text="Close"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.opened2 = true"><i class="fa fa-calendar"></i></button></span></p></div><div class="form-group col-md-4"><label class="control-label" for="titulo">Titulo/Descri\xE7\xE3o</label><input type="text" class="form-control" id="titulo" name="titulo" ng-model="vm.chamado.titulo"></div><div class="form-group col-md-2"><label class="control-label">&ensp;</label><button ng-click="vm.loadAll()" class="btn btn-success btn-block"><i class="fa fa-search"></i> Buscar</button></div></form></div></div><div class="row m-t-lg" ng-show="vm.chamados"><div class="col-md-12 bm" ng-repeat="releasePronta in vm.realsesProntas"><div class="col-md-12 text-center m-b-md"><h3><i class="fa fa-code-fork"></i> <span>V.{{releasePronta.versao}}</span></h3><small ng-if="releasePronta.liberacao"><span class="label label-success">Liberado</span><br>em produ\xE7\xE3o em data de {{releasePronta.liberacao | date:\'mediumDate\'}} por {{releasePronta.responsavel.firstName}} </small><small ng-if="!releasePronta.liberacao"><span class="label label-warning">Aguardando Libera\xE7\xE3o em produ\xE7\xE3o</span></small></div><table class="jh-table table table-striped table-hover"><tr><th class="issue-info">Severidade <small>Tipo</small></th><th class="issue-info">N\xBA do chamado <small>Titulo</small></th><th class="issue-info">Solicitante <small>Respons\xE1vel</small></th><th class="issue-info">Data <small>Estimado</small></th><th class="issue-info">M\xF3dulo <small>Sub-M\xF3dulo</small></th></tr><tbody><tr ng-repeat="chamado in vm.chamadosAgrupados[releasePronta.versao].chamados track by chamado.id"><td class="issue-info"><span data-translate="{{\'chamadosApp.Severidade.\' + chamado.severidade}}">{{chamado.severidade}}</span> <small><span class="font-bold text-{{vm.getCorPorTipo(chamado.tipoChamado)}}" data-translate="{{\'chamadosApp.TipoChamado.\' + chamado.tipoChamado}}">{{chamado.tipoChamado}}</span></small></td><td class="issue-info" style="width: 30%"><a ui-sref="edit-chamado({id:chamado.id, search: null, situacao: null})">#{{chamado.id}} </a>{{chamado.titulo}}</td><td class="issue-info" style="width: 10%">{{chamado.solicitante.firstName}} <small>{{chamado.responsavel.firstName}}</small></td><td class="issue-info">{{chamado.criadoEm | date:\'mediumDate\'}} <small><i ng-if="chamado.tempoEstimado" class="fa fa-clock-o"></i> {{chamado.tempoEstimado}}</small></td><td class="issue-info">{{chamado.modulo.descricao}} <small>{{chamado.subModulo.descricao}}</small></td></tr></tbody></table></div><button ng-click="vm.imprimir()" class="btn btn-success btn-block"><i class="fa fa-print"></i> Imprimir</button></div></div></div>');
$templateCache.put('app/relatorios/chamados-por-sprint/chamados-por-sprint.html','<div class="ibox"><div class="ibox-title"><h3>Demandas sem movimenta\xE7\xE3o com a quantidade de dias</h3></div><div class="ibox-content"><div class="row"><div class="col-md-12"><form name="editForm" role="form" novalidate show-validation><div class="form-group col-md-2"><label for="id">Chamado</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.chamado.id"></div><div class="form-group col-md-3"><label for="field_modulo">M\xF3dulo</label><select class="form-control" required id="field_modulo" name="modulo" ng-model="vm.chamado.modulo" ng-options="modulo as modulo.descricao for modulo in vm.modulos track by modulo.id"><option value=""></option></select></div><div class="form-group col-md-4"><label for="field_submodulo">Sub-M\xF3dulo</label><select class="form-control" required id="field_submodulo" name="submodulo" ng-model="vm.chamado.subModulo" ng-options="subModulo as subModulo.descricao for subModulo in vm.subModulos track by subModulo.id"><option value=""></option></select></div><div class="form-group col-md-3"><label for="field_usuarios">Clientes</label><select class="form-control" id="field_usuarios" name="clientes" ng-model="vm.chamado.cliente" ng-options="cliente as cliente.nome for cliente in vm.clientes | orderBy: \'nome\'"></select></div><div class="form-group col-md-4"><label for="field_modulo">Ciclo</label><select class="form-control" id="field_sprint" name="modulo" ng-model="vm.chamado.sprint" ng-options="sprint as sprint.descricao for sprint in vm.sprints track by sprint.id"><option value=""></option></select></div><div class="form-group col-md-4"><label class="control-label" data-translate="chamadosApp.chamado.tipoChamado" for="field_tipoChamado">Tipo Chamado</label><select class="form-control" name="tipoChamado" ng-model="vm.chamado.tipoChamado" id="field_tipoChamado"><option value="SUPORTE">Suporte ou D\xFAvida</option><option value="BUG">Bug</option><option value="MELHORIA">Melhoria</option><option value="NOVA_FUNCIONALIDADE">Nova Funcionalidade</option></select></div><div class="form-group col-md-4"><label for="field_modulo">Release</label><select class="form-control" id="field_release" name="release" ng-model="vm.chamado.release" ng-options="release as release.versao for release in vm.releases track by release.id"><option value=""></option></select></div><div class="form-group col-md-2"><label class="control-label">In\xEDcio</label><p class="input-group"><input type="text" class="form-control" name="inicio" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.chamado.sprint.inicio" is-open="vm.opened" required close-text="Close"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.opened = true"><i class="fa fa-calendar"></i></button></span></p></div><div class="form-group col-md-2"><label class="control-label">Fim</label><p class="input-group"><input type="text" class="form-control" name="fim" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.chamado.sprint.fim" is-open="vm.opened2" required close-text="Close"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.opened2 = true"><i class="fa fa-calendar"></i></button></span></p></div><div class="form-group col-md-6"><label class="control-label" for="titulo">Titulo/Descri\xE7\xE3o</label><input type="text" class="form-control" id="titulo" name="titulo" ng-model="vm.chamado.titulo"></div><div class="form-group col-md-2"><label class="control-label">&ensp;</label><button ng-click="vm.loadAll()" class="btn btn-success btn-block"><i class="fa fa-search"></i> Buscar</button></div></form></div></div><div class="row m-t-lg" ng-show="vm.chamados"><div class="col-md-12 bm" ng-repeat="sprintPronta in vm.sprintsProntas"><div class="col-md-12 text-center m-b-md"><h3><i class="fa fa-code-fork"></i> <span>{{sprintPronta.descricao}}</span></h3><small>Sprint iniciada em {{sprintPronta.inicio | date:\'mediumDate\'}} e finalizada em {{sprintPronta.fim | date:\'mediumDate\'}}</small></div><table class="jh-table table table-striped table-hover"><tr><th class="issue-info">Severidade <small>Tipo</small></th><th class="issue-info">N\xBA do chamado <small>Titulo</small></th><th class="issue-info">Solicitante <small>Respons\xE1vel</small></th><th class="issue-info">Data <small>Estimado</small></th><th class="issue-info">M\xF3dulo <small>Sub-M\xF3dulo</small></th><th>Situa\xE7\xE3o</th></tr><tbody><tr ng-repeat="chamado in vm.chamadosAgrupados[sprintPronta.descricao].chamados track by chamado.id"><td class="issue-info"><span data-translate="{{\'chamadosApp.Severidade.\' + chamado.severidade}}">{{chamado.severidade}}</span> <small><span class="font-bold text-{{vm.getCorPorTipo(chamado.tipoChamado)}}" data-translate="{{\'chamadosApp.TipoChamado.\' + chamado.tipoChamado}}">{{chamado.tipoChamado}}</span></small></td><td class="issue-info" style="width: 30%"><a ui-sref="edit-chamado({id:chamado.id, search: null, situacao: null})">#{{chamado.id}} </a>{{chamado.titulo}}</td><td class="issue-info" style="width: 10%">{{chamado.solicitante.firstName}} <small>{{chamado.responsavel.firstName}}</small></td><td class="issue-info">{{chamado.criadoEm | date:\'mediumDate\'}} <small><i ng-if="chamado.tempoEstimado" class="fa fa-clock-o"></i> {{chamado.tempoEstimado}}</small></td><td class="issue-info">{{chamado.modulo.descricao}} <small>{{chamado.subModulo.descricao}}</small></td><td><span data-translate="{{\'chamadosApp.SituacaoChamado.\' + chamado.situacao}}">{{chamado.situacao}}</span></td></tr></tbody></table></div><button ng-click="vm.imprimir()" class="btn btn-success btn-block"><i class="fa fa-print"></i> Imprimir</button></div></div></div>');
$templateCache.put('app/relatorios/chamados-por-volumetria/chamados-por-volumetria.html','<div class="ibox"><div class="ibox-title"><h3>Volumetria</h3></div><div class="ibox-content"><div class="row"><div class="col-md-12"><form name="editForm" role="form" novalidate show-validation><div class="col-md-9 no-margins"><div class="form-group col-md-2"><label for="id">Chamado</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.chamado.id"></div><div class="form-group col-md-5"><label for="field_modulo">M\xF3dulo</label><select class="form-control" required id="field_modulo" name="modulo" ng-model="vm.chamado.modulo" ng-options="modulo as modulo.descricao for modulo in vm.modulos track by modulo.id"><option value=""></option></select></div><div class="form-group col-md-5"><label for="field_submodulo">Sub-M\xF3dulo</label><select class="form-control" required id="field_submodulo" name="submodulo" ng-model="vm.chamado.subModulo" ng-options="subModulo as subModulo.descricao for subModulo in vm.subModulos track by subModulo.id"><option value=""></option></select></div><div class="form-group col-md-4"><label for="field_usuarios">Clientes</label><select class="form-control" id="field_usuarios" name="clientes" ng-model="vm.chamado.cliente" ng-options="cliente as cliente.nome for cliente in vm.clientes | orderBy: \'nome\'"></select></div><div class="form-group col-md-4"><label class="control-label" data-translate="chamadosApp.chamado.tipoChamado" for="field_tipoChamado">Tipo Chamado</label><select class="form-control" name="tipoChamado" ng-model="vm.chamado.tipoChamado" id="field_tipoChamado"><option value="SUPORTE">Suporte ou D\xFAvida</option><option value="BUG">Bug</option><option value="MELHORIA">Melhoria</option><option value="NOVA_FUNCIONALIDADE">Nova Funcionalidade</option></select></div><div class="form-group col-md-4"><label for="field_modulo">Release</label><select class="form-control" id="field_release" name="release" ng-model="vm.chamado.release" ng-options="release as release.versao for release in vm.releases track by release.id"><option value=""></option></select></div><div class="form-group col-md-3"><label class="control-label">Aberto desde</label><p class="input-group"><input type="text" class="form-control" name="inicio" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.chamado.criadoEmInicio" is-open="vm.opened" required close-text="Close"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.opened = true"><i class="fa fa-calendar"></i></button></span></p></div><div class="form-group col-md-3"><label class="control-label">Aberto at\xE9</label><p class="input-group"><input type="text" class="form-control" name="fim" uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.chamado.criadoEmFim" is-open="vm.opened2" required close-text="Close"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.opened2 = true"><i class="fa fa-calendar"></i></button></span></p></div><div class="form-group col-md-6"><label class="control-label" for="titulo">Titulo/Descri\xE7\xE3o</label><input type="text" class="form-control" id="titulo" name="titulo" ng-model="vm.chamado.titulo"></div></div><div class="col-md-3 no-margins"><div class="form-group"><label class="control-label">Ciclos</label><div style="max-height: 200px; overflow: auto"><table class="table"><tr class="{{vm.chamado.sprints.indexOf(sprint) > -1 ? \'success\':\'\'}}" ng-repeat="sprint in vm.sprints track by $index"><td><i class="fa fa-circle-o" ng-click="vm.chamado.sprints.push(sprint)" ng-show="vm.chamado.sprints.indexOf(sprint) < 0"></i> <i class="fa fa-check-circle-o" ng-click="vm.chamado.sprints.splice(vm.chamado.sprints.indexOf(sprint),1)" ng-show="vm.chamado.sprints.indexOf(sprint) > -1"></i></td><td>{{sprint.descricao}}</td></tr></table></div></div></div><div class="form-group col-md-2"><label class="control-label">&ensp;</label><button ng-click="vm.loadAll()" class="btn btn-success btn-block"><i class="fa fa-search"></i> Buscar</button></div></form></div></div><div class="row m-t-lg" ng-show="vm.total"><div class="col-md-12"><h3><i class="fa fa-print"></i> Resultado da Volumetria</h3><hr></div><div class="col-md-2"></div><div class="col-md-3 m-t-lg m-l-lg text-center"><div class="widget blue-bg p-lg"><div class="m-b-xs"><i class="fa fa-list fa-4x"></i><h1 class="m-xs">{{vm.total}}</h1><h3 class="font-bold no-margins">Total de Chamados</h3></div></div><div class="widget red-bg p-lg"><div class="m-b-xs"><i class="fa fa-close fa-4x"></i><h1 class="m-xs">{{vm.quantidadeAbertoVencidos}}</h1><h3 class="font-bold no-margins">Vencidos</h3></div></div></div><div class="col-md-1"></div><div class="col-md-4"><div class="float-e-margins"><div class="feed-activity-list"><div class="feed-element"><span class="pull-left text-primary"><h1>{{vm.quantidadeAberto}}</h1></span><div class="media-body text-center"><i class="fa fa-envelope-o fa-4x pull-right text-primary"></i><h2 class="text-primary">Abertos</h2></div></div><div class="feed-element"><span class="pull-left text-primary"><h1>{{vm.quantidadeImpedido}}</h1></span><div class="media-body text-center"><i class="fa fa-bell fa-4x pull-right text-primary"></i><h2 class="text-primary">Impedidos</h2></div></div><div class="feed-element"><span class="pull-left text-info"><h1>{{vm.quantidadeAguardandoDesenvolvimento}}</h1></span><div class="media-body text-center"><i class="fa fa-laptop fa-4x pull-right text-info"></i><h2 class="text-info">Aguardando Desenvolvimento</h2></div></div><div class="feed-element"><span class="pull-left text-info"><h1>{{vm.quantidadeAbertoSprint}}</h1></span><div class="media-body text-center"><i class="fa fa-check fa-4x pull-right text-info"></i><h2 class="text-info">Alocados na Sprint</h2></div></div><div class="feed-element"><span class="pull-left text-info"><h1>{{vm.quantidadeTeste}}</h1></span><div class="media-body text-center"><i class="fa fa-group fa-4x pull-right text-info"></i><h2 class="text-info">Em Teste</h2></div></div><div class="feed-element"><span class="pull-left text-primary"><h1>{{vm.quantidadeAguardandoValidacao}}</h1></span><div class="media-body text-center"><i class="fa fa-check fa-4x pull-right text-primary"></i><h2 class="text-primary">Aguardando Valida\xE7\xE3o</h2></div></div><div class="feed-element"><span class="pull-left text-danger"><h1>{{vm.quantidadeRejeitado}}</h1></span><div class="media-body text-center"><i class="fa fa-thumbs-o-down fa-4x pull-right text-danger"></i><h2 class="text-danger">Rejeitados</h2></div></div><div class="feed-element"><span class="pull-left text-success"><h1>{{vm.quantidadeEncerrado}}</h1></span><div class="media-body text-center"><i class="fa fa-tasks fa-4x pull-right text-success"></i><h2 class="text-success">Encerrados</h2></div></div></div></div></div><div class="col-md-2"></div><div class="col-md-12 m-t-lg"><h3><i class="fa fa-print"></i> Produtividade da equipe de suporte por M\xF3dulo</h3><hr></div><div class="row m-t-lg" ng-show="vm.produtividade"><div class="col-md-3"></div><div class="col-md-6"><div class="table-responsive"><table class="jh-table table table-hover"><tr><th>M\xF3dulo</th><th class="text-center">Quantidade de Chamados</th><th class="text-center">Tempo Gasto</th></tr><tbody><tr ng-repeat="prod in vm.produtividade"><td><strong>{{prod.modulo}}</strong></td><td class="text-center">{{prod.quantidadeChamados}}</td><td class="text-center">{{prod.tempoGasto | number : fractionSize}} hs</td></tr></tbody></table></div></div><div class="col-md-3"></div></div><div class="col-md-6"><div class="col-md-12 m-t-lg"><h3><i class="fa fa-print"></i> Esfor\xE7o empregado</h3><hr></div><div class="col-md-6 m-t-lg m-l-lg text-center"><div class="widget navy-bg p-lg"><div class="m-b-xs"><i class="fa fa-users fa-4x"></i><h1 class="m-xs">{{vm.esforcoEmpregado | number : fractionSize}}</h1><h3 class="font-bold no-margins">Esfor\xE7o empregado</h3></div></div></div></div><div class="col-md-6"><div class="col-md-12 m-t-lg"><h3><i class="fa fa-print"></i> Tempo M\xE9dio</h3><hr></div><div class="col-md-6 m-t-lg m-l-lg text-center"><div class="widget sky-bg p-lg"><div class="m-b-xs"><i class="fa fa-clock-o fa-4x"></i><h1 class="m-xs">{{vm.tempoMedio | number:2}}</h1><h3 class="font-bold no-margins">Tempo M\xE9dio</h3></div></div></div></div><div class="col-md-12 m-t-lg"><h3><i class="fa fa-print"></i> Porcentagem de atendimento</h3><hr></div><div class="col-md-3 m-t-lg m-l-lg text-center"><div class="widget green-bg p-lg"><div class="m-b-xs"><i class="fa fa-users fa-4x"></i><h1 class="m-xs">{{vm.atendimentoSegundoNivel | number:2}}%</h1><h3 class="font-bold no-margins">Segundo N\xEDvel</h3></div></div></div><div class="col-md-3 m-t-lg m-l-lg text-center"><div class="widget blue-bg p-lg"><div class="m-b-xs"><i class="fa fa-code fa-4x"></i><h1 class="m-xs">{{vm.atendimentoDesenvolvimento | number:2}}%</h1><h3 class="font-bold no-margins">Desenvolvimento</h3></div></div></div><div class="col-md-3 m-t-lg m-l-lg text-center"><div class="widget red-bg p-lg"><div class="m-b-xs"><i class="fa fa-exclamation fa-4x"></i><h1 class="m-xs">0%</h1><h3 class="font-bold no-margins">N\xE3o atendidos</h3></div></div></div><div class="col-md-12 m-t-lg"><h3><i class="fa fa-print"></i> Produtividade por Severidade</h3><hr></div><div class="row m-t-lg" ng-show="vm.severidades"><div class="col-md-3"></div><div class="col-md-6"><div class="table-responsive"><table class="jh-table table table-hover"><tr><th>Severidade</th><th class="text-center">Quantidade de Chamados</th><th class="text-center">Tempo Gasto</th></tr><tbody><tr ng-repeat="sev in vm.severidades"><td><strong data-translate="{{\'chamadosApp.Severidade.\' + sev.severidade}}">{{sev.severidade}}</strong></td><td class="text-center">{{sev.quantidadeChamados}}</td><td class="text-center">{{sev.tempoGasto | number : fractionSize}} hs</td></tr></tbody></table></div></div><div class="col-md-3"></div></div></div></div></div>');
$templateCache.put('app/relatorios/chamados-rejeitados/chamados-rejeitados.html','<div class="ibox"><div class="ibox-title"><h3>Chamados Rejeitados</h3></div><div class="ibox-content"><div class="row"><div class="col-md-12"><form name="editForm" role="form" novalidate show-validation><div class="col-md-9 no-margins"><div class="form-group col-md-2"><label for="id">Chamado</label><input type="text" class="form-control" id="id" name="id" ng-model="vm.chamado.id"></div><div class="form-group col-md-5"><label for="field_modulo">M\xF3dulo</label><select class="form-control" required id="field_modulo" name="modulo" ng-model="vm.chamado.modulo" ng-options="modulo as modulo.descricao for modulo in vm.modulos track by modulo.id"><option value=""></option></select></div><div class="form-group col-md-5"><label for="field_submodulo">Sub-M\xF3dulo</label><select class="form-control" required id="field_submodulo" name="submodulo" ng-model="vm.chamado.subModulo" ng-options="subModulo as subModulo.descricao for subModulo in vm.subModulos track by subModulo.id"><option value=""></option></select></div><div class="form-group col-md-4"><label for="field_usuarios">Clientes</label><select class="form-control" id="field_usuarios" name="clientes" ng-model="vm.chamado.cliente" ng-options="cliente as cliente.nome for cliente in vm.clientes | orderBy: \'nome\'"></select></div><div class="form-group col-md-4"><label class="control-label" data-translate="chamadosApp.chamado.tipoChamado" for="field_tipoChamado">Tipo Chamado</label><select class="form-control" name="tipoChamado" ng-model="vm.chamado.tipoChamado" id="field_tipoChamado"><option value="SUPORTE">Suporte ou D\xFAvida</option><option value="BUG">Bug</option><option value="MELHORIA">Melhoria</option><option value="NOVA_FUNCIONALIDADE">Nova Funcionalidade</option></select></div><div class="form-group col-md-4"><label for="field_modulo">Release</label><select class="form-control" id="field_release" name="release" ng-model="vm.chamado.release" ng-options="release as release.versao for release in vm.releases track by release.id"><option value=""></option></select></div><div class="form-group col-md-12"><label class="control-label" for="titulo">Titulo/Descri\xE7\xE3o</label><input type="text" class="form-control" id="titulo" name="titulo" ng-model="vm.chamado.titulo"></div></div><div class="col-md-3 no-margins"><div class="form-group"><label class="control-label">Ciclos</label><div style="max-height: 200px; overflow: auto"><table class="table"><tr class="{{vm.chamado.sprints.indexOf(sprint) > -1 ? \'success\':\'\'}}" ng-repeat="sprint in vm.sprints track by $index"><td><i class="fa fa-circle-o" ng-click="vm.chamado.sprints.push(sprint)" ng-show="vm.chamado.sprints.indexOf(sprint) < 0"></i> <i class="fa fa-check-circle-o" ng-click="vm.chamado.sprints.splice(vm.chamado.sprints.indexOf(sprint),1)" ng-show="vm.chamado.sprints.indexOf(sprint) > -1"></i></td><td>{{sprint.descricao}}</td></tr></table></div></div></div><div class="form-group col-md-2"><label class="control-label">&ensp;</label><button ng-click="vm.loadAll()" class="btn btn-success btn-block"><i class="fa fa-search"></i> Buscar</button></div><div class="form-group col-md-2"><label class="control-label">&ensp;</label><button ng-click="vm.limpar()" class="btn btn-default btn-block"><i class="fa fa-times"></i> Limpar</button></div></form></div></div><div class="row m-t-md" ng-show="vm.chamados"><div class="col-md-6"><div class="col-md-12"><h3><i class="fa fa-list"></i> Quantidade de Rejei\xE7\xE3o por tipo</h3><hr></div><div class="col-md-6"><canvas id="pie" class="chart chart-pie" chart-colors="vm.colors" chart-data="vm.data" chart-labels="vm.labels"></canvas></div><div class="col-md-6"><ul class="stat-list"><li ng-repeat="situacao in vm.labels"><h2 class="no-margins">{{vm.data[$index] | number:0}}</h2><small>{{situacao}}</small><div class="stat-percent">{{vm.percentual[$index]| number:2}}%</div><div class="progress progress-mini"><div style="width: {{vm.percentual[$index]}}%" class="progress-bar" st></div></div></li></ul></div></div><div class="col-md-6"><div class="col-md-12"><h3><i class="fa fa-calendar"></i> Rejei\xE7\xE3o</h3><hr></div><div class="col-md-5"><div class="widget blue-bg p-md text-center"><div class="m-b-md"><i class="fa fa-list fa-4x"></i><h1 class="m-xs">{{(vm.chamados.length) }}</h1><h3 class="font-bold no-margins">Quantidade de Chamados</h3><small class="text-white">Chamados rejeitados</small></div></div></div><div class="col-md-2"></div><div class="col-md-5"><div class="widget red-bg p-md text-center"><div class="m-b-md"><i class="fa fa-thumbs-o-down fa-4x"></i><h1 class="m-xs">{{(vm.totalRejeicoes + vm.totalMelhorias) }}</h1><h3 class="font-bold no-margins">Total de Rejei\xE7\xE3o</h3><small class="text-white">N\xFAmero de rejei\xE7\xF5es</small></div></div></div><div class="col-md-12"><div class="alert alert-danger text-center"><i class="fa fa-info-circle fa-4x"></i><h3>Em M\xE9dia, entre os chamados rejeitados, um chamado foi rejeitado {{(vm.totalRejeicoes + vm.totalMelhorias) / vm.chamados.length | number:2}} vez(es).</h3></div><hr></div></div></div><div class="row m-t-md" ng-show="vm.chamados"><div class="col-md-4"><div class="col-md-12"><h3><i class="fa fa-list"></i> Rejei\xE7\xE3o por m\xF3dulo</h3><hr></div><div class="col-md-12"><ul class="stat-list"><li ng-repeat="modulo in vm.modulosAtrasados | orderBy : \'quantidade\'"><h2 class="no-margins label label-default"><strong>{{modulo.quantidade}}</strong> Rejei\xE7\xE3o(\xF5es) do m\xF3dulo <strong>{{modulo.modulo}}</strong></h2></li></ul></div></div><div class="col-md-8"><div class="col-md-12"><h3><i class="fa fa-calendar"></i> Total de chamados</h3><hr></div><div class="col-md-5"><div class="widget sky-bg p-md text-center"><div class="m-b-md"><i class="fa fa-list fa-4x"></i><h1 class="m-xs">{{vm.totalChamados}}</h1><h3 class="font-bold no-margins">Total de Chamados</h3><small>Quantidade total de chamados</small></div></div></div><div class="col-md-2"></div><div class="col-md-5"><div class="widget navy-bg p-md text-center"><div class="m-b-md"><i class="fa fa-check fa-4x"></i><h1 class="m-xs">{{(vm.chamados.length * 100) / vm.totalChamados | number:2}}%</h1><h3 class="font-bold no-margins">Indice de Rejei\xE7\xE3o</h3><small class="text-white">Porcentagem de Rejei\xE7\xE3o</small></div></div></div></div></div><div class="row"><div class="col-md-12 text-center"><p>Listando todos os chamados Rejeitados</p></div><div class="col-md-12"><div class="table-responsive"><table class="jh-table table table-striped table-hover"><tr jh-sort="vm.predicate" ascending="vm.reverse" callback="vm.transition()"><th></th><th class="issue-info cursor-pointer"><span jh-sort-by="chamado.severidade">Severidade </span><small jh-sort-by="chamado.tipo_chamado">Tipo</small></th><th class="issue-info cursor-pointer"><span jh-sort-by="chamado.id">N\xBA do chamado </span><small jh-sort-by="chamado.titulo">Titulo</small></th><th class="issue-info cursor-pointer"><span jh-sort-by="solicitante.first_name">Solicitante </span><small jh-sort-by="responsavel.first_name">Respons\xE1vel</small></th><th class="issue-info cursor-pointer"><span jh-sort-by="chamado.criado_em">Data </span><small jh-sort-by="chamado.tempo_estimado">Tempo Estimado</small></th><th class="issue-info cursor-pointer"><span jh-sort-by="modulo.descricao">M\xF3dulo </span><small jh-sort-by="sub_modulo.descricao">Sub-M\xF3dulo</small></th><th class="issue-info cursor-pointer"><span jh-sort-by="cliente.nome">Cliente </span><small jh-sort-by="sistema.nome">Sistema</small></th><th class="cursor-pointer"><span>Rejei\xE7\xE3o/Melhorias</span></th><th class="cursor-pointer"><span jh-sort-by="sprint.descricao">Ciclo </span><small>Situa\xE7\xE3o</small></th></tr><tbody><tr class="{{chamado.situacao == \'REJEITADO\'? \'danger\':\'\'}} {{chamado.situacao == \'TESTE_SUPORTE\'? \'warning\':\'\'}} {{chamado.situacao == \'VALIDADO\'? \'info\':\'\'}}" ng-repeat="chamado in vm.chamados"><td class="issue-info"><button type="button" ng-click="vm.visualizar(chamado)" class="btn btn-danger btn-outline btn-block"><span class="fa fa-search"></span></button></td><td class="issue-info"><span class="strong" data-translate="{{\'chamadosApp.Severidade.\' + chamado.chamado.severidade}}">{{chamado.chamado.severidade}}</span> <small><span class="text-{{vm.getCorPorTipo(chamado.tipoChamado)}}" data-translate="{{\'chamadosApp.TipoChamado.\' + chamado.chamado.tipoChamado}}">{{chamado.chamado.tipoChamado}}</span></small></td><td class="issue-info" style="width: 30%"><a ui-sref="edit-chamado({id:chamado.chamado.id, search: null, situacao: null})">#{{chamado.chamado.id}} <span class="text-danger small" ng-if="chamado.possuiDependencias"><i class="fa fa-exclamation-triangle"></i> Possui Depend\xEAncias </span></a><span ng-if="chamado.sprint && !chamado.planejado" class="small label">NP</span> <small>{{chamado.chamado.titulo}}</small></td><td class="issue-info" style="width: 10%">{{chamado.chamado.solicitante.firstName}} <small>{{chamado.chamado.responsavel.firstName}}</small></td><td class="issue-info">{{chamado.chamado.criadoEm | date:\'mediumDate\'}} <small><i ng-if="chamado.tempoEstimado" class="fa fa-clock-o"></i> {{chamado.chamado.tempoEstimado}}</small></td><td class="issue-info">{{chamado.chamado.modulo.descricao}} <small>{{chamado.chamado.subModulo.descricao}}</small></td><td class="issue-info"><span class="small">{{chamado.chamado.cliente.nome}}</span> <small><span class="text-success small">{{chamado.chamado.sistema.nome}}</span></small></td><td class="text-center">{{chamado.quantidadeRejeicao}} / {{chamado.quantidadeMelhorias}}</td><td>{{chamado.chamado.sprint.descricao}} <small><span data-translate="{{\'chamadosApp.SituacaoChamado.\' + chamado.chamado.situacao}}">{{chamado.chamado.situacao}}</span></small></td></tr></tbody></table></div><button ng-click="vm.imprimir()" class="btn btn-success"><i class="fa fa-print"></i> Imprimir</button></div></div></div></div><script type="text/ng-template" id="visualizarRejeicao.html"><div class="modal-header">\n        <h3 class="modal-title" id="reabrirContent-title">Visualizar Rejei\xE7\xE3o do chamado</h3>\n    </div>\n    <div class="modal-body" id="reabrirContent-body">\n        <div class="row">\n            <div class="col-md-3 text-center">\n                <img alt="profile" class="img-circle circle-border"\n                     ng-show="!vm.fotoSolicitante"\n                     width="72"\n                     ng-src="/content/images/user-default.png">\n                <img ng-src="{{vm.fotoSolicitante}}"\n                     ng-if="vm.fotoSolicitante"\n                     width="72"\n                     class="img-circle circle-border" alt="profile"> <br/>\n                <small class="text-muted">{{vm.chamado.chamado.solicitante.firstName}}</small>\n            </div>\n            <div class="col-md-9 ">\n                <h3 class="no-margins">\n                        <span\n                            data-translate="{{\'chamadosApp.TipoChamado.\' + vm.chamado.chamado.tipoChamado}}">tipo</span>\n                </h3>\n                <h2>\n                    <strong> #{{vm.chamado.chamado.id}} </strong> - {{vm.chamado.chamado.titulo}}\n                </h2>\n                <h4 class="no-margins">\n                    {{vm.chamado.chamado.cliente.nome}}\n                    <small class="text-success">{{vm.chamado.chamado.sistema.nome}}</small>\n                </h4>\n                <div class="m-t-sm">\n                    <span class="label label-primary m-r-sm" ng-if="vm.chamado.sprint">\n                                <i class="fa fa-code-fork"></i>\n                                {{vm.chamado.chamado.sprint.descricao}}\n                            </span>\n                    <span class="label label-success m-r-sm" ng-if="vm.chamado.tempoEstimado">\n                                <i class="fa fa-clock-o"></i>\n                                {{vm.chamado.chamado.tempoEstimado}}h\n                            </span>\n                    <a href="http://redmine.webpublico.com.br/issues/{{vm.chamado.chamado.ticketLegado}}"\n                       target="_blank"\n                       class="label label-warning m-r-sm" ng-if="vm.chamado.chamado.ticketLegado">\n                        <i class="fa fa-calendar-o"></i>\n                        Legado:\n                        {{vm.chamado.chamado.ticketLegado}}\n                    </a>\n\n                    <span class="label label-info"\n                          data-translate="{{\'chamadosApp.SituacaoChamado.\' + vm.chamado.chamado.situacao}}">{{vm.chamado.chamado.situacao}}</span>\n                    <span ng-if="vm.chamado.sprint && !vm.chamado.planejado" class="small label">NP</span>\n\n                    <a ui-sref="release-detail({versao:vm.chamado.chamado.release.versao, sistemaId: vm.chamado.chamado.release.sistema.id})"\n                       class="label label-primary m-r-sm"\n                       ng-if="vm.chamado.chamado.release">\n                        <i class="fa fa-code-fork"></i>\n                        {{vm.chamado.chamado.release.versao}}\n                    </a>\n\n                    <span class="label label-danger"\n                          data-translate="{{\'chamadosApp.Severidade.\' + vm.chamado.chamado.severidade}}">{{vm.chamado.chamado.severidade}}</span>\n                </div>\n            </div>\n\n            <div class="col-md-12 m-t-md">\n                <span class="font-normal">M\xF3dulo: </span>\n                <strong>{{vm.chamado.chamado.modulo.descricao}}</strong><br/>\n                <span class="font-normal">Sub-M\xF3dulo: </span>\n                <strong>{{vm.chamado.chamado.subModulo.descricao}}</strong> <br/>\n                <span class="font-normal">Ordem: </span>\n                <strong>{{vm.chamado.chamado.ordem}}</strong> <br/>\n                <span class="font-normal">Criado em: </span>\n                <strong>{{vm.chamado.chamado.criadoEm | date:\'mediumDate\'}}</strong> <br/>\n                <span class="font-normal">Altera\xE7\xE3o c\xF3digo fonte: </span>\n                <strong>{{vm.chamado.chamado.alteracaoCodigo ? \'Sim\' : \'N\xE3o\'}}</strong> <br/>\n                <span class="font-normal">Altera\xE7\xE3o estrutura de tabelas: </span>\n                <strong>{{vm.chamado.chamado.alteracaoTabela ? \'Sim\' : \'N\xE3o\'}}</strong> <br/>\n                <span class="font-normal">Altera\xE7\xE3o arquitetura do sistema: </span>\n                <strong>{{vm.chamado.chamado.alteracaoArquitetura ? \'Sim\' : \'N\xE3o\'}}</strong> <br/>\n            </div>\n\n            <div class="row">\n                <div class="col-md-12 m-t">\n                    <div>\n                        <h3>Coment\xE1rios</h3>\n                        <div class="chat-activity-list m-t-lg">\n                            <div\n                                class="chat-element {{comentario.usuario.id == vm.chamado.chamado.solicitante.id? \'\' : \'right\'}}"\n                                ng-repeat="comentario in vm.chamado.comentariosRejeicao | orderBy: \'criadoEm\'">\n                                <a href="#"\n                                   class="{{comentario.usuario.id == vm.chamado.solicitante.id? \'pull-left\' : \'pull-right\'}}">\n\n                                    <img ng-src="{{comentario.imagemUsuario}}"\n                                         ng-show="comentario.imagemUsuario"\n                                         class="img-circle">\n                                    <img alt="image" class="img-circle"\n                                         ng-show="!comentario.imagemUsuario"\n                                         ng-src="/content/images/user-default.png">\n                                </a>\n                                <div\n                                    class="media-body {{comentario.usuario.id == vm.chamado.solicitante.id? \'\' : \'text-right\'}}">\n                                    <small\n                                        class="{{comentario.usuario.id != vm.chamado.solicitante.id? \'pull-left\' : \'pull-right\'}} ">\n                                        {{ comentario.criadoEm | date:\'dd/MM/yyyy\'}}\n                                        <span class="text-navy">(\n                                            <time-ago from-time=\'{{comentario.criadoEm}}\'\n                                                      format=\'dd/MM/yyyy h:mm a\'>\n                                            </time-ago>\n                                             )</span>\n                                    </small>\n                                    <strong>{{comentario.usuario.firstName}}</strong>\n                                    <div\n                                        class="m-b-xs" style="white-space: pre-wrap;"\n                                        ng-bind-html="vm.trustAsHtml(\'<p>\' + comentario.descricao + \'</p>\')">\n                                    </div>\n                                </div>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n            </div>\n\n        </div>\n    </div>\n    <div class="modal-footer">\n        <button class="btn btn-default" type="button" ng-click="vm.cancel()">\n            <i class="fa fa-ban"></i>\n            Fechar\n        </button>\n    </div></script>');
$templateCache.put('app/relatorios/movimentacao-demandas/acumulo-demandas.html','<div class="ibox"><div class="ibox-title"><h3>Demandas sem movimenta\xE7\xE3o com a quantidade de dias</h3></div><div class="ibox-content"><div class="row"><div class="col-md-12"><form name="editForm" role="form" novalidate show-validation><div class="form-group col-md-4"><label for="field_modulo">M\xEDnimo de dias em atraso</label><input type="number" class="form-control" id="minimoDias" name="minimoDias" ng-model="vm.diasSemMovimentar"></div><div class="form-group col-md-4"><label for="field_situacaoChamado">Situa\xE7\xE3o</label><select class="form-control" name="situacaoChamado" ng-model="vm.chamado.situacao" id="field_situacaoChamado"><option value="BACKLOG">Backlog</option><option value="ABERTO">Aberto</option><option value="IMPEDIDO">Impedido</option><option value="EM_SUPORTE">Fila Suporte</option><option value="AGUARDANDO_DESENVOLVIMENTO">Fila Desenvolvimento</option><option value="EM_DESENVOLVIMENTO">Em Desenvolvimento</option><option value="AGUARDANDO_TESTE">Aguardando valida\xE7\xE3o t\xE9cnica</option><option value="AGUARDANDO_VALIDACAO">Aguardando valida\xE7\xE3o do usu\xE1rio</option><option value="EM_ANALISE">Em An\xE1lise</option><option value="VALIDADO">Validade</option><option value="TESTE_SUPORTE">Em Teste</option><option value="REJEITADO">Rejeitado</option><option value="FECHADO">Fechado</option></select></div><div class="form-group col-md-4"><label class="control-label">&ensp;</label><button ng-click="vm.loadAll()" class="btn btn-success btn-block"><i class="fa fa-search"></i> Buscar</button></div></form></div></div><div class="row"><ul class="nav nav-tabs" role="tablist"><li ng-repeat="cliente in vm.clientes" ng-click="vm.chamado.cliente  = cliente; vm.loadAll()"><a class="nav-link {{vm.chamado.cliente.id === cliente.id ? \'active\': \'\'}}" title="{{cliente.nome}}">{{cliente.nome | limitTo: 15 }}{{cliente.nome.length > 15 ? \'...\' : \'\'}}</a></li></ul></div><div class="row"><div class="col-md-12 m-t-md text-center"><button class="btn btn-success btn-outline" ui-sref="movimentacao-demandas">Quantidade de Movimenta\xE7\xF5es</button> <button class="btn btn-danger">Acumulo de Movimenta\xE7\xF5es</button></div></div></div></div><div class="col-md-4" ng-repeat="modulo in vm.atrasoPorModulo"><div class="ibox border-bottom border-left-right"><div class="ibox-title"><div class="ibox-tools small"><span class="text-success">{{modulo.chamados.length}} </span>c/m\xE9dia de <span class="text-danger">{{modulo.diasAtraso | number:0}} </span>dias <b>parados</b></div><h5 class="ng-binding">{{modulo.modulo}}</h5></div><div class="ibox-content"><div class="table-responsive" style="height: 300px; overflow-x: auto"><table class="jh-table table table-striped table-hover"><tr><th class="issue-info"><a ng-click=" vm.orderBy = \'id\'">Chamado</a></th><th class="issue-info"><a ng-click=" vm.orderBy = \'-diasAtraso\'">Ultimo</a> <small ng-click=" vm.orderBy = \'situacao\'">Situa\xE7\xE3o.</small></th></tr><tr ng-repeat="chamado in modulo.chamados | orderBy: vm.orderBy"><td class="issue-info"><a title="{{chamado.titulo}}" ui-sref="edit-chamado({id:chamado.id})">#{{chamado.id}} </a>{{chamado.titulo | limitTo: 60 }}{{chamado.titulo.length > 60 ? \'...\' : \'\'}}</td><td class="issue-info"><span ng-if="chamado.diasAtraso" class="text-{{chamado.cor}}">{{chamado.diasAtraso}} {{chamado.diasAtraso > 1 ? \'dias\' : \'dia\'}} </span><small>{{\'chamadosApp.SituacaoChamado.\' + chamado.situacao | translate}}</small></td></tr></table></div></div></div></div>');
$templateCache.put('app/relatorios/movimentacao-demandas/movimentacao-demandas.html','<div class="ibox"><div class="ibox-title"><h3>Movimenta\xE7\xE3o dos Chamados</h3></div><div class="ibox-content"><div class="row"><div class="form-group col-md-4"><label class="control-label" for="field_inicio">In\xEDcio</label><div class="input-group"><input id="field_inicio" type="text" class="form-control" name="inicio" required uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.inicio" is-open="vm.datePickerOpenStatus.inicio"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'inicio\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.inicio.$invalid"><p class="help-block" ng-show="editForm.inicio.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-md-4"><label class="control-label" for="field_fim">Fim</label><div class="input-group"><input id="field_fim" type="text" class="form-control" name="fim" required uib-datepicker-popup="dd/MM/yyyy" ng-model="vm.fim" is-open="vm.datePickerOpenStatus.fim"> <span class="input-group-btn"><button type="button" class="btn btn-default" ng-click="vm.openCalendar(\'fim\')"><i class="glyphicon glyphicon-calendar"></i></button></span></div><div ng-show="editForm.fim.$invalid"><p class="help-block" ng-show="editForm.fim.$error.required" data-translate="entity.validation.required">This field is required.</p></div></div><div class="form-group col-md-4"><label class="control-label">&ensp;</label><button ng-click="vm.load()" class="btn btn-success btn-block"><i class="fa fa-search"></i> Buscar</button></div></div><div class="row"><ul class="nav nav-tabs" role="tablist"><li ng-repeat="cliente in vm.chamadosPorCliente" ng-click="vm.clienteSelecionado  = cliente"><a class="nav-link {{cliente.cliente.id === vm.clienteSelecionado.cliente.id ? \'active\': \'\'}}" title="{{cliente.cliente.nome}}">{{cliente.cliente.nome | limitTo: 15 }}{{cliente.cliente.nome.length > 15 ? \'...\' : \'\'}}</a></li></ul></div><div class="row"><div class="col-md-12 m-t-md text-center"><button class="btn btn-success">Quantidade de Movimenta\xE7\xF5es</button> <button class="btn btn-danger btn-outline" ui-sref="acumulo-demandas">Acumulo de Movimenta\xE7\xF5es</button></div></div></div></div><div class="row m-t-md"><div class="col-md-12"><div class="col-md-4" ng-repeat="modulo in vm.clienteSelecionado.modulos"><div class="ibox border-bottom border-left-right"><div class="ibox-title"><div class="ibox-tools"><span class="badge badge-success">{{modulo.chamados.length}} </span><a class="text-success" ng-click="modulo.verLista = !modulo.verLista"><i class="fa {{modulo.verLista ? \'fa-pie-chart\' :\'fa-list\'}}"></i></a></div><h5 class="ng-binding">{{modulo.modulo.nome}}</h5></div><div class="ibox-content"><div class="row" style="height: 450px; overflow-x: auto"><div class="col-md-12 text-center" ng-show="!modulo.verLista"><div class="m-b-sm"><a class="m-sm" ng-click="vm.agruparPorCampo(modulo, \'situacao\')"><i class="fa fa-tag"></i> Situa\xE7\xE3o </a><a class="m-sm" ng-click="vm.agruparPorCampo(modulo, \'tipoChamado\')"><i class="fa fa-list"></i> Tipo </a><a class="m-sm" ng-click="vm.agruparPorCampo(modulo, \'responsavel\')"><i class="fa fa-user"></i> Usuario</a></div><canvas id="bar" class="chart chart-pie" chart-data="modulo.pie.data" chart-options="modulo.pie.options" chart-labels="modulo.pie.labels"></canvas></div><div class="col-md-12"><table class="table small table-striped" ng-show="modulo.verLista"><tr><th class="issue-info"><a ng-click=" vm.orderBy = \'id\'">Chamado</a> <small><a ng-click=" vm.orderBy = \'tipoChamado\'">Tipo</a>/<a ng-click=" vm.orderBy = \'situacao\'">Situa\xE7\xE3o</a></small></th><th class="issue-info"><a ng-click=" vm.orderBy = \'criadoEm\'">Data </a><small><a ng-click=" vm.orderBy = \'responsavel\'">Usu\xE1rio</a></small></th></tr><tr ng-repeat="chamado in modulo.chamados | orderBy: vm.orderBy"><td class="issue-info"><a title="{{chamado.titulo}}" ui-sref="edit-chamado({id:chamado.id})">#{{chamado.id}} </a>{{chamado.titulo | limitTo: 40 }}{{chamado.titulo.length > 10 ? \'...\' : \'\'}} {{}} <small>{{\'chamadosApp.TipoChamado.\' + chamado.tipoChamado | translate}} - {{\'chamadosApp.SituacaoChamado.\' + chamado.situacao | translate}}</small></td><td class="issue-info">{{chamado.criadoEm | date:\'dd/MM/yyyy\'}} <small>{{chamado.responsavel}}</small></td></tr></table></div></div></div></div></div></div></div><div class="row m-t-md"><div class="col-md-12"><div class="ibox border-bottom border-left-right"><div class="ibox-title"><div class="ibox-tools"><span class="badge badge-success">{{vm.clienteSelecionado.chamados.length}} </span><a class="text-success" ng-click="vm.clienteSelecionado.cliente.verLista = !vm.clienteSelecionado.cliente.verLista"><i class="fa {{vm.clienteSelecionado.cliente.verLista ? \'fa-pie-chart\' :\'fa-list\'}}"></i></a></div><h5 class="ng-binding">{{vm.clienteSelecionado.cliente.nome}}</h5></div><div class="ibox-content"><div class="row"><div class="col-md-12 text-center" ng-show="!vm.clienteSelecionado.cliente.verLista"><div class="m-b-sm"><a class="m-sm" ng-click="vm.agruparPorCampo(vm.clienteSelecionado, \'situacao\')"><i class="fa fa-tag"></i> Situa\xE7\xE3o </a><a class="m-sm" ng-click="vm.agruparPorCampo(vm.clienteSelecionado, \'tipoChamado\')"><i class="fa fa-list"></i> Tipo </a><a class="m-sm" ng-click="vm.agruparPorCampo(vm.clienteSelecionado, \'responsavel\')"><i class="fa fa-user"></i> Usuario</a></div><canvas id="bar" class="chart chart-bar" chart-data="vm.clienteSelecionado.pie.data" chart-options="vm.clienteSelecionado.pie.options" chart-labels="vm.clienteSelecionado.pie.labels"></canvas></div><div class="col-md-12"><table class="table small table-striped" ng-show="vm.clienteSelecionado.cliente.verLista"><tr><th class="issue-info"><a ng-click=" vm.orderBy = \'id\'">Chamado</a> <small><a ng-click=" vm.orderBy = \'tipoChamado\'">Tipo</a>/<a ng-click=" vm.orderBy = \'situacao\'">Situa\xE7\xE3o</a></small></th><th class="issue-info"><a ng-click=" vm.orderBy = \'criadoEm\'">Data </a><small><a ng-click=" vm.orderBy = \'responsavel\'">Usu\xE1rio</a></small></th></tr><tr ng-repeat="chamado in vm.clienteSelecionado.chamados | orderBy: vm.orderBy"><td class="issue-info"><a title="{{chamado.titulo}}" ui-sref="edit-chamado({id:chamado.id})">#{{chamado.id}} </a>{{chamado.titulo | limitTo: 40 }}{{chamado.titulo.length > 10 ? \'...\' : \'\'}} {{}} <small>{{\'chamadosApp.TipoChamado.\' + chamado.tipoChamado | translate}} - {{\'chamadosApp.SituacaoChamado.\' + chamado.situacao | translate}}</small></td><td class="issue-info">{{chamado.criadoEm | date:\'dd/MM/yyyy\'}} <small>{{chamado.responsavel}}</small></td></tr></table></div></div></div></div></div></div>');
$templateCache.put('app/account/reset/finish/reset.finish.html','<div><div class="row"><div class="col-md-4 col-md-offset-4"><h1 data-translate="reset.finish.title">Reset password</h1><div class="alert alert-danger" data-translate="reset.finish.messages.keymissing" ng-show="vm.keyMissing"><strong>The password reset key is missing.</strong></div><div class="alert alert-warning" ng-hide="vm.success || vm.keyMissing"><p data-translate="reset.finish.messages.info">Choose a new password</p></div><div class="alert alert-danger" ng-show="vm.error"><p data-translate="reset.finish.messages.error">Your password couldn\'t be reset. Remember a password request is only valid for 24 hours.</p></div><div class="alert alert-success" ng-show="vm.success"><p data-translate="reset.finish.messages.success" translate-compile><strong>Your password has been reset.</strong> Please <a class="alert-link" href="" ng-click="vm.login()">sign in</a>.</p></div><div class="alert alert-danger" ng-show="vm.doNotMatch" data-translate="global.messages.error.dontmatch">The password and its confirmation do not match!</div><div ng-hide="vm.keyMissing"><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.finishReset()" show-validation><div class="form-group"><label class="control-label" for="password" data-translate="global.form.newpassword">New password</label><input type="password" class="form-control" id="password" name="password" placeholder="{{\'global.form.newpassword.placeholder\' | translate}}" ng-model="vm.resetAccount.password" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.password.$dirty && form.password.$invalid"><p class="help-block" ng-show="form.password.$error.required" data-translate="global.messages.validate.newpassword.required">Your password is required.</p><p class="help-block" ng-show="form.password.$error.minlength" data-translate="global.messages.validate.newpassword.minlength">Your password is required to be at least 4 characters.</p><p class="help-block" ng-show="form.password.$error.maxlength" data-translate="global.messages.validate.newpassword.maxlength">Your password cannot be longer than 50 characters.</p></div><password-strength-bar password-to-check="vm.resetAccount.password"></password-strength-bar></div><div class="form-group"><label class="control-label" for="confirmPassword" data-translate="global.form.confirmpassword">New password confirmation</label><input type="password" class="form-control" id="confirmPassword" name="confirmPassword" placeholder="{{\'global.form.confirmpassword.placeholder\' | translate}}" ng-model="vm.confirmPassword" ng-minlength="4" ng-maxlength="50" required><div ng-show="form.confirmPassword.$dirty && form.confirmPassword.$invalid"><p class="help-block" ng-show="form.confirmPassword.$error.required" data-translate="global.messages.validate.confirmpassword.required">Your password confirmation is required.</p><p class="help-block" ng-show="form.confirmPassword.$error.minlength" data-translate="global.messages.validate.confirmpassword.minlength">Your password confirmation is required to be at least 4 characters.</p><p class="help-block" ng-show="form.confirmPassword.$error.maxlength" data-translate="global.messages.validate.confirmpassword.maxlength">Your password confirmation cannot be longer than 50 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.finish.form.button">Reset Password</button></form></div></div></div></div>');
$templateCache.put('app/account/reset/request/reset.request.html','<div><div class="row"><div class="col-md-8 col-md-offset-2"><h1 data-translate="reset.request.title">Reset your password</h1><div class="alert alert-danger" data-translate="reset.request.messages.notfound" ng-show="vm.errorEmailNotExists"><strong>E-Mail address isn\'t registered!</strong> Please check and try again.</div><div class="alert alert-warning" ng-hide="vm.success"><p data-translate="reset.request.messages.info">Enter the e-mail address you used to register.</p></div><div class="alert alert-success" ng-show="vm.success == \'OK\'"><p data-translate="reset.request.messages.success">Check your e-mails for details on how to reset your password.</p></div><form ng-show="!vm.success" name="form" role="form" novalidate ng-submit="vm.requestReset()" show-validation><div class="form-group"><label class="control-label" for="email" data-translate="global.form.email">E-mail</label><input type="email" class="form-control" id="email" name="email" placeholder="{{\'global.form.email.placeholder\' | translate}}" ng-model="vm.resetAccount.email" ng-minlength="5" ng-maxlength="100" required><div ng-show="form.email.$dirty && form.email.$invalid"><p class="help-block" ng-show="form.email.$error.required" data-translate="global.messages.validate.email.required">Your e-mail is required.</p><p class="help-block" ng-show="form.email.$error.email" data-translate="global.messages.validate.email.invalid">Your e-mail is invalid.</p><p class="help-block" ng-show="form.email.$error.minlength" data-translate="global.messages.validate.email.minlength">Your e-mail is required to be at least 5 characters.</p><p class="help-block" ng-show="form.email.$error.maxlength" data-translate="global.messages.validate.email.maxlength">Your e-mail cannot be longer than 100 characters.</p></div></div><button type="submit" ng-disabled="form.$invalid" class="btn btn-primary" data-translate="reset.request.form.button">Reset</button></form></div></div></div>');
$templateCache.put('app/account/social/directive/social.html','<form action="{{ providerURL }}" method="POST"><button type="submit" class="btn btn-block jh-btn-social jh-btn-{{ provider }}"><span data-translate="social.btnLabel" translate-values="{ label: label }">Sign in with {{ label }}</span></button> <input name="scope" type="hidden" value="{{\xA0providerSetting }}"> <input name="_csrf" type="hidden" value="{{\xA0csrf }}"></form>');}]);})();